
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire837b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire837b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7tvZy", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $57140eba618a667e$export$ffb0004e005737fa; }, function (v) { return $57140eba618a667e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $57140eba618a667e$export$34b9dba7ce09269b; }, function (v) { return $57140eba618a667e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $57140eba618a667e$export$25062201e9e25d76; }, function (v) { return $57140eba618a667e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $57140eba618a667e$export$ffb0004e005737fa;
var $57140eba618a667e$export$34b9dba7ce09269b;
var $57140eba618a667e$export$25062201e9e25d76;
"use strict";

var $4HBpa = parcelRequire("4HBpa");
var $57140eba618a667e$var$k = Symbol.for("react.element"), $57140eba618a667e$var$l = Symbol.for("react.fragment"), $57140eba618a667e$var$m = Object.prototype.hasOwnProperty, $57140eba618a667e$var$n = $4HBpa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $57140eba618a667e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $57140eba618a667e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$57140eba618a667e$var$m.call(a, b) && !$57140eba618a667e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $57140eba618a667e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $57140eba618a667e$var$n.current
    };
}
$57140eba618a667e$export$ffb0004e005737fa = $57140eba618a667e$var$l;
$57140eba618a667e$export$34b9dba7ce09269b = $57140eba618a667e$var$q;
$57140eba618a667e$export$25062201e9e25d76 = $57140eba618a667e$var$q;

});
parcelRegister("4HBpa", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3zNE5"));

});
parcelRegister("3zNE5", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $29ab268c844a6818$export$dca3b0875bd9a954; }, function (v) { return $29ab268c844a6818$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $29ab268c844a6818$export$16fa2f45be04daa8; }, function (v) { return $29ab268c844a6818$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $29ab268c844a6818$export$ffb0004e005737fa; }, function (v) { return $29ab268c844a6818$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $29ab268c844a6818$export$e2c29f18771995cb; }, function (v) { return $29ab268c844a6818$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $29ab268c844a6818$export$221d75b3f55bb0bd; }, function (v) { return $29ab268c844a6818$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $29ab268c844a6818$export$5f8d39834fd61797; }, function (v) { return $29ab268c844a6818$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $29ab268c844a6818$export$74bf444e3cd11ea5; }, function (v) { return $29ab268c844a6818$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $29ab268c844a6818$export$ae55be85d98224ed; }, function (v) { return $29ab268c844a6818$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $29ab268c844a6818$export$3ba232387fd5d6dd; }, function (v) { return $29ab268c844a6818$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $29ab268c844a6818$export$e530037191fcd5d7; }, function (v) { return $29ab268c844a6818$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $29ab268c844a6818$export$fd42f52fd3ae1109; }, function (v) { return $29ab268c844a6818$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $29ab268c844a6818$export$c8a8987d4410bf2d; }, function (v) { return $29ab268c844a6818$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $29ab268c844a6818$export$d38cd72104c1f0e9; }, function (v) { return $29ab268c844a6818$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $29ab268c844a6818$export$7d1e3a5e95ceca43; }, function (v) { return $29ab268c844a6818$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $29ab268c844a6818$export$257a8862b851cb5b; }, function (v) { return $29ab268c844a6818$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $29ab268c844a6818$export$a8257692ac88316c; }, function (v) { return $29ab268c844a6818$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $29ab268c844a6818$export$488013bae63b21da; }, function (v) { return $29ab268c844a6818$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $29ab268c844a6818$export$7c73462e0d25e514; }, function (v) { return $29ab268c844a6818$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $29ab268c844a6818$export$7568632d0d33d16d; }, function (v) { return $29ab268c844a6818$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $29ab268c844a6818$export$88948ce120ea2619; }, function (v) { return $29ab268c844a6818$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $29ab268c844a6818$export$35808ee640e87ca7; }, function (v) { return $29ab268c844a6818$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $29ab268c844a6818$export$fae74005e78b1a27; }, function (v) { return $29ab268c844a6818$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $29ab268c844a6818$export$dc8fbce3eb94dc1e; }, function (v) { return $29ab268c844a6818$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $29ab268c844a6818$export$6a7bc4e911dc01cf; }, function (v) { return $29ab268c844a6818$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $29ab268c844a6818$export$6d9c69b0de29b591; }, function (v) { return $29ab268c844a6818$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $29ab268c844a6818$export$f680877a34711e37; }, function (v) { return $29ab268c844a6818$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $29ab268c844a6818$export$d5a552a76deda3c2; }, function (v) { return $29ab268c844a6818$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $29ab268c844a6818$export$aaabe4eda9ed9969; }, function (v) { return $29ab268c844a6818$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $29ab268c844a6818$export$e5c5a5f917a5871c; }, function (v) { return $29ab268c844a6818$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $29ab268c844a6818$export$1538c33de8887b59; }, function (v) { return $29ab268c844a6818$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $29ab268c844a6818$export$13e3392192263954; }, function (v) { return $29ab268c844a6818$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $29ab268c844a6818$export$b8f5890fc79d6aca; }, function (v) { return $29ab268c844a6818$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $29ab268c844a6818$export$60241385465d0a34; }, function (v) { return $29ab268c844a6818$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $29ab268c844a6818$export$306c0aa65ff9ec16; }, function (v) { return $29ab268c844a6818$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $29ab268c844a6818$export$7b286972b8d8ccbf; }, function (v) { return $29ab268c844a6818$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $29ab268c844a6818$export$83d89fbfd8236492; }, function (v) { return $29ab268c844a6818$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $29ab268c844a6818$export$dca3b0875bd9a954;
var $29ab268c844a6818$export$16fa2f45be04daa8;
var $29ab268c844a6818$export$ffb0004e005737fa;
var $29ab268c844a6818$export$e2c29f18771995cb;
var $29ab268c844a6818$export$221d75b3f55bb0bd;
var $29ab268c844a6818$export$5f8d39834fd61797;
var $29ab268c844a6818$export$74bf444e3cd11ea5;
var $29ab268c844a6818$export$ae55be85d98224ed;
var $29ab268c844a6818$export$3ba232387fd5d6dd;
var $29ab268c844a6818$export$e530037191fcd5d7;
var $29ab268c844a6818$export$fd42f52fd3ae1109;
var $29ab268c844a6818$export$c8a8987d4410bf2d;
var $29ab268c844a6818$export$d38cd72104c1f0e9;
var $29ab268c844a6818$export$7d1e3a5e95ceca43;
var $29ab268c844a6818$export$257a8862b851cb5b;
var $29ab268c844a6818$export$a8257692ac88316c;
var $29ab268c844a6818$export$488013bae63b21da;
var $29ab268c844a6818$export$7c73462e0d25e514;
var $29ab268c844a6818$export$7568632d0d33d16d;
var $29ab268c844a6818$export$88948ce120ea2619;
var $29ab268c844a6818$export$35808ee640e87ca7;
var $29ab268c844a6818$export$fae74005e78b1a27;
var $29ab268c844a6818$export$dc8fbce3eb94dc1e;
var $29ab268c844a6818$export$6a7bc4e911dc01cf;
var $29ab268c844a6818$export$6d9c69b0de29b591;
var $29ab268c844a6818$export$f680877a34711e37;
var $29ab268c844a6818$export$d5a552a76deda3c2;
var $29ab268c844a6818$export$aaabe4eda9ed9969;
var $29ab268c844a6818$export$e5c5a5f917a5871c;
var $29ab268c844a6818$export$1538c33de8887b59;
var $29ab268c844a6818$export$13e3392192263954;
var $29ab268c844a6818$export$b8f5890fc79d6aca;
var $29ab268c844a6818$export$60241385465d0a34;
var $29ab268c844a6818$export$306c0aa65ff9ec16;
var $29ab268c844a6818$export$7b286972b8d8ccbf;
var $29ab268c844a6818$export$83d89fbfd8236492;
"use strict";
var $29ab268c844a6818$var$l = Symbol.for("react.element"), $29ab268c844a6818$var$n = Symbol.for("react.portal"), $29ab268c844a6818$var$p = Symbol.for("react.fragment"), $29ab268c844a6818$var$q = Symbol.for("react.strict_mode"), $29ab268c844a6818$var$r = Symbol.for("react.profiler"), $29ab268c844a6818$var$t = Symbol.for("react.provider"), $29ab268c844a6818$var$u = Symbol.for("react.context"), $29ab268c844a6818$var$v = Symbol.for("react.forward_ref"), $29ab268c844a6818$var$w = Symbol.for("react.suspense"), $29ab268c844a6818$var$x = Symbol.for("react.memo"), $29ab268c844a6818$var$y = Symbol.for("react.lazy"), $29ab268c844a6818$var$z = Symbol.iterator;
function $29ab268c844a6818$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $29ab268c844a6818$var$z && a[$29ab268c844a6818$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $29ab268c844a6818$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $29ab268c844a6818$var$C = Object.assign, $29ab268c844a6818$var$D = {};
function $29ab268c844a6818$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $29ab268c844a6818$var$D;
    this.updater = e || $29ab268c844a6818$var$B;
}
$29ab268c844a6818$var$E.prototype.isReactComponent = {};
$29ab268c844a6818$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$29ab268c844a6818$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $29ab268c844a6818$var$F() {}
$29ab268c844a6818$var$F.prototype = $29ab268c844a6818$var$E.prototype;
function $29ab268c844a6818$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $29ab268c844a6818$var$D;
    this.updater = e || $29ab268c844a6818$var$B;
}
var $29ab268c844a6818$var$H = $29ab268c844a6818$var$G.prototype = new $29ab268c844a6818$var$F;
$29ab268c844a6818$var$H.constructor = $29ab268c844a6818$var$G;
$29ab268c844a6818$var$C($29ab268c844a6818$var$H, $29ab268c844a6818$var$E.prototype);
$29ab268c844a6818$var$H.isPureReactComponent = !0;
var $29ab268c844a6818$var$I = Array.isArray, $29ab268c844a6818$var$J = Object.prototype.hasOwnProperty, $29ab268c844a6818$var$K = {
    current: null
}, $29ab268c844a6818$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $29ab268c844a6818$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$29ab268c844a6818$var$J.call(b, d) && !$29ab268c844a6818$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $29ab268c844a6818$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $29ab268c844a6818$var$K.current
    };
}
function $29ab268c844a6818$var$N(a, b) {
    return {
        $$typeof: $29ab268c844a6818$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $29ab268c844a6818$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $29ab268c844a6818$var$l;
}
function $29ab268c844a6818$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $29ab268c844a6818$var$P = /\/+/g;
function $29ab268c844a6818$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $29ab268c844a6818$var$escape("" + a.key) : b.toString(36);
}
function $29ab268c844a6818$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $29ab268c844a6818$var$l:
                case $29ab268c844a6818$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $29ab268c844a6818$var$Q(h, 0) : d, $29ab268c844a6818$var$I(c) ? (e = "", null != a && (e = a.replace($29ab268c844a6818$var$P, "$&/") + "/"), $29ab268c844a6818$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($29ab268c844a6818$var$O(c) && (c = $29ab268c844a6818$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($29ab268c844a6818$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($29ab268c844a6818$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $29ab268c844a6818$var$Q(k, g);
        h += $29ab268c844a6818$var$R(k, b, e, f, c);
    }
    else if (f = $29ab268c844a6818$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $29ab268c844a6818$var$Q(k, g++), h += $29ab268c844a6818$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $29ab268c844a6818$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $29ab268c844a6818$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $29ab268c844a6818$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $29ab268c844a6818$var$U = {
    current: null
}, $29ab268c844a6818$var$V = {
    transition: null
}, $29ab268c844a6818$var$W = {
    ReactCurrentDispatcher: $29ab268c844a6818$var$U,
    ReactCurrentBatchConfig: $29ab268c844a6818$var$V,
    ReactCurrentOwner: $29ab268c844a6818$var$K
};
function $29ab268c844a6818$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$29ab268c844a6818$export$dca3b0875bd9a954 = {
    map: $29ab268c844a6818$var$S,
    forEach: function(a, b, e) {
        $29ab268c844a6818$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $29ab268c844a6818$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $29ab268c844a6818$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$29ab268c844a6818$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$29ab268c844a6818$export$16fa2f45be04daa8 = $29ab268c844a6818$var$E;
$29ab268c844a6818$export$ffb0004e005737fa = $29ab268c844a6818$var$p;
$29ab268c844a6818$export$e2c29f18771995cb = $29ab268c844a6818$var$r;
$29ab268c844a6818$export$221d75b3f55bb0bd = $29ab268c844a6818$var$G;
$29ab268c844a6818$export$5f8d39834fd61797 = $29ab268c844a6818$var$q;
$29ab268c844a6818$export$74bf444e3cd11ea5 = $29ab268c844a6818$var$w;
$29ab268c844a6818$export$ae55be85d98224ed = $29ab268c844a6818$var$W;
$29ab268c844a6818$export$3ba232387fd5d6dd = $29ab268c844a6818$var$X;
$29ab268c844a6818$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $29ab268c844a6818$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $29ab268c844a6818$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$29ab268c844a6818$var$J.call(b, f) && !$29ab268c844a6818$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $29ab268c844a6818$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$29ab268c844a6818$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $29ab268c844a6818$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $29ab268c844a6818$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$29ab268c844a6818$export$c8a8987d4410bf2d = $29ab268c844a6818$var$M;
$29ab268c844a6818$export$d38cd72104c1f0e9 = function(a) {
    var b = $29ab268c844a6818$var$M.bind(null, a);
    b.type = a;
    return b;
};
$29ab268c844a6818$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$29ab268c844a6818$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $29ab268c844a6818$var$v,
        render: a
    };
};
$29ab268c844a6818$export$a8257692ac88316c = $29ab268c844a6818$var$O;
$29ab268c844a6818$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $29ab268c844a6818$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $29ab268c844a6818$var$T
    };
};
$29ab268c844a6818$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $29ab268c844a6818$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$29ab268c844a6818$export$7568632d0d33d16d = function(a) {
    var b = $29ab268c844a6818$var$V.transition;
    $29ab268c844a6818$var$V.transition = {};
    try {
        a();
    } finally{
        $29ab268c844a6818$var$V.transition = b;
    }
};
$29ab268c844a6818$export$88948ce120ea2619 = $29ab268c844a6818$var$X;
$29ab268c844a6818$export$35808ee640e87ca7 = function(a, b) {
    return $29ab268c844a6818$var$U.current.useCallback(a, b);
};
$29ab268c844a6818$export$fae74005e78b1a27 = function(a) {
    return $29ab268c844a6818$var$U.current.useContext(a);
};
$29ab268c844a6818$export$dc8fbce3eb94dc1e = function() {};
$29ab268c844a6818$export$6a7bc4e911dc01cf = function(a) {
    return $29ab268c844a6818$var$U.current.useDeferredValue(a);
};
$29ab268c844a6818$export$6d9c69b0de29b591 = function(a, b) {
    return $29ab268c844a6818$var$U.current.useEffect(a, b);
};
$29ab268c844a6818$export$f680877a34711e37 = function() {
    return $29ab268c844a6818$var$U.current.useId();
};
$29ab268c844a6818$export$d5a552a76deda3c2 = function(a, b, e) {
    return $29ab268c844a6818$var$U.current.useImperativeHandle(a, b, e);
};
$29ab268c844a6818$export$aaabe4eda9ed9969 = function(a, b) {
    return $29ab268c844a6818$var$U.current.useInsertionEffect(a, b);
};
$29ab268c844a6818$export$e5c5a5f917a5871c = function(a, b) {
    return $29ab268c844a6818$var$U.current.useLayoutEffect(a, b);
};
$29ab268c844a6818$export$1538c33de8887b59 = function(a, b) {
    return $29ab268c844a6818$var$U.current.useMemo(a, b);
};
$29ab268c844a6818$export$13e3392192263954 = function(a, b, e) {
    return $29ab268c844a6818$var$U.current.useReducer(a, b, e);
};
$29ab268c844a6818$export$b8f5890fc79d6aca = function(a) {
    return $29ab268c844a6818$var$U.current.useRef(a);
};
$29ab268c844a6818$export$60241385465d0a34 = function(a) {
    return $29ab268c844a6818$var$U.current.useState(a);
};
$29ab268c844a6818$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $29ab268c844a6818$var$U.current.useSyncExternalStore(a, b, e);
};
$29ab268c844a6818$export$7b286972b8d8ccbf = function() {
    return $29ab268c844a6818$var$U.current.useTransition();
};
$29ab268c844a6818$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("kAoxL", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("3Baf1", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $29ecc58491fb6f0d$export$ae55be85d98224ed; }, function (v) { return $29ecc58491fb6f0d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $29ecc58491fb6f0d$export$d39a5bbd09211389; }, function (v) { return $29ecc58491fb6f0d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $29ecc58491fb6f0d$export$882461b6382ed46c; }, function (v) { return $29ecc58491fb6f0d$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $29ecc58491fb6f0d$export$466bfc07425424d5; }, function (v) { return $29ecc58491fb6f0d$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $29ecc58491fb6f0d$export$cd75ccfd720a3cd4; }, function (v) { return $29ecc58491fb6f0d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $29ecc58491fb6f0d$export$fa8d919ba61d84db; }, function (v) { return $29ecc58491fb6f0d$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $29ecc58491fb6f0d$export$757ceba2d55c277e; }, function (v) { return $29ecc58491fb6f0d$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $29ecc58491fb6f0d$export$b3890eb0ae9dca99; }, function (v) { return $29ecc58491fb6f0d$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $29ecc58491fb6f0d$export$502457920280e6be; }, function (v) { return $29ecc58491fb6f0d$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $29ecc58491fb6f0d$export$c78a37762a8d58e1; }, function (v) { return $29ecc58491fb6f0d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $29ecc58491fb6f0d$export$dc54d992c10e8a18; }, function (v) { return $29ecc58491fb6f0d$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $29ecc58491fb6f0d$export$83d89fbfd8236492; }, function (v) { return $29ecc58491fb6f0d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $29ecc58491fb6f0d$export$ae55be85d98224ed;
var $29ecc58491fb6f0d$export$d39a5bbd09211389;
var $29ecc58491fb6f0d$export$882461b6382ed46c;
var $29ecc58491fb6f0d$export$466bfc07425424d5;
var $29ecc58491fb6f0d$export$cd75ccfd720a3cd4;
var $29ecc58491fb6f0d$export$fa8d919ba61d84db;
var $29ecc58491fb6f0d$export$757ceba2d55c277e;
var $29ecc58491fb6f0d$export$b3890eb0ae9dca99;
var $29ecc58491fb6f0d$export$502457920280e6be;
var $29ecc58491fb6f0d$export$c78a37762a8d58e1;
var $29ecc58491fb6f0d$export$dc54d992c10e8a18;
var $29ecc58491fb6f0d$export$83d89fbfd8236492;
"use strict";

var $4HBpa = parcelRequire("4HBpa");

var $lC4Dh = parcelRequire("lC4Dh");
function $29ecc58491fb6f0d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $29ecc58491fb6f0d$var$da = new Set, $29ecc58491fb6f0d$var$ea = {};
function $29ecc58491fb6f0d$var$fa(a, b) {
    $29ecc58491fb6f0d$var$ha(a, b);
    $29ecc58491fb6f0d$var$ha(a + "Capture", b);
}
function $29ecc58491fb6f0d$var$ha(a, b) {
    $29ecc58491fb6f0d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$29ecc58491fb6f0d$var$da.add(b[a]);
}
var $29ecc58491fb6f0d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $29ecc58491fb6f0d$var$ja = Object.prototype.hasOwnProperty, $29ecc58491fb6f0d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $29ecc58491fb6f0d$var$la = {}, $29ecc58491fb6f0d$var$ma = {};
function $29ecc58491fb6f0d$var$oa(a) {
    if ($29ecc58491fb6f0d$var$ja.call($29ecc58491fb6f0d$var$ma, a)) return !0;
    if ($29ecc58491fb6f0d$var$ja.call($29ecc58491fb6f0d$var$la, a)) return !1;
    if ($29ecc58491fb6f0d$var$ka.test(a)) return $29ecc58491fb6f0d$var$ma[a] = !0;
    $29ecc58491fb6f0d$var$la[a] = !0;
    return !1;
}
function $29ecc58491fb6f0d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $29ecc58491fb6f0d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $29ecc58491fb6f0d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $29ecc58491fb6f0d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $29ecc58491fb6f0d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $29ecc58491fb6f0d$var$z[b] = new $29ecc58491fb6f0d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $29ecc58491fb6f0d$var$ra = /[\-:]([a-z])/g;
function $29ecc58491fb6f0d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($29ecc58491fb6f0d$var$ra, $29ecc58491fb6f0d$var$sa);
    $29ecc58491fb6f0d$var$z[b] = new $29ecc58491fb6f0d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($29ecc58491fb6f0d$var$ra, $29ecc58491fb6f0d$var$sa);
    $29ecc58491fb6f0d$var$z[b] = new $29ecc58491fb6f0d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($29ecc58491fb6f0d$var$ra, $29ecc58491fb6f0d$var$sa);
    $29ecc58491fb6f0d$var$z[b] = new $29ecc58491fb6f0d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$29ecc58491fb6f0d$var$z.xlinkHref = new $29ecc58491fb6f0d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $29ecc58491fb6f0d$var$z[a] = new $29ecc58491fb6f0d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $29ecc58491fb6f0d$var$ta(a, b, c, d) {
    var e = $29ecc58491fb6f0d$var$z.hasOwnProperty(b) ? $29ecc58491fb6f0d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $29ecc58491fb6f0d$var$qa(b, c, e, d) && (c = null), d || null === e ? $29ecc58491fb6f0d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $29ecc58491fb6f0d$var$ua = $4HBpa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $29ecc58491fb6f0d$var$va = Symbol.for("react.element"), $29ecc58491fb6f0d$var$wa = Symbol.for("react.portal"), $29ecc58491fb6f0d$var$ya = Symbol.for("react.fragment"), $29ecc58491fb6f0d$var$za = Symbol.for("react.strict_mode"), $29ecc58491fb6f0d$var$Aa = Symbol.for("react.profiler"), $29ecc58491fb6f0d$var$Ba = Symbol.for("react.provider"), $29ecc58491fb6f0d$var$Ca = Symbol.for("react.context"), $29ecc58491fb6f0d$var$Da = Symbol.for("react.forward_ref"), $29ecc58491fb6f0d$var$Ea = Symbol.for("react.suspense"), $29ecc58491fb6f0d$var$Fa = Symbol.for("react.suspense_list"), $29ecc58491fb6f0d$var$Ga = Symbol.for("react.memo"), $29ecc58491fb6f0d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $29ecc58491fb6f0d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $29ecc58491fb6f0d$var$Ja = Symbol.iterator;
function $29ecc58491fb6f0d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $29ecc58491fb6f0d$var$Ja && a[$29ecc58491fb6f0d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $29ecc58491fb6f0d$var$A = Object.assign, $29ecc58491fb6f0d$var$La;
function $29ecc58491fb6f0d$var$Ma(a) {
    if (void 0 === $29ecc58491fb6f0d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $29ecc58491fb6f0d$var$La = b && b[1] || "";
    }
    return "\n" + $29ecc58491fb6f0d$var$La + a;
}
var $29ecc58491fb6f0d$var$Na = !1;
function $29ecc58491fb6f0d$var$Oa(a, b) {
    if (!a || $29ecc58491fb6f0d$var$Na) return "";
    $29ecc58491fb6f0d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $29ecc58491fb6f0d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $29ecc58491fb6f0d$var$Ma(a) : "";
}
function $29ecc58491fb6f0d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $29ecc58491fb6f0d$var$Ma(a.type);
        case 16:
            return $29ecc58491fb6f0d$var$Ma("Lazy");
        case 13:
            return $29ecc58491fb6f0d$var$Ma("Suspense");
        case 19:
            return $29ecc58491fb6f0d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $29ecc58491fb6f0d$var$Oa(a.type, !1), a;
        case 11:
            return a = $29ecc58491fb6f0d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $29ecc58491fb6f0d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $29ecc58491fb6f0d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $29ecc58491fb6f0d$var$ya:
            return "Fragment";
        case $29ecc58491fb6f0d$var$wa:
            return "Portal";
        case $29ecc58491fb6f0d$var$Aa:
            return "Profiler";
        case $29ecc58491fb6f0d$var$za:
            return "StrictMode";
        case $29ecc58491fb6f0d$var$Ea:
            return "Suspense";
        case $29ecc58491fb6f0d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $29ecc58491fb6f0d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $29ecc58491fb6f0d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $29ecc58491fb6f0d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $29ecc58491fb6f0d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $29ecc58491fb6f0d$var$Qa(a.type) || "Memo";
        case $29ecc58491fb6f0d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $29ecc58491fb6f0d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $29ecc58491fb6f0d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $29ecc58491fb6f0d$var$Qa(b);
        case 8:
            return b === $29ecc58491fb6f0d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $29ecc58491fb6f0d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $29ecc58491fb6f0d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $29ecc58491fb6f0d$var$Ua(a) {
    var b = $29ecc58491fb6f0d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $29ecc58491fb6f0d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $29ecc58491fb6f0d$var$Ua(a));
}
function $29ecc58491fb6f0d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $29ecc58491fb6f0d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $29ecc58491fb6f0d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $29ecc58491fb6f0d$var$Ya(a, b) {
    var c = b.checked;
    return $29ecc58491fb6f0d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $29ecc58491fb6f0d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $29ecc58491fb6f0d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $29ecc58491fb6f0d$var$ab(a, b) {
    b = b.checked;
    null != b && $29ecc58491fb6f0d$var$ta(a, "checked", b, !1);
}
function $29ecc58491fb6f0d$var$bb(a, b) {
    $29ecc58491fb6f0d$var$ab(a, b);
    var c = $29ecc58491fb6f0d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $29ecc58491fb6f0d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $29ecc58491fb6f0d$var$cb(a, b.type, $29ecc58491fb6f0d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $29ecc58491fb6f0d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $29ecc58491fb6f0d$var$cb(a, b, c) {
    if ("number" !== b || $29ecc58491fb6f0d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $29ecc58491fb6f0d$var$eb = Array.isArray;
function $29ecc58491fb6f0d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $29ecc58491fb6f0d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $29ecc58491fb6f0d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($29ecc58491fb6f0d$var$p(91));
    return $29ecc58491fb6f0d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $29ecc58491fb6f0d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($29ecc58491fb6f0d$var$p(92));
            if ($29ecc58491fb6f0d$var$eb(c)) {
                if (1 < c.length) throw Error($29ecc58491fb6f0d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $29ecc58491fb6f0d$var$Sa(c)
    };
}
function $29ecc58491fb6f0d$var$ib(a, b) {
    var c = $29ecc58491fb6f0d$var$Sa(b.value), d = $29ecc58491fb6f0d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $29ecc58491fb6f0d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $29ecc58491fb6f0d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $29ecc58491fb6f0d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $29ecc58491fb6f0d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $29ecc58491fb6f0d$var$mb, $29ecc58491fb6f0d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $29ecc58491fb6f0d$var$mb = $29ecc58491fb6f0d$var$mb || document.createElement("div");
        $29ecc58491fb6f0d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $29ecc58491fb6f0d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $29ecc58491fb6f0d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $29ecc58491fb6f0d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $29ecc58491fb6f0d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($29ecc58491fb6f0d$var$pb).forEach(function(a) {
    $29ecc58491fb6f0d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $29ecc58491fb6f0d$var$pb[b] = $29ecc58491fb6f0d$var$pb[a];
    });
});
function $29ecc58491fb6f0d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $29ecc58491fb6f0d$var$pb.hasOwnProperty(a) && $29ecc58491fb6f0d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $29ecc58491fb6f0d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $29ecc58491fb6f0d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $29ecc58491fb6f0d$var$tb = $29ecc58491fb6f0d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $29ecc58491fb6f0d$var$ub(a, b) {
    if (b) {
        if ($29ecc58491fb6f0d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($29ecc58491fb6f0d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($29ecc58491fb6f0d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($29ecc58491fb6f0d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($29ecc58491fb6f0d$var$p(62));
    }
}
function $29ecc58491fb6f0d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $29ecc58491fb6f0d$var$wb = null;
function $29ecc58491fb6f0d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $29ecc58491fb6f0d$var$yb = null, $29ecc58491fb6f0d$var$zb = null, $29ecc58491fb6f0d$var$Ab = null;
function $29ecc58491fb6f0d$var$Bb(a) {
    if (a = $29ecc58491fb6f0d$var$Cb(a)) {
        if ("function" !== typeof $29ecc58491fb6f0d$var$yb) throw Error($29ecc58491fb6f0d$var$p(280));
        var b = a.stateNode;
        b && (b = $29ecc58491fb6f0d$var$Db(b), $29ecc58491fb6f0d$var$yb(a.stateNode, a.type, b));
    }
}
function $29ecc58491fb6f0d$var$Eb(a) {
    $29ecc58491fb6f0d$var$zb ? $29ecc58491fb6f0d$var$Ab ? $29ecc58491fb6f0d$var$Ab.push(a) : $29ecc58491fb6f0d$var$Ab = [
        a
    ] : $29ecc58491fb6f0d$var$zb = a;
}
function $29ecc58491fb6f0d$var$Fb() {
    if ($29ecc58491fb6f0d$var$zb) {
        var a = $29ecc58491fb6f0d$var$zb, b = $29ecc58491fb6f0d$var$Ab;
        $29ecc58491fb6f0d$var$Ab = $29ecc58491fb6f0d$var$zb = null;
        $29ecc58491fb6f0d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$29ecc58491fb6f0d$var$Bb(b[a]);
    }
}
function $29ecc58491fb6f0d$var$Gb(a, b) {
    return a(b);
}
function $29ecc58491fb6f0d$var$Hb() {}
var $29ecc58491fb6f0d$var$Ib = !1;
function $29ecc58491fb6f0d$var$Jb(a, b, c) {
    if ($29ecc58491fb6f0d$var$Ib) return a(b, c);
    $29ecc58491fb6f0d$var$Ib = !0;
    try {
        return $29ecc58491fb6f0d$var$Gb(a, b, c);
    } finally{
        if ($29ecc58491fb6f0d$var$Ib = !1, null !== $29ecc58491fb6f0d$var$zb || null !== $29ecc58491fb6f0d$var$Ab) $29ecc58491fb6f0d$var$Hb(), $29ecc58491fb6f0d$var$Fb();
    }
}
function $29ecc58491fb6f0d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $29ecc58491fb6f0d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($29ecc58491fb6f0d$var$p(231, b, typeof c));
    return c;
}
var $29ecc58491fb6f0d$var$Lb = !1;
if ($29ecc58491fb6f0d$var$ia) try {
    var $29ecc58491fb6f0d$var$Mb = {};
    Object.defineProperty($29ecc58491fb6f0d$var$Mb, "passive", {
        get: function() {
            $29ecc58491fb6f0d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $29ecc58491fb6f0d$var$Mb, $29ecc58491fb6f0d$var$Mb);
    window.removeEventListener("test", $29ecc58491fb6f0d$var$Mb, $29ecc58491fb6f0d$var$Mb);
} catch (a) {
    $29ecc58491fb6f0d$var$Lb = !1;
}
function $29ecc58491fb6f0d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $29ecc58491fb6f0d$var$Ob = !1, $29ecc58491fb6f0d$var$Pb = null, $29ecc58491fb6f0d$var$Qb = !1, $29ecc58491fb6f0d$var$Rb = null, $29ecc58491fb6f0d$var$Sb = {
    onError: function(a) {
        $29ecc58491fb6f0d$var$Ob = !0;
        $29ecc58491fb6f0d$var$Pb = a;
    }
};
function $29ecc58491fb6f0d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $29ecc58491fb6f0d$var$Ob = !1;
    $29ecc58491fb6f0d$var$Pb = null;
    $29ecc58491fb6f0d$var$Nb.apply($29ecc58491fb6f0d$var$Sb, arguments);
}
function $29ecc58491fb6f0d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $29ecc58491fb6f0d$var$Tb.apply(this, arguments);
    if ($29ecc58491fb6f0d$var$Ob) {
        if ($29ecc58491fb6f0d$var$Ob) {
            var l = $29ecc58491fb6f0d$var$Pb;
            $29ecc58491fb6f0d$var$Ob = !1;
            $29ecc58491fb6f0d$var$Pb = null;
        } else throw Error($29ecc58491fb6f0d$var$p(198));
        $29ecc58491fb6f0d$var$Qb || ($29ecc58491fb6f0d$var$Qb = !0, $29ecc58491fb6f0d$var$Rb = l);
    }
}
function $29ecc58491fb6f0d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $29ecc58491fb6f0d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $29ecc58491fb6f0d$var$Xb(a) {
    if ($29ecc58491fb6f0d$var$Vb(a) !== a) throw Error($29ecc58491fb6f0d$var$p(188));
}
function $29ecc58491fb6f0d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $29ecc58491fb6f0d$var$Vb(a);
        if (null === b) throw Error($29ecc58491fb6f0d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $29ecc58491fb6f0d$var$Xb(e), a;
                if (f === d) return $29ecc58491fb6f0d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($29ecc58491fb6f0d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($29ecc58491fb6f0d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($29ecc58491fb6f0d$var$p(190));
    }
    if (3 !== c.tag) throw Error($29ecc58491fb6f0d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $29ecc58491fb6f0d$var$Zb(a) {
    a = $29ecc58491fb6f0d$var$Yb(a);
    return null !== a ? $29ecc58491fb6f0d$var$$b(a) : null;
}
function $29ecc58491fb6f0d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $29ecc58491fb6f0d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $29ecc58491fb6f0d$var$ac = $lC4Dh.unstable_scheduleCallback, $29ecc58491fb6f0d$var$bc = $lC4Dh.unstable_cancelCallback, $29ecc58491fb6f0d$var$cc = $lC4Dh.unstable_shouldYield, $29ecc58491fb6f0d$var$dc = $lC4Dh.unstable_requestPaint, $29ecc58491fb6f0d$var$B = $lC4Dh.unstable_now, $29ecc58491fb6f0d$var$ec = $lC4Dh.unstable_getCurrentPriorityLevel, $29ecc58491fb6f0d$var$fc = $lC4Dh.unstable_ImmediatePriority, $29ecc58491fb6f0d$var$gc = $lC4Dh.unstable_UserBlockingPriority, $29ecc58491fb6f0d$var$hc = $lC4Dh.unstable_NormalPriority, $29ecc58491fb6f0d$var$ic = $lC4Dh.unstable_LowPriority, $29ecc58491fb6f0d$var$jc = $lC4Dh.unstable_IdlePriority, $29ecc58491fb6f0d$var$kc = null, $29ecc58491fb6f0d$var$lc = null;
function $29ecc58491fb6f0d$var$mc(a) {
    if ($29ecc58491fb6f0d$var$lc && "function" === typeof $29ecc58491fb6f0d$var$lc.onCommitFiberRoot) try {
        $29ecc58491fb6f0d$var$lc.onCommitFiberRoot($29ecc58491fb6f0d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $29ecc58491fb6f0d$var$oc = Math.clz32 ? Math.clz32 : $29ecc58491fb6f0d$var$nc, $29ecc58491fb6f0d$var$pc = Math.log, $29ecc58491fb6f0d$var$qc = Math.LN2;
function $29ecc58491fb6f0d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($29ecc58491fb6f0d$var$pc(a) / $29ecc58491fb6f0d$var$qc | 0) | 0;
}
var $29ecc58491fb6f0d$var$rc = 64, $29ecc58491fb6f0d$var$sc = 4194304;
function $29ecc58491fb6f0d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $29ecc58491fb6f0d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $29ecc58491fb6f0d$var$tc(h) : (f &= g, 0 !== f && (d = $29ecc58491fb6f0d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $29ecc58491fb6f0d$var$tc(g) : 0 !== f && (d = $29ecc58491fb6f0d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $29ecc58491fb6f0d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $29ecc58491fb6f0d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $29ecc58491fb6f0d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $29ecc58491fb6f0d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $29ecc58491fb6f0d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $29ecc58491fb6f0d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $29ecc58491fb6f0d$var$yc() {
    var a = $29ecc58491fb6f0d$var$rc;
    $29ecc58491fb6f0d$var$rc <<= 1;
    0 === ($29ecc58491fb6f0d$var$rc & 4194240) && ($29ecc58491fb6f0d$var$rc = 64);
    return a;
}
function $29ecc58491fb6f0d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $29ecc58491fb6f0d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $29ecc58491fb6f0d$var$oc(b);
    a[b] = c;
}
function $29ecc58491fb6f0d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $29ecc58491fb6f0d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $29ecc58491fb6f0d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $29ecc58491fb6f0d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $29ecc58491fb6f0d$var$C = 0;
function $29ecc58491fb6f0d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $29ecc58491fb6f0d$var$Ec, $29ecc58491fb6f0d$var$Fc, $29ecc58491fb6f0d$var$Gc, $29ecc58491fb6f0d$var$Hc, $29ecc58491fb6f0d$var$Ic, $29ecc58491fb6f0d$var$Jc = !1, $29ecc58491fb6f0d$var$Kc = [], $29ecc58491fb6f0d$var$Lc = null, $29ecc58491fb6f0d$var$Mc = null, $29ecc58491fb6f0d$var$Nc = null, $29ecc58491fb6f0d$var$Oc = new Map, $29ecc58491fb6f0d$var$Pc = new Map, $29ecc58491fb6f0d$var$Qc = [], $29ecc58491fb6f0d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $29ecc58491fb6f0d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $29ecc58491fb6f0d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $29ecc58491fb6f0d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $29ecc58491fb6f0d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $29ecc58491fb6f0d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $29ecc58491fb6f0d$var$Pc.delete(b.pointerId);
    }
}
function $29ecc58491fb6f0d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $29ecc58491fb6f0d$var$Cb(b), null !== b && $29ecc58491fb6f0d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $29ecc58491fb6f0d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $29ecc58491fb6f0d$var$Lc = $29ecc58491fb6f0d$var$Tc($29ecc58491fb6f0d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $29ecc58491fb6f0d$var$Mc = $29ecc58491fb6f0d$var$Tc($29ecc58491fb6f0d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $29ecc58491fb6f0d$var$Nc = $29ecc58491fb6f0d$var$Tc($29ecc58491fb6f0d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $29ecc58491fb6f0d$var$Oc.set(f, $29ecc58491fb6f0d$var$Tc($29ecc58491fb6f0d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $29ecc58491fb6f0d$var$Pc.set(f, $29ecc58491fb6f0d$var$Tc($29ecc58491fb6f0d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $29ecc58491fb6f0d$var$Vc(a) {
    var b = $29ecc58491fb6f0d$var$Wc(a.target);
    if (null !== b) {
        var c = $29ecc58491fb6f0d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $29ecc58491fb6f0d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $29ecc58491fb6f0d$var$Ic(a.priority, function() {
                        $29ecc58491fb6f0d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $29ecc58491fb6f0d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $29ecc58491fb6f0d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $29ecc58491fb6f0d$var$wb = d;
            c.target.dispatchEvent(d);
            $29ecc58491fb6f0d$var$wb = null;
        } else return b = $29ecc58491fb6f0d$var$Cb(c), null !== b && $29ecc58491fb6f0d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $29ecc58491fb6f0d$var$Zc(a, b, c) {
    $29ecc58491fb6f0d$var$Xc(a) && c.delete(b);
}
function $29ecc58491fb6f0d$var$$c() {
    $29ecc58491fb6f0d$var$Jc = !1;
    null !== $29ecc58491fb6f0d$var$Lc && $29ecc58491fb6f0d$var$Xc($29ecc58491fb6f0d$var$Lc) && ($29ecc58491fb6f0d$var$Lc = null);
    null !== $29ecc58491fb6f0d$var$Mc && $29ecc58491fb6f0d$var$Xc($29ecc58491fb6f0d$var$Mc) && ($29ecc58491fb6f0d$var$Mc = null);
    null !== $29ecc58491fb6f0d$var$Nc && $29ecc58491fb6f0d$var$Xc($29ecc58491fb6f0d$var$Nc) && ($29ecc58491fb6f0d$var$Nc = null);
    $29ecc58491fb6f0d$var$Oc.forEach($29ecc58491fb6f0d$var$Zc);
    $29ecc58491fb6f0d$var$Pc.forEach($29ecc58491fb6f0d$var$Zc);
}
function $29ecc58491fb6f0d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $29ecc58491fb6f0d$var$Jc || ($29ecc58491fb6f0d$var$Jc = !0, $lC4Dh.unstable_scheduleCallback($lC4Dh.unstable_NormalPriority, $29ecc58491fb6f0d$var$$c)));
}
function $29ecc58491fb6f0d$var$bd(a) {
    function b(b) {
        return $29ecc58491fb6f0d$var$ad(b, a);
    }
    if (0 < $29ecc58491fb6f0d$var$Kc.length) {
        $29ecc58491fb6f0d$var$ad($29ecc58491fb6f0d$var$Kc[0], a);
        for(var c = 1; c < $29ecc58491fb6f0d$var$Kc.length; c++){
            var d = $29ecc58491fb6f0d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $29ecc58491fb6f0d$var$Lc && $29ecc58491fb6f0d$var$ad($29ecc58491fb6f0d$var$Lc, a);
    null !== $29ecc58491fb6f0d$var$Mc && $29ecc58491fb6f0d$var$ad($29ecc58491fb6f0d$var$Mc, a);
    null !== $29ecc58491fb6f0d$var$Nc && $29ecc58491fb6f0d$var$ad($29ecc58491fb6f0d$var$Nc, a);
    $29ecc58491fb6f0d$var$Oc.forEach(b);
    $29ecc58491fb6f0d$var$Pc.forEach(b);
    for(c = 0; c < $29ecc58491fb6f0d$var$Qc.length; c++)d = $29ecc58491fb6f0d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $29ecc58491fb6f0d$var$Qc.length && (c = $29ecc58491fb6f0d$var$Qc[0], null === c.blockedOn);)$29ecc58491fb6f0d$var$Vc(c), null === c.blockedOn && $29ecc58491fb6f0d$var$Qc.shift();
}
var $29ecc58491fb6f0d$var$cd = $29ecc58491fb6f0d$var$ua.ReactCurrentBatchConfig, $29ecc58491fb6f0d$var$dd = !0;
function $29ecc58491fb6f0d$var$ed(a, b, c, d) {
    var e = $29ecc58491fb6f0d$var$C, f = $29ecc58491fb6f0d$var$cd.transition;
    $29ecc58491fb6f0d$var$cd.transition = null;
    try {
        $29ecc58491fb6f0d$var$C = 1, $29ecc58491fb6f0d$var$fd(a, b, c, d);
    } finally{
        $29ecc58491fb6f0d$var$C = e, $29ecc58491fb6f0d$var$cd.transition = f;
    }
}
function $29ecc58491fb6f0d$var$gd(a, b, c, d) {
    var e = $29ecc58491fb6f0d$var$C, f = $29ecc58491fb6f0d$var$cd.transition;
    $29ecc58491fb6f0d$var$cd.transition = null;
    try {
        $29ecc58491fb6f0d$var$C = 4, $29ecc58491fb6f0d$var$fd(a, b, c, d);
    } finally{
        $29ecc58491fb6f0d$var$C = e, $29ecc58491fb6f0d$var$cd.transition = f;
    }
}
function $29ecc58491fb6f0d$var$fd(a, b, c, d) {
    if ($29ecc58491fb6f0d$var$dd) {
        var e = $29ecc58491fb6f0d$var$Yc(a, b, c, d);
        if (null === e) $29ecc58491fb6f0d$var$hd(a, b, d, $29ecc58491fb6f0d$var$id, c), $29ecc58491fb6f0d$var$Sc(a, d);
        else if ($29ecc58491fb6f0d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($29ecc58491fb6f0d$var$Sc(a, d), b & 4 && -1 < $29ecc58491fb6f0d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $29ecc58491fb6f0d$var$Cb(e);
                null !== f && $29ecc58491fb6f0d$var$Ec(f);
                f = $29ecc58491fb6f0d$var$Yc(a, b, c, d);
                null === f && $29ecc58491fb6f0d$var$hd(a, b, d, $29ecc58491fb6f0d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $29ecc58491fb6f0d$var$hd(a, b, d, null, c);
    }
}
var $29ecc58491fb6f0d$var$id = null;
function $29ecc58491fb6f0d$var$Yc(a, b, c, d) {
    $29ecc58491fb6f0d$var$id = null;
    a = $29ecc58491fb6f0d$var$xb(d);
    a = $29ecc58491fb6f0d$var$Wc(a);
    if (null !== a) {
        if (b = $29ecc58491fb6f0d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $29ecc58491fb6f0d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $29ecc58491fb6f0d$var$id = a;
    return null;
}
function $29ecc58491fb6f0d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($29ecc58491fb6f0d$var$ec()){
                case $29ecc58491fb6f0d$var$fc:
                    return 1;
                case $29ecc58491fb6f0d$var$gc:
                    return 4;
                case $29ecc58491fb6f0d$var$hc:
                case $29ecc58491fb6f0d$var$ic:
                    return 16;
                case $29ecc58491fb6f0d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $29ecc58491fb6f0d$var$kd = null, $29ecc58491fb6f0d$var$ld = null, $29ecc58491fb6f0d$var$md = null;
function $29ecc58491fb6f0d$var$nd() {
    if ($29ecc58491fb6f0d$var$md) return $29ecc58491fb6f0d$var$md;
    var a, b = $29ecc58491fb6f0d$var$ld, c = b.length, d, e = "value" in $29ecc58491fb6f0d$var$kd ? $29ecc58491fb6f0d$var$kd.value : $29ecc58491fb6f0d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $29ecc58491fb6f0d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $29ecc58491fb6f0d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $29ecc58491fb6f0d$var$pd() {
    return !0;
}
function $29ecc58491fb6f0d$var$qd() {
    return !1;
}
function $29ecc58491fb6f0d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $29ecc58491fb6f0d$var$pd : $29ecc58491fb6f0d$var$qd;
        this.isPropagationStopped = $29ecc58491fb6f0d$var$qd;
        return this;
    }
    $29ecc58491fb6f0d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $29ecc58491fb6f0d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $29ecc58491fb6f0d$var$pd);
        },
        persist: function() {},
        isPersistent: $29ecc58491fb6f0d$var$pd
    });
    return b;
}
var $29ecc58491fb6f0d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $29ecc58491fb6f0d$var$td = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$sd), $29ecc58491fb6f0d$var$ud = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$sd, {
    view: 0,
    detail: 0
}), $29ecc58491fb6f0d$var$vd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$ud), $29ecc58491fb6f0d$var$wd, $29ecc58491fb6f0d$var$xd, $29ecc58491fb6f0d$var$yd, $29ecc58491fb6f0d$var$Ad = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $29ecc58491fb6f0d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $29ecc58491fb6f0d$var$yd && ($29ecc58491fb6f0d$var$yd && "mousemove" === a.type ? ($29ecc58491fb6f0d$var$wd = a.screenX - $29ecc58491fb6f0d$var$yd.screenX, $29ecc58491fb6f0d$var$xd = a.screenY - $29ecc58491fb6f0d$var$yd.screenY) : $29ecc58491fb6f0d$var$xd = $29ecc58491fb6f0d$var$wd = 0, $29ecc58491fb6f0d$var$yd = a);
        return $29ecc58491fb6f0d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $29ecc58491fb6f0d$var$xd;
    }
}), $29ecc58491fb6f0d$var$Bd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Ad), $29ecc58491fb6f0d$var$Cd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$Ad, {
    dataTransfer: 0
}), $29ecc58491fb6f0d$var$Dd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Cd), $29ecc58491fb6f0d$var$Ed = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$ud, {
    relatedTarget: 0
}), $29ecc58491fb6f0d$var$Fd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Ed), $29ecc58491fb6f0d$var$Gd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $29ecc58491fb6f0d$var$Hd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Gd), $29ecc58491fb6f0d$var$Id = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $29ecc58491fb6f0d$var$Jd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Id), $29ecc58491fb6f0d$var$Kd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$sd, {
    data: 0
}), $29ecc58491fb6f0d$var$Ld = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Kd), $29ecc58491fb6f0d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $29ecc58491fb6f0d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $29ecc58491fb6f0d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $29ecc58491fb6f0d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $29ecc58491fb6f0d$var$Od[a]) ? !!b[a] : !1;
}
function $29ecc58491fb6f0d$var$zd() {
    return $29ecc58491fb6f0d$var$Pd;
}
var $29ecc58491fb6f0d$var$Qd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $29ecc58491fb6f0d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $29ecc58491fb6f0d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $29ecc58491fb6f0d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $29ecc58491fb6f0d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $29ecc58491fb6f0d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $29ecc58491fb6f0d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $29ecc58491fb6f0d$var$Rd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Qd), $29ecc58491fb6f0d$var$Sd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $29ecc58491fb6f0d$var$Td = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Sd), $29ecc58491fb6f0d$var$Ud = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $29ecc58491fb6f0d$var$zd
}), $29ecc58491fb6f0d$var$Vd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Ud), $29ecc58491fb6f0d$var$Wd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $29ecc58491fb6f0d$var$Xd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Wd), $29ecc58491fb6f0d$var$Yd = $29ecc58491fb6f0d$var$A({}, $29ecc58491fb6f0d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $29ecc58491fb6f0d$var$Zd = $29ecc58491fb6f0d$var$rd($29ecc58491fb6f0d$var$Yd), $29ecc58491fb6f0d$var$$d = [
    9,
    13,
    27,
    32
], $29ecc58491fb6f0d$var$ae = $29ecc58491fb6f0d$var$ia && "CompositionEvent" in window, $29ecc58491fb6f0d$var$be = null;
$29ecc58491fb6f0d$var$ia && "documentMode" in document && ($29ecc58491fb6f0d$var$be = document.documentMode);
var $29ecc58491fb6f0d$var$ce = $29ecc58491fb6f0d$var$ia && "TextEvent" in window && !$29ecc58491fb6f0d$var$be, $29ecc58491fb6f0d$var$de = $29ecc58491fb6f0d$var$ia && (!$29ecc58491fb6f0d$var$ae || $29ecc58491fb6f0d$var$be && 8 < $29ecc58491fb6f0d$var$be && 11 >= $29ecc58491fb6f0d$var$be), $29ecc58491fb6f0d$var$ee = String.fromCharCode(32), $29ecc58491fb6f0d$var$fe = !1;
function $29ecc58491fb6f0d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $29ecc58491fb6f0d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $29ecc58491fb6f0d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $29ecc58491fb6f0d$var$ie = !1;
function $29ecc58491fb6f0d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $29ecc58491fb6f0d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $29ecc58491fb6f0d$var$fe = !0;
            return $29ecc58491fb6f0d$var$ee;
        case "textInput":
            return a = b.data, a === $29ecc58491fb6f0d$var$ee && $29ecc58491fb6f0d$var$fe ? null : a;
        default:
            return null;
    }
}
function $29ecc58491fb6f0d$var$ke(a, b) {
    if ($29ecc58491fb6f0d$var$ie) return "compositionend" === a || !$29ecc58491fb6f0d$var$ae && $29ecc58491fb6f0d$var$ge(a, b) ? (a = $29ecc58491fb6f0d$var$nd(), $29ecc58491fb6f0d$var$md = $29ecc58491fb6f0d$var$ld = $29ecc58491fb6f0d$var$kd = null, $29ecc58491fb6f0d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $29ecc58491fb6f0d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $29ecc58491fb6f0d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $29ecc58491fb6f0d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$29ecc58491fb6f0d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $29ecc58491fb6f0d$var$ne(a, b, c, d) {
    $29ecc58491fb6f0d$var$Eb(d);
    b = $29ecc58491fb6f0d$var$oe(b, "onChange");
    0 < b.length && (c = new $29ecc58491fb6f0d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $29ecc58491fb6f0d$var$pe = null, $29ecc58491fb6f0d$var$qe = null;
function $29ecc58491fb6f0d$var$re(a) {
    $29ecc58491fb6f0d$var$se(a, 0);
}
function $29ecc58491fb6f0d$var$te(a) {
    var b = $29ecc58491fb6f0d$var$ue(a);
    if ($29ecc58491fb6f0d$var$Wa(b)) return a;
}
function $29ecc58491fb6f0d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $29ecc58491fb6f0d$var$we = !1;
if ($29ecc58491fb6f0d$var$ia) {
    var $29ecc58491fb6f0d$var$xe;
    if ($29ecc58491fb6f0d$var$ia) {
        var $29ecc58491fb6f0d$var$ye = "oninput" in document;
        if (!$29ecc58491fb6f0d$var$ye) {
            var $29ecc58491fb6f0d$var$ze = document.createElement("div");
            $29ecc58491fb6f0d$var$ze.setAttribute("oninput", "return;");
            $29ecc58491fb6f0d$var$ye = "function" === typeof $29ecc58491fb6f0d$var$ze.oninput;
        }
        $29ecc58491fb6f0d$var$xe = $29ecc58491fb6f0d$var$ye;
    } else $29ecc58491fb6f0d$var$xe = !1;
    $29ecc58491fb6f0d$var$we = $29ecc58491fb6f0d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $29ecc58491fb6f0d$var$Ae() {
    $29ecc58491fb6f0d$var$pe && ($29ecc58491fb6f0d$var$pe.detachEvent("onpropertychange", $29ecc58491fb6f0d$var$Be), $29ecc58491fb6f0d$var$qe = $29ecc58491fb6f0d$var$pe = null);
}
function $29ecc58491fb6f0d$var$Be(a) {
    if ("value" === a.propertyName && $29ecc58491fb6f0d$var$te($29ecc58491fb6f0d$var$qe)) {
        var b = [];
        $29ecc58491fb6f0d$var$ne(b, $29ecc58491fb6f0d$var$qe, a, $29ecc58491fb6f0d$var$xb(a));
        $29ecc58491fb6f0d$var$Jb($29ecc58491fb6f0d$var$re, b);
    }
}
function $29ecc58491fb6f0d$var$Ce(a, b, c) {
    "focusin" === a ? ($29ecc58491fb6f0d$var$Ae(), $29ecc58491fb6f0d$var$pe = b, $29ecc58491fb6f0d$var$qe = c, $29ecc58491fb6f0d$var$pe.attachEvent("onpropertychange", $29ecc58491fb6f0d$var$Be)) : "focusout" === a && $29ecc58491fb6f0d$var$Ae();
}
function $29ecc58491fb6f0d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $29ecc58491fb6f0d$var$te($29ecc58491fb6f0d$var$qe);
}
function $29ecc58491fb6f0d$var$Ee(a, b) {
    if ("click" === a) return $29ecc58491fb6f0d$var$te(b);
}
function $29ecc58491fb6f0d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $29ecc58491fb6f0d$var$te(b);
}
function $29ecc58491fb6f0d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $29ecc58491fb6f0d$var$He = "function" === typeof Object.is ? Object.is : $29ecc58491fb6f0d$var$Ge;
function $29ecc58491fb6f0d$var$Ie(a, b) {
    if ($29ecc58491fb6f0d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$29ecc58491fb6f0d$var$ja.call(b, e) || !$29ecc58491fb6f0d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $29ecc58491fb6f0d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $29ecc58491fb6f0d$var$Ke(a, b) {
    var c = $29ecc58491fb6f0d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $29ecc58491fb6f0d$var$Je(c);
    }
}
function $29ecc58491fb6f0d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $29ecc58491fb6f0d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $29ecc58491fb6f0d$var$Me() {
    for(var a = window, b = $29ecc58491fb6f0d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $29ecc58491fb6f0d$var$Xa(a.document);
    }
    return b;
}
function $29ecc58491fb6f0d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $29ecc58491fb6f0d$var$Oe(a) {
    var b = $29ecc58491fb6f0d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $29ecc58491fb6f0d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $29ecc58491fb6f0d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $29ecc58491fb6f0d$var$Ke(c, f);
                var g = $29ecc58491fb6f0d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $29ecc58491fb6f0d$var$Pe = $29ecc58491fb6f0d$var$ia && "documentMode" in document && 11 >= document.documentMode, $29ecc58491fb6f0d$var$Qe = null, $29ecc58491fb6f0d$var$Re = null, $29ecc58491fb6f0d$var$Se = null, $29ecc58491fb6f0d$var$Te = !1;
function $29ecc58491fb6f0d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $29ecc58491fb6f0d$var$Te || null == $29ecc58491fb6f0d$var$Qe || $29ecc58491fb6f0d$var$Qe !== $29ecc58491fb6f0d$var$Xa(d) || (d = $29ecc58491fb6f0d$var$Qe, "selectionStart" in d && $29ecc58491fb6f0d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $29ecc58491fb6f0d$var$Se && $29ecc58491fb6f0d$var$Ie($29ecc58491fb6f0d$var$Se, d) || ($29ecc58491fb6f0d$var$Se = d, d = $29ecc58491fb6f0d$var$oe($29ecc58491fb6f0d$var$Re, "onSelect"), 0 < d.length && (b = new $29ecc58491fb6f0d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $29ecc58491fb6f0d$var$Qe)));
}
function $29ecc58491fb6f0d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $29ecc58491fb6f0d$var$We = {
    animationend: $29ecc58491fb6f0d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $29ecc58491fb6f0d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $29ecc58491fb6f0d$var$Ve("Animation", "AnimationStart"),
    transitionend: $29ecc58491fb6f0d$var$Ve("Transition", "TransitionEnd")
}, $29ecc58491fb6f0d$var$Xe = {}, $29ecc58491fb6f0d$var$Ye = {};
$29ecc58491fb6f0d$var$ia && ($29ecc58491fb6f0d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $29ecc58491fb6f0d$var$We.animationend.animation, delete $29ecc58491fb6f0d$var$We.animationiteration.animation, delete $29ecc58491fb6f0d$var$We.animationstart.animation), "TransitionEvent" in window || delete $29ecc58491fb6f0d$var$We.transitionend.transition);
function $29ecc58491fb6f0d$var$Ze(a) {
    if ($29ecc58491fb6f0d$var$Xe[a]) return $29ecc58491fb6f0d$var$Xe[a];
    if (!$29ecc58491fb6f0d$var$We[a]) return a;
    var b = $29ecc58491fb6f0d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $29ecc58491fb6f0d$var$Ye) return $29ecc58491fb6f0d$var$Xe[a] = b[c];
    return a;
}
var $29ecc58491fb6f0d$var$$e = $29ecc58491fb6f0d$var$Ze("animationend"), $29ecc58491fb6f0d$var$af = $29ecc58491fb6f0d$var$Ze("animationiteration"), $29ecc58491fb6f0d$var$bf = $29ecc58491fb6f0d$var$Ze("animationstart"), $29ecc58491fb6f0d$var$cf = $29ecc58491fb6f0d$var$Ze("transitionend"), $29ecc58491fb6f0d$var$df = new Map, $29ecc58491fb6f0d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $29ecc58491fb6f0d$var$ff(a, b) {
    $29ecc58491fb6f0d$var$df.set(a, b);
    $29ecc58491fb6f0d$var$fa(b, [
        a
    ]);
}
for(var $29ecc58491fb6f0d$var$gf = 0; $29ecc58491fb6f0d$var$gf < $29ecc58491fb6f0d$var$ef.length; $29ecc58491fb6f0d$var$gf++){
    var $29ecc58491fb6f0d$var$hf = $29ecc58491fb6f0d$var$ef[$29ecc58491fb6f0d$var$gf], $29ecc58491fb6f0d$var$jf = $29ecc58491fb6f0d$var$hf.toLowerCase(), $29ecc58491fb6f0d$var$kf = $29ecc58491fb6f0d$var$hf[0].toUpperCase() + $29ecc58491fb6f0d$var$hf.slice(1);
    $29ecc58491fb6f0d$var$ff($29ecc58491fb6f0d$var$jf, "on" + $29ecc58491fb6f0d$var$kf);
}
$29ecc58491fb6f0d$var$ff($29ecc58491fb6f0d$var$$e, "onAnimationEnd");
$29ecc58491fb6f0d$var$ff($29ecc58491fb6f0d$var$af, "onAnimationIteration");
$29ecc58491fb6f0d$var$ff($29ecc58491fb6f0d$var$bf, "onAnimationStart");
$29ecc58491fb6f0d$var$ff("dblclick", "onDoubleClick");
$29ecc58491fb6f0d$var$ff("focusin", "onFocus");
$29ecc58491fb6f0d$var$ff("focusout", "onBlur");
$29ecc58491fb6f0d$var$ff($29ecc58491fb6f0d$var$cf, "onTransitionEnd");
$29ecc58491fb6f0d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$29ecc58491fb6f0d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$29ecc58491fb6f0d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$29ecc58491fb6f0d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$29ecc58491fb6f0d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$29ecc58491fb6f0d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$29ecc58491fb6f0d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$29ecc58491fb6f0d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$29ecc58491fb6f0d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$29ecc58491fb6f0d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $29ecc58491fb6f0d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $29ecc58491fb6f0d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($29ecc58491fb6f0d$var$lf));
function $29ecc58491fb6f0d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $29ecc58491fb6f0d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $29ecc58491fb6f0d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $29ecc58491fb6f0d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $29ecc58491fb6f0d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($29ecc58491fb6f0d$var$Qb) throw a = $29ecc58491fb6f0d$var$Rb, $29ecc58491fb6f0d$var$Qb = !1, $29ecc58491fb6f0d$var$Rb = null, a;
}
function $29ecc58491fb6f0d$var$D(a, b) {
    var c = b[$29ecc58491fb6f0d$var$of];
    void 0 === c && (c = b[$29ecc58491fb6f0d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($29ecc58491fb6f0d$var$pf(b, a, 2, !1), c.add(d));
}
function $29ecc58491fb6f0d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $29ecc58491fb6f0d$var$pf(c, a, d, b);
}
var $29ecc58491fb6f0d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $29ecc58491fb6f0d$var$sf(a) {
    if (!a[$29ecc58491fb6f0d$var$rf]) {
        a[$29ecc58491fb6f0d$var$rf] = !0;
        $29ecc58491fb6f0d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($29ecc58491fb6f0d$var$mf.has(b) || $29ecc58491fb6f0d$var$qf(b, !1, a), $29ecc58491fb6f0d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$29ecc58491fb6f0d$var$rf] || (b[$29ecc58491fb6f0d$var$rf] = !0, $29ecc58491fb6f0d$var$qf("selectionchange", !1, b));
    }
}
function $29ecc58491fb6f0d$var$pf(a, b, c, d) {
    switch($29ecc58491fb6f0d$var$jd(b)){
        case 1:
            var e = $29ecc58491fb6f0d$var$ed;
            break;
        case 4:
            e = $29ecc58491fb6f0d$var$gd;
            break;
        default:
            e = $29ecc58491fb6f0d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$29ecc58491fb6f0d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $29ecc58491fb6f0d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $29ecc58491fb6f0d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $29ecc58491fb6f0d$var$Jb(function() {
        var d = f, e = $29ecc58491fb6f0d$var$xb(c), g = [];
        a: {
            var h = $29ecc58491fb6f0d$var$df.get(a);
            if (void 0 !== h) {
                var k = $29ecc58491fb6f0d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $29ecc58491fb6f0d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $29ecc58491fb6f0d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $29ecc58491fb6f0d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $29ecc58491fb6f0d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $29ecc58491fb6f0d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $29ecc58491fb6f0d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $29ecc58491fb6f0d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $29ecc58491fb6f0d$var$Vd;
                        break;
                    case $29ecc58491fb6f0d$var$$e:
                    case $29ecc58491fb6f0d$var$af:
                    case $29ecc58491fb6f0d$var$bf:
                        k = $29ecc58491fb6f0d$var$Hd;
                        break;
                    case $29ecc58491fb6f0d$var$cf:
                        k = $29ecc58491fb6f0d$var$Xd;
                        break;
                    case "scroll":
                        k = $29ecc58491fb6f0d$var$vd;
                        break;
                    case "wheel":
                        k = $29ecc58491fb6f0d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $29ecc58491fb6f0d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $29ecc58491fb6f0d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $29ecc58491fb6f0d$var$Kb(w, x), null != F && t.push($29ecc58491fb6f0d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $29ecc58491fb6f0d$var$wb && (n = c.relatedTarget || c.fromElement) && ($29ecc58491fb6f0d$var$Wc(n) || n[$29ecc58491fb6f0d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $29ecc58491fb6f0d$var$Wc(n) : null, null !== n && (J = $29ecc58491fb6f0d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $29ecc58491fb6f0d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $29ecc58491fb6f0d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $29ecc58491fb6f0d$var$ue(k);
                        u = null == n ? h : $29ecc58491fb6f0d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $29ecc58491fb6f0d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $29ecc58491fb6f0d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $29ecc58491fb6f0d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $29ecc58491fb6f0d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $29ecc58491fb6f0d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $29ecc58491fb6f0d$var$vf(t);
                                x = $29ecc58491fb6f0d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $29ecc58491fb6f0d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $29ecc58491fb6f0d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $29ecc58491fb6f0d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $29ecc58491fb6f0d$var$ve;
                else if ($29ecc58491fb6f0d$var$me(h)) {
                    if ($29ecc58491fb6f0d$var$we) na = $29ecc58491fb6f0d$var$Fe;
                    else {
                        na = $29ecc58491fb6f0d$var$De;
                        var xa = $29ecc58491fb6f0d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $29ecc58491fb6f0d$var$Ee);
                if (na && (na = na(a, d))) {
                    $29ecc58491fb6f0d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $29ecc58491fb6f0d$var$cb(h, "number", h.value);
            }
            xa = d ? $29ecc58491fb6f0d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($29ecc58491fb6f0d$var$me(xa) || "true" === xa.contentEditable) $29ecc58491fb6f0d$var$Qe = xa, $29ecc58491fb6f0d$var$Re = d, $29ecc58491fb6f0d$var$Se = null;
                    break;
                case "focusout":
                    $29ecc58491fb6f0d$var$Se = $29ecc58491fb6f0d$var$Re = $29ecc58491fb6f0d$var$Qe = null;
                    break;
                case "mousedown":
                    $29ecc58491fb6f0d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $29ecc58491fb6f0d$var$Te = !1;
                    $29ecc58491fb6f0d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($29ecc58491fb6f0d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $29ecc58491fb6f0d$var$Ue(g, c, e);
            }
            var $a;
            if ($29ecc58491fb6f0d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $29ecc58491fb6f0d$var$ie ? $29ecc58491fb6f0d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($29ecc58491fb6f0d$var$de && "ko" !== c.locale && ($29ecc58491fb6f0d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $29ecc58491fb6f0d$var$ie && ($a = $29ecc58491fb6f0d$var$nd()) : ($29ecc58491fb6f0d$var$kd = e, $29ecc58491fb6f0d$var$ld = "value" in $29ecc58491fb6f0d$var$kd ? $29ecc58491fb6f0d$var$kd.value : $29ecc58491fb6f0d$var$kd.textContent, $29ecc58491fb6f0d$var$ie = !0)), xa = $29ecc58491fb6f0d$var$oe(d, ba), 0 < xa.length && (ba = new $29ecc58491fb6f0d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $29ecc58491fb6f0d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $29ecc58491fb6f0d$var$ce ? $29ecc58491fb6f0d$var$je(a, c) : $29ecc58491fb6f0d$var$ke(a, c)) d = $29ecc58491fb6f0d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $29ecc58491fb6f0d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $29ecc58491fb6f0d$var$se(g, b);
    });
}
function $29ecc58491fb6f0d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $29ecc58491fb6f0d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $29ecc58491fb6f0d$var$Kb(a, c), null != f && d.unshift($29ecc58491fb6f0d$var$tf(a, f, e)), f = $29ecc58491fb6f0d$var$Kb(a, b), null != f && d.push($29ecc58491fb6f0d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $29ecc58491fb6f0d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $29ecc58491fb6f0d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $29ecc58491fb6f0d$var$Kb(c, f), null != k && g.unshift($29ecc58491fb6f0d$var$tf(c, k, h))) : e || (k = $29ecc58491fb6f0d$var$Kb(c, f), null != k && g.push($29ecc58491fb6f0d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $29ecc58491fb6f0d$var$xf = /\r\n?/g, $29ecc58491fb6f0d$var$yf = /\u0000|\uFFFD/g;
function $29ecc58491fb6f0d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($29ecc58491fb6f0d$var$xf, "\n").replace($29ecc58491fb6f0d$var$yf, "");
}
function $29ecc58491fb6f0d$var$Af(a, b, c) {
    b = $29ecc58491fb6f0d$var$zf(b);
    if ($29ecc58491fb6f0d$var$zf(a) !== b && c) throw Error($29ecc58491fb6f0d$var$p(425));
}
function $29ecc58491fb6f0d$var$Bf() {}
var $29ecc58491fb6f0d$var$Cf = null, $29ecc58491fb6f0d$var$Df = null;
function $29ecc58491fb6f0d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $29ecc58491fb6f0d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $29ecc58491fb6f0d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $29ecc58491fb6f0d$var$Hf = "function" === typeof Promise ? Promise : void 0, $29ecc58491fb6f0d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $29ecc58491fb6f0d$var$Hf ? function(a) {
    return $29ecc58491fb6f0d$var$Hf.resolve(null).then(a).catch($29ecc58491fb6f0d$var$If);
} : $29ecc58491fb6f0d$var$Ff;
function $29ecc58491fb6f0d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $29ecc58491fb6f0d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $29ecc58491fb6f0d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $29ecc58491fb6f0d$var$bd(b);
}
function $29ecc58491fb6f0d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $29ecc58491fb6f0d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $29ecc58491fb6f0d$var$Nf = Math.random().toString(36).slice(2), $29ecc58491fb6f0d$var$Of = "__reactFiber$" + $29ecc58491fb6f0d$var$Nf, $29ecc58491fb6f0d$var$Pf = "__reactProps$" + $29ecc58491fb6f0d$var$Nf, $29ecc58491fb6f0d$var$uf = "__reactContainer$" + $29ecc58491fb6f0d$var$Nf, $29ecc58491fb6f0d$var$of = "__reactEvents$" + $29ecc58491fb6f0d$var$Nf, $29ecc58491fb6f0d$var$Qf = "__reactListeners$" + $29ecc58491fb6f0d$var$Nf, $29ecc58491fb6f0d$var$Rf = "__reactHandles$" + $29ecc58491fb6f0d$var$Nf;
function $29ecc58491fb6f0d$var$Wc(a) {
    var b = a[$29ecc58491fb6f0d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$29ecc58491fb6f0d$var$uf] || c[$29ecc58491fb6f0d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $29ecc58491fb6f0d$var$Mf(a); null !== a;){
                if (c = a[$29ecc58491fb6f0d$var$Of]) return c;
                a = $29ecc58491fb6f0d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $29ecc58491fb6f0d$var$Cb(a) {
    a = a[$29ecc58491fb6f0d$var$Of] || a[$29ecc58491fb6f0d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $29ecc58491fb6f0d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($29ecc58491fb6f0d$var$p(33));
}
function $29ecc58491fb6f0d$var$Db(a) {
    return a[$29ecc58491fb6f0d$var$Pf] || null;
}
var $29ecc58491fb6f0d$var$Sf = [], $29ecc58491fb6f0d$var$Tf = -1;
function $29ecc58491fb6f0d$var$Uf(a) {
    return {
        current: a
    };
}
function $29ecc58491fb6f0d$var$E(a) {
    0 > $29ecc58491fb6f0d$var$Tf || (a.current = $29ecc58491fb6f0d$var$Sf[$29ecc58491fb6f0d$var$Tf], $29ecc58491fb6f0d$var$Sf[$29ecc58491fb6f0d$var$Tf] = null, $29ecc58491fb6f0d$var$Tf--);
}
function $29ecc58491fb6f0d$var$G(a, b) {
    $29ecc58491fb6f0d$var$Tf++;
    $29ecc58491fb6f0d$var$Sf[$29ecc58491fb6f0d$var$Tf] = a.current;
    a.current = b;
}
var $29ecc58491fb6f0d$var$Vf = {}, $29ecc58491fb6f0d$var$H = $29ecc58491fb6f0d$var$Uf($29ecc58491fb6f0d$var$Vf), $29ecc58491fb6f0d$var$Wf = $29ecc58491fb6f0d$var$Uf(!1), $29ecc58491fb6f0d$var$Xf = $29ecc58491fb6f0d$var$Vf;
function $29ecc58491fb6f0d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $29ecc58491fb6f0d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $29ecc58491fb6f0d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $29ecc58491fb6f0d$var$$f() {
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wf);
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$H);
}
function $29ecc58491fb6f0d$var$ag(a, b, c) {
    if ($29ecc58491fb6f0d$var$H.current !== $29ecc58491fb6f0d$var$Vf) throw Error($29ecc58491fb6f0d$var$p(168));
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$H, b);
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$Wf, c);
}
function $29ecc58491fb6f0d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($29ecc58491fb6f0d$var$p(108, $29ecc58491fb6f0d$var$Ra(a) || "Unknown", e));
    return $29ecc58491fb6f0d$var$A({}, c, d);
}
function $29ecc58491fb6f0d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $29ecc58491fb6f0d$var$Vf;
    $29ecc58491fb6f0d$var$Xf = $29ecc58491fb6f0d$var$H.current;
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$H, a);
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$Wf, $29ecc58491fb6f0d$var$Wf.current);
    return !0;
}
function $29ecc58491fb6f0d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($29ecc58491fb6f0d$var$p(169));
    c ? (a = $29ecc58491fb6f0d$var$bg(a, b, $29ecc58491fb6f0d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wf), $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$H), $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$H, a)) : $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wf);
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$Wf, c);
}
var $29ecc58491fb6f0d$var$eg = null, $29ecc58491fb6f0d$var$fg = !1, $29ecc58491fb6f0d$var$gg = !1;
function $29ecc58491fb6f0d$var$hg(a) {
    null === $29ecc58491fb6f0d$var$eg ? $29ecc58491fb6f0d$var$eg = [
        a
    ] : $29ecc58491fb6f0d$var$eg.push(a);
}
function $29ecc58491fb6f0d$var$ig(a) {
    $29ecc58491fb6f0d$var$fg = !0;
    $29ecc58491fb6f0d$var$hg(a);
}
function $29ecc58491fb6f0d$var$jg() {
    if (!$29ecc58491fb6f0d$var$gg && null !== $29ecc58491fb6f0d$var$eg) {
        $29ecc58491fb6f0d$var$gg = !0;
        var a = 0, b = $29ecc58491fb6f0d$var$C;
        try {
            var c = $29ecc58491fb6f0d$var$eg;
            for($29ecc58491fb6f0d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $29ecc58491fb6f0d$var$eg = null;
            $29ecc58491fb6f0d$var$fg = !1;
        } catch (e) {
            throw null !== $29ecc58491fb6f0d$var$eg && ($29ecc58491fb6f0d$var$eg = $29ecc58491fb6f0d$var$eg.slice(a + 1)), $29ecc58491fb6f0d$var$ac($29ecc58491fb6f0d$var$fc, $29ecc58491fb6f0d$var$jg), e;
        } finally{
            $29ecc58491fb6f0d$var$C = b, $29ecc58491fb6f0d$var$gg = !1;
        }
    }
    return null;
}
var $29ecc58491fb6f0d$var$kg = [], $29ecc58491fb6f0d$var$lg = 0, $29ecc58491fb6f0d$var$mg = null, $29ecc58491fb6f0d$var$ng = 0, $29ecc58491fb6f0d$var$og = [], $29ecc58491fb6f0d$var$pg = 0, $29ecc58491fb6f0d$var$qg = null, $29ecc58491fb6f0d$var$rg = 1, $29ecc58491fb6f0d$var$sg = "";
function $29ecc58491fb6f0d$var$tg(a, b) {
    $29ecc58491fb6f0d$var$kg[$29ecc58491fb6f0d$var$lg++] = $29ecc58491fb6f0d$var$ng;
    $29ecc58491fb6f0d$var$kg[$29ecc58491fb6f0d$var$lg++] = $29ecc58491fb6f0d$var$mg;
    $29ecc58491fb6f0d$var$mg = a;
    $29ecc58491fb6f0d$var$ng = b;
}
function $29ecc58491fb6f0d$var$ug(a, b, c) {
    $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg++] = $29ecc58491fb6f0d$var$rg;
    $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg++] = $29ecc58491fb6f0d$var$sg;
    $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg++] = $29ecc58491fb6f0d$var$qg;
    $29ecc58491fb6f0d$var$qg = a;
    var d = $29ecc58491fb6f0d$var$rg;
    a = $29ecc58491fb6f0d$var$sg;
    var e = 32 - $29ecc58491fb6f0d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $29ecc58491fb6f0d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $29ecc58491fb6f0d$var$rg = 1 << 32 - $29ecc58491fb6f0d$var$oc(b) + e | c << e | d;
        $29ecc58491fb6f0d$var$sg = f + a;
    } else $29ecc58491fb6f0d$var$rg = 1 << f | c << e | d, $29ecc58491fb6f0d$var$sg = a;
}
function $29ecc58491fb6f0d$var$vg(a) {
    null !== a.return && ($29ecc58491fb6f0d$var$tg(a, 1), $29ecc58491fb6f0d$var$ug(a, 1, 0));
}
function $29ecc58491fb6f0d$var$wg(a) {
    for(; a === $29ecc58491fb6f0d$var$mg;)$29ecc58491fb6f0d$var$mg = $29ecc58491fb6f0d$var$kg[--$29ecc58491fb6f0d$var$lg], $29ecc58491fb6f0d$var$kg[$29ecc58491fb6f0d$var$lg] = null, $29ecc58491fb6f0d$var$ng = $29ecc58491fb6f0d$var$kg[--$29ecc58491fb6f0d$var$lg], $29ecc58491fb6f0d$var$kg[$29ecc58491fb6f0d$var$lg] = null;
    for(; a === $29ecc58491fb6f0d$var$qg;)$29ecc58491fb6f0d$var$qg = $29ecc58491fb6f0d$var$og[--$29ecc58491fb6f0d$var$pg], $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg] = null, $29ecc58491fb6f0d$var$sg = $29ecc58491fb6f0d$var$og[--$29ecc58491fb6f0d$var$pg], $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg] = null, $29ecc58491fb6f0d$var$rg = $29ecc58491fb6f0d$var$og[--$29ecc58491fb6f0d$var$pg], $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg] = null;
}
var $29ecc58491fb6f0d$var$xg = null, $29ecc58491fb6f0d$var$yg = null, $29ecc58491fb6f0d$var$I = !1, $29ecc58491fb6f0d$var$zg = null;
function $29ecc58491fb6f0d$var$Ag(a, b) {
    var c = $29ecc58491fb6f0d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $29ecc58491fb6f0d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $29ecc58491fb6f0d$var$xg = a, $29ecc58491fb6f0d$var$yg = $29ecc58491fb6f0d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $29ecc58491fb6f0d$var$xg = a, $29ecc58491fb6f0d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $29ecc58491fb6f0d$var$qg ? {
                id: $29ecc58491fb6f0d$var$rg,
                overflow: $29ecc58491fb6f0d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $29ecc58491fb6f0d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $29ecc58491fb6f0d$var$xg = a, $29ecc58491fb6f0d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $29ecc58491fb6f0d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $29ecc58491fb6f0d$var$Eg(a) {
    if ($29ecc58491fb6f0d$var$I) {
        var b = $29ecc58491fb6f0d$var$yg;
        if (b) {
            var c = b;
            if (!$29ecc58491fb6f0d$var$Cg(a, b)) {
                if ($29ecc58491fb6f0d$var$Dg(a)) throw Error($29ecc58491fb6f0d$var$p(418));
                b = $29ecc58491fb6f0d$var$Lf(c.nextSibling);
                var d = $29ecc58491fb6f0d$var$xg;
                b && $29ecc58491fb6f0d$var$Cg(a, b) ? $29ecc58491fb6f0d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $29ecc58491fb6f0d$var$I = !1, $29ecc58491fb6f0d$var$xg = a);
            }
        } else {
            if ($29ecc58491fb6f0d$var$Dg(a)) throw Error($29ecc58491fb6f0d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $29ecc58491fb6f0d$var$I = !1;
            $29ecc58491fb6f0d$var$xg = a;
        }
    }
}
function $29ecc58491fb6f0d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $29ecc58491fb6f0d$var$xg = a;
}
function $29ecc58491fb6f0d$var$Gg(a) {
    if (a !== $29ecc58491fb6f0d$var$xg) return !1;
    if (!$29ecc58491fb6f0d$var$I) return $29ecc58491fb6f0d$var$Fg(a), $29ecc58491fb6f0d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$29ecc58491fb6f0d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $29ecc58491fb6f0d$var$yg)) {
        if ($29ecc58491fb6f0d$var$Dg(a)) throw $29ecc58491fb6f0d$var$Hg(), Error($29ecc58491fb6f0d$var$p(418));
        for(; b;)$29ecc58491fb6f0d$var$Ag(a, b), b = $29ecc58491fb6f0d$var$Lf(b.nextSibling);
    }
    $29ecc58491fb6f0d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($29ecc58491fb6f0d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $29ecc58491fb6f0d$var$yg = $29ecc58491fb6f0d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $29ecc58491fb6f0d$var$yg = null;
        }
    } else $29ecc58491fb6f0d$var$yg = $29ecc58491fb6f0d$var$xg ? $29ecc58491fb6f0d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $29ecc58491fb6f0d$var$Hg() {
    for(var a = $29ecc58491fb6f0d$var$yg; a;)a = $29ecc58491fb6f0d$var$Lf(a.nextSibling);
}
function $29ecc58491fb6f0d$var$Ig() {
    $29ecc58491fb6f0d$var$yg = $29ecc58491fb6f0d$var$xg = null;
    $29ecc58491fb6f0d$var$I = !1;
}
function $29ecc58491fb6f0d$var$Jg(a) {
    null === $29ecc58491fb6f0d$var$zg ? $29ecc58491fb6f0d$var$zg = [
        a
    ] : $29ecc58491fb6f0d$var$zg.push(a);
}
var $29ecc58491fb6f0d$var$Kg = $29ecc58491fb6f0d$var$ua.ReactCurrentBatchConfig;
function $29ecc58491fb6f0d$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($29ecc58491fb6f0d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($29ecc58491fb6f0d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($29ecc58491fb6f0d$var$p(284));
        if (!c._owner) throw Error($29ecc58491fb6f0d$var$p(290, a));
    }
    return a;
}
function $29ecc58491fb6f0d$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($29ecc58491fb6f0d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $29ecc58491fb6f0d$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $29ecc58491fb6f0d$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $29ecc58491fb6f0d$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $29ecc58491fb6f0d$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $29ecc58491fb6f0d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $29ecc58491fb6f0d$var$Ha && $29ecc58491fb6f0d$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $29ecc58491fb6f0d$var$Lg(a, b, c), d.return = a, d;
        d = $29ecc58491fb6f0d$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $29ecc58491fb6f0d$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $29ecc58491fb6f0d$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $29ecc58491fb6f0d$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $29ecc58491fb6f0d$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $29ecc58491fb6f0d$var$va:
                    return c = $29ecc58491fb6f0d$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $29ecc58491fb6f0d$var$Lg(a, null, b), c.return = a, c;
                case $29ecc58491fb6f0d$var$wa:
                    return b = $29ecc58491fb6f0d$var$Sg(b, a.mode, c), b.return = a, b;
                case $29ecc58491fb6f0d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($29ecc58491fb6f0d$var$eb(b) || $29ecc58491fb6f0d$var$Ka(b)) return b = $29ecc58491fb6f0d$var$Tg(b, a.mode, c, null), b.return = a, b;
            $29ecc58491fb6f0d$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $29ecc58491fb6f0d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $29ecc58491fb6f0d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $29ecc58491fb6f0d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($29ecc58491fb6f0d$var$eb(c) || $29ecc58491fb6f0d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $29ecc58491fb6f0d$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $29ecc58491fb6f0d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $29ecc58491fb6f0d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $29ecc58491fb6f0d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($29ecc58491fb6f0d$var$eb(d) || $29ecc58491fb6f0d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $29ecc58491fb6f0d$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $29ecc58491fb6f0d$var$I && $29ecc58491fb6f0d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $29ecc58491fb6f0d$var$I && $29ecc58491fb6f0d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $29ecc58491fb6f0d$var$I && $29ecc58491fb6f0d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $29ecc58491fb6f0d$var$Ka(h);
        if ("function" !== typeof l) throw Error($29ecc58491fb6f0d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($29ecc58491fb6f0d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $29ecc58491fb6f0d$var$I && $29ecc58491fb6f0d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $29ecc58491fb6f0d$var$I && $29ecc58491fb6f0d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $29ecc58491fb6f0d$var$I && $29ecc58491fb6f0d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $29ecc58491fb6f0d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $29ecc58491fb6f0d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $29ecc58491fb6f0d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $29ecc58491fb6f0d$var$Ha && $29ecc58491fb6f0d$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $29ecc58491fb6f0d$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $29ecc58491fb6f0d$var$ya ? (d = $29ecc58491fb6f0d$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $29ecc58491fb6f0d$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $29ecc58491fb6f0d$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $29ecc58491fb6f0d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $29ecc58491fb6f0d$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $29ecc58491fb6f0d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($29ecc58491fb6f0d$var$eb(f)) return n(a, d, f, h);
            if ($29ecc58491fb6f0d$var$Ka(f)) return t(a, d, f, h);
            $29ecc58491fb6f0d$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $29ecc58491fb6f0d$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $29ecc58491fb6f0d$var$Ug = $29ecc58491fb6f0d$var$Og(!0), $29ecc58491fb6f0d$var$Vg = $29ecc58491fb6f0d$var$Og(!1), $29ecc58491fb6f0d$var$Wg = $29ecc58491fb6f0d$var$Uf(null), $29ecc58491fb6f0d$var$Xg = null, $29ecc58491fb6f0d$var$Yg = null, $29ecc58491fb6f0d$var$Zg = null;
function $29ecc58491fb6f0d$var$$g() {
    $29ecc58491fb6f0d$var$Zg = $29ecc58491fb6f0d$var$Yg = $29ecc58491fb6f0d$var$Xg = null;
}
function $29ecc58491fb6f0d$var$ah(a) {
    var b = $29ecc58491fb6f0d$var$Wg.current;
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wg);
    a._currentValue = b;
}
function $29ecc58491fb6f0d$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $29ecc58491fb6f0d$var$ch(a, b) {
    $29ecc58491fb6f0d$var$Xg = a;
    $29ecc58491fb6f0d$var$Zg = $29ecc58491fb6f0d$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($29ecc58491fb6f0d$var$dh = !0), a.firstContext = null);
}
function $29ecc58491fb6f0d$var$eh(a) {
    var b = a._currentValue;
    if ($29ecc58491fb6f0d$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $29ecc58491fb6f0d$var$Yg) {
            if (null === $29ecc58491fb6f0d$var$Xg) throw Error($29ecc58491fb6f0d$var$p(308));
            $29ecc58491fb6f0d$var$Yg = a;
            $29ecc58491fb6f0d$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $29ecc58491fb6f0d$var$Yg = $29ecc58491fb6f0d$var$Yg.next = a;
    }
    return b;
}
var $29ecc58491fb6f0d$var$fh = null;
function $29ecc58491fb6f0d$var$gh(a) {
    null === $29ecc58491fb6f0d$var$fh ? $29ecc58491fb6f0d$var$fh = [
        a
    ] : $29ecc58491fb6f0d$var$fh.push(a);
}
function $29ecc58491fb6f0d$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $29ecc58491fb6f0d$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $29ecc58491fb6f0d$var$ih(a, d);
}
function $29ecc58491fb6f0d$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $29ecc58491fb6f0d$var$jh = !1;
function $29ecc58491fb6f0d$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $29ecc58491fb6f0d$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $29ecc58491fb6f0d$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $29ecc58491fb6f0d$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($29ecc58491fb6f0d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $29ecc58491fb6f0d$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $29ecc58491fb6f0d$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $29ecc58491fb6f0d$var$ih(a, c);
}
function $29ecc58491fb6f0d$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $29ecc58491fb6f0d$var$Cc(a, c);
    }
}
function $29ecc58491fb6f0d$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $29ecc58491fb6f0d$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $29ecc58491fb6f0d$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $29ecc58491fb6f0d$var$A({}, q, r);
                            break a;
                        case 2:
                            $29ecc58491fb6f0d$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $29ecc58491fb6f0d$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $29ecc58491fb6f0d$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($29ecc58491fb6f0d$var$p(191, e));
            e.call(d);
        }
    }
}
var $29ecc58491fb6f0d$var$th = {}, $29ecc58491fb6f0d$var$uh = $29ecc58491fb6f0d$var$Uf($29ecc58491fb6f0d$var$th), $29ecc58491fb6f0d$var$vh = $29ecc58491fb6f0d$var$Uf($29ecc58491fb6f0d$var$th), $29ecc58491fb6f0d$var$wh = $29ecc58491fb6f0d$var$Uf($29ecc58491fb6f0d$var$th);
function $29ecc58491fb6f0d$var$xh(a) {
    if (a === $29ecc58491fb6f0d$var$th) throw Error($29ecc58491fb6f0d$var$p(174));
    return a;
}
function $29ecc58491fb6f0d$var$yh(a, b) {
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$wh, b);
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$vh, a);
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$uh, $29ecc58491fb6f0d$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $29ecc58491fb6f0d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $29ecc58491fb6f0d$var$lb(b, a);
    }
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$uh);
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$uh, b);
}
function $29ecc58491fb6f0d$var$zh() {
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$uh);
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$vh);
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$wh);
}
function $29ecc58491fb6f0d$var$Ah(a) {
    $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$wh.current);
    var b = $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$uh.current);
    var c = $29ecc58491fb6f0d$var$lb(b, a.type);
    b !== c && ($29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$vh, a), $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$uh, c));
}
function $29ecc58491fb6f0d$var$Bh(a) {
    $29ecc58491fb6f0d$var$vh.current === a && ($29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$uh), $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$vh));
}
var $29ecc58491fb6f0d$var$L = $29ecc58491fb6f0d$var$Uf(0);
function $29ecc58491fb6f0d$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $29ecc58491fb6f0d$var$Dh = [];
function $29ecc58491fb6f0d$var$Eh() {
    for(var a = 0; a < $29ecc58491fb6f0d$var$Dh.length; a++)$29ecc58491fb6f0d$var$Dh[a]._workInProgressVersionPrimary = null;
    $29ecc58491fb6f0d$var$Dh.length = 0;
}
var $29ecc58491fb6f0d$var$Fh = $29ecc58491fb6f0d$var$ua.ReactCurrentDispatcher, $29ecc58491fb6f0d$var$Gh = $29ecc58491fb6f0d$var$ua.ReactCurrentBatchConfig, $29ecc58491fb6f0d$var$Hh = 0, $29ecc58491fb6f0d$var$M = null, $29ecc58491fb6f0d$var$N = null, $29ecc58491fb6f0d$var$O = null, $29ecc58491fb6f0d$var$Ih = !1, $29ecc58491fb6f0d$var$Jh = !1, $29ecc58491fb6f0d$var$Kh = 0, $29ecc58491fb6f0d$var$Lh = 0;
function $29ecc58491fb6f0d$var$P() {
    throw Error($29ecc58491fb6f0d$var$p(321));
}
function $29ecc58491fb6f0d$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$29ecc58491fb6f0d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $29ecc58491fb6f0d$var$Nh(a, b, c, d, e, f) {
    $29ecc58491fb6f0d$var$Hh = f;
    $29ecc58491fb6f0d$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $29ecc58491fb6f0d$var$Fh.current = null === a || null === a.memoizedState ? $29ecc58491fb6f0d$var$Oh : $29ecc58491fb6f0d$var$Ph;
    a = c(d, e);
    if ($29ecc58491fb6f0d$var$Jh) {
        f = 0;
        do {
            $29ecc58491fb6f0d$var$Jh = !1;
            $29ecc58491fb6f0d$var$Kh = 0;
            if (25 <= f) throw Error($29ecc58491fb6f0d$var$p(301));
            f += 1;
            $29ecc58491fb6f0d$var$O = $29ecc58491fb6f0d$var$N = null;
            b.updateQueue = null;
            $29ecc58491fb6f0d$var$Fh.current = $29ecc58491fb6f0d$var$Qh;
            a = c(d, e);
        }while ($29ecc58491fb6f0d$var$Jh);
    }
    $29ecc58491fb6f0d$var$Fh.current = $29ecc58491fb6f0d$var$Rh;
    b = null !== $29ecc58491fb6f0d$var$N && null !== $29ecc58491fb6f0d$var$N.next;
    $29ecc58491fb6f0d$var$Hh = 0;
    $29ecc58491fb6f0d$var$O = $29ecc58491fb6f0d$var$N = $29ecc58491fb6f0d$var$M = null;
    $29ecc58491fb6f0d$var$Ih = !1;
    if (b) throw Error($29ecc58491fb6f0d$var$p(300));
    return a;
}
function $29ecc58491fb6f0d$var$Sh() {
    var a = 0 !== $29ecc58491fb6f0d$var$Kh;
    $29ecc58491fb6f0d$var$Kh = 0;
    return a;
}
function $29ecc58491fb6f0d$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $29ecc58491fb6f0d$var$O ? $29ecc58491fb6f0d$var$M.memoizedState = $29ecc58491fb6f0d$var$O = a : $29ecc58491fb6f0d$var$O = $29ecc58491fb6f0d$var$O.next = a;
    return $29ecc58491fb6f0d$var$O;
}
function $29ecc58491fb6f0d$var$Uh() {
    if (null === $29ecc58491fb6f0d$var$N) {
        var a = $29ecc58491fb6f0d$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $29ecc58491fb6f0d$var$N.next;
    var b = null === $29ecc58491fb6f0d$var$O ? $29ecc58491fb6f0d$var$M.memoizedState : $29ecc58491fb6f0d$var$O.next;
    if (null !== b) $29ecc58491fb6f0d$var$O = b, $29ecc58491fb6f0d$var$N = a;
    else {
        if (null === a) throw Error($29ecc58491fb6f0d$var$p(310));
        $29ecc58491fb6f0d$var$N = a;
        a = {
            memoizedState: $29ecc58491fb6f0d$var$N.memoizedState,
            baseState: $29ecc58491fb6f0d$var$N.baseState,
            baseQueue: $29ecc58491fb6f0d$var$N.baseQueue,
            queue: $29ecc58491fb6f0d$var$N.queue,
            next: null
        };
        null === $29ecc58491fb6f0d$var$O ? $29ecc58491fb6f0d$var$M.memoizedState = $29ecc58491fb6f0d$var$O = a : $29ecc58491fb6f0d$var$O = $29ecc58491fb6f0d$var$O.next = a;
    }
    return $29ecc58491fb6f0d$var$O;
}
function $29ecc58491fb6f0d$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $29ecc58491fb6f0d$var$Wh(a) {
    var b = $29ecc58491fb6f0d$var$Uh(), c = b.queue;
    if (null === c) throw Error($29ecc58491fb6f0d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $29ecc58491fb6f0d$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($29ecc58491fb6f0d$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $29ecc58491fb6f0d$var$M.lanes |= m;
                $29ecc58491fb6f0d$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $29ecc58491fb6f0d$var$He(d, b.memoizedState) || ($29ecc58491fb6f0d$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $29ecc58491fb6f0d$var$M.lanes |= f, $29ecc58491fb6f0d$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $29ecc58491fb6f0d$var$Xh(a) {
    var b = $29ecc58491fb6f0d$var$Uh(), c = b.queue;
    if (null === c) throw Error($29ecc58491fb6f0d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $29ecc58491fb6f0d$var$He(f, b.memoizedState) || ($29ecc58491fb6f0d$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $29ecc58491fb6f0d$var$Yh() {}
function $29ecc58491fb6f0d$var$Zh(a, b) {
    var c = $29ecc58491fb6f0d$var$M, d = $29ecc58491fb6f0d$var$Uh(), e = b(), f = !$29ecc58491fb6f0d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $29ecc58491fb6f0d$var$dh = !0);
    d = d.queue;
    $29ecc58491fb6f0d$var$$h($29ecc58491fb6f0d$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $29ecc58491fb6f0d$var$O && $29ecc58491fb6f0d$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $29ecc58491fb6f0d$var$bi(9, $29ecc58491fb6f0d$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $29ecc58491fb6f0d$var$Q) throw Error($29ecc58491fb6f0d$var$p(349));
        0 !== ($29ecc58491fb6f0d$var$Hh & 30) || $29ecc58491fb6f0d$var$di(c, b, e);
    }
    return e;
}
function $29ecc58491fb6f0d$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $29ecc58491fb6f0d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $29ecc58491fb6f0d$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $29ecc58491fb6f0d$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $29ecc58491fb6f0d$var$ei(b) && $29ecc58491fb6f0d$var$fi(a);
}
function $29ecc58491fb6f0d$var$ai(a, b, c) {
    return c(function() {
        $29ecc58491fb6f0d$var$ei(b) && $29ecc58491fb6f0d$var$fi(a);
    });
}
function $29ecc58491fb6f0d$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$29ecc58491fb6f0d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $29ecc58491fb6f0d$var$fi(a) {
    var b = $29ecc58491fb6f0d$var$ih(a, 1);
    null !== b && $29ecc58491fb6f0d$var$gi(b, a, 1, -1);
}
function $29ecc58491fb6f0d$var$hi(a) {
    var b = $29ecc58491fb6f0d$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $29ecc58491fb6f0d$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $29ecc58491fb6f0d$var$ii.bind(null, $29ecc58491fb6f0d$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $29ecc58491fb6f0d$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $29ecc58491fb6f0d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $29ecc58491fb6f0d$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $29ecc58491fb6f0d$var$ji() {
    return $29ecc58491fb6f0d$var$Uh().memoizedState;
}
function $29ecc58491fb6f0d$var$ki(a, b, c, d) {
    var e = $29ecc58491fb6f0d$var$Th();
    $29ecc58491fb6f0d$var$M.flags |= a;
    e.memoizedState = $29ecc58491fb6f0d$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $29ecc58491fb6f0d$var$li(a, b, c, d) {
    var e = $29ecc58491fb6f0d$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $29ecc58491fb6f0d$var$N) {
        var g = $29ecc58491fb6f0d$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $29ecc58491fb6f0d$var$Mh(d, g.deps)) {
            e.memoizedState = $29ecc58491fb6f0d$var$bi(b, c, f, d);
            return;
        }
    }
    $29ecc58491fb6f0d$var$M.flags |= a;
    e.memoizedState = $29ecc58491fb6f0d$var$bi(1 | b, c, f, d);
}
function $29ecc58491fb6f0d$var$mi(a, b) {
    return $29ecc58491fb6f0d$var$ki(8390656, 8, a, b);
}
function $29ecc58491fb6f0d$var$$h(a, b) {
    return $29ecc58491fb6f0d$var$li(2048, 8, a, b);
}
function $29ecc58491fb6f0d$var$ni(a, b) {
    return $29ecc58491fb6f0d$var$li(4, 2, a, b);
}
function $29ecc58491fb6f0d$var$oi(a, b) {
    return $29ecc58491fb6f0d$var$li(4, 4, a, b);
}
function $29ecc58491fb6f0d$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $29ecc58491fb6f0d$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $29ecc58491fb6f0d$var$li(4, 4, $29ecc58491fb6f0d$var$pi.bind(null, b, a), c);
}
function $29ecc58491fb6f0d$var$ri() {}
function $29ecc58491fb6f0d$var$si(a, b) {
    var c = $29ecc58491fb6f0d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $29ecc58491fb6f0d$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $29ecc58491fb6f0d$var$ti(a, b) {
    var c = $29ecc58491fb6f0d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $29ecc58491fb6f0d$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $29ecc58491fb6f0d$var$ui(a, b, c) {
    if (0 === ($29ecc58491fb6f0d$var$Hh & 21)) return a.baseState && (a.baseState = !1, $29ecc58491fb6f0d$var$dh = !0), a.memoizedState = c;
    $29ecc58491fb6f0d$var$He(c, b) || (c = $29ecc58491fb6f0d$var$yc(), $29ecc58491fb6f0d$var$M.lanes |= c, $29ecc58491fb6f0d$var$rh |= c, a.baseState = !0);
    return b;
}
function $29ecc58491fb6f0d$var$vi(a, b) {
    var c = $29ecc58491fb6f0d$var$C;
    $29ecc58491fb6f0d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $29ecc58491fb6f0d$var$Gh.transition;
    $29ecc58491fb6f0d$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $29ecc58491fb6f0d$var$C = c, $29ecc58491fb6f0d$var$Gh.transition = d;
    }
}
function $29ecc58491fb6f0d$var$wi() {
    return $29ecc58491fb6f0d$var$Uh().memoizedState;
}
function $29ecc58491fb6f0d$var$xi(a, b, c) {
    var d = $29ecc58491fb6f0d$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($29ecc58491fb6f0d$var$zi(a)) $29ecc58491fb6f0d$var$Ai(b, c);
    else if (c = $29ecc58491fb6f0d$var$hh(a, b, c, d), null !== c) {
        var e = $29ecc58491fb6f0d$var$R();
        $29ecc58491fb6f0d$var$gi(c, a, d, e);
        $29ecc58491fb6f0d$var$Bi(c, b, d);
    }
}
function $29ecc58491fb6f0d$var$ii(a, b, c) {
    var d = $29ecc58491fb6f0d$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($29ecc58491fb6f0d$var$zi(a)) $29ecc58491fb6f0d$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($29ecc58491fb6f0d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $29ecc58491fb6f0d$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $29ecc58491fb6f0d$var$hh(a, b, e, d);
        null !== c && (e = $29ecc58491fb6f0d$var$R(), $29ecc58491fb6f0d$var$gi(c, a, d, e), $29ecc58491fb6f0d$var$Bi(c, b, d));
    }
}
function $29ecc58491fb6f0d$var$zi(a) {
    var b = a.alternate;
    return a === $29ecc58491fb6f0d$var$M || null !== b && b === $29ecc58491fb6f0d$var$M;
}
function $29ecc58491fb6f0d$var$Ai(a, b) {
    $29ecc58491fb6f0d$var$Jh = $29ecc58491fb6f0d$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $29ecc58491fb6f0d$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $29ecc58491fb6f0d$var$Cc(a, c);
    }
}
var $29ecc58491fb6f0d$var$Rh = {
    readContext: $29ecc58491fb6f0d$var$eh,
    useCallback: $29ecc58491fb6f0d$var$P,
    useContext: $29ecc58491fb6f0d$var$P,
    useEffect: $29ecc58491fb6f0d$var$P,
    useImperativeHandle: $29ecc58491fb6f0d$var$P,
    useInsertionEffect: $29ecc58491fb6f0d$var$P,
    useLayoutEffect: $29ecc58491fb6f0d$var$P,
    useMemo: $29ecc58491fb6f0d$var$P,
    useReducer: $29ecc58491fb6f0d$var$P,
    useRef: $29ecc58491fb6f0d$var$P,
    useState: $29ecc58491fb6f0d$var$P,
    useDebugValue: $29ecc58491fb6f0d$var$P,
    useDeferredValue: $29ecc58491fb6f0d$var$P,
    useTransition: $29ecc58491fb6f0d$var$P,
    useMutableSource: $29ecc58491fb6f0d$var$P,
    useSyncExternalStore: $29ecc58491fb6f0d$var$P,
    useId: $29ecc58491fb6f0d$var$P,
    unstable_isNewReconciler: !1
}, $29ecc58491fb6f0d$var$Oh = {
    readContext: $29ecc58491fb6f0d$var$eh,
    useCallback: function(a, b) {
        $29ecc58491fb6f0d$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $29ecc58491fb6f0d$var$eh,
    useEffect: $29ecc58491fb6f0d$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $29ecc58491fb6f0d$var$ki(4194308, 4, $29ecc58491fb6f0d$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $29ecc58491fb6f0d$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $29ecc58491fb6f0d$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $29ecc58491fb6f0d$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $29ecc58491fb6f0d$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $29ecc58491fb6f0d$var$xi.bind(null, $29ecc58491fb6f0d$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $29ecc58491fb6f0d$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $29ecc58491fb6f0d$var$hi,
    useDebugValue: $29ecc58491fb6f0d$var$ri,
    useDeferredValue: function(a) {
        return $29ecc58491fb6f0d$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $29ecc58491fb6f0d$var$hi(!1), b = a[0];
        a = $29ecc58491fb6f0d$var$vi.bind(null, a[1]);
        $29ecc58491fb6f0d$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $29ecc58491fb6f0d$var$M, e = $29ecc58491fb6f0d$var$Th();
        if ($29ecc58491fb6f0d$var$I) {
            if (void 0 === c) throw Error($29ecc58491fb6f0d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $29ecc58491fb6f0d$var$Q) throw Error($29ecc58491fb6f0d$var$p(349));
            0 !== ($29ecc58491fb6f0d$var$Hh & 30) || $29ecc58491fb6f0d$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $29ecc58491fb6f0d$var$mi($29ecc58491fb6f0d$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $29ecc58491fb6f0d$var$bi(9, $29ecc58491fb6f0d$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $29ecc58491fb6f0d$var$Th(), b = $29ecc58491fb6f0d$var$Q.identifierPrefix;
        if ($29ecc58491fb6f0d$var$I) {
            var c = $29ecc58491fb6f0d$var$sg;
            var d = $29ecc58491fb6f0d$var$rg;
            c = (d & ~(1 << 32 - $29ecc58491fb6f0d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $29ecc58491fb6f0d$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $29ecc58491fb6f0d$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $29ecc58491fb6f0d$var$Ph = {
    readContext: $29ecc58491fb6f0d$var$eh,
    useCallback: $29ecc58491fb6f0d$var$si,
    useContext: $29ecc58491fb6f0d$var$eh,
    useEffect: $29ecc58491fb6f0d$var$$h,
    useImperativeHandle: $29ecc58491fb6f0d$var$qi,
    useInsertionEffect: $29ecc58491fb6f0d$var$ni,
    useLayoutEffect: $29ecc58491fb6f0d$var$oi,
    useMemo: $29ecc58491fb6f0d$var$ti,
    useReducer: $29ecc58491fb6f0d$var$Wh,
    useRef: $29ecc58491fb6f0d$var$ji,
    useState: function() {
        return $29ecc58491fb6f0d$var$Wh($29ecc58491fb6f0d$var$Vh);
    },
    useDebugValue: $29ecc58491fb6f0d$var$ri,
    useDeferredValue: function(a) {
        var b = $29ecc58491fb6f0d$var$Uh();
        return $29ecc58491fb6f0d$var$ui(b, $29ecc58491fb6f0d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $29ecc58491fb6f0d$var$Wh($29ecc58491fb6f0d$var$Vh)[0], b = $29ecc58491fb6f0d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $29ecc58491fb6f0d$var$Yh,
    useSyncExternalStore: $29ecc58491fb6f0d$var$Zh,
    useId: $29ecc58491fb6f0d$var$wi,
    unstable_isNewReconciler: !1
}, $29ecc58491fb6f0d$var$Qh = {
    readContext: $29ecc58491fb6f0d$var$eh,
    useCallback: $29ecc58491fb6f0d$var$si,
    useContext: $29ecc58491fb6f0d$var$eh,
    useEffect: $29ecc58491fb6f0d$var$$h,
    useImperativeHandle: $29ecc58491fb6f0d$var$qi,
    useInsertionEffect: $29ecc58491fb6f0d$var$ni,
    useLayoutEffect: $29ecc58491fb6f0d$var$oi,
    useMemo: $29ecc58491fb6f0d$var$ti,
    useReducer: $29ecc58491fb6f0d$var$Xh,
    useRef: $29ecc58491fb6f0d$var$ji,
    useState: function() {
        return $29ecc58491fb6f0d$var$Xh($29ecc58491fb6f0d$var$Vh);
    },
    useDebugValue: $29ecc58491fb6f0d$var$ri,
    useDeferredValue: function(a) {
        var b = $29ecc58491fb6f0d$var$Uh();
        return null === $29ecc58491fb6f0d$var$N ? b.memoizedState = a : $29ecc58491fb6f0d$var$ui(b, $29ecc58491fb6f0d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $29ecc58491fb6f0d$var$Xh($29ecc58491fb6f0d$var$Vh)[0], b = $29ecc58491fb6f0d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $29ecc58491fb6f0d$var$Yh,
    useSyncExternalStore: $29ecc58491fb6f0d$var$Zh,
    useId: $29ecc58491fb6f0d$var$wi,
    unstable_isNewReconciler: !1
};
function $29ecc58491fb6f0d$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $29ecc58491fb6f0d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $29ecc58491fb6f0d$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $29ecc58491fb6f0d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $29ecc58491fb6f0d$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $29ecc58491fb6f0d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $29ecc58491fb6f0d$var$R(), e = $29ecc58491fb6f0d$var$yi(a), f = $29ecc58491fb6f0d$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $29ecc58491fb6f0d$var$nh(a, f, e);
        null !== b && ($29ecc58491fb6f0d$var$gi(b, a, e, d), $29ecc58491fb6f0d$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $29ecc58491fb6f0d$var$R(), e = $29ecc58491fb6f0d$var$yi(a), f = $29ecc58491fb6f0d$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $29ecc58491fb6f0d$var$nh(a, f, e);
        null !== b && ($29ecc58491fb6f0d$var$gi(b, a, e, d), $29ecc58491fb6f0d$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $29ecc58491fb6f0d$var$R(), d = $29ecc58491fb6f0d$var$yi(a), e = $29ecc58491fb6f0d$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $29ecc58491fb6f0d$var$nh(a, e, d);
        null !== b && ($29ecc58491fb6f0d$var$gi(b, a, d, c), $29ecc58491fb6f0d$var$oh(b, a, d));
    }
};
function $29ecc58491fb6f0d$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$29ecc58491fb6f0d$var$Ie(c, d) || !$29ecc58491fb6f0d$var$Ie(e, f) : !0;
}
function $29ecc58491fb6f0d$var$Gi(a, b, c) {
    var d = !1, e = $29ecc58491fb6f0d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $29ecc58491fb6f0d$var$eh(f) : (e = $29ecc58491fb6f0d$var$Zf(b) ? $29ecc58491fb6f0d$var$Xf : $29ecc58491fb6f0d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $29ecc58491fb6f0d$var$Yf(a, e) : $29ecc58491fb6f0d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $29ecc58491fb6f0d$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $29ecc58491fb6f0d$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $29ecc58491fb6f0d$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $29ecc58491fb6f0d$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $29ecc58491fb6f0d$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $29ecc58491fb6f0d$var$eh(f) : (f = $29ecc58491fb6f0d$var$Zf(b) ? $29ecc58491fb6f0d$var$Xf : $29ecc58491fb6f0d$var$H.current, e.context = $29ecc58491fb6f0d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($29ecc58491fb6f0d$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $29ecc58491fb6f0d$var$Ei.enqueueReplaceState(e, e.state, null), $29ecc58491fb6f0d$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $29ecc58491fb6f0d$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $29ecc58491fb6f0d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $29ecc58491fb6f0d$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $29ecc58491fb6f0d$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $29ecc58491fb6f0d$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $29ecc58491fb6f0d$var$Ni(a, b, c) {
    c = $29ecc58491fb6f0d$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $29ecc58491fb6f0d$var$Oi || ($29ecc58491fb6f0d$var$Oi = !0, $29ecc58491fb6f0d$var$Pi = d);
        $29ecc58491fb6f0d$var$Li(a, b);
    };
    return c;
}
function $29ecc58491fb6f0d$var$Qi(a, b, c) {
    c = $29ecc58491fb6f0d$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $29ecc58491fb6f0d$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $29ecc58491fb6f0d$var$Li(a, b);
        "function" !== typeof d && (null === $29ecc58491fb6f0d$var$Ri ? $29ecc58491fb6f0d$var$Ri = new Set([
            this
        ]) : $29ecc58491fb6f0d$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $29ecc58491fb6f0d$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $29ecc58491fb6f0d$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $29ecc58491fb6f0d$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $29ecc58491fb6f0d$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $29ecc58491fb6f0d$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $29ecc58491fb6f0d$var$mh(-1, 1), b.tag = 2, $29ecc58491fb6f0d$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $29ecc58491fb6f0d$var$Wi = $29ecc58491fb6f0d$var$ua.ReactCurrentOwner, $29ecc58491fb6f0d$var$dh = !1;
function $29ecc58491fb6f0d$var$Xi(a, b, c, d) {
    b.child = null === a ? $29ecc58491fb6f0d$var$Vg(b, null, c, d) : $29ecc58491fb6f0d$var$Ug(b, a.child, c, d);
}
function $29ecc58491fb6f0d$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $29ecc58491fb6f0d$var$ch(b, e);
    d = $29ecc58491fb6f0d$var$Nh(a, b, c, d, f, e);
    c = $29ecc58491fb6f0d$var$Sh();
    if (null !== a && !$29ecc58491fb6f0d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $29ecc58491fb6f0d$var$Zi(a, b, e);
    $29ecc58491fb6f0d$var$I && c && $29ecc58491fb6f0d$var$vg(b);
    b.flags |= 1;
    $29ecc58491fb6f0d$var$Xi(a, b, d, e);
    return b.child;
}
function $29ecc58491fb6f0d$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$29ecc58491fb6f0d$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $29ecc58491fb6f0d$var$bj(a, b, f, d, e);
        a = $29ecc58491fb6f0d$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $29ecc58491fb6f0d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $29ecc58491fb6f0d$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $29ecc58491fb6f0d$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $29ecc58491fb6f0d$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($29ecc58491fb6f0d$var$Ie(f, d) && a.ref === b.ref) {
            if ($29ecc58491fb6f0d$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($29ecc58491fb6f0d$var$dh = !0);
            else return b.lanes = a.lanes, $29ecc58491fb6f0d$var$Zi(a, b, e);
        }
    }
    return $29ecc58491fb6f0d$var$cj(a, b, c, d, e);
}
function $29ecc58491fb6f0d$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$ej, $29ecc58491fb6f0d$var$fj), $29ecc58491fb6f0d$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$ej, $29ecc58491fb6f0d$var$fj), $29ecc58491fb6f0d$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$ej, $29ecc58491fb6f0d$var$fj);
            $29ecc58491fb6f0d$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$ej, $29ecc58491fb6f0d$var$fj), $29ecc58491fb6f0d$var$fj |= d;
    $29ecc58491fb6f0d$var$Xi(a, b, e, c);
    return b.child;
}
function $29ecc58491fb6f0d$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $29ecc58491fb6f0d$var$cj(a, b, c, d, e) {
    var f = $29ecc58491fb6f0d$var$Zf(c) ? $29ecc58491fb6f0d$var$Xf : $29ecc58491fb6f0d$var$H.current;
    f = $29ecc58491fb6f0d$var$Yf(b, f);
    $29ecc58491fb6f0d$var$ch(b, e);
    c = $29ecc58491fb6f0d$var$Nh(a, b, c, d, f, e);
    d = $29ecc58491fb6f0d$var$Sh();
    if (null !== a && !$29ecc58491fb6f0d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $29ecc58491fb6f0d$var$Zi(a, b, e);
    $29ecc58491fb6f0d$var$I && d && $29ecc58491fb6f0d$var$vg(b);
    b.flags |= 1;
    $29ecc58491fb6f0d$var$Xi(a, b, c, e);
    return b.child;
}
function $29ecc58491fb6f0d$var$hj(a, b, c, d, e) {
    if ($29ecc58491fb6f0d$var$Zf(c)) {
        var f = !0;
        $29ecc58491fb6f0d$var$cg(b);
    } else f = !1;
    $29ecc58491fb6f0d$var$ch(b, e);
    if (null === b.stateNode) $29ecc58491fb6f0d$var$ij(a, b), $29ecc58491fb6f0d$var$Gi(b, c, d), $29ecc58491fb6f0d$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $29ecc58491fb6f0d$var$eh(l) : (l = $29ecc58491fb6f0d$var$Zf(c) ? $29ecc58491fb6f0d$var$Xf : $29ecc58491fb6f0d$var$H.current, l = $29ecc58491fb6f0d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $29ecc58491fb6f0d$var$Hi(b, g, d, l);
        $29ecc58491fb6f0d$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $29ecc58491fb6f0d$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $29ecc58491fb6f0d$var$Wf.current || $29ecc58491fb6f0d$var$jh ? ("function" === typeof m && ($29ecc58491fb6f0d$var$Di(b, c, m, d), k = b.memoizedState), (h = $29ecc58491fb6f0d$var$jh || $29ecc58491fb6f0d$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $29ecc58491fb6f0d$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $29ecc58491fb6f0d$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $29ecc58491fb6f0d$var$eh(k) : (k = $29ecc58491fb6f0d$var$Zf(c) ? $29ecc58491fb6f0d$var$Xf : $29ecc58491fb6f0d$var$H.current, k = $29ecc58491fb6f0d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $29ecc58491fb6f0d$var$Hi(b, g, d, k);
        $29ecc58491fb6f0d$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $29ecc58491fb6f0d$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $29ecc58491fb6f0d$var$Wf.current || $29ecc58491fb6f0d$var$jh ? ("function" === typeof y && ($29ecc58491fb6f0d$var$Di(b, c, y, d), n = b.memoizedState), (l = $29ecc58491fb6f0d$var$jh || $29ecc58491fb6f0d$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $29ecc58491fb6f0d$var$jj(a, b, c, d, f, e);
}
function $29ecc58491fb6f0d$var$jj(a, b, c, d, e, f) {
    $29ecc58491fb6f0d$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $29ecc58491fb6f0d$var$dg(b, c, !1), $29ecc58491fb6f0d$var$Zi(a, b, f);
    d = b.stateNode;
    $29ecc58491fb6f0d$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $29ecc58491fb6f0d$var$Ug(b, a.child, null, f), b.child = $29ecc58491fb6f0d$var$Ug(b, null, h, f)) : $29ecc58491fb6f0d$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $29ecc58491fb6f0d$var$dg(b, c, !0);
    return b.child;
}
function $29ecc58491fb6f0d$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $29ecc58491fb6f0d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $29ecc58491fb6f0d$var$ag(a, b.context, !1);
    $29ecc58491fb6f0d$var$yh(a, b.containerInfo);
}
function $29ecc58491fb6f0d$var$lj(a, b, c, d, e) {
    $29ecc58491fb6f0d$var$Ig();
    $29ecc58491fb6f0d$var$Jg(e);
    b.flags |= 256;
    $29ecc58491fb6f0d$var$Xi(a, b, c, d);
    return b.child;
}
var $29ecc58491fb6f0d$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $29ecc58491fb6f0d$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $29ecc58491fb6f0d$var$oj(a, b, c) {
    var d = b.pendingProps, e = $29ecc58491fb6f0d$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, e & 1);
    if (null === a) {
        $29ecc58491fb6f0d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $29ecc58491fb6f0d$var$pj(g, d, 0, null), a = $29ecc58491fb6f0d$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $29ecc58491fb6f0d$var$nj(c), b.memoizedState = $29ecc58491fb6f0d$var$mj, a) : $29ecc58491fb6f0d$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $29ecc58491fb6f0d$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $29ecc58491fb6f0d$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $29ecc58491fb6f0d$var$Pg(h, f) : (f = $29ecc58491fb6f0d$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $29ecc58491fb6f0d$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $29ecc58491fb6f0d$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $29ecc58491fb6f0d$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $29ecc58491fb6f0d$var$qj(a, b) {
    b = $29ecc58491fb6f0d$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $29ecc58491fb6f0d$var$sj(a, b, c, d) {
    null !== d && $29ecc58491fb6f0d$var$Jg(d);
    $29ecc58491fb6f0d$var$Ug(b, a.child, null, c);
    a = $29ecc58491fb6f0d$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $29ecc58491fb6f0d$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $29ecc58491fb6f0d$var$Ki(Error($29ecc58491fb6f0d$var$p(422))), $29ecc58491fb6f0d$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $29ecc58491fb6f0d$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $29ecc58491fb6f0d$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $29ecc58491fb6f0d$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $29ecc58491fb6f0d$var$nj(g);
        b.memoizedState = $29ecc58491fb6f0d$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $29ecc58491fb6f0d$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($29ecc58491fb6f0d$var$p(419));
        d = $29ecc58491fb6f0d$var$Ki(f, d, void 0);
        return $29ecc58491fb6f0d$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($29ecc58491fb6f0d$var$dh || h) {
        d = $29ecc58491fb6f0d$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $29ecc58491fb6f0d$var$ih(a, e), $29ecc58491fb6f0d$var$gi(d, a, e, -1));
        }
        $29ecc58491fb6f0d$var$tj();
        d = $29ecc58491fb6f0d$var$Ki(Error($29ecc58491fb6f0d$var$p(421)));
        return $29ecc58491fb6f0d$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $29ecc58491fb6f0d$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $29ecc58491fb6f0d$var$yg = $29ecc58491fb6f0d$var$Lf(e.nextSibling);
    $29ecc58491fb6f0d$var$xg = b;
    $29ecc58491fb6f0d$var$I = !0;
    $29ecc58491fb6f0d$var$zg = null;
    null !== a && ($29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg++] = $29ecc58491fb6f0d$var$rg, $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg++] = $29ecc58491fb6f0d$var$sg, $29ecc58491fb6f0d$var$og[$29ecc58491fb6f0d$var$pg++] = $29ecc58491fb6f0d$var$qg, $29ecc58491fb6f0d$var$rg = a.id, $29ecc58491fb6f0d$var$sg = a.overflow, $29ecc58491fb6f0d$var$qg = b);
    b = $29ecc58491fb6f0d$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $29ecc58491fb6f0d$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $29ecc58491fb6f0d$var$bh(a.return, b, c);
}
function $29ecc58491fb6f0d$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $29ecc58491fb6f0d$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $29ecc58491fb6f0d$var$Xi(a, b, d.children, c);
    d = $29ecc58491fb6f0d$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $29ecc58491fb6f0d$var$vj(a, c, b);
            else if (19 === a.tag) $29ecc58491fb6f0d$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $29ecc58491fb6f0d$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $29ecc58491fb6f0d$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $29ecc58491fb6f0d$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $29ecc58491fb6f0d$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $29ecc58491fb6f0d$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $29ecc58491fb6f0d$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $29ecc58491fb6f0d$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $29ecc58491fb6f0d$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($29ecc58491fb6f0d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $29ecc58491fb6f0d$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $29ecc58491fb6f0d$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $29ecc58491fb6f0d$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $29ecc58491fb6f0d$var$kj(b);
            $29ecc58491fb6f0d$var$Ig();
            break;
        case 5:
            $29ecc58491fb6f0d$var$Ah(b);
            break;
        case 1:
            $29ecc58491fb6f0d$var$Zf(b.type) && $29ecc58491fb6f0d$var$cg(b);
            break;
        case 4:
            $29ecc58491fb6f0d$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, $29ecc58491fb6f0d$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $29ecc58491fb6f0d$var$oj(a, b, c);
                $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, $29ecc58491fb6f0d$var$L.current & 1);
                a = $29ecc58491fb6f0d$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, $29ecc58491fb6f0d$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $29ecc58491fb6f0d$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, $29ecc58491fb6f0d$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $29ecc58491fb6f0d$var$dj(a, b, c);
    }
    return $29ecc58491fb6f0d$var$Zi(a, b, c);
}
var $29ecc58491fb6f0d$var$zj, $29ecc58491fb6f0d$var$Aj, $29ecc58491fb6f0d$var$Bj, $29ecc58491fb6f0d$var$Cj;
$29ecc58491fb6f0d$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$29ecc58491fb6f0d$var$Aj = function() {};
$29ecc58491fb6f0d$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $29ecc58491fb6f0d$var$Ya(a, e);
                d = $29ecc58491fb6f0d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $29ecc58491fb6f0d$var$A({}, e, {
                    value: void 0
                });
                d = $29ecc58491fb6f0d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $29ecc58491fb6f0d$var$gb(a, e);
                d = $29ecc58491fb6f0d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $29ecc58491fb6f0d$var$Bf);
        }
        $29ecc58491fb6f0d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($29ecc58491fb6f0d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($29ecc58491fb6f0d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $29ecc58491fb6f0d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$29ecc58491fb6f0d$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $29ecc58491fb6f0d$var$Dj(a, b) {
    if (!$29ecc58491fb6f0d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $29ecc58491fb6f0d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $29ecc58491fb6f0d$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $29ecc58491fb6f0d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $29ecc58491fb6f0d$var$S(b), null;
        case 1:
            return $29ecc58491fb6f0d$var$Zf(b.type) && $29ecc58491fb6f0d$var$$f(), $29ecc58491fb6f0d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $29ecc58491fb6f0d$var$zh();
            $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wf);
            $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$H);
            $29ecc58491fb6f0d$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $29ecc58491fb6f0d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $29ecc58491fb6f0d$var$zg && ($29ecc58491fb6f0d$var$Fj($29ecc58491fb6f0d$var$zg), $29ecc58491fb6f0d$var$zg = null));
            $29ecc58491fb6f0d$var$Aj(a, b);
            $29ecc58491fb6f0d$var$S(b);
            return null;
        case 5:
            $29ecc58491fb6f0d$var$Bh(b);
            var e = $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $29ecc58491fb6f0d$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($29ecc58491fb6f0d$var$p(166));
                    $29ecc58491fb6f0d$var$S(b);
                    return null;
                }
                a = $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$uh.current);
                if ($29ecc58491fb6f0d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$29ecc58491fb6f0d$var$Of] = b;
                    d[$29ecc58491fb6f0d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $29ecc58491fb6f0d$var$D("cancel", d);
                            $29ecc58491fb6f0d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $29ecc58491fb6f0d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $29ecc58491fb6f0d$var$lf.length; e++)$29ecc58491fb6f0d$var$D($29ecc58491fb6f0d$var$lf[e], d);
                            break;
                        case "source":
                            $29ecc58491fb6f0d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $29ecc58491fb6f0d$var$D("error", d);
                            $29ecc58491fb6f0d$var$D("load", d);
                            break;
                        case "details":
                            $29ecc58491fb6f0d$var$D("toggle", d);
                            break;
                        case "input":
                            $29ecc58491fb6f0d$var$Za(d, f);
                            $29ecc58491fb6f0d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $29ecc58491fb6f0d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $29ecc58491fb6f0d$var$hb(d, f), $29ecc58491fb6f0d$var$D("invalid", d);
                    }
                    $29ecc58491fb6f0d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $29ecc58491fb6f0d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $29ecc58491fb6f0d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $29ecc58491fb6f0d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $29ecc58491fb6f0d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $29ecc58491fb6f0d$var$Va(d);
                            $29ecc58491fb6f0d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $29ecc58491fb6f0d$var$Va(d);
                            $29ecc58491fb6f0d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $29ecc58491fb6f0d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $29ecc58491fb6f0d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$29ecc58491fb6f0d$var$Of] = b;
                    a[$29ecc58491fb6f0d$var$Pf] = d;
                    $29ecc58491fb6f0d$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $29ecc58491fb6f0d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $29ecc58491fb6f0d$var$D("cancel", a);
                                $29ecc58491fb6f0d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $29ecc58491fb6f0d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $29ecc58491fb6f0d$var$lf.length; e++)$29ecc58491fb6f0d$var$D($29ecc58491fb6f0d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $29ecc58491fb6f0d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $29ecc58491fb6f0d$var$D("error", a);
                                $29ecc58491fb6f0d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $29ecc58491fb6f0d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $29ecc58491fb6f0d$var$Za(a, d);
                                e = $29ecc58491fb6f0d$var$Ya(a, d);
                                $29ecc58491fb6f0d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $29ecc58491fb6f0d$var$A({}, d, {
                                    value: void 0
                                });
                                $29ecc58491fb6f0d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $29ecc58491fb6f0d$var$hb(a, d);
                                e = $29ecc58491fb6f0d$var$gb(a, d);
                                $29ecc58491fb6f0d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $29ecc58491fb6f0d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $29ecc58491fb6f0d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $29ecc58491fb6f0d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $29ecc58491fb6f0d$var$ob(a, k) : "number" === typeof k && $29ecc58491fb6f0d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($29ecc58491fb6f0d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $29ecc58491fb6f0d$var$D("scroll", a) : null != k && $29ecc58491fb6f0d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $29ecc58491fb6f0d$var$Va(a);
                                $29ecc58491fb6f0d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $29ecc58491fb6f0d$var$Va(a);
                                $29ecc58491fb6f0d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $29ecc58491fb6f0d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $29ecc58491fb6f0d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $29ecc58491fb6f0d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $29ecc58491fb6f0d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $29ecc58491fb6f0d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $29ecc58491fb6f0d$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($29ecc58491fb6f0d$var$p(166));
                c = $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$wh.current);
                $29ecc58491fb6f0d$var$xh($29ecc58491fb6f0d$var$uh.current);
                if ($29ecc58491fb6f0d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$29ecc58491fb6f0d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $29ecc58491fb6f0d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $29ecc58491fb6f0d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $29ecc58491fb6f0d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$29ecc58491fb6f0d$var$Of] = b, b.stateNode = d;
            }
            $29ecc58491fb6f0d$var$S(b);
            return null;
        case 13:
            $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($29ecc58491fb6f0d$var$I && null !== $29ecc58491fb6f0d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $29ecc58491fb6f0d$var$Hg(), $29ecc58491fb6f0d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $29ecc58491fb6f0d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($29ecc58491fb6f0d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($29ecc58491fb6f0d$var$p(317));
                        f[$29ecc58491fb6f0d$var$Of] = b;
                    } else $29ecc58491fb6f0d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $29ecc58491fb6f0d$var$S(b);
                    f = !1;
                } else null !== $29ecc58491fb6f0d$var$zg && ($29ecc58491fb6f0d$var$Fj($29ecc58491fb6f0d$var$zg), $29ecc58491fb6f0d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($29ecc58491fb6f0d$var$L.current & 1) ? 0 === $29ecc58491fb6f0d$var$T && ($29ecc58491fb6f0d$var$T = 3) : $29ecc58491fb6f0d$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $29ecc58491fb6f0d$var$S(b);
            return null;
        case 4:
            return $29ecc58491fb6f0d$var$zh(), $29ecc58491fb6f0d$var$Aj(a, b), null === a && $29ecc58491fb6f0d$var$sf(b.stateNode.containerInfo), $29ecc58491fb6f0d$var$S(b), null;
        case 10:
            return $29ecc58491fb6f0d$var$ah(b.type._context), $29ecc58491fb6f0d$var$S(b), null;
        case 17:
            return $29ecc58491fb6f0d$var$Zf(b.type) && $29ecc58491fb6f0d$var$$f(), $29ecc58491fb6f0d$var$S(b), null;
        case 19:
            $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$L);
            f = b.memoizedState;
            if (null === f) return $29ecc58491fb6f0d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $29ecc58491fb6f0d$var$Dj(f, !1);
                else {
                    if (0 !== $29ecc58491fb6f0d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $29ecc58491fb6f0d$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $29ecc58491fb6f0d$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, $29ecc58491fb6f0d$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $29ecc58491fb6f0d$var$B() > $29ecc58491fb6f0d$var$Gj && (b.flags |= 128, d = !0, $29ecc58491fb6f0d$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $29ecc58491fb6f0d$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $29ecc58491fb6f0d$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$29ecc58491fb6f0d$var$I) return $29ecc58491fb6f0d$var$S(b), null;
                    } else 2 * $29ecc58491fb6f0d$var$B() - f.renderingStartTime > $29ecc58491fb6f0d$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $29ecc58491fb6f0d$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $29ecc58491fb6f0d$var$B(), b.sibling = null, c = $29ecc58491fb6f0d$var$L.current, $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$L, d ? c & 1 | 2 : c & 1), b;
            $29ecc58491fb6f0d$var$S(b);
            return null;
        case 22:
        case 23:
            return $29ecc58491fb6f0d$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($29ecc58491fb6f0d$var$fj & 1073741824) && ($29ecc58491fb6f0d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $29ecc58491fb6f0d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($29ecc58491fb6f0d$var$p(156, b.tag));
}
function $29ecc58491fb6f0d$var$Ij(a, b) {
    $29ecc58491fb6f0d$var$wg(b);
    switch(b.tag){
        case 1:
            return $29ecc58491fb6f0d$var$Zf(b.type) && $29ecc58491fb6f0d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $29ecc58491fb6f0d$var$zh(), $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wf), $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$H), $29ecc58491fb6f0d$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $29ecc58491fb6f0d$var$Bh(b), null;
        case 13:
            $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($29ecc58491fb6f0d$var$p(340));
                $29ecc58491fb6f0d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$L), null;
        case 4:
            return $29ecc58491fb6f0d$var$zh(), null;
        case 10:
            return $29ecc58491fb6f0d$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $29ecc58491fb6f0d$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $29ecc58491fb6f0d$var$Jj = !1, $29ecc58491fb6f0d$var$U = !1, $29ecc58491fb6f0d$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $29ecc58491fb6f0d$var$V = null;
function $29ecc58491fb6f0d$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $29ecc58491fb6f0d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $29ecc58491fb6f0d$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $29ecc58491fb6f0d$var$W(a, b, d);
    }
}
var $29ecc58491fb6f0d$var$Nj = !1;
function $29ecc58491fb6f0d$var$Oj(a, b) {
    $29ecc58491fb6f0d$var$Cf = $29ecc58491fb6f0d$var$dd;
    a = $29ecc58491fb6f0d$var$Me();
    if ($29ecc58491fb6f0d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $29ecc58491fb6f0d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $29ecc58491fb6f0d$var$dd = !1;
    for($29ecc58491fb6f0d$var$V = b; null !== $29ecc58491fb6f0d$var$V;)if (b = $29ecc58491fb6f0d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $29ecc58491fb6f0d$var$V = a;
    else for(; null !== $29ecc58491fb6f0d$var$V;){
        b = $29ecc58491fb6f0d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $29ecc58491fb6f0d$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($29ecc58491fb6f0d$var$p(163));
            }
        } catch (F) {
            $29ecc58491fb6f0d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $29ecc58491fb6f0d$var$V = a;
            break;
        }
        $29ecc58491fb6f0d$var$V = b.return;
    }
    n = $29ecc58491fb6f0d$var$Nj;
    $29ecc58491fb6f0d$var$Nj = !1;
    return n;
}
function $29ecc58491fb6f0d$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $29ecc58491fb6f0d$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $29ecc58491fb6f0d$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $29ecc58491fb6f0d$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $29ecc58491fb6f0d$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $29ecc58491fb6f0d$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$29ecc58491fb6f0d$var$Of], delete b[$29ecc58491fb6f0d$var$Pf], delete b[$29ecc58491fb6f0d$var$of], delete b[$29ecc58491fb6f0d$var$Qf], delete b[$29ecc58491fb6f0d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $29ecc58491fb6f0d$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $29ecc58491fb6f0d$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $29ecc58491fb6f0d$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $29ecc58491fb6f0d$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $29ecc58491fb6f0d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($29ecc58491fb6f0d$var$Vj(a, b, c), a = a.sibling; null !== a;)$29ecc58491fb6f0d$var$Vj(a, b, c), a = a.sibling;
}
function $29ecc58491fb6f0d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($29ecc58491fb6f0d$var$Wj(a, b, c), a = a.sibling; null !== a;)$29ecc58491fb6f0d$var$Wj(a, b, c), a = a.sibling;
}
var $29ecc58491fb6f0d$var$X = null, $29ecc58491fb6f0d$var$Xj = !1;
function $29ecc58491fb6f0d$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$29ecc58491fb6f0d$var$Zj(a, b, c), c = c.sibling;
}
function $29ecc58491fb6f0d$var$Zj(a, b, c) {
    if ($29ecc58491fb6f0d$var$lc && "function" === typeof $29ecc58491fb6f0d$var$lc.onCommitFiberUnmount) try {
        $29ecc58491fb6f0d$var$lc.onCommitFiberUnmount($29ecc58491fb6f0d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $29ecc58491fb6f0d$var$U || $29ecc58491fb6f0d$var$Lj(c, b);
        case 6:
            var d = $29ecc58491fb6f0d$var$X, e = $29ecc58491fb6f0d$var$Xj;
            $29ecc58491fb6f0d$var$X = null;
            $29ecc58491fb6f0d$var$Yj(a, b, c);
            $29ecc58491fb6f0d$var$X = d;
            $29ecc58491fb6f0d$var$Xj = e;
            null !== $29ecc58491fb6f0d$var$X && ($29ecc58491fb6f0d$var$Xj ? (a = $29ecc58491fb6f0d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $29ecc58491fb6f0d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $29ecc58491fb6f0d$var$X && ($29ecc58491fb6f0d$var$Xj ? (a = $29ecc58491fb6f0d$var$X, c = c.stateNode, 8 === a.nodeType ? $29ecc58491fb6f0d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $29ecc58491fb6f0d$var$Kf(a, c), $29ecc58491fb6f0d$var$bd(a)) : $29ecc58491fb6f0d$var$Kf($29ecc58491fb6f0d$var$X, c.stateNode));
            break;
        case 4:
            d = $29ecc58491fb6f0d$var$X;
            e = $29ecc58491fb6f0d$var$Xj;
            $29ecc58491fb6f0d$var$X = c.stateNode.containerInfo;
            $29ecc58491fb6f0d$var$Xj = !0;
            $29ecc58491fb6f0d$var$Yj(a, b, c);
            $29ecc58491fb6f0d$var$X = d;
            $29ecc58491fb6f0d$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$29ecc58491fb6f0d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $29ecc58491fb6f0d$var$Mj(c, b, g) : 0 !== (f & 4) && $29ecc58491fb6f0d$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $29ecc58491fb6f0d$var$Yj(a, b, c);
            break;
        case 1:
            if (!$29ecc58491fb6f0d$var$U && ($29ecc58491fb6f0d$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $29ecc58491fb6f0d$var$W(c, b, h);
            }
            $29ecc58491fb6f0d$var$Yj(a, b, c);
            break;
        case 21:
            $29ecc58491fb6f0d$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($29ecc58491fb6f0d$var$U = (d = $29ecc58491fb6f0d$var$U) || null !== c.memoizedState, $29ecc58491fb6f0d$var$Yj(a, b, c), $29ecc58491fb6f0d$var$U = d) : $29ecc58491fb6f0d$var$Yj(a, b, c);
            break;
        default:
            $29ecc58491fb6f0d$var$Yj(a, b, c);
    }
}
function $29ecc58491fb6f0d$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $29ecc58491fb6f0d$var$Kj);
        b.forEach(function(b) {
            var d = $29ecc58491fb6f0d$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $29ecc58491fb6f0d$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $29ecc58491fb6f0d$var$X = h.stateNode;
                        $29ecc58491fb6f0d$var$Xj = !1;
                        break a;
                    case 3:
                        $29ecc58491fb6f0d$var$X = h.stateNode.containerInfo;
                        $29ecc58491fb6f0d$var$Xj = !0;
                        break a;
                    case 4:
                        $29ecc58491fb6f0d$var$X = h.stateNode.containerInfo;
                        $29ecc58491fb6f0d$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $29ecc58491fb6f0d$var$X) throw Error($29ecc58491fb6f0d$var$p(160));
            $29ecc58491fb6f0d$var$Zj(f, g, e);
            $29ecc58491fb6f0d$var$X = null;
            $29ecc58491fb6f0d$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $29ecc58491fb6f0d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$29ecc58491fb6f0d$var$dk(b, a), b = b.sibling;
}
function $29ecc58491fb6f0d$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            if (d & 4) {
                try {
                    $29ecc58491fb6f0d$var$Pj(3, a, a.return), $29ecc58491fb6f0d$var$Qj(3, a);
                } catch (t) {
                    $29ecc58491fb6f0d$var$W(a, a.return, t);
                }
                try {
                    $29ecc58491fb6f0d$var$Pj(5, a, a.return);
                } catch (t) {
                    $29ecc58491fb6f0d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            d & 512 && null !== c && $29ecc58491fb6f0d$var$Lj(c, c.return);
            break;
        case 5:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            d & 512 && null !== c && $29ecc58491fb6f0d$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $29ecc58491fb6f0d$var$ob(e, "");
                } catch (t) {
                    $29ecc58491fb6f0d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $29ecc58491fb6f0d$var$ab(e, f);
                    $29ecc58491fb6f0d$var$vb(h, g);
                    var l = $29ecc58491fb6f0d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $29ecc58491fb6f0d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $29ecc58491fb6f0d$var$nb(e, q) : "children" === m ? $29ecc58491fb6f0d$var$ob(e, q) : $29ecc58491fb6f0d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $29ecc58491fb6f0d$var$bb(e, f);
                            break;
                        case "textarea":
                            $29ecc58491fb6f0d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $29ecc58491fb6f0d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $29ecc58491fb6f0d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $29ecc58491fb6f0d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$29ecc58491fb6f0d$var$Pf] = f;
                } catch (t) {
                    $29ecc58491fb6f0d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($29ecc58491fb6f0d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $29ecc58491fb6f0d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $29ecc58491fb6f0d$var$bd(b.containerInfo);
            } catch (t) {
                $29ecc58491fb6f0d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            break;
        case 13:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($29ecc58491fb6f0d$var$fk = $29ecc58491fb6f0d$var$B()));
            d & 4 && $29ecc58491fb6f0d$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($29ecc58491fb6f0d$var$U = (l = $29ecc58491fb6f0d$var$U) || m, $29ecc58491fb6f0d$var$ck(b, a), $29ecc58491fb6f0d$var$U = l) : $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($29ecc58491fb6f0d$var$V = a, m = a.child; null !== m;){
                    for(q = $29ecc58491fb6f0d$var$V = m; null !== $29ecc58491fb6f0d$var$V;){
                        r = $29ecc58491fb6f0d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $29ecc58491fb6f0d$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $29ecc58491fb6f0d$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $29ecc58491fb6f0d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $29ecc58491fb6f0d$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $29ecc58491fb6f0d$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $29ecc58491fb6f0d$var$V = y) : $29ecc58491fb6f0d$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $29ecc58491fb6f0d$var$rb("display", g));
                            } catch (t) {
                                $29ecc58491fb6f0d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $29ecc58491fb6f0d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $29ecc58491fb6f0d$var$ck(b, a);
            $29ecc58491fb6f0d$var$ek(a);
            d & 4 && $29ecc58491fb6f0d$var$ak(a);
            break;
        case 21:
            break;
        default:
            $29ecc58491fb6f0d$var$ck(b, a), $29ecc58491fb6f0d$var$ek(a);
    }
}
function $29ecc58491fb6f0d$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($29ecc58491fb6f0d$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($29ecc58491fb6f0d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($29ecc58491fb6f0d$var$ob(e, ""), d.flags &= -33);
                    var f = $29ecc58491fb6f0d$var$Uj(a);
                    $29ecc58491fb6f0d$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $29ecc58491fb6f0d$var$Uj(a);
                    $29ecc58491fb6f0d$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($29ecc58491fb6f0d$var$p(161));
            }
        } catch (k) {
            $29ecc58491fb6f0d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $29ecc58491fb6f0d$var$hk(a, b, c) {
    $29ecc58491fb6f0d$var$V = a;
    $29ecc58491fb6f0d$var$ik(a, b, c);
}
function $29ecc58491fb6f0d$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $29ecc58491fb6f0d$var$V;){
        var e = $29ecc58491fb6f0d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $29ecc58491fb6f0d$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $29ecc58491fb6f0d$var$U;
                h = $29ecc58491fb6f0d$var$Jj;
                var l = $29ecc58491fb6f0d$var$U;
                $29ecc58491fb6f0d$var$Jj = g;
                if (($29ecc58491fb6f0d$var$U = k) && !l) for($29ecc58491fb6f0d$var$V = e; null !== $29ecc58491fb6f0d$var$V;)g = $29ecc58491fb6f0d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $29ecc58491fb6f0d$var$jk(e) : null !== k ? (k.return = g, $29ecc58491fb6f0d$var$V = k) : $29ecc58491fb6f0d$var$jk(e);
                for(; null !== f;)$29ecc58491fb6f0d$var$V = f, $29ecc58491fb6f0d$var$ik(f, b, c), f = f.sibling;
                $29ecc58491fb6f0d$var$V = e;
                $29ecc58491fb6f0d$var$Jj = h;
                $29ecc58491fb6f0d$var$U = l;
            }
            $29ecc58491fb6f0d$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $29ecc58491fb6f0d$var$V = f) : $29ecc58491fb6f0d$var$kk(a, b, c);
    }
}
function $29ecc58491fb6f0d$var$kk(a) {
    for(; null !== $29ecc58491fb6f0d$var$V;){
        var b = $29ecc58491fb6f0d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $29ecc58491fb6f0d$var$U || $29ecc58491fb6f0d$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$29ecc58491fb6f0d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $29ecc58491fb6f0d$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $29ecc58491fb6f0d$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $29ecc58491fb6f0d$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $29ecc58491fb6f0d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($29ecc58491fb6f0d$var$p(163));
                }
                $29ecc58491fb6f0d$var$U || b.flags & 512 && $29ecc58491fb6f0d$var$Rj(b);
            } catch (r) {
                $29ecc58491fb6f0d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $29ecc58491fb6f0d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $29ecc58491fb6f0d$var$V = c;
            break;
        }
        $29ecc58491fb6f0d$var$V = b.return;
    }
}
function $29ecc58491fb6f0d$var$gk(a) {
    for(; null !== $29ecc58491fb6f0d$var$V;){
        var b = $29ecc58491fb6f0d$var$V;
        if (b === a) {
            $29ecc58491fb6f0d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $29ecc58491fb6f0d$var$V = c;
            break;
        }
        $29ecc58491fb6f0d$var$V = b.return;
    }
}
function $29ecc58491fb6f0d$var$jk(a) {
    for(; null !== $29ecc58491fb6f0d$var$V;){
        var b = $29ecc58491fb6f0d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $29ecc58491fb6f0d$var$Qj(4, b);
                    } catch (k) {
                        $29ecc58491fb6f0d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $29ecc58491fb6f0d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $29ecc58491fb6f0d$var$Rj(b);
                    } catch (k) {
                        $29ecc58491fb6f0d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $29ecc58491fb6f0d$var$Rj(b);
                    } catch (k) {
                        $29ecc58491fb6f0d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $29ecc58491fb6f0d$var$W(b, b.return, k);
        }
        if (b === a) {
            $29ecc58491fb6f0d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $29ecc58491fb6f0d$var$V = h;
            break;
        }
        $29ecc58491fb6f0d$var$V = b.return;
    }
}
var $29ecc58491fb6f0d$var$lk = Math.ceil, $29ecc58491fb6f0d$var$mk = $29ecc58491fb6f0d$var$ua.ReactCurrentDispatcher, $29ecc58491fb6f0d$var$nk = $29ecc58491fb6f0d$var$ua.ReactCurrentOwner, $29ecc58491fb6f0d$var$ok = $29ecc58491fb6f0d$var$ua.ReactCurrentBatchConfig, $29ecc58491fb6f0d$var$K = 0, $29ecc58491fb6f0d$var$Q = null, $29ecc58491fb6f0d$var$Y = null, $29ecc58491fb6f0d$var$Z = 0, $29ecc58491fb6f0d$var$fj = 0, $29ecc58491fb6f0d$var$ej = $29ecc58491fb6f0d$var$Uf(0), $29ecc58491fb6f0d$var$T = 0, $29ecc58491fb6f0d$var$pk = null, $29ecc58491fb6f0d$var$rh = 0, $29ecc58491fb6f0d$var$qk = 0, $29ecc58491fb6f0d$var$rk = 0, $29ecc58491fb6f0d$var$sk = null, $29ecc58491fb6f0d$var$tk = null, $29ecc58491fb6f0d$var$fk = 0, $29ecc58491fb6f0d$var$Gj = Infinity, $29ecc58491fb6f0d$var$uk = null, $29ecc58491fb6f0d$var$Oi = !1, $29ecc58491fb6f0d$var$Pi = null, $29ecc58491fb6f0d$var$Ri = null, $29ecc58491fb6f0d$var$vk = !1, $29ecc58491fb6f0d$var$wk = null, $29ecc58491fb6f0d$var$xk = 0, $29ecc58491fb6f0d$var$yk = 0, $29ecc58491fb6f0d$var$zk = null, $29ecc58491fb6f0d$var$Ak = -1, $29ecc58491fb6f0d$var$Bk = 0;
function $29ecc58491fb6f0d$var$R() {
    return 0 !== ($29ecc58491fb6f0d$var$K & 6) ? $29ecc58491fb6f0d$var$B() : -1 !== $29ecc58491fb6f0d$var$Ak ? $29ecc58491fb6f0d$var$Ak : $29ecc58491fb6f0d$var$Ak = $29ecc58491fb6f0d$var$B();
}
function $29ecc58491fb6f0d$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($29ecc58491fb6f0d$var$K & 2) && 0 !== $29ecc58491fb6f0d$var$Z) return $29ecc58491fb6f0d$var$Z & -$29ecc58491fb6f0d$var$Z;
    if (null !== $29ecc58491fb6f0d$var$Kg.transition) return 0 === $29ecc58491fb6f0d$var$Bk && ($29ecc58491fb6f0d$var$Bk = $29ecc58491fb6f0d$var$yc()), $29ecc58491fb6f0d$var$Bk;
    a = $29ecc58491fb6f0d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $29ecc58491fb6f0d$var$jd(a.type);
    return a;
}
function $29ecc58491fb6f0d$var$gi(a, b, c, d) {
    if (50 < $29ecc58491fb6f0d$var$yk) throw $29ecc58491fb6f0d$var$yk = 0, $29ecc58491fb6f0d$var$zk = null, Error($29ecc58491fb6f0d$var$p(185));
    $29ecc58491fb6f0d$var$Ac(a, c, d);
    if (0 === ($29ecc58491fb6f0d$var$K & 2) || a !== $29ecc58491fb6f0d$var$Q) a === $29ecc58491fb6f0d$var$Q && (0 === ($29ecc58491fb6f0d$var$K & 2) && ($29ecc58491fb6f0d$var$qk |= c), 4 === $29ecc58491fb6f0d$var$T && $29ecc58491fb6f0d$var$Ck(a, $29ecc58491fb6f0d$var$Z)), $29ecc58491fb6f0d$var$Dk(a, d), 1 === c && 0 === $29ecc58491fb6f0d$var$K && 0 === (b.mode & 1) && ($29ecc58491fb6f0d$var$Gj = $29ecc58491fb6f0d$var$B() + 500, $29ecc58491fb6f0d$var$fg && $29ecc58491fb6f0d$var$jg());
}
function $29ecc58491fb6f0d$var$Dk(a, b) {
    var c = a.callbackNode;
    $29ecc58491fb6f0d$var$wc(a, b);
    var d = $29ecc58491fb6f0d$var$uc(a, a === $29ecc58491fb6f0d$var$Q ? $29ecc58491fb6f0d$var$Z : 0);
    if (0 === d) null !== c && $29ecc58491fb6f0d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $29ecc58491fb6f0d$var$bc(c);
        if (1 === b) 0 === a.tag ? $29ecc58491fb6f0d$var$ig($29ecc58491fb6f0d$var$Ek.bind(null, a)) : $29ecc58491fb6f0d$var$hg($29ecc58491fb6f0d$var$Ek.bind(null, a)), $29ecc58491fb6f0d$var$Jf(function() {
            0 === ($29ecc58491fb6f0d$var$K & 6) && $29ecc58491fb6f0d$var$jg();
        }), c = null;
        else {
            switch($29ecc58491fb6f0d$var$Dc(d)){
                case 1:
                    c = $29ecc58491fb6f0d$var$fc;
                    break;
                case 4:
                    c = $29ecc58491fb6f0d$var$gc;
                    break;
                case 16:
                    c = $29ecc58491fb6f0d$var$hc;
                    break;
                case 536870912:
                    c = $29ecc58491fb6f0d$var$jc;
                    break;
                default:
                    c = $29ecc58491fb6f0d$var$hc;
            }
            c = $29ecc58491fb6f0d$var$Fk(c, $29ecc58491fb6f0d$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $29ecc58491fb6f0d$var$Gk(a, b) {
    $29ecc58491fb6f0d$var$Ak = -1;
    $29ecc58491fb6f0d$var$Bk = 0;
    if (0 !== ($29ecc58491fb6f0d$var$K & 6)) throw Error($29ecc58491fb6f0d$var$p(327));
    var c = a.callbackNode;
    if ($29ecc58491fb6f0d$var$Hk() && a.callbackNode !== c) return null;
    var d = $29ecc58491fb6f0d$var$uc(a, a === $29ecc58491fb6f0d$var$Q ? $29ecc58491fb6f0d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $29ecc58491fb6f0d$var$Ik(a, d);
    else {
        b = d;
        var e = $29ecc58491fb6f0d$var$K;
        $29ecc58491fb6f0d$var$K |= 2;
        var f = $29ecc58491fb6f0d$var$Jk();
        if ($29ecc58491fb6f0d$var$Q !== a || $29ecc58491fb6f0d$var$Z !== b) $29ecc58491fb6f0d$var$uk = null, $29ecc58491fb6f0d$var$Gj = $29ecc58491fb6f0d$var$B() + 500, $29ecc58491fb6f0d$var$Kk(a, b);
        for(;;)try {
            $29ecc58491fb6f0d$var$Lk();
            break;
        } catch (h) {
            $29ecc58491fb6f0d$var$Mk(a, h);
        }
        $29ecc58491fb6f0d$var$$g();
        $29ecc58491fb6f0d$var$mk.current = f;
        $29ecc58491fb6f0d$var$K = e;
        null !== $29ecc58491fb6f0d$var$Y ? b = 0 : ($29ecc58491fb6f0d$var$Q = null, $29ecc58491fb6f0d$var$Z = 0, b = $29ecc58491fb6f0d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $29ecc58491fb6f0d$var$xc(a), 0 !== e && (d = e, b = $29ecc58491fb6f0d$var$Nk(a, e)));
        if (1 === b) throw c = $29ecc58491fb6f0d$var$pk, $29ecc58491fb6f0d$var$Kk(a, 0), $29ecc58491fb6f0d$var$Ck(a, d), $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B()), c;
        if (6 === b) $29ecc58491fb6f0d$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$29ecc58491fb6f0d$var$Ok(e) && (b = $29ecc58491fb6f0d$var$Ik(a, d), 2 === b && (f = $29ecc58491fb6f0d$var$xc(a), 0 !== f && (d = f, b = $29ecc58491fb6f0d$var$Nk(a, f))), 1 === b)) throw c = $29ecc58491fb6f0d$var$pk, $29ecc58491fb6f0d$var$Kk(a, 0), $29ecc58491fb6f0d$var$Ck(a, d), $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($29ecc58491fb6f0d$var$p(345));
                case 2:
                    $29ecc58491fb6f0d$var$Pk(a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk);
                    break;
                case 3:
                    $29ecc58491fb6f0d$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $29ecc58491fb6f0d$var$fk + 500 - $29ecc58491fb6f0d$var$B(), 10 < b)) {
                        if (0 !== $29ecc58491fb6f0d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $29ecc58491fb6f0d$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $29ecc58491fb6f0d$var$Ff($29ecc58491fb6f0d$var$Pk.bind(null, a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk), b);
                        break;
                    }
                    $29ecc58491fb6f0d$var$Pk(a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk);
                    break;
                case 4:
                    $29ecc58491fb6f0d$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $29ecc58491fb6f0d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $29ecc58491fb6f0d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $29ecc58491fb6f0d$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $29ecc58491fb6f0d$var$Ff($29ecc58491fb6f0d$var$Pk.bind(null, a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk), d);
                        break;
                    }
                    $29ecc58491fb6f0d$var$Pk(a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk);
                    break;
                case 5:
                    $29ecc58491fb6f0d$var$Pk(a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk);
                    break;
                default:
                    throw Error($29ecc58491fb6f0d$var$p(329));
            }
        }
    }
    $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B());
    return a.callbackNode === c ? $29ecc58491fb6f0d$var$Gk.bind(null, a) : null;
}
function $29ecc58491fb6f0d$var$Nk(a, b) {
    var c = $29ecc58491fb6f0d$var$sk;
    a.current.memoizedState.isDehydrated && ($29ecc58491fb6f0d$var$Kk(a, b).flags |= 256);
    a = $29ecc58491fb6f0d$var$Ik(a, b);
    2 !== a && (b = $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$tk = c, null !== b && $29ecc58491fb6f0d$var$Fj(b));
    return a;
}
function $29ecc58491fb6f0d$var$Fj(a) {
    null === $29ecc58491fb6f0d$var$tk ? $29ecc58491fb6f0d$var$tk = a : $29ecc58491fb6f0d$var$tk.push.apply($29ecc58491fb6f0d$var$tk, a);
}
function $29ecc58491fb6f0d$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$29ecc58491fb6f0d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $29ecc58491fb6f0d$var$Ck(a, b) {
    b &= ~$29ecc58491fb6f0d$var$rk;
    b &= ~$29ecc58491fb6f0d$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $29ecc58491fb6f0d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $29ecc58491fb6f0d$var$Ek(a) {
    if (0 !== ($29ecc58491fb6f0d$var$K & 6)) throw Error($29ecc58491fb6f0d$var$p(327));
    $29ecc58491fb6f0d$var$Hk();
    var b = $29ecc58491fb6f0d$var$uc(a, 0);
    if (0 === (b & 1)) return $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B()), null;
    var c = $29ecc58491fb6f0d$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $29ecc58491fb6f0d$var$xc(a);
        0 !== d && (b = d, c = $29ecc58491fb6f0d$var$Nk(a, d));
    }
    if (1 === c) throw c = $29ecc58491fb6f0d$var$pk, $29ecc58491fb6f0d$var$Kk(a, 0), $29ecc58491fb6f0d$var$Ck(a, b), $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B()), c;
    if (6 === c) throw Error($29ecc58491fb6f0d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $29ecc58491fb6f0d$var$Pk(a, $29ecc58491fb6f0d$var$tk, $29ecc58491fb6f0d$var$uk);
    $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B());
    return null;
}
function $29ecc58491fb6f0d$var$Qk(a, b) {
    var c = $29ecc58491fb6f0d$var$K;
    $29ecc58491fb6f0d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $29ecc58491fb6f0d$var$K = c, 0 === $29ecc58491fb6f0d$var$K && ($29ecc58491fb6f0d$var$Gj = $29ecc58491fb6f0d$var$B() + 500, $29ecc58491fb6f0d$var$fg && $29ecc58491fb6f0d$var$jg());
    }
}
function $29ecc58491fb6f0d$var$Rk(a) {
    null !== $29ecc58491fb6f0d$var$wk && 0 === $29ecc58491fb6f0d$var$wk.tag && 0 === ($29ecc58491fb6f0d$var$K & 6) && $29ecc58491fb6f0d$var$Hk();
    var b = $29ecc58491fb6f0d$var$K;
    $29ecc58491fb6f0d$var$K |= 1;
    var c = $29ecc58491fb6f0d$var$ok.transition, d = $29ecc58491fb6f0d$var$C;
    try {
        if ($29ecc58491fb6f0d$var$ok.transition = null, $29ecc58491fb6f0d$var$C = 1, a) return a();
    } finally{
        $29ecc58491fb6f0d$var$C = d, $29ecc58491fb6f0d$var$ok.transition = c, $29ecc58491fb6f0d$var$K = b, 0 === ($29ecc58491fb6f0d$var$K & 6) && $29ecc58491fb6f0d$var$jg();
    }
}
function $29ecc58491fb6f0d$var$Hj() {
    $29ecc58491fb6f0d$var$fj = $29ecc58491fb6f0d$var$ej.current;
    $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$ej);
}
function $29ecc58491fb6f0d$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $29ecc58491fb6f0d$var$Gf(c));
    if (null !== $29ecc58491fb6f0d$var$Y) for(c = $29ecc58491fb6f0d$var$Y.return; null !== c;){
        var d = c;
        $29ecc58491fb6f0d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $29ecc58491fb6f0d$var$$f();
                break;
            case 3:
                $29ecc58491fb6f0d$var$zh();
                $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$Wf);
                $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$H);
                $29ecc58491fb6f0d$var$Eh();
                break;
            case 5:
                $29ecc58491fb6f0d$var$Bh(d);
                break;
            case 4:
                $29ecc58491fb6f0d$var$zh();
                break;
            case 13:
                $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$L);
                break;
            case 19:
                $29ecc58491fb6f0d$var$E($29ecc58491fb6f0d$var$L);
                break;
            case 10:
                $29ecc58491fb6f0d$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $29ecc58491fb6f0d$var$Hj();
        }
        c = c.return;
    }
    $29ecc58491fb6f0d$var$Q = a;
    $29ecc58491fb6f0d$var$Y = a = $29ecc58491fb6f0d$var$Pg(a.current, null);
    $29ecc58491fb6f0d$var$Z = $29ecc58491fb6f0d$var$fj = b;
    $29ecc58491fb6f0d$var$T = 0;
    $29ecc58491fb6f0d$var$pk = null;
    $29ecc58491fb6f0d$var$rk = $29ecc58491fb6f0d$var$qk = $29ecc58491fb6f0d$var$rh = 0;
    $29ecc58491fb6f0d$var$tk = $29ecc58491fb6f0d$var$sk = null;
    if (null !== $29ecc58491fb6f0d$var$fh) {
        for(b = 0; b < $29ecc58491fb6f0d$var$fh.length; b++)if (c = $29ecc58491fb6f0d$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $29ecc58491fb6f0d$var$fh = null;
    }
    return a;
}
function $29ecc58491fb6f0d$var$Mk(a, b) {
    do {
        var c = $29ecc58491fb6f0d$var$Y;
        try {
            $29ecc58491fb6f0d$var$$g();
            $29ecc58491fb6f0d$var$Fh.current = $29ecc58491fb6f0d$var$Rh;
            if ($29ecc58491fb6f0d$var$Ih) {
                for(var d = $29ecc58491fb6f0d$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $29ecc58491fb6f0d$var$Ih = !1;
            }
            $29ecc58491fb6f0d$var$Hh = 0;
            $29ecc58491fb6f0d$var$O = $29ecc58491fb6f0d$var$N = $29ecc58491fb6f0d$var$M = null;
            $29ecc58491fb6f0d$var$Jh = !1;
            $29ecc58491fb6f0d$var$Kh = 0;
            $29ecc58491fb6f0d$var$nk.current = null;
            if (null === c || null === c.return) {
                $29ecc58491fb6f0d$var$T = 1;
                $29ecc58491fb6f0d$var$pk = b;
                $29ecc58491fb6f0d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $29ecc58491fb6f0d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $29ecc58491fb6f0d$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $29ecc58491fb6f0d$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $29ecc58491fb6f0d$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $29ecc58491fb6f0d$var$Si(f, l, b);
                            $29ecc58491fb6f0d$var$tj();
                            break a;
                        }
                        k = Error($29ecc58491fb6f0d$var$p(426));
                    }
                } else if ($29ecc58491fb6f0d$var$I && h.mode & 1) {
                    var J = $29ecc58491fb6f0d$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $29ecc58491fb6f0d$var$Vi(J, g, h, f, b);
                        $29ecc58491fb6f0d$var$Jg($29ecc58491fb6f0d$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $29ecc58491fb6f0d$var$Ji(k, h);
                4 !== $29ecc58491fb6f0d$var$T && ($29ecc58491fb6f0d$var$T = 2);
                null === $29ecc58491fb6f0d$var$sk ? $29ecc58491fb6f0d$var$sk = [
                    f
                ] : $29ecc58491fb6f0d$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $29ecc58491fb6f0d$var$Ni(f, k, b);
                            $29ecc58491fb6f0d$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $29ecc58491fb6f0d$var$Ri || !$29ecc58491fb6f0d$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $29ecc58491fb6f0d$var$Qi(f, h, b);
                                $29ecc58491fb6f0d$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $29ecc58491fb6f0d$var$Sk(c);
        } catch (na) {
            b = na;
            $29ecc58491fb6f0d$var$Y === c && null !== c && ($29ecc58491fb6f0d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $29ecc58491fb6f0d$var$Jk() {
    var a = $29ecc58491fb6f0d$var$mk.current;
    $29ecc58491fb6f0d$var$mk.current = $29ecc58491fb6f0d$var$Rh;
    return null === a ? $29ecc58491fb6f0d$var$Rh : a;
}
function $29ecc58491fb6f0d$var$tj() {
    if (0 === $29ecc58491fb6f0d$var$T || 3 === $29ecc58491fb6f0d$var$T || 2 === $29ecc58491fb6f0d$var$T) $29ecc58491fb6f0d$var$T = 4;
    null === $29ecc58491fb6f0d$var$Q || 0 === ($29ecc58491fb6f0d$var$rh & 268435455) && 0 === ($29ecc58491fb6f0d$var$qk & 268435455) || $29ecc58491fb6f0d$var$Ck($29ecc58491fb6f0d$var$Q, $29ecc58491fb6f0d$var$Z);
}
function $29ecc58491fb6f0d$var$Ik(a, b) {
    var c = $29ecc58491fb6f0d$var$K;
    $29ecc58491fb6f0d$var$K |= 2;
    var d = $29ecc58491fb6f0d$var$Jk();
    if ($29ecc58491fb6f0d$var$Q !== a || $29ecc58491fb6f0d$var$Z !== b) $29ecc58491fb6f0d$var$uk = null, $29ecc58491fb6f0d$var$Kk(a, b);
    for(;;)try {
        $29ecc58491fb6f0d$var$Tk();
        break;
    } catch (e) {
        $29ecc58491fb6f0d$var$Mk(a, e);
    }
    $29ecc58491fb6f0d$var$$g();
    $29ecc58491fb6f0d$var$K = c;
    $29ecc58491fb6f0d$var$mk.current = d;
    if (null !== $29ecc58491fb6f0d$var$Y) throw Error($29ecc58491fb6f0d$var$p(261));
    $29ecc58491fb6f0d$var$Q = null;
    $29ecc58491fb6f0d$var$Z = 0;
    return $29ecc58491fb6f0d$var$T;
}
function $29ecc58491fb6f0d$var$Tk() {
    for(; null !== $29ecc58491fb6f0d$var$Y;)$29ecc58491fb6f0d$var$Uk($29ecc58491fb6f0d$var$Y);
}
function $29ecc58491fb6f0d$var$Lk() {
    for(; null !== $29ecc58491fb6f0d$var$Y && !$29ecc58491fb6f0d$var$cc();)$29ecc58491fb6f0d$var$Uk($29ecc58491fb6f0d$var$Y);
}
function $29ecc58491fb6f0d$var$Uk(a) {
    var b = $29ecc58491fb6f0d$var$Vk(a.alternate, a, $29ecc58491fb6f0d$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $29ecc58491fb6f0d$var$Sk(a) : $29ecc58491fb6f0d$var$Y = b;
    $29ecc58491fb6f0d$var$nk.current = null;
}
function $29ecc58491fb6f0d$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $29ecc58491fb6f0d$var$Ej(c, b, $29ecc58491fb6f0d$var$fj), null !== c) {
                $29ecc58491fb6f0d$var$Y = c;
                return;
            }
        } else {
            c = $29ecc58491fb6f0d$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $29ecc58491fb6f0d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $29ecc58491fb6f0d$var$T = 6;
                $29ecc58491fb6f0d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $29ecc58491fb6f0d$var$Y = b;
            return;
        }
        $29ecc58491fb6f0d$var$Y = b = a;
    }while (null !== b);
    0 === $29ecc58491fb6f0d$var$T && ($29ecc58491fb6f0d$var$T = 5);
}
function $29ecc58491fb6f0d$var$Pk(a, b, c) {
    var d = $29ecc58491fb6f0d$var$C, e = $29ecc58491fb6f0d$var$ok.transition;
    try {
        $29ecc58491fb6f0d$var$ok.transition = null, $29ecc58491fb6f0d$var$C = 1, $29ecc58491fb6f0d$var$Wk(a, b, c, d);
    } finally{
        $29ecc58491fb6f0d$var$ok.transition = e, $29ecc58491fb6f0d$var$C = d;
    }
    return null;
}
function $29ecc58491fb6f0d$var$Wk(a, b, c, d) {
    do $29ecc58491fb6f0d$var$Hk();
    while (null !== $29ecc58491fb6f0d$var$wk);
    if (0 !== ($29ecc58491fb6f0d$var$K & 6)) throw Error($29ecc58491fb6f0d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($29ecc58491fb6f0d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $29ecc58491fb6f0d$var$Bc(a, f);
    a === $29ecc58491fb6f0d$var$Q && ($29ecc58491fb6f0d$var$Y = $29ecc58491fb6f0d$var$Q = null, $29ecc58491fb6f0d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $29ecc58491fb6f0d$var$vk || ($29ecc58491fb6f0d$var$vk = !0, $29ecc58491fb6f0d$var$Fk($29ecc58491fb6f0d$var$hc, function() {
        $29ecc58491fb6f0d$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $29ecc58491fb6f0d$var$ok.transition;
        $29ecc58491fb6f0d$var$ok.transition = null;
        var g = $29ecc58491fb6f0d$var$C;
        $29ecc58491fb6f0d$var$C = 1;
        var h = $29ecc58491fb6f0d$var$K;
        $29ecc58491fb6f0d$var$K |= 4;
        $29ecc58491fb6f0d$var$nk.current = null;
        $29ecc58491fb6f0d$var$Oj(a, c);
        $29ecc58491fb6f0d$var$dk(c, a);
        $29ecc58491fb6f0d$var$Oe($29ecc58491fb6f0d$var$Df);
        $29ecc58491fb6f0d$var$dd = !!$29ecc58491fb6f0d$var$Cf;
        $29ecc58491fb6f0d$var$Df = $29ecc58491fb6f0d$var$Cf = null;
        a.current = c;
        $29ecc58491fb6f0d$var$hk(c, a, e);
        $29ecc58491fb6f0d$var$dc();
        $29ecc58491fb6f0d$var$K = h;
        $29ecc58491fb6f0d$var$C = g;
        $29ecc58491fb6f0d$var$ok.transition = f;
    } else a.current = c;
    $29ecc58491fb6f0d$var$vk && ($29ecc58491fb6f0d$var$vk = !1, $29ecc58491fb6f0d$var$wk = a, $29ecc58491fb6f0d$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($29ecc58491fb6f0d$var$Ri = null);
    $29ecc58491fb6f0d$var$mc(c.stateNode, d);
    $29ecc58491fb6f0d$var$Dk(a, $29ecc58491fb6f0d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($29ecc58491fb6f0d$var$Oi) throw $29ecc58491fb6f0d$var$Oi = !1, a = $29ecc58491fb6f0d$var$Pi, $29ecc58491fb6f0d$var$Pi = null, a;
    0 !== ($29ecc58491fb6f0d$var$xk & 1) && 0 !== a.tag && $29ecc58491fb6f0d$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $29ecc58491fb6f0d$var$zk ? $29ecc58491fb6f0d$var$yk++ : ($29ecc58491fb6f0d$var$yk = 0, $29ecc58491fb6f0d$var$zk = a) : $29ecc58491fb6f0d$var$yk = 0;
    $29ecc58491fb6f0d$var$jg();
    return null;
}
function $29ecc58491fb6f0d$var$Hk() {
    if (null !== $29ecc58491fb6f0d$var$wk) {
        var a = $29ecc58491fb6f0d$var$Dc($29ecc58491fb6f0d$var$xk), b = $29ecc58491fb6f0d$var$ok.transition, c = $29ecc58491fb6f0d$var$C;
        try {
            $29ecc58491fb6f0d$var$ok.transition = null;
            $29ecc58491fb6f0d$var$C = 16 > a ? 16 : a;
            if (null === $29ecc58491fb6f0d$var$wk) var d = !1;
            else {
                a = $29ecc58491fb6f0d$var$wk;
                $29ecc58491fb6f0d$var$wk = null;
                $29ecc58491fb6f0d$var$xk = 0;
                if (0 !== ($29ecc58491fb6f0d$var$K & 6)) throw Error($29ecc58491fb6f0d$var$p(331));
                var e = $29ecc58491fb6f0d$var$K;
                $29ecc58491fb6f0d$var$K |= 4;
                for($29ecc58491fb6f0d$var$V = a.current; null !== $29ecc58491fb6f0d$var$V;){
                    var f = $29ecc58491fb6f0d$var$V, g = f.child;
                    if (0 !== ($29ecc58491fb6f0d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($29ecc58491fb6f0d$var$V = l; null !== $29ecc58491fb6f0d$var$V;){
                                    var m = $29ecc58491fb6f0d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $29ecc58491fb6f0d$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $29ecc58491fb6f0d$var$V = q;
                                    else for(; null !== $29ecc58491fb6f0d$var$V;){
                                        m = $29ecc58491fb6f0d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $29ecc58491fb6f0d$var$Sj(m);
                                        if (m === l) {
                                            $29ecc58491fb6f0d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $29ecc58491fb6f0d$var$V = r;
                                            break;
                                        }
                                        $29ecc58491fb6f0d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $29ecc58491fb6f0d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $29ecc58491fb6f0d$var$V = g;
                    else b: for(; null !== $29ecc58491fb6f0d$var$V;){
                        f = $29ecc58491fb6f0d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $29ecc58491fb6f0d$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $29ecc58491fb6f0d$var$V = x;
                            break b;
                        }
                        $29ecc58491fb6f0d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($29ecc58491fb6f0d$var$V = w; null !== $29ecc58491fb6f0d$var$V;){
                    g = $29ecc58491fb6f0d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $29ecc58491fb6f0d$var$V = u;
                    else b: for(g = w; null !== $29ecc58491fb6f0d$var$V;){
                        h = $29ecc58491fb6f0d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $29ecc58491fb6f0d$var$Qj(9, h);
                            }
                        } catch (na) {
                            $29ecc58491fb6f0d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $29ecc58491fb6f0d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $29ecc58491fb6f0d$var$V = F;
                            break b;
                        }
                        $29ecc58491fb6f0d$var$V = h.return;
                    }
                }
                $29ecc58491fb6f0d$var$K = e;
                $29ecc58491fb6f0d$var$jg();
                if ($29ecc58491fb6f0d$var$lc && "function" === typeof $29ecc58491fb6f0d$var$lc.onPostCommitFiberRoot) try {
                    $29ecc58491fb6f0d$var$lc.onPostCommitFiberRoot($29ecc58491fb6f0d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $29ecc58491fb6f0d$var$C = c, $29ecc58491fb6f0d$var$ok.transition = b;
        }
    }
    return !1;
}
function $29ecc58491fb6f0d$var$Xk(a, b, c) {
    b = $29ecc58491fb6f0d$var$Ji(c, b);
    b = $29ecc58491fb6f0d$var$Ni(a, b, 1);
    a = $29ecc58491fb6f0d$var$nh(a, b, 1);
    b = $29ecc58491fb6f0d$var$R();
    null !== a && ($29ecc58491fb6f0d$var$Ac(a, 1, b), $29ecc58491fb6f0d$var$Dk(a, b));
}
function $29ecc58491fb6f0d$var$W(a, b, c) {
    if (3 === a.tag) $29ecc58491fb6f0d$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $29ecc58491fb6f0d$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $29ecc58491fb6f0d$var$Ri || !$29ecc58491fb6f0d$var$Ri.has(d))) {
                a = $29ecc58491fb6f0d$var$Ji(c, a);
                a = $29ecc58491fb6f0d$var$Qi(b, a, 1);
                b = $29ecc58491fb6f0d$var$nh(b, a, 1);
                a = $29ecc58491fb6f0d$var$R();
                null !== b && ($29ecc58491fb6f0d$var$Ac(b, 1, a), $29ecc58491fb6f0d$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $29ecc58491fb6f0d$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $29ecc58491fb6f0d$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $29ecc58491fb6f0d$var$Q === a && ($29ecc58491fb6f0d$var$Z & c) === c && (4 === $29ecc58491fb6f0d$var$T || 3 === $29ecc58491fb6f0d$var$T && ($29ecc58491fb6f0d$var$Z & 130023424) === $29ecc58491fb6f0d$var$Z && 500 > $29ecc58491fb6f0d$var$B() - $29ecc58491fb6f0d$var$fk ? $29ecc58491fb6f0d$var$Kk(a, 0) : $29ecc58491fb6f0d$var$rk |= c);
    $29ecc58491fb6f0d$var$Dk(a, b);
}
function $29ecc58491fb6f0d$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $29ecc58491fb6f0d$var$sc, $29ecc58491fb6f0d$var$sc <<= 1, 0 === ($29ecc58491fb6f0d$var$sc & 130023424) && ($29ecc58491fb6f0d$var$sc = 4194304)));
    var c = $29ecc58491fb6f0d$var$R();
    a = $29ecc58491fb6f0d$var$ih(a, b);
    null !== a && ($29ecc58491fb6f0d$var$Ac(a, b, c), $29ecc58491fb6f0d$var$Dk(a, c));
}
function $29ecc58491fb6f0d$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $29ecc58491fb6f0d$var$Yk(a, c);
}
function $29ecc58491fb6f0d$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($29ecc58491fb6f0d$var$p(314));
    }
    null !== d && d.delete(b);
    $29ecc58491fb6f0d$var$Yk(a, c);
}
var $29ecc58491fb6f0d$var$Vk;
$29ecc58491fb6f0d$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $29ecc58491fb6f0d$var$Wf.current) $29ecc58491fb6f0d$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $29ecc58491fb6f0d$var$dh = !1, $29ecc58491fb6f0d$var$yj(a, b, c);
            $29ecc58491fb6f0d$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $29ecc58491fb6f0d$var$dh = !1, $29ecc58491fb6f0d$var$I && 0 !== (b.flags & 1048576) && $29ecc58491fb6f0d$var$ug(b, $29ecc58491fb6f0d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $29ecc58491fb6f0d$var$ij(a, b);
            a = b.pendingProps;
            var e = $29ecc58491fb6f0d$var$Yf(b, $29ecc58491fb6f0d$var$H.current);
            $29ecc58491fb6f0d$var$ch(b, c);
            e = $29ecc58491fb6f0d$var$Nh(null, b, d, a, e, c);
            var f = $29ecc58491fb6f0d$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $29ecc58491fb6f0d$var$Zf(d) ? (f = !0, $29ecc58491fb6f0d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $29ecc58491fb6f0d$var$kh(b), e.updater = $29ecc58491fb6f0d$var$Ei, b.stateNode = e, e._reactInternals = b, $29ecc58491fb6f0d$var$Ii(b, d, a, c), b = $29ecc58491fb6f0d$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $29ecc58491fb6f0d$var$I && f && $29ecc58491fb6f0d$var$vg(b), $29ecc58491fb6f0d$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $29ecc58491fb6f0d$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $29ecc58491fb6f0d$var$Zk(d);
                a = $29ecc58491fb6f0d$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $29ecc58491fb6f0d$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $29ecc58491fb6f0d$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $29ecc58491fb6f0d$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $29ecc58491fb6f0d$var$$i(null, b, d, $29ecc58491fb6f0d$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($29ecc58491fb6f0d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $29ecc58491fb6f0d$var$Ci(d, e), $29ecc58491fb6f0d$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $29ecc58491fb6f0d$var$Ci(d, e), $29ecc58491fb6f0d$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $29ecc58491fb6f0d$var$kj(b);
                if (null === a) throw Error($29ecc58491fb6f0d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $29ecc58491fb6f0d$var$lh(a, b);
                $29ecc58491fb6f0d$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $29ecc58491fb6f0d$var$Ji(Error($29ecc58491fb6f0d$var$p(423)), b);
                        b = $29ecc58491fb6f0d$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $29ecc58491fb6f0d$var$Ji(Error($29ecc58491fb6f0d$var$p(424)), b);
                        b = $29ecc58491fb6f0d$var$lj(a, b, d, c, e);
                        break a;
                    } else for($29ecc58491fb6f0d$var$yg = $29ecc58491fb6f0d$var$Lf(b.stateNode.containerInfo.firstChild), $29ecc58491fb6f0d$var$xg = b, $29ecc58491fb6f0d$var$I = !0, $29ecc58491fb6f0d$var$zg = null, c = $29ecc58491fb6f0d$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $29ecc58491fb6f0d$var$Ig();
                    if (d === e) {
                        b = $29ecc58491fb6f0d$var$Zi(a, b, c);
                        break a;
                    }
                    $29ecc58491fb6f0d$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $29ecc58491fb6f0d$var$Ah(b), null === a && $29ecc58491fb6f0d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $29ecc58491fb6f0d$var$Ef(d, e) ? g = null : null !== f && $29ecc58491fb6f0d$var$Ef(d, f) && (b.flags |= 32), $29ecc58491fb6f0d$var$gj(a, b), $29ecc58491fb6f0d$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $29ecc58491fb6f0d$var$Eg(b), null;
        case 13:
            return $29ecc58491fb6f0d$var$oj(a, b, c);
        case 4:
            return $29ecc58491fb6f0d$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $29ecc58491fb6f0d$var$Ug(b, null, d, c) : $29ecc58491fb6f0d$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $29ecc58491fb6f0d$var$Ci(d, e), $29ecc58491fb6f0d$var$Yi(a, b, d, e, c);
        case 7:
            return $29ecc58491fb6f0d$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $29ecc58491fb6f0d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $29ecc58491fb6f0d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $29ecc58491fb6f0d$var$G($29ecc58491fb6f0d$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($29ecc58491fb6f0d$var$He(f.value, g)) {
                        if (f.children === e.children && !$29ecc58491fb6f0d$var$Wf.current) {
                            b = $29ecc58491fb6f0d$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $29ecc58491fb6f0d$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $29ecc58491fb6f0d$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($29ecc58491fb6f0d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $29ecc58491fb6f0d$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $29ecc58491fb6f0d$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $29ecc58491fb6f0d$var$ch(b, c), e = $29ecc58491fb6f0d$var$eh(e), d = d(e), b.flags |= 1, $29ecc58491fb6f0d$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $29ecc58491fb6f0d$var$Ci(d, b.pendingProps), e = $29ecc58491fb6f0d$var$Ci(d.type, e), $29ecc58491fb6f0d$var$$i(a, b, d, e, c);
        case 15:
            return $29ecc58491fb6f0d$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $29ecc58491fb6f0d$var$Ci(d, e), $29ecc58491fb6f0d$var$ij(a, b), b.tag = 1, $29ecc58491fb6f0d$var$Zf(d) ? (a = !0, $29ecc58491fb6f0d$var$cg(b)) : a = !1, $29ecc58491fb6f0d$var$ch(b, c), $29ecc58491fb6f0d$var$Gi(b, d, e), $29ecc58491fb6f0d$var$Ii(b, d, e, c), $29ecc58491fb6f0d$var$jj(null, b, d, !0, a, c);
        case 19:
            return $29ecc58491fb6f0d$var$xj(a, b, c);
        case 22:
            return $29ecc58491fb6f0d$var$dj(a, b, c);
    }
    throw Error($29ecc58491fb6f0d$var$p(156, b.tag));
};
function $29ecc58491fb6f0d$var$Fk(a, b) {
    return $29ecc58491fb6f0d$var$ac(a, b);
}
function $29ecc58491fb6f0d$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $29ecc58491fb6f0d$var$Bg(a, b, c, d) {
    return new $29ecc58491fb6f0d$var$$k(a, b, c, d);
}
function $29ecc58491fb6f0d$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $29ecc58491fb6f0d$var$Zk(a) {
    if ("function" === typeof a) return $29ecc58491fb6f0d$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $29ecc58491fb6f0d$var$Da) return 11;
        if (a === $29ecc58491fb6f0d$var$Ga) return 14;
    }
    return 2;
}
function $29ecc58491fb6f0d$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $29ecc58491fb6f0d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $29ecc58491fb6f0d$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $29ecc58491fb6f0d$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $29ecc58491fb6f0d$var$ya:
            return $29ecc58491fb6f0d$var$Tg(c.children, e, f, b);
        case $29ecc58491fb6f0d$var$za:
            g = 8;
            e |= 8;
            break;
        case $29ecc58491fb6f0d$var$Aa:
            return a = $29ecc58491fb6f0d$var$Bg(12, c, b, e | 2), a.elementType = $29ecc58491fb6f0d$var$Aa, a.lanes = f, a;
        case $29ecc58491fb6f0d$var$Ea:
            return a = $29ecc58491fb6f0d$var$Bg(13, c, b, e), a.elementType = $29ecc58491fb6f0d$var$Ea, a.lanes = f, a;
        case $29ecc58491fb6f0d$var$Fa:
            return a = $29ecc58491fb6f0d$var$Bg(19, c, b, e), a.elementType = $29ecc58491fb6f0d$var$Fa, a.lanes = f, a;
        case $29ecc58491fb6f0d$var$Ia:
            return $29ecc58491fb6f0d$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $29ecc58491fb6f0d$var$Ba:
                    g = 10;
                    break a;
                case $29ecc58491fb6f0d$var$Ca:
                    g = 9;
                    break a;
                case $29ecc58491fb6f0d$var$Da:
                    g = 11;
                    break a;
                case $29ecc58491fb6f0d$var$Ga:
                    g = 14;
                    break a;
                case $29ecc58491fb6f0d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($29ecc58491fb6f0d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $29ecc58491fb6f0d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $29ecc58491fb6f0d$var$Tg(a, b, c, d) {
    a = $29ecc58491fb6f0d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $29ecc58491fb6f0d$var$pj(a, b, c, d) {
    a = $29ecc58491fb6f0d$var$Bg(22, a, d, b);
    a.elementType = $29ecc58491fb6f0d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $29ecc58491fb6f0d$var$Qg(a, b, c) {
    a = $29ecc58491fb6f0d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $29ecc58491fb6f0d$var$Sg(a, b, c) {
    b = $29ecc58491fb6f0d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $29ecc58491fb6f0d$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $29ecc58491fb6f0d$var$zc(0);
    this.expirationTimes = $29ecc58491fb6f0d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $29ecc58491fb6f0d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $29ecc58491fb6f0d$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $29ecc58491fb6f0d$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $29ecc58491fb6f0d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $29ecc58491fb6f0d$var$kh(f);
    return a;
}
function $29ecc58491fb6f0d$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $29ecc58491fb6f0d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $29ecc58491fb6f0d$var$dl(a) {
    if (!a) return $29ecc58491fb6f0d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($29ecc58491fb6f0d$var$Vb(a) !== a || 1 !== a.tag) throw Error($29ecc58491fb6f0d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($29ecc58491fb6f0d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($29ecc58491fb6f0d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($29ecc58491fb6f0d$var$Zf(c)) return $29ecc58491fb6f0d$var$bg(a, c, b);
    }
    return b;
}
function $29ecc58491fb6f0d$var$el(a, b, c, d, e, f, g, h, k) {
    a = $29ecc58491fb6f0d$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $29ecc58491fb6f0d$var$dl(null);
    c = a.current;
    d = $29ecc58491fb6f0d$var$R();
    e = $29ecc58491fb6f0d$var$yi(c);
    f = $29ecc58491fb6f0d$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $29ecc58491fb6f0d$var$nh(c, f, e);
    a.current.lanes = e;
    $29ecc58491fb6f0d$var$Ac(a, e, d);
    $29ecc58491fb6f0d$var$Dk(a, d);
    return a;
}
function $29ecc58491fb6f0d$var$fl(a, b, c, d) {
    var e = b.current, f = $29ecc58491fb6f0d$var$R(), g = $29ecc58491fb6f0d$var$yi(e);
    c = $29ecc58491fb6f0d$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $29ecc58491fb6f0d$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $29ecc58491fb6f0d$var$nh(e, b, g);
    null !== a && ($29ecc58491fb6f0d$var$gi(a, e, g, f), $29ecc58491fb6f0d$var$oh(a, e, g));
    return g;
}
function $29ecc58491fb6f0d$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $29ecc58491fb6f0d$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $29ecc58491fb6f0d$var$il(a, b) {
    $29ecc58491fb6f0d$var$hl(a, b);
    (a = a.alternate) && $29ecc58491fb6f0d$var$hl(a, b);
}
function $29ecc58491fb6f0d$var$jl() {
    return null;
}
var $29ecc58491fb6f0d$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $29ecc58491fb6f0d$var$ll(a) {
    this._internalRoot = a;
}
$29ecc58491fb6f0d$var$ml.prototype.render = $29ecc58491fb6f0d$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($29ecc58491fb6f0d$var$p(409));
    $29ecc58491fb6f0d$var$fl(a, b, null, null);
};
$29ecc58491fb6f0d$var$ml.prototype.unmount = $29ecc58491fb6f0d$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $29ecc58491fb6f0d$var$Rk(function() {
            $29ecc58491fb6f0d$var$fl(null, a, null, null);
        });
        b[$29ecc58491fb6f0d$var$uf] = null;
    }
};
function $29ecc58491fb6f0d$var$ml(a) {
    this._internalRoot = a;
}
$29ecc58491fb6f0d$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $29ecc58491fb6f0d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $29ecc58491fb6f0d$var$Qc.length && 0 !== b && b < $29ecc58491fb6f0d$var$Qc[c].priority; c++);
        $29ecc58491fb6f0d$var$Qc.splice(c, 0, a);
        0 === c && $29ecc58491fb6f0d$var$Vc(a);
    }
};
function $29ecc58491fb6f0d$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $29ecc58491fb6f0d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $29ecc58491fb6f0d$var$pl() {}
function $29ecc58491fb6f0d$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $29ecc58491fb6f0d$var$gl(g);
                f.call(a);
            };
        }
        var g = $29ecc58491fb6f0d$var$el(b, d, a, 0, null, !1, !1, "", $29ecc58491fb6f0d$var$pl);
        a._reactRootContainer = g;
        a[$29ecc58491fb6f0d$var$uf] = g.current;
        $29ecc58491fb6f0d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $29ecc58491fb6f0d$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $29ecc58491fb6f0d$var$gl(k);
            h.call(a);
        };
    }
    var k = $29ecc58491fb6f0d$var$bl(a, 0, !1, null, null, !1, !1, "", $29ecc58491fb6f0d$var$pl);
    a._reactRootContainer = k;
    a[$29ecc58491fb6f0d$var$uf] = k.current;
    $29ecc58491fb6f0d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $29ecc58491fb6f0d$var$Rk(function() {
        $29ecc58491fb6f0d$var$fl(b, k, c, d);
    });
    return k;
}
function $29ecc58491fb6f0d$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $29ecc58491fb6f0d$var$gl(g);
                h.call(a);
            };
        }
        $29ecc58491fb6f0d$var$fl(b, g, a, e);
    } else g = $29ecc58491fb6f0d$var$ql(c, b, a, e, d);
    return $29ecc58491fb6f0d$var$gl(g);
}
$29ecc58491fb6f0d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $29ecc58491fb6f0d$var$tc(b.pendingLanes);
                0 !== c && ($29ecc58491fb6f0d$var$Cc(b, c | 1), $29ecc58491fb6f0d$var$Dk(b, $29ecc58491fb6f0d$var$B()), 0 === ($29ecc58491fb6f0d$var$K & 6) && ($29ecc58491fb6f0d$var$Gj = $29ecc58491fb6f0d$var$B() + 500, $29ecc58491fb6f0d$var$jg()));
            }
            break;
        case 13:
            $29ecc58491fb6f0d$var$Rk(function() {
                var b = $29ecc58491fb6f0d$var$ih(a, 1);
                if (null !== b) {
                    var c = $29ecc58491fb6f0d$var$R();
                    $29ecc58491fb6f0d$var$gi(b, a, 1, c);
                }
            }), $29ecc58491fb6f0d$var$il(a, 1);
    }
};
$29ecc58491fb6f0d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $29ecc58491fb6f0d$var$ih(a, 134217728);
        if (null !== b) {
            var c = $29ecc58491fb6f0d$var$R();
            $29ecc58491fb6f0d$var$gi(b, a, 134217728, c);
        }
        $29ecc58491fb6f0d$var$il(a, 134217728);
    }
};
$29ecc58491fb6f0d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $29ecc58491fb6f0d$var$yi(a), c = $29ecc58491fb6f0d$var$ih(a, b);
        if (null !== c) {
            var d = $29ecc58491fb6f0d$var$R();
            $29ecc58491fb6f0d$var$gi(c, a, b, d);
        }
        $29ecc58491fb6f0d$var$il(a, b);
    }
};
$29ecc58491fb6f0d$var$Hc = function() {
    return $29ecc58491fb6f0d$var$C;
};
$29ecc58491fb6f0d$var$Ic = function(a, b) {
    var c = $29ecc58491fb6f0d$var$C;
    try {
        return $29ecc58491fb6f0d$var$C = a, b();
    } finally{
        $29ecc58491fb6f0d$var$C = c;
    }
};
$29ecc58491fb6f0d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $29ecc58491fb6f0d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $29ecc58491fb6f0d$var$Db(d);
                        if (!e) throw Error($29ecc58491fb6f0d$var$p(90));
                        $29ecc58491fb6f0d$var$Wa(d);
                        $29ecc58491fb6f0d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $29ecc58491fb6f0d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $29ecc58491fb6f0d$var$fb(a, !!c.multiple, b, !1);
    }
};
$29ecc58491fb6f0d$var$Gb = $29ecc58491fb6f0d$var$Qk;
$29ecc58491fb6f0d$var$Hb = $29ecc58491fb6f0d$var$Rk;
var $29ecc58491fb6f0d$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $29ecc58491fb6f0d$var$Cb,
        $29ecc58491fb6f0d$var$ue,
        $29ecc58491fb6f0d$var$Db,
        $29ecc58491fb6f0d$var$Eb,
        $29ecc58491fb6f0d$var$Fb,
        $29ecc58491fb6f0d$var$Qk
    ]
}, $29ecc58491fb6f0d$var$tl = {
    findFiberByHostInstance: $29ecc58491fb6f0d$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $29ecc58491fb6f0d$var$ul = {
    bundleType: $29ecc58491fb6f0d$var$tl.bundleType,
    version: $29ecc58491fb6f0d$var$tl.version,
    rendererPackageName: $29ecc58491fb6f0d$var$tl.rendererPackageName,
    rendererConfig: $29ecc58491fb6f0d$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $29ecc58491fb6f0d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $29ecc58491fb6f0d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $29ecc58491fb6f0d$var$tl.findFiberByHostInstance || $29ecc58491fb6f0d$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $29ecc58491fb6f0d$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$29ecc58491fb6f0d$var$vl.isDisabled && $29ecc58491fb6f0d$var$vl.supportsFiber) try {
        $29ecc58491fb6f0d$var$kc = $29ecc58491fb6f0d$var$vl.inject($29ecc58491fb6f0d$var$ul), $29ecc58491fb6f0d$var$lc = $29ecc58491fb6f0d$var$vl;
    } catch (a) {}
}
$29ecc58491fb6f0d$export$ae55be85d98224ed = $29ecc58491fb6f0d$var$sl;
$29ecc58491fb6f0d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$29ecc58491fb6f0d$var$nl(b)) throw Error($29ecc58491fb6f0d$var$p(200));
    return $29ecc58491fb6f0d$var$cl(a, b, null, c);
};
$29ecc58491fb6f0d$export$882461b6382ed46c = function(a, b) {
    if (!$29ecc58491fb6f0d$var$nl(a)) throw Error($29ecc58491fb6f0d$var$p(299));
    var c = !1, d = "", e = $29ecc58491fb6f0d$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $29ecc58491fb6f0d$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$29ecc58491fb6f0d$var$uf] = b.current;
    $29ecc58491fb6f0d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $29ecc58491fb6f0d$var$ll(b);
};
$29ecc58491fb6f0d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($29ecc58491fb6f0d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($29ecc58491fb6f0d$var$p(268, a));
    }
    a = $29ecc58491fb6f0d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$29ecc58491fb6f0d$export$cd75ccfd720a3cd4 = function(a) {
    return $29ecc58491fb6f0d$var$Rk(a);
};
$29ecc58491fb6f0d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$29ecc58491fb6f0d$var$ol(b)) throw Error($29ecc58491fb6f0d$var$p(200));
    return $29ecc58491fb6f0d$var$rl(null, a, b, !0, c);
};
$29ecc58491fb6f0d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$29ecc58491fb6f0d$var$nl(a)) throw Error($29ecc58491fb6f0d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $29ecc58491fb6f0d$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $29ecc58491fb6f0d$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$29ecc58491fb6f0d$var$uf] = b.current;
    $29ecc58491fb6f0d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $29ecc58491fb6f0d$var$ml(b);
};
$29ecc58491fb6f0d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$29ecc58491fb6f0d$var$ol(b)) throw Error($29ecc58491fb6f0d$var$p(200));
    return $29ecc58491fb6f0d$var$rl(null, a, b, !1, c);
};
$29ecc58491fb6f0d$export$502457920280e6be = function(a) {
    if (!$29ecc58491fb6f0d$var$ol(a)) throw Error($29ecc58491fb6f0d$var$p(40));
    return a._reactRootContainer ? ($29ecc58491fb6f0d$var$Rk(function() {
        $29ecc58491fb6f0d$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$29ecc58491fb6f0d$var$uf] = null;
        });
    }), !0) : !1;
};
$29ecc58491fb6f0d$export$c78a37762a8d58e1 = $29ecc58491fb6f0d$var$Qk;
$29ecc58491fb6f0d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$29ecc58491fb6f0d$var$ol(c)) throw Error($29ecc58491fb6f0d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($29ecc58491fb6f0d$var$p(38));
    return $29ecc58491fb6f0d$var$rl(a, b, c, !1, d);
};
$29ecc58491fb6f0d$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lC4Dh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dqzhg"));

});
parcelRegister("dqzhg", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9c6911696f98b24c$export$c4744153514ff05d; }, function (v) { return $9c6911696f98b24c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9c6911696f98b24c$export$3e506c1ccc9cc1a7; }, function (v) { return $9c6911696f98b24c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9c6911696f98b24c$export$e26fe2ed2fa76875; }, function (v) { return $9c6911696f98b24c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9c6911696f98b24c$export$502329bbf4b505b1; }, function (v) { return $9c6911696f98b24c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9c6911696f98b24c$export$6e3807111c4874c4; }, function (v) { return $9c6911696f98b24c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9c6911696f98b24c$export$c27134553091fb3a; }, function (v) { return $9c6911696f98b24c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9c6911696f98b24c$export$33ee1acdc04fd2a2; }, function (v) { return $9c6911696f98b24c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9c6911696f98b24c$export$b00a404bbd5edef2; }, function (v) { return $9c6911696f98b24c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9c6911696f98b24c$export$8352ce38b91d0c62; }, function (v) { return $9c6911696f98b24c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9c6911696f98b24c$export$d66a1c1c77bd778b; }, function (v) { return $9c6911696f98b24c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9c6911696f98b24c$export$d3dfb8e4810cb555; }, function (v) { return $9c6911696f98b24c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9c6911696f98b24c$export$839f9183b0465a69; }, function (v) { return $9c6911696f98b24c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9c6911696f98b24c$export$72fdf0e06517287b; }, function (v) { return $9c6911696f98b24c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9c6911696f98b24c$export$4b844e58a3e414b4; }, function (v) { return $9c6911696f98b24c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9c6911696f98b24c$export$816d2913ae6b83b1; }, function (v) { return $9c6911696f98b24c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9c6911696f98b24c$export$61bcfe829111a1d0; }, function (v) { return $9c6911696f98b24c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9c6911696f98b24c$export$7ee8c9beb337bc3f; }, function (v) { return $9c6911696f98b24c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9c6911696f98b24c$export$b5836b71941fa3ed; }, function (v) { return $9c6911696f98b24c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9c6911696f98b24c$export$cf845f2c119da08a; }, function (v) { return $9c6911696f98b24c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c6911696f98b24c$export$c4744153514ff05d;
var $9c6911696f98b24c$export$3e506c1ccc9cc1a7;
var $9c6911696f98b24c$export$e26fe2ed2fa76875;
var $9c6911696f98b24c$export$502329bbf4b505b1;
var $9c6911696f98b24c$export$6e3807111c4874c4;
var $9c6911696f98b24c$export$c27134553091fb3a;
var $9c6911696f98b24c$export$33ee1acdc04fd2a2;
var $9c6911696f98b24c$export$b00a404bbd5edef2;
var $9c6911696f98b24c$export$8352ce38b91d0c62;
var $9c6911696f98b24c$export$d66a1c1c77bd778b;
var $9c6911696f98b24c$export$d3dfb8e4810cb555;
var $9c6911696f98b24c$export$839f9183b0465a69;
var $9c6911696f98b24c$export$72fdf0e06517287b;
var $9c6911696f98b24c$export$4b844e58a3e414b4;
var $9c6911696f98b24c$export$816d2913ae6b83b1;
var $9c6911696f98b24c$export$61bcfe829111a1d0;
var $9c6911696f98b24c$export$7ee8c9beb337bc3f;
var $9c6911696f98b24c$export$b5836b71941fa3ed;
var $9c6911696f98b24c$export$cf845f2c119da08a;
"use strict";
function $9c6911696f98b24c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9c6911696f98b24c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9c6911696f98b24c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9c6911696f98b24c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9c6911696f98b24c$var$g(C, c)) n < e && 0 > $9c6911696f98b24c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9c6911696f98b24c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9c6911696f98b24c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9c6911696f98b24c$var$l = performance;
    $9c6911696f98b24c$export$c4744153514ff05d = function() {
        return $9c6911696f98b24c$var$l.now();
    };
} else {
    var $9c6911696f98b24c$var$p = Date, $9c6911696f98b24c$var$q = $9c6911696f98b24c$var$p.now();
    $9c6911696f98b24c$export$c4744153514ff05d = function() {
        return $9c6911696f98b24c$var$p.now() - $9c6911696f98b24c$var$q;
    };
}
var $9c6911696f98b24c$var$r = [], $9c6911696f98b24c$var$t = [], $9c6911696f98b24c$var$u = 1, $9c6911696f98b24c$var$v = null, $9c6911696f98b24c$var$y = 3, $9c6911696f98b24c$var$z = !1, $9c6911696f98b24c$var$A = !1, $9c6911696f98b24c$var$B = !1, $9c6911696f98b24c$var$D = "function" === typeof setTimeout ? setTimeout : null, $9c6911696f98b24c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9c6911696f98b24c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9c6911696f98b24c$var$G(a) {
    for(var b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t); null !== b;){
        if (null === b.callback) $9c6911696f98b24c$var$k($9c6911696f98b24c$var$t);
        else if (b.startTime <= a) $9c6911696f98b24c$var$k($9c6911696f98b24c$var$t), b.sortIndex = b.expirationTime, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$r, b);
        else break;
        b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
    }
}
function $9c6911696f98b24c$var$H(a) {
    $9c6911696f98b24c$var$B = !1;
    $9c6911696f98b24c$var$G(a);
    if (!$9c6911696f98b24c$var$A) {
        if (null !== $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r)) $9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J);
        else {
            var b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
            null !== b && $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, b.startTime - a);
        }
    }
}
function $9c6911696f98b24c$var$J(a, b) {
    $9c6911696f98b24c$var$A = !1;
    $9c6911696f98b24c$var$B && ($9c6911696f98b24c$var$B = !1, $9c6911696f98b24c$var$E($9c6911696f98b24c$var$L), $9c6911696f98b24c$var$L = -1);
    $9c6911696f98b24c$var$z = !0;
    var c = $9c6911696f98b24c$var$y;
    try {
        $9c6911696f98b24c$var$G(b);
        for($9c6911696f98b24c$var$v = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r); null !== $9c6911696f98b24c$var$v && (!($9c6911696f98b24c$var$v.expirationTime > b) || a && !$9c6911696f98b24c$var$M());){
            var d = $9c6911696f98b24c$var$v.callback;
            if ("function" === typeof d) {
                $9c6911696f98b24c$var$v.callback = null;
                $9c6911696f98b24c$var$y = $9c6911696f98b24c$var$v.priorityLevel;
                var e = d($9c6911696f98b24c$var$v.expirationTime <= b);
                b = $9c6911696f98b24c$export$c4744153514ff05d();
                "function" === typeof e ? $9c6911696f98b24c$var$v.callback = e : $9c6911696f98b24c$var$v === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r) && $9c6911696f98b24c$var$k($9c6911696f98b24c$var$r);
                $9c6911696f98b24c$var$G(b);
            } else $9c6911696f98b24c$var$k($9c6911696f98b24c$var$r);
            $9c6911696f98b24c$var$v = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r);
        }
        if (null !== $9c6911696f98b24c$var$v) var w = !0;
        else {
            var m = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
            null !== m && $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9c6911696f98b24c$var$v = null, $9c6911696f98b24c$var$y = c, $9c6911696f98b24c$var$z = !1;
    }
}
var $9c6911696f98b24c$var$N = !1, $9c6911696f98b24c$var$O = null, $9c6911696f98b24c$var$L = -1, $9c6911696f98b24c$var$P = 5, $9c6911696f98b24c$var$Q = -1;
function $9c6911696f98b24c$var$M() {
    return $9c6911696f98b24c$export$c4744153514ff05d() - $9c6911696f98b24c$var$Q < $9c6911696f98b24c$var$P ? !1 : !0;
}
function $9c6911696f98b24c$var$R() {
    if (null !== $9c6911696f98b24c$var$O) {
        var a = $9c6911696f98b24c$export$c4744153514ff05d();
        $9c6911696f98b24c$var$Q = a;
        var b = !0;
        try {
            b = $9c6911696f98b24c$var$O(!0, a);
        } finally{
            b ? $9c6911696f98b24c$var$S() : ($9c6911696f98b24c$var$N = !1, $9c6911696f98b24c$var$O = null);
        }
    } else $9c6911696f98b24c$var$N = !1;
}
var $9c6911696f98b24c$var$S;
if ("function" === typeof $9c6911696f98b24c$var$F) $9c6911696f98b24c$var$S = function() {
    $9c6911696f98b24c$var$F($9c6911696f98b24c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9c6911696f98b24c$var$T = new MessageChannel, $9c6911696f98b24c$var$U = $9c6911696f98b24c$var$T.port2;
    $9c6911696f98b24c$var$T.port1.onmessage = $9c6911696f98b24c$var$R;
    $9c6911696f98b24c$var$S = function() {
        $9c6911696f98b24c$var$U.postMessage(null);
    };
} else $9c6911696f98b24c$var$S = function() {
    $9c6911696f98b24c$var$D($9c6911696f98b24c$var$R, 0);
};
function $9c6911696f98b24c$var$I(a) {
    $9c6911696f98b24c$var$O = a;
    $9c6911696f98b24c$var$N || ($9c6911696f98b24c$var$N = !0, $9c6911696f98b24c$var$S());
}
function $9c6911696f98b24c$var$K(a, b) {
    $9c6911696f98b24c$var$L = $9c6911696f98b24c$var$D(function() {
        a($9c6911696f98b24c$export$c4744153514ff05d());
    }, b);
}
$9c6911696f98b24c$export$3e506c1ccc9cc1a7 = 5;
$9c6911696f98b24c$export$e26fe2ed2fa76875 = 1;
$9c6911696f98b24c$export$502329bbf4b505b1 = 4;
$9c6911696f98b24c$export$6e3807111c4874c4 = 3;
$9c6911696f98b24c$export$c27134553091fb3a = null;
$9c6911696f98b24c$export$33ee1acdc04fd2a2 = 2;
$9c6911696f98b24c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9c6911696f98b24c$export$8352ce38b91d0c62 = function() {
    $9c6911696f98b24c$var$A || $9c6911696f98b24c$var$z || ($9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J));
};
$9c6911696f98b24c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9c6911696f98b24c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9c6911696f98b24c$export$d3dfb8e4810cb555 = function() {
    return $9c6911696f98b24c$var$y;
};
$9c6911696f98b24c$export$839f9183b0465a69 = function() {
    return $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r);
};
$9c6911696f98b24c$export$72fdf0e06517287b = function(a) {
    switch($9c6911696f98b24c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9c6911696f98b24c$var$y;
    }
    var c = $9c6911696f98b24c$var$y;
    $9c6911696f98b24c$var$y = b;
    try {
        return a();
    } finally{
        $9c6911696f98b24c$var$y = c;
    }
};
$9c6911696f98b24c$export$4b844e58a3e414b4 = function() {};
$9c6911696f98b24c$export$816d2913ae6b83b1 = function() {};
$9c6911696f98b24c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9c6911696f98b24c$var$y;
    $9c6911696f98b24c$var$y = a;
    try {
        return b();
    } finally{
        $9c6911696f98b24c$var$y = c;
    }
};
$9c6911696f98b24c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9c6911696f98b24c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9c6911696f98b24c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$t, a), null === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r) && a === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t) && ($9c6911696f98b24c$var$B ? ($9c6911696f98b24c$var$E($9c6911696f98b24c$var$L), $9c6911696f98b24c$var$L = -1) : $9c6911696f98b24c$var$B = !0, $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, c - d))) : (a.sortIndex = e, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$r, a), $9c6911696f98b24c$var$A || $9c6911696f98b24c$var$z || ($9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J)));
    return a;
};
$9c6911696f98b24c$export$b5836b71941fa3ed = $9c6911696f98b24c$var$M;
$9c6911696f98b24c$export$cf845f2c119da08a = function(a) {
    var b = $9c6911696f98b24c$var$y;
    return function() {
        var c = $9c6911696f98b24c$var$y;
        $9c6911696f98b24c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9c6911696f98b24c$var$y = c;
        }
    };
};

});



parcelRegister("gwgqN", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $c06c6167c0d9656d$export$a7c73072b1a182ae; }, function (v) { return $c06c6167c0d9656d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c06c6167c0d9656d$export$9f27bc3417b4524d; }, function (v) { return $c06c6167c0d9656d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c06c6167c0d9656d$export$db77ccec0bb4ccac; }, function (v) { return $c06c6167c0d9656d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c06c6167c0d9656d$export$8392c0c9d3dcbd35; }, function (v) { return $c06c6167c0d9656d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c06c6167c0d9656d$export$ffb0004e005737fa; }, function (v) { return $c06c6167c0d9656d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c06c6167c0d9656d$export$b624eff549462981; }, function (v) { return $c06c6167c0d9656d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c06c6167c0d9656d$export$7897aa7841a5380c; }, function (v) { return $c06c6167c0d9656d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c06c6167c0d9656d$export$602eac185826482c; }, function (v) { return $c06c6167c0d9656d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c06c6167c0d9656d$export$e2c29f18771995cb; }, function (v) { return $c06c6167c0d9656d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c06c6167c0d9656d$export$5f8d39834fd61797; }, function (v) { return $c06c6167c0d9656d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c06c6167c0d9656d$export$74bf444e3cd11ea5; }, function (v) { return $c06c6167c0d9656d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $c06c6167c0d9656d$export$998bcd577473dd93; }, function (v) { return $c06c6167c0d9656d$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c06c6167c0d9656d$export$92387174baf9b227; }, function (v) { return $c06c6167c0d9656d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c06c6167c0d9656d$export$ec112efeb987d9c6; }, function (v) { return $c06c6167c0d9656d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c06c6167c0d9656d$export$b706b080d889d2c9; }, function (v) { return $c06c6167c0d9656d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c06c6167c0d9656d$export$5be5a87408f70ddc; }, function (v) { return $c06c6167c0d9656d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c06c6167c0d9656d$export$45a5e7f76e0caa8d; }, function (v) { return $c06c6167c0d9656d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c06c6167c0d9656d$export$455c2e768291efa6; }, function (v) { return $c06c6167c0d9656d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c06c6167c0d9656d$export$9522e17588c12572; }, function (v) { return $c06c6167c0d9656d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c06c6167c0d9656d$export$2110ac352bb060b9; }, function (v) { return $c06c6167c0d9656d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c06c6167c0d9656d$export$56885ab8b9c456ab; }, function (v) { return $c06c6167c0d9656d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c06c6167c0d9656d$export$d927fcb6adf8f9de; }, function (v) { return $c06c6167c0d9656d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c06c6167c0d9656d$export$b82d16f27459e05a; }, function (v) { return $c06c6167c0d9656d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c06c6167c0d9656d$export$522c17b4f5e123e8; }, function (v) { return $c06c6167c0d9656d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c06c6167c0d9656d$export$1aabd8a0274ecfd6; }, function (v) { return $c06c6167c0d9656d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $c06c6167c0d9656d$export$3d6c20d97e46b957; }, function (v) { return $c06c6167c0d9656d$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c06c6167c0d9656d$export$9b621391a187a31a; }, function (v) { return $c06c6167c0d9656d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c06c6167c0d9656d$export$f5bbd400c2f4426f; }, function (v) { return $c06c6167c0d9656d$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c06c6167c0d9656d$export$a7c73072b1a182ae;
var $c06c6167c0d9656d$export$9f27bc3417b4524d;
var $c06c6167c0d9656d$export$db77ccec0bb4ccac;
var $c06c6167c0d9656d$export$8392c0c9d3dcbd35;
var $c06c6167c0d9656d$export$ffb0004e005737fa;
var $c06c6167c0d9656d$export$b624eff549462981;
var $c06c6167c0d9656d$export$7897aa7841a5380c;
var $c06c6167c0d9656d$export$602eac185826482c;
var $c06c6167c0d9656d$export$e2c29f18771995cb;
var $c06c6167c0d9656d$export$5f8d39834fd61797;
var $c06c6167c0d9656d$export$74bf444e3cd11ea5;
var $c06c6167c0d9656d$export$998bcd577473dd93;
var $c06c6167c0d9656d$export$92387174baf9b227;
var $c06c6167c0d9656d$export$ec112efeb987d9c6;
var $c06c6167c0d9656d$export$b706b080d889d2c9;
var $c06c6167c0d9656d$export$5be5a87408f70ddc;
var $c06c6167c0d9656d$export$45a5e7f76e0caa8d;
var $c06c6167c0d9656d$export$455c2e768291efa6;
var $c06c6167c0d9656d$export$9522e17588c12572;
var $c06c6167c0d9656d$export$2110ac352bb060b9;
var $c06c6167c0d9656d$export$56885ab8b9c456ab;
var $c06c6167c0d9656d$export$d927fcb6adf8f9de;
var $c06c6167c0d9656d$export$b82d16f27459e05a;
var $c06c6167c0d9656d$export$522c17b4f5e123e8;
var $c06c6167c0d9656d$export$1aabd8a0274ecfd6;
var $c06c6167c0d9656d$export$3d6c20d97e46b957;
var $c06c6167c0d9656d$export$9b621391a187a31a;
var $c06c6167c0d9656d$export$f5bbd400c2f4426f;
"use strict";
var $c06c6167c0d9656d$var$b = Symbol.for("react.element"), $c06c6167c0d9656d$var$c = Symbol.for("react.portal"), $c06c6167c0d9656d$var$d = Symbol.for("react.fragment"), $c06c6167c0d9656d$var$e = Symbol.for("react.strict_mode"), $c06c6167c0d9656d$var$f = Symbol.for("react.profiler"), $c06c6167c0d9656d$var$g = Symbol.for("react.provider"), $c06c6167c0d9656d$var$h = Symbol.for("react.context"), $c06c6167c0d9656d$var$k = Symbol.for("react.server_context"), $c06c6167c0d9656d$var$l = Symbol.for("react.forward_ref"), $c06c6167c0d9656d$var$m = Symbol.for("react.suspense"), $c06c6167c0d9656d$var$n = Symbol.for("react.suspense_list"), $c06c6167c0d9656d$var$p = Symbol.for("react.memo"), $c06c6167c0d9656d$var$q = Symbol.for("react.lazy"), $c06c6167c0d9656d$var$t = Symbol.for("react.offscreen"), $c06c6167c0d9656d$var$u;
$c06c6167c0d9656d$var$u = Symbol.for("react.module.reference");
function $c06c6167c0d9656d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $c06c6167c0d9656d$var$b:
                switch(a = a.type, a){
                    case $c06c6167c0d9656d$var$d:
                    case $c06c6167c0d9656d$var$f:
                    case $c06c6167c0d9656d$var$e:
                    case $c06c6167c0d9656d$var$m:
                    case $c06c6167c0d9656d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c06c6167c0d9656d$var$k:
                            case $c06c6167c0d9656d$var$h:
                            case $c06c6167c0d9656d$var$l:
                            case $c06c6167c0d9656d$var$q:
                            case $c06c6167c0d9656d$var$p:
                            case $c06c6167c0d9656d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $c06c6167c0d9656d$var$c:
                return r;
        }
    }
}
$c06c6167c0d9656d$export$a7c73072b1a182ae = $c06c6167c0d9656d$var$h;
$c06c6167c0d9656d$export$9f27bc3417b4524d = $c06c6167c0d9656d$var$g;
$c06c6167c0d9656d$export$db77ccec0bb4ccac = $c06c6167c0d9656d$var$b;
$c06c6167c0d9656d$export$8392c0c9d3dcbd35 = $c06c6167c0d9656d$var$l;
$c06c6167c0d9656d$export$ffb0004e005737fa = $c06c6167c0d9656d$var$d;
$c06c6167c0d9656d$export$b624eff549462981 = $c06c6167c0d9656d$var$q;
$c06c6167c0d9656d$export$7897aa7841a5380c = $c06c6167c0d9656d$var$p;
$c06c6167c0d9656d$export$602eac185826482c = $c06c6167c0d9656d$var$c;
$c06c6167c0d9656d$export$e2c29f18771995cb = $c06c6167c0d9656d$var$f;
$c06c6167c0d9656d$export$5f8d39834fd61797 = $c06c6167c0d9656d$var$e;
$c06c6167c0d9656d$export$74bf444e3cd11ea5 = $c06c6167c0d9656d$var$m;
$c06c6167c0d9656d$export$998bcd577473dd93 = $c06c6167c0d9656d$var$n;
$c06c6167c0d9656d$export$92387174baf9b227 = function() {
    return !1;
};
$c06c6167c0d9656d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$c06c6167c0d9656d$export$b706b080d889d2c9 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$h;
};
$c06c6167c0d9656d$export$5be5a87408f70ddc = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$g;
};
$c06c6167c0d9656d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c06c6167c0d9656d$var$b;
};
$c06c6167c0d9656d$export$455c2e768291efa6 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$l;
};
$c06c6167c0d9656d$export$9522e17588c12572 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$d;
};
$c06c6167c0d9656d$export$2110ac352bb060b9 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$q;
};
$c06c6167c0d9656d$export$56885ab8b9c456ab = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$p;
};
$c06c6167c0d9656d$export$d927fcb6adf8f9de = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$c;
};
$c06c6167c0d9656d$export$b82d16f27459e05a = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$f;
};
$c06c6167c0d9656d$export$522c17b4f5e123e8 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$e;
};
$c06c6167c0d9656d$export$1aabd8a0274ecfd6 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$m;
};
$c06c6167c0d9656d$export$3d6c20d97e46b957 = function(a) {
    return $c06c6167c0d9656d$var$v(a) === $c06c6167c0d9656d$var$n;
};
$c06c6167c0d9656d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c06c6167c0d9656d$var$d || a === $c06c6167c0d9656d$var$f || a === $c06c6167c0d9656d$var$e || a === $c06c6167c0d9656d$var$m || a === $c06c6167c0d9656d$var$n || a === $c06c6167c0d9656d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $c06c6167c0d9656d$var$q || a.$$typeof === $c06c6167c0d9656d$var$p || a.$$typeof === $c06c6167c0d9656d$var$g || a.$$typeof === $c06c6167c0d9656d$var$h || a.$$typeof === $c06c6167c0d9656d$var$l || a.$$typeof === $c06c6167c0d9656d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$c06c6167c0d9656d$export$f5bbd400c2f4426f = $c06c6167c0d9656d$var$v;

});

parcelRegister("gVIri", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $c53470ea0aa5d9bd$export$306c0aa65ff9ec16; }, function (v) { return $c53470ea0aa5d9bd$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c53470ea0aa5d9bd$export$306c0aa65ff9ec16;
"use strict";

var $4HBpa = parcelRequire("4HBpa");
function $c53470ea0aa5d9bd$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c53470ea0aa5d9bd$var$k = "function" === typeof Object.is ? Object.is : $c53470ea0aa5d9bd$var$h, $c53470ea0aa5d9bd$var$l = $4HBpa.useState, $c53470ea0aa5d9bd$var$m = $4HBpa.useEffect, $c53470ea0aa5d9bd$var$n = $4HBpa.useLayoutEffect, $c53470ea0aa5d9bd$var$p = $4HBpa.useDebugValue;
function $c53470ea0aa5d9bd$var$q(a, b) {
    var d = b(), f = $c53470ea0aa5d9bd$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $c53470ea0aa5d9bd$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $c53470ea0aa5d9bd$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $c53470ea0aa5d9bd$var$m(function() {
        $c53470ea0aa5d9bd$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $c53470ea0aa5d9bd$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $c53470ea0aa5d9bd$var$p(d);
    return d;
}
function $c53470ea0aa5d9bd$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$c53470ea0aa5d9bd$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $c53470ea0aa5d9bd$var$t(a, b) {
    return b();
}
var $c53470ea0aa5d9bd$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c53470ea0aa5d9bd$var$t : $c53470ea0aa5d9bd$var$q;
$c53470ea0aa5d9bd$export$306c0aa65ff9ec16 = void 0 !== $4HBpa.useSyncExternalStore ? $4HBpa.useSyncExternalStore : $c53470ea0aa5d9bd$var$u;

});

parcelRegister("eOEwK", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $ac952c09ad8f194b$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $ac952c09ad8f194b$var$extendStatics = function(d, b) {
    $ac952c09ad8f194b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ac952c09ad8f194b$var$extendStatics(d, b);
};
function $ac952c09ad8f194b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ac952c09ad8f194b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ac952c09ad8f194b$export$18ce0697a983be9b = function() {
    $ac952c09ad8f194b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ac952c09ad8f194b$export$18ce0697a983be9b.apply(this, arguments);
};
function $ac952c09ad8f194b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ac952c09ad8f194b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ac952c09ad8f194b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ac952c09ad8f194b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ac952c09ad8f194b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ac952c09ad8f194b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ac952c09ad8f194b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ac952c09ad8f194b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ac952c09ad8f194b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ac952c09ad8f194b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ac952c09ad8f194b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ac952c09ad8f194b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ac952c09ad8f194b$export$45d3717a4c69092e(o, m, p);
}
function $ac952c09ad8f194b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ac952c09ad8f194b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ac952c09ad8f194b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ac952c09ad8f194b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ac952c09ad8f194b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ac952c09ad8f194b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ac952c09ad8f194b$export$10c90e4f7922046c(v) {
    return this instanceof $ac952c09ad8f194b$export$10c90e4f7922046c ? (this.v = v, this) : new $ac952c09ad8f194b$export$10c90e4f7922046c(v);
}
function $ac952c09ad8f194b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ac952c09ad8f194b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ac952c09ad8f194b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ac952c09ad8f194b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ac952c09ad8f194b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ac952c09ad8f194b$export$19a8beecd37a4c45 === "function" ? $ac952c09ad8f194b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ac952c09ad8f194b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ac952c09ad8f194b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $ac952c09ad8f194b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ac952c09ad8f194b$export$45d3717a4c69092e(result, mod, k);
    }
    $ac952c09ad8f194b$var$__setModuleDefault(result, mod);
    return result;
}
function $ac952c09ad8f194b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ac952c09ad8f194b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ac952c09ad8f194b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ac952c09ad8f194b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ac952c09ad8f194b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ac952c09ad8f194b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ac952c09ad8f194b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ac952c09ad8f194b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $ac952c09ad8f194b$export$2e2bcd8739ae039 = {
    __extends: $ac952c09ad8f194b$export$a8ba968b8961cb8a,
    __assign: $ac952c09ad8f194b$export$18ce0697a983be9b,
    __rest: $ac952c09ad8f194b$export$3c9a16f847548506,
    __decorate: $ac952c09ad8f194b$export$29e00dfd3077644b,
    __param: $ac952c09ad8f194b$export$d5ad3fd78186038f,
    __metadata: $ac952c09ad8f194b$export$f1db080c865becb9,
    __awaiter: $ac952c09ad8f194b$export$1050f835b63b671e,
    __generator: $ac952c09ad8f194b$export$67ebef60e6f28a6,
    __createBinding: $ac952c09ad8f194b$export$45d3717a4c69092e,
    __exportStar: $ac952c09ad8f194b$export$f33643c0debef087,
    __values: $ac952c09ad8f194b$export$19a8beecd37a4c45,
    __read: $ac952c09ad8f194b$export$8d051b38c9118094,
    __spread: $ac952c09ad8f194b$export$afc72e2116322959,
    __spreadArrays: $ac952c09ad8f194b$export$6388937ca91ccae8,
    __spreadArray: $ac952c09ad8f194b$export$1216008129fb82ed,
    __await: $ac952c09ad8f194b$export$10c90e4f7922046c,
    __asyncGenerator: $ac952c09ad8f194b$export$e427f37a30a4de9b,
    __asyncDelegator: $ac952c09ad8f194b$export$bbd80228419bb833,
    __asyncValues: $ac952c09ad8f194b$export$e3b29a3d6162315f,
    __makeTemplateObject: $ac952c09ad8f194b$export$4fb47efe1390b86f,
    __importStar: $ac952c09ad8f194b$export$c21735bcef00d192,
    __importDefault: $ac952c09ad8f194b$export$da59b14a69baef04,
    __classPrivateFieldGet: $ac952c09ad8f194b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ac952c09ad8f194b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ac952c09ad8f194b$export$81fdc39f203e4e04,
    __addDisposableResource: $ac952c09ad8f194b$export$88ac25d8e944e405,
    __disposeResources: $ac952c09ad8f194b$export$8f076105dc360e92
};

});

parcelRegister("lf9Oh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f7729bc229bee435$export$2e2bcd8739ae039; });

var $4HBpa = parcelRequire("4HBpa");

var $jgO6T = parcelRequire("jgO6T");

var $2ldO2 = parcelRequire("2ldO2");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f7729bc229bee435$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f7729bc229bee435$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f7729bc229bee435$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $f7729bc229bee435$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $f7729bc229bee435$var$ClientEditorCore {
    constructor(_a){
        var { tools: tools } = _a, config = $f7729bc229bee435$var$__rest(_a, [
            "tools"
        ]);
        const extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $2ldO2.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $jgO6T.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    get dangerouslyLowLevelInstance() {
        return this._editorJS;
    }
    clear() {
        return $f7729bc229bee435$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.clear();
        });
    }
    save() {
        return $f7729bc229bee435$var$__awaiter(this, void 0, void 0, function*() {
            return this._editorJS.save();
        });
    }
    destroy() {
        return $f7729bc229bee435$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.isReady;
            yield this._editorJS.destroy();
        });
    }
    render(data) {
        return $f7729bc229bee435$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.render(data);
        });
    }
}
function $f7729bc229bee435$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useCallback((config)=>new $f7729bc229bee435$var$ClientEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement($f7729bc229bee435$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("jgO6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca477aae3d96de69$export$2e2bcd8739ae039; });
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $ca477aae3d96de69$var$ko = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $ca477aae3d96de69$var$Fe(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $ca477aae3d96de69$var$ze() {}
Object.assign($ca477aae3d96de69$var$ze, {
    default: $ca477aae3d96de69$var$ze,
    register: $ca477aae3d96de69$var$ze,
    revert: function() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    const e = (this.document || this.ownerDocument).querySelectorAll(n);
    let t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    let e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    const t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach((o)=>{
        const i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    const e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, l = this.offsetLeft - e.offsetLeft < e.scrollLeft, a = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (l || a) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || l || a) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    const e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
let $ca477aae3d96de69$var$vo = (n = 21)=>crypto.getRandomValues(new Uint8Array(n)).reduce((e, t1)=>(t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e), "");
var $ca477aae3d96de69$var$St = /* @__PURE__ */ ((n)=>(n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n))($ca477aae3d96de69$var$St || {});
const $ca477aae3d96de69$var$w = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $ca477aae3d96de69$var$wo = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $ca477aae3d96de69$var$Be(n, e, t1 = "log", o, i = "color: inherit") {
    if (!("console" in window) || !window.console[t1]) return;
    const s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($ca477aae3d96de69$var$Be.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    const l = "Editor.js 2.30.5", a = `line-height: 1em;
            color: #006FEA;
            display: inline-block;
            font-size: 11px;
            line-height: 1em;
            background-color: #fff;
            padding: 4px 9px;
            border-radius: 30px;
            border: 1px solid rgba(56, 138, 229, 0.16);
            margin: 4px 5px 4px 0;`;
    n && (s ? (r.unshift(a, i), e = `%c${l}%c ${e}`) : e = `( ${l} )${e}`);
    try {
        s ? o ? console[t1](`${e} %o`, ...r) : console[t1](e, ...r) : console[t1](e);
    } catch  {}
}
$ca477aae3d96de69$var$Be.logLevel = "VERBOSE";
function $ca477aae3d96de69$var$xo(n) {
    $ca477aae3d96de69$var$Be.logLevel = n;
}
const $ca477aae3d96de69$var$I = $ca477aae3d96de69$var$Be.bind(window, !1), $ca477aae3d96de69$var$X = $ca477aae3d96de69$var$Be.bind(window, !0);
function $ca477aae3d96de69$var$re(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $ca477aae3d96de69$var$O(n) {
    return $ca477aae3d96de69$var$re(n) === "function" || $ca477aae3d96de69$var$re(n) === "asyncfunction";
}
function $ca477aae3d96de69$var$R(n) {
    return $ca477aae3d96de69$var$re(n) === "object";
}
function $ca477aae3d96de69$var$Q(n) {
    return $ca477aae3d96de69$var$re(n) === "string";
}
function $ca477aae3d96de69$var$yo(n) {
    return $ca477aae3d96de69$var$re(n) === "boolean";
}
function $ca477aae3d96de69$var$mt(n) {
    return $ca477aae3d96de69$var$re(n) === "number";
}
function $ca477aae3d96de69$var$bt(n) {
    return $ca477aae3d96de69$var$re(n) === "undefined";
}
function $ca477aae3d96de69$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $ca477aae3d96de69$var$It(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
async function $ca477aae3d96de69$var$Eo(n, e = ()=>{}, t1 = ()=>{}) {
    async function o(i, s, r) {
        try {
            await i.function(i.data), await s($ca477aae3d96de69$var$bt(i.data) ? {} : i.data);
        } catch  {
            r($ca477aae3d96de69$var$bt(i.data) ? {} : i.data);
        }
    }
    return n.reduce(async (i, s)=>(await i, o(s, e, t1)), Promise.resolve());
}
function $ca477aae3d96de69$var$Mt(n) {
    return Array.prototype.slice.call(n);
}
function $ca477aae3d96de69$var$Oe(n, e) {
    return function() {
        const t1 = this, o = arguments;
        window.setTimeout(()=>n.apply(t1, o), e);
    };
}
function $ca477aae3d96de69$var$Bo(n) {
    return n.name.split(".").pop();
}
function $ca477aae3d96de69$var$To(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $ca477aae3d96de69$var$kt(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = null, t1 || n.apply(s, i);
        }, l = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), l && n.apply(s, i);
    };
}
function $ca477aae3d96de69$var$Ve(n, e, t1) {
    let o, i, s, r = null, l = 0;
    t1 || (t1 = {});
    const a = function() {
        l = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        const c = Date.now();
        !l && t1.leading === !1 && (l = c);
        const u = e - (c - l);
        return o = this, i = arguments, u <= 0 || u > e ? (r && (clearTimeout(r), r = null), l = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(a, u)), s;
    };
}
function $ca477aae3d96de69$var$Co() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e && (n[e] = !0), n;
}
function $ca477aae3d96de69$var$Le(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $ca477aae3d96de69$var$qe(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($ca477aae3d96de69$var$R(n) && $ca477aae3d96de69$var$R(t1)) for(const o in t1)$ca477aae3d96de69$var$R(t1[o]) ? (n[o] || Object.assign(n, {
        [o]: {}
    }), $ca477aae3d96de69$var$qe(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $ca477aae3d96de69$var$qe(n, ...e);
}
function $ca477aae3d96de69$var$et(n) {
    const e = $ca477aae3d96de69$var$Co();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $ca477aae3d96de69$var$So(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $ca477aae3d96de69$var$Io() {
    return $ca477aae3d96de69$var$vo(10);
}
function $ca477aae3d96de69$var$Mo(n) {
    window.open(n, "_blank");
}
function $ca477aae3d96de69$var$Ao(n = "") {
    return `${n}${Math.floor(Math.random() * 1e8).toString(16)}`;
}
function $ca477aae3d96de69$var$Ze(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && $ca477aae3d96de69$var$X(o, "warn");
}
function $ca477aae3d96de69$var$ue(n, e, t1) {
    const o = t1.value ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, ...r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(l) {
            delete n[s], r.apply(this, l);
        };
    }
    return t1;
}
const $ca477aae3d96de69$var$At = 650;
function $ca477aae3d96de69$var$pe() {
    return window.matchMedia(`(max-width: ${$ca477aae3d96de69$var$At}px)`).matches;
}
const $ca477aae3d96de69$var$Ge = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $ca477aae3d96de69$var$Oo(n, e) {
    const t1 = Array.isArray(n) || $ca477aae3d96de69$var$R(n), o = Array.isArray(e) || $ca477aae3d96de69$var$R(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
class $ca477aae3d96de69$var$d {
    /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ static isSingleTag(e) {
        return e.tagName && [
            "AREA",
            "BASE",
            "BR",
            "COL",
            "COMMAND",
            "EMBED",
            "HR",
            "IMG",
            "INPUT",
            "KEYGEN",
            "LINK",
            "META",
            "PARAM",
            "SOURCE",
            "TRACK",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ static isLineBreakTag(e) {
        return e && e.tagName && [
            "BR",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ static make(e, t1 = null, o = {}) {
        const i = document.createElement(e);
        if (Array.isArray(t1)) {
            const s = t1.filter((r)=>r !== void 0);
            i.classList.add(...s);
        } else t1 && i.classList.add(t1);
        for(const s in o)Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
        return i;
    }
    /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ static text(e) {
        return document.createTextNode(e);
    }
    /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ static append(e, t1) {
        Array.isArray(t1) ? t1.forEach((o)=>e.appendChild(o)) : e.appendChild(t1);
    }
    /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ static prepend(e, t1) {
        Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach((o)=>e.prepend(o))) : e.prepend(t1);
    }
    /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ static swap(e, t1) {
        const o = document.createElement("div"), i = e.parentNode;
        i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
    }
    /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ static find(e = document, t1) {
        return e.querySelector(t1);
    }
    /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ static get(e) {
        return document.getElementById(e);
    }
    /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ static findAll(e = document, t1) {
        return e.querySelectorAll(t1);
    }
    /**
   * Returns CSS selector for all text inputs
   */ static get allInputsSelector() {
        return "[contenteditable=true], textarea, input:not([type]), " + [
            "text",
            "password",
            "email",
            "number",
            "search",
            "tel",
            "url"
        ].map((t1)=>`input[type="${t1}"]`).join(", ");
    }
    /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ static findAllInputs(e) {
        return $ca477aae3d96de69$var$Mt(e.querySelectorAll($ca477aae3d96de69$var$d.allInputsSelector)).reduce((t1, o)=>$ca477aae3d96de69$var$d.isNativeInput(o) || $ca477aae3d96de69$var$d.containsOnlyInlineElements(o) ? [
                ...t1,
                o
            ] : [
                ...t1,
                ...$ca477aae3d96de69$var$d.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ static getDeepestNode(e, t1 = !1) {
        const o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
        if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
            let s = e[o];
            if ($ca477aae3d96de69$var$d.isSingleTag(s) && !$ca477aae3d96de69$var$d.isNativeInput(s) && !$ca477aae3d96de69$var$d.isLineBreakTag(s)) {
                if (s[i]) s = s[i];
                else if (s.parentNode[i]) s = s.parentNode[i];
                else return s.parentNode;
            }
            return this.getDeepestNode(s, t1);
        }
        return e;
    }
    /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isElement(e) {
        return $ca477aae3d96de69$var$mt(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isFragment(e) {
        return $ca477aae3d96de69$var$mt(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ static isContentEditable(e) {
        return e.contentEditable === "true";
    }
    /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNativeInput(e) {
        const t1 = [
            "INPUT",
            "TEXTAREA"
        ];
        return e && e.tagName ? t1.includes(e.tagName) : !1;
    }
    /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ static canSetCaret(e) {
        let t1 = !0;
        if ($ca477aae3d96de69$var$d.isNativeInput(e)) switch(e.type){
            case "file":
            case "checkbox":
            case "radio":
            case "hidden":
            case "submit":
            case "button":
            case "image":
            case "reset":
                t1 = !1;
                break;
        }
        else t1 = $ca477aae3d96de69$var$d.isContentEditable(e);
        return t1;
    }
    /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ static isNodeEmpty(e, t1) {
        let o;
        return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.trim().length === 0);
    }
    /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ static isLeaf(e) {
        return e ? e.childNodes.length === 0 : !1;
    }
    /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ static isEmpty(e, t1) {
        e.normalize();
        const o = [
            e
        ];
        for(; o.length > 0;)if (e = o.shift(), !!e) {
            if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
            e.childNodes && o.push(...Array.from(e.childNodes));
        }
        return !0;
    }
    /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ static isHTMLString(e) {
        const t1 = $ca477aae3d96de69$var$d.make("div");
        return t1.innerHTML = e, t1.childElementCount > 0;
    }
    /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ static getContentLength(e) {
        return $ca477aae3d96de69$var$d.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ static get blockElements() {
        return [
            "address",
            "article",
            "aside",
            "blockquote",
            "canvas",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "li",
            "main",
            "nav",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "ruby",
            "section",
            "table",
            "tbody",
            "thead",
            "tr",
            "tfoot",
            "ul",
            "video"
        ];
    }
    /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ static containsOnlyInlineElements(e) {
        let t1;
        $ca477aae3d96de69$var$Q(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
        const o = (i)=>!$ca477aae3d96de69$var$d.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
        return Array.from(t1.children).every(o);
    }
    /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ static getDeepestBlockElements(e) {
        return $ca477aae3d96de69$var$d.containsOnlyInlineElements(e) ? [
            e
        ] : Array.from(e.children).reduce((t1, o)=>[
                ...t1,
                ...$ca477aae3d96de69$var$d.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ static getHolder(e) {
        return $ca477aae3d96de69$var$Q(e) ? document.getElementById(e) : e;
    }
    /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ static isAnchor(e) {
        return e.tagName.toLowerCase() === "a";
    }
    /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ static offset(e) {
        const t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
        return {
            top: s,
            left: r,
            bottom: s + t1.height,
            right: r + t1.width
        };
    }
}
function $ca477aae3d96de69$var$Lo(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $ca477aae3d96de69$var$_o(n) {
    const e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), l = t1 * 0.8, a = (o - t1) / 2;
    return r + s + i + a + l;
}
function $ca477aae3d96de69$var$Ot(n) {
    n.dataset.empty = $ca477aae3d96de69$var$d.isEmpty(n) ? "true" : "false";
}
const $ca477aae3d96de69$var$No = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $ca477aae3d96de69$var$Po = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $ca477aae3d96de69$var$Do = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $ca477aae3d96de69$var$Ro = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $ca477aae3d96de69$var$Lt = {
    ui: $ca477aae3d96de69$var$No,
    toolNames: $ca477aae3d96de69$var$Po,
    tools: $ca477aae3d96de69$var$Do,
    blockTunes: $ca477aae3d96de69$var$Ro
}, $ca477aae3d96de69$var$_t = class ae {
    /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static ui(e, t1) {
        return ae._t(e, t1);
    }
    /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static t(e, t1) {
        return ae._t(e, t1);
    }
    /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ static setDictionary(e) {
        ae.currentDictionary = e;
    }
    /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static _t(e, t1) {
        const o = ae.getNamespace(e);
        return !o || !o[t1] ? t1 : o[t1];
    }
    /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ static getNamespace(e) {
        return e.split(".").reduce((o, i)=>!o || !Object.keys(o).length ? {} : o[i], ae.currentDictionary);
    }
};
$ca477aae3d96de69$var$_t.currentDictionary = $ca477aae3d96de69$var$Lt;
let $ca477aae3d96de69$var$z = $ca477aae3d96de69$var$_t;
class $ca477aae3d96de69$var$Nt extends Error {
}
class $ca477aae3d96de69$var$Te {
    constructor(){
        this.subscribers = {};
    }
    /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ on(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
    }
    /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ once(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []);
        const o = (i)=>{
            const s = t1(i), r = this.subscribers[e].indexOf(o);
            return r !== -1 && this.subscribers[e].splice(r, 1), s;
        };
        this.subscribers[e].push(o);
    }
    /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ emit(e, t1) {
        $ca477aae3d96de69$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce((o, i)=>{
            const s = i(o);
            return s !== void 0 ? s : o;
        }, t1);
    }
    /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ off(e, t1) {
        if (this.subscribers[e] === void 0) {
            console.warn(`EventDispatcher .off(): there is no subscribers for event "${e.toString()}". Probably, .off() called before .on()`);
            return;
        }
        for(let o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
            delete this.subscribers[e][o];
            break;
        }
    }
    /**
   * Destroyer
   * clears subscribers list
   */ destroy() {
        this.subscribers = {};
    }
}
function $ca477aae3d96de69$var$G(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call (t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save () {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate (t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange () {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry () {
            return n.getActiveToolboxEntry();
        }
    });
}
class $ca477aae3d96de69$var$Ce {
    constructor(){
        this.allListeners = [];
    }
    /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ on(e, t1, o, i = !1) {
        const s = $ca477aae3d96de69$var$Ao("l"), r = {
            id: s,
            element: e,
            eventType: t1,
            handler: o,
            options: i
        };
        if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
    }
    /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ off(e, t1, o, i) {
        const s = this.findAll(e, t1, o);
        s.forEach((r, l)=>{
            const a = this.allListeners.indexOf(s[l]);
            a > -1 && (this.allListeners.splice(a, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
        });
    }
    /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ offById(e) {
        const t1 = this.findById(e);
        t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
    }
    /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ findOne(e, t1, o) {
        const i = this.findAll(e, t1, o);
        return i.length > 0 ? i[0] : null;
    }
    /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ findAll(e, t1, o) {
        let i;
        const s = e ? this.findByEventTarget(e) : [];
        return e && t1 && o ? i = s.filter((r)=>r.eventType === t1 && r.handler === o) : e && t1 ? i = s.filter((r)=>r.eventType === t1) : i = s, i;
    }
    /**
   * Removes all listeners
   */ removeAll() {
        this.allListeners.map((e)=>{
            e.element.removeEventListener(e.eventType, e.handler, e.options);
        }), this.allListeners = [];
    }
    /**
   * Module cleanup on destruction
   */ destroy() {
        this.removeAll();
    }
    /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ findByEventTarget(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.element === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ findByType(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.eventType === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ findByHandler(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.handler === e) return t1;
        });
    }
    /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ findById(e) {
        return this.allListeners.find((t1)=>t1.id === e);
    }
}
class $ca477aae3d96de69$var$y {
    /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        if (this.nodes = {}, this.listeners = new $ca477aae3d96de69$var$Ce(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: (o, i, s, r = !1)=>{
                this.mutableListenerIds.push(this.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: ()=>{
                for (const o of this.mutableListenerIds)this.listeners.offById(o);
                this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], new.target === $ca477aae3d96de69$var$y) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ set state(e) {
        this.Editor = e;
    }
    /**
   * Remove memorized nodes
   */ removeAllNodes() {
        for(const e in this.nodes){
            const t1 = this.nodes[e];
            t1 instanceof HTMLElement && t1.remove();
        }
    }
    /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ get isRtl() {
        return this.config.i18n.direction === "rtl";
    }
}
class $ca477aae3d96de69$var$b {
    constructor(){
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor", this.commandRemoveFormat = "removeFormat";
    }
    /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ static get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorZone: "codex-editor__redactor"
        };
    }
    /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ static get anchorNode() {
        const e = window.getSelection();
        return e ? e.anchorNode : null;
    }
    /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ static get anchorElement() {
        const e = window.getSelection();
        if (!e) return null;
        const t1 = e.anchorNode;
        return t1 ? $ca477aae3d96de69$var$d.isElement(t1) ? t1 : t1.parentElement : null;
    }
    /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ static get anchorOffset() {
        const e = window.getSelection();
        return e ? e.anchorOffset : null;
    }
    /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ static get isCollapsed() {
        const e = window.getSelection();
        return e ? e.isCollapsed : null;
    }
    /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ static get isAtEditor() {
        return this.isSelectionAtEditor($ca477aae3d96de69$var$b.get());
    }
    /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ static isSelectionAtEditor(e) {
        if (!e) return !1;
        let t1 = e.anchorNode || e.focusNode;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$ca477aae3d96de69$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ static isRangeAtEditor(e) {
        if (!e) return;
        let t1 = e.startContainer;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$ca477aae3d96de69$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Methods return boolean that true if selection exists on the page
   */ static get isSelectionExists() {
        return !!$ca477aae3d96de69$var$b.get().anchorNode;
    }
    /**
   * Return first range
   *
   * @returns {Range|null}
   */ static get range() {
        return this.getRangeFromSelection(this.get());
    }
    /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ static getRangeFromSelection(e) {
        return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ static get rect() {
        let e = document.selection, t1, o = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
        if (!window.getSelection) return $ca477aae3d96de69$var$I("Method window.getSelection is not supported", "warn"), o;
        if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $ca477aae3d96de69$var$I("Method SelectionUtils.rangeCount is not supported", "warn"), o;
        if (e.rangeCount === 0) return o;
        if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
            const i = document.createElement("span");
            if (i.getBoundingClientRect) {
                i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                const s = i.parentNode;
                s.removeChild(i), s.normalize();
            }
        }
        return o;
    }
    /**
   * Returns selected text as String
   *
   * @returns {string}
   */ static get text() {
        return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ static get() {
        return window.getSelection();
    }
    /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ static setCursor(e, t1 = 0) {
        const o = document.createRange(), i = window.getSelection();
        return $ca477aae3d96de69$var$d.isNativeInput(e) ? $ca477aae3d96de69$var$d.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ static isRangeInsideContainer(e) {
        const t1 = $ca477aae3d96de69$var$b.range;
        return t1 === null ? !1 : e.contains(t1.startContainer);
    }
    /**
   * Adds fake cursor to the current range
   */ static addFakeCursor() {
        const e = $ca477aae3d96de69$var$b.range;
        if (e === null) return;
        const t1 = $ca477aae3d96de69$var$d.make("span", "codex-editor__fake-cursor");
        t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
    }
    /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ static isFakeCursorInsideContainer(e) {
        return $ca477aae3d96de69$var$d.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ static removeFakeCursor(e = document.body) {
        const t1 = $ca477aae3d96de69$var$d.find(e, ".codex-editor__fake-cursor");
        t1 && t1.remove();
    }
    /**
   * Removes fake background
   */ removeFakeBackground() {
        this.isFakeBackgroundEnabled && (this.isFakeBackgroundEnabled = !1, document.execCommand(this.commandRemoveFormat));
    }
    /**
   * Sets fake background
   */ setFakeBackground() {
        document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
   * Save SelectionUtils's range
   */ save() {
        this.savedSelectionRange = $ca477aae3d96de69$var$b.range;
    }
    /**
   * Restore saved SelectionUtils's range
   */ restore() {
        if (!this.savedSelectionRange) return;
        const e = window.getSelection();
        e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
   * Clears saved selection
   */ clearSaved() {
        this.savedSelectionRange = null;
    }
    /**
   * Collapse current selection
   */ collapseToEnd() {
        const e = window.getSelection(), t1 = document.createRange();
        t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
    }
    /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1, o = 10) {
        const i = window.getSelection();
        let s = null;
        return !i || !i.anchorNode || !i.focusNode ? null : ([
            /** the Node in which the selection begins */ i.anchorNode,
            /** the Node in which the selection ends */ i.focusNode
        ].forEach((l)=>{
            let a = o;
            for(; a > 0 && l.parentNode && !(l.tagName === e && (s = l, t1 && l.classList && !l.classList.contains(t1) && (s = null), s));)l = l.parentNode, a--;
        }), s);
    }
    /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ expandToTag(e) {
        const t1 = window.getSelection();
        t1.removeAllRanges();
        const o = document.createRange();
        o.selectNodeContents(e), t1.addRange(o);
    }
}
function $ca477aae3d96de69$var$Fo(n, e) {
    const { type: t1, target: o, addedNodes: i, removedNodes: s } = n;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some((a)=>a === e) || Array.from(s).some((a)=>a === e)));
}
const $ca477aae3d96de69$var$Je = "redactor dom changed", $ca477aae3d96de69$var$Pt = "block changed", $ca477aae3d96de69$var$Dt = "fake cursor is about to be toggled", $ca477aae3d96de69$var$Rt = "fake cursor have been set", $ca477aae3d96de69$var$ye = "editor mobile layout toggled";
function $ca477aae3d96de69$var$Ft(n, e) {
    if (!n.conversionConfig) return !1;
    const t1 = n.conversionConfig[e];
    return $ca477aae3d96de69$var$O(t1) || $ca477aae3d96de69$var$Q(t1);
}
function $ca477aae3d96de69$var$_e(n, e) {
    return $ca477aae3d96de69$var$Ft(n.tool, e);
}
function $ca477aae3d96de69$var$Ht(n, e) {
    return Object.entries(n).some(([t1, o])=>e[t1] && $ca477aae3d96de69$var$Oo(e[t1], o));
}
async function $ca477aae3d96de69$var$zt(n, e) {
    const o = (await n.save()).data;
    return e.reduce((i, s)=>{
        if (!$ca477aae3d96de69$var$Ft(s, "import")) return i;
        const r = s.toolbox.filter((l)=>{
            if ($ca477aae3d96de69$var$V(l) || !l.icon) return !1;
            if (l.data !== void 0) {
                if ($ca477aae3d96de69$var$Ht(l.data, o)) return !1;
            } else if (s.name === n.name) return !1;
            return !0;
        });
        return i.push({
            ...s,
            toolbox: r
        }), i;
    }, []);
}
function $ca477aae3d96de69$var$vt(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $ca477aae3d96de69$var$_e(e, "export") && $ca477aae3d96de69$var$_e(n, "import") : !1;
}
function $ca477aae3d96de69$var$Ho(n, e) {
    const t1 = e == null ? void 0 : e.export;
    return $ca477aae3d96de69$var$O(t1) ? t1(n) : $ca477aae3d96de69$var$Q(t1) ? n[t1] : (t1 !== void 0 && $ca477aae3d96de69$var$I("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $ca477aae3d96de69$var$wt(n, e) {
    const t1 = e == null ? void 0 : e.import;
    return $ca477aae3d96de69$var$O(t1) ? t1(n) : $ca477aae3d96de69$var$Q(t1) ? {
        [t1]: n
    } : (t1 !== void 0 && $ca477aae3d96de69$var$I("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $ca477aae3d96de69$var$A = /* @__PURE__ */ ((n)=>(n.Default = "default", n.Separator = "separator", n.Html = "html", n))($ca477aae3d96de69$var$A || {}), $ca477aae3d96de69$var$J = /* @__PURE__ */ ((n)=>(n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n))($ca477aae3d96de69$var$J || {});
class $ca477aae3d96de69$var$D extends $ca477aae3d96de69$var$Te {
    /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */ constructor({ id: e = $ca477aae3d96de69$var$Io(), data: t1, tool: o, readOnly: i, tunesData: s }, r){
        super(), this.cachedInputs = [], this.toolRenderedElement = null, this.tunesInstances = /* @__PURE__ */ new Map(), this.defaultTunesInstances = /* @__PURE__ */ new Map(), this.unavailableTunesData = {}, this.inputIndex = 0, this.editorEventBus = null, this.handleFocus = ()=>{
            this.dropInputsCache(), this.updateCurrentInput();
        }, this.didMutated = (l)=>{
            const a = l === void 0, c = l instanceof InputEvent;
            !a && !c && this.detectToolRootChange(l);
            let u;
            a || c ? u = !0 : u = !(l.length > 0 && l.every((p)=>{
                const { addedNodes: g, removedNodes: f, target: k } = p;
                return [
                    ...Array.from(g),
                    ...Array.from(f),
                    k
                ].some((S)=>($ca477aae3d96de69$var$d.isElement(S) || (S = S.parentElement), S && S.closest('[data-mutation-free="true"]') !== null));
            })), u && (this.dropInputsCache(), this.updateCurrentInput(), this.toggleInputsEmptyMark(), this.call("updated"), this.emit("didMutated", this));
        }, this.name = o.name, this.id = e, this.settings = o.settings, this.config = o.settings.config || {}, this.editorEventBus = r || null, this.blockAPI = new $ca477aae3d96de69$var$G(this), this.tool = o, this.toolInstance = o.create(t1, this.blockAPI, i), this.tunes = o.tunes, this.composeTunes(s), this.holder = this.compose(), window.requestIdleCallback(()=>{
            this.watchBlockMutations(), this.addInputEvents(), this.toggleInputsEmptyMark();
        });
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            wrapper: "ce-block",
            wrapperStretched: "ce-block--stretched",
            content: "ce-block__content",
            selected: "ce-block--selected",
            dropTarget: "ce-block--drop-target"
        };
    }
    /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ get inputs() {
        if (this.cachedInputs.length !== 0) return this.cachedInputs;
        const e = $ca477aae3d96de69$var$d.findAllInputs(this.holder);
        return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get currentInput() {
        return this.inputs[this.inputIndex];
    }
    /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ set currentInput(e) {
        const t1 = this.inputs.findIndex((o)=>o === e || o.contains(e));
        t1 !== -1 && (this.inputIndex = t1);
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get firstInput() {
        return this.inputs[0];
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get lastInput() {
        const e = this.inputs;
        return e[e.length - 1];
    }
    /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get nextInput() {
        return this.inputs[this.inputIndex + 1];
    }
    /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get previousInput() {
        return this.inputs[this.inputIndex - 1];
    }
    /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ get data() {
        return this.save().then((e)=>e && !$ca477aae3d96de69$var$V(e.data) ? e.data : {});
    }
    /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ get sanitize() {
        return this.tool.sanitizeConfig;
    }
    /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ get mergeable() {
        return $ca477aae3d96de69$var$O(this.toolInstance.merge);
    }
    /**
   * If Block contains inputs, it is focusable
   */ get focusable() {
        return this.inputs.length !== 0;
    }
    /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ get isEmpty() {
        const e = $ca477aae3d96de69$var$d.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
        return e && t1;
    }
    /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ get hasMedia() {
        const e = [
            "img",
            "iframe",
            "video",
            "audio",
            "source",
            "input",
            "textarea",
            "twitterwidget"
        ];
        return !!this.holder.querySelector(e.join(","));
    }
    /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ set selected(e) {
        var i, s;
        this.holder.classList.toggle($ca477aae3d96de69$var$D.CSS.selected, e);
        const t1 = e === !0 && $ca477aae3d96de69$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $ca477aae3d96de69$var$b.isFakeCursorInsideContainer(this.holder);
        (t1 || o) && ((i = this.editorEventBus) == null || i.emit($ca477aae3d96de69$var$Dt, {
            state: e
        }), t1 ? $ca477aae3d96de69$var$b.addFakeCursor() : $ca477aae3d96de69$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($ca477aae3d96de69$var$Rt, {
            state: e
        }));
    }
    /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ get selected() {
        return this.holder.classList.contains($ca477aae3d96de69$var$D.CSS.selected);
    }
    /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ set stretched(e) {
        this.holder.classList.toggle($ca477aae3d96de69$var$D.CSS.wrapperStretched, e);
    }
    /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ get stretched() {
        return this.holder.classList.contains($ca477aae3d96de69$var$D.CSS.wrapperStretched);
    }
    /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ set dropTarget(e) {
        this.holder.classList.toggle($ca477aae3d96de69$var$D.CSS.dropTarget, e);
    }
    /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ get pluginsContent() {
        return this.toolRenderedElement;
    }
    /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ call(e, t1) {
        if ($ca477aae3d96de69$var$O(this.toolInstance[e])) {
            e === "appendCallback" && $ca477aae3d96de69$var$I("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
            try {
                this.toolInstance[e].call(this.toolInstance, t1);
            } catch (o) {
                $ca477aae3d96de69$var$I(`Error during '${e}' call: ${o.message}`, "error");
            }
        }
    }
    /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ async mergeWith(e) {
        await this.toolInstance.merge(e);
    }
    /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ async save() {
        const e = await this.toolInstance.save(this.pluginsContent), t1 = this.unavailableTunesData;
        [
            ...this.tunesInstances.entries(),
            ...this.defaultTunesInstances.entries()
        ].forEach(([s, r])=>{
            if ($ca477aae3d96de69$var$O(r.save)) try {
                t1[s] = r.save();
            } catch (l) {
                $ca477aae3d96de69$var$I(`Tune ${r.constructor.name} save method throws an Error %o`, "warn", l);
            }
        });
        const o = window.performance.now();
        let i;
        return Promise.resolve(e).then((s)=>(i = window.performance.now(), {
                id: this.id,
                tool: this.name,
                data: s,
                tunes: t1,
                time: i - o
            })).catch((s)=>{
            $ca477aae3d96de69$var$I(`Saving process for ${this.name} tool failed due to the ${s}`, "log", "red");
        });
    }
    /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ async validate(e) {
        let t1 = !0;
        return this.toolInstance.validate instanceof Function && (t1 = await this.toolInstance.validate(e)), t1;
    }
    /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ getTunes() {
        const e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
        return $ca477aae3d96de69$var$d.isElement(o) ? e.push({
            type: $ca477aae3d96de69$var$A.Html,
            element: o
        }) : Array.isArray(o) ? e.push(...o) : e.push(o), [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].map((s)=>s.render()).forEach((s)=>{
            $ca477aae3d96de69$var$d.isElement(s) ? t1.push({
                type: $ca477aae3d96de69$var$A.Html,
                element: s
            }) : Array.isArray(s) ? t1.push(...s) : t1.push(s);
        }), {
            toolTunes: e,
            commonTunes: t1
        };
    }
    /**
   * Update current input index with selection anchor node
   */ updateCurrentInput() {
        this.currentInput = $ca477aae3d96de69$var$d.isNativeInput(document.activeElement) || !$ca477aae3d96de69$var$b.anchorNode ? document.activeElement : $ca477aae3d96de69$var$b.anchorNode;
    }
    /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ dispatchChange() {
        this.didMutated();
    }
    /**
   * Call Tool instance destroy method
   */ destroy() {
        this.unwatchBlockMutations(), this.removeInputEvents(), super.destroy(), $ca477aae3d96de69$var$O(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ async getActiveToolboxEntry() {
        const e = this.tool.toolbox;
        if (e.length === 1) return Promise.resolve(this.tool.toolbox[0]);
        const t1 = await this.data, o = e;
        return o == null ? void 0 : o.find((i)=>$ca477aae3d96de69$var$Ht(i.data, t1));
    }
    /**
   * Exports Block data as string using conversion config
   */ async exportDataAsString() {
        const e = await this.data;
        return $ca477aae3d96de69$var$Ho(e, this.tool.conversionConfig);
    }
    /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ compose() {
        const e = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$D.CSS.wrapper), t1 = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$D.CSS.content), o = this.toolInstance.render();
        e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
        let i = t1;
        return [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].forEach((s)=>{
            if ($ca477aae3d96de69$var$O(s.wrap)) try {
                i = s.wrap(i);
            } catch (r) {
                $ca477aae3d96de69$var$I(`Tune ${s.constructor.name} wrap method throws an Error %o`, "warn", r);
            }
        }), e.appendChild(i), e;
    }
    /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ composeTunes(e) {
        Array.from(this.tunes.values()).forEach((t1)=>{
            (t1.isInternal ? this.defaultTunesInstances : this.tunesInstances).set(t1.name, t1.create(e[t1.name], this.blockAPI));
        }), Object.entries(e).forEach(([t1, o])=>{
            this.tunesInstances.has(t1) || (this.unavailableTunesData[t1] = o);
        });
    }
    /**
   * Adds focus event listeners to all inputs and contenteditable
   */ addInputEvents() {
        this.inputs.forEach((e)=>{
            e.addEventListener("focus", this.handleFocus), $ca477aae3d96de69$var$d.isNativeInput(e) && e.addEventListener("input", this.didMutated);
        });
    }
    /**
   * removes focus event listeners from all inputs and contenteditable
   */ removeInputEvents() {
        this.inputs.forEach((e)=>{
            e.removeEventListener("focus", this.handleFocus), $ca477aae3d96de69$var$d.isNativeInput(e) && e.removeEventListener("input", this.didMutated);
        });
    }
    /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ watchBlockMutations() {
        var e;
        this.redactorDomChangedCallback = (t1)=>{
            const { mutations: o } = t1;
            o.some((s)=>$ca477aae3d96de69$var$Fo(s, this.toolRenderedElement)) && this.didMutated(o);
        }, (e = this.editorEventBus) == null || e.on($ca477aae3d96de69$var$Je, this.redactorDomChangedCallback);
    }
    /**
   * Remove redactor dom change event listener
   */ unwatchBlockMutations() {
        var e;
        (e = this.editorEventBus) == null || e.off($ca477aae3d96de69$var$Je, this.redactorDomChangedCallback);
    }
    /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ detectToolRootChange(e) {
        e.forEach((t1)=>{
            if (Array.from(t1.removedNodes).includes(this.toolRenderedElement)) {
                const i = t1.addedNodes[t1.addedNodes.length - 1];
                this.toolRenderedElement = i;
            }
        });
    }
    /**
   * Clears inputs cached value
   */ dropInputsCache() {
        this.cachedInputs = [];
    }
    /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ toggleInputsEmptyMark() {
        this.inputs.forEach($ca477aae3d96de69$var$Ot);
    }
}
class $ca477aae3d96de69$var$zo extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.insert = (e = this.config.defaultBlock, t1 = {}, o = {}, i, s, r, l)=>{
            const a = this.Editor.BlockManager.insert({
                id: l,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $ca477aae3d96de69$var$G(a);
        }, this.composeBlockData = async (e)=>{
            const t1 = this.Editor.Tools.blockTools.get(e);
            return new $ca477aae3d96de69$var$D({
                tool: t1,
                api: this.Editor.API,
                readOnly: !0,
                data: {},
                tunesData: {}
            }).data;
        }, this.update = async (e, t1, o)=>{
            const { BlockManager: i } = this.Editor, s = i.getBlockById(e);
            if (s === void 0) throw new Error(`Block with id "${e}" not found`);
            const r = await i.update(s, t1, o);
            return new $ca477aae3d96de69$var$G(r);
        }, this.convert = async (e, t1, o)=>{
            var h, p;
            const { BlockManager: i, Tools: s } = this.Editor, r = i.getBlockById(e);
            if (!r) throw new Error(`Block with id "${e}" not found`);
            const l = s.blockTools.get(r.name), a = s.blockTools.get(t1);
            if (!a) throw new Error(`Block Tool with type "${t1}" not found`);
            const c = ((h = l == null ? void 0 : l.conversionConfig) == null ? void 0 : h.export) !== void 0, u = ((p = a.conversionConfig) == null ? void 0 : p.import) !== void 0;
            if (c && u) {
                const g = await i.convert(r, t1, o);
                return new $ca477aae3d96de69$var$G(g);
            } else {
                const g = [
                    c ? !1 : $ca477aae3d96de69$var$Le(r.name),
                    u ? !1 : $ca477aae3d96de69$var$Le(t1)
                ].filter(Boolean).join(" and ");
                throw new Error(`Conversion from "${r.name}" to "${t1}" is not possible. ${g} tool(s) should provide a "conversionConfig"`);
            }
        }, this.insertMany = (e, t1 = this.Editor.BlockManager.blocks.length - 1)=>{
            this.validateIndex(t1);
            const o = e.map(({ id: i, type: s, data: r })=>this.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || this.config.defaultBlock,
                    data: r
                }));
            return this.Editor.BlockManager.insertMany(o, t1), o.map((i)=>new $ca477aae3d96de69$var$G(i));
        };
    }
    /**
   * Available methods
   *
   * @returns {Blocks}
   */ get methods() {
        return {
            clear: ()=>this.clear(),
            render: (e)=>this.render(e),
            renderFromHTML: (e)=>this.renderFromHTML(e),
            delete: (e)=>this.delete(e),
            swap: (e, t1)=>this.swap(e, t1),
            move: (e, t1)=>this.move(e, t1),
            getBlockByIndex: (e)=>this.getBlockByIndex(e),
            getById: (e)=>this.getById(e),
            getCurrentBlockIndex: ()=>this.getCurrentBlockIndex(),
            getBlockIndex: (e)=>this.getBlockIndex(e),
            getBlocksCount: ()=>this.getBlocksCount(),
            getBlockByElement: (e)=>this.getBlockByElement(e),
            stretchBlock: (e, t1 = !0)=>this.stretchBlock(e, t1),
            insertNewBlock: ()=>this.insertNewBlock(),
            insert: this.insert,
            insertMany: this.insertMany,
            update: this.update,
            composeBlockData: this.composeBlockData,
            convert: this.convert
        };
    }
    /**
   * Returns Blocks count
   *
   * @returns {number}
   */ getBlocksCount() {
        return this.Editor.BlockManager.blocks.length;
    }
    /**
   * Returns current block index
   *
   * @returns {number}
   */ getCurrentBlockIndex() {
        return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ getBlockIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        if (!t1) {
            $ca477aae3d96de69$var$X("There is no block with id `" + e + "`", "warn");
            return;
        }
        return this.Editor.BlockManager.getBlockIndex(t1);
    }
    /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ getBlockByIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(e);
        if (t1 === void 0) {
            $ca477aae3d96de69$var$X("There is no block at index `" + e + "`", "warn");
            return;
        }
        return new $ca477aae3d96de69$var$G(t1);
    }
    /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ getById(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        return t1 === void 0 ? ($ca477aae3d96de69$var$X("There is no block with id `" + e + "`", "warn"), null) : new $ca477aae3d96de69$var$G(t1);
    }
    /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ getBlockByElement(e) {
        const t1 = this.Editor.BlockManager.getBlock(e);
        if (t1 === void 0) {
            $ca477aae3d96de69$var$X("There is no block corresponding to element `" + e + "`", "warn");
            return;
        }
        return new $ca477aae3d96de69$var$G(t1);
    }
    /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        $ca477aae3d96de69$var$I("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
    }
    /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ move(e, t1) {
        this.Editor.BlockManager.move(e, t1);
    }
    /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ delete(e = this.Editor.BlockManager.currentBlockIndex) {
        try {
            const t1 = this.Editor.BlockManager.getBlockByIndex(e);
            this.Editor.BlockManager.removeBlock(t1);
        } catch (t1) {
            $ca477aae3d96de69$var$X(t1, "warn");
            return;
        }
        this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
   * Clear Editor's area
   */ async clear() {
        await this.Editor.BlockManager.clear(!0), this.Editor.InlineToolbar.close();
    }
    /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ async render(e) {
        if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
        this.Editor.ModificationsObserver.disable(), await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(e.blocks), this.Editor.ModificationsObserver.enable();
    }
    /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ renderFromHTML(e) {
        return this.Editor.BlockManager.clear(), this.Editor.Paste.processText(e, !0);
    }
    /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ stretchBlock(e, t1 = !0) {
        $ca477aae3d96de69$var$Ze(!0, "blocks.stretchBlock()", "BlockAPI");
        const o = this.Editor.BlockManager.getBlockByIndex(e);
        o && (o.stretched = t1);
    }
    /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ insertNewBlock() {
        $ca477aae3d96de69$var$I("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ validateIndex(e) {
        if (typeof e != "number") throw new Error("Index should be a number");
        if (e < 0) throw new Error("Index should be greater than or equal to 0");
        if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
}
function $ca477aae3d96de69$var$Uo(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
class $ca477aae3d96de69$var$jo extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.setToFirstBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.firstBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.firstBlock, e, t1), !0) : !1, this.setToLastBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.lastBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.lastBlock, e, t1), !0) : !1, this.setToPreviousBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.previousBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.previousBlock, e, t1), !0) : !1, this.setToNextBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.nextBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.nextBlock, e, t1), !0) : !1, this.setToBlock = (e, t1 = this.Editor.Caret.positions.DEFAULT, o = 0)=>{
            const i = $ca477aae3d96de69$var$Uo(e, this.Editor);
            return i === void 0 ? !1 : (this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, this.focus = (e = !1)=>e ? this.setToLastBlock(this.Editor.Caret.positions.END) : this.setToFirstBlock(this.Editor.Caret.positions.START);
    }
    /**
   * Available methods
   *
   * @returns {Caret}
   */ get methods() {
        return {
            setToFirstBlock: this.setToFirstBlock,
            setToLastBlock: this.setToLastBlock,
            setToPreviousBlock: this.setToPreviousBlock,
            setToNextBlock: this.setToNextBlock,
            setToBlock: this.setToBlock,
            focus: this.focus
        };
    }
}
class $ca477aae3d96de69$var$$o extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   *
   * @returns {Events}
   */ get methods() {
        return {
            emit: (e, t1)=>this.emit(e, t1),
            off: (e, t1)=>this.off(e, t1),
            on: (e, t1)=>this.on(e, t1)
        };
    }
    /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ on(e, t1) {
        this.eventsDispatcher.on(e, t1);
    }
    /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ emit(e, t1) {
        this.eventsDispatcher.emit(e, t1);
    }
    /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ off(e, t1) {
        this.eventsDispatcher.off(e, t1);
    }
}
class $ca477aae3d96de69$var$tt extends $ca477aae3d96de69$var$y {
    /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ static getNamespace(e, t1) {
        return t1 ? `blockTunes.${e}` : `tools.${e}`;
    }
    /**
   * Return I18n API methods with global dictionary access
   */ get methods() {
        return {
            t: ()=>{
                $ca477aae3d96de69$var$X("I18n.t() method can be accessed only from Tools", "warn");
            }
        };
    }
    /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            t: (o)=>$ca477aae3d96de69$var$z.t($ca477aae3d96de69$var$tt.getNamespace(e, t1), o)
        });
    }
}
class $ca477aae3d96de69$var$Yo extends $ca477aae3d96de69$var$y {
    /**
   * Editor.js Core API modules
   */ get methods() {
        return {
            blocks: this.Editor.BlocksAPI.methods,
            caret: this.Editor.CaretAPI.methods,
            tools: this.Editor.ToolsAPI.methods,
            events: this.Editor.EventsAPI.methods,
            listeners: this.Editor.ListenersAPI.methods,
            notifier: this.Editor.NotifierAPI.methods,
            sanitizer: this.Editor.SanitizerAPI.methods,
            saver: this.Editor.SaverAPI.methods,
            selection: this.Editor.SelectionAPI.methods,
            styles: this.Editor.StylesAPI.classes,
            toolbar: this.Editor.ToolbarAPI.methods,
            inlineToolbar: this.Editor.InlineToolbarAPI.methods,
            tooltip: this.Editor.TooltipAPI.methods,
            i18n: this.Editor.I18nAPI.methods,
            readOnly: this.Editor.ReadOnlyAPI.methods,
            ui: this.Editor.UiAPI.methods
        };
    }
    /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
        });
    }
}
class $ca477aae3d96de69$var$Wo extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open()
        };
    }
    /**
   * Open Inline Toolbar
   */ open() {
        this.Editor.InlineToolbar.tryToShow();
    }
    /**
   * Close Inline Toolbar
   */ close() {
        this.Editor.InlineToolbar.close();
    }
}
class $ca477aae3d96de69$var$Ko extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   *
   * @returns {Listeners}
   */ get methods() {
        return {
            on: (e, t1, o, i)=>this.on(e, t1, o, i),
            off: (e, t1, o, i)=>this.off(e, t1, o, i),
            offById: (e)=>this.offById(e)
        };
    }
    /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ on(e, t1, o, i) {
        return this.listeners.on(e, t1, o, i);
    }
    /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ off(e, t1, o, i) {
        this.listeners.off(e, t1, o, i);
    }
    /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ offById(e) {
        this.listeners.offById(e);
    }
}
var $ca477aae3d96de69$var$Ut = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, l) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: l
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var l = /* @__PURE__ */ Object.create(null);
                if (i.r(l), Object.defineProperty(l, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var a in s)i.d(l, a, (function(c) {
                    return s[c];
                }).bind(null, a));
                return l;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", l = null;
                    return {
                        show: function(a) {
                            if (a.message) {
                                (function() {
                                    if (l) return !0;
                                    l = s.getWrapper(), document.body.appendChild(l);
                                })();
                                var c = null, u = a.time || 8e3;
                                switch(a.type){
                                    case "confirm":
                                        c = s.confirm(a);
                                        break;
                                    case "prompt":
                                        c = s.prompt(a);
                                        break;
                                    default:
                                        c = s.alert(a), window.setTimeout(function() {
                                            c.remove();
                                        }, u);
                                }
                                l.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    `.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}`,
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var l = function(a, c) {
                                var u = a[1] || "", h = a[3];
                                if (!h) return u;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(k) {
                                        return "/*# sourceURL=" + h.sourceRoot + k + " */";
                                    });
                                    return [
                                        u
                                    ].concat(g).concat([
                                        p
                                    ]).join(`
`);
                                }
                                var f;
                                return [
                                    u
                                ].join(`
`);
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + l + "}" : l;
                        }).join("");
                    }, s.i = function(r, l) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var a = {}, c = 0; c < this.length; c++){
                            var u = this[c][0];
                            typeof u == "number" && (a[u] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && a[h[0]] || (l && !h[2] ? h[2] = l : l && (h[2] = "(" + h[2] + ") and (" + l + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, l = {}, a = (s = function() {
                    return window && document && document.all && !window.atob;
                }, function() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(v) {
                    var m = {};
                    return function(x) {
                        if (typeof x == "function") return x();
                        if (m[x] === void 0) {
                            var E = (function(M) {
                                return document.querySelector(M);
                            }).call(this, x);
                            if (window.HTMLIFrameElement && E instanceof window.HTMLIFrameElement) try {
                                E = E.contentDocument.head;
                            } catch  {
                                E = null;
                            }
                            m[x] = E;
                        }
                        return m[x];
                    };
                }(), u = null, h = 0, p = [], g = i(5);
                function f(v, m) {
                    for(var x = 0; x < v.length; x++){
                        var E = v[x], M = l[E.id];
                        if (M) {
                            M.refs++;
                            for(var T = 0; T < M.parts.length; T++)M.parts[T](E.parts[T]);
                            for(; T < E.parts.length; T++)M.parts.push(j(E.parts[T], m));
                        } else {
                            var P = [];
                            for(T = 0; T < E.parts.length; T++)P.push(j(E.parts[T], m));
                            l[E.id] = {
                                id: E.id,
                                refs: 1,
                                parts: P
                            };
                        }
                    }
                }
                function k(v, m) {
                    for(var x = [], E = {}, M = 0; M < v.length; M++){
                        var T = v[M], P = m.base ? T[0] + m.base : T[0], B = {
                            css: T[1],
                            media: T[2],
                            sourceMap: T[3]
                        };
                        E[P] ? E[P].parts.push(B) : x.push(E[P] = {
                            id: P,
                            parts: [
                                B
                            ]
                        });
                    }
                    return x;
                }
                function C(v, m) {
                    var x = c(v.insertInto);
                    if (!x) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var E = p[p.length - 1];
                    if (v.insertAt === "top") E ? E.nextSibling ? x.insertBefore(m, E.nextSibling) : x.appendChild(m) : x.insertBefore(m, x.firstChild), p.push(m);
                    else if (v.insertAt === "bottom") x.appendChild(m);
                    else {
                        if (typeof v.insertAt != "object" || !v.insertAt.before) throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
                        var M = c(v.insertInto + " " + v.insertAt.before);
                        x.insertBefore(m, M);
                    }
                }
                function S(v) {
                    if (v.parentNode === null) return !1;
                    v.parentNode.removeChild(v);
                    var m = p.indexOf(v);
                    m >= 0 && p.splice(m, 1);
                }
                function _(v) {
                    var m = document.createElement("style");
                    return v.attrs.type === void 0 && (v.attrs.type = "text/css"), ee(m, v.attrs), C(v, m), m;
                }
                function ee(v, m) {
                    Object.keys(m).forEach(function(x) {
                        v.setAttribute(x, m[x]);
                    });
                }
                function j(v, m) {
                    var x, E, M, T;
                    if (m.transform && v.css) {
                        if (!(T = m.transform(v.css))) return function() {};
                        v.css = T;
                    }
                    if (m.singleton) {
                        var P = h++;
                        x = u || (u = _(m)), E = fe.bind(null, x, P, !1), M = fe.bind(null, x, P, !0);
                    } else v.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (x = function(B) {
                        var Y = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", ee(Y, B.attrs), C(B, Y), Y;
                    }(m), E = (function(B, Y, ge) {
                        var ie = ge.css, He = ge.sourceMap, mo = Y.convertToAbsoluteUrls === void 0 && He;
                        (Y.convertToAbsoluteUrls || mo) && (ie = g(ie)), He && (ie += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(He)))) + " */");
                        var bo = new Blob([
                            ie
                        ], {
                            type: "text/css"
                        }), gt = B.href;
                        B.href = URL.createObjectURL(bo), gt && URL.revokeObjectURL(gt);
                    }).bind(null, x, m), M = function() {
                        S(x), x.href && URL.revokeObjectURL(x.href);
                    }) : (x = _(m), E = (function(B, Y) {
                        var ge = Y.css, ie = Y.media;
                        if (ie && B.setAttribute("media", ie), B.styleSheet) B.styleSheet.cssText = ge;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ge));
                        }
                    }).bind(null, x), M = function() {
                        S(x);
                    });
                    return E(v), function(B) {
                        if (B) {
                            if (B.css === v.css && B.media === v.media && B.sourceMap === v.sourceMap) return;
                            E(v = B);
                        } else M();
                    };
                }
                t1.exports = function(v, m) {
                    if (typeof DEBUG < "u" && DEBUG && typeof document != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = typeof m.attrs == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = a()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var x = k(v, m);
                    return f(x, m), function(E) {
                        for(var M = [], T = 0; T < x.length; T++){
                            var P = x[T];
                            (B = l[P.id]).refs--, M.push(B);
                        }
                        for(E && f(k(E, m), m), T = 0; T < M.length; T++){
                            var B;
                            if ((B = M[T]).refs === 0) {
                                for(var Y = 0; Y < B.parts.length; Y++)B.parts[Y]();
                                delete l[B.id];
                            }
                        }
                    };
                };
                var $, oe = ($ = [], function(v, m) {
                    return $[v] = m, $.filter(Boolean).join(`
`);
                });
                function fe(v, m, x, E) {
                    var M = x ? "" : E.css;
                    if (v.styleSheet) v.styleSheet.cssText = oe(m, M);
                    else {
                        var T = document.createTextNode(M), P = v.childNodes;
                        P[m] && v.removeChild(P[m]), P.length ? v.insertBefore(T, P[m]) : v.appendChild(T);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = typeof window < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, l = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(a, c) {
                        var u, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? a : (u = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : l + h.replace(/^\.\//, ""), "url(" + JSON.stringify(u) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, l, a, c, u, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", l = "cdx-notify__cross", a = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", u = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function(f) {
                        var k = document.createElement("DIV"), C = document.createElement("DIV"), S = f.message, _ = f.style;
                        return k.classList.add(r), _ && k.classList.add(r + "--" + _), k.innerHTML = S, C.classList.add(l), C.addEventListener("click", k.remove.bind(k)), k.appendChild(C), k;
                    },
                    confirm: function(f) {
                        var k = g(f), C = document.createElement("div"), S = document.createElement("button"), _ = document.createElement("button"), ee = k.querySelector("." + l), j = f.cancelHandler, $ = f.okHandler;
                        return C.classList.add(p), S.innerHTML = f.okText || "Confirm", _.innerHTML = f.cancelText || "Cancel", S.classList.add(h), _.classList.add(h), S.classList.add(a), _.classList.add(c), j && typeof j == "function" && (_.addEventListener("click", j), ee.addEventListener("click", j)), $ && typeof $ == "function" && S.addEventListener("click", $), S.addEventListener("click", k.remove.bind(k)), _.addEventListener("click", k.remove.bind(k)), C.appendChild(S), C.appendChild(_), k.appendChild(C), k;
                    },
                    prompt: function(f) {
                        var k = g(f), C = document.createElement("div"), S = document.createElement("button"), _ = document.createElement("input"), ee = k.querySelector("." + l), j = f.cancelHandler, $ = f.okHandler;
                        return C.classList.add(p), S.innerHTML = f.okText || "Ok", S.classList.add(h), S.classList.add(a), _.classList.add(u), f.placeholder && _.setAttribute("placeholder", f.placeholder), f.default && (_.value = f.default), f.inputType && (_.type = f.inputType), j && typeof j == "function" && ee.addEventListener("click", j), $ && typeof $ == "function" && S.addEventListener("click", function() {
                            $(_.value);
                        }), S.addEventListener("click", k.remove.bind(k)), C.appendChild(_), C.appendChild(S), k.appendChild(C), k;
                    },
                    getWrapper: function() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($ca477aae3d96de69$var$Ut);
var $ca477aae3d96de69$var$Xo = $ca477aae3d96de69$var$Ut.exports;
const $ca477aae3d96de69$var$Vo = /* @__PURE__ */ $ca477aae3d96de69$var$Fe($ca477aae3d96de69$var$Xo);
class $ca477aae3d96de69$var$qo {
    /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ show(e) {
        $ca477aae3d96de69$var$Vo.show(e);
    }
}
class $ca477aae3d96de69$var$Zo extends $ca477aae3d96de69$var$y {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.notifier = new $ca477aae3d96de69$var$qo();
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e)=>this.show(e)
        };
    }
    /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ show(e) {
        return this.notifier.show(e);
    }
}
class $ca477aae3d96de69$var$Go extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   */ get methods() {
        const e = ()=>this.isEnabled;
        return {
            toggle: (t1)=>this.toggle(t1),
            get isEnabled () {
                return e();
            }
        };
    }
    /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ toggle(e) {
        return this.Editor.ReadOnly.toggle(e);
    }
    /**
   * Returns current read-only state
   */ get isEnabled() {
        return this.Editor.ReadOnly.isEnabled;
    }
}
var $ca477aae3d96de69$var$jt = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($ca477aae3d96de69$var$ko, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(k) {
                return typeof p[k];
            }).every(function(k) {
                return k === "object" || k === "boolean" || k === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            const p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = l(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var k = r(f), C;
                k && (C = Array.prototype.some.call(f.childNodes, i));
                var S = !!p.parentNode, _ = i(p) && i(f) && S, ee = f.nodeName.toLowerCase(), j = a(this.config, ee, f), $ = k && C;
                if ($ || c(f, j) || !this.config.keepNestedBlockElements && _) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var oe = 0; oe < f.attributes.length; oe += 1){
                    var fe = f.attributes[oe];
                    u(fe, j, f) && (f.removeAttribute(fe.name), oe = oe - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function l(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function a(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return typeof p > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function u(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : typeof p[f] > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($ca477aae3d96de69$var$jt);
var $ca477aae3d96de69$var$Jo = $ca477aae3d96de69$var$jt.exports;
const $ca477aae3d96de69$var$Qo = /* @__PURE__ */ $ca477aae3d96de69$var$Fe($ca477aae3d96de69$var$Jo);
function $ca477aae3d96de69$var$ot(n, e) {
    return n.map((t1)=>{
        const o = $ca477aae3d96de69$var$O(e) ? e(t1.tool) : e;
        return $ca477aae3d96de69$var$V(o) || (t1.data = $ca477aae3d96de69$var$it(t1.data, o)), t1;
    });
}
function $ca477aae3d96de69$var$q(n, e = {}) {
    const t1 = {
        tags: e
    };
    return new $ca477aae3d96de69$var$Qo(t1).clean(n);
}
function $ca477aae3d96de69$var$it(n, e) {
    return Array.isArray(n) ? $ca477aae3d96de69$var$ei(n, e) : $ca477aae3d96de69$var$R(n) ? $ca477aae3d96de69$var$ti(n, e) : $ca477aae3d96de69$var$Q(n) ? $ca477aae3d96de69$var$oi(n, e) : n;
}
function $ca477aae3d96de69$var$ei(n, e) {
    return n.map((t1)=>$ca477aae3d96de69$var$it(t1, e));
}
function $ca477aae3d96de69$var$ti(n, e) {
    const t1 = {};
    for(const o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        const i = n[o], s = $ca477aae3d96de69$var$ii(e[o]) ? e[o] : e;
        t1[o] = $ca477aae3d96de69$var$it(i, s);
    }
    return t1;
}
function $ca477aae3d96de69$var$oi(n, e) {
    return $ca477aae3d96de69$var$R(e) ? $ca477aae3d96de69$var$q(n, e) : e === !1 ? $ca477aae3d96de69$var$q(n, {}) : n;
}
function $ca477aae3d96de69$var$ii(n) {
    return $ca477aae3d96de69$var$R(n) || $ca477aae3d96de69$var$yo(n) || $ca477aae3d96de69$var$O(n);
}
class $ca477aae3d96de69$var$si extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ get methods() {
        return {
            clean: (e, t1)=>this.clean(e, t1)
        };
    }
    /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ clean(e, t1) {
        return $ca477aae3d96de69$var$q(e, t1);
    }
}
class $ca477aae3d96de69$var$ni extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   *
   * @returns {Saver}
   */ get methods() {
        return {
            save: ()=>this.save()
        };
    }
    /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ save() {
        const e = "Editor's content can not be saved in read-only mode";
        return this.Editor.ReadOnly.isEnabled ? ($ca477aae3d96de69$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
}
class $ca477aae3d96de69$var$ri extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.selectionUtils = new $ca477aae3d96de69$var$b();
    }
    /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ get methods() {
        return {
            findParentTag: (e, t1)=>this.findParentTag(e, t1),
            expandToTag: (e)=>this.expandToTag(e),
            save: ()=>this.selectionUtils.save(),
            restore: ()=>this.selectionUtils.restore(),
            setFakeBackground: ()=>this.selectionUtils.setFakeBackground(),
            removeFakeBackground: ()=>this.selectionUtils.removeFakeBackground()
        };
    }
    /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1) {
        return this.selectionUtils.findParentTag(e, t1);
    }
    /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ expandToTag(e) {
        this.selectionUtils.expandToTag(e);
    }
}
class $ca477aae3d96de69$var$li extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   */ get methods() {
        return {
            getBlockTools: ()=>Array.from(this.Editor.Tools.blockTools.values())
        };
    }
}
class $ca477aae3d96de69$var$ai extends $ca477aae3d96de69$var$y {
    /**
   * Exported classes
   */ get classes() {
        return {
            /**
       * Base Block styles
       */ block: "cdx-block",
            /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
            inlineToolButtonActive: "ce-inline-tool--active",
            /**
       * UI elements
       */ input: "cdx-input",
            loader: "cdx-loader",
            button: "cdx-button",
            /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
            settingsButtonActive: "cdx-settings-button--active"
        };
    }
}
class $ca477aae3d96de69$var$ci extends $ca477aae3d96de69$var$y {
    /**
   * Available methods
   *
   * @returns {Toolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open(),
            toggleBlockSettings: (e)=>this.toggleBlockSettings(e),
            toggleToolbox: (e)=>this.toggleToolbox(e)
        };
    }
    /**
   * Open toolbar
   */ open() {
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * Close toolbar and all included elements
   */ close() {
        this.Editor.Toolbar.close();
    }
    /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ toggleBlockSettings(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $ca477aae3d96de69$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.BlockSettings.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ toggleToolbox(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $ca477aae3d96de69$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
}
var $ca477aae3d96de69$var$$t = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, l) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: l
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var l = /* @__PURE__ */ Object.create(null);
                if (i.r(l), Object.defineProperty(l, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var a in s)i.d(l, a, (function(c) {
                    return s[c];
                }).bind(null, a));
                return l;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                class s {
                    constructor(){
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = ()=>{
                            this.showed && this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    get CSS() {
                        return {
                            tooltip: "ct",
                            tooltipContent: "ct__content",
                            tooltipShown: "ct--shown",
                            placement: {
                                left: "ct--left",
                                bottom: "ct--bottom",
                                right: "ct--right",
                                top: "ct--top"
                            }
                        };
                    }
                    show(l, a, c) {
                        this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                        const u = Object.assign({
                            placement: "bottom",
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            delay: 70,
                            hidingDelay: 0
                        }, c);
                        if (u.hidingDelay && (this.hidingDelay = u.hidingDelay), this.nodes.content.innerHTML = "", typeof a == "string") this.nodes.content.appendChild(document.createTextNode(a));
                        else {
                            if (!(a instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + typeof a + " given.");
                            this.nodes.content.appendChild(a);
                        }
                        switch(this.nodes.wrapper.classList.remove(...Object.values(this.CSS.placement)), u.placement){
                            case "top":
                                this.placeTop(l, u);
                                break;
                            case "left":
                                this.placeLeft(l, u);
                                break;
                            case "right":
                                this.placeRight(l, u);
                                break;
                            case "bottom":
                            default:
                                this.placeBottom(l, u);
                        }
                        u && u.delay ? this.showingTimeout = setTimeout(()=>{
                            this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0;
                        }, u.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                    }
                    hide(l = !1) {
                        if (this.hidingDelay && !l) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(()=>{
                            this.hide(!0);
                        }, this.hidingDelay));
                        this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                    }
                    onHover(l, a, c) {
                        l.addEventListener("mouseenter", ()=>{
                            this.show(l, a, c);
                        }), l.addEventListener("mouseleave", ()=>{
                            this.hide();
                        });
                    }
                    destroy() {
                        this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                    }
                    prepare() {
                        this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                    }
                    loadStyles() {
                        const l = "codex-tooltips-style";
                        if (document.getElementById(l)) return;
                        const a = i(2), c = this.make("style", null, {
                            textContent: a.toString(),
                            id: l
                        });
                        this.prepend(document.head, c);
                    }
                    placeBottom(l, a) {
                        const c = l.getBoundingClientRect(), u = c.left + l.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + a.marginTop;
                        this.applyPlacement("bottom", u, h);
                    }
                    placeTop(l, a) {
                        const c = l.getBoundingClientRect(), u = c.left + l.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                        this.applyPlacement("top", u, h);
                    }
                    placeLeft(l, a) {
                        const c = l.getBoundingClientRect(), u = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - a.marginLeft, h = c.top + window.pageYOffset + l.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("left", u, h);
                    }
                    placeRight(l, a) {
                        const c = l.getBoundingClientRect(), u = c.right + this.offsetRight + a.marginRight, h = c.top + window.pageYOffset + l.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("right", u, h);
                    }
                    applyPlacement(l, a, c) {
                        this.nodes.wrapper.classList.add(this.CSS.placement[l]), this.nodes.wrapper.style.left = a + "px", this.nodes.wrapper.style.top = c + "px";
                    }
                    make(l, a = null, c = {}) {
                        const u = document.createElement(l);
                        Array.isArray(a) ? u.classList.add(...a) : a && u.classList.add(a);
                        for(const h in c)c.hasOwnProperty(h) && (u[h] = c[h]);
                        return u;
                    }
                    append(l, a) {
                        Array.isArray(a) ? a.forEach((c)=>l.appendChild(c)) : l.appendChild(a);
                    }
                    prepend(l, a) {
                        Array.isArray(a) ? (a = a.reverse()).forEach((c)=>l.prepend(c)) : l.prepend(a);
                    }
                }
            },
            function(t1, o) {
                t1.exports = `.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}`;
            }
        ]).default;
    });
})($ca477aae3d96de69$var$$t);
var $ca477aae3d96de69$var$di = $ca477aae3d96de69$var$$t.exports;
const $ca477aae3d96de69$var$hi = /* @__PURE__ */ $ca477aae3d96de69$var$Fe($ca477aae3d96de69$var$di);
let $ca477aae3d96de69$var$U = null;
function $ca477aae3d96de69$var$st() {
    $ca477aae3d96de69$var$U || ($ca477aae3d96de69$var$U = new $ca477aae3d96de69$var$hi());
}
function $ca477aae3d96de69$var$ui(n, e, t1) {
    $ca477aae3d96de69$var$st(), $ca477aae3d96de69$var$U == null || $ca477aae3d96de69$var$U.show(n, e, t1);
}
function $ca477aae3d96de69$var$Ne(n = !1) {
    $ca477aae3d96de69$var$st(), $ca477aae3d96de69$var$U == null || $ca477aae3d96de69$var$U.hide(n);
}
function $ca477aae3d96de69$var$Pe(n, e, t1) {
    $ca477aae3d96de69$var$st(), $ca477aae3d96de69$var$U == null || $ca477aae3d96de69$var$U.onHover(n, e, t1);
}
function $ca477aae3d96de69$var$pi() {
    $ca477aae3d96de69$var$U == null || $ca477aae3d96de69$var$U.destroy(), $ca477aae3d96de69$var$U = null;
}
class $ca477aae3d96de69$var$fi extends $ca477aae3d96de69$var$y {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        });
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e, t1, o)=>this.show(e, t1, o),
            hide: ()=>this.hide(),
            onHover: (e, t1, o)=>this.onHover(e, t1, o)
        };
    }
    /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ show(e, t1, o) {
        $ca477aae3d96de69$var$ui(e, t1, o);
    }
    /**
   * Method hides tooltip on HTML page
   */ hide() {
        $ca477aae3d96de69$var$Ne();
    }
    /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ onHover(e, t1, o) {
        $ca477aae3d96de69$var$Pe(e, t1, o);
    }
}
class $ca477aae3d96de69$var$gi extends $ca477aae3d96de69$var$y {
    /**
   * Available methods / getters
   */ get methods() {
        return {
            nodes: this.editorNodes
        };
    }
    /**
   * Exported classes
   */ get editorNodes() {
        return {
            /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
            /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
        };
    }
}
function $ca477aae3d96de69$var$Yt(n, e) {
    const t1 = {};
    return Object.entries(n).forEach(([o, i])=>{
        if ($ca477aae3d96de69$var$R(i)) {
            const s = e ? `${e}.${o}` : o;
            Object.values(i).every((l)=>$ca477aae3d96de69$var$Q(l)) ? t1[o] = s : t1[o] = $ca477aae3d96de69$var$Yt(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
const $ca477aae3d96de69$var$K = $ca477aae3d96de69$var$Yt($ca477aae3d96de69$var$Lt);
function $ca477aae3d96de69$var$mi(n, e) {
    const t1 = {};
    return Object.keys(n).forEach((o)=>{
        const i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
const $ca477aae3d96de69$var$Wt = class ve {
    /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */ constructor(e, t1){
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ get currentItem() {
        return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ setCursor(e) {
        e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ setItems(e) {
        this.items = e;
    }
    /**
   * Sets cursor next to the current
   */ next() {
        this.cursor = this.leafNodesAndReturnIndex(ve.directions.RIGHT);
    }
    /**
   * Sets cursor before current
   */ previous() {
        this.cursor = this.leafNodesAndReturnIndex(ve.directions.LEFT);
    }
    /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ dropCursor() {
        this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ leafNodesAndReturnIndex(e) {
        if (this.items.length === 0) return this.cursor;
        let t1 = this.cursor;
        return t1 === -1 ? t1 = e === ve.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === ve.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $ca477aae3d96de69$var$d.canSetCaret(this.items[t1]) && $ca477aae3d96de69$var$Oe(()=>$ca477aae3d96de69$var$b.setCursor(this.items[t1]), 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
    }
};
$ca477aae3d96de69$var$Wt.directions = {
    RIGHT: "right",
    LEFT: "left"
};
let $ca477aae3d96de69$var$me = $ca477aae3d96de69$var$Wt;
class $ca477aae3d96de69$var$le {
    /**
   * @param options - different constructing settings
   */ constructor(e){
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = (t1)=>{
            if (this.isEventReadyForHandling(t1)) switch($ca477aae3d96de69$var$le.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $ca477aae3d96de69$var$w.TAB:
                    this.handleTabPress(t1);
                    break;
                case $ca477aae3d96de69$var$w.LEFT:
                case $ca477aae3d96de69$var$w.UP:
                    this.flipLeft();
                    break;
                case $ca477aae3d96de69$var$w.RIGHT:
                case $ca477aae3d96de69$var$w.DOWN:
                    this.flipRight();
                    break;
                case $ca477aae3d96de69$var$w.ENTER:
                    this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $ca477aae3d96de69$var$me(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || $ca477aae3d96de69$var$le.usedKeys;
    }
    /**
   * True if flipper is currently activated
   */ get isActivated() {
        return this.activated;
    }
    /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ static get usedKeys() {
        return [
            $ca477aae3d96de69$var$w.TAB,
            $ca477aae3d96de69$var$w.LEFT,
            $ca477aae3d96de69$var$w.RIGHT,
            $ca477aae3d96de69$var$w.ENTER,
            $ca477aae3d96de69$var$w.UP,
            $ca477aae3d96de69$var$w.DOWN
        ];
    }
    /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ activate(e, t1) {
        this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
   * Disable tab/arrows handling by flipper
   */ deactivate() {
        this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
   * Focus first item
   */ focusFirst() {
        this.dropCursor(), this.flipRight();
    }
    /**
   * Focuses previous flipper iterator item
   */ flipLeft() {
        this.iterator.previous(), this.flipCallback();
    }
    /**
   * Focuses next flipper iterator item
   */ flipRight() {
        this.iterator.next(), this.flipCallback();
    }
    /**
   * Return true if some button is focused
   */ hasFocus() {
        return !!this.iterator.currentItem;
    }
    /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ onFlip(e) {
        this.flipCallbacks.push(e);
    }
    /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ removeOnFlip(e) {
        this.flipCallbacks = this.flipCallbacks.filter((t1)=>t1 !== e);
    }
    /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ dropCursor() {
        this.iterator.dropCursor();
    }
    /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ isEventReadyForHandling(e) {
        return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ handleTabPress(e) {
        switch(e.shiftKey ? $ca477aae3d96de69$var$me.directions.LEFT : $ca477aae3d96de69$var$me.directions.RIGHT){
            case $ca477aae3d96de69$var$me.directions.RIGHT:
                this.flipRight();
                break;
            case $ca477aae3d96de69$var$me.directions.LEFT:
                this.flipLeft();
                break;
        }
    }
    /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ handleEnterPress(e) {
        this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $ca477aae3d96de69$var$O(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
   * Fired after flipping in any direction
   */ flipCallback() {
        this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach((e)=>e());
    }
}
const $ca477aae3d96de69$var$bi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $ca477aae3d96de69$var$ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $ca477aae3d96de69$var$vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $ca477aae3d96de69$var$wi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $ca477aae3d96de69$var$xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $ca477aae3d96de69$var$yi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $ca477aae3d96de69$var$Ei = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $ca477aae3d96de69$var$Bi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $ca477aae3d96de69$var$xt = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $ca477aae3d96de69$var$Ti = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $ca477aae3d96de69$var$Ci = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $ca477aae3d96de69$var$Kt = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $ca477aae3d96de69$var$Si = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $ca477aae3d96de69$var$Ii = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $ca477aae3d96de69$var$Mi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $ca477aae3d96de69$var$Ai = "__", $ca477aae3d96de69$var$Oi = "--";
function $ca477aae3d96de69$var$te(n) {
    return (e, t1)=>[
            [
                n,
                e
            ].filter((i)=>!!i).join($ca477aae3d96de69$var$Ai),
            t1
        ].filter((i)=>!!i).join($ca477aae3d96de69$var$Oi);
}
const $ca477aae3d96de69$var$be = $ca477aae3d96de69$var$te("ce-hint"), $ca477aae3d96de69$var$ke = {
    root: $ca477aae3d96de69$var$be(),
    alignedStart: $ca477aae3d96de69$var$be(null, "align-left"),
    alignedCenter: $ca477aae3d96de69$var$be(null, "align-center"),
    title: $ca477aae3d96de69$var$be("title"),
    description: $ca477aae3d96de69$var$be("description")
};
class $ca477aae3d96de69$var$Li {
    /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */ constructor(e){
        this.nodes = {
            root: $ca477aae3d96de69$var$d.make("div", [
                $ca477aae3d96de69$var$ke.root,
                e.alignment === "center" ? $ca477aae3d96de69$var$ke.alignedCenter : $ca477aae3d96de69$var$ke.alignedStart
            ]),
            title: $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$ke.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$ke.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    /**
   * Returns the root element of the hint content
   */ getElement() {
        return this.nodes.root;
    }
}
class $ca477aae3d96de69$var$nt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        this.params = e;
    }
    /**
   * Item name if exists
   */ get name() {
        if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
   * Destroys the instance
   */ destroy() {
        $ca477aae3d96de69$var$Ne();
    }
    /**
   * Called when children popover is opened (if exists)
   */ onChildrenOpen() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
   * Called when children popover is closed (if exists)
   */ onChildrenClose() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
   * Called on popover item click
   */ handleClick() {
        var e, t1;
        this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
    }
    /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ addHint(e, t1) {
        const o = new $ca477aae3d96de69$var$Li(t1);
        $ca477aae3d96de69$var$Pe(e, o.getElement(), {
            placement: t1.position,
            hidingDelay: 100
        });
    }
    /**
   * Returns item children that are represented as popover items
   */ get children() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
   * Returns true if item has any type of children
   */ get hasChildren() {
        return this.children.length > 0;
    }
    /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ get isChildrenOpen() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
   * True if item children items should be navigatable via keyboard
   */ get isChildrenFlippable() {
        var e;
        return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
   * Returns true if item has children that should be searchable
   */ get isChildrenSearchable() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
   * True if popover should close once item is activated
   */ get closeOnActivate() {
        return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
   * True if item is active
   */ get isActive() {
        return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
}
const $ca477aae3d96de69$var$W = $ca477aae3d96de69$var$te("ce-popover-item"), $ca477aae3d96de69$var$L = {
    container: $ca477aae3d96de69$var$W(),
    active: $ca477aae3d96de69$var$W(null, "active"),
    disabled: $ca477aae3d96de69$var$W(null, "disabled"),
    focused: $ca477aae3d96de69$var$W(null, "focused"),
    hidden: $ca477aae3d96de69$var$W(null, "hidden"),
    confirmationState: $ca477aae3d96de69$var$W(null, "confirmation"),
    noHover: $ca477aae3d96de69$var$W(null, "no-hover"),
    noFocus: $ca477aae3d96de69$var$W(null, "no-focus"),
    title: $ca477aae3d96de69$var$W("title"),
    secondaryTitle: $ca477aae3d96de69$var$W("secondary-title"),
    icon: $ca477aae3d96de69$var$W("icon"),
    iconTool: $ca477aae3d96de69$var$W("icon", "tool"),
    iconChevronRight: $ca477aae3d96de69$var$W("icon", "chevron-right"),
    wobbleAnimation: $ca477aae3d96de69$var$te("wobble")()
};
class $ca477aae3d96de69$var$se extends $ca477aae3d96de69$var$nt {
    /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e), this.params = e, this.nodes = {
            root: null,
            icon: null
        }, this.confirmationState = null, this.removeSpecialFocusBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($ca477aae3d96de69$var$L.noFocus);
        }, this.removeSpecialHoverBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($ca477aae3d96de69$var$L.noHover);
        }, this.onErrorAnimationEnd = ()=>{
            var o, i;
            (o = this.nodes.icon) == null || o.classList.remove($ca477aae3d96de69$var$L.wobbleAnimation), (i = this.nodes.icon) == null || i.removeEventListener("animationend", this.onErrorAnimationEnd);
        }, this.nodes.root = this.make(e, t1);
    }
    /**
   * True if item is disabled and hence not clickable
   */ get isDisabled() {
        return this.params.isDisabled === !0;
    }
    /**
   * Exposes popover item toggle parameter
   */ get toggle() {
        return this.params.toggle;
    }
    /**
   * Item title
   */ get title() {
        return this.params.title;
    }
    /**
   * True if confirmation state is enabled for popover item
   */ get isConfirmationStateEnabled() {
        return this.confirmationState !== null;
    }
    /**
   * True if item is focused in keyboard navigation process
   */ get isFocused() {
        return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($ca477aae3d96de69$var$L.focused);
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Called on popover item click
   */ handleClick() {
        if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
            this.activateOrEnableConfirmationMode(this.confirmationState);
            return;
        }
        this.activateOrEnableConfirmationMode(this.params);
    }
    /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ toggleActive(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($ca477aae3d96de69$var$L.active, e);
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($ca477aae3d96de69$var$L.hidden, e);
    }
    /**
   * Resets popover item to its original state
   */ reset() {
        this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
   * Method called once item becomes focused during keyboard navigation
   */ onFocus() {
        this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ make(e, t1) {
        var s, r;
        const o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $ca477aae3d96de69$var$d.make(o, $ca477aae3d96de69$var$L.container, {
            type: o === "button" ? "button" : void 0
        });
        return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$L.icon,
            $ca477aae3d96de69$var$L.iconTool
        ], {
            innerHTML: e.icon || $ca477aae3d96de69$var$Ei
        }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$L.title, {
            innerHTML: e.title || ""
        })), e.secondaryLabel && i.appendChild($ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$L.secondaryTitle, {
            textContent: e.secondaryLabel
        })), this.hasChildren && i.appendChild($ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$L.icon,
            $ca477aae3d96de69$var$L.iconChevronRight
        ], {
            innerHTML: $ca477aae3d96de69$var$wi
        })), this.isActive && i.classList.add($ca477aae3d96de69$var$L.active), e.isDisabled && i.classList.add($ca477aae3d96de69$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, {
            ...e.hint,
            position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
        }), i;
    }
    /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ enableConfirmationMode(e) {
        if (this.nodes.root === null) return;
        const t1 = {
            ...this.params,
            ...e,
            confirmation: "confirmation" in e ? e.confirmation : void 0
        }, o = this.make(t1);
        this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($ca477aae3d96de69$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
   * Returns item to its original state
   */ disableConfirmationMode() {
        if (this.nodes.root === null) return;
        const e = this.make(this.params);
        this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($ca477aae3d96de69$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ enableSpecialHoverAndFocusBehavior() {
        var e, t1, o;
        (e = this.nodes.root) == null || e.classList.add($ca477aae3d96de69$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($ca477aae3d96de69$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
            once: !0
        });
    }
    /**
   * Disables special focus and hover behavior
   */ disableSpecialHoverAndFocusBehavior() {
        var e;
        this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ activateOrEnableConfirmationMode(e) {
        var t1;
        if (!("confirmation" in e) || e.confirmation === void 0) try {
            (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
        } catch  {
            this.animateError();
        }
        else this.enableConfirmationMode(e.confirmation);
    }
    /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ animateError() {
        var e, t1, o;
        (e = this.nodes.icon) != null && e.classList.contains($ca477aae3d96de69$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($ca477aae3d96de69$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
}
const $ca477aae3d96de69$var$Ue = $ca477aae3d96de69$var$te("ce-popover-item-separator"), $ca477aae3d96de69$var$je = {
    container: $ca477aae3d96de69$var$Ue(),
    line: $ca477aae3d96de69$var$Ue("line"),
    hidden: $ca477aae3d96de69$var$Ue(null, "hidden")
};
class $ca477aae3d96de69$var$Xt extends $ca477aae3d96de69$var$nt {
    /**
   * Constructs the instance
   */ constructor(){
        super(), this.nodes = {
            root: $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$je.container),
            line: $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$je.line)
        }, this.nodes.root.appendChild(this.nodes.line);
    }
    /**
   * Returns popover separator root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($ca477aae3d96de69$var$je.hidden, e);
    }
}
var $ca477aae3d96de69$var$Z = /* @__PURE__ */ ((n)=>(n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n))($ca477aae3d96de69$var$Z || {});
const $ca477aae3d96de69$var$H = $ca477aae3d96de69$var$te("ce-popover"), $ca477aae3d96de69$var$N = {
    popover: $ca477aae3d96de69$var$H(),
    popoverContainer: $ca477aae3d96de69$var$H("container"),
    popoverOpenTop: $ca477aae3d96de69$var$H(null, "open-top"),
    popoverOpenLeft: $ca477aae3d96de69$var$H(null, "open-left"),
    popoverOpened: $ca477aae3d96de69$var$H(null, "opened"),
    search: $ca477aae3d96de69$var$H("search"),
    nothingFoundMessage: $ca477aae3d96de69$var$H("nothing-found-message"),
    nothingFoundMessageDisplayed: $ca477aae3d96de69$var$H("nothing-found-message", "displayed"),
    items: $ca477aae3d96de69$var$H("items"),
    overlay: $ca477aae3d96de69$var$H("overlay"),
    overlayHidden: $ca477aae3d96de69$var$H("overlay", "hidden"),
    popoverNested: $ca477aae3d96de69$var$H(null, "nested"),
    getPopoverNestedClass: (n)=>$ca477aae3d96de69$var$H(null, `nested-level-${n.toString()}`),
    popoverInline: $ca477aae3d96de69$var$H(null, "inline"),
    popoverHeader: $ca477aae3d96de69$var$H("header")
};
var $ca477aae3d96de69$var$de = /* @__PURE__ */ ((n)=>(n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n))($ca477aae3d96de69$var$de || {});
const $ca477aae3d96de69$var$yt = $ca477aae3d96de69$var$te("ce-popover-item-html"), $ca477aae3d96de69$var$Et = {
    root: $ca477aae3d96de69$var$yt(),
    hidden: $ca477aae3d96de69$var$yt(null, "hidden")
};
class $ca477aae3d96de69$var$Ee extends $ca477aae3d96de69$var$nt {
    /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        var o, i;
        super(e), this.nodes = {
            root: $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$Et.root)
        }, this.nodes.root.appendChild(e.element), e.name && (this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && this.addHint(this.nodes.root, {
            ...e.hint,
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        });
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($ca477aae3d96de69$var$Et.hidden, e);
    }
    /**
   * Returns list of buttons and inputs inside custom content
   */ getControls() {
        const e = this.nodes.root.querySelectorAll(`button, ${$ca477aae3d96de69$var$d.allInputsSelector}`);
        return Array.from(e);
    }
}
class $ca477aae3d96de69$var$Vt extends $ca477aae3d96de69$var$Te {
    /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1 = {}){
        super(), this.params = e, this.itemsRenderParams = t1, this.listeners = new $ca477aae3d96de69$var$Ce(), this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, this.items = this.buildItems(e.items), e.messages && (this.messages = {
            ...this.messages,
            ...e.messages
        }), this.nodes = {}, this.nodes.popoverContainer = $ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$N.popoverContainer
        ]), this.nodes.nothingFoundMessage = $ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$N.nothingFoundMessage
        ], {
            textContent: this.messages.nothingFound
        }), this.nodes.popoverContainer.appendChild(this.nodes.nothingFoundMessage), this.nodes.items = $ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$N.items
        ]), this.items.forEach((o)=>{
            const i = o.getElement();
            i !== null && this.nodes.items.appendChild(i);
        }), this.nodes.popoverContainer.appendChild(this.nodes.items), this.listeners.on(this.nodes.popoverContainer, "click", (o)=>this.handleClick(o)), this.nodes.popover = $ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$N.popover,
            this.params.class
        ]), this.nodes.popover.appendChild(this.nodes.popoverContainer);
    }
    /**
   * List of default popover items that are searchable and may have confirmation state
   */ get itemsDefault() {
        return this.items.filter((e)=>e instanceof $ca477aae3d96de69$var$se);
    }
    /**
   * Returns HTML element corresponding to the popover
   */ getElement() {
        return this.nodes.popover;
    }
    /**
   * Open popover
   */ show() {
        this.nodes.popover.classList.add($ca477aae3d96de69$var$N.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
   * Closes popover
   */ hide() {
        this.nodes.popover.classList.remove($ca477aae3d96de69$var$N.popoverOpened), this.nodes.popover.classList.remove($ca477aae3d96de69$var$N.popoverOpenTop), this.itemsDefault.forEach((e)=>e.reset()), this.search !== void 0 && this.search.clear(), this.emit($ca477aae3d96de69$var$Z.Closed);
    }
    /**
   * Clears memory
   */ destroy() {
        var e;
        this.items.forEach((t1)=>t1.destroy()), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ activateItemByName(e) {
        const t1 = this.items.find((o)=>o.name === e);
        this.handleItemClick(t1);
    }
    /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ buildItems(e) {
        return e.map((t1)=>{
            switch(t1.type){
                case $ca477aae3d96de69$var$A.Separator:
                    return new $ca477aae3d96de69$var$Xt();
                case $ca477aae3d96de69$var$A.Html:
                    return new $ca477aae3d96de69$var$Ee(t1, this.itemsRenderParams[$ca477aae3d96de69$var$A.Html]);
                default:
                    return new $ca477aae3d96de69$var$se(t1, this.itemsRenderParams[$ca477aae3d96de69$var$A.Default]);
            }
        });
    }
    /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ getTargetItem(e) {
        return this.items.filter((t1)=>t1 instanceof $ca477aae3d96de69$var$se || t1 instanceof $ca477aae3d96de69$var$Ee).find((t1)=>{
            const o = t1.getElement();
            return o === null ? !1 : e.composedPath().includes(o);
        });
    }
    /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ handleItemClick(e) {
        if (!("isDisabled" in e && e.isDisabled)) {
            if (e.hasChildren) {
                this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                return;
            }
            this.itemsDefault.filter((t1)=>t1 !== e).forEach((t1)=>t1.reset()), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($ca477aae3d96de69$var$Z.ClosedOnActivate));
        }
    }
    /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ handleClick(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.handleItemClick(t1);
    }
    /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ toggleItemActivenessIfNeeded(e) {
        if (e instanceof $ca477aae3d96de69$var$se && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
            const t1 = this.itemsDefault.filter((o)=>o.toggle === e.toggle);
            if (t1.length === 1) {
                e.toggleActive();
                return;
            }
            t1.forEach((o)=>{
                o.toggleActive(o === e);
            });
        }
    }
}
var $ca477aae3d96de69$var$De = /* @__PURE__ */ ((n)=>(n.Search = "search", n))($ca477aae3d96de69$var$De || {});
const $ca477aae3d96de69$var$$e = $ca477aae3d96de69$var$te("cdx-search-field"), $ca477aae3d96de69$var$Ye = {
    wrapper: $ca477aae3d96de69$var$$e(),
    icon: $ca477aae3d96de69$var$$e("icon"),
    input: $ca477aae3d96de69$var$$e("input")
};
class $ca477aae3d96de69$var$_i extends $ca477aae3d96de69$var$Te {
    /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */ constructor({ items: e, placeholder: t1 }){
        super(), this.listeners = new $ca477aae3d96de69$var$Ce(), this.items = e, this.wrapper = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$Ye.wrapper);
        const o = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$Ye.icon, {
            innerHTML: $ca477aae3d96de69$var$Si
        });
        this.input = $ca477aae3d96de69$var$d.make("input", $ca477aae3d96de69$var$Ye.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), this.wrapper.appendChild(o), this.wrapper.appendChild(this.input), this.listeners.on(this.input, "input", ()=>{
            this.searchQuery = this.input.value, this.emit($ca477aae3d96de69$var$De.Search, {
                query: this.searchQuery,
                items: this.foundItems
            });
        });
    }
    /**
   * Returns search field element
   */ getElement() {
        return this.wrapper;
    }
    /**
   * Sets focus to the input
   */ focus() {
        this.input.focus();
    }
    /**
   * Clears search query and results
   */ clear() {
        this.input.value = "", this.searchQuery = "", this.emit($ca477aae3d96de69$var$De.Search, {
            query: "",
            items: this.foundItems
        });
    }
    /**
   * Clears memory
   */ destroy() {
        this.listeners.removeAll();
    }
    /**
   * Returns list of found items for the current search query
   */ get foundItems() {
        return this.items.filter((e)=>this.checkItem(e));
    }
    /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ checkItem(e) {
        var i, s;
        const t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
        return o !== void 0 ? t1.includes(o) : !1;
    }
}
var $ca477aae3d96de69$var$Ni = Object.defineProperty, $ca477aae3d96de69$var$Pi = Object.getOwnPropertyDescriptor, $ca477aae3d96de69$var$Di = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $ca477aae3d96de69$var$Pi(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $ca477aae3d96de69$var$Ni(e, t1, i), i;
};
const $ca477aae3d96de69$var$qt = class Zt extends $ca477aae3d96de69$var$Vt {
    /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e, t1), this.nestingLevel = 0, this.nestedPopoverTriggerItem = null, this.previouslyHoveredItem = null, this.scopeElement = document.body, this.hide = ()=>{
            var o;
            super.hide(), this.destroyNestedPopoverIfExists(), (o = this.flipper) == null || o.deactivate(), this.previouslyHoveredItem = null;
        }, this.onFlip = ()=>{
            const o = this.itemsDefault.find((i)=>i.isFocused);
            o == null || o.onFocus();
        }, this.onSearch = (o)=>{
            var l;
            const i = o.query === "", s = o.items.length === 0;
            this.items.forEach((a)=>{
                let c = !1;
                a instanceof $ca477aae3d96de69$var$se ? c = !o.items.includes(a) : (a instanceof $ca477aae3d96de69$var$Xt || a instanceof $ca477aae3d96de69$var$Ee) && (c = s || !i), a.toggleHidden(c);
            }), this.toggleNothingFoundMessage(s);
            const r = o.query === "" ? this.flippableElements : o.items.map((a)=>a.getElement());
            (l = this.flipper) != null && l.isActivated && (this.flipper.deactivate(), this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (this.nestingLevel = e.nestingLevel), this.nestingLevel > 0 && this.nodes.popover.classList.add($ca477aae3d96de69$var$N.popoverNested), e.scopeElement !== void 0 && (this.scopeElement = e.scopeElement), this.nodes.popoverContainer !== null && this.listeners.on(this.nodes.popoverContainer, "mouseover", (o)=>this.handleHover(o)), e.searchable && this.addSearch(), e.flippable !== !1 && (this.flipper = new $ca477aae3d96de69$var$le({
            items: this.flippableElements,
            focusedItemClass: $ca477aae3d96de69$var$L.focused,
            allowedKeys: [
                $ca477aae3d96de69$var$w.TAB,
                $ca477aae3d96de69$var$w.UP,
                $ca477aae3d96de69$var$w.DOWN,
                $ca477aae3d96de69$var$w.ENTER
            ]
        }), this.flipper.onFlip(this.onFlip));
    }
    /**
   * Returns true if some item inside popover is focused
   */ hasFocus() {
        return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
   * Scroll position inside items container of the popover
   */ get scrollTop() {
        return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
   * Returns visible element offset top
   */ get offsetTop() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
   * Open popover
   */ show() {
        var e;
        this.nodes.popover.style.setProperty($ca477aae3d96de69$var$de.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($ca477aae3d96de69$var$N.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($ca477aae3d96de69$var$N.popoverOpenLeft), super.show(), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
   * Clears memory
   */ destroy() {
        this.hide(), super.destroy();
    }
    /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ handleHover(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
    }
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
        e.style.setProperty($ca477aae3d96de69$var$de.TriggerItemTop, s + "px");
    }
    /**
   * Destroys existing nested popover
   */ destroyNestedPopoverIfExists() {
        var e, t1;
        this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($ca477aae3d96de69$var$Z.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        var o;
        this.nestedPopover = new Zt({
            searchable: e.isChildrenSearchable,
            items: e.children,
            nestingLevel: this.nestingLevel + 1,
            flippable: e.isChildrenFlippable,
            messages: this.messages
        }), e.onChildrenOpen(), this.nestedPopover.on($ca477aae3d96de69$var$Z.ClosedOnActivate, this.hide);
        const t1 = this.nestedPopover.getElement();
        return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($ca477aae3d96de69$var$de.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ get shouldOpenBottom() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
        return s < t1.top || i <= r;
    }
    /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ get shouldOpenRight() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
        return s < t1.left || i <= r;
    }
    get size() {
        var i;
        const e = {
            height: 0,
            width: 0
        };
        if (this.nodes.popover === null) return e;
        const t1 = this.nodes.popover.cloneNode(!0);
        t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($ca477aae3d96de69$var$N.popoverOpened), (i = t1.querySelector("." + $ca477aae3d96de69$var$N.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
        const o = t1.querySelector("." + $ca477aae3d96de69$var$N.popoverContainer);
        return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
    }
    /**
   * Returns list of elements available for keyboard navigation.
   */ get flippableElements() {
        return this.items.map((t1)=>{
            if (t1 instanceof $ca477aae3d96de69$var$se) return t1.getElement();
            if (t1 instanceof $ca477aae3d96de69$var$Ee) return t1.getControls();
        }).flat().filter((t1)=>t1 != null);
    }
    /**
   * Adds search to the popover
   */ addSearch() {
        this.search = new $ca477aae3d96de69$var$_i({
            items: this.itemsDefault,
            placeholder: this.messages.search
        }), this.search.on($ca477aae3d96de69$var$De.Search, this.onSearch);
        const e = this.search.getElement();
        e.classList.add($ca477aae3d96de69$var$N.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ toggleNothingFoundMessage(e) {
        this.nodes.nothingFoundMessage.classList.toggle($ca477aae3d96de69$var$N.nothingFoundMessageDisplayed, e);
    }
};
$ca477aae3d96de69$var$Di([
    $ca477aae3d96de69$var$ue
], $ca477aae3d96de69$var$qt.prototype, "size", 1);
let $ca477aae3d96de69$var$rt = $ca477aae3d96de69$var$qt;
class $ca477aae3d96de69$var$Ri extends $ca477aae3d96de69$var$rt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        const t1 = !$ca477aae3d96de69$var$pe();
        super({
            ...e,
            class: $ca477aae3d96de69$var$N.popoverInline
        }, {
            [$ca477aae3d96de69$var$A.Default]: {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            },
            [$ca477aae3d96de69$var$A.Html]: {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }
        }), this.items.forEach((o)=>{
            !(o instanceof $ca477aae3d96de69$var$se) && !(o instanceof $ca477aae3d96de69$var$Ee) || o.hasChildren && o.isChildrenOpen && this.showNestedItems(o);
        });
    }
    /**
   * Returns visible element offset top
   */ get offsetLeft() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
   * Open popover
   */ show() {
        this.nestingLevel === 0 && this.nodes.popover.style.setProperty($ca477aae3d96de69$var$de.InlinePopoverWidth, this.size.width + "px"), super.show();
    }
    /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ handleHover() {}
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
        e.style.setProperty($ca477aae3d96de69$var$de.TriggerItemLeft, s + "px");
    }
    /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ showNestedItems(e) {
        if (this.nestedPopoverTriggerItem === e) {
            this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
            return;
        }
        super.showNestedItems(e);
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        const t1 = super.showNestedPopoverForItem(e);
        return t1.getElement().classList.add($ca477aae3d96de69$var$N.getPopoverNestedClass(t1.nestingLevel)), t1;
    }
    /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ handleItemClick(e) {
        var t1;
        e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), super.destroyNestedPopoverIfExists()), super.handleItemClick(e);
    }
}
const $ca477aae3d96de69$var$Gt = class we {
    constructor(){
        this.scrollPosition = null;
    }
    /**
   * Locks body element scroll
   */ lock() {
        $ca477aae3d96de69$var$Ge ? this.lockHard() : document.body.classList.add(we.CSS.scrollLocked);
    }
    /**
   * Unlocks body element scroll
   */ unlock() {
        $ca477aae3d96de69$var$Ge ? this.unlockHard() : document.body.classList.remove(we.CSS.scrollLocked);
    }
    /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ lockHard() {
        this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", `${this.scrollPosition}px`), document.body.classList.add(we.CSS.scrollLockedHard);
    }
    /**
   * Unlocks hard scroll lock
   */ unlockHard() {
        document.body.classList.remove(we.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
};
$ca477aae3d96de69$var$Gt.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
let $ca477aae3d96de69$var$Fi = $ca477aae3d96de69$var$Gt;
const $ca477aae3d96de69$var$We = $ca477aae3d96de69$var$te("ce-popover-header"), $ca477aae3d96de69$var$Ke = {
    root: $ca477aae3d96de69$var$We(),
    text: $ca477aae3d96de69$var$We("text"),
    backButton: $ca477aae3d96de69$var$We("back-button")
};
class $ca477aae3d96de69$var$Hi {
    /**
   * Constructs the instance
   *
   * @param params - popover header params
   */ constructor({ text: e, onBackButtonClick: t1 }){
        this.listeners = new $ca477aae3d96de69$var$Ce(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $ca477aae3d96de69$var$d.make("div", [
                $ca477aae3d96de69$var$Ke.root
            ]),
            backButton: $ca477aae3d96de69$var$d.make("button", [
                $ca477aae3d96de69$var$Ke.backButton
            ]),
            text: $ca477aae3d96de69$var$d.make("div", [
                $ca477aae3d96de69$var$Ke.text
            ])
        }, this.nodes.backButton.innerHTML = $ca477aae3d96de69$var$vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    /**
   * Returns popover header root html element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Destroys the instance
   */ destroy() {
        this.nodes.root.remove(), this.listeners.destroy();
    }
}
class $ca477aae3d96de69$var$zi {
    constructor(){
        this.history = [];
    }
    /**
   * Push new popover state
   *
   * @param state - new state
   */ push(e) {
        this.history.push(e);
    }
    /**
   * Pop last popover state
   */ pop() {
        return this.history.pop();
    }
    /**
   * Title retrieved from the current state
   */ get currentTitle() {
        return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
   * Items list retrieved from the current state
   */ get currentItems() {
        return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
   * Returns history to initial popover state
   */ reset() {
        for(; this.history.length > 1;)this.pop();
    }
}
class $ca477aae3d96de69$var$Jt extends $ca477aae3d96de69$var$Vt {
    /**
   * Construct the instance
   *
   * @param params - popover params
   */ constructor(e){
        super(e, {
            [$ca477aae3d96de69$var$A.Default]: {
                hint: {
                    enabled: !1
                }
            },
            [$ca477aae3d96de69$var$A.Html]: {
                hint: {
                    enabled: !1
                }
            }
        }), this.scrollLocker = new $ca477aae3d96de69$var$Fi(), this.history = new $ca477aae3d96de69$var$zi(), this.isHidden = !0, this.nodes.overlay = $ca477aae3d96de69$var$d.make("div", [
            $ca477aae3d96de69$var$N.overlay,
            $ca477aae3d96de69$var$N.overlayHidden
        ]), this.nodes.popover.insertBefore(this.nodes.overlay, this.nodes.popover.firstChild), this.listeners.on(this.nodes.overlay, "click", ()=>{
            this.hide();
        }), this.history.push({
            items: e.items
        });
    }
    /**
   * Open popover
   */ show() {
        this.nodes.overlay.classList.remove($ca477aae3d96de69$var$N.overlayHidden), super.show(), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
   * Closes popover
   */ hide() {
        this.isHidden || (super.hide(), this.nodes.overlay.classList.add($ca477aae3d96de69$var$N.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
   * Clears memory
   */ destroy() {
        super.destroy(), this.scrollLocker.unlock();
    }
    /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.updateItemsAndHeader(e.children, e.title), this.history.push({
            title: e.title,
            items: e.children
        });
    }
    /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ updateItemsAndHeader(e, t1) {
        if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
            this.header = new $ca477aae3d96de69$var$Hi({
                text: t1,
                onBackButtonClick: ()=>{
                    this.history.pop(), this.updateItemsAndHeader(this.history.currentItems, this.history.currentTitle);
                }
            });
            const o = this.header.getElement();
            o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
        }
        this.items.forEach((o)=>{
            var i;
            return (i = o.getElement()) == null ? void 0 : i.remove();
        }), this.items = this.buildItems(e), this.items.forEach((o)=>{
            var s;
            const i = o.getElement();
            i !== null && ((s = this.nodes.items) == null || s.appendChild(i));
        });
    }
}
class $ca477aae3d96de69$var$Ui extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.opened = !1, this.selection = new $ca477aae3d96de69$var$b(), this.popover = null, this.close = ()=>{
            this.opened && (this.opened = !1, $ca477aae3d96de69$var$b.isAtEditor || this.selection.restore(), this.selection.clearSaved(), !this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && this.Editor.BlockManager.currentBlock && this.Editor.BlockSelection.unselectBlock(this.Editor.BlockManager.currentBlock), this.eventsDispatcher.emit(this.events.closed), this.popover && (this.popover.off($ca477aae3d96de69$var$Z.Closed, this.onPopoverClose), this.popover.destroy(), this.popover.getElement().remove(), this.popover = null));
        }, this.onPopoverClose = ()=>{
            this.close();
        };
    }
    /**
   * Module Events
   */ get events() {
        return {
            opened: "block-settings-opened",
            closed: "block-settings-closed"
        };
    }
    /**
   * Block Settings CSS
   */ get CSS() {
        return {
            settings: "ce-settings"
        };
    }
    /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ get flipper() {
        var e;
        if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ make() {
        this.nodes.wrapper = $ca477aae3d96de69$var$d.make("div", [
            this.CSS.settings
        ]), this.eventsDispatcher.on($ca477aae3d96de69$var$ye, this.close);
    }
    /**
   * Destroys module
   */ destroy() {
        this.removeAllNodes(), this.listeners.destroy(), this.eventsDispatcher.off($ca477aae3d96de69$var$ye, this.close);
    }
    /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ async open(e = this.Editor.BlockManager.currentBlock) {
        var s;
        this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
        const { toolTunes: t1, commonTunes: o } = e.getTunes();
        this.eventsDispatcher.emit(this.events.opened);
        const i = $ca477aae3d96de69$var$pe() ? $ca477aae3d96de69$var$Jt : $ca477aae3d96de69$var$rt;
        this.popover = new i({
            searchable: !0,
            items: await this.getTunesItems(e, o, t1),
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Nothing found"),
                search: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Filter")
            }
        }), this.popover.on($ca477aae3d96de69$var$Z.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.wrapper;
    }
    /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ async getTunesItems(e, t1, o) {
        const i = [];
        o !== void 0 && o.length > 0 && (i.push(...o), i.push({
            type: $ca477aae3d96de69$var$A.Separator
        }));
        const s = Array.from(this.Editor.Tools.blockTools.values()), l = (await $ca477aae3d96de69$var$zt(e, s)).reduce((a, c)=>(c.toolbox.forEach((u)=>{
                a.push({
                    icon: u.icon,
                    title: $ca477aae3d96de69$var$z.t($ca477aae3d96de69$var$K.toolNames, u.title),
                    name: c.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const { BlockManager: h, Caret: p, Toolbar: g } = this.Editor, f = await h.convert(e, c.name, u.data);
                        g.close(), p.setToBlock(f, p.positions.END);
                    }
                });
            }), a), []);
        return l.length > 0 && (i.push({
            icon: $ca477aae3d96de69$var$Kt,
            name: "convert-to",
            title: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Convert to"),
            children: {
                searchable: !0,
                items: l
            }
        }), i.push({
            type: $ca477aae3d96de69$var$A.Separator
        })), i.push(...t1), i.map((a)=>this.resolveTuneAliases(a));
    }
    /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ resolveTuneAliases(e) {
        if (e.type === $ca477aae3d96de69$var$A.Separator || e.type === $ca477aae3d96de69$var$A.Html) return e;
        const t1 = $ca477aae3d96de69$var$mi(e, {
            label: "title"
        });
        return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
    }
}
var $ca477aae3d96de69$var$Qt = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, l) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: l
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var l = /* @__PURE__ */ Object.create(null);
                if (i.r(l), Object.defineProperty(l, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var a in s)i.d(l, a, (function(c) {
                    return s[c];
                }).bind(null, a));
                return l;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(a, c) {
                    for(var u = 0; u < c.length; u++){
                        var h = c[u];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(a, h.key, h);
                    }
                }
                function r(a, c, u) {
                    return c && s(a.prototype, c), u && s(a, u), a;
                }
                i.r(o);
                var l = function() {
                    function a(c) {
                        var u = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, a), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            u.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(a, null, [
                        {
                            key: "supportedCommands",
                            get: function() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(a, [
                        {
                            key: "parseShortcutName",
                            value: function(c) {
                                c = c.split("+");
                                for(var u = 0; u < c.length; u++){
                                    c[u] = c[u].toUpperCase();
                                    var h = !1;
                                    for(var p in a.supportedCommands)if (a.supportedCommands[p].includes(c[u])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[u]] = !0);
                                }
                                for(var g in a.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function(c) {
                                var u, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(u in this.commands)this.commands[u] !== h[u] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === a.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), a;
                }();
                o.default = l;
            }
        ]).default;
    });
})($ca477aae3d96de69$var$Qt);
var $ca477aae3d96de69$var$ji = $ca477aae3d96de69$var$Qt.exports;
const $ca477aae3d96de69$var$$i = /* @__PURE__ */ $ca477aae3d96de69$var$Fe($ca477aae3d96de69$var$ji);
class $ca477aae3d96de69$var$Yi {
    constructor(){
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ add(e) {
        if (this.findShortcut(e.on, e.name)) throw Error(`Shortcut ${e.name} is already registered for ${e.on}. Please remove it before add a new handler.`);
        const o = new $ca477aae3d96de69$var$$i({
            name: e.name,
            on: e.on,
            callback: e.handler
        }), i = this.registeredShortcuts.get(e.on) || [];
        this.registeredShortcuts.set(e.on, [
            ...i,
            o
        ]);
    }
    /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ remove(e, t1) {
        const o = this.findShortcut(e, t1);
        if (!o) return;
        o.remove();
        const i = this.registeredShortcuts.get(e);
        this.registeredShortcuts.set(e, i.filter((s)=>s !== o));
    }
    /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ findShortcut(e, t1) {
        return (this.registeredShortcuts.get(e) || []).find(({ name: i })=>i === t1);
    }
}
const $ca477aae3d96de69$var$he = new $ca477aae3d96de69$var$Yi();
var $ca477aae3d96de69$var$Wi = Object.defineProperty, $ca477aae3d96de69$var$Ki = Object.getOwnPropertyDescriptor, $ca477aae3d96de69$var$eo = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $ca477aae3d96de69$var$Ki(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $ca477aae3d96de69$var$Wi(e, t1, i), i;
}, $ca477aae3d96de69$var$Se = /* @__PURE__ */ ((n)=>(n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n))($ca477aae3d96de69$var$Se || {});
const $ca477aae3d96de69$var$lt = class to extends $ca477aae3d96de69$var$Te {
    /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */ constructor({ api: e, tools: t1, i18nLabels: o }){
        super(), this.opened = !1, this.listeners = new $ca477aae3d96de69$var$Ce(), this.popover = null, this.handleMobileLayoutToggle = ()=>{
            this.destroyPopover(), this.initPopover();
        }, this.onPopoverClose = ()=>{
            this.opened = !1, this.emit("toolbox-closed");
        }, this.api = e, this.tools = t1, this.i18nLabels = o, this.enableShortcuts(), this.nodes = {
            toolbox: $ca477aae3d96de69$var$d.make("div", to.CSS.toolbox)
        }, this.initPopover(), this.api.events.on($ca477aae3d96de69$var$ye, this.handleMobileLayoutToggle);
    }
    /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ get isEmpty() {
        return this.toolsToBeDisplayed.length === 0;
    }
    /**
   * CSS styles
   */ static get CSS() {
        return {
            toolbox: "ce-toolbox"
        };
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.toolbox;
    }
    /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ hasFocus() {
        if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
   * Destroy Module
   */ destroy() {
        var e;
        super.destroy(), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($ca477aae3d96de69$var$Z.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($ca477aae3d96de69$var$ye, this.handleMobileLayoutToggle);
    }
    /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ toolButtonActivated(e, t1) {
        this.insertNewBlock(e, t1);
    }
    /**
   * Open Toolbox with Tools
   */ open() {
        var e;
        this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
    }
    /**
   * Close Toolbox
   */ close() {
        var e;
        (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
    }
    /**
   * Close Toolbox
   */ toggle() {
        this.opened ? this.close() : this.open();
    }
    /**
   * Creates toolbox popover and appends it inside wrapper element
   */ initPopover() {
        var t1;
        const e = $ca477aae3d96de69$var$pe() ? $ca477aae3d96de69$var$Jt : $ca477aae3d96de69$var$rt;
        this.popover = new e({
            scopeElement: this.api.ui.nodes.redactor,
            searchable: !0,
            messages: {
                nothingFound: this.i18nLabels.nothingFound,
                search: this.i18nLabels.filter
            },
            items: this.toolboxItemsToBeDisplayed
        }), this.popover.on($ca477aae3d96de69$var$Z.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
    }
    /**
   * Destroys popover instance and removes it from DOM
   */ destroyPopover() {
        this.popover !== null && (this.popover.hide(), this.popover.off($ca477aae3d96de69$var$Z.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
    get toolsToBeDisplayed() {
        const e = [];
        return this.tools.forEach((t1)=>{
            t1.toolbox && e.push(t1);
        }), e;
    }
    get toolboxItemsToBeDisplayed() {
        const e = (t1, o)=>({
                icon: t1.icon,
                title: $ca477aae3d96de69$var$z.t($ca477aae3d96de69$var$K.toolNames, t1.title || $ca477aae3d96de69$var$Le(o.name)),
                name: o.name,
                onActivate: ()=>{
                    this.toolButtonActivated(o.name, t1.data);
                },
                secondaryLabel: o.shortcut ? $ca477aae3d96de69$var$et(o.shortcut) : ""
            });
        return this.toolsToBeDisplayed.reduce((t1, o)=>(Array.isArray(o.toolbox) ? o.toolbox.forEach((i)=>{
                t1.push(e(i, o));
            }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1), []);
    }
    /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ enableShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && this.enableShortcutForTool(e.name, t1);
        });
    }
    /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcutForTool(e, t1) {
        $ca477aae3d96de69$var$he.add({
            name: t1,
            on: this.api.ui.nodes.redactor,
            handler: async (o)=>{
                o.preventDefault();
                const i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                if (s) try {
                    const r = await this.api.blocks.convert(s.id, e);
                    this.api.caret.setToBlock(r, "end");
                    return;
                } catch  {}
                this.insertNewBlock(e);
            }
        });
    }
    /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ removeAllShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && $ca477aae3d96de69$var$he.remove(this.api.ui.nodes.redactor, t1);
        });
    }
    /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ async insertNewBlock(e, t1) {
        const o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
        if (!i) return;
        const s = i.isEmpty ? o : o + 1;
        let r;
        if (t1) {
            const a = await this.api.blocks.composeBlockData(e);
            r = Object.assign(a, t1);
        }
        const l = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
        l.call($ca477aae3d96de69$var$J.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
            block: l
        }), this.api.toolbar.close();
    }
};
$ca477aae3d96de69$var$eo([
    $ca477aae3d96de69$var$ue
], $ca477aae3d96de69$var$lt.prototype, "toolsToBeDisplayed", 1);
$ca477aae3d96de69$var$eo([
    $ca477aae3d96de69$var$ue
], $ca477aae3d96de69$var$lt.prototype, "toolboxItemsToBeDisplayed", 1);
let $ca477aae3d96de69$var$Xi = $ca477aae3d96de69$var$lt;
const $ca477aae3d96de69$var$oo = "block hovered";
async function $ca477aae3d96de69$var$Vi(n, e) {
    const t1 = navigator.keyboard;
    return t1 && (await t1.getLayoutMap()).get(n) || e;
}
class $ca477aae3d96de69$var$qi extends $ca477aae3d96de69$var$y {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.toolboxInstance = null;
    }
    /**
   * CSS styles
   *
   * @returns {object}
   */ get CSS() {
        return {
            toolbar: "ce-toolbar",
            content: "ce-toolbar__content",
            actions: "ce-toolbar__actions",
            actionsOpened: "ce-toolbar__actions--opened",
            toolbarOpened: "ce-toolbar--opened",
            openedToolboxHolderModifier: "codex-editor--toolbox-opened",
            plusButton: "ce-toolbar__plus",
            plusButtonShortcut: "ce-toolbar__plus-shortcut",
            settingsToggler: "ce-toolbar__settings-btn",
            settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
        };
    }
    /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
   * Public interface for accessing the Toolbox
   */ get toolbox() {
        var e;
        return {
            opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
            close: ()=>{
                var t1;
                (t1 = this.toolboxInstance) == null || t1.close();
            },
            open: ()=>{
                if (this.toolboxInstance === null) {
                    $ca477aae3d96de69$var$I("toolbox.open() called before initialization is finished", "warn");
                    return;
                }
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.toolboxInstance.open();
            },
            toggle: ()=>{
                if (this.toolboxInstance === null) {
                    $ca477aae3d96de69$var$I("toolbox.toggle() called before initialization is finished", "warn");
                    return;
                }
                this.toolboxInstance.toggle();
            },
            hasFocus: ()=>{
                var t1;
                return (t1 = this.toolboxInstance) == null ? void 0 : t1.hasFocus();
            }
        };
    }
    /**
   * Block actions appearance manipulations
   */ get blockActions() {
        return {
            hide: ()=>{
                this.nodes.actions.classList.remove(this.CSS.actionsOpened);
            },
            show: ()=>{
                this.nodes.actions.classList.add(this.CSS.actionsOpened);
            }
        };
    }
    /**
   * Methods for working with Block Tunes toggler
   */ get blockTunesToggler() {
        return {
            hide: ()=>this.nodes.settingsToggler.classList.add(this.CSS.settingsTogglerHidden),
            show: ()=>this.nodes.settingsToggler.classList.remove(this.CSS.settingsTogglerHidden)
        };
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(()=>{
            this.drawUI(), this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ moveAndOpen(e = this.Editor.BlockManager.currentBlock) {
        if (this.toolboxInstance === null) {
            $ca477aae3d96de69$var$I("Can't open Toolbar since Editor initialization is not finished yet", "warn");
            return;
        }
        if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
        this.hoveredBlock = e;
        const t1 = e.holder, { isMobile: o } = this.Editor.UI;
        let i;
        const s = 20, r = e.firstInput, l = t1.getBoundingClientRect(), a = r !== void 0 ? r.getBoundingClientRect() : null, c = a !== null ? a.top - l.top : null, u = c !== null ? c > s : void 0;
        if (o) i = t1.offsetTop + t1.offsetHeight;
        else if (r === void 0 || u) {
            const h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
            i = t1.offsetTop + h;
        } else {
            const h = $ca477aae3d96de69$var$_o(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
            i = t1.offsetTop + h - p + g + c;
        }
        this.nodes.wrapper.style.top = `${Math.floor(i)}px`, this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
   * Close the Toolbar
   */ close() {
        var e, t1;
        this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ reset() {
        this.nodes.wrapper.style.top = "unset";
    }
    /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ open(e = !0) {
        this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
   * Draws Toolbar elements
   */ async make() {
        this.nodes.wrapper = $ca477aae3d96de69$var$d.make("div", this.CSS.toolbar), [
            "content",
            "actions"
        ].forEach((s)=>{
            this.nodes[s] = $ca477aae3d96de69$var$d.make("div", this.CSS[s]);
        }), $ca477aae3d96de69$var$d.append(this.nodes.wrapper, this.nodes.content), $ca477aae3d96de69$var$d.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $ca477aae3d96de69$var$d.make("div", this.CSS.plusButton, {
            innerHTML: $ca477aae3d96de69$var$Ci
        }), $ca477aae3d96de69$var$d.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", ()=>{
            $ca477aae3d96de69$var$Ne(!0), this.plusButtonClicked();
        }, !1);
        const e = $ca477aae3d96de69$var$d.make("div");
        e.appendChild(document.createTextNode($ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($ca477aae3d96de69$var$d.make("div", this.CSS.plusButtonShortcut, {
            textContent: "/"
        })), $ca477aae3d96de69$var$Pe(this.nodes.plusButton, e, {
            hidingDelay: 400
        }), this.nodes.settingsToggler = $ca477aae3d96de69$var$d.make("span", this.CSS.settingsToggler, {
            innerHTML: $ca477aae3d96de69$var$Ti
        }), $ca477aae3d96de69$var$d.append(this.nodes.actions, this.nodes.settingsToggler);
        const t1 = $ca477aae3d96de69$var$d.make("div"), o = $ca477aae3d96de69$var$d.text($ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.blockTunes.toggler, "Click to tune")), i = await $ca477aae3d96de69$var$Vi("Slash", "/");
        t1.appendChild(o), t1.appendChild($ca477aae3d96de69$var$d.make("div", this.CSS.plusButtonShortcut, {
            textContent: $ca477aae3d96de69$var$et(`CMD + ${i}`)
        })), $ca477aae3d96de69$var$Pe(this.nodes.settingsToggler, t1, {
            hidingDelay: 400
        }), $ca477aae3d96de69$var$d.append(this.nodes.actions, this.makeToolbox()), $ca477aae3d96de69$var$d.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $ca477aae3d96de69$var$d.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Creates the Toolbox instance and return it's rendered element
   */ makeToolbox() {
        return this.toolboxInstance = new $ca477aae3d96de69$var$Xi({
            api: this.Editor.API.methods,
            tools: this.Editor.Tools.blockTools,
            i18nLabels: {
                filter: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Filter"),
                nothingFound: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Nothing found")
            }
        }), this.toolboxInstance.on($ca477aae3d96de69$var$Se.Opened, ()=>{
            this.Editor.UI.nodes.wrapper.classList.add(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($ca477aae3d96de69$var$Se.Closed, ()=>{
            this.Editor.UI.nodes.wrapper.classList.remove(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($ca477aae3d96de69$var$Se.BlockAdded, ({ block: e })=>{
            const { BlockManager: t1, Caret: o } = this.Editor, i = t1.getBlockById(e.id);
            i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
        }), this.toolboxInstance.getElement();
    }
    /**
   * Handler for Plus Button
   */ plusButtonClicked() {
        var e;
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
   * Enable bindings
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", (e)=>{
            var t1;
            e.stopPropagation(), this.settingsTogglerClicked(), (t1 = this.toolboxInstance) != null && t1.opened && this.toolboxInstance.close(), $ca477aae3d96de69$var$Ne(!0);
        }, !0), $ca477aae3d96de69$var$pe() || this.eventsDispatcher.on($ca477aae3d96de69$var$oo, (e)=>{
            var t1;
            this.Editor.BlockSettings.opened || (t1 = this.toolboxInstance) != null && t1.opened || this.moveAndOpen(e.block);
        });
    }
    /**
   * Disable bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Clicks on the Block Settings toggler
   */ settingsTogglerClicked() {
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ drawUI() {
        this.Editor.BlockSettings.make(), this.make();
    }
    /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ destroy() {
        this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
}
var $ca477aae3d96de69$var$ne = /* @__PURE__ */ ((n)=>(n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n))($ca477aae3d96de69$var$ne || {}), $ca477aae3d96de69$var$Ie = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n))($ca477aae3d96de69$var$Ie || {}), $ca477aae3d96de69$var$io = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n))($ca477aae3d96de69$var$io || {}), $ca477aae3d96de69$var$ce = /* @__PURE__ */ ((n)=>(n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n))($ca477aae3d96de69$var$ce || {}), $ca477aae3d96de69$var$at = /* @__PURE__ */ ((n)=>(n.IsInline = "isInline", n.Title = "title", n))($ca477aae3d96de69$var$at || {}), $ca477aae3d96de69$var$Qe = /* @__PURE__ */ ((n)=>(n.IsTune = "isTune", n))($ca477aae3d96de69$var$Qe || {});
class $ca477aae3d96de69$var$ct {
    /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */ constructor({ name: e, constructable: t1, config: o, api: i, isDefault: s, isInternal: r = !1, defaultPlaceholder: l }){
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = l;
    }
    /**
   * Returns Tool user configuration
   */ get settings() {
        const e = this.config.config || {};
        return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
   * Calls Tool's reset method
   */ reset() {
        if ($ca477aae3d96de69$var$O(this.constructable.reset)) return this.constructable.reset();
    }
    /**
   * Calls Tool's prepare method
   */ prepare() {
        if ($ca477aae3d96de69$var$O(this.constructable.prepare)) return this.constructable.prepare({
            toolName: this.name,
            config: this.settings
        });
    }
    /**
   * Returns shortcut for Tool (internal or specified by user)
   */ get shortcut() {
        const e = this.constructable.shortcut;
        return this.config.shortcut || e;
    }
    /**
   * Returns Tool's sanitizer configuration
   */ get sanitizeConfig() {
        return this.constructable.sanitize || {};
    }
    /**
   * Returns true if Tools is inline
   */ isInline() {
        return this.type === $ca477aae3d96de69$var$ne.Inline;
    }
    /**
   * Returns true if Tools is block
   */ isBlock() {
        return this.type === $ca477aae3d96de69$var$ne.Block;
    }
    /**
   * Returns true if Tools is tune
   */ isTune() {
        return this.type === $ca477aae3d96de69$var$ne.Tune;
    }
}
class $ca477aae3d96de69$var$Zi extends $ca477aae3d96de69$var$y {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, this.opened = !1, this.popover = null, this.toolbarVerticalMargin = $ca477aae3d96de69$var$pe() ? 20 : 6, this.toolsInstances = /* @__PURE__ */ new Map();
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? this.destroy() : window.requestIdleCallback(()=>{
            this.make();
        }, {
            timeout: 2e3
        });
    }
    /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ async tryToShow(e = !1) {
        e && this.close(), this.allowedToShow() && (await this.open(), this.Editor.Toolbar.close());
    }
    /**
   * Hides Inline Toolbar
   */ close() {
        var e, t1;
        this.opened && (this.Editor.ReadOnly.isEnabled || (Array.from(this.toolsInstances.entries()).forEach(([o, i])=>{
            const s = this.getToolShortcut(o);
            s && $ca477aae3d96de69$var$he.remove(this.Editor.UI.nodes.redactor, s), $ca477aae3d96de69$var$O(i.clear) && i.clear();
        }), this.toolsInstances = null, this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null));
    }
    /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ containsNode(e) {
        return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
   * Removes UI and its components
   */ destroy() {
        var e;
        this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
   * Making DOM
   */ make() {
        this.nodes.wrapper = $ca477aae3d96de69$var$d.make("div", [
            this.CSS.inlineToolbar,
            ...this.isRtl ? [
                this.Editor.UI.CSS.editorRtlFix
            ] : []
        ]), $ca477aae3d96de69$var$d.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Shows Inline Toolbar
   */ async open() {
        var t1;
        if (this.opened) return;
        this.opened = !0, this.popover !== null && this.popover.destroy();
        const e = await this.getInlineTools();
        this.popover = new $ca477aae3d96de69$var$Ri({
            items: e,
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Nothing found"),
                search: $ca477aae3d96de69$var$z.ui($ca477aae3d96de69$var$K.ui.popover, "Filter")
            }
        }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ move(e) {
        const t1 = $ca477aae3d96de69$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
            x: t1.x - o.x,
            y: t1.y + t1.height - // + window.scrollY
            o.top + this.toolbarVerticalMargin
        };
        i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
   * Clear orientation classes and reset position
   */ reset() {
        this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
   * Need to show Inline Toolbar or not
   */ allowedToShow() {
        const e = [
            "IMG",
            "INPUT"
        ], t1 = $ca477aae3d96de69$var$b.get(), o = $ca477aae3d96de69$var$b.text;
        if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
        const i = $ca477aae3d96de69$var$d.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
        if (i === null || t1 && e.includes(i.tagName) || i.closest('[contenteditable="true"]') === null) return !1;
        const r = this.Editor.BlockManager.getBlock(t1.anchorNode);
        return r ? r.tool.inlineTools.size !== 0 : !1;
    }
    /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns Inline Tools segregated by their appearance type: popover items and custom html elements.
   * Sets this.toolsInstances map
   */ async getInlineTools() {
        const e = $ca477aae3d96de69$var$b.get(), t1 = this.Editor.BlockManager.getBlock(e.anchorNode), o = Array.from(t1.tool.inlineTools.values()), i = [];
        this.toolsInstances === null && (this.toolsInstances = /* @__PURE__ */ new Map());
        for(let s = 0; s < o.length; s++){
            const r = o[s], l = r.create(), a = await l.render();
            this.toolsInstances.set(r.name, l);
            const c = this.getToolShortcut(r.name);
            if (c) try {
                this.enableShortcuts(r.name, c);
            } catch  {}
            const u = c !== void 0 ? $ca477aae3d96de69$var$et(c) : void 0, h = $ca477aae3d96de69$var$z.t($ca477aae3d96de69$var$K.toolNames, r.title || $ca477aae3d96de69$var$Le(r.name));
            [
                a
            ].flat().forEach((p)=>{
                var f, k;
                const g = {
                    name: r.name,
                    onActivate: ()=>{
                        this.toolClicked(l);
                    },
                    hint: {
                        title: h,
                        description: u
                    }
                };
                if ($ca477aae3d96de69$var$d.isElement(p)) {
                    const C = {
                        ...g,
                        element: p,
                        type: $ca477aae3d96de69$var$A.Html
                    };
                    if ($ca477aae3d96de69$var$O(l.renderActions)) {
                        const S = l.renderActions();
                        C.children = {
                            isOpen: (f = l.checkState) == null ? void 0 : f.call(l, $ca477aae3d96de69$var$b.get()),
                            /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                            items: [
                                {
                                    type: $ca477aae3d96de69$var$A.Html,
                                    element: S
                                }
                            ]
                        };
                    } else (k = l.checkState) == null || k.call(l, $ca477aae3d96de69$var$b.get());
                    i.push(C);
                } else if (p.type === $ca477aae3d96de69$var$A.Html) i.push({
                    ...g,
                    ...p,
                    type: $ca477aae3d96de69$var$A.Html
                });
                else if (p.type === $ca477aae3d96de69$var$A.Separator) i.push({
                    type: $ca477aae3d96de69$var$A.Separator
                });
                else {
                    const C = {
                        ...g,
                        ...p,
                        type: $ca477aae3d96de69$var$A.Default
                    };
                    "children" in C && s !== 0 && i.push({
                        type: $ca477aae3d96de69$var$A.Separator
                    }), i.push(C), "children" in C && s < o.length - 1 && i.push({
                        type: $ca477aae3d96de69$var$A.Separator
                    });
                }
            });
        }
        return i;
    }
    /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ getToolShortcut(e) {
        const { Tools: t1 } = this.Editor, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
        return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$ca477aae3d96de69$var$io.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcuts(e, t1) {
        $ca477aae3d96de69$var$he.add({
            name: t1,
            handler: (o)=>{
                var s;
                const { currentBlock: i } = this.Editor.BlockManager;
                i && i.tool.enabledInlineTools && (o.preventDefault(), (s = this.popover) == null || s.activateItemByName(e));
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ toolClicked(e) {
        var o;
        const t1 = $ca477aae3d96de69$var$b.range;
        (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
    }
    /**
   * Check Tools` state by selection
   */ checkToolsState() {
        var e;
        (e = this.toolsInstances) == null || e.forEach((t1)=>{
            var o;
            (o = t1.checkState) == null || o.call(t1, $ca477aae3d96de69$var$b.get());
        });
    }
    /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ get inlineTools() {
        const e = {};
        return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(([t1, o])=>{
            e[t1] = o.create();
        }), e;
    }
}
function $ca477aae3d96de69$var$so() {
    const n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    let e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $ca477aae3d96de69$var$no(n, e, t1, o) {
    const i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    const s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    const l = r.textContent || "";
    return $ca477aae3d96de69$var$Lo(l);
}
function $ca477aae3d96de69$var$Me(n) {
    const e = $ca477aae3d96de69$var$d.getDeepestNode(n);
    if (e === null || $ca477aae3d96de69$var$d.isEmpty(n)) return !0;
    if ($ca477aae3d96de69$var$d.isNativeInput(e)) return e.selectionEnd === 0;
    if ($ca477aae3d96de69$var$d.isEmpty(n)) return !0;
    const [t1, o] = $ca477aae3d96de69$var$so();
    return t1 === null ? !1 : $ca477aae3d96de69$var$no(n, t1, o, "left");
}
function $ca477aae3d96de69$var$Ae(n) {
    const e = $ca477aae3d96de69$var$d.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($ca477aae3d96de69$var$d.isNativeInput(e)) return e.selectionEnd === e.value.length;
    const [t1, o] = $ca477aae3d96de69$var$so();
    return t1 === null ? !1 : $ca477aae3d96de69$var$no(n, t1, o, "right");
}
class $ca477aae3d96de69$var$Gi extends $ca477aae3d96de69$var$y {
    /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ keydown(e) {
        switch(this.beforeKeydownProcessing(e), e.keyCode){
            case $ca477aae3d96de69$var$w.BACKSPACE:
                this.backspace(e);
                break;
            case $ca477aae3d96de69$var$w.DELETE:
                this.delete(e);
                break;
            case $ca477aae3d96de69$var$w.ENTER:
                this.enter(e);
                break;
            case $ca477aae3d96de69$var$w.DOWN:
            case $ca477aae3d96de69$var$w.RIGHT:
                this.arrowRightAndDown(e);
                break;
            case $ca477aae3d96de69$var$w.UP:
            case $ca477aae3d96de69$var$w.LEFT:
                this.arrowLeftAndUp(e);
                break;
            case $ca477aae3d96de69$var$w.TAB:
                this.tabPressed(e);
                break;
        }
        e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ beforeKeydownProcessing(e) {
        this.needToolbarClosing(e) && $ca477aae3d96de69$var$It(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ keyup(e) {
        e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ dragOver(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !0;
    }
    /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ dragLeave(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !1;
    }
    /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandC(e) {
        const { BlockSelection: t1 } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e);
    }
    /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandX(e) {
        const { BlockSelection: t1, BlockManager: o, Caret: i } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e).then(()=>{
            const s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), t1.clearSelection(e);
        });
    }
    /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ tabPressed(e) {
        const { InlineToolbar: t1, Caret: o } = this.Editor;
        if (t1.opened) return;
        (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
   * '/' + 'command' keydown inside a Block
   */ commandSlashPressed() {
        this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ slashPressed(e) {
        this.Editor.BlockManager.currentBlock.isEmpty && (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ enter(e) {
        const { BlockManager: t1, UI: o } = this.Editor, i = t1.currentBlock;
        if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$ca477aae3d96de69$var$Ge) return;
        let s = i;
        i.currentInput !== void 0 && $ca477aae3d96de69$var$Me(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $ca477aae3d96de69$var$Ae(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ backspace(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, previousBlock: s } = t1;
        if (i === void 0 || !$ca477aae3d96de69$var$b.isCollapsed || !i.currentInput || !$ca477aae3d96de69$var$Me(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
            o.navigatePrevious();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i);
            const a = t1.currentBlock;
            o.setToBlock(a, o.positions.END);
            return;
        }
        $ca477aae3d96de69$var$vt(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ delete(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, nextBlock: s } = t1;
        if (!$ca477aae3d96de69$var$b.isCollapsed || !$ca477aae3d96de69$var$Ae(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
            o.navigateNext();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i), o.setToBlock(s, o.positions.START);
            return;
        }
        $ca477aae3d96de69$var$vt(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ mergeBlocks(e, t1) {
        const { BlockManager: o, Caret: i, Toolbar: s } = this.Editor;
        i.createShadow(e.lastInput), o.mergeBlocks(e, t1).then(()=>{
            i.restoreCaret(e.pluginsContent), s.close();
        });
    }
    /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowRightAndDown(e) {
        const t1 = $ca477aae3d96de69$var$le.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $ca477aae3d96de69$var$w.TAB);
        if (this.Editor.UI.someToolbarOpened && t1) return;
        this.Editor.Toolbar.close();
        const { currentBlock: o } = this.Editor.BlockManager, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $ca477aae3d96de69$var$Ae(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $ca477aae3d96de69$var$w.DOWN && s) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState();
            return;
        }
        if (e.keyCode === $ca477aae3d96de69$var$w.DOWN || e.keyCode === $ca477aae3d96de69$var$w.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
            e.preventDefault();
            return;
        }
        $ca477aae3d96de69$var$Oe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowLeftAndUp(e) {
        if (this.Editor.UI.someToolbarOpened) {
            if ($ca477aae3d96de69$var$le.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $ca477aae3d96de69$var$w.TAB)) return;
            this.Editor.UI.closeAllToolbars();
        }
        this.Editor.Toolbar.close();
        const { currentBlock: t1 } = this.Editor.BlockManager, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $ca477aae3d96de69$var$Me(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $ca477aae3d96de69$var$w.UP && i) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
            return;
        }
        if (e.keyCode === $ca477aae3d96de69$var$w.UP || e.keyCode === $ca477aae3d96de69$var$w.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
            e.preventDefault();
            return;
        }
        $ca477aae3d96de69$var$Oe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ needToolbarClosing(e) {
        const t1 = e.keyCode === $ca477aae3d96de69$var$w.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $ca477aae3d96de69$var$w.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $ca477aae3d96de69$var$w.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $ca477aae3d96de69$var$w.TAB;
        return !(e.shiftKey || s || t1 || o || i);
    }
    /**
   * If Toolbox is not open, then just open it and show plus button
   */ activateToolbox() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ activateBlockSettings() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
}
class $ca477aae3d96de69$var$Xe {
    /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */ constructor(e){
        this.blocks = [], this.workingArea = e;
    }
    /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ get length() {
        return this.blocks.length;
    }
    /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ get array() {
        return this.blocks;
    }
    /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ get nodes() {
        return $ca477aae3d96de69$var$Mt(this.workingArea.children);
    }
    /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ static set(e, t1, o) {
        return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
    }
    /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ static get(e, t1) {
        return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
    }
    /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ push(e) {
        this.blocks.push(e), this.insertToDOM(e);
    }
    /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        const o = this.blocks[t1];
        $ca477aae3d96de69$var$d.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
    }
    /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ move(e, t1) {
        const o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
        e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
        const l = this.composeBlockEvent("move", {
            fromIndex: t1,
            toIndex: e
        });
        o.call($ca477aae3d96de69$var$J.MOVED, l);
    }
    /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ insert(e, t1, o = !1) {
        if (!this.length) {
            this.push(t1);
            return;
        }
        e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($ca477aae3d96de69$var$J.REMOVED));
        const i = o ? 1 : 0;
        if (this.blocks.splice(e, i, t1), e > 0) {
            const s = this.blocks[e - 1];
            this.insertToDOM(t1, "afterend", s);
        } else {
            const s = this.blocks[e + 1];
            s ? this.insertToDOM(t1, "beforebegin", s) : this.insertToDOM(t1);
        }
    }
    /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ replace(e, t1) {
        if (this.blocks[e] === void 0) throw Error("Incorrect index");
        this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ insertMany(e, t1) {
        const o = new DocumentFragment();
        for (const i of e)o.appendChild(i.holder);
        if (this.length > 0) {
            if (t1 > 0) {
                const i = Math.min(t1 - 1, this.length - 1);
                this.blocks[i].holder.after(o);
            } else t1 === 0 && this.workingArea.prepend(o);
            this.blocks.splice(t1, 0, ...e);
        } else this.blocks.push(...e), this.workingArea.appendChild(o);
        e.forEach((i)=>i.call($ca477aae3d96de69$var$J.RENDERED));
    }
    /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ remove(e) {
        isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($ca477aae3d96de69$var$J.REMOVED), this.blocks.splice(e, 1);
    }
    /**
   * Remove all blocks
   */ removeAll() {
        this.workingArea.innerHTML = "", this.blocks.forEach((e)=>e.call($ca477aae3d96de69$var$J.REMOVED)), this.blocks.length = 0;
    }
    /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ insertAfter(e, t1) {
        const o = this.blocks.indexOf(e);
        this.insert(o + 1, t1);
    }
    /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ get(e) {
        return this.blocks[e];
    }
    /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ indexOf(e) {
        return this.blocks.indexOf(e);
    }
    /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ insertToDOM(e, t1, o) {
        t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($ca477aae3d96de69$var$J.RENDERED);
    }
    /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ composeBlockEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
}
const $ca477aae3d96de69$var$Bt = "block-removed", $ca477aae3d96de69$var$Tt = "block-added", $ca477aae3d96de69$var$Ji = "block-moved", $ca477aae3d96de69$var$Ct = "block-changed";
class $ca477aae3d96de69$var$Qi {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
}
class $ca477aae3d96de69$var$es extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this._currentBlockIndex = -1, this._blocks = null;
    }
    /**
   * Returns current Block index
   *
   * @returns {number}
   */ get currentBlockIndex() {
        return this._currentBlockIndex;
    }
    /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ set currentBlockIndex(e) {
        this._currentBlockIndex = e;
    }
    /**
   * returns first Block
   *
   * @returns {Block}
   */ get firstBlock() {
        return this._blocks[0];
    }
    /**
   * returns last Block
   *
   * @returns {Block}
   */ get lastBlock() {
        return this._blocks[this._blocks.length - 1];
    }
    /**
   * Get current Block instance
   *
   * @returns {Block}
   */ get currentBlock() {
        return this._blocks[this.currentBlockIndex];
    }
    /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ set currentBlock(e) {
        this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ get nextBlock() {
        return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ get nextContentfulBlock() {
        return this.blocks.slice(this.currentBlockIndex + 1).find((t1)=>!!t1.inputs.length);
    }
    /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ get previousContentfulBlock() {
        return this.blocks.slice(0, this.currentBlockIndex).reverse().find((t1)=>!!t1.inputs.length);
    }
    /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ get previousBlock() {
        return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ get blocks() {
        return this._blocks.array;
    }
    /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ get isEditorEmpty() {
        return this.blocks.every((e)=>e.isEmpty);
    }
    /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ prepare() {
        const e = new $ca477aae3d96de69$var$Xe(this.Editor.UI.nodes.redactor);
        this._blocks = new Proxy(e, {
            set: $ca477aae3d96de69$var$Xe.set,
            get: $ca477aae3d96de69$var$Xe.get
        }), this.listeners.on(document, "copy", (t1)=>this.Editor.BlockEvents.handleCommandC(t1));
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ composeBlock({ tool: e, data: t1 = {}, id: o, tunes: i = {} }) {
        const s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), l = new $ca477aae3d96de69$var$D({
            id: o,
            data: t1,
            tool: r,
            api: this.Editor.API,
            readOnly: s,
            tunesData: i
        }, this.eventsDispatcher);
        return s || window.requestIdleCallback(()=>{
            this.bindBlockEvents(l);
        }, {
            timeout: 2e3
        }), l;
    }
    /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ insert({ id: e, tool: t1 = this.config.defaultBlock, data: o = {}, index: i, needToFocus: s = !0, replace: r = !1, tunes: l = {} } = {}) {
        let a = i;
        a === void 0 && (a = this.currentBlockIndex + (r ? 0 : 1));
        const c = this.composeBlock({
            id: e,
            tool: t1,
            data: o,
            tunes: l
        });
        return r && this.blockDidMutated($ca477aae3d96de69$var$Bt, this.getBlockByIndex(a), {
            index: a
        }), this._blocks.insert(a, c, r), this.blockDidMutated($ca477aae3d96de69$var$Tt, c, {
            index: a
        }), s ? this.currentBlockIndex = a : a <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ insertMany(e, t1 = 0) {
        this._blocks.insertMany(e, t1);
    }
    /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ async update(e, t1, o) {
        if (!t1 && !o) return e;
        const i = await e.data, s = this.composeBlock({
            id: e.id,
            tool: e.name,
            data: Object.assign({}, i, t1 ?? {}),
            tunes: o ?? e.tunes
        }), r = this.getBlockIndex(e);
        return this._blocks.replace(r, s), this.blockDidMutated($ca477aae3d96de69$var$Ct, s, {
            index: r
        }), s;
    }
    /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ replace(e, t1, o) {
        const i = this.getBlockIndex(e);
        return this.insert({
            tool: t1,
            data: o,
            index: i,
            replace: !0
        });
    }
    /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ paste(e, t1, o = !1) {
        const i = this.insert({
            tool: e,
            replace: o
        });
        try {
            window.requestIdleCallback(()=>{
                i.call($ca477aae3d96de69$var$J.ON_PASTE, t1);
            });
        } catch (s) {
            $ca477aae3d96de69$var$I(`${e}: onPaste callback call is failed`, "error", s);
        }
        return i;
    }
    /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ insertDefaultBlockAtIndex(e, t1 = !1) {
        const o = this.composeBlock({
            tool: this.config.defaultBlock
        });
        return this._blocks[e] = o, this.blockDidMutated($ca477aae3d96de69$var$Tt, o, {
            index: e
        }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ insertAtEnd() {
        return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ async mergeBlocks(e, t1) {
        let o;
        if (e.name === t1.name && e.mergeable) {
            const i = await t1.data;
            if ($ca477aae3d96de69$var$V(i)) {
                console.error("Could not merge Block. Failed to extract original Block data.");
                return;
            }
            const [s] = $ca477aae3d96de69$var$ot([
                i
            ], e.tool.sanitizeConfig);
            o = s;
        } else if (e.mergeable && $ca477aae3d96de69$var$_e(t1, "export") && $ca477aae3d96de69$var$_e(e, "import")) {
            const i = await t1.exportDataAsString(), s = $ca477aae3d96de69$var$q(i, e.tool.sanitizeConfig);
            o = $ca477aae3d96de69$var$wt(s, e.tool.conversionConfig);
        }
        o !== void 0 && (await e.mergeWith(o), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
    }
    /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ removeBlock(e, t1 = !0) {
        return new Promise((o)=>{
            const i = this._blocks.indexOf(e);
            if (!this.validateIndex(i)) throw new Error("Can't find a Block to remove");
            e.destroy(), this._blocks.remove(i), this.blockDidMutated($ca477aae3d96de69$var$Bt, e, {
                index: i
            }), this.currentBlockIndex >= i && this.currentBlockIndex--, this.blocks.length ? i === 0 && (this.currentBlockIndex = 0) : (this.unsetCurrentBlock(), t1 && this.insert()), o();
        });
    }
    /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ removeSelectedBlocks() {
        let e;
        for(let t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
        return e;
    }
    /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ removeAllBlocks() {
        for(let e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
        this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ split() {
        const e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $ca477aae3d96de69$var$d.make("div");
        t1.appendChild(e);
        const o = {
            text: $ca477aae3d96de69$var$d.isEmpty(t1) ? "" : t1.innerHTML
        };
        return this.insert({
            data: o
        });
    }
    /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ getBlockByIndex(e) {
        return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ getBlockIndex(e) {
        return this._blocks.indexOf(e);
    }
    /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ getBlockById(e) {
        return this._blocks.array.find((t1)=>t1.id === e);
    }
    /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ getBlock(e) {
        $ca477aae3d96de69$var$d.isElement(e) || (e = e.parentNode);
        const t1 = this._blocks.nodes, o = e.closest(`.${$ca477aae3d96de69$var$D.CSS.wrapper}`), i = t1.indexOf(o);
        if (i >= 0) return this._blocks[i];
    }
    /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ setCurrentBlockByChildNode(e) {
        $ca477aae3d96de69$var$d.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$ca477aae3d96de69$var$D.CSS.wrapper}`);
        if (!t1) return;
        const o = t1.closest(`.${this.Editor.UI.CSS.editorWrapper}`);
        if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ getBlockByChildNode(e) {
        if (!e || !(e instanceof Node)) return;
        $ca477aae3d96de69$var$d.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$ca477aae3d96de69$var$D.CSS.wrapper}`);
        return this.blocks.find((o)=>o.holder === t1);
    }
    /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        this._blocks.swap(e, t1), this.currentBlockIndex = t1;
    }
    /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ move(e, t1 = this.currentBlockIndex) {
        if (isNaN(e) || isNaN(t1)) {
            $ca477aae3d96de69$var$I("Warning during 'move' call: incorrect indices provided.", "warn");
            return;
        }
        if (!this.validateIndex(e) || !this.validateIndex(t1)) {
            $ca477aae3d96de69$var$I("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
            return;
        }
        this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($ca477aae3d96de69$var$Ji, this.currentBlock, {
            fromIndex: t1,
            toIndex: e
        });
    }
    /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ async convert(e, t1, o) {
        if (!await e.save()) throw new Error("Could not convert Block. Failed to extract original Block data.");
        const s = this.Editor.Tools.blockTools.get(t1);
        if (!s) throw new Error(`Could not convert Block. Tool \xab${t1}\xbb not found.`);
        const r = await e.exportDataAsString(), l = $ca477aae3d96de69$var$q(r, s.sanitizeConfig);
        let a = $ca477aae3d96de69$var$wt(l, s.conversionConfig);
        return o && (a = Object.assign(a, o)), this.replace(e, s.name, a);
    }
    /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ unsetCurrentBlock() {
        this.currentBlockIndex = -1;
    }
    /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ async clear(e = !1) {
        const t1 = new $ca477aae3d96de69$var$Qi();
        this.blocks.forEach((o)=>{
            t1.add(async ()=>{
                await this.removeBlock(o, !1);
            });
        }), await t1.completed, this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
    }
    /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ async destroy() {
        await Promise.all(this.blocks.map((e)=>e.destroy()));
    }
    /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ bindBlockEvents(e) {
        const { BlockEvents: t1 } = this.Editor;
        this.readOnlyMutableListeners.on(e.holder, "keydown", (o)=>{
            t1.keydown(o);
        }), this.readOnlyMutableListeners.on(e.holder, "keyup", (o)=>{
            t1.keyup(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragover", (o)=>{
            t1.dragOver(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragleave", (o)=>{
            t1.dragLeave(o);
        }), e.on("didMutated", (o)=>this.blockDidMutated($ca477aae3d96de69$var$Ct, o, {
                index: this.getBlockIndex(o)
            }));
    }
    /**
   * Disable mutable handlers and bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Enables all module handlers and bindings for all Blocks
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(document, "cut", (e)=>this.Editor.BlockEvents.handleCommandX(e)), this.blocks.forEach((e)=>{
            this.bindBlockEvents(e);
        });
    }
    /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ validateIndex(e) {
        return !(e < 0 || e >= this._blocks.length);
    }
    /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ blockDidMutated(e, t1, o) {
        const i = new CustomEvent(e, {
            detail: {
                target: new $ca477aae3d96de69$var$G(t1),
                ...o
            }
        });
        return this.eventsDispatcher.emit($ca477aae3d96de69$var$Pt, {
            event: i
        }), t1;
    }
}
class $ca477aae3d96de69$var$ts extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.anyBlockSelectedCache = null, this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
    }
    /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ get sanitizerConfig() {
        return {
            p: {},
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            ol: {},
            ul: {},
            li: {},
            br: !0,
            img: {
                src: !0,
                width: !0,
                height: !0
            },
            a: {
                href: !0
            },
            b: {},
            i: {},
            u: {}
        };
    }
    /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ get allBlocksSelected() {
        const { BlockManager: e } = this.Editor;
        return e.blocks.every((t1)=>t1.selected === !0);
    }
    /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ set allBlocksSelected(e) {
        const { BlockManager: t1 } = this.Editor;
        t1.blocks.forEach((o)=>{
            o.selected = e;
        }), this.clearCache();
    }
    /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ get anyBlockSelected() {
        const { BlockManager: e } = this.Editor;
        return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some((t1)=>t1.selected === !0)), this.anyBlockSelectedCache;
    }
    /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ get selectedBlocks() {
        return this.Editor.BlockManager.blocks.filter((e)=>e.selected);
    }
    /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ prepare() {
        this.selection = new $ca477aae3d96de69$var$b(), $ca477aae3d96de69$var$he.add({
            name: "CMD+A",
            handler: (e)=>{
                const { BlockManager: t1, ReadOnly: o } = this.Editor;
                if (o.isEnabled) {
                    e.preventDefault(), this.selectAllBlocks();
                    return;
                }
                t1.currentBlock && this.handleCommandA(e);
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ toggleReadOnly() {
        $ca477aae3d96de69$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ unSelectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ clearSelection(e, t1 = !1) {
        const { BlockManager: o, Caret: i, RectangleSelection: s } = this.Editor;
        this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
        const r = e && e instanceof KeyboardEvent, l = r && $ca477aae3d96de69$var$It(e.keyCode);
        if (this.anyBlockSelected && r && l && !$ca477aae3d96de69$var$b.isSelectionExists) {
            const a = o.removeSelectedBlocks();
            o.insertDefaultBlockAtIndex(a, !0), i.setToBlock(o.currentBlock), $ca477aae3d96de69$var$Oe(()=>{
                const c = e.key;
                i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
            }, 20)();
        }
        if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
            this.Editor.RectangleSelection.clearSelection();
            return;
        }
        t1 && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ copySelectedBlocks(e) {
        e.preventDefault();
        const t1 = $ca477aae3d96de69$var$d.make("div");
        this.selectedBlocks.forEach((s)=>{
            const r = $ca477aae3d96de69$var$q(s.holder.innerHTML, this.sanitizerConfig), l = $ca477aae3d96de69$var$d.make("p");
            l.innerHTML = r, t1.appendChild(l);
        });
        const o = Array.from(t1.childNodes).map((s)=>s.textContent).join(`

`), i = t1.innerHTML;
        return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map((s)=>s.save())).then((s)=>{
            try {
                e.clipboardData.setData(this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
            } catch  {}
        });
    }
    /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ selectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor, o = t1.getBlockByIndex(e);
        o !== void 0 && this.selectBlock(o);
    }
    /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ selectBlock(e) {
        this.selection.save(), $ca477aae3d96de69$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ unselectBlock(e) {
        e.selected = !1, this.clearCache();
    }
    /**
   * Clear anyBlockSelected cache
   */ clearCache() {
        this.anyBlockSelectedCache = null;
    }
    /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ destroy() {
        $ca477aae3d96de69$var$he.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ handleCommandA(e) {
        if (this.Editor.RectangleSelection.clearSelection(), $ca477aae3d96de69$var$d.isNativeInput(e.target) && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        const t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
        if (o.length > 1 && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        if (o.length === 1 && !this.needToSelectAll) {
            this.needToSelectAll = !0;
            return;
        }
        this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
    }
    /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ selectAllBlocks() {
        this.selection.save(), $ca477aae3d96de69$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
}
class $ca477aae3d96de69$var$Re extends $ca477aae3d96de69$var$y {
    /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ get positions() {
        return {
            START: "start",
            END: "end",
            DEFAULT: "default"
        };
    }
    /**
   * Elements styles that can be useful for Caret Module
   */ static get CSS() {
        return {
            shadowCaret: "cdx-shadow-caret"
        };
    }
    /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToBlock(e, t1 = this.positions.DEFAULT, o = 0) {
        var c;
        const { BlockManager: i, BlockSelection: s } = this.Editor;
        if (s.clearSelection(), !e.focusable) {
            (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
            return;
        }
        let r;
        switch(t1){
            case this.positions.START:
                r = e.firstInput;
                break;
            case this.positions.END:
                r = e.lastInput;
                break;
            default:
                r = e.currentInput;
        }
        if (!r) return;
        const l = $ca477aae3d96de69$var$d.getDeepestNode(r, t1 === this.positions.END), a = $ca477aae3d96de69$var$d.getContentLength(l);
        switch(!0){
            case t1 === this.positions.START:
                o = 0;
                break;
            case t1 === this.positions.END:
            case o > a:
                o = a;
                break;
        }
        this.set(l, o), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToInput(e, t1 = this.positions.DEFAULT, o = 0) {
        const { currentBlock: i } = this.Editor.BlockManager, s = $ca477aae3d96de69$var$d.getDeepestNode(e);
        switch(t1){
            case this.positions.START:
                this.set(s, 0);
                break;
            case this.positions.END:
                this.set(s, $ca477aae3d96de69$var$d.getContentLength(s));
                break;
            default:
                o && this.set(s, o);
        }
        i.currentInput = e;
    }
    /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ set(e, t1 = 0) {
        const { top: i, bottom: s } = $ca477aae3d96de69$var$b.setCursor(e, t1), { innerHeight: r } = window;
        i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ setToTheLastBlock() {
        const e = this.Editor.BlockManager.lastBlock;
        if (e) {
            if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
            else {
                const t1 = this.Editor.BlockManager.insertAtEnd();
                this.setToBlock(t1);
            }
        }
    }
    /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ extractFragmentFromCaretPosition() {
        const e = $ca477aae3d96de69$var$b.get();
        if (e.rangeCount) {
            const t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
            if (t1.deleteContents(), o) {
                if ($ca477aae3d96de69$var$d.isNativeInput(o)) {
                    const i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), l = i.value.substring(i.selectionStart);
                    return s.textContent = l, i.value = r, s;
                } else {
                    const i = t1.cloneRange();
                    return i.selectNodeContents(o), i.setStart(t1.endContainer, t1.endOffset), i.extractContents();
                }
            }
        }
    }
    /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigateNext(e = !1) {
        const { BlockManager: t1 } = this.Editor, { currentBlock: o, nextBlock: i } = t1;
        if (o === void 0) return !1;
        const { nextInput: s, currentInput: r } = o, l = r !== void 0 ? $ca477aae3d96de69$var$Ae(r) : void 0;
        let a = i;
        const c = e || l || !o.focusable;
        if (s && c) return this.setToInput(s, this.positions.START), !0;
        if (a === null) {
            if (o.tool.isDefault || !c) return !1;
            a = t1.insertAtEnd();
        }
        return c ? (this.setToBlock(a, this.positions.START), !0) : !1;
    }
    /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigatePrevious(e = !1) {
        const { currentBlock: t1, previousBlock: o } = this.Editor.BlockManager;
        if (!t1) return !1;
        const { previousInput: i, currentInput: s } = t1, r = s !== void 0 ? $ca477aae3d96de69$var$Me(s) : void 0, l = e || r || !t1.focusable;
        return i && l ? (this.setToInput(i, this.positions.END), !0) : o !== null && l ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ createShadow(e) {
        const t1 = document.createElement("span");
        t1.classList.add($ca477aae3d96de69$var$Re.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
    }
    /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ restoreCaret(e) {
        const t1 = e.querySelector(`.${$ca477aae3d96de69$var$Re.CSS.shadowCaret}`);
        if (!t1) return;
        new $ca477aae3d96de69$var$b().expandToTag(t1);
        const i = document.createRange();
        i.selectNode(t1), i.extractContents();
    }
    /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ insertContentAtCaretPosition(e) {
        const t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $ca477aae3d96de69$var$b.get(), s = $ca477aae3d96de69$var$b.range;
        o.innerHTML = e, Array.from(o.childNodes).forEach((c)=>t1.appendChild(c)), t1.childNodes.length === 0 && t1.appendChild(new Text());
        const r = t1.lastChild;
        s.deleteContents(), s.insertNode(t1);
        const l = document.createRange(), a = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
        a !== null && a.textContent !== null && l.setStart(a, a.textContent.length), i.removeAllRanges(), i.addRange(l);
    }
}
class $ca477aae3d96de69$var$os extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.onMouseUp = ()=>{
            this.listeners.off(document, "mouseover", this.onMouseOver), this.listeners.off(document, "mouseup", this.onMouseUp);
        }, this.onMouseOver = (e)=>{
            const { BlockManager: t1, BlockSelection: o } = this.Editor;
            if (e.relatedTarget === null && e.target === null) return;
            const i = t1.getBlockByChildNode(e.relatedTarget) || this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === this.firstSelectedBlock) {
                    $ca477aae3d96de69$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                this.Editor.InlineToolbar.close(), this.toggleBlocksSelectedState(i, s), this.lastSelectedBlock = s;
            }
        };
    }
    /**
   * Module preparation
   *
   * @returns {Promise}
   */ async prepare() {
        this.listeners.on(document, "mousedown", (e)=>{
            this.enableCrossBlockSelection(e);
        });
    }
    /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ watchSelection(e) {
        if (e.button !== $ca477aae3d96de69$var$wo.LEFT) return;
        const { BlockManager: t1 } = this.Editor;
        this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ get isCrossBlockSelectionStarted() {
        return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ toggleBlockSelectedState(e = !0) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $ca477aae3d96de69$var$b.get().removeAllRanges());
        const i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
        s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
            block: "nearest"
        }));
    }
    /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ clear(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
        if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
            case $ca477aae3d96de69$var$w.DOWN:
            case $ca477aae3d96de69$var$w.RIGHT:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                break;
            case $ca477aae3d96de69$var$w.UP:
            case $ca477aae3d96de69$var$w.LEFT:
                i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                break;
            default:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
        }
        this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ enableCrossBlockSelection(e) {
        const { UI: t1 } = this.Editor;
        $ca477aae3d96de69$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ toggleBlocksSelectedState(e, t1) {
        const { BlockManager: o, BlockSelection: i } = this.Editor, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), l = e.selected !== t1.selected;
        for(let a = Math.min(s, r); a <= Math.max(s, r); a++){
            const c = o.blocks[a];
            c !== this.firstSelectedBlock && c !== (l ? e : t1) && (o.blocks[a].selected = !o.blocks[a].selected, i.clearCache());
        }
    }
}
class $ca477aae3d96de69$var$is extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.isStartedAtEditor = !1;
    }
    /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Add drag events listeners to editor zone
   */ enableModuleBindings() {
        const { UI: e } = this.Editor;
        this.readOnlyMutableListeners.on(e.nodes.holder, "drop", async (t1)=>{
            await this.processDrop(t1);
        }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", ()=>{
            this.processDragStart();
        }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", (t1)=>{
            this.processDragOver(t1);
        }, !0);
    }
    /**
   * Unbind drag-n-drop event handlers
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ async processDrop(e) {
        const { BlockManager: t1, Paste: o, Caret: i } = this.Editor;
        e.preventDefault(), t1.blocks.forEach((r)=>{
            r.dropTarget = !1;
        }), $ca477aae3d96de69$var$b.isAtEditor && !$ca477aae3d96de69$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
        const s = t1.setCurrentBlockByChildNode(e.target);
        if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
        else {
            const r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
            this.Editor.Caret.setToBlock(r, i.positions.END);
        }
        await o.processDataTransfer(e.dataTransfer, !0);
    }
    /**
   * Handle drag start event
   */ processDragStart() {
        $ca477aae3d96de69$var$b.isAtEditor && !$ca477aae3d96de69$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
   * @param {DragEvent} dragEvent - drag event
   */ processDragOver(e) {
        e.preventDefault();
    }
}
const $ca477aae3d96de69$var$ss = 180, $ca477aae3d96de69$var$ns = 400;
class $ca477aae3d96de69$var$rs extends $ca477aae3d96de69$var$y {
    /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.disabled = !1, this.batchingTimeout = null, this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), this.batchTime = $ca477aae3d96de69$var$ns, this.mutationObserver = new MutationObserver((o)=>{
            this.redactorChanged(o);
        }), this.eventsDispatcher.on($ca477aae3d96de69$var$Pt, (o)=>{
            this.particularBlockChanged(o.event);
        }), this.eventsDispatcher.on($ca477aae3d96de69$var$Dt, ()=>{
            this.disable();
        }), this.eventsDispatcher.on($ca477aae3d96de69$var$Rt, ()=>{
            this.enable();
        });
    }
    /**
   * Enables onChange event
   */ enable() {
        this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        }), this.disabled = !1;
    }
    /**
   * Disables onChange event
   */ disable() {
        this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ particularBlockChanged(e) {
        this.disabled || !$ca477aae3d96de69$var$O(this.config.onChange) || (this.batchingOnChangeQueue.set(`block:${e.detail.target.id}:event:${e.type}`, e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(()=>{
            let t1;
            this.batchingOnChangeQueue.size === 1 ? t1 = this.batchingOnChangeQueue.values().next().value : t1 = Array.from(this.batchingOnChangeQueue.values()), this.config.onChange && this.config.onChange(this.Editor.API.methods, t1), this.batchingOnChangeQueue.clear();
        }, this.batchTime));
    }
    /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ redactorChanged(e) {
        this.eventsDispatcher.emit($ca477aae3d96de69$var$Je, {
            mutations: e
        });
    }
}
const $ca477aae3d96de69$var$ro = class lo extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.MIME_TYPE = "application/x-editor-js", this.toolsTags = {}, this.tagsByTool = {}, this.toolsPatterns = [], this.toolsFiles = {}, this.exceptionList = [], this.processTool = (e)=>{
            try {
                const t1 = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    this.exceptionList.push(e.name);
                    return;
                }
                if (!$ca477aae3d96de69$var$O(t1.onPaste)) return;
                this.getTagsConfig(e), this.getFilesConfig(e), this.getPatternsConfig(e);
            } catch (t1) {
                $ca477aae3d96de69$var$I(`Paste handling for \xab${e.name}\xbb Tool hasn't been set up because of the error`, "warn", t1);
            }
        }, this.handlePasteEvent = async (e)=>{
            const { BlockManager: t1, Toolbar: o } = this.Editor, i = t1.setCurrentBlockByChildNode(e.target);
            !i || this.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && this.exceptionList.includes(i.name) || (e.preventDefault(), this.processDataTransfer(e.clipboardData), o.close());
        };
    }
    /**
   * Set onPaste callback and collect tools` paste configurations
   */ async prepare() {
        this.processTools();
    }
    /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ toggleReadOnly(e) {
        e ? this.unsetCallback() : this.setCallback();
    }
    /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ async processDataTransfer(e, t1 = !1) {
        const { Tools: o } = this.Editor, i = e.types;
        if ((i.includes ? i.includes("Files") : i.contains("Files")) && !$ca477aae3d96de69$var$V(this.toolsFiles)) {
            await this.processFiles(e.files);
            return;
        }
        const r = e.getData(this.MIME_TYPE), l = e.getData("text/plain");
        let a = e.getData("text/html");
        if (r) try {
            this.insertEditorJSData(JSON.parse(r));
            return;
        } catch  {}
        t1 && l.trim() && a.trim() && (a = "<p>" + (a.trim() ? a : l) + "</p>");
        const c = Object.keys(this.toolsTags).reduce((p, g)=>(p[g.toLowerCase()] = this.toolsTags[g].sanitizationConfig ?? {}, p), {}), u = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
            br: {}
        }), h = $ca477aae3d96de69$var$q(a, u);
        !h.trim() || h.trim() === l || !$ca477aae3d96de69$var$d.isHTMLString(h) ? await this.processText(l) : await this.processText(h, !0);
    }
    /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ async processText(e, t1 = !1) {
        const { Caret: o, BlockManager: i } = this.Editor, s = t1 ? this.processHTML(e) : this.processPlain(e);
        if (!s.length) return;
        if (s.length === 1) {
            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
            return;
        }
        const l = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
        s.map(async (a, c)=>this.insertBlock(a, c === 0 && l)), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
    }
    /**
   * Set onPaste callback handler
   */ setCallback() {
        this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Unset onPaste callback handler
   */ unsetCallback() {
        this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Get and process tool`s paste configs
   */ processTools() {
        const e = this.Editor.Tools.blockTools;
        Array.from(e.values()).forEach(this.processTool);
    }
    /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ collectTagNames(e) {
        return $ca477aae3d96de69$var$Q(e) ? [
            e
        ] : $ca477aae3d96de69$var$R(e) ? Object.keys(e) : [];
    }
    /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getTagsConfig(e) {
        if (e.pasteConfig === !1) return;
        const t1 = e.pasteConfig.tags || [], o = [];
        t1.forEach((i)=>{
            const s = this.collectTagNames(i);
            o.push(...s), s.forEach((r)=>{
                if (Object.prototype.hasOwnProperty.call(this.toolsTags, r)) {
                    $ca477aae3d96de69$var$I(`Paste handler for \xab${e.name}\xbb Tool on \xab${r}\xbb tag is skipped because it is already used by \xab${this.toolsTags[r].tool.name}\xbb Tool.`, "warn");
                    return;
                }
                const l = $ca477aae3d96de69$var$R(i) ? i[r] : null;
                this.toolsTags[r.toUpperCase()] = {
                    tool: e,
                    sanitizationConfig: l
                };
            });
        }), this.tagsByTool[e.name] = o.map((i)=>i.toUpperCase());
    }
    /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getFilesConfig(e) {
        if (e.pasteConfig === !1) return;
        const { files: t1 = {} } = e.pasteConfig;
        let { extensions: o, mimeTypes: i } = t1;
        !o && !i || (o && !Array.isArray(o) && ($ca477aae3d96de69$var$I(`\xabextensions\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), o = []), i && !Array.isArray(i) && ($ca477aae3d96de69$var$I(`\xabmimeTypes\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), i = []), i && (i = i.filter((s)=>$ca477aae3d96de69$var$To(s) ? !0 : ($ca477aae3d96de69$var$I(`MIME type value \xab${s}\xbb for the \xab${e.name}\xbb Tool is not a valid MIME type`, "warn"), !1))), this.toolsFiles[e.name] = {
            extensions: o || [],
            mimeTypes: i || []
        });
    }
    /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getPatternsConfig(e) {
        e.pasteConfig === !1 || !e.pasteConfig.patterns || $ca477aae3d96de69$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(([t1, o])=>{
            o instanceof RegExp || $ca477aae3d96de69$var$I(`Pattern ${o} for \xab${e.name}\xbb Tool is skipped because it should be a Regexp instance.`, "warn"), this.toolsPatterns.push({
                key: t1,
                pattern: o,
                tool: e
            });
        });
    }
    /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ isNativeBehaviour(e) {
        return $ca477aae3d96de69$var$d.isNativeInput(e);
    }
    /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ async processFiles(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        o = await Promise.all(Array.from(e).map((r)=>this.processFile(r))), o = o.filter((r)=>!!r);
        const s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
        o.forEach((r, l)=>{
            t1.paste(r.type, r.event, l === 0 && s);
        });
    }
    /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ async processFile(e) {
        const t1 = $ca477aae3d96de69$var$Bo(e), o = Object.entries(this.toolsFiles).find(([r, { mimeTypes: l, extensions: a }])=>{
            const [c, u] = e.type.split("/"), h = a.find((g)=>g.toLowerCase() === t1.toLowerCase()), p = l.find((g)=>{
                const [f, k] = g.split("/");
                return f === c && (k === u || k === "*");
            });
            return !!h || !!p;
        });
        if (!o) return;
        const [i] = o;
        return {
            event: this.composePasteEvent("file", {
                file: e
            }),
            type: i
        };
    }
    /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ processHTML(e) {
        const { Tools: t1 } = this.Editor, o = $ca477aae3d96de69$var$d.make("DIV");
        return o.innerHTML = e, this.getNodes(o).map((s)=>{
            let r, l = t1.defaultTool, a = !1;
            switch(s.nodeType){
                case Node.DOCUMENT_FRAGMENT_NODE:
                    r = $ca477aae3d96de69$var$d.make("div"), r.appendChild(s);
                    break;
                case Node.ELEMENT_NODE:
                    r = s, a = !0, this.toolsTags[r.tagName] && (l = this.toolsTags[r.tagName].tool);
                    break;
            }
            const { tags: c } = l.pasteConfig || {
                tags: []
            }, u = c.reduce((g, f)=>(this.collectTagNames(f).forEach((C)=>{
                    const S = $ca477aae3d96de69$var$R(f) ? f[C] : null;
                    g[C.toLowerCase()] = S || {};
                }), g), {}), h = Object.assign({}, u, l.baseSanitizeConfig);
            if (r.tagName.toLowerCase() === "table") {
                const g = $ca477aae3d96de69$var$q(r.outerHTML, h);
                r = $ca477aae3d96de69$var$d.make("div", void 0, {
                    innerHTML: g
                }).firstChild;
            } else r.innerHTML = $ca477aae3d96de69$var$q(r.innerHTML, h);
            const p = this.composePasteEvent("tag", {
                data: r
            });
            return {
                content: r,
                isBlock: a,
                tool: l.name,
                event: p
            };
        }).filter((s)=>{
            const r = $ca477aae3d96de69$var$d.isEmpty(s.content), l = $ca477aae3d96de69$var$d.isSingleTag(s.content);
            return !r || l;
        });
    }
    /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ processPlain(e) {
        const { defaultBlock: t1 } = this.config;
        if (!e) return [];
        const o = t1;
        return e.split(/\r?\n/).filter((i)=>i.trim()).map((i)=>{
            const s = $ca477aae3d96de69$var$d.make("div");
            s.textContent = i;
            const r = this.composePasteEvent("tag", {
                data: s
            });
            return {
                content: s,
                tool: o,
                isBlock: !1,
                event: r
            };
        });
    }
    /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processSingleBlock(e) {
        const { Caret: t1, BlockManager: o } = this.Editor, { currentBlock: i } = o;
        if (!i || e.tool !== i.name || !$ca477aae3d96de69$var$d.containsOnlyInlineElements(e.content.innerHTML)) {
            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
            return;
        }
        t1.insertContentAtCaretPosition(e.content.innerHTML);
    }
    /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processInlinePaste(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { content: i } = e;
        if (t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < lo.PATTERN_PROCESSING_MAX_LENGTH) {
            const r = await this.processPattern(i.textContent);
            if (r) {
                const l = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, a = t1.paste(r.tool, r.event, l);
                o.setToBlock(a, o.positions.END);
                return;
            }
        }
        if (t1.currentBlock && t1.currentBlock.currentInput) {
            const r = t1.currentBlock.tool.baseSanitizeConfig;
            document.execCommand("insertHTML", !1, $ca477aae3d96de69$var$q(i.innerHTML, r));
        } else this.insertBlock(e);
    }
    /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ async processPattern(e) {
        const t1 = this.toolsPatterns.find((i)=>{
            const s = i.pattern.exec(e);
            return s ? e === s.shift() : !1;
        });
        return t1 ? {
            event: this.composePasteEvent("pattern", {
                key: t1.key,
                data: e
            }),
            tool: t1.tool.name
        } : void 0;
    }
    /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ insertBlock(e, t1 = !1) {
        const { BlockManager: o, Caret: i } = this.Editor, { currentBlock: s } = o;
        let r;
        if (t1 && s && s.isEmpty) {
            r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
            return;
        }
        r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ insertEditorJSData(e) {
        const { BlockManager: t1, Caret: o, Tools: i } = this.Editor;
        $ca477aae3d96de69$var$ot(e, (r)=>i.blockTools.get(r).sanitizeConfig).forEach(({ tool: r, data: l }, a)=>{
            let c = !1;
            a === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
            const u = t1.insert({
                tool: r,
                data: l,
                replace: c
            });
            o.setToBlock(u, o.positions.END);
        });
    }
    /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ processElementNode(e, t1, o) {
        const i = Object.keys(this.toolsTags), s = e, { tool: r } = this.toolsTags[s.tagName] || {}, l = this.tagsByTool[r == null ? void 0 : r.name] || [], a = i.includes(s.tagName), c = $ca477aae3d96de69$var$d.blockElements.includes(s.tagName.toLowerCase()), u = Array.from(s.children).some(({ tagName: p })=>i.includes(p) && !l.includes(p)), h = Array.from(s.children).some(({ tagName: p })=>$ca477aae3d96de69$var$d.blockElements.includes(p.toLowerCase()));
        if (!c && !a && !u) return o.appendChild(s), [
            ...t1,
            o
        ];
        if (a && !u || c && !h && !u) return [
            ...t1,
            o,
            s
        ];
    }
    /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ getNodes(e) {
        const t1 = Array.from(e.childNodes);
        let o;
        const i = (s, r)=>{
            if ($ca477aae3d96de69$var$d.isEmpty(r) && !$ca477aae3d96de69$var$d.isSingleTag(r)) return s;
            const l = s[s.length - 1];
            let a = new DocumentFragment();
            switch(l && $ca477aae3d96de69$var$d.isFragment(l) && (a = s.pop()), r.nodeType){
                case Node.ELEMENT_NODE:
                    if (o = this.processElementNode(r, s, a), o) return o;
                    break;
                case Node.TEXT_NODE:
                    return a.appendChild(r), [
                        ...s,
                        a
                    ];
                default:
                    return [
                        ...s,
                        a
                    ];
            }
            return [
                ...s,
                ...Array.from(r.childNodes).reduce(i, [])
            ];
        };
        return t1.reduce(i, []);
    }
    /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ composePasteEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
};
$ca477aae3d96de69$var$ro.PATTERN_PROCESSING_MAX_LENGTH = 450;
let $ca477aae3d96de69$var$ls = $ca477aae3d96de69$var$ro;
class $ca477aae3d96de69$var$as extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.toolsDontSupportReadOnly = [], this.readOnlyEnabled = !1;
    }
    /**
   * Returns state of read only mode
   */ get isEnabled() {
        return this.readOnlyEnabled;
    }
    /**
   * Set initial state
   */ async prepare() {
        const { Tools: e } = this.Editor, { blockTools: t1 } = e, o = [];
        Array.from(t1.entries()).forEach(([i, s])=>{
            s.isReadOnlySupported || o.push(i);
        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
    }
    /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ async toggle(e = !this.readOnlyEnabled, t1 = !1) {
        e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
        const o = this.readOnlyEnabled;
        this.readOnlyEnabled = e;
        for(const s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
        if (o === e) return this.readOnlyEnabled;
        if (t1) return this.readOnlyEnabled;
        this.Editor.ModificationsObserver.disable();
        const i = await this.Editor.Saver.save();
        return await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(i.blocks), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled;
    }
    /**
   * Throws an error about tools which don't support read-only mode
   */ throwCriticalError() {
        throw new $ca477aae3d96de69$var$Nt(`To enable read-only mode all connected tools should support it. Tools ${this.toolsDontSupportReadOnly.join(", ")} don't support read-only mode.`);
    }
}
class $ca477aae3d96de69$var$xe extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.isRectSelectionActivated = !1, this.SCROLL_SPEED = 3, this.HEIGHT_OF_SCROLL_ZONE = 40, this.BOTTOM_SCROLL_ZONE = 1, this.TOP_SCROLL_ZONE = 2, this.MAIN_MOUSE_BUTTON = 0, this.mousedown = !1, this.isScrolling = !1, this.inScrollZone = null, this.startX = 0, this.startY = 0, this.mouseX = 0, this.mouseY = 0, this.stackOfSelected = [], this.listenerIds = [];
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            overlay: "codex-editor-overlay",
            overlayContainer: "codex-editor-overlay__container",
            rect: "codex-editor-overlay__rectangle",
            topScrollZone: "codex-editor-overlay__scroll-zone--top",
            bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
        };
    }
    /**
   * Module Preparation
   * Creating rect and hang handlers
   */ prepare() {
        this.enableModuleBindings();
    }
    /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ startSelection(e, t1) {
        const o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
        o.closest(`.${this.Editor.Toolbar.CSS.toolbar}`) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
        const s = [
            `.${$ca477aae3d96de69$var$D.CSS.content}`,
            `.${this.Editor.Toolbar.CSS.toolbar}`,
            `.${this.Editor.InlineToolbar.CSS.inlineToolbar}`
        ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), l = s.some((a)=>!!o.closest(a));
        !r || l || (this.mousedown = !0, this.startX = e, this.startY = t1);
    }
    /**
   * Clear all params to end selection
   */ endSelection() {
        this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
   * is RectSelection Activated
   */ isRectActivated() {
        return this.isRectSelectionActivated;
    }
    /**
   * Mark that selection is end
   */ clearSelection() {
        this.isRectSelectionActivated = !1;
    }
    /**
   * Sets Module necessary event handlers
   */ enableModuleBindings() {
        const { container: e } = this.genHTML();
        this.listeners.on(e, "mousedown", (t1)=>{
            this.processMouseDown(t1);
        }, !1), this.listeners.on(document.body, "mousemove", $ca477aae3d96de69$var$Ve((t1)=>{
            this.processMouseMove(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseleave", ()=>{
            this.processMouseLeave();
        }), this.listeners.on(window, "scroll", $ca477aae3d96de69$var$Ve((t1)=>{
            this.processScroll(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseup", ()=>{
            this.processMouseUp();
        }, !1);
    }
    /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseDown(e) {
        if (e.button !== this.MAIN_MOUSE_BUTTON) return;
        e.target.closest($ca477aae3d96de69$var$d.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseMove(e) {
        this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
   * Handle mouse leave
   */ processMouseLeave() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processScroll(e) {
        this.changingRectangle(e);
    }
    /**
   * Handle mouse up
   */ processMouseUp() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ scrollByZones(e) {
        if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
            this.isScrolling = !1;
            return;
        }
        this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ genHTML() {
        const { UI: e } = this.Editor, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$xe.CSS.overlay, {}), i = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$xe.CSS.overlayContainer, {}), s = $ca477aae3d96de69$var$d.make("div", $ca477aae3d96de69$var$xe.CSS.rect, {});
        return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
            container: t1,
            overlay: o
        };
    }
    /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ scrollVertical(e) {
        if (!(this.inScrollZone && this.mousedown)) return;
        const t1 = window.pageYOffset;
        window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(()=>{
            this.scrollVertical(e);
        }, 0);
    }
    /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ changingRectangle(e) {
        if (!this.mousedown) return;
        e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
        const { rightPos: t1, leftPos: o, index: i } = this.genInfoForMouseSelection(), s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
        this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $ca477aae3d96de69$var$b.get().removeAllRanges());
    }
    /**
   * Shrink rect to singular point
   */ shrinkRectangleToPoint() {
        this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`;
    }
    /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ inverseSelection() {
        const t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
        if (this.rectCrossesBlocks && !t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.selectBlockByIndex(o);
        if (!this.rectCrossesBlocks && t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.unSelectBlockByIndex(o);
    }
    /**
   * Updates size of rectangle
   */ updateRectangleSize() {
        this.mouseY >= this.startY ? (this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.mouseY - window.pageYOffset}px`) : (this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.top = `${this.mouseY - window.pageYOffset}px`), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.mouseX - window.pageXOffset}px`) : (this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.left = `${this.mouseX - window.pageXOffset}px`);
    }
    /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ genInfoForMouseSelection() {
        const t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
        let r;
        s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex((h)=>h.holder === s.holder));
        const l = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $ca477aae3d96de69$var$D.CSS.content), a = Number.parseInt(window.getComputedStyle(l).width, 10) / 2, c = t1 - a, u = t1 + a;
        return {
            index: r,
            leftPos: c,
            rightPos: u
        };
    }
    /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ addBlockInSelection(e) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ trySelectNextBlock(e) {
        const t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
        if (t1) return;
        const l = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
        let a = r;
        o > 1 && (a = l ? i : s);
        const c = e > this.stackOfSelected[o - 1] && a === i, u = e < this.stackOfSelected[o - 1] && a === s, p = !(c || u || a === r);
        if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
            let k = this.stackOfSelected[o - 1] + 1 || e;
            for(k; k <= e; k++)this.addBlockInSelection(k);
            return;
        }
        if (!p && e < this.stackOfSelected[o - 1]) {
            for(let k = this.stackOfSelected[o - 1] - 1; k >= e; k--)this.addBlockInSelection(k);
            return;
        }
        if (!p) return;
        let g = o - 1, f;
        for(e > this.stackOfSelected[o - 1] ? f = ()=>e > this.stackOfSelected[g] : f = ()=>e < this.stackOfSelected[g]; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
    }
}
class $ca477aae3d96de69$var$cs extends $ca477aae3d96de69$var$y {
    /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ async render(e) {
        return new Promise((t1)=>{
            const { Tools: o, BlockManager: i } = this.Editor;
            if (e.length === 0) i.insert();
            else {
                const s = e.map(({ type: r, data: l, tunes: a, id: c })=>{
                    o.available.has(r) === !1 && ($ca477aae3d96de69$var$X(`Tool \xab${r}\xbb is not found. Check 'tools' property at the Editor.js config.`, "warn"), l = this.composeStubDataForTool(r, l, c), r = o.stubTool);
                    let u;
                    try {
                        u = i.composeBlock({
                            id: c,
                            tool: r,
                            data: l,
                            tunes: a
                        });
                    } catch (h) {
                        $ca477aae3d96de69$var$I(`Block \xab${r}\xbb skipped because of plugins error`, "error", {
                            data: l,
                            error: h
                        }), l = this.composeStubDataForTool(r, l, c), r = o.stubTool, u = i.composeBlock({
                            id: c,
                            tool: r,
                            data: l,
                            tunes: a
                        });
                    }
                    return u;
                });
                i.insertMany(s);
            }
            window.requestIdleCallback(()=>{
                t1();
            }, {
                timeout: 2e3
            });
        });
    }
    /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ composeStubDataForTool(e, t1, o) {
        const { Tools: i } = this.Editor;
        let s = e;
        if (i.unavailable.has(e)) {
            const r = i.unavailable.get(e).toolbox;
            r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
        }
        return {
            savedData: {
                id: o,
                type: e,
                data: t1
            },
            title: s
        };
    }
}
class $ca477aae3d96de69$var$ds extends $ca477aae3d96de69$var$y {
    /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ async save() {
        const { BlockManager: e, Tools: t1 } = this.Editor, o = e.blocks, i = [];
        try {
            o.forEach((l)=>{
                i.push(this.getSavedData(l));
            });
            const s = await Promise.all(i), r = await $ca477aae3d96de69$var$ot(s, (l)=>t1.blockTools.get(l).sanitizeConfig);
            return this.makeOutput(r);
        } catch (s) {
            $ca477aae3d96de69$var$X("Saving failed due to the Error %o", "error", s);
        }
    }
    /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ async getSavedData(e) {
        const t1 = await e.save(), o = t1 && await e.validate(t1.data);
        return {
            ...t1,
            isValid: o
        };
    }
    /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ makeOutput(e) {
        const t1 = [];
        return e.forEach(({ id: o, tool: i, data: s, tunes: r, isValid: l })=>{
            if (!l) {
                $ca477aae3d96de69$var$I(`Block \xab${i}\xbb skipped because saved data is invalid`);
                return;
            }
            if (i === this.Editor.Tools.stubTool) {
                t1.push(s);
                return;
            }
            const a = {
                id: o,
                type: i,
                data: s,
                ...!$ca477aae3d96de69$var$V(r) && {
                    tunes: r
                }
            };
            t1.push(a);
        }), {
            time: +/* @__PURE__ */ new Date(),
            blocks: t1,
            version: "2.30.5"
        };
    }
}
(function() {
    try {
        if (typeof document < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $ca477aae3d96de69$var$hs = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $ca477aae3d96de69$var$us(n) {
    const e = document.createElement("div");
    e.innerHTML = n.trim();
    const t1 = document.createDocumentFragment();
    return t1.append(...Array.from(e.childNodes)), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $ca477aae3d96de69$var$dt {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: e, config: t1, api: o, readOnly: i }){
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : $ca477aae3d96de69$var$dt.DEFAULT_PLACEHOLDER, this._data = e ?? {}, this._element = null, this._preserveBlank = t1.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(e) {
        if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
        const { textContent: t1 } = this._element;
        t1 === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const e = document.createElement("DIV");
        return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(e) {
        if (!this._element) return;
        this._data.text += e.text;
        const t1 = $ca477aae3d96de69$var$us(e.text);
        this._element.appendChild(t1), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t1 = {
            text: e.detail.data.innerHTML
        };
        this._data = t1, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $ca477aae3d96de69$var$hs,
            title: "Text"
        };
    }
}
class $ca477aae3d96de69$var$ht {
    constructor(){
        this.commandName = "bold";
    }
    /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            b: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return {
            icon: $ca477aae3d96de69$var$bi,
            name: "bold",
            onActivate: ()=>{
                document.execCommand(this.commandName);
            },
            isActive: ()=>document.queryCommandState(this.commandName)
        };
    }
    /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ get shortcut() {
        return "CMD+B";
    }
}
$ca477aae3d96de69$var$ht.isInline = !0;
$ca477aae3d96de69$var$ht.title = "Bold";
class $ca477aae3d96de69$var$ut {
    constructor(){
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            i: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $ca477aae3d96de69$var$Bi, this.nodes.button;
    }
    /**
   * Wrap range with <i> tag
   */ surround() {
        document.execCommand(this.commandName);
    }
    /**
   * Check selection and set activated state to button if there are <i> tag
   */ checkState() {
        const e = document.queryCommandState(this.commandName);
        return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+I";
    }
}
$ca477aae3d96de69$var$ut.isInline = !0;
$ca477aae3d96de69$var$ut.title = "Italic";
class $ca477aae3d96de69$var$pt {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $ca477aae3d96de69$var$b();
    }
    /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            a: {
                href: !0,
                target: "_blank",
                rel: "nofollow"
            }
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $ca477aae3d96de69$var$xt, this.nodes.button;
    }
    /**
   * Input for the link
   */ renderActions() {
        return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", (e)=>{
            e.keyCode === this.ENTER_KEY && this.enterPressed(e);
        }), this.nodes.input;
    }
    /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ surround(e) {
        if (e) {
            this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
            const t1 = this.selection.findParentTag("A");
            if (t1) {
                this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close();
                return;
            }
        }
        this.toggleActions();
    }
    /**
   * Check selection and set activated state to button if there are <a> tag
   */ checkState() {
        const e = this.selection.findParentTag("A");
        if (e) {
            this.nodes.button.innerHTML = $ca477aae3d96de69$var$Ii, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
            const t1 = e.getAttribute("href");
            this.nodes.input.value = t1 !== "null" ? t1 : "", this.selection.save();
        } else this.nodes.button.innerHTML = $ca477aae3d96de69$var$xt, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
        return !!e;
    }
    /**
   * Function called with Inline Toolbar closing
   */ clear() {
        this.closeActions();
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+K";
    }
    /**
   * Show/close link input
   */ toggleActions() {
        this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ openActions(e = !1) {
        this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ closeActions(e = !0) {
        if (this.selection.isFakeBackgroundEnabled) {
            const t1 = new $ca477aae3d96de69$var$b();
            t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
        }
        this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ enterPressed(e) {
        let t1 = this.nodes.input.value || "";
        if (!t1.trim()) {
            this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
            return;
        }
        if (!this.validateURL(t1)) {
            this.notifier.show({
                message: "Pasted link is not valid.",
                style: "error"
            }), $ca477aae3d96de69$var$I("Incorrect Link pasted", "warn", t1);
            return;
        }
        t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ validateURL(e) {
        return !/\s/.test(e);
    }
    /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ prepareLink(e) {
        return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ addProtocol(e) {
        if (/^(\w+):(\/\/)?/.test(e)) return e;
        const t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
        return !t1 && !o && !i && (e = "http://" + e), e;
    }
    /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ insertLink(e) {
        const t1 = this.selection.findParentTag("A");
        t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
    }
    /**
   * Removes <a> tag
   */ unlink() {
        document.execCommand(this.commandUnlink);
    }
}
$ca477aae3d96de69$var$pt.isInline = !0;
$ca477aae3d96de69$var$pt.title = "Link";
class $ca477aae3d96de69$var$ao {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    /**
   * Returns tool's UI config
   */ async render() {
        const e = $ca477aae3d96de69$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
        if (t1 === void 0) return [];
        const o = this.toolsAPI.getBlockTools(), i = await $ca477aae3d96de69$var$zt(t1, o);
        if (i.length === 0) return [];
        const s = i.reduce((c, u)=>{
            var h;
            return (h = u.toolbox) == null || h.forEach((p)=>{
                c.push({
                    icon: p.icon,
                    title: $ca477aae3d96de69$var$z.t($ca477aae3d96de69$var$K.toolNames, p.title),
                    name: u.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const g = await this.blocksAPI.convert(t1.id, u.name, p.data);
                        this.caretAPI.setToBlock(g, "end");
                    }
                });
            }), c;
        }, []), r = await t1.getActiveToolboxEntry(), l = r !== void 0 ? r.icon : $ca477aae3d96de69$var$Kt, a = !$ca477aae3d96de69$var$pe();
        return {
            icon: l,
            name: "convert-to",
            hint: {
                title: this.i18nAPI.t("Convert to")
            },
            children: {
                searchable: a,
                items: s,
                onOpen: ()=>{
                    a && (this.selectionAPI.setFakeBackground(), this.selectionAPI.save());
                },
                onClose: ()=>{
                    a && (this.selectionAPI.restore(), this.selectionAPI.removeFakeBackground());
                }
            }
        };
    }
}
$ca477aae3d96de69$var$ao.isInline = !0;
class $ca477aae3d96de69$var$co {
    /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */ constructor({ data: e, api: t1 }){
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ render() {
        return this.wrapper;
    }
    /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ save() {
        return this.savedData;
    }
    /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ make() {
        const e = $ca477aae3d96de69$var$d.make("div", this.CSS.wrapper), t1 = $ca477aae3d96de69$var$Mi, o = $ca477aae3d96de69$var$d.make("div", this.CSS.info), i = $ca477aae3d96de69$var$d.make("div", this.CSS.title, {
            textContent: this.title
        }), s = $ca477aae3d96de69$var$d.make("div", this.CSS.subtitle, {
            textContent: this.subtitle
        });
        return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
}
$ca477aae3d96de69$var$co.isReadOnlySupported = !0;
class $ca477aae3d96de69$var$ps extends $ca477aae3d96de69$var$ct {
    constructor(){
        super(...arguments), this.type = $ca477aae3d96de69$var$ne.Inline;
    }
    /**
   * Returns title for Inline Tool if specified by user
   */ get title() {
        return this.constructable[$ca477aae3d96de69$var$at.Title];
    }
    /**
   * Constructs new InlineTool instance from constructable
   */ create() {
        return new this.constructable({
            api: this.api,
            config: this.settings
        });
    }
}
class $ca477aae3d96de69$var$fs extends $ca477aae3d96de69$var$ct {
    constructor(){
        super(...arguments), this.type = $ca477aae3d96de69$var$ne.Tune;
    }
    /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ create(e, t1) {
        return new this.constructable({
            api: this.api,
            config: this.settings,
            block: t1,
            data: e
        });
    }
}
class $ca477aae3d96de69$var$F extends Map {
    /**
   * Returns Block Tools collection
   */ get blockTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isBlock());
        return new $ca477aae3d96de69$var$F(e);
    }
    /**
   * Returns Inline Tools collection
   */ get inlineTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInline());
        return new $ca477aae3d96de69$var$F(e);
    }
    /**
   * Returns Block Tunes collection
   */ get blockTunes() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isTune());
        return new $ca477aae3d96de69$var$F(e);
    }
    /**
   * Returns internal Tools collection
   */ get internalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInternal);
        return new $ca477aae3d96de69$var$F(e);
    }
    /**
   * Returns Tools collection provided by user
   */ get externalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>!t1.isInternal);
        return new $ca477aae3d96de69$var$F(e);
    }
}
var $ca477aae3d96de69$var$gs = Object.defineProperty, $ca477aae3d96de69$var$ms = Object.getOwnPropertyDescriptor, $ca477aae3d96de69$var$ho = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $ca477aae3d96de69$var$ms(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $ca477aae3d96de69$var$gs(e, t1, i), i;
};
class $ca477aae3d96de69$var$ft extends $ca477aae3d96de69$var$ct {
    constructor(){
        super(...arguments), this.type = $ca477aae3d96de69$var$ne.Block, this.inlineTools = new $ca477aae3d96de69$var$F(), this.tunes = new $ca477aae3d96de69$var$F();
    }
    /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ create(e, t1, o) {
        return new this.constructable({
            data: e,
            block: t1,
            readOnly: o,
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Returns true if read-only mode is supported by Tool
   */ get isReadOnlySupported() {
        return this.constructable[$ca477aae3d96de69$var$ce.IsReadOnlySupported] === !0;
    }
    /**
   * Returns true if Tool supports linebreaks
   */ get isLineBreaksEnabled() {
        return this.constructable[$ca477aae3d96de69$var$ce.IsEnabledLineBreaks];
    }
    /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ get toolbox() {
        const e = this.constructable[$ca477aae3d96de69$var$ce.Toolbox], t1 = this.config[$ca477aae3d96de69$var$Ie.Toolbox];
        if (!$ca477aae3d96de69$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map((o, i)=>{
            const s = e[i];
            return s ? {
                ...s,
                ...o
            } : o;
        }) : [
            t1
        ] : Array.isArray(t1) ? t1 : [
            {
                ...e,
                ...t1
            }
        ] : Array.isArray(e) ? e : [
            e
        ];
    }
    /**
   * Returns Tool conversion configuration
   */ get conversionConfig() {
        return this.constructable[$ca477aae3d96de69$var$ce.ConversionConfig];
    }
    /**
   * Returns enabled inline tools for Tool
   */ get enabledInlineTools() {
        return this.config[$ca477aae3d96de69$var$Ie.EnabledInlineTools] || !1;
    }
    /**
   * Returns enabled tunes for Tool
   */ get enabledBlockTunes() {
        return this.config[$ca477aae3d96de69$var$Ie.EnabledBlockTunes];
    }
    /**
   * Returns Tool paste configuration
   */ get pasteConfig() {
        return this.constructable[$ca477aae3d96de69$var$ce.PasteConfig] ?? {};
    }
    get sanitizeConfig() {
        const e = super.sanitizeConfig, t1 = this.baseSanitizeConfig;
        if ($ca477aae3d96de69$var$V(e)) return t1;
        const o = {};
        for(const i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
            const s = e[i];
            $ca477aae3d96de69$var$R(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
        }
        return o;
    }
    get baseSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), Array.from(this.tunes.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), e;
    }
}
$ca477aae3d96de69$var$ho([
    $ca477aae3d96de69$var$ue
], $ca477aae3d96de69$var$ft.prototype, "sanitizeConfig", 1);
$ca477aae3d96de69$var$ho([
    $ca477aae3d96de69$var$ue
], $ca477aae3d96de69$var$ft.prototype, "baseSanitizeConfig", 1);
class $ca477aae3d96de69$var$bs {
    /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */ constructor(e, t1, o){
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ get(e) {
        const { class: t1, isInternal: o = !1, ...i } = this.config[e], s = this.getConstructor(t1), r = t1[$ca477aae3d96de69$var$Qe.IsTune];
        return new s({
            name: e,
            constructable: t1,
            config: i,
            api: this.api.getMethodsForTool(e, r),
            isDefault: e === this.editorConfig.defaultBlock,
            defaultPlaceholder: this.editorConfig.placeholder,
            isInternal: o
        });
    }
    /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ getConstructor(e) {
        switch(!0){
            case e[$ca477aae3d96de69$var$at.IsInline]:
                return $ca477aae3d96de69$var$ps;
            case e[$ca477aae3d96de69$var$Qe.IsTune]:
                return $ca477aae3d96de69$var$fs;
            default:
                return $ca477aae3d96de69$var$ft;
        }
    }
}
class $ca477aae3d96de69$var$uo {
    /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $ca477aae3d96de69$var$ki,
            title: this.api.i18n.t("Move down"),
            onActivate: ()=>this.handleClick(),
            name: "move-down"
        };
    }
    /**
   * Handle clicks on 'move down' button
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
        if (!t1) throw new Error("Unable to move Block down since it is already the last");
        const o = t1.holder, i = o.getBoundingClientRect();
        let s = Math.abs(window.innerHeight - o.offsetHeight);
        i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$ca477aae3d96de69$var$uo.isTune = !0;
class $ca477aae3d96de69$var$po {
    /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $ca477aae3d96de69$var$yi,
            title: this.api.i18n.t("Delete"),
            name: "delete",
            confirmation: {
                title: this.api.i18n.t("Click to delete"),
                onActivate: ()=>this.handleClick()
            }
        };
    }
    /**
   * Delete block conditions passed
   */ handleClick() {
        this.api.blocks.delete();
    }
}
$ca477aae3d96de69$var$po.isTune = !0;
class $ca477aae3d96de69$var$fo {
    /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $ca477aae3d96de69$var$xi,
            title: this.api.i18n.t("Move up"),
            onActivate: ()=>this.handleClick(),
            name: "move-up"
        };
    }
    /**
   * Move current block up
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
        if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
        const i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), l = s.getBoundingClientRect();
        let a;
        l.top > 0 ? a = Math.abs(r.top) - Math.abs(l.top) : a = Math.abs(r.top) + l.height, window.scrollBy(0, -1 * a), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$ca477aae3d96de69$var$fo.isTune = !0;
var $ca477aae3d96de69$var$ks = Object.defineProperty, $ca477aae3d96de69$var$vs = Object.getOwnPropertyDescriptor, $ca477aae3d96de69$var$ws = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $ca477aae3d96de69$var$vs(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $ca477aae3d96de69$var$ks(e, t1, i), i;
};
class $ca477aae3d96de69$var$go extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.stubTool = "stub", this.toolsAvailable = new $ca477aae3d96de69$var$F(), this.toolsUnavailable = new $ca477aae3d96de69$var$F();
    }
    /**
   * Returns available Tools
   */ get available() {
        return this.toolsAvailable;
    }
    /**
   * Returns unavailable Tools
   */ get unavailable() {
        return this.toolsUnavailable;
    }
    /**
   * Return Tools for the Inline Toolbar
   */ get inlineTools() {
        return this.available.inlineTools;
    }
    /**
   * Return editor block tools
   */ get blockTools() {
        return this.available.blockTools;
    }
    /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ get blockTunes() {
        return this.available.blockTunes;
    }
    /**
   * Returns default Tool object
   */ get defaultTool() {
        return this.blockTools.get(this.config.defaultBlock);
    }
    /**
   * Returns internal tools
   */ get internal() {
        return this.available.internalTools;
    }
    /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ async prepare() {
        if (this.validateTools(), this.config.tools = $ca477aae3d96de69$var$qe({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
        const e = this.prepareConfig();
        this.factory = new $ca477aae3d96de69$var$bs(e, this.config, this.Editor.API);
        const t1 = this.getListOfPrepareFunctions(e);
        if (t1.length === 0) return Promise.resolve();
        await $ca477aae3d96de69$var$Eo(t1, (o)=>{
            this.toolPrepareMethodSuccess(o);
        }, (o)=>{
            this.toolPrepareMethodFallback(o);
        }), this.prepareBlockTools();
    }
    getAllInlineToolsSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>{
            Object.assign(e, t1.sanitizeConfig);
        }), e;
    }
    /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ destroy() {
        Object.values(this.available).forEach(async (e)=>{
            $ca477aae3d96de69$var$O(e.reset) && await e.reset();
        });
    }
    /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ get internalTools() {
        return {
            convertTo: {
                class: $ca477aae3d96de69$var$ao,
                isInternal: !0
            },
            link: {
                class: $ca477aae3d96de69$var$pt,
                isInternal: !0
            },
            bold: {
                class: $ca477aae3d96de69$var$ht,
                isInternal: !0
            },
            italic: {
                class: $ca477aae3d96de69$var$ut,
                isInternal: !0
            },
            paragraph: {
                class: $ca477aae3d96de69$var$dt,
                inlineToolbar: !0,
                isInternal: !0
            },
            stub: {
                class: $ca477aae3d96de69$var$co,
                isInternal: !0
            },
            moveUp: {
                class: $ca477aae3d96de69$var$fo,
                isInternal: !0
            },
            delete: {
                class: $ca477aae3d96de69$var$po,
                isInternal: !0
            },
            moveDown: {
                class: $ca477aae3d96de69$var$uo,
                isInternal: !0
            }
        };
    }
    /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ toolPrepareMethodSuccess(e) {
        const t1 = this.factory.get(e.toolName);
        if (t1.isInline()) {
            const i = [
                "render"
            ].filter((s)=>!t1.create()[s]);
            if (i.length) {
                $ca477aae3d96de69$var$I(`Incorrect Inline Tool: ${t1.name}. Some of required methods is not implemented %o`, "warn", i), this.toolsUnavailable.set(t1.name, t1);
                return;
            }
        }
        this.toolsAvailable.set(t1.name, t1);
    }
    /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ toolPrepareMethodFallback(e) {
        this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ getListOfPrepareFunctions(e) {
        const t1 = [];
        return Object.entries(e).forEach(([o, i])=>{
            t1.push({
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function: $ca477aae3d96de69$var$O(i.class.prepare) ? i.class.prepare : ()=>{},
                data: {
                    toolName: o,
                    config: i.config
                }
            });
        }), t1;
    }
    /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ prepareBlockTools() {
        Array.from(this.blockTools.values()).forEach((e)=>{
            this.assignInlineToolsToBlockTool(e), this.assignBlockTunesToBlockTool(e);
        });
    }
    /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ assignInlineToolsToBlockTool(e) {
        if (this.config.inlineToolbar !== !1) {
            if (e.enabledInlineTools === !0) {
                e.inlineTools = new $ca477aae3d96de69$var$F(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map((t1)=>[
                        t1,
                        this.inlineTools.get(t1)
                    ]) : Array.from(this.inlineTools.entries()));
                return;
            }
            Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $ca477aae3d96de69$var$F(/** Prepend ConvertTo Inline Tool */ [
                "convertTo",
                ...e.enabledInlineTools
            ].map((t1)=>[
                    t1,
                    this.inlineTools.get(t1)
                ])));
        }
    }
    /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ assignBlockTunesToBlockTool(e) {
        if (e.enabledBlockTunes !== !1) {
            if (Array.isArray(e.enabledBlockTunes)) {
                const t1 = new $ca477aae3d96de69$var$F(e.enabledBlockTunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $ca477aae3d96de69$var$F([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            if (Array.isArray(this.config.tunes)) {
                const t1 = new $ca477aae3d96de69$var$F(this.config.tunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $ca477aae3d96de69$var$F([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            e.tunes = this.blockTunes.internalTools;
        }
    }
    /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ validateTools() {
        for(const e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
            if (e in this.internalTools) return;
            const t1 = this.config.tools[e];
            if (!$ca477aae3d96de69$var$O(t1) && !$ca477aae3d96de69$var$O(t1.class)) throw Error(`Tool \xab${e}\xbb must be a constructor function or an object with function in the \xabclass\xbb property`);
        }
    }
    /**
   * Unify tools config
   */ prepareConfig() {
        const e = {};
        for(const t1 in this.config.tools)$ca477aae3d96de69$var$R(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
            class: this.config.tools[t1]
        };
        return e;
    }
}
$ca477aae3d96de69$var$ws([
    $ca477aae3d96de69$var$ue
], $ca477aae3d96de69$var$go.prototype, "getAllInlineToolsSanitizeConfig", 1);
const $ca477aae3d96de69$var$xs = `:root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}
`;
class $ca477aae3d96de69$var$ys extends $ca477aae3d96de69$var$y {
    constructor(){
        super(...arguments), this.isMobile = !1, this.contentRectCache = void 0, this.resizeDebouncer = $ca477aae3d96de69$var$kt(()=>{
            this.windowResize();
        }, 200);
    }
    /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorWrapperNarrow: "codex-editor--narrow",
            editorZone: "codex-editor__redactor",
            editorZoneHidden: "codex-editor__redactor--hidden",
            editorEmpty: "codex-editor--empty",
            editorRtlFix: "codex-editor--rtl"
        };
    }
    /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ get contentRect() {
        if (this.contentRectCache) return this.contentRectCache;
        const e = this.nodes.wrapper.querySelector(`.${$ca477aae3d96de69$var$D.CSS.content}`);
        return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
            width: 650,
            left: 0,
            right: 0
        };
    }
    /**
   * Making main interface
   */ async prepare() {
        this.setIsMobile(), this.make(), this.loadStyles();
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : window.requestIdleCallback(()=>{
            this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Check if Editor is empty and set CSS class to wrapper
   */ checkEmptiness() {
        const { BlockManager: e } = this.Editor;
        this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ get someToolbarOpened() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        return !!(t1.opened || o.opened || e.toolbox.opened);
    }
    /**
   * Check for some Flipper-buttons is under focus
   */ get someFlipperButtonFocused() {
        return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(([e, t1])=>t1.flipper instanceof $ca477aae3d96de69$var$le).some(([e, t1])=>t1.flipper.hasFocus());
    }
    /**
   * Clean editor`s UI
   */ destroy() {
        this.nodes.holder.innerHTML = "";
    }
    /**
   * Close all Editor's toolbars
   */ closeAllToolbars() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        t1.close(), o.close(), e.toolbox.close();
    }
    /**
   * Check for mobile mode and save the result
   */ setIsMobile() {
        const e = window.innerWidth < $ca477aae3d96de69$var$At;
        e !== this.isMobile && this.eventsDispatcher.emit($ca477aae3d96de69$var$ye, {
            isEnabled: this.isMobile
        }), this.isMobile = e;
    }
    /**
   * Makes Editor.js interface
   */ make() {
        this.nodes.holder = $ca477aae3d96de69$var$d.getHolder(this.config.holder), this.nodes.wrapper = $ca477aae3d96de69$var$d.make("div", [
            this.CSS.editorWrapper,
            ...this.isRtl ? [
                this.CSS.editorRtlFix
            ] : []
        ]), this.nodes.redactor = $ca477aae3d96de69$var$d.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper);
    }
    /**
   * Appends CSS
   */ loadStyles() {
        const e = "editor-js-styles";
        if ($ca477aae3d96de69$var$d.get(e)) return;
        const t1 = $ca477aae3d96de69$var$d.make("style", null, {
            id: e,
            textContent: $ca477aae3d96de69$var$xs.toString()
        });
        this.config.style && !$ca477aae3d96de69$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $ca477aae3d96de69$var$d.prepend(document.head, t1);
    }
    /**
   * Bind events on the Editor.js interface
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.redactor, "click", (t1)=>{
            this.redactorClicked(t1);
        }, !1), this.readOnlyMutableListeners.on(this.nodes.redactor, "mousedown", (t1)=>{
            this.documentTouched(t1);
        }, {
            capture: !0,
            passive: !0
        }), this.readOnlyMutableListeners.on(this.nodes.redactor, "touchstart", (t1)=>{
            this.documentTouched(t1);
        }, {
            capture: !0,
            passive: !0
        }), this.readOnlyMutableListeners.on(document, "keydown", (t1)=>{
            this.documentKeydown(t1);
        }, !0), this.readOnlyMutableListeners.on(document, "mousedown", (t1)=>{
            this.documentClicked(t1);
        }, !0);
        const e = $ca477aae3d96de69$var$kt(()=>{
            this.selectionChanged();
        }, $ca477aae3d96de69$var$ss);
        this.readOnlyMutableListeners.on(document, "selectionchange", e, !0), this.readOnlyMutableListeners.on(window, "resize", ()=>{
            this.resizeDebouncer();
        }, {
            passive: !0
        }), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ watchBlockHoveredEvents() {
        let e;
        this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $ca477aae3d96de69$var$Ve((t1)=>{
            const o = t1.target.closest(".ce-block");
            this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, this.eventsDispatcher.emit($ca477aae3d96de69$var$oo, {
                block: this.Editor.BlockManager.getBlockByChildNode(o)
            }));
        }, 20), {
            passive: !0
        });
    }
    /**
   * Unbind events on the Editor.js interface
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Resize window handler
   */ windowResize() {
        this.contentRectCache = null, this.setIsMobile();
    }
    /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ documentKeydown(e) {
        switch(e.keyCode){
            case $ca477aae3d96de69$var$w.ENTER:
                this.enterPressed(e);
                break;
            case $ca477aae3d96de69$var$w.BACKSPACE:
            case $ca477aae3d96de69$var$w.DELETE:
                this.backspacePressed(e);
                break;
            case $ca477aae3d96de69$var$w.ESC:
                this.escapePressed(e);
                break;
            default:
                this.defaultBehaviour(e);
                break;
        }
    }
    /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ defaultBehaviour(e) {
        const { currentBlock: t1 } = this.Editor.BlockManager, o = e.target.closest(`.${this.CSS.editorWrapper}`), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
        if (t1 !== void 0 && o === null) {
            this.Editor.BlockEvents.keydown(e);
            return;
        }
        o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
   * @param {KeyboardEvent} event - keyboard event
   */ backspacePressed(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor;
        if (o.anyBlockSelected && !$ca477aae3d96de69$var$b.isSelectionExists) {
            const s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }
    /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ escapePressed(e) {
        this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ enterPressed(e) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        if (this.someToolbarOpened) return;
        const i = t1.currentBlockIndex >= 0;
        if (o.anyBlockSelected && !$ca477aae3d96de69$var$b.isSelectionExists) {
            o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            return;
        }
        if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
            const s = this.Editor.BlockManager.insert();
            e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ documentClicked(e) {
        var l, a;
        if (!e.isTrusted) return;
        const t1 = e.target;
        this.nodes.holder.contains(t1) || $ca477aae3d96de69$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
        const i = (l = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : l.contains(t1), s = (a = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : a.contains(t1), r = i || s;
        if (this.Editor.BlockSettings.opened && !r) {
            this.Editor.BlockSettings.close();
            const c = this.Editor.BlockManager.getBlockByChildNode(t1);
            this.Editor.Toolbar.moveAndOpen(c);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param {MouseEvent | TouchEvent} event - touch or mouse event
   */ documentTouched(e) {
        let t1 = e.target;
        if (t1 === this.nodes.redactor) {
            const o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
            t1 = document.elementFromPoint(o, i);
        }
        try {
            this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
        } catch  {
            this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
        }
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ redactorClicked(e) {
        if (!$ca477aae3d96de69$var$b.isCollapsed) return;
        const t1 = e.target, o = e.metaKey || e.ctrlKey;
        if ($ca477aae3d96de69$var$d.isAnchor(t1) && o) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const i = t1.getAttribute("href"), s = $ca477aae3d96de69$var$So(i);
            $ca477aae3d96de69$var$Mo(s);
            return;
        }
        this.processBottomZoneClick(e);
    }
    /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ processBottomZoneClick(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $ca477aae3d96de69$var$d.offset(t1.holder).bottom, i = e.pageY, { BlockSelection: s } = this.Editor;
        if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const { BlockManager: l, Caret: a, Toolbar: c } = this.Editor;
            (!l.lastBlock.tool.isDefault || !l.lastBlock.isEmpty) && l.insertAtEnd(), a.setToTheLastBlock(), c.moveAndOpen(l.lastBlock);
        }
    }
    /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ selectionChanged() {
        const { CrossBlockSelection: e, BlockSelection: t1 } = this.Editor, o = $ca477aae3d96de69$var$b.anchorElement;
        if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $ca477aae3d96de69$var$b.get().removeAllRanges(), !o) {
            $ca477aae3d96de69$var$b.range || this.Editor.InlineToolbar.close();
            return;
        }
        o.closest(`.${$ca477aae3d96de69$var$D.CSS.content}`) === null && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ enableInputsEmptyMark() {
        function e(t1) {
            const o = t1.target;
            $ca477aae3d96de69$var$Ot(o);
        }
        this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
}
const $ca477aae3d96de69$var$Es = {
    // API Modules
    BlocksAPI: $ca477aae3d96de69$var$zo,
    CaretAPI: $ca477aae3d96de69$var$jo,
    EventsAPI: $ca477aae3d96de69$var$$o,
    I18nAPI: $ca477aae3d96de69$var$tt,
    API: $ca477aae3d96de69$var$Yo,
    InlineToolbarAPI: $ca477aae3d96de69$var$Wo,
    ListenersAPI: $ca477aae3d96de69$var$Ko,
    NotifierAPI: $ca477aae3d96de69$var$Zo,
    ReadOnlyAPI: $ca477aae3d96de69$var$Go,
    SanitizerAPI: $ca477aae3d96de69$var$si,
    SaverAPI: $ca477aae3d96de69$var$ni,
    SelectionAPI: $ca477aae3d96de69$var$ri,
    ToolsAPI: $ca477aae3d96de69$var$li,
    StylesAPI: $ca477aae3d96de69$var$ai,
    ToolbarAPI: $ca477aae3d96de69$var$ci,
    TooltipAPI: $ca477aae3d96de69$var$fi,
    UiAPI: $ca477aae3d96de69$var$gi,
    // Toolbar Modules
    BlockSettings: $ca477aae3d96de69$var$Ui,
    Toolbar: $ca477aae3d96de69$var$qi,
    InlineToolbar: $ca477aae3d96de69$var$Zi,
    // Modules
    BlockEvents: $ca477aae3d96de69$var$Gi,
    BlockManager: $ca477aae3d96de69$var$es,
    BlockSelection: $ca477aae3d96de69$var$ts,
    Caret: $ca477aae3d96de69$var$Re,
    CrossBlockSelection: $ca477aae3d96de69$var$os,
    DragNDrop: $ca477aae3d96de69$var$is,
    ModificationsObserver: $ca477aae3d96de69$var$rs,
    Paste: $ca477aae3d96de69$var$ls,
    ReadOnly: $ca477aae3d96de69$var$as,
    RectangleSelection: $ca477aae3d96de69$var$xe,
    Renderer: $ca477aae3d96de69$var$cs,
    Saver: $ca477aae3d96de69$var$ds,
    Tools: $ca477aae3d96de69$var$go,
    UI: $ca477aae3d96de69$var$ys
};
class $ca477aae3d96de69$var$Bs {
    /**
   * @param {EditorConfig} config - user configuration
   */ constructor(e){
        this.moduleInstances = {}, this.eventsDispatcher = new $ca477aae3d96de69$var$Te();
        let t1, o;
        this.isReady = new Promise((i, s)=>{
            t1 = i, o = s;
        }), Promise.resolve().then(async ()=>{
            this.configuration = e, this.validate(), this.init(), await this.start(), await this.render();
            const { BlockManager: i, Caret: s, UI: r, ModificationsObserver: l } = this.moduleInstances;
            r.checkEmptiness(), l.enable(), this.configuration.autofocus && s.setToBlock(i.blocks[0], s.positions.START), t1();
        }).catch((i)=>{
            $ca477aae3d96de69$var$I(`Editor.js is not ready because of ${i}`, "error"), o(i);
        });
    }
    /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ set configuration(e) {
        var o, i;
        $ca477aae3d96de69$var$R(e) ? this.config = {
            ...e
        } : this.config = {
            holder: e
        }, $ca477aae3d96de69$var$Ze(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $ca477aae3d96de69$var$St.VERBOSE), $ca477aae3d96de69$var$xo(this.config.logLevel), $ca477aae3d96de69$var$Ze(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
        const t1 = {
            type: this.config.defaultBlock,
            data: {}
        };
        this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
            p: !0,
            b: !0,
            a: !0
        }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
            blocks: []
        }, this.config.onReady = this.config.onReady || (()=>{}), this.config.onChange = this.config.onChange || (()=>{}), this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($ca477aae3d96de69$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
            blocks: [
                t1
            ]
        }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $ca477aae3d96de69$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
    /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ get configuration() {
        return this.config;
    }
    /**
   * Checks for required fields in Editor's config
   */ validate() {
        const { holderId: e, holder: t1 } = this.config;
        if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
        if ($ca477aae3d96de69$var$Q(t1) && !$ca477aae3d96de69$var$d.get(t1)) throw Error(`element with ID \xab${t1}\xbb is missing. Pass correct holder's ID.`);
        if (t1 && $ca477aae3d96de69$var$R(t1) && !$ca477aae3d96de69$var$d.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
    }
    /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ init() {
        this.constructModules(), this.configureModules();
    }
    /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ async start() {
        await [
            "Tools",
            "UI",
            "BlockManager",
            "Paste",
            "BlockSelection",
            "RectangleSelection",
            "CrossBlockSelection",
            "ReadOnly"
        ].reduce((t1, o)=>t1.then(async ()=>{
                try {
                    await this.moduleInstances[o].prepare();
                } catch (i) {
                    if (i instanceof $ca477aae3d96de69$var$Nt) throw new Error(i.message);
                    $ca477aae3d96de69$var$I(`Module ${o} was skipped because of %o`, "warn", i);
                }
            }), Promise.resolve());
    }
    /**
   * Render initial data
   */ render() {
        return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ constructModules() {
        Object.entries($ca477aae3d96de69$var$Es).forEach(([e, t1])=>{
            try {
                this.moduleInstances[e] = new t1({
                    config: this.configuration,
                    eventsDispatcher: this.eventsDispatcher
                });
            } catch (o) {
                $ca477aae3d96de69$var$I("[constructModules]", `Module ${e} skipped because`, "error", o);
            }
        });
    }
    /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ configureModules() {
        for(const e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
    }
    /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ getModulesDiff(e) {
        const t1 = {};
        for(const o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
        return t1;
    }
}
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ class $ca477aae3d96de69$export$2e2bcd8739ae039 {
    /** Editor version */ static get version() {
        return "2.30.5";
    }
    /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */ constructor(e){
        let t1 = ()=>{};
        $ca477aae3d96de69$var$R(e) && $ca477aae3d96de69$var$O(e.onReady) && (t1 = e.onReady);
        const o = new $ca477aae3d96de69$var$Bs(e);
        this.isReady = o.isReady.then(()=>{
            this.exportAPI(o), t1();
        });
    }
    /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ exportAPI(e) {
        const t1 = [
            "configuration"
        ], o = ()=>{
            Object.values(e.moduleInstances).forEach((s)=>{
                $ca477aae3d96de69$var$O(s.destroy) && s.destroy(), s.listeners.removeAll();
            }), $ca477aae3d96de69$var$pi(), e = null;
            for(const s in this)Object.prototype.hasOwnProperty.call(this, s) && delete this[s];
            Object.setPrototypeOf(this, null);
        };
        t1.forEach((s)=>{
            this[s] = e[s];
        }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
            blocks: {
                clear: "clear",
                render: "render"
            },
            caret: {
                focus: "focus"
            },
            events: {
                on: "on",
                off: "off",
                emit: "emit"
            },
            saver: {
                save: "save"
            }
        }).forEach(([s, r])=>{
            Object.entries(r).forEach(([l, a])=>{
                this[a] = e.moduleInstances.API.methods[s][l];
            });
        });
    }
}

});

parcelRegister("2ldO2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c5a0f911bd541c3$export$2e2bcd8739ae039; });
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
const $7c5a0f911bd541c3$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $7c5a0f911bd541c3$var$l(r) {
    const t = document.createElement("div");
    t.innerHTML = r.trim();
    const e = document.createDocumentFragment();
    return e.append(...Array.from(t.childNodes)), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $7c5a0f911bd541c3$export$2e2bcd8739ae039 {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: i, readOnly: s }){
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : $7c5a0f911bd541c3$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER, this._data = t ?? {}, this._element = null, this._preserveBlank = e.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(t) {
        if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
        const { textContent: e } = this._element;
        e === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const t = document.createElement("DIV");
        return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(t) {
        if (!this._element) return;
        this._data.text += t.text;
        const e = $7c5a0f911bd541c3$var$l(t.text);
        this._element.appendChild(e), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(t) {
        return !(t.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(t) {
        return {
            text: t.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(t) {
        const e = {
            text: t.detail.data.innerHTML
        };
        this._data = e, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $7c5a0f911bd541c3$var$a,
            title: "Text"
        };
    }
}

});


parcelRegister("8Cjev", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6460ca9dad1a2ced$export$2e2bcd8739ae039; });

var $4HBpa = parcelRequire("4HBpa");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6460ca9dad1a2ced$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6460ca9dad1a2ced$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6460ca9dad1a2ced$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $6460ca9dad1a2ced$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $6460ca9dad1a2ced$var$ServerEditorCore {
    constructor({ data: data }){
        if (data) this._memoizedData = data;
    }
    get dangerouslyLowLevelInstance() {
        return null;
    }
    clear() {
        return $6460ca9dad1a2ced$var$__awaiter(this, void 0, void 0, function*() {});
    }
    save() {
        return $6460ca9dad1a2ced$var$__awaiter(this, void 0, void 0, function*() {
            return this._memoizedData;
        });
    }
    destroy() {
        return $6460ca9dad1a2ced$var$__awaiter(this, void 0, void 0, function*() {});
    }
    render() {
        return $6460ca9dad1a2ced$var$__awaiter(this, void 0, void 0, function*() {});
    }
}
function $6460ca9dad1a2ced$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useCallback((config)=>new $6460ca9dad1a2ced$var$ServerEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement($6460ca9dad1a2ced$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("3p0ZA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $j82M4 = parcelRequire("j82M4");
function $27a479f8b1e67f1c$var$emptyFunction() {}
function $27a479f8b1e67f1c$var$emptyFunctionWithReset() {}
$27a479f8b1e67f1c$var$emptyFunctionWithReset.resetWarningCache = $27a479f8b1e67f1c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $j82M4) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $27a479f8b1e67f1c$var$emptyFunctionWithReset,
        resetWarningCache: $27a479f8b1e67f1c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("j82M4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $ded0ea9b72e1fb62$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $ded0ea9b72e1fb62$var$ReactPropTypesSecret;

});


parcelRegister("ddVow", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("9zpVk", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $7U1b8 = parcelRequire("7U1b8");

var $jnC97 = parcelRequire("jnC97");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $7U1b8.validateField)(curve.Fp);
    (0, $jnC97.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $7U1b8.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});
parcelRegister("7U1b8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $jnC97 = parcelRequire("jnC97");
// prettier-ignore
const $5c0ead6707a7bf59$var$_0n = BigInt(0), $5c0ead6707a7bf59$var$_1n = BigInt(1), $5c0ead6707a7bf59$var$_2n = BigInt(2), $5c0ead6707a7bf59$var$_3n = BigInt(3);
// prettier-ignore
const $5c0ead6707a7bf59$var$_4n = BigInt(4), $5c0ead6707a7bf59$var$_5n = BigInt(5), $5c0ead6707a7bf59$var$_8n = BigInt(8);
// prettier-ignore
const $5c0ead6707a7bf59$var$_9n = BigInt(9), $5c0ead6707a7bf59$var$_16n = BigInt(16);
// Calculates a modulo b
function $5c0ead6707a7bf59$var$mod(a, b) {
    const result = a % b;
    return result >= $5c0ead6707a7bf59$var$_0n ? result : b + result;
}
module.exports.mod = $5c0ead6707a7bf59$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $5c0ead6707a7bf59$var$pow(num, power, modulo) {
    if (modulo <= $5c0ead6707a7bf59$var$_0n || power < $5c0ead6707a7bf59$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $5c0ead6707a7bf59$var$_1n) return $5c0ead6707a7bf59$var$_0n;
    let res = $5c0ead6707a7bf59$var$_1n;
    while(power > $5c0ead6707a7bf59$var$_0n){
        if (power & $5c0ead6707a7bf59$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $5c0ead6707a7bf59$var$_1n;
    }
    return res;
}
module.exports.pow = $5c0ead6707a7bf59$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $5c0ead6707a7bf59$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $5c0ead6707a7bf59$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $5c0ead6707a7bf59$var$pow2;
// Inverses number over modulo
function $5c0ead6707a7bf59$var$invert(number, modulo) {
    if (number === $5c0ead6707a7bf59$var$_0n || modulo <= $5c0ead6707a7bf59$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $5c0ead6707a7bf59$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $5c0ead6707a7bf59$var$_0n, y = $5c0ead6707a7bf59$var$_1n, u = $5c0ead6707a7bf59$var$_1n, v = $5c0ead6707a7bf59$var$_0n;
    while(a !== $5c0ead6707a7bf59$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $5c0ead6707a7bf59$var$_1n) throw new Error("invert: does not exist");
    return $5c0ead6707a7bf59$var$mod(x, modulo);
}
module.exports.invert = $5c0ead6707a7bf59$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $5c0ead6707a7bf59$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $5c0ead6707a7bf59$var$_1n) / $5c0ead6707a7bf59$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $5c0ead6707a7bf59$var$_1n, S = 0; Q % $5c0ead6707a7bf59$var$_2n === $5c0ead6707a7bf59$var$_0n; Q /= $5c0ead6707a7bf59$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $5c0ead6707a7bf59$var$_2n; Z < P && $5c0ead6707a7bf59$var$pow(Z, legendreC, P) !== P - $5c0ead6707a7bf59$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $5c0ead6707a7bf59$var$_1n) / $5c0ead6707a7bf59$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $5c0ead6707a7bf59$var$_1n) / $5c0ead6707a7bf59$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $5c0ead6707a7bf59$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $5c0ead6707a7bf59$var$tonelliShanks;
function $5c0ead6707a7bf59$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $5c0ead6707a7bf59$var$_4n === $5c0ead6707a7bf59$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $5c0ead6707a7bf59$var$_1n) / $5c0ead6707a7bf59$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $5c0ead6707a7bf59$var$_8n === $5c0ead6707a7bf59$var$_5n) {
        const c1 = (P - $5c0ead6707a7bf59$var$_5n) / $5c0ead6707a7bf59$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $5c0ead6707a7bf59$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $5c0ead6707a7bf59$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $5c0ead6707a7bf59$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $5c0ead6707a7bf59$var$tonelliShanks(P);
}
module.exports.FpSqrt = $5c0ead6707a7bf59$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $5c0ead6707a7bf59$var$isNegativeLE = (num, modulo)=>($5c0ead6707a7bf59$var$mod(num, modulo) & $5c0ead6707a7bf59$var$_1n) === $5c0ead6707a7bf59$var$_1n;
module.exports.isNegativeLE = $5c0ead6707a7bf59$var$isNegativeLE;
// prettier-ignore
const $5c0ead6707a7bf59$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $5c0ead6707a7bf59$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $5c0ead6707a7bf59$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $jnC97.validateObject)(field, opts);
}
module.exports.validateField = $5c0ead6707a7bf59$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $5c0ead6707a7bf59$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $5c0ead6707a7bf59$var$_0n) throw new Error("Expected power > 0");
    if (power === $5c0ead6707a7bf59$var$_0n) return f.ONE;
    if (power === $5c0ead6707a7bf59$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $5c0ead6707a7bf59$var$_0n){
        if (power & $5c0ead6707a7bf59$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $5c0ead6707a7bf59$var$_1n;
    }
    return p;
}
module.exports.FpPow = $5c0ead6707a7bf59$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $5c0ead6707a7bf59$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $5c0ead6707a7bf59$var$FpInvertBatch;
function $5c0ead6707a7bf59$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $5c0ead6707a7bf59$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $5c0ead6707a7bf59$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $5c0ead6707a7bf59$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $5c0ead6707a7bf59$var$_1n) / $5c0ead6707a7bf59$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $5c0ead6707a7bf59$var$FpIsSquare;
// CURVE.n lengths
function $5c0ead6707a7bf59$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $5c0ead6707a7bf59$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $5c0ead6707a7bf59$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $5c0ead6707a7bf59$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $5c0ead6707a7bf59$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $5c0ead6707a7bf59$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $jnC97.bitMask)(BITS),
        ZERO: $5c0ead6707a7bf59$var$_0n,
        ONE: $5c0ead6707a7bf59$var$_1n,
        create: (num)=>$5c0ead6707a7bf59$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $5c0ead6707a7bf59$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $5c0ead6707a7bf59$var$_0n,
        isOdd: (num)=>(num & $5c0ead6707a7bf59$var$_1n) === $5c0ead6707a7bf59$var$_1n,
        neg: (num)=>$5c0ead6707a7bf59$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$5c0ead6707a7bf59$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$5c0ead6707a7bf59$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$5c0ead6707a7bf59$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$5c0ead6707a7bf59$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$5c0ead6707a7bf59$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$5c0ead6707a7bf59$var$mod(lhs * $5c0ead6707a7bf59$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$5c0ead6707a7bf59$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$5c0ead6707a7bf59$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $jnC97.numberToBytesLE)(num, BYTES) : (0, $jnC97.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $jnC97.bytesToNumberLE)(bytes) : (0, $jnC97.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $5c0ead6707a7bf59$var$Field;
function $5c0ead6707a7bf59$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $5c0ead6707a7bf59$var$FpSqrtOdd;
function $5c0ead6707a7bf59$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $5c0ead6707a7bf59$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $5c0ead6707a7bf59$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $jnC97.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $5c0ead6707a7bf59$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $jnC97.bytesToNumberLE)(hash) : (0, $jnC97.bytesToNumberBE)(hash);
    return $5c0ead6707a7bf59$var$mod(num, groupOrder - $5c0ead6707a7bf59$var$_1n) + $5c0ead6707a7bf59$var$_1n;
}
module.exports.hashToPrivateScalar = $5c0ead6707a7bf59$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $5c0ead6707a7bf59$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $5c0ead6707a7bf59$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $5c0ead6707a7bf59$var$getMinHashLength(fieldOrder) {
    const length = $5c0ead6707a7bf59$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $5c0ead6707a7bf59$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $5c0ead6707a7bf59$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $5c0ead6707a7bf59$var$getFieldBytesLength(fieldOrder);
    const minLen = $5c0ead6707a7bf59$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $jnC97.bytesToNumberBE)(key) : (0, $jnC97.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $5c0ead6707a7bf59$var$mod(num, fieldOrder - $5c0ead6707a7bf59$var$_1n) + $5c0ead6707a7bf59$var$_1n;
    return isLE ? (0, $jnC97.numberToBytesLE)(reduced, fieldLen) : (0, $jnC97.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $5c0ead6707a7bf59$var$mapHashToField;

});
parcelRegister("jnC97", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $e1bdc150c1e96269$var$_0n = BigInt(0);
const $e1bdc150c1e96269$var$_1n = BigInt(1);
const $e1bdc150c1e96269$var$_2n = BigInt(2);
const $e1bdc150c1e96269$var$u8a = (a)=>a instanceof Uint8Array;
const $e1bdc150c1e96269$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $e1bdc150c1e96269$var$bytesToHex(bytes) {
    if (!$e1bdc150c1e96269$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $e1bdc150c1e96269$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $e1bdc150c1e96269$var$bytesToHex;
function $e1bdc150c1e96269$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $e1bdc150c1e96269$var$numberToHexUnpadded;
function $e1bdc150c1e96269$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $e1bdc150c1e96269$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $e1bdc150c1e96269$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $e1bdc150c1e96269$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $e1bdc150c1e96269$var$bytesToNumberBE(bytes) {
    return $e1bdc150c1e96269$var$hexToNumber($e1bdc150c1e96269$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $e1bdc150c1e96269$var$bytesToNumberBE;
function $e1bdc150c1e96269$var$bytesToNumberLE(bytes) {
    if (!$e1bdc150c1e96269$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $e1bdc150c1e96269$var$hexToNumber($e1bdc150c1e96269$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $e1bdc150c1e96269$var$bytesToNumberLE;
function $e1bdc150c1e96269$var$numberToBytesBE(n, len) {
    return $e1bdc150c1e96269$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $e1bdc150c1e96269$var$numberToBytesBE;
function $e1bdc150c1e96269$var$numberToBytesLE(n, len) {
    return $e1bdc150c1e96269$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $e1bdc150c1e96269$var$numberToBytesLE;
// Unpadded, rarely used
function $e1bdc150c1e96269$var$numberToVarBytesBE(n) {
    return $e1bdc150c1e96269$var$hexToBytes($e1bdc150c1e96269$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $e1bdc150c1e96269$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $e1bdc150c1e96269$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $e1bdc150c1e96269$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($e1bdc150c1e96269$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $e1bdc150c1e96269$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $e1bdc150c1e96269$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$e1bdc150c1e96269$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $e1bdc150c1e96269$var$concatBytes;
function $e1bdc150c1e96269$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $e1bdc150c1e96269$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $e1bdc150c1e96269$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $e1bdc150c1e96269$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $e1bdc150c1e96269$var$bitLen(n) {
    let len;
    for(len = 0; n > $e1bdc150c1e96269$var$_0n; n >>= $e1bdc150c1e96269$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $e1bdc150c1e96269$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $e1bdc150c1e96269$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $e1bdc150c1e96269$var$_1n;
}
module.exports.bitGet = $e1bdc150c1e96269$var$bitGet;
/**
 * Sets single bit at position.
 */ const $e1bdc150c1e96269$var$bitSet = (n, pos, value)=>{
    return n | (value ? $e1bdc150c1e96269$var$_1n : $e1bdc150c1e96269$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $e1bdc150c1e96269$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $e1bdc150c1e96269$var$bitMask = (n)=>($e1bdc150c1e96269$var$_2n << BigInt(n - 1)) - $e1bdc150c1e96269$var$_1n;
module.exports.bitMask = $e1bdc150c1e96269$var$bitMask;
// DRBG
const $e1bdc150c1e96269$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $e1bdc150c1e96269$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $e1bdc150c1e96269$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $e1bdc150c1e96269$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $e1bdc150c1e96269$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $e1bdc150c1e96269$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($e1bdc150c1e96269$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($e1bdc150c1e96269$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $e1bdc150c1e96269$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $e1bdc150c1e96269$var$createHmacDrbg;
// Validating curves and fields
const $e1bdc150c1e96269$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $e1bdc150c1e96269$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $e1bdc150c1e96269$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $e1bdc150c1e96269$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("h6VsE", function(module, exports) {

var $bOmn0 = parcelRequire("bOmn0");
module.exports = $bOmn0("cYG3x").then(()=>parcelRequire("kYRgI"));

});
parcelRegister("bOmn0", function(module, exports) {
"use strict";

function $8995b778360a2533$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("6AOIc")).resolve(id));
}
module.exports = $8995b778360a2533$var$load;

});


parcelRegister("ljuBJ", function(module, exports) {

var $bOmn0 = parcelRequire("bOmn0");
module.exports = $bOmn0("9uSQe").then(()=>parcelRequire("ePczV"));

});

parcelRegister("a2zud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01e2ede7bb5203b5$export$2e2bcd8739ae039; });
const $01e2ede7bb5203b5$var$config = {
    ReadableStream: globalThis.ReadableStream,
    WritableStream: globalThis.WritableStream,
    TransformStream: globalThis.TransformStream,
    DOMException: globalThis.DOMException,
    Blob: globalThis.Blob,
    File: globalThis.File
};
var $01e2ede7bb5203b5$export$2e2bcd8739ae039 = $01e2ede7bb5203b5$var$config;

});

parcelRegister("7LdLi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemDirectoryHandle", function () { return $5a679901fcc25329$export$80c69d2381792bb3; });
$parcel$export(module.exports, "default", function () { return $5a679901fcc25329$export$2e2bcd8739ae039; });

var $9QfhF = parcelRequire("9QfhF");

var $cFLn4 = parcelRequire("cFLn4");
const { GONE: $5a679901fcc25329$var$GONE, MOD_ERR: $5a679901fcc25329$var$MOD_ERR } = (0, $cFLn4.errors);
const $5a679901fcc25329$var$kAdapter = Symbol("adapter");



class $5a679901fcc25329$export$80c69d2381792bb3 extends (0, $9QfhF.default) {
    /** @type {FileSystemDirectoryHandle} */ [$5a679901fcc25329$var$kAdapter];
    constructor(adapter){
        super(adapter);
        this[$5a679901fcc25329$var$kAdapter] = adapter;
    }
    /**
   * @param {string} name Name of the directory
   * @param {object} [options]
   * @param {boolean} [options.create] create the directory if don't exist
   * @returns {Promise<FileSystemDirectoryHandle>}
   */ async getDirectoryHandle(name, options = {}) {
        if (name === "") throw new TypeError(`Name can't be an empty string.`);
        if (name === "." || name === ".." || name.includes("/")) throw new TypeError(`Name contains invalid characters.`);
        options.create = !!options.create;
        const handle = await this[$5a679901fcc25329$var$kAdapter].getDirectoryHandle(name, options);
        return new $5a679901fcc25329$export$80c69d2381792bb3(handle);
    }
    /** @returns {AsyncGenerator<[string, FileSystemHandle | FileSystemDirectoryHandle]>} */ async *entries() {
        const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
        for await (const [_, entry] of this[$5a679901fcc25329$var$kAdapter].entries())yield [
            entry.name,
            entry.kind === "file" ? new FileSystemFileHandle(entry) : new $5a679901fcc25329$export$80c69d2381792bb3(entry)
        ];
    }
    /** @deprecated use .entries() instead */ async *getEntries() {
        const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
        console.warn("deprecated, use .entries() instead");
        for await (let entry of this[$5a679901fcc25329$var$kAdapter].entries())yield entry.kind === "file" ? new FileSystemFileHandle(entry) : new $5a679901fcc25329$export$80c69d2381792bb3(entry);
    }
    /**
   * @param {string} name Name of the file
   * @param {object} [options]
   * @param {boolean} [options.create] create the file if don't exist
   */ async getFileHandle(name, options = {}) {
        const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
        if (name === "") throw new TypeError(`Name can't be an empty string.`);
        if (name === "." || name === ".." || name.includes("/")) throw new TypeError(`Name contains invalid characters.`);
        options.create = !!options.create;
        const handle = await this[$5a679901fcc25329$var$kAdapter].getFileHandle(name, options);
        return new FileSystemFileHandle(handle);
    }
    /**
   * @param {string} name
   * @param {object} [options]
   * @param {boolean} [options.recursive]
   */ async removeEntry(name, options = {}) {
        if (name === "") throw new TypeError(`Name can't be an empty string.`);
        if (name === "." || name === ".." || name.includes("/")) throw new TypeError(`Name contains invalid characters.`);
        options.recursive = !!options.recursive // cuz node's fs.rm require boolean
        ;
        return this[$5a679901fcc25329$var$kAdapter].removeEntry(name, options);
    }
    async resolve(possibleDescendant) {
        if (await possibleDescendant.isSameEntry(this)) return [];
        const openSet = [
            {
                handle: this,
                path: []
            }
        ];
        while(openSet.length){
            let { handle: current, path: path } = openSet.pop();
            for await (const entry of current.values()){
                if (await entry.isSameEntry(possibleDescendant)) return [
                    ...path,
                    entry.name
                ];
                if (entry.kind === "directory") openSet.push({
                    handle: entry,
                    path: [
                        ...path,
                        entry.name
                    ]
                });
            }
        }
        return null;
    }
    async *keys() {
        for await (const [name] of this[$5a679901fcc25329$var$kAdapter].entries())yield name;
    }
    async *values() {
        for await (const [_, entry] of this)yield entry;
    }
    [Symbol.asyncIterator]() {
        return this.entries();
    }
}
Object.defineProperty($5a679901fcc25329$export$80c69d2381792bb3.prototype, Symbol.toStringTag, {
    value: "FileSystemDirectoryHandle",
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($5a679901fcc25329$export$80c69d2381792bb3.prototype, {
    getDirectoryHandle: {
        enumerable: true
    },
    entries: {
        enumerable: true
    },
    getFileHandle: {
        enumerable: true
    },
    removeEntry: {
        enumerable: true
    }
});
if (globalThis.FileSystemDirectoryHandle) {
    const proto = globalThis.FileSystemDirectoryHandle.prototype;
    proto.resolve = async function resolve(possibleDescendant) {
        if (await possibleDescendant.isSameEntry(this)) return [];
        const openSet = [
            {
                handle: this,
                path: []
            }
        ];
        while(openSet.length){
            let { handle: current, path: path } = openSet.pop();
            for await (const entry of current.values()){
                if (await entry.isSameEntry(possibleDescendant)) return [
                    ...path,
                    entry.name
                ];
                if (entry.kind === "directory") openSet.push({
                    handle: entry,
                    path: [
                        ...path,
                        entry.name
                    ]
                });
            }
        }
        return null;
    };
    // Safari allows us operate on deleted files,
    // so we need to check if they still exist.
    // Hope to remove this one day.
    async function ensureDoActuallyStillExist(handle) {
        const root = await navigator.storage.getDirectory();
        const path = await root.resolve(handle);
        if (path === null) throw new DOMException(...$5a679901fcc25329$var$GONE);
    }
    const entries = proto.entries;
    proto.entries = async function*() {
        await ensureDoActuallyStillExist(this);
        yield* entries.call(this);
    };
    proto[Symbol.asyncIterator] = async function*() {
        yield* this.entries();
    };
    const removeEntry = proto.removeEntry;
    proto.removeEntry = async function(name, options = {}) {
        return removeEntry.call(this, name, options).catch(async (err)=>{
            const unknown = err instanceof DOMException && err.name === "UnknownError";
            if (unknown && !options.recursive) {
                const empty = (await entries.call(this).next()).done;
                if (!empty) throw new DOMException(...$5a679901fcc25329$var$MOD_ERR);
            }
            throw err;
        });
    };
}
var $5a679901fcc25329$export$2e2bcd8739ae039 = $5a679901fcc25329$export$80c69d2381792bb3;

});
parcelRegister("9QfhF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72a4d37afd24250d$export$2e2bcd8739ae039; });
const $72a4d37afd24250d$var$kAdapter = Symbol("adapter");
/**
 * @typedef {Object} FileSystemHandlePermissionDescriptor
 * @property {('read'|'readwrite')} [mode='read']
 */ class $72a4d37afd24250d$export$90d155f9f7c2d644 {
    /** @type {FileSystemHandle} */ [$72a4d37afd24250d$var$kAdapter];
    /** @type {string} */ name;
    /** @type {('file'|'directory')} */ kind;
    /** @param {FileSystemHandle & {writable}} adapter */ constructor(adapter){
        this.kind = adapter.kind;
        this.name = adapter.name;
        this[$72a4d37afd24250d$var$kAdapter] = adapter;
    }
    /** @param {FileSystemHandlePermissionDescriptor} descriptor */ async queryPermission(descriptor = {}) {
        const { mode: mode = "read" } = descriptor;
        const handle = this[$72a4d37afd24250d$var$kAdapter];
        if (handle.queryPermission) return handle.queryPermission({
            mode: mode
        });
        if (mode === "read") return "granted";
        else if (mode === "readwrite") return handle.writable ? "granted" : "denied";
        else throw new TypeError(`Mode ${mode} must be 'read' or 'readwrite'`);
    }
    async requestPermission({ mode: mode = "read" } = {}) {
        const handle = this[$72a4d37afd24250d$var$kAdapter];
        if (handle.requestPermission) return handle.requestPermission({
            mode: mode
        });
        if (mode === "read") return "granted";
        else if (mode === "readwrite") return handle.writable ? "granted" : "denied";
        else throw new TypeError(`Mode ${mode} must be 'read' or 'readwrite'`);
    }
    /**
   * Attempts to remove the entry represented by handle from the underlying file system.
   *
   * @param {object} options
   * @param {boolean} [options.recursive=false]
   */ async remove(options = {}) {
        await this[$72a4d37afd24250d$var$kAdapter].remove(options);
    }
    /**
   * @param {FileSystemHandle} other
   */ async isSameEntry(other) {
        if (this === other) return true;
        if (!other || typeof other !== "object" || this.kind !== other.kind || !other[$72a4d37afd24250d$var$kAdapter]) return false;
        return this[$72a4d37afd24250d$var$kAdapter].isSameEntry(other[$72a4d37afd24250d$var$kAdapter]);
    }
}
Object.defineProperty($72a4d37afd24250d$export$90d155f9f7c2d644.prototype, Symbol.toStringTag, {
    value: "FileSystemHandle",
    writable: false,
    enumerable: false,
    configurable: true
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemHandle) globalThis.FileSystemHandle.prototype.queryPermission ??= function(descriptor) {
    return "granted";
};
var $72a4d37afd24250d$export$2e2bcd8739ae039 = $72a4d37afd24250d$export$90d155f9f7c2d644;

});

parcelRegister("cFLn4", function(module, exports) {

$parcel$export(module.exports, "errors", function () { return $939e0f49c4a3b174$export$30f3b02011db23c0; });
$parcel$export(module.exports, "config", function () { return $939e0f49c4a3b174$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "fromDataTransfer", function () { return $939e0f49c4a3b174$export$34af8373a76882c2; });
$parcel$export(module.exports, "getDirHandlesFromInput", function () { return $939e0f49c4a3b174$export$7d17e35d81e093f2; });
$parcel$export(module.exports, "getFileHandlesFromInput", function () { return $939e0f49c4a3b174$export$45ac616e835cfe89; });
const $939e0f49c4a3b174$export$30f3b02011db23c0 = {
    INVALID: [
        "seeking position failed.",
        "InvalidStateError"
    ],
    GONE: [
        "A requested file or directory could not be found at the time an operation was processed.",
        "NotFoundError"
    ],
    MISMATCH: [
        "The path supplied exists, but was not an entry of requested type.",
        "TypeMismatchError"
    ],
    MOD_ERR: [
        "The object can not be modified in this way.",
        "InvalidModificationError"
    ],
    SYNTAX: (m)=>[
            `Failed to execute 'write' on 'UnderlyingSinkBase': Invalid params passed. ${m}`,
            "SyntaxError"
        ],
    SECURITY: [
        "It was determined that certain files are unsafe for access within a Web application, or that too many calls are being made on file resources.",
        "SecurityError"
    ],
    DISALLOWED: [
        "The request is not allowed by the user agent or the platform in the current context.",
        "NotAllowedError"
    ]
};
const $939e0f49c4a3b174$export$e506a1d27d1eaa20 = {
    writable: globalThis.WritableStream
};



async function $939e0f49c4a3b174$export$34af8373a76882c2(entries) {
    console.warn("deprecated fromDataTransfer - use `dt.items[0].getAsFileSystemHandle()` instead");
    const [memory, sandbox, fs] = await Promise.all([
        (parcelRequire("fNAYE")),
        (parcelRequire("ljuBJ")),
        Promise.resolve((parcelRequire("7LdLi")))
    ]);
    const folder = new memory.FolderHandle("", false);
    folder._entries = entries.map((entry)=>entry.isFile ? new sandbox.FileHandle(entry, false) : new sandbox.FolderHandle(entry, false));
    return new fs.FileSystemDirectoryHandle(folder);
}


async function $939e0f49c4a3b174$export$7d17e35d81e093f2(input) {
    const { FolderHandle: FolderHandle, FileHandle: FileHandle } = await (parcelRequire("fNAYE"));
    const { FileSystemDirectoryHandle: FileSystemDirectoryHandle } = await Promise.resolve((parcelRequire("7LdLi")));
    const files = Array.from(input.files);
    const rootName = files[0].webkitRelativePath.split("/", 1)[0];
    const root = new FolderHandle(rootName, false);
    files.forEach((file)=>{
        const path = file.webkitRelativePath.split("/");
        path.shift();
        const name = path.pop();
        const dir = path.reduce((dir, path)=>{
            if (!dir._entries[path]) dir._entries[path] = new FolderHandle(path, false);
            return dir._entries[path];
        }, root);
        dir._entries[name] = new FileHandle(file.name, file, false);
    });
    return new FileSystemDirectoryHandle(root);
}


async function $939e0f49c4a3b174$export$45ac616e835cfe89(input) {
    const { FileHandle: FileHandle } = await (parcelRequire("fNAYE"));
    const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
    return Array.from(input.files).map((file)=>new FileSystemFileHandle(new FileHandle(file.name, file, false)));
}

});
parcelRegister("fNAYE", function(module, exports) {

var $bOmn0 = parcelRequire("bOmn0");
module.exports = $bOmn0("6uZq5").then(()=>parcelRequire("eIbxT"));

});

parcelRegister("dPisW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemFileHandle", function () { return $a10e5cb78d2beb74$export$db2751aad7d8e0f3; });
$parcel$export(module.exports, "default", function () { return $a10e5cb78d2beb74$export$2e2bcd8739ae039; });

var $9QfhF = parcelRequire("9QfhF");

var $1A4EY = parcelRequire("1A4EY");

var $cFLn4 = parcelRequire("cFLn4");
const { INVALID: $a10e5cb78d2beb74$var$INVALID, SYNTAX: $a10e5cb78d2beb74$var$SYNTAX, GONE: $a10e5cb78d2beb74$var$GONE } = (0, $cFLn4.errors);
const $a10e5cb78d2beb74$var$kAdapter = Symbol("adapter");
class $a10e5cb78d2beb74$export$db2751aad7d8e0f3 extends (0, $9QfhF.default) {
    /** @type {FileSystemFileHandle} */ [$a10e5cb78d2beb74$var$kAdapter];
    constructor(adapter){
        super(adapter);
        this[$a10e5cb78d2beb74$var$kAdapter] = adapter;
    }
    /**
   * @param  {Object} [options={}]
   * @param  {boolean} [options.keepExistingData]
   * @returns {Promise<FileSystemWritableFileStream>}
   */ async createWritable(options = {}) {
        return new (0, $1A4EY.default)(await this[$a10e5cb78d2beb74$var$kAdapter].createWritable(options));
    }
    /**
   * @returns {Promise<File>}
   */ async getFile() {
        return this[$a10e5cb78d2beb74$var$kAdapter].getFile();
    }
}
Object.defineProperty($a10e5cb78d2beb74$export$db2751aad7d8e0f3.prototype, Symbol.toStringTag, {
    value: "FileSystemFileHandle",
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($a10e5cb78d2beb74$export$db2751aad7d8e0f3.prototype, {
    createWritable: {
        enumerable: true
    },
    getFile: {
        enumerable: true
    }
});
// Safari doesn't support async createWritable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable) {
    const wm = new WeakMap();
    let workerUrl;
    // Worker code that should be inlined (can't use any external functions)
    const code = ()=>{
        let fileHandle, handle;
        onmessage = async (evt)=>{
            const port = evt.ports[0];
            const cmd = evt.data;
            switch(cmd.type){
                case "open":
                    const file = cmd.name;
                    let dir = await navigator.storage.getDirectory();
                    for (const folder of cmd.path)dir = await dir.getDirectoryHandle(folder);
                    fileHandle = await dir.getFileHandle(file);
                    handle = await fileHandle.createSyncAccessHandle();
                    break;
                case "write":
                    handle.write(cmd.data, {
                        at: cmd.position
                    });
                    handle.flush();
                    break;
                case "truncate":
                    handle.truncate(cmd.size);
                    break;
                case "abort":
                case "close":
                    handle.close();
                    break;
            }
            port.postMessage(0);
        };
    };
    globalThis.FileSystemFileHandle.prototype.createWritable = async function(options) {
        // Safari only support writing data in a worker with sync access handle.
        if (!workerUrl) {
            const stringCode = `(${code.toString()})()`;
            const blob = new Blob([
                stringCode
            ], {
                type: "text/javascript"
            });
            workerUrl = URL.createObjectURL(blob);
        }
        const worker = new Worker(workerUrl, {
            type: "module"
        });
        let position = 0;
        const textEncoder = new TextEncoder();
        let size = await this.getFile().then((file)=>file.size);
        const send = (message)=>new Promise((resolve, reject)=>{
                const mc = new MessageChannel();
                mc.port1.onmessage = (evt)=>{
                    if (evt.data instanceof Error) reject(evt.data);
                    else resolve(evt.data);
                    mc.port1.close();
                    mc.port2.close();
                    mc.port1.onmessage = null;
                };
                worker.postMessage(message, [
                    mc.port2
                ]);
            });
        // Safari also don't support transferable file system handles.
        // So we need to pass the path to the worker. This is a bit hacky and ugly.
        const root = await navigator.storage.getDirectory();
        const parent = await wm.get(this);
        const path = await root.resolve(parent);
        // Should likely never happen, but just in case...
        if (path === null) throw new DOMException(...$a10e5cb78d2beb74$var$GONE);
        let controller;
        await send({
            type: "open",
            path: path,
            name: this.name
        });
        if (options?.keepExistingData === false) {
            await send({
                type: "truncate",
                size: 0
            });
            size = 0;
        }
        const ws = new (0, $1A4EY.default)({
            start: (ctrl)=>{
                controller = ctrl;
            },
            async write (chunk) {
                const isPlainObject = chunk?.constructor === Object;
                if (isPlainObject) chunk = {
                    ...chunk
                };
                else chunk = {
                    type: "write",
                    data: chunk,
                    position: position
                };
                if (chunk.type === "write") {
                    if (!("data" in chunk)) {
                        await send({
                            type: "close"
                        });
                        throw new DOMException(...$a10e5cb78d2beb74$var$SYNTAX("write requires a data argument"));
                    }
                    chunk.position ??= position;
                    if (typeof chunk.data === "string") chunk.data = textEncoder.encode(chunk.data);
                    else if (chunk.data instanceof ArrayBuffer) chunk.data = new Uint8Array(chunk.data);
                    else if (!(chunk.data instanceof Uint8Array) && ArrayBuffer.isView(chunk.data)) chunk.data = new Uint8Array(chunk.data.buffer, chunk.data.byteOffset, chunk.data.byteLength);
                    else if (!(chunk.data instanceof Uint8Array)) {
                        const ab = await new Response(chunk.data).arrayBuffer();
                        chunk.data = new Uint8Array(ab);
                    }
                    if (Number.isInteger(chunk.position) && chunk.position >= 0) position = chunk.position;
                    position += chunk.data.byteLength;
                    size += chunk.data.byteLength;
                } else if (chunk.type === "seek") {
                    if (Number.isInteger(chunk.position) && chunk.position >= 0) {
                        if (size < chunk.position) throw new DOMException(...$a10e5cb78d2beb74$var$INVALID);
                        console.log("seeking", chunk);
                        position = chunk.position;
                        return; // Don't need to enqueue seek...
                    } else {
                        await send({
                            type: "close"
                        });
                        throw new DOMException(...$a10e5cb78d2beb74$var$SYNTAX("seek requires a position argument"));
                    }
                } else if (chunk.type === "truncate") {
                    if (Number.isInteger(chunk.size) && chunk.size >= 0) {
                        size = chunk.size;
                        if (position > size) position = size;
                    } else {
                        await send({
                            type: "close"
                        });
                        throw new DOMException(...$a10e5cb78d2beb74$var$SYNTAX("truncate requires a size argument"));
                    }
                }
                await send(chunk);
            },
            async close () {
                await send({
                    type: "close"
                });
                worker.terminate();
            },
            async abort (reason) {
                await send({
                    type: "abort",
                    reason: reason
                });
                worker.terminate();
            }
        });
        return ws;
    };
    const orig = FileSystemDirectoryHandle.prototype.getFileHandle;
    FileSystemDirectoryHandle.prototype.getFileHandle = async function(...args) {
        const handle = await orig.call(this, ...args);
        wm.set(handle, this);
        return handle;
    };
}
var $a10e5cb78d2beb74$export$2e2bcd8739ae039 = $a10e5cb78d2beb74$export$db2751aad7d8e0f3;

});
parcelRegister("1A4EY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $126cc49748d7ef7c$export$2e2bcd8739ae039; });

var $a2zud = parcelRequire("a2zud");
const { WritableStream: $126cc49748d7ef7c$var$WritableStream } = (0, $a2zud.default);
class $126cc49748d7ef7c$export$fea83bdfcd3f94c extends $126cc49748d7ef7c$var$WritableStream {
    #writer;
    constructor(writer){
        super(writer);
        this.#writer = writer;
        // Stupid Safari hack to extend native classes
        // https://bugs.webkit.org/show_bug.cgi?id=226201
        Object.setPrototypeOf(this, $126cc49748d7ef7c$export$fea83bdfcd3f94c.prototype);
        /** @private */ this._closed = false;
    }
    async close() {
        this._closed = true;
        const w = this.getWriter();
        const p = w.close();
        w.releaseLock();
        return p;
    // return super.close ? super.close() : this.getWriter().close()
    }
    /** @param {number} position */ seek(position) {
        return this.write({
            type: "seek",
            position: position
        });
    }
    /** @param {number} size */ truncate(size) {
        return this.write({
            type: "truncate",
            size: size
        });
    }
    // The write(data) method steps are:
    write(data) {
        if (this._closed) return Promise.reject(new TypeError("Cannot write to a CLOSED writable stream"));
        // 1. Let writer be the result of getting a writer for this.
        const writer = this.getWriter();
        // 2. Let result be the result of writing a chunk to writer given data.
        const result = writer.write(data);
        // 3. Release writer.
        writer.releaseLock();
        // 4. Return result.
        return result;
    }
}
Object.defineProperty($126cc49748d7ef7c$export$fea83bdfcd3f94c.prototype, Symbol.toStringTag, {
    value: "FileSystemWritableFileStream",
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($126cc49748d7ef7c$export$fea83bdfcd3f94c.prototype, {
    close: {
        enumerable: true
    },
    seek: {
        enumerable: true
    },
    truncate: {
        enumerable: true
    },
    write: {
        enumerable: true
    }
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable && !globalThis.FileSystemWritableFileStream) globalThis.FileSystemWritableFileStream = $126cc49748d7ef7c$export$fea83bdfcd3f94c;
var $126cc49748d7ef7c$export$2e2bcd8739ae039 = $126cc49748d7ef7c$export$fea83bdfcd3f94c;

});




var $237889e76c767d38$exports = {};
"use strict";

$237889e76c767d38$exports = (parcelRequire("7tvZy"));


var $de9addb89ca41b61$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $de9addb89ca41b61$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $de9addb89ca41b61$var$InstrumentedPromise$1)) throw new TypeError("Cannot call a class as a function");
    var promise = new $de9addb89ca41b61$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $de9addb89ca41b61$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $de9addb89ca41b61$var$InstrumentedPromise$1.prototype;
    return promise;
};
$de9addb89ca41b61$var$InstrumentedPromise$1.__proto__ = $de9addb89ca41b61$var$OriginalPromise;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.__proto__ = $de9addb89ca41b61$var$OriginalPromise.prototype;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $de9addb89ca41b61$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent("Event");
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent("unhandledrejection", false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $de9addb89ca41b61$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === "undefined";
}
function $de9addb89ca41b61$export$cea1c58a6db52bca() {
    Promise = $de9addb89ca41b61$var$InstrumentedPromise$1;
}
function $de9addb89ca41b61$export$dfb5619354ba860() {
    if ($de9addb89ca41b61$export$baf72085f5fb4df()) $de9addb89ca41b61$export$cea1c58a6db52bca();
}
var $de9addb89ca41b61$export$2e2bcd8739ae039 = $de9addb89ca41b61$var$InstrumentedPromise$1;



var $kAoxL = parcelRequire("kAoxL");
var $1235ee506af21140$export$882461b6382ed46c;
var $1235ee506af21140$export$757ceba2d55c277e;
"use strict";
var $384457d72cc1e1d1$exports = {};
"use strict";
function $384457d72cc1e1d1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($384457d72cc1e1d1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$384457d72cc1e1d1$var$checkDCE();

$384457d72cc1e1d1$exports = (parcelRequire("3Baf1"));


var $1235ee506af21140$var$i;
$1235ee506af21140$export$882461b6382ed46c = $384457d72cc1e1d1$exports.createRoot;
$1235ee506af21140$export$757ceba2d55c277e = $384457d72cc1e1d1$exports.hydrateRoot;


function $a1a155eb9166d0df$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $a1a155eb9166d0df$var$$9b05bcda60cc529c$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $a1a155eb9166d0df$export$61cc6ed0f143570b;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $a1a155eb9166d0df$export$dd1bc94b04021eeb;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $a1a155eb9166d0df$export$a09f818797e212c4;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $a1a155eb9166d0df$export$170f4e08cad8229d;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $a1a155eb9166d0df$export$2a489b3f92f4996a;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $a1a155eb9166d0df$export$67a6ce548ae77071;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $a1a155eb9166d0df$export$a48f0734ac7c2329;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $a1a155eb9166d0df$export$3f34ca2fef821bbd;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $a1a155eb9166d0df$export$86f54f62aa7a7514;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $a1a155eb9166d0df$export$89912e019eef22aa;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $a1a155eb9166d0df$export$1c8ba402144543e5;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $a1a155eb9166d0df$export$2ddabb89308e1a22;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $a1a155eb9166d0df$export$14527669107aa301;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $a1a155eb9166d0df$export$3f063810d7bf01bd;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $a1a155eb9166d0df$export$b5a4d6f439a5044d;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $a1a155eb9166d0df$export$b119cc7e1840e59c;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $a1a155eb9166d0df$export$7b85fd78dd236198;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $a1a155eb9166d0df$export$697c3df919c0e61a;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $a1a155eb9166d0df$export$e6b5ff3168b5942b;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $a1a155eb9166d0df$export$1d012a0dff3dab06;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $a1a155eb9166d0df$export$69a3209f1a06c04d;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $a1a155eb9166d0df$export$86c18c6347f4a8c4;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $a1a155eb9166d0df$export$dce9414bed0662c;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $a1a155eb9166d0df$export$271f7c16f175f804;
});
var $a1a155eb9166d0df$var$$6a9944941b4c1893$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "sum", function() {
    return $a1a155eb9166d0df$export$8a63f25cc62965f1;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $a1a155eb9166d0df$export$e1f36757ecda301d;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $a1a155eb9166d0df$export$8e694e1eafd55acb;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $a1a155eb9166d0df$export$57d7c52a66287430;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $a1a155eb9166d0df$export$2b4693832ca3ce16;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $a1a155eb9166d0df$export$5b784e078da1ce6;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $a1a155eb9166d0df$export$17ec9c9f4f23588c;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $a1a155eb9166d0df$export$595dbf49c602a1f;
});
function $a1a155eb9166d0df$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $a1a155eb9166d0df$export$e1f36757ecda301d(...data) {
    return $a1a155eb9166d0df$export$8a63f25cc62965f1(...data) / data.length;
}
function $a1a155eb9166d0df$export$8e694e1eafd55acb(data, sample = false) {
    const average = $a1a155eb9166d0df$export$e1f36757ecda301d(...data);
    const summary = $a1a155eb9166d0df$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $a1a155eb9166d0df$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($a1a155eb9166d0df$export$8e694e1eafd55acb(data, sample));
}
function $a1a155eb9166d0df$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($a1a155eb9166d0df$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $a1a155eb9166d0df$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $a1a155eb9166d0df$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $a1a155eb9166d0df$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
class $a1a155eb9166d0df$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
function $a1a155eb9166d0df$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $a1a155eb9166d0df$export$dd1bc94b04021eeb(value) {
    return $a1a155eb9166d0df$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $a1a155eb9166d0df$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $a1a155eb9166d0df$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $a1a155eb9166d0df$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $a1a155eb9166d0df$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $a1a155eb9166d0df$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $a1a155eb9166d0df$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $a1a155eb9166d0df$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $a1a155eb9166d0df$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $a1a155eb9166d0df$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $a1a155eb9166d0df$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($a1a155eb9166d0df$export$2ddabb89308e1a22 || ($a1a155eb9166d0df$export$2ddabb89308e1a22 = {}));
function $a1a155eb9166d0df$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $a1a155eb9166d0df$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $a1a155eb9166d0df$export$b5a4d6f439a5044d(data) {
    if ($a1a155eb9166d0df$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $a1a155eb9166d0df$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $a1a155eb9166d0df$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($a1a155eb9166d0df$export$61cc6ed0f143570b(data)) return [];
    if ($a1a155eb9166d0df$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $a1a155eb9166d0df$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $a1a155eb9166d0df$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $a1a155eb9166d0df$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $a1a155eb9166d0df$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $a1a155eb9166d0df$export$1d012a0dff3dab06(list, iteratee) {
    const group = $a1a155eb9166d0df$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $a1a155eb9166d0df$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $a1a155eb9166d0df$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol("done"), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $a1a155eb9166d0df$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $a1a155eb9166d0df$export$271f7c16f175f804 extends $a1a155eb9166d0df$export$595dbf49c602a1f {
    constructor(...args){
        super(...args);
        this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + "B"
            }));
    }
}
var $a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $a1a155eb9166d0df$export$c489aa6f7fd82b1a;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $a1a155eb9166d0df$export$cbd942915f33be50;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $a1a155eb9166d0df$export$9b886f8493244014;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $a1a155eb9166d0df$export$e99cbb807a5bb10d;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $a1a155eb9166d0df$export$7a9a31a911eb9a20;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $a1a155eb9166d0df$export$fca4f8121099df57;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $a1a155eb9166d0df$export$6ce2f08d515512;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $a1a155eb9166d0df$export$951c8378cdfec6e6;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $a1a155eb9166d0df$export$1a4097b876a13bf7;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $a1a155eb9166d0df$export$d9bcbd5e1ff81430;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $a1a155eb9166d0df$export$506c8e8f8c8edda;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $a1a155eb9166d0df$export$3ae94a2503e890a1;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $a1a155eb9166d0df$export$62ad822b3a5fd9a0;
});
const $a1a155eb9166d0df$export$c489aa6f7fd82b1a = 1000;
const $a1a155eb9166d0df$export$cbd942915f33be50 = $a1a155eb9166d0df$export$c489aa6f7fd82b1a * 60;
const $a1a155eb9166d0df$export$9b886f8493244014 = $a1a155eb9166d0df$export$cbd942915f33be50 * 15;
const $a1a155eb9166d0df$export$e99cbb807a5bb10d = $a1a155eb9166d0df$export$9b886f8493244014 * 4;
const $a1a155eb9166d0df$export$7a9a31a911eb9a20 = $a1a155eb9166d0df$export$e99cbb807a5bb10d * 24;
const $a1a155eb9166d0df$export$fca4f8121099df57 = $a1a155eb9166d0df$export$7a9a31a911eb9a20 * 7;
const $a1a155eb9166d0df$export$6ce2f08d515512 = $a1a155eb9166d0df$export$7a9a31a911eb9a20 * 365;
const $a1a155eb9166d0df$export$951c8378cdfec6e6 = $a1a155eb9166d0df$export$6ce2f08d515512 / 12;
const $a1a155eb9166d0df$export$1a4097b876a13bf7 = $a1a155eb9166d0df$export$951c8378cdfec6e6 * 3;
class $a1a155eb9166d0df$export$d9bcbd5e1ff81430 extends $a1a155eb9166d0df$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args);
        this.units = [
            {
                base: $a1a155eb9166d0df$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $a1a155eb9166d0df$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $a1a155eb9166d0df$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $a1a155eb9166d0df$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $a1a155eb9166d0df$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $a1a155eb9166d0df$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $a1a155eb9166d0df$export$6ce2f08d515512,
                name: "Y"
            }
        ];
    }
}
function $a1a155eb9166d0df$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $a1a155eb9166d0df$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $a1a155eb9166d0df$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $a1a155eb9166d0df$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $a1a155eb9166d0df$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $a1a155eb9166d0df$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $a1a155eb9166d0df$var$$ba0e5dc395660a7c$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $a1a155eb9166d0df$export$27924e57e9afff7f;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $a1a155eb9166d0df$export$7ea17d45ecdcf634;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $a1a155eb9166d0df$export$bb8626e4916f587b;
});
function $a1a155eb9166d0df$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || $a1a155eb9166d0df$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $a1a155eb9166d0df$export$7ea17d45ecdcf634(raw) {
    const parsed = $a1a155eb9166d0df$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $a1a155eb9166d0df$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $a1a155eb9166d0df$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $a1a155eb9166d0df$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($a1a155eb9166d0df$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}
var $a1a155eb9166d0df$var$$083124ac4b1a50a0$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $a1a155eb9166d0df$export$71e6483fc2b024eb;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $a1a155eb9166d0df$export$eb9b2aadbe449a20;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $a1a155eb9166d0df$export$13397a83aa5915d6;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $a1a155eb9166d0df$export$fd89523fba250fa4;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $a1a155eb9166d0df$export$504fbde693c1771c;
});
function $a1a155eb9166d0df$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $a1a155eb9166d0df$export$eb9b2aadbe449a20(raw = window.location.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($a1a155eb9166d0df$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $a1a155eb9166d0df$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : $a1a155eb9166d0df$export$b5a4d6f439a5044d(value) ? $a1a155eb9166d0df$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
function $a1a155eb9166d0df$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$a1a155eb9166d0df$export$dd1bc94b04021eeb(value) && [
            key,
            $a1a155eb9166d0df$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $a1a155eb9166d0df$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $a1a155eb9166d0df$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $a1a155eb9166d0df$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $a1a155eb9166d0df$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $a1a155eb9166d0df$var$$50872bf213056663$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $a1a155eb9166d0df$export$1b9ac4d3de3ffd2e;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$50872bf213056663$exports, "makeSHA", function() {
    return $a1a155eb9166d0df$export$d51f3b55e8d1aa73;
});
const $a1a155eb9166d0df$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $a1a155eb9166d0df$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $a1a155eb9166d0df$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) crypto1.subtle = crypto1["webkitSubtle"];
}
async function $a1a155eb9166d0df$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
var $a1a155eb9166d0df$var$$93a3089d2937b23f$exports = {};
var $a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $a1a155eb9166d0df$export$2ee022bbbc550b25;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $a1a155eb9166d0df$export$a549dd5cef7f8327;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $a1a155eb9166d0df$export$8eece510bcb9c62c;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $a1a155eb9166d0df$export$b8a1af58c024fefd;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $a1a155eb9166d0df$export$a2cf0d4bb6e06de4;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $a1a155eb9166d0df$export$d66b332881d9723f;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $a1a155eb9166d0df$export$b0709844452f8b6b;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $a1a155eb9166d0df$export$5118471ee5d5453b;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $a1a155eb9166d0df$export$be4650432daa84fd;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $a1a155eb9166d0df$export$578e38b4a3e0b255;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $a1a155eb9166d0df$export$7cd14c57bbb84350;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $a1a155eb9166d0df$export$5100419dfae0456d;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $a1a155eb9166d0df$export$28d9d24a8cd0ffc2;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $a1a155eb9166d0df$export$3f99968195accfaf;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $a1a155eb9166d0df$export$eafdbaa868ea9975;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $a1a155eb9166d0df$export$36a0c1ca2ae264fa;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $a1a155eb9166d0df$export$86d7c59254d6a2c9;
});
const $a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$templateMap = {};
function $a1a155eb9166d0df$export$2ee022bbbc550b25(tagName) {
    if ($a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $a1a155eb9166d0df$export$a549dd5cef7f8327(tagName) {
    const node = $a1a155eb9166d0df$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $a1a155eb9166d0df$export$8eece510bcb9c62c(Class) {
    return $a1a155eb9166d0df$export$170f4e08cad8229d(Class, HTMLElement);
}
const $a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $a1a155eb9166d0df$export$b8a1af58c024fefd(Class) {
    const name = $a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $a1a155eb9166d0df$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $a1a155eb9166d0df$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $a1a155eb9166d0df$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $a1a155eb9166d0df$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $a1a155eb9166d0df$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $a1a155eb9166d0df$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($a1a155eb9166d0df$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $a1a155eb9166d0df$export$5118471ee5d5453b(node, type);
}
function $a1a155eb9166d0df$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $a1a155eb9166d0df$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $a1a155eb9166d0df$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $a1a155eb9166d0df$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $a1a155eb9166d0df$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${$a1a155eb9166d0df$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$a1a155eb9166d0df$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $a1a155eb9166d0df$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $a1a155eb9166d0df$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $a1a155eb9166d0df$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $a1a155eb9166d0df$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $a1a155eb9166d0df$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $a1a155eb9166d0df$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { type: type, name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? $a1a155eb9166d0df$export$7ea17d45ecdcf634(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$a1a155eb9166d0df$export$7ea17d45ecdcf634(value));
                break;
            case "fieldset":
                parsedValue = $a1a155eb9166d0df$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = $a1a155eb9166d0df$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$a1a155eb9166d0df$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $a1a155eb9166d0df$var$$bb23e0c794fefbef$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $a1a155eb9166d0df$export$e772c8ff12451969;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $a1a155eb9166d0df$export$57207d71b8c929c8;
});
function $a1a155eb9166d0df$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $a1a155eb9166d0df$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $a1a155eb9166d0df$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $a1a155eb9166d0df$var$$19ed8aeb7905a045$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $a1a155eb9166d0df$export$10b1921597150314;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $a1a155eb9166d0df$export$3e2b244719956741;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $a1a155eb9166d0df$export$1d1d2ed6b55cf67f;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $a1a155eb9166d0df$export$2155c0b5a4b77fb8;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $a1a155eb9166d0df$export$9d97473344489dfc;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $a1a155eb9166d0df$export$d635d04af3887bbe;
});
function $a1a155eb9166d0df$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $a1a155eb9166d0df$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $a1a155eb9166d0df$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $a1a155eb9166d0df$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $a1a155eb9166d0df$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $a1a155eb9166d0df$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $a1a155eb9166d0df$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $a1a155eb9166d0df$var$$7a08303ce13c49c5$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $a1a155eb9166d0df$export$1b88f6b6d432a52a;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $a1a155eb9166d0df$export$b70f6380221b1350;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $a1a155eb9166d0df$export$75d6cbe4503e149;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $a1a155eb9166d0df$export$b2618d51188815c2;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $a1a155eb9166d0df$export$490814474ddbb428;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $a1a155eb9166d0df$export$3ea201dffb50dfef;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $a1a155eb9166d0df$export$d1012c7198c6b460;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $a1a155eb9166d0df$export$a35a418b7b17958e;
});
class $a1a155eb9166d0df$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $a1a155eb9166d0df$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $a1a155eb9166d0df$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $a1a155eb9166d0df$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $a1a155eb9166d0df$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $a1a155eb9166d0df$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $a1a155eb9166d0df$export$75d6cbe4503e149(type, element)))
    ]);
}
function $a1a155eb9166d0df$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $a1a155eb9166d0df$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $a1a155eb9166d0df$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $a1a155eb9166d0df$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $a1a155eb9166d0df$export$490814474ddbb428(element, className, display = "block") {
    return $a1a155eb9166d0df$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $a1a155eb9166d0df$export$3ea201dffb50dfef(element, className, display = "block") {
    return $a1a155eb9166d0df$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $a1a155eb9166d0df$export$d1012c7198c6b460(element, className, remove) {
    return $a1a155eb9166d0df$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $a1a155eb9166d0df$export$a35a418b7b17958e(element, className, remove) {
    return $a1a155eb9166d0df$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $a1a155eb9166d0df$var$$69bd9f0117925302$exports = {};
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$69bd9f0117925302$exports, "describe", function() {
    return $a1a155eb9166d0df$export$cd5450f3a47e3789;
});
$a1a155eb9166d0df$var$$parcel$export($a1a155eb9166d0df$var$$69bd9f0117925302$exports, "it", function() {
    return $a1a155eb9166d0df$export$3486a10f30cf1ee4;
});
async function $a1a155eb9166d0df$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $a1a155eb9166d0df$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await $a1a155eb9166d0df$export$e772c8ff12451969(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}



/**
 * React Router DOM v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4HBpa = parcelRequire("4HBpa");

/**
 * @remix-run/router v1.19.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $c0e7f593a2d56a40$var$_extends() {
    $c0e7f593a2d56a40$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0e7f593a2d56a40$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $c0e7f593a2d56a40$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c0e7f593a2d56a40$export$e19cd5f9376f8cee || ($c0e7f593a2d56a40$export$e19cd5f9376f8cee = {}));
const $c0e7f593a2d56a40$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $c0e7f593a2d56a40$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $c0e7f593a2d56a40$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $c0e7f593a2d56a40$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $c0e7f593a2d56a40$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c0e7f593a2d56a40$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $c0e7f593a2d56a40$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $c0e7f593a2d56a40$export$fe53371bee54353d(to);
    }
    return $c0e7f593a2d56a40$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c0e7f593a2d56a40$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $c0e7f593a2d56a40$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $c0e7f593a2d56a40$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $c0e7f593a2d56a40$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c0e7f593a2d56a40$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $c0e7f593a2d56a40$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c0e7f593a2d56a40$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c0e7f593a2d56a40$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $c0e7f593a2d56a40$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $c0e7f593a2d56a40$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $c0e7f593a2d56a40$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $c0e7f593a2d56a40$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c0e7f593a2d56a40$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $c0e7f593a2d56a40$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $c0e7f593a2d56a40$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c0e7f593a2d56a40$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($c0e7f593a2d56a40$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Push;
        let location = $c0e7f593a2d56a40$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c0e7f593a2d56a40$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Replace;
        let location = $c0e7f593a2d56a40$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c0e7f593a2d56a40$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $c0e7f593a2d56a40$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $c0e7f593a2d56a40$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($c0e7f593a2d56a40$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($c0e7f593a2d56a40$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $c0e7f593a2d56a40$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($c0e7f593a2d56a40$var$ResultType || ($c0e7f593a2d56a40$var$ResultType = {}));
const $c0e7f593a2d56a40$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c0e7f593a2d56a40$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $c0e7f593a2d56a40$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c0e7f593a2d56a40$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $c0e7f593a2d56a40$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($c0e7f593a2d56a40$var$isIndexRoute(route)) {
            let indexRoute = $c0e7f593a2d56a40$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $c0e7f593a2d56a40$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $c0e7f593a2d56a40$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $c0e7f593a2d56a40$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $c0e7f593a2d56a40$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $c0e7f593a2d56a40$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c0e7f593a2d56a40$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c0e7f593a2d56a40$var$flattenRoutes(routes);
    $c0e7f593a2d56a40$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $c0e7f593a2d56a40$export$30d21fd6d7295f52(pathname);
        matches = $c0e7f593a2d56a40$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $c0e7f593a2d56a40$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $c0e7f593a2d56a40$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $c0e7f593a2d56a40$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c0e7f593a2d56a40$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $c0e7f593a2d56a40$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $c0e7f593a2d56a40$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c0e7f593a2d56a40$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $c0e7f593a2d56a40$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $c0e7f593a2d56a40$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c0e7f593a2d56a40$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c0e7f593a2d56a40$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $c0e7f593a2d56a40$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $c0e7f593a2d56a40$var$paramRe = /^:[\w-]+$/;
const $c0e7f593a2d56a40$var$dynamicSegmentValue = 3;
const $c0e7f593a2d56a40$var$indexRouteValue = 2;
const $c0e7f593a2d56a40$var$emptySegmentValue = 1;
const $c0e7f593a2d56a40$var$staticSegmentValue = 10;
const $c0e7f593a2d56a40$var$splatPenalty = -2;
const $c0e7f593a2d56a40$var$isSplat = (s)=>s === "*";
function $c0e7f593a2d56a40$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c0e7f593a2d56a40$var$isSplat)) initialScore += $c0e7f593a2d56a40$var$splatPenalty;
    if (index) initialScore += $c0e7f593a2d56a40$var$indexRouteValue;
    return segments.filter((s)=>!$c0e7f593a2d56a40$var$isSplat(s)).reduce((score, segment)=>score + ($c0e7f593a2d56a40$var$paramRe.test(segment) ? $c0e7f593a2d56a40$var$dynamicSegmentValue : segment === "" ? $c0e7f593a2d56a40$var$emptySegmentValue : $c0e7f593a2d56a40$var$staticSegmentValue), initialScore);
}
function $c0e7f593a2d56a40$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c0e7f593a2d56a40$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c0e7f593a2d56a40$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $c0e7f593a2d56a40$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c0e7f593a2d56a40$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c0e7f593a2d56a40$export$a5c6d149b50c1d86($c0e7f593a2d56a40$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c0e7f593a2d56a40$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $c0e7f593a2d56a40$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c0e7f593a2d56a40$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $c0e7f593a2d56a40$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $c0e7f593a2d56a40$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $c0e7f593a2d56a40$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c0e7f593a2d56a40$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $c0e7f593a2d56a40$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $c0e7f593a2d56a40$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $c0e7f593a2d56a40$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $c0e7f593a2d56a40$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $c0e7f593a2d56a40$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $c0e7f593a2d56a40$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $c0e7f593a2d56a40$var$normalizeSearch(search),
        hash: $c0e7f593a2d56a40$var$normalizeHash(hash)
    };
}
function $c0e7f593a2d56a40$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c0e7f593a2d56a40$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $c0e7f593a2d56a40$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $c0e7f593a2d56a40$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $c0e7f593a2d56a40$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $c0e7f593a2d56a40$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $c0e7f593a2d56a40$export$8ccf933b0513f8d0(toArg);
    else {
        to = $c0e7f593a2d56a40$var$_extends({}, toArg);
        $c0e7f593a2d56a40$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $c0e7f593a2d56a40$var$getInvalidPathError("?", "pathname", "search", to));
        $c0e7f593a2d56a40$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $c0e7f593a2d56a40$var$getInvalidPathError("#", "pathname", "hash", to));
        $c0e7f593a2d56a40$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $c0e7f593a2d56a40$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c0e7f593a2d56a40$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $c0e7f593a2d56a40$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $c0e7f593a2d56a40$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $c0e7f593a2d56a40$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $c0e7f593a2d56a40$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $c0e7f593a2d56a40$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $c0e7f593a2d56a40$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $c0e7f593a2d56a40$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $c0e7f593a2d56a40$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $c0e7f593a2d56a40$export$480182c6abbb2ff6(data, init) {
    return new $c0e7f593a2d56a40$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $c0e7f593a2d56a40$export$42a99a7a4bc0e76a extends Error {
}
class $c0e7f593a2d56a40$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $c0e7f593a2d56a40$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $c0e7f593a2d56a40$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $c0e7f593a2d56a40$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $c0e7f593a2d56a40$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $c0e7f593a2d56a40$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $c0e7f593a2d56a40$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $c0e7f593a2d56a40$var$unwrapTrackedPromise(value) {
    if (!$c0e7f593a2d56a40$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $c0e7f593a2d56a40$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $c0e7f593a2d56a40$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c0e7f593a2d56a40$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $c0e7f593a2d56a40$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c0e7f593a2d56a40$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $c0e7f593a2d56a40$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c0e7f593a2d56a40$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $c0e7f593a2d56a40$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $c0e7f593a2d56a40$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $c0e7f593a2d56a40$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $c0e7f593a2d56a40$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $c0e7f593a2d56a40$var$validMutationMethods = new Set($c0e7f593a2d56a40$var$validMutationMethodsArr);
const $c0e7f593a2d56a40$var$validRequestMethodsArr = [
    "get",
    ...$c0e7f593a2d56a40$var$validMutationMethodsArr
];
const $c0e7f593a2d56a40$var$validRequestMethods = new Set($c0e7f593a2d56a40$var$validRequestMethodsArr);
const $c0e7f593a2d56a40$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $c0e7f593a2d56a40$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $c0e7f593a2d56a40$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $c0e7f593a2d56a40$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $c0e7f593a2d56a40$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $c0e7f593a2d56a40$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $c0e7f593a2d56a40$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $c0e7f593a2d56a40$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $c0e7f593a2d56a40$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $c0e7f593a2d56a40$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c0e7f593a2d56a40$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $c0e7f593a2d56a40$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $c0e7f593a2d56a40$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $c0e7f593a2d56a40$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c0e7f593a2d56a40$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $c0e7f593a2d56a40$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $c0e7f593a2d56a40$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $c0e7f593a2d56a40$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $c0e7f593a2d56a40$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $c0e7f593a2d56a40$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $c0e7f593a2d56a40$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$c0e7f593a2d56a40$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $c0e7f593a2d56a40$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c0e7f593a2d56a40$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $c0e7f593a2d56a40$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $c0e7f593a2d56a40$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c0e7f593a2d56a40$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($c0e7f593a2d56a40$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $c0e7f593a2d56a40$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $c0e7f593a2d56a40$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $c0e7f593a2d56a40$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $c0e7f593a2d56a40$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $c0e7f593a2d56a40$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $c0e7f593a2d56a40$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $c0e7f593a2d56a40$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $c0e7f593a2d56a40$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $c0e7f593a2d56a40$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c0e7f593a2d56a40$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $c0e7f593a2d56a40$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $c0e7f593a2d56a40$var$findNearestBoundary(matches).route.id,
            {
                type: $c0e7f593a2d56a40$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $c0e7f593a2d56a40$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($c0e7f593a2d56a40$var$isErrorResult(result) && $c0e7f593a2d56a40$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $c0e7f593a2d56a40$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $c0e7f593a2d56a40$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $c0e7f593a2d56a40$var$_extends({
            matches: updatedMatches || matches
        }, $c0e7f593a2d56a40$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $c0e7f593a2d56a40$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $c0e7f593a2d56a40$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $c0e7f593a2d56a40$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $c0e7f593a2d56a40$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $c0e7f593a2d56a40$var$ResultType.error,
            error: $c0e7f593a2d56a40$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c0e7f593a2d56a40$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $c0e7f593a2d56a40$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($c0e7f593a2d56a40$var$isDeferredResult(result)) throw $c0e7f593a2d56a40$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($c0e7f593a2d56a40$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $c0e7f593a2d56a40$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $c0e7f593a2d56a40$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $c0e7f593a2d56a40$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($c0e7f593a2d56a40$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $c0e7f593a2d56a40$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $c0e7f593a2d56a40$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $c0e7f593a2d56a40$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $c0e7f593a2d56a40$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $c0e7f593a2d56a40$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $c0e7f593a2d56a40$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $c0e7f593a2d56a40$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c0e7f593a2d56a40$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $c0e7f593a2d56a40$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $c0e7f593a2d56a40$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $c0e7f593a2d56a40$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $c0e7f593a2d56a40$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c0e7f593a2d56a40$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $c0e7f593a2d56a40$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c0e7f593a2d56a40$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c0e7f593a2d56a40$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c0e7f593a2d56a40$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $c0e7f593a2d56a40$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($c0e7f593a2d56a40$var$isRedirectResult(actionResult) || $c0e7f593a2d56a40$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $c0e7f593a2d56a40$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($c0e7f593a2d56a40$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $c0e7f593a2d56a40$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $c0e7f593a2d56a40$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($c0e7f593a2d56a40$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($c0e7f593a2d56a40$var$isDeferredResult(actionResult)) throw $c0e7f593a2d56a40$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c0e7f593a2d56a40$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c0e7f593a2d56a40$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c0e7f593a2d56a40$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c0e7f593a2d56a40$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $c0e7f593a2d56a40$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $c0e7f593a2d56a40$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $c0e7f593a2d56a40$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $c0e7f593a2d56a40$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $c0e7f593a2d56a40$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c0e7f593a2d56a40$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $c0e7f593a2d56a40$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c0e7f593a2d56a40$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c0e7f593a2d56a40$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c0e7f593a2d56a40$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $c0e7f593a2d56a40$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($c0e7f593a2d56a40$var$isDeferredResult(result)) result = await $c0e7f593a2d56a40$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $c0e7f593a2d56a40$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($c0e7f593a2d56a40$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $c0e7f593a2d56a40$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($c0e7f593a2d56a40$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $c0e7f593a2d56a40$export$3e9cee6b33872309(!$c0e7f593a2d56a40$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $c0e7f593a2d56a40$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $c0e7f593a2d56a40$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $c0e7f593a2d56a40$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $c0e7f593a2d56a40$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($c0e7f593a2d56a40$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $c0e7f593a2d56a40$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Replace : $c0e7f593a2d56a40$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $c0e7f593a2d56a40$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($c0e7f593a2d56a40$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $c0e7f593a2d56a40$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $c0e7f593a2d56a40$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $c0e7f593a2d56a40$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $c0e7f593a2d56a40$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($c0e7f593a2d56a40$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $c0e7f593a2d56a40$var$ResultType.redirect,
                        response: $c0e7f593a2d56a40$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $c0e7f593a2d56a40$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $c0e7f593a2d56a40$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $c0e7f593a2d56a40$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $c0e7f593a2d56a40$var$ResultType.error,
                    error: $c0e7f593a2d56a40$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $c0e7f593a2d56a40$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $c0e7f593a2d56a40$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $c0e7f593a2d56a40$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $c0e7f593a2d56a40$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $c0e7f593a2d56a40$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $c0e7f593a2d56a40$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c0e7f593a2d56a40$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c0e7f593a2d56a40$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c0e7f593a2d56a40$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c0e7f593a2d56a40$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $c0e7f593a2d56a40$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $c0e7f593a2d56a40$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $c0e7f593a2d56a40$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $c0e7f593a2d56a40$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $c0e7f593a2d56a40$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $c0e7f593a2d56a40$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $c0e7f593a2d56a40$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$c0e7f593a2d56a40$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $c0e7f593a2d56a40$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $c0e7f593a2d56a40$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $c0e7f593a2d56a40$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $c0e7f593a2d56a40$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $c0e7f593a2d56a40$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c0e7f593a2d56a40$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $c0e7f593a2d56a40$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $c0e7f593a2d56a40$export$4d0306f8f6a4585b = Symbol("deferred");
function $c0e7f593a2d56a40$export$3336b097a6fbc59a(routes, opts) {
    $c0e7f593a2d56a40$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c0e7f593a2d56a40$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $c0e7f593a2d56a40$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $c0e7f593a2d56a40$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c0e7f593a2d56a40$var$createLocation("", $c0e7f593a2d56a40$export$fe53371bee54353d(url), null, "default");
        let matches = $c0e7f593a2d56a40$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c0e7f593a2d56a40$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c0e7f593a2d56a40$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $c0e7f593a2d56a40$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $c0e7f593a2d56a40$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c0e7f593a2d56a40$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($c0e7f593a2d56a40$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $c0e7f593a2d56a40$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c0e7f593a2d56a40$var$createLocation("", $c0e7f593a2d56a40$export$fe53371bee54353d(url), null, "default");
        let matches = $c0e7f593a2d56a40$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c0e7f593a2d56a40$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c0e7f593a2d56a40$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c0e7f593a2d56a40$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c0e7f593a2d56a40$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c0e7f593a2d56a40$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $c0e7f593a2d56a40$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($c0e7f593a2d56a40$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$c0e7f593a2d56a40$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $c0e7f593a2d56a40$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c0e7f593a2d56a40$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $c0e7f593a2d56a40$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $c0e7f593a2d56a40$var$isResponse(result) ? result : $c0e7f593a2d56a40$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($c0e7f593a2d56a40$var$isHandlerResult(e) && $c0e7f593a2d56a40$var$isResponse(e.result)) {
                if (e.type === $c0e7f593a2d56a40$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($c0e7f593a2d56a40$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c0e7f593a2d56a40$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c0e7f593a2d56a40$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $c0e7f593a2d56a40$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($c0e7f593a2d56a40$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($c0e7f593a2d56a40$var$isDeferredResult(result)) {
            let error = $c0e7f593a2d56a40$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c0e7f593a2d56a40$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($c0e7f593a2d56a40$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($c0e7f593a2d56a40$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c0e7f593a2d56a40$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $c0e7f593a2d56a40$var$_extends({}, context, {
                statusCode: $c0e7f593a2d56a40$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $c0e7f593a2d56a40$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $c0e7f593a2d56a40$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $c0e7f593a2d56a40$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? $c0e7f593a2d56a40$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $c0e7f593a2d56a40$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $c0e7f593a2d56a40$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $c0e7f593a2d56a40$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $c0e7f593a2d56a40$var$callDataStrategyImpl(unstable_dataStrategy || $c0e7f593a2d56a40$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($c0e7f593a2d56a40$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $c0e7f593a2d56a40$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($c0e7f593a2d56a40$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $c0e7f593a2d56a40$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $c0e7f593a2d56a40$export$fec11da027c70692(routes, context, error) {
    let newContext = $c0e7f593a2d56a40$var$_extends({}, context, {
        statusCode: $c0e7f593a2d56a40$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $c0e7f593a2d56a40$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $c0e7f593a2d56a40$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $c0e7f593a2d56a40$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $c0e7f593a2d56a40$export$cae722b0cc860f13(to ? to : ".", $c0e7f593a2d56a40$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $c0e7f593a2d56a40$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$c0e7f593a2d56a40$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c0e7f593a2d56a40$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $c0e7f593a2d56a40$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $c0e7f593a2d56a40$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$c0e7f593a2d56a40$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c0e7f593a2d56a40$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c0e7f593a2d56a40$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $c0e7f593a2d56a40$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $c0e7f593a2d56a40$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$c0e7f593a2d56a40$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$c0e7f593a2d56a40$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $c0e7f593a2d56a40$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $c0e7f593a2d56a40$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $c0e7f593a2d56a40$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $c0e7f593a2d56a40$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $c0e7f593a2d56a40$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($c0e7f593a2d56a40$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $c0e7f593a2d56a40$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $c0e7f593a2d56a40$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $c0e7f593a2d56a40$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $c0e7f593a2d56a40$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $c0e7f593a2d56a40$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $c0e7f593a2d56a40$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($c0e7f593a2d56a40$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $c0e7f593a2d56a40$var$shouldRevalidateLoader(match, $c0e7f593a2d56a40$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $c0e7f593a2d56a40$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $c0e7f593a2d56a40$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $c0e7f593a2d56a40$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $c0e7f593a2d56a40$var$shouldRevalidateLoader(fetcherMatch, $c0e7f593a2d56a40$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $c0e7f593a2d56a40$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $c0e7f593a2d56a40$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c0e7f593a2d56a40$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $c0e7f593a2d56a40$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $c0e7f593a2d56a40$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $c0e7f593a2d56a40$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $c0e7f593a2d56a40$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $c0e7f593a2d56a40$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $c0e7f593a2d56a40$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $c0e7f593a2d56a40$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $c0e7f593a2d56a40$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $c0e7f593a2d56a40$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $c0e7f593a2d56a40$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$c0e7f593a2d56a40$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $c0e7f593a2d56a40$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $c0e7f593a2d56a40$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $c0e7f593a2d56a40$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $c0e7f593a2d56a40$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $c0e7f593a2d56a40$var$ResultType.data,
                    result: undefined
                });
            };
            return $c0e7f593a2d56a40$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$c0e7f593a2d56a40$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $c0e7f593a2d56a40$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $c0e7f593a2d56a40$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $c0e7f593a2d56a40$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c0e7f593a2d56a40$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $c0e7f593a2d56a40$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c0e7f593a2d56a40$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $c0e7f593a2d56a40$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $c0e7f593a2d56a40$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $c0e7f593a2d56a40$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type } = handlerResult;
    if ($c0e7f593a2d56a40$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $c0e7f593a2d56a40$var$ResultType.error,
                error: e
            };
        }
        if (type === $c0e7f593a2d56a40$var$ResultType.error) return {
            type: $c0e7f593a2d56a40$var$ResultType.error,
            error: new $c0e7f593a2d56a40$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $c0e7f593a2d56a40$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $c0e7f593a2d56a40$var$ResultType.error) {
        if ($c0e7f593a2d56a40$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $c0e7f593a2d56a40$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $c0e7f593a2d56a40$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $c0e7f593a2d56a40$var$ResultType.error,
            error: result,
            statusCode: $c0e7f593a2d56a40$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($c0e7f593a2d56a40$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $c0e7f593a2d56a40$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($c0e7f593a2d56a40$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $c0e7f593a2d56a40$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $c0e7f593a2d56a40$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $c0e7f593a2d56a40$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $c0e7f593a2d56a40$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$c0e7f593a2d56a40$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $c0e7f593a2d56a40$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $c0e7f593a2d56a40$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($c0e7f593a2d56a40$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $c0e7f593a2d56a40$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $c0e7f593a2d56a40$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c0e7f593a2d56a40$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c0e7f593a2d56a40$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $c0e7f593a2d56a40$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $c0e7f593a2d56a40$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $c0e7f593a2d56a40$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $c0e7f593a2d56a40$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $c0e7f593a2d56a40$export$3e9cee6b33872309(!$c0e7f593a2d56a40$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c0e7f593a2d56a40$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $c0e7f593a2d56a40$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $c0e7f593a2d56a40$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($c0e7f593a2d56a40$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c0e7f593a2d56a40$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $c0e7f593a2d56a40$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $c0e7f593a2d56a40$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($c0e7f593a2d56a40$var$isErrorResult(result)) {
            let boundaryMatch = $c0e7f593a2d56a40$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $c0e7f593a2d56a40$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($c0e7f593a2d56a40$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $c0e7f593a2d56a40$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($c0e7f593a2d56a40$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $c0e7f593a2d56a40$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $c0e7f593a2d56a40$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c0e7f593a2d56a40$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $c0e7f593a2d56a40$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $c0e7f593a2d56a40$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $c0e7f593a2d56a40$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $c0e7f593a2d56a40$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c0e7f593a2d56a40$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c0e7f593a2d56a40$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $c0e7f593a2d56a40$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $c0e7f593a2d56a40$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($c0e7f593a2d56a40$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $c0e7f593a2d56a40$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(path) : path;
    return $c0e7f593a2d56a40$export$fe53371bee54353d($c0e7f593a2d56a40$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $c0e7f593a2d56a40$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $c0e7f593a2d56a40$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $c0e7f593a2d56a40$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $c0e7f593a2d56a40$var$ResultType.data || result.type === $c0e7f593a2d56a40$var$ResultType.error);
}
function $c0e7f593a2d56a40$var$isRedirectHandlerResult(result) {
    return $c0e7f593a2d56a40$var$isResponse(result.result) && $c0e7f593a2d56a40$var$redirectStatusCodes.has(result.result.status);
}
function $c0e7f593a2d56a40$var$isDeferredResult(result) {
    return result.type === $c0e7f593a2d56a40$var$ResultType.deferred;
}
function $c0e7f593a2d56a40$var$isErrorResult(result) {
    return result.type === $c0e7f593a2d56a40$var$ResultType.error;
}
function $c0e7f593a2d56a40$var$isRedirectResult(result) {
    return (result && result.type) === $c0e7f593a2d56a40$var$ResultType.redirect;
}
function $c0e7f593a2d56a40$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $c0e7f593a2d56a40$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $c0e7f593a2d56a40$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c0e7f593a2d56a40$var$isRedirectResponse(result) {
    if (!$c0e7f593a2d56a40$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $c0e7f593a2d56a40$var$isValidMethod(method) {
    return $c0e7f593a2d56a40$var$validRequestMethods.has(method.toLowerCase());
}
function $c0e7f593a2d56a40$var$isMutationMethod(method) {
    return $c0e7f593a2d56a40$var$validMutationMethods.has(method.toLowerCase());
}
async function $c0e7f593a2d56a40$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$c0e7f593a2d56a40$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($c0e7f593a2d56a40$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $c0e7f593a2d56a40$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $c0e7f593a2d56a40$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $c0e7f593a2d56a40$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $c0e7f593a2d56a40$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $c0e7f593a2d56a40$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $c0e7f593a2d56a40$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $c0e7f593a2d56a40$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $c0e7f593a2d56a40$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c0e7f593a2d56a40$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c0e7f593a2d56a40$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $c0e7f593a2d56a40$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $c0e7f593a2d56a40$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $c0e7f593a2d56a40$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $c0e7f593a2d56a40$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $c0e7f593a2d56a40$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $c0e7f593a2d56a40$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $c0e7f593a2d56a40$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $c0e7f593a2d56a40$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($c0e7f593a2d56a40$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $c0e7f593a2d56a40$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($c0e7f593a2d56a40$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $c0e7f593a2d56a40$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4HBpa = parcelRequire("4HBpa");

function $c03a1ed858071efe$var$_extends() {
    $c03a1ed858071efe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c03a1ed858071efe$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $c03a1ed858071efe$export$3add0d5dce533e2e = /*#__PURE__*/ $4HBpa.createContext(null);
const $c03a1ed858071efe$export$145dfa71566a64dc = /*#__PURE__*/ $4HBpa.createContext(null);
const $c03a1ed858071efe$var$AwaitContext = /*#__PURE__*/ $4HBpa.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $c03a1ed858071efe$export$26749e8557646306 = /*#__PURE__*/ $4HBpa.createContext(null);
const $c03a1ed858071efe$export$c7914228fb69b0f5 = /*#__PURE__*/ $4HBpa.createContext(null);
const $c03a1ed858071efe$export$9072aa6dd1f93057 = /*#__PURE__*/ $4HBpa.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $c03a1ed858071efe$var$RouteErrorContext = /*#__PURE__*/ $4HBpa.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $c03a1ed858071efe$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4HBpa.useContext($c03a1ed858071efe$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $c03a1ed858071efe$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $c0e7f593a2d56a40$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $c03a1ed858071efe$export$9c954a9d03d32f4a() {
    return $4HBpa.useContext($c03a1ed858071efe$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $c03a1ed858071efe$export$45d76561a5302f2b() {
    !$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return $4HBpa.useContext($c03a1ed858071efe$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $c03a1ed858071efe$export$1b3f31771c5d07c() {
    return $4HBpa.useContext($c03a1ed858071efe$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $c03a1ed858071efe$export$6c330e8992e8a295(pattern) {
    !$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $c03a1ed858071efe$export$45d76561a5302f2b();
    return $4HBpa.useMemo(()=>(0, $c0e7f593a2d56a40$export$81336c211d5ff295)(pattern, (0, $c0e7f593a2d56a40$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $c03a1ed858071efe$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $c03a1ed858071efe$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4HBpa.useContext($c03a1ed858071efe$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4HBpa.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $c03a1ed858071efe$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $c03a1ed858071efe$var$useNavigateStable() : $c03a1ed858071efe$var$useNavigateUnstable();
}
function $c03a1ed858071efe$var$useNavigateUnstable() {
    !$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4HBpa.useContext($c03a1ed858071efe$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4HBpa.useContext($c03a1ed858071efe$export$26749e8557646306);
    let { matches: matches } = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $c03a1ed858071efe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $c0e7f593a2d56a40$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $4HBpa.useRef(false);
    $c03a1ed858071efe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4HBpa.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $c0e7f593a2d56a40$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $c0e7f593a2d56a40$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $c03a1ed858071efe$var$OutletContext = /*#__PURE__*/ $4HBpa.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $c03a1ed858071efe$export$4138103a3ae699cc() {
    return $4HBpa.useContext($c03a1ed858071efe$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $c03a1ed858071efe$export$a3be3530d8e40d0b(context) {
    let outlet = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $c03a1ed858071efe$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $c03a1ed858071efe$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4HBpa.useContext($c03a1ed858071efe$export$26749e8557646306);
    let { matches: matches } = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $c03a1ed858071efe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $c0e7f593a2d56a40$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4HBpa.useMemo(()=>(0, $c0e7f593a2d56a40$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $c03a1ed858071efe$export$5d3fca4a98652595(routes, locationArg) {
    return $c03a1ed858071efe$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $c03a1ed858071efe$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4HBpa.useContext($c03a1ed858071efe$export$26749e8557646306);
    let { matches: parentMatches } = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $c03a1ed858071efe$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $c0e7f593a2d56a40$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $c0e7f593a2d56a40$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $c03a1ed858071efe$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $c0e7f593a2d56a40$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $c0e7f593a2d56a40$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $c03a1ed858071efe$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $c0e7f593a2d56a40$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $c03a1ed858071efe$var$DefaultErrorComponent() {
    let error = $c03a1ed858071efe$export$ed527bf60f6e05f2();
    let message = (0, $c0e7f593a2d56a40$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4HBpa.createElement($4HBpa.Fragment, null, /*#__PURE__*/ $4HBpa.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4HBpa.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4HBpa.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $c03a1ed858071efe$var$defaultErrorElement = /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$DefaultErrorComponent, null);
class $c03a1ed858071efe$var$RenderErrorBoundary extends $4HBpa.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $c03a1ed858071efe$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4HBpa.useContext($c03a1ed858071efe$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $c03a1ed858071efe$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $c03a1ed858071efe$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $c03a1ed858071efe$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4HBpa.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $c03a1ed858071efe$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($c03a1ed858071efe$var$DataRouterHook || {});
var $c03a1ed858071efe$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($c03a1ed858071efe$var$DataRouterStateHook || {});
function $c03a1ed858071efe$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c03a1ed858071efe$var$useDataRouterContext(hookName) {
    let ctx = $4HBpa.useContext($c03a1ed858071efe$export$3add0d5dce533e2e);
    !ctx && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c03a1ed858071efe$var$useDataRouterState(hookName) {
    let state = $4HBpa.useContext($c03a1ed858071efe$export$145dfa71566a64dc);
    !state && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return state;
}
function $c03a1ed858071efe$var$useRouteContext(hookName) {
    let route = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    !route && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $c03a1ed858071efe$var$useCurrentRouteId(hookName) {
    let route = $c03a1ed858071efe$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $c03a1ed858071efe$export$5fc8298006ad9e58() {
    return $c03a1ed858071efe$var$useCurrentRouteId($c03a1ed858071efe$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $c03a1ed858071efe$export$d0fd4b7106de2769() {
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $c03a1ed858071efe$export$600dc272ed516c15() {
    let dataRouterContext = $c03a1ed858071efe$var$useDataRouterContext($c03a1ed858071efe$var$DataRouterHook.UseRevalidator);
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseRevalidator);
    return $4HBpa.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $c03a1ed858071efe$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseMatches);
    return $4HBpa.useMemo(()=>matches.map((m)=>(0, $c0e7f593a2d56a40$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $c03a1ed858071efe$export$1448a5050d252c4d() {
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseLoaderData);
    let routeId = $c03a1ed858071efe$var$useCurrentRouteId($c03a1ed858071efe$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $c03a1ed858071efe$export$fd5d37484eab868d(routeId) {
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $c03a1ed858071efe$export$fdc00f3f26066d5e() {
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseActionData);
    let routeId = $c03a1ed858071efe$var$useCurrentRouteId($c03a1ed858071efe$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $c03a1ed858071efe$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4HBpa.useContext($c03a1ed858071efe$var$RouteErrorContext);
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseRouteError);
    let routeId = $c03a1ed858071efe$var$useCurrentRouteId($c03a1ed858071efe$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $c03a1ed858071efe$export$78a72ddb39bdd145() {
    let value = $4HBpa.useContext($c03a1ed858071efe$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $c03a1ed858071efe$export$17f53340677d5831() {
    let value = $4HBpa.useContext($c03a1ed858071efe$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $c03a1ed858071efe$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $c03a1ed858071efe$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $c03a1ed858071efe$var$useDataRouterContext($c03a1ed858071efe$var$DataRouterHook.UseBlocker);
    let state = $c03a1ed858071efe$var$useDataRouterState($c03a1ed858071efe$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4HBpa.useState("");
    let blockerFunction = $4HBpa.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $c03a1ed858071efe$var$_extends({}, currentLocation, {
                pathname: (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $c03a1ed858071efe$var$_extends({}, nextLocation, {
                pathname: (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4HBpa.useEffect(()=>{
        let key = String(++$c03a1ed858071efe$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4HBpa.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $c0e7f593a2d56a40$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $c03a1ed858071efe$var$useNavigateStable() {
    let { router: router } = $c03a1ed858071efe$var$useDataRouterContext($c03a1ed858071efe$var$DataRouterHook.UseNavigateStable);
    let id = $c03a1ed858071efe$var$useCurrentRouteId($c03a1ed858071efe$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4HBpa.useRef(false);
    $c03a1ed858071efe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4HBpa.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $c03a1ed858071efe$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $c03a1ed858071efe$var$alreadyWarned = {};
function $c03a1ed858071efe$var$warningOnce(key, cond, message) {
    if (!cond && !$c03a1ed858071efe$var$alreadyWarned[key]) $c03a1ed858071efe$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c03a1ed858071efe$var$START_TRANSITION = "startTransition";
const $c03a1ed858071efe$var$startTransitionImpl = $4HBpa[$c03a1ed858071efe$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c03a1ed858071efe$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4HBpa.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4HBpa.useCallback((newState)=>{
        if (v7_startTransition && $c03a1ed858071efe$var$startTransitionImpl) $c03a1ed858071efe$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4HBpa.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4HBpa.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4HBpa.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4HBpa.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4HBpa.createElement($4HBpa.Fragment, null, /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $c03a1ed858071efe$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $c03a1ed858071efe$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $c03a1ed858071efe$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4HBpa.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c0e7f593a2d56a40$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4HBpa.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4HBpa.useCallback((newState)=>{
        v7_startTransition && $c03a1ed858071efe$var$startTransitionImpl ? $c03a1ed858071efe$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4HBpa.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $c03a1ed858071efe$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $4HBpa.useContext($c03a1ed858071efe$export$26749e8557646306);
    let { matches: matches } = $4HBpa.useContext($c03a1ed858071efe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $c03a1ed858071efe$export$45d76561a5302f2b();
    let navigate = $c03a1ed858071efe$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $c0e7f593a2d56a40$export$cae722b0cc860f13)(to, (0, $c0e7f593a2d56a40$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4HBpa.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $c03a1ed858071efe$export$910ae8079b2c2852(props) {
    return $c03a1ed858071efe$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $c03a1ed858071efe$export$e7b0ac011bb776c6(_props) {
    (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $c03a1ed858071efe$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $c0e7f593a2d56a40$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$c03a1ed858071efe$export$9c954a9d03d32f4a() && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4HBpa.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $c03a1ed858071efe$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $c0e7f593a2d56a40$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4HBpa.useMemo(()=>{
        let trailingPathname = (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $c03a1ed858071efe$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $c03a1ed858071efe$export$5d3fca4a98652595($c03a1ed858071efe$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $c03a1ed858071efe$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$ResolveAwait, null, children));
}
var $c03a1ed858071efe$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($c03a1ed858071efe$var$AwaitRenderStatus || {});
const $c03a1ed858071efe$var$neverSettledPromise = new Promise(()=>{});
class $c03a1ed858071efe$var$AwaitErrorBoundary extends $4HBpa.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $c03a1ed858071efe$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $c03a1ed858071efe$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $c03a1ed858071efe$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $c03a1ed858071efe$var$AwaitRenderStatus.error : "_data" in promise ? $c03a1ed858071efe$var$AwaitRenderStatus.success : $c03a1ed858071efe$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $c03a1ed858071efe$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $c03a1ed858071efe$var$AwaitRenderStatus.error && promise._error instanceof (0, $c0e7f593a2d56a40$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $c03a1ed858071efe$var$neverSettledPromise;
        if (status === $c03a1ed858071efe$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $c03a1ed858071efe$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $c03a1ed858071efe$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4HBpa.createElement($c03a1ed858071efe$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $c03a1ed858071efe$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $c03a1ed858071efe$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4HBpa.createElement($4HBpa.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $c03a1ed858071efe$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4HBpa.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4HBpa.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4HBpa.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $c03a1ed858071efe$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $c03a1ed858071efe$export$e7b0ac011bb776c6) && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $c03a1ed858071efe$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $c03a1ed858071efe$export$daf73786167a7f72(matches) {
    return $c03a1ed858071efe$var$_renderMatches(matches);
}
function $c03a1ed858071efe$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4HBpa.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4HBpa.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4HBpa.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $c03a1ed858071efe$export$f30f7e456d254e83(routes, opts) {
    return (0, $c0e7f593a2d56a40$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c03a1ed858071efe$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c0e7f593a2d56a40$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $c03a1ed858071efe$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}



function $13f7c841fa583706$var$_extends() {
    $13f7c841fa583706$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $13f7c841fa583706$var$_extends.apply(this, arguments);
}
function $13f7c841fa583706$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $13f7c841fa583706$var$defaultMethod = "get";
const $13f7c841fa583706$var$defaultEncType = "application/x-www-form-urlencoded";
function $13f7c841fa583706$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $13f7c841fa583706$var$isButtonElement(object) {
    return $13f7c841fa583706$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $13f7c841fa583706$var$isFormElement(object) {
    return $13f7c841fa583706$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $13f7c841fa583706$var$isInputElement(object) {
    return $13f7c841fa583706$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $13f7c841fa583706$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $13f7c841fa583706$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$13f7c841fa583706$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $13f7c841fa583706$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $13f7c841fa583706$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $13f7c841fa583706$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $13f7c841fa583706$var$_formDataSupportsSubmitter = null;
function $13f7c841fa583706$var$isFormDataSubmitterSupported() {
    if ($13f7c841fa583706$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $13f7c841fa583706$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $13f7c841fa583706$var$_formDataSupportsSubmitter = true;
    }
    return $13f7c841fa583706$var$_formDataSupportsSubmitter;
}
const $13f7c841fa583706$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $13f7c841fa583706$var$getFormEncType(encType) {
    if (encType != null && !$13f7c841fa583706$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $13f7c841fa583706$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($13f7c841fa583706$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $13f7c841fa583706$var$defaultMethod;
        encType = $13f7c841fa583706$var$getFormEncType(target.getAttribute("enctype")) || $13f7c841fa583706$var$defaultEncType;
        formData = new FormData(target);
    } else if ($13f7c841fa583706$var$isButtonElement(target) || $13f7c841fa583706$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $13f7c841fa583706$var$defaultMethod;
        encType = $13f7c841fa583706$var$getFormEncType(target.getAttribute("formenctype")) || $13f7c841fa583706$var$getFormEncType(form.getAttribute("enctype")) || $13f7c841fa583706$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$13f7c841fa583706$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($13f7c841fa583706$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $13f7c841fa583706$var$defaultMethod;
        action = null;
        encType = $13f7c841fa583706$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $13f7c841fa583706$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $13f7c841fa583706$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $13f7c841fa583706$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $13f7c841fa583706$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $13f7c841fa583706$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $13f7c841fa583706$export$1f3f55432a00e06d(routes, opts) {
    return (0, $c0e7f593a2d56a40$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $13f7c841fa583706$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c0e7f593a2d56a40$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $13f7c841fa583706$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $c03a1ed858071efe$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $13f7c841fa583706$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $c0e7f593a2d56a40$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $13f7c841fa583706$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c0e7f593a2d56a40$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $13f7c841fa583706$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $c03a1ed858071efe$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $13f7c841fa583706$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $13f7c841fa583706$var$_extends({}, state, {
        errors: $13f7c841fa583706$var$deserializeErrors(state.errors)
    });
    return state;
}
function $13f7c841fa583706$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $c0e7f593a2d56a40$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $13f7c841fa583706$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4HBpa.createContext({
    isTransitioning: false
});
const $13f7c841fa583706$export$148fd98d095596d4 = /*#__PURE__*/ $4HBpa.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $13f7c841fa583706$var$START_TRANSITION = "startTransition";
const $13f7c841fa583706$var$startTransitionImpl = $4HBpa[$13f7c841fa583706$var$START_TRANSITION];
const $13f7c841fa583706$var$FLUSH_SYNC = "flushSync";
const $13f7c841fa583706$var$flushSyncImpl = $384457d72cc1e1d1$exports[$13f7c841fa583706$var$FLUSH_SYNC];
const $13f7c841fa583706$var$USE_ID = "useId";
const $13f7c841fa583706$var$useIdImpl = $4HBpa[$13f7c841fa583706$var$USE_ID];
function $13f7c841fa583706$var$startTransitionSafe(cb) {
    if ($13f7c841fa583706$var$startTransitionImpl) $13f7c841fa583706$var$startTransitionImpl(cb);
    else cb();
}
function $13f7c841fa583706$var$flushSyncSafe(cb) {
    if ($13f7c841fa583706$var$flushSyncImpl) $13f7c841fa583706$var$flushSyncImpl(cb);
    else cb();
}
class $13f7c841fa583706$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $13f7c841fa583706$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4HBpa.useState(router.state);
    let [pendingState, setPendingState] = $4HBpa.useState();
    let [vtContext, setVtContext] = $4HBpa.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4HBpa.useState();
    let [transition, setTransition] = $4HBpa.useState();
    let [interruption, setInterruption] = $4HBpa.useState();
    let fetcherData = $4HBpa.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4HBpa.useCallback((cb)=>{
        if (v7_startTransition) $13f7c841fa583706$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4HBpa.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $13f7c841fa583706$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $13f7c841fa583706$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $13f7c841fa583706$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $13f7c841fa583706$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $13f7c841fa583706$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4HBpa.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4HBpa.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $13f7c841fa583706$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4HBpa.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4HBpa.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4HBpa.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4HBpa.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4HBpa.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4HBpa.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $4HBpa.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4HBpa.createElement($4HBpa.Fragment, null, /*#__PURE__*/ $4HBpa.createElement((0, $c03a1ed858071efe$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4HBpa.createElement((0, $c03a1ed858071efe$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4HBpa.createElement($13f7c841fa583706$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4HBpa.createElement($13f7c841fa583706$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4HBpa.createElement((0, $c03a1ed858071efe$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4HBpa.createElement($13f7c841fa583706$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $13f7c841fa583706$var$MemoizedDataRoutes = /*#__PURE__*/ $4HBpa.memo($13f7c841fa583706$var$DataRoutes);
function $13f7c841fa583706$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $c03a1ed858071efe$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $13f7c841fa583706$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4HBpa.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c0e7f593a2d56a40$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4HBpa.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4HBpa.useCallback((newState)=>{
        v7_startTransition && $13f7c841fa583706$var$startTransitionImpl ? $13f7c841fa583706$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4HBpa.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4HBpa.createElement((0, $c03a1ed858071efe$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $13f7c841fa583706$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4HBpa.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c0e7f593a2d56a40$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4HBpa.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4HBpa.useCallback((newState)=>{
        v7_startTransition && $13f7c841fa583706$var$startTransitionImpl ? $13f7c841fa583706$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4HBpa.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4HBpa.createElement((0, $c03a1ed858071efe$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $13f7c841fa583706$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4HBpa.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4HBpa.useCallback((newState)=>{
        v7_startTransition && $13f7c841fa583706$var$startTransitionImpl ? $13f7c841fa583706$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4HBpa.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4HBpa.createElement((0, $c03a1ed858071efe$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $13f7c841fa583706$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $13f7c841fa583706$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $13f7c841fa583706$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4HBpa.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $13f7c841fa583706$var$_objectWithoutPropertiesLoose(_ref7, $13f7c841fa583706$var$_excluded);
    let { basename: basename } = $4HBpa.useContext((0, $c03a1ed858071efe$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $13f7c841fa583706$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($13f7c841fa583706$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $c03a1ed858071efe$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $13f7c841fa583706$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4HBpa.createElement("a", $13f7c841fa583706$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $13f7c841fa583706$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4HBpa.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $13f7c841fa583706$var$_objectWithoutPropertiesLoose(_ref8, $13f7c841fa583706$var$_excluded2);
    let path = (0, $c03a1ed858071efe$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $c03a1ed858071efe$export$45d76561a5302f2b)();
    let routerState = $4HBpa.useContext((0, $c03a1ed858071efe$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $4HBpa.useContext((0, $c03a1ed858071efe$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $13f7c841fa583706$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4HBpa.createElement($13f7c841fa583706$export$a6c7ac8248d6e38a, $13f7c841fa583706$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $13f7c841fa583706$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4HBpa.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $13f7c841fa583706$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $13f7c841fa583706$var$_objectWithoutPropertiesLoose(_ref9, $13f7c841fa583706$var$_excluded3);
    let submit = $13f7c841fa583706$export$47c85c6e3a081d3();
    let formAction = $13f7c841fa583706$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $4HBpa.createElement("form", $13f7c841fa583706$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $13f7c841fa583706$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $13f7c841fa583706$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $13f7c841fa583706$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($13f7c841fa583706$var$DataRouterHook || ($13f7c841fa583706$var$DataRouterHook = {}));
var $13f7c841fa583706$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($13f7c841fa583706$var$DataRouterStateHook || ($13f7c841fa583706$var$DataRouterStateHook = {}));
// Internal hooks
function $13f7c841fa583706$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $13f7c841fa583706$var$useDataRouterContext(hookName) {
    let ctx = $4HBpa.useContext((0, $c03a1ed858071efe$export$3add0d5dce533e2e));
    !ctx && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return ctx;
}
function $13f7c841fa583706$var$useDataRouterState(hookName) {
    let state = $4HBpa.useContext((0, $c03a1ed858071efe$export$145dfa71566a64dc));
    !state && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $13f7c841fa583706$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $c03a1ed858071efe$export$9770f232ac06a008)();
    let location = (0, $c03a1ed858071efe$export$45d76561a5302f2b)();
    let path = (0, $c03a1ed858071efe$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4HBpa.useCallback((event)=>{
        if ($13f7c841fa583706$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $c0e7f593a2d56a40$export$fe53371bee54353d)(location) === (0, $c0e7f593a2d56a40$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $13f7c841fa583706$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4HBpa.useRef($13f7c841fa583706$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4HBpa.useRef(false);
    let location = (0, $c03a1ed858071efe$export$45d76561a5302f2b)();
    let searchParams = $4HBpa.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $13f7c841fa583706$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $c03a1ed858071efe$export$9770f232ac06a008)();
    let setSearchParams = $4HBpa.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $13f7c841fa583706$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $13f7c841fa583706$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $13f7c841fa583706$var$fetcherId = 0;
let $13f7c841fa583706$var$getUniqueFetcherId = ()=>"__" + String(++$13f7c841fa583706$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $13f7c841fa583706$export$47c85c6e3a081d3() {
    let { router: router } = $13f7c841fa583706$var$useDataRouterContext($13f7c841fa583706$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4HBpa.useContext((0, $c03a1ed858071efe$export$26749e8557646306));
    let currentRouteId = (0, $c03a1ed858071efe$export$5fc8298006ad9e58)();
    return $4HBpa.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $13f7c841fa583706$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $13f7c841fa583706$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $13f7c841fa583706$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $13f7c841fa583706$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4HBpa.useContext((0, $c03a1ed858071efe$export$26749e8557646306));
    let routeContext = $4HBpa.useContext((0, $c03a1ed858071efe$export$9072aa6dd1f93057));
    !routeContext && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $13f7c841fa583706$var$_extends({}, (0, $c03a1ed858071efe$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $c03a1ed858071efe$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $c0e7f593a2d56a40$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $c0e7f593a2d56a40$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $13f7c841fa583706$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $13f7c841fa583706$var$useDataRouterContext($13f7c841fa583706$var$DataRouterHook.UseFetcher);
    let state = $13f7c841fa583706$var$useDataRouterState($13f7c841fa583706$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4HBpa.useContext($13f7c841fa583706$export$148fd98d095596d4);
    let route = $4HBpa.useContext((0, $c03a1ed858071efe$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    !route && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $13f7c841fa583706$var$useIdImpl ? $13f7c841fa583706$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4HBpa.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($13f7c841fa583706$var$getUniqueFetcherId());
    // Registration/cleanup
    $4HBpa.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4HBpa.useCallback((href, opts)=>{
        !routeId && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $13f7c841fa583706$export$47c85c6e3a081d3();
    let submit = $4HBpa.useCallback((target, opts)=>{
        submitImpl(target, $13f7c841fa583706$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4HBpa.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4HBpa.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4HBpa.createElement($13f7c841fa583706$export$a7fed597f4b8afd8, $13f7c841fa583706$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $c0e7f593a2d56a40$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4HBpa.useMemo(()=>$13f7c841fa583706$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $13f7c841fa583706$export$fa996778a3a31087() {
    let state = $13f7c841fa583706$var$useDataRouterState($13f7c841fa583706$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $13f7c841fa583706$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $13f7c841fa583706$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $13f7c841fa583706$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $13f7c841fa583706$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $13f7c841fa583706$var$useDataRouterContext($13f7c841fa583706$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $13f7c841fa583706$var$useDataRouterState($13f7c841fa583706$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4HBpa.useContext((0, $c03a1ed858071efe$export$26749e8557646306));
    let location = (0, $c03a1ed858071efe$export$45d76561a5302f2b)();
    let matches = (0, $c03a1ed858071efe$export$2378eb7f5ff86053)();
    let navigation = (0, $c03a1ed858071efe$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4HBpa.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $13f7c841fa583706$var$usePageHide($4HBpa.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $13f7c841fa583706$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $13f7c841fa583706$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($13f7c841fa583706$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4HBpa.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $13f7c841fa583706$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $13f7c841fa583706$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4HBpa.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($13f7c841fa583706$var$_extends({}, location, {
                    pathname: (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($13f7c841fa583706$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4HBpa.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $13f7c841fa583706$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4HBpa.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $13f7c841fa583706$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4HBpa.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $13f7c841fa583706$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $c03a1ed858071efe$export$b273b3273281a049)(when);
    $4HBpa.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4HBpa.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $13f7c841fa583706$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4HBpa.useContext($13f7c841fa583706$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $c0e7f593a2d56a40$export$3e9cee6b33872309)(false);
    let { basename: basename } = $13f7c841fa583706$var$useDataRouterContext($13f7c841fa583706$var$DataRouterHook.useViewTransitionState);
    let path = (0, $c03a1ed858071efe$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $c0e7f593a2d56a40$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $c0e7f593a2d56a40$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $c0e7f593a2d56a40$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $b2d204ad2c8a6909$exports = {};
var $b2d204ad2c8a6909$var$e, $b2d204ad2c8a6909$var$t, $b2d204ad2c8a6909$var$r, $b2d204ad2c8a6909$var$n, $b2d204ad2c8a6909$var$a, $b2d204ad2c8a6909$var$i, $b2d204ad2c8a6909$var$o, $b2d204ad2c8a6909$var$c, $b2d204ad2c8a6909$var$l, $b2d204ad2c8a6909$var$s, $b2d204ad2c8a6909$var$u, $b2d204ad2c8a6909$var$d, $b2d204ad2c8a6909$var$f, $b2d204ad2c8a6909$var$p, $b2d204ad2c8a6909$var$v, $b2d204ad2c8a6909$var$h, $b2d204ad2c8a6909$var$m, $b2d204ad2c8a6909$var$y, $b2d204ad2c8a6909$var$b, $b2d204ad2c8a6909$var$g, $b2d204ad2c8a6909$var$w, $b2d204ad2c8a6909$var$j, $b2d204ad2c8a6909$var$O, $b2d204ad2c8a6909$var$x, $b2d204ad2c8a6909$var$_, $b2d204ad2c8a6909$var$P, $b2d204ad2c8a6909$var$k, $b2d204ad2c8a6909$var$T, $b2d204ad2c8a6909$var$E, $b2d204ad2c8a6909$var$S, $b2d204ad2c8a6909$var$I, $b2d204ad2c8a6909$var$N, $b2d204ad2c8a6909$var$C, $b2d204ad2c8a6909$var$D, $b2d204ad2c8a6909$var$M, $b2d204ad2c8a6909$var$q, $b2d204ad2c8a6909$var$Y, $b2d204ad2c8a6909$var$L, $b2d204ad2c8a6909$var$z, $b2d204ad2c8a6909$var$A, $b2d204ad2c8a6909$var$R, $b2d204ad2c8a6909$var$U, $b2d204ad2c8a6909$var$F, $b2d204ad2c8a6909$var$B, $b2d204ad2c8a6909$var$W, $b2d204ad2c8a6909$var$V, $b2d204ad2c8a6909$var$H, $b2d204ad2c8a6909$var$G, $b2d204ad2c8a6909$var$J, $b2d204ad2c8a6909$var$K, $b2d204ad2c8a6909$var$Q, $b2d204ad2c8a6909$var$X, $b2d204ad2c8a6909$var$Z, $b2d204ad2c8a6909$var$$, $b2d204ad2c8a6909$var$ee, $b2d204ad2c8a6909$var$et, $b2d204ad2c8a6909$var$er, $b2d204ad2c8a6909$var$en, $b2d204ad2c8a6909$var$ea, $b2d204ad2c8a6909$var$ei, $b2d204ad2c8a6909$var$eo, $b2d204ad2c8a6909$var$ec, $b2d204ad2c8a6909$var$el, $b2d204ad2c8a6909$var$es, $b2d204ad2c8a6909$var$eu, $b2d204ad2c8a6909$var$ed, $b2d204ad2c8a6909$var$ef, $b2d204ad2c8a6909$var$ep, $b2d204ad2c8a6909$var$ev, $b2d204ad2c8a6909$var$eh, $b2d204ad2c8a6909$var$em, $b2d204ad2c8a6909$var$ey, $b2d204ad2c8a6909$var$eb, $b2d204ad2c8a6909$var$eg, $b2d204ad2c8a6909$var$ew, $b2d204ad2c8a6909$var$ej, $b2d204ad2c8a6909$var$eO, $b2d204ad2c8a6909$var$ex, $b2d204ad2c8a6909$var$e_, $b2d204ad2c8a6909$var$eP, $b2d204ad2c8a6909$var$ek, $b2d204ad2c8a6909$var$eT;
var $88421859e416994d$export$71511d61b312f219;
"use strict";
var $317f0c7ab7314098$export$71511d61b312f219;
"use strict";
function $317f0c7ab7314098$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
$317f0c7ab7314098$export$71511d61b312f219 = $317f0c7ab7314098$var$_array_with_holes;


var $9a7f4039c2c4b428$export$71511d61b312f219;
"use strict";
function $9a7f4039c2c4b428$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$9a7f4039c2c4b428$export$71511d61b312f219 = $9a7f4039c2c4b428$var$_iterable_to_array_limit;


var $a652b11a0669eeee$export$71511d61b312f219;
"use strict";
function $a652b11a0669eeee$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a652b11a0669eeee$export$71511d61b312f219 = $a652b11a0669eeee$var$_non_iterable_rest;


var $f1cf903cb1bf4289$export$71511d61b312f219;
"use strict";
var $44834f70a345b0ad$export$71511d61b312f219;
"use strict";
function $44834f70a345b0ad$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$44834f70a345b0ad$export$71511d61b312f219 = $44834f70a345b0ad$var$_array_like_to_array;


function $f1cf903cb1bf4289$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $44834f70a345b0ad$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $44834f70a345b0ad$export$71511d61b312f219(o, minLen);
}
$f1cf903cb1bf4289$export$71511d61b312f219 = $f1cf903cb1bf4289$var$_unsupported_iterable_to_array;


function $88421859e416994d$var$_sliced_to_array(arr, i) {
    return $317f0c7ab7314098$export$71511d61b312f219(arr) || $9a7f4039c2c4b428$export$71511d61b312f219(arr, i) || $f1cf903cb1bf4289$export$71511d61b312f219(arr, i) || $a652b11a0669eeee$export$71511d61b312f219();
}
$88421859e416994d$export$71511d61b312f219 = $88421859e416994d$var$_sliced_to_array;


var $41564e795f0c9d63$export$71511d61b312f219;
"use strict";
var $15c8b93faf6f64a7$export$71511d61b312f219;
"use strict";

function $15c8b93faf6f64a7$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $44834f70a345b0ad$export$71511d61b312f219(arr);
}
$15c8b93faf6f64a7$export$71511d61b312f219 = $15c8b93faf6f64a7$var$_array_without_holes;


var $46ab3626cd043009$export$71511d61b312f219;
"use strict";
function $46ab3626cd043009$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$46ab3626cd043009$export$71511d61b312f219 = $46ab3626cd043009$var$_iterable_to_array;


var $9bb99bddc1daca06$export$71511d61b312f219;
"use strict";
function $9bb99bddc1daca06$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9bb99bddc1daca06$export$71511d61b312f219 = $9bb99bddc1daca06$var$_non_iterable_spread;



function $41564e795f0c9d63$var$_to_consumable_array(arr) {
    return $15c8b93faf6f64a7$export$71511d61b312f219(arr) || $46ab3626cd043009$export$71511d61b312f219(arr) || $f1cf903cb1bf4289$export$71511d61b312f219(arr) || $9bb99bddc1daca06$export$71511d61b312f219();
}
$41564e795f0c9d63$export$71511d61b312f219 = $41564e795f0c9d63$var$_to_consumable_array;



var $46a03b660b5bd4f2$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $46a03b660b5bd4f2$exports) {
        classNames.default = classNames;
        $46a03b660b5bd4f2$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $0fbfbb0e88863202$export$71511d61b312f219;
"use strict";
function $0fbfbb0e88863202$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$0fbfbb0e88863202$export$71511d61b312f219 = $0fbfbb0e88863202$var$_assert_this_initialized;


var $a3e0d6b297546463$export$71511d61b312f219;
"use strict";
function $a3e0d6b297546463$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$a3e0d6b297546463$export$71511d61b312f219 = $a3e0d6b297546463$var$_class_call_check;


var $d828c11bd1c1c0bb$export$71511d61b312f219;
"use strict";
function $d828c11bd1c1c0bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d828c11bd1c1c0bb$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $d828c11bd1c1c0bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d828c11bd1c1c0bb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
$d828c11bd1c1c0bb$export$71511d61b312f219 = $d828c11bd1c1c0bb$var$_create_class;


var $cd0a83c7e6f027c0$export$71511d61b312f219;
"use strict";
var $b5ec57665330634d$export$71511d61b312f219;
"use strict";
function $b5ec57665330634d$var$_set_prototype_of(o, p) {
    $b5ec57665330634d$export$71511d61b312f219 = $b5ec57665330634d$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b5ec57665330634d$var$_set_prototype_of(o, p);
}
$b5ec57665330634d$export$71511d61b312f219 = $b5ec57665330634d$var$_set_prototype_of;


function $cd0a83c7e6f027c0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b5ec57665330634d$export$71511d61b312f219(subClass, superClass);
}
$cd0a83c7e6f027c0$export$71511d61b312f219 = $cd0a83c7e6f027c0$var$_inherits;


var $f44768c4e043f9d2$export$71511d61b312f219;
"use strict";
var $b68705b1e088022e$export$71511d61b312f219;
"use strict";
function $b68705b1e088022e$var$_get_prototype_of(o) {
    $b68705b1e088022e$export$71511d61b312f219 = $b68705b1e088022e$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b68705b1e088022e$var$_get_prototype_of(o);
}
$b68705b1e088022e$export$71511d61b312f219 = $b68705b1e088022e$var$_get_prototype_of;


var $c37185e15892315d$export$71511d61b312f219;
"use strict";
function $c37185e15892315d$var$_is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$c37185e15892315d$export$71511d61b312f219 = $c37185e15892315d$var$_is_native_reflect_construct;


var $6f16b83a96f260d1$export$71511d61b312f219;
"use strict";

var $0d42f84d7422b820$export$71511d61b312f219;
"use strict";
function $0d42f84d7422b820$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
$0d42f84d7422b820$export$71511d61b312f219 = $0d42f84d7422b820$var$_type_of;


function $6f16b83a96f260d1$var$_possible_constructor_return(self, call) {
    if (call && ($0d42f84d7422b820$export$71511d61b312f219(call) === "object" || typeof call === "function")) return call;
    return $0fbfbb0e88863202$export$71511d61b312f219(self);
}
$6f16b83a96f260d1$export$71511d61b312f219 = $6f16b83a96f260d1$var$_possible_constructor_return;


function $f44768c4e043f9d2$var$_create_super(Derived) {
    var hasNativeReflectConstruct = $c37185e15892315d$export$71511d61b312f219();
    return function _createSuperInternal() {
        var Super = $b68705b1e088022e$export$71511d61b312f219(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b68705b1e088022e$export$71511d61b312f219(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6f16b83a96f260d1$export$71511d61b312f219(this, result);
    };
}
$f44768c4e043f9d2$export$71511d61b312f219 = $f44768c4e043f9d2$var$_create_super;



var $4HBpa = parcelRequire("4HBpa");
var $37311d2b72b65959$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $37311d2b72b65959$var$_self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $37311d2b72b65959$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if ("currentScript" in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($37311d2b72b65959$var$_self);
if (0, $37311d2b72b65959$exports) $37311d2b72b65959$exports = $37311d2b72b65959$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== "undefined") $parcel$global.Prism = $37311d2b72b65959$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $37311d2b72b65959$var$Prism.languages.markup = {
    "comment": {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    "prolog": {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    "doctype": {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            "string": {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            "punctuation": /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            "name": /[^\s<>'"]+/
        }
    },
    "cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    "tag": {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            "tag": {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    "punctuation": /^<\/?/,
                    "namespace": /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    "punctuation": [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            "punctuation": /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    "namespace": /^[^\s>\/:]+:/
                }
            }
        }
    },
    "entity": [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$37311d2b72b65959$var$Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = $37311d2b72b65959$var$Prism.languages.markup["entity"];
$37311d2b72b65959$var$Prism.languages.markup["doctype"].inside["internal-subset"].inside = $37311d2b72b65959$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$37311d2b72b65959$var$Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
Object.defineProperty($37311d2b72b65959$var$Prism.languages.markup.tag, "addInlined", {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside["language-" + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $37311d2b72b65959$var$Prism.languages[lang]
        };
        includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside["language-" + lang] = {
            pattern: /[\s\S]+/,
            inside: $37311d2b72b65959$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $37311d2b72b65959$var$Prism.languages.insertBefore("markup", "cdata", def);
    }
});
Object.defineProperty($37311d2b72b65959$var$Prism.languages.markup.tag, "addAttribute", {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $37311d2b72b65959$var$Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        "value": {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                "language-" + lang
                            ],
                            inside: $37311d2b72b65959$var$Prism.languages[lang]
                        },
                        "punctuation": [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$37311d2b72b65959$var$Prism.languages.html = $37311d2b72b65959$var$Prism.languages.markup;
$37311d2b72b65959$var$Prism.languages.mathml = $37311d2b72b65959$var$Prism.languages.markup;
$37311d2b72b65959$var$Prism.languages.svg = $37311d2b72b65959$var$Prism.languages.markup;
$37311d2b72b65959$var$Prism.languages.xml = $37311d2b72b65959$var$Prism.languages.extend("markup", {});
$37311d2b72b65959$var$Prism.languages.ssml = $37311d2b72b65959$var$Prism.languages.xml;
$37311d2b72b65959$var$Prism.languages.atom = $37311d2b72b65959$var$Prism.languages.xml;
$37311d2b72b65959$var$Prism.languages.rss = $37311d2b72b65959$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        "comment": /\/\*[\s\S]*?\*\//,
        "atrule": {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                "rule": /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                "keyword": {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        "url": {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                "function": /^url/i,
                "punctuation": /^\(|\)$/,
                "string": {
                    pattern: RegExp("^" + string.source + "$"),
                    alias: "url"
                }
            }
        },
        "selector": {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        "string": {
            pattern: string,
            greedy: true
        },
        "property": {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        "important": /!important\b/i,
        "function": {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        "punctuation": /[(){};:,]/
    };
    Prism.languages.css["atrule"].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined("style", "css");
        markup.tag.addAttribute("style", "css");
    }
})($37311d2b72b65959$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $37311d2b72b65959$var$Prism.languages.clike = {
    "comment": [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    "string": {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            "punctuation": /[.\\]/
        }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $37311d2b72b65959$var$Prism.languages.javascript = $37311d2b72b65959$var$Prism.languages.extend("clike", {
    "class-name": [
        $37311d2b72b65959$var$Prism.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    "keyword": [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$37311d2b72b65959$var$Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$37311d2b72b65959$var$Prism.languages.insertBefore("javascript", "keyword", {
    "regex": {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $37311d2b72b65959$var$Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    "parameter": [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $37311d2b72b65959$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $37311d2b72b65959$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $37311d2b72b65959$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $37311d2b72b65959$var$Prism.languages.javascript
        }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$37311d2b72b65959$var$Prism.languages.insertBefore("javascript", "string", {
    "hashbang": {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            "interpolation": {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $37311d2b72b65959$var$Prism.languages.javascript
                }
            },
            "string": /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
});
$37311d2b72b65959$var$Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
});
if ($37311d2b72b65959$var$Prism.languages.markup) {
    $37311d2b72b65959$var$Prism.languages.markup.tag.addInlined("script", "javascript");
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $37311d2b72b65959$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
}
$37311d2b72b65959$var$Prism.languages.js = $37311d2b72b65959$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $37311d2b72b65959$var$Prism === "undefined" || typeof document === "undefined") return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + " while fetching file: " + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        "js": "javascript",
        "py": "python",
        "rb": "ruby",
        "ps1": "powershell",
        "psm1": "powershell",
        "sh": "bash",
        "bat": "batch",
        "h": "c",
        "tex": "latex"
    };
    var STATUS_ATTR = "data-src-status";
    var STATUS_LOADING = "loading";
    var STATUS_LOADED = "loaded";
    var STATUS_FAILED = "failed";
    var SELECTOR = "pre[data-src]:not([" + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ":not([" + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || "");
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $37311d2b72b65959$var$Prism.hooks.add("before-highlightall", function(env) {
        env.selector += ", " + SELECTOR;
    });
    $37311d2b72b65959$var$Prism.hooks.add("before-sanity-check", function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ""; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement("CODE"));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute("data-src");
            var language = env.language;
            if (language === "none") {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    "none"
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $37311d2b72b65959$var$Prism.util.setLanguage(code, language);
            $37311d2b72b65959$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $37311d2b72b65959$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute("data-range"));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join("\n");
                    // add data-start for line numbers
                    if (!pre.hasAttribute("data-start")) pre.setAttribute("data-start", String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $37311d2b72b65959$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $37311d2b72b65959$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$37311d2b72b65959$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $37311d2b72b65959$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.");
            logged = true;
        }
        $37311d2b72b65959$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


var $48df8688b246b15a$exports = {};
"use strict";
Object.defineProperty($48df8688b246b15a$exports, "__esModule", {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $1b6e982017e6de16$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $1b6e982017e6de16$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($1b6e982017e6de16$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($1b6e982017e6de16$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}



var $4HBpa = parcelRequire("4HBpa");
var $6abf8cb115d57217$exports = {};
"use strict";
var $6abf8cb115d57217$var$__assign = $6abf8cb115d57217$exports && $6abf8cb115d57217$exports.__assign || function() {
    $6abf8cb115d57217$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6abf8cb115d57217$var$__assign.apply(this, arguments);
};
var $6abf8cb115d57217$var$__spreadArrays = $6abf8cb115d57217$exports && $6abf8cb115d57217$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($6abf8cb115d57217$exports, "__esModule", {
    value: true
});
var $6abf8cb115d57217$var$seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function $6abf8cb115d57217$var$isObj(value) {
    var type = typeof value;
    return value !== null && (type === "object" || type === "function");
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function $6abf8cb115d57217$var$isRegexp(value) {
    return Object.prototype.toString.call(value) === "[object RegExp]";
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function $6abf8cb115d57217$var$getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function $6abf8cb115d57217$var$prettyPrint(input, options, pad) {
    if (pad === void 0) pad = "";
    // sensible option defaults
    var defaultOptions = {
        indent: "	",
        singleQuotes: true
    };
    var combinedOptions = $6abf8cb115d57217$var$__assign($6abf8cb115d57217$var$__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: "\n",
        newLineOrSpace: "\n",
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: "@@__PRETTY_PRINT_NEW_LINE__@@",
        newLineOrSpace: "@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@",
        pad: "@@__PRETTY_PRINT_PAD__@@",
        indent: "@@__PRETTY_PRINT_INDENT__@@"
    };
    var expandWhiteSpace = function(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, "g"), "").replace(new RegExp(tokens.newLineOrSpace, "g"), " ").replace(new RegExp(tokens.pad + "|" + tokens.indent, "g"), "");
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + "|" + tokens.newLineOrSpace, "g"), "\n").replace(new RegExp(tokens.pad, "g"), pad).replace(new RegExp(tokens.indent, "g"), pad + combinedOptions.indent);
    };
    if ($6abf8cb115d57217$var$seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === "number" || typeof input === "boolean" || typeof input === "function" || typeof input === "symbol" || $6abf8cb115d57217$var$isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('" + input.toISOString() + "')";
    if (Array.isArray(input)) {
        if (input.length === 0) return "[]";
        $6abf8cb115d57217$var$seen.push(input);
        var ret = "[" + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : "," + tokens.newLineOrSpace;
            var value = $6abf8cb115d57217$var$prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join("") + tokens.pad + "]";
        $6abf8cb115d57217$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    if ($6abf8cb115d57217$var$isObj(input)) {
        var objKeys_1 = $6abf8cb115d57217$var$__spreadArrays(Object.keys(input), $6abf8cb115d57217$var$getOwnEnumPropSymbols(input));
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return "{}";
        $6abf8cb115d57217$var$seen.push(input);
        var ret = "{" + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : "," + tokens.newLineOrSpace;
            var isSymbol = typeof el === "symbol";
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : $6abf8cb115d57217$var$prettyPrint(el, combinedOptions);
            var value = $6abf8cb115d57217$var$prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ": " + value + eol;
        }).join("") + tokens.pad + "}";
        $6abf8cb115d57217$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === "\n" ? "\\n" : "\\r";
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return '"' + input + '"';
    }
    input = input.replace(/\\?'/g, "\\'");
    return "'" + input + "'";
}
$6abf8cb115d57217$exports.prettyPrint = $6abf8cb115d57217$var$prettyPrint;


var $7902089e2b9a7e98$exports = {};
"use strict";

$7902089e2b9a7e98$exports = (parcelRequire("gwgqN"));


function $48df8688b246b15a$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
function $48df8688b246b15a$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== "default") {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var $48df8688b246b15a$var$React__namespace = /*#__PURE__*/ $48df8688b246b15a$var$_interopNamespace($4HBpa);
var $48df8688b246b15a$var$React__default = /*#__PURE__*/ $48df8688b246b15a$var$_interopDefaultLegacy($4HBpa);
var $48df8688b246b15a$var$spacer = function(times, tabStop) {
    if (times === 0) return "";
    return new Array(times * tabStop).fill(" ").join("");
};
function $48df8688b246b15a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $48df8688b246b15a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $48df8688b246b15a$var$_typeof(obj);
}
function $48df8688b246b15a$var$_toConsumableArray(arr) {
    return $48df8688b246b15a$var$_arrayWithoutHoles(arr) || $48df8688b246b15a$var$_iterableToArray(arr) || $48df8688b246b15a$var$_unsupportedIterableToArray(arr) || $48df8688b246b15a$var$_nonIterableSpread();
}
function $48df8688b246b15a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $48df8688b246b15a$var$_arrayLikeToArray(arr);
}
function $48df8688b246b15a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $48df8688b246b15a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $48df8688b246b15a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $48df8688b246b15a$var$_arrayLikeToArray(o, minLen);
}
function $48df8688b246b15a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $48df8688b246b15a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $48df8688b246b15a$var$safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || $48df8688b246b15a$var$_typeof(value) !== "object") return value;
     // return date, regexp and react element values as is
    if (value instanceof Date || value instanceof RegExp || /*#__PURE__*/ $48df8688b246b15a$var$React__namespace.isValidElement(value)) return value;
    seen.add(value); // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return $48df8688b246b15a$var$safeSortObject(v, seen);
    });
     // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === "_owner") return result;
        if (key === "current" || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = "[Circular]";
        else // eslint-disable-next-line no-param-reassign
        result[key] = $48df8688b246b15a$var$safeSortObject(value[key], seen);
        return result;
    }, {});
}
function $48df8688b246b15a$var$sortObject(value) {
    return $48df8688b246b15a$var$safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var $48df8688b246b15a$var$createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: "string",
        value: value
    };
};
var $48df8688b246b15a$var$createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: "number",
        value: value
    };
};
var $48df8688b246b15a$var$createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: "ReactElement",
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var $48df8688b246b15a$var$createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: "ReactFragment",
        key: key,
        childrens: childrens
    };
};
var $48df8688b246b15a$var$supportFragment = Boolean($4HBpa.Fragment);
var $48df8688b246b15a$var$getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === "_default") return "No Display Name";
    return functionType.name;
};
var $48df8688b246b15a$var$getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === $7902089e2b9a7e98$exports.Memo:
            return getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === $7902089e2b9a7e98$exports.ForwardRef:
            return getWrappedComponentDisplayName(Component.render);
        default:
            return $48df8688b246b15a$var$getFunctionTypeName(Component);
    }
}; // heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var $48df8688b246b15a$var$getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === "string":
            return element.type;
        case typeof element.type === "function":
            if (element.type.displayName) return element.type.displayName;
            return $48df8688b246b15a$var$getFunctionTypeName(element.type);
        case $7902089e2b9a7e98$exports.isForwardRef(element):
        case $7902089e2b9a7e98$exports.isMemo(element):
            return $48df8688b246b15a$var$getWrappedComponentDisplayName(element.type);
        case $7902089e2b9a7e98$exports.isContextConsumer(element):
            return "".concat(element.type._context.displayName || "Context", ".Consumer");
        case $7902089e2b9a7e98$exports.isContextProvider(element):
            return "".concat(element.type._context.displayName || "Context", ".Provider");
        case $7902089e2b9a7e98$exports.isLazy(element):
            return "Lazy";
        case $7902089e2b9a7e98$exports.isProfiler(element):
            return "Profiler";
        case $7902089e2b9a7e98$exports.isStrictMode(element):
            return "StrictMode";
        case $7902089e2b9a7e98$exports.isSuspense(element):
            return "Suspense";
        default:
            return "UnknownElementType";
    }
};
var $48df8688b246b15a$var$noChildren = function noChildren(propsValue, propName) {
    return propName !== "children";
};
var $48df8688b246b15a$var$onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== "";
};
var $48df8688b246b15a$var$filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var $48df8688b246b15a$var$parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? $48df8688b246b15a$var$getReactElementDisplayName : _options$displayName;
    if (typeof element === "string") return $48df8688b246b15a$var$createStringTreeNode(element);
    else if (typeof element === "number") return $48df8688b246b15a$var$createNumberTreeNode(element);
    else if (!/*#__PURE__*/ $48df8688b246b15a$var$React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat($48df8688b246b15a$var$_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = $48df8688b246b15a$var$filterProps(element.props, $48df8688b246b15a$var$noChildren);
    if (element.ref !== null) props.ref = element.ref;
    var key = element.key;
    if (typeof key === "string" && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = $48df8688b246b15a$var$filterProps(element.type.defaultProps || {}, $48df8688b246b15a$var$noChildren);
    var childrens = $48df8688b246b15a$var$React__default["default"].Children.toArray(element.props.children).filter($48df8688b246b15a$var$onlyMeaningfulChildren).map(function(child) {
        return parseReactElement(child, options);
    });
    if ($48df8688b246b15a$var$supportFragment && element.type === $4HBpa.Fragment) return $48df8688b246b15a$var$createReactFragmentTreeNode(key, childrens);
    return $48df8688b246b15a$var$createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function $48df8688b246b15a$var$noRefCheck() {}
var $48df8688b246b15a$var$inlineFunction = function inlineFunction(fn) {
    return fn.toString().split("\n").map(function(line) {
        return line.trim();
    }).join("");
};
var $48df8688b246b15a$var$preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var $48df8688b246b15a$var$defaultFunctionValue = $48df8688b246b15a$var$inlineFunction;
var $48df8688b246b15a$var$formatFunction = function(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? $48df8688b246b15a$var$defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === $48df8688b246b15a$var$defaultFunctionValue) return functionValue($48df8688b246b15a$var$noRefCheck);
    return functionValue(fn);
};
var $48df8688b246b15a$var$formatComplexDataStructure = function(value, inline, lvl, options) {
    var normalizedValue = $48df8688b246b15a$var$sortObject(value);
    var stringifiedValue = $6abf8cb115d57217$exports.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ $4HBpa.isValidElement(currentValue)) return $48df8688b246b15a$var$formatTreeNode($48df8688b246b15a$var$parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === "function") return $48df8688b246b15a$var$formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, " ").replace(/{ /g, "{").replace(/ }/g, "}").replace(/\[ /g, "[").replace(/ ]/g, "]");
     // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, $48df8688b246b15a$var$spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat($48df8688b246b15a$var$spacer(lvl + 1, options.tabStop), "$1"));
};
var $48df8688b246b15a$var$escape$1 = function escape(s) {
    return s.replace(/"/g, "&quot;");
};
var $48df8688b246b15a$var$formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === "number") return "{".concat(String(propValue), "}");
    if (typeof propValue === "string") return '"'.concat($48df8688b246b15a$var$escape$1(propValue), '"');
     // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ($48df8688b246b15a$var$_typeof(propValue) === "symbol") {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, "$1");
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === "function") return "{".concat($48df8688b246b15a$var$formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ $4HBpa.isValidElement(propValue)) return "{".concat($48df8688b246b15a$var$formatTreeNode($48df8688b246b15a$var$parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return '{new Date("'.concat(propValue.toISOString(), '")}');
    }
    if ($1b6e982017e6de16$export$53b83ca8eaab0383(propValue) || Array.isArray(propValue)) return "{".concat($48df8688b246b15a$var$formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var $48df8688b246b15a$var$formatProp = function(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error('The prop "'.concat(name, '" has no value and no default: could not be formatted'));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = $48df8688b246b15a$var$formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = " ";
    var attributeFormattedMultiline = "\n".concat($48df8688b246b15a$var$spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes("\n");
    if (useBooleanShorthandSyntax && formattedPropValue === "{false}" && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = "";
        attributeFormattedMultiline = "";
    } else if (useBooleanShorthandSyntax && formattedPropValue === "{true}") {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var $48df8688b246b15a$var$mergeSiblingPlainStringChildrenReducer = function(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === "string" || currentNode.type === "number") && (previousNode.type === "string" || previousNode.type === "number")) nodes.push($48df8688b246b15a$var$createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var $48df8688b246b15a$var$isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        "key",
        "ref"
    ].includes(propName);
};
var $48df8688b246b15a$var$sortPropsByNames = function(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes("key");
        var haveRefProp = props.includes("ref");
        var userPropsOnly = props.filter(function(oneProp) {
            return !$48df8688b246b15a$var$isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? $48df8688b246b15a$var$_toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : $48df8688b246b15a$var$_toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift("ref");
        if (haveKeyProp) sortedProps.unshift("key");
        return sortedProps;
    };
};
function $48df8688b246b15a$var$createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var $48df8688b246b15a$var$compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === "string") return formattedElement.split("\n").map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat($48df8688b246b15a$var$spacer(lvl, tabStop)).concat(line);
    }).join("\n");
    return formattedElement;
};
var $48df8688b246b15a$var$formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return $48df8688b246b15a$var$compensateMultilineStringElementIndentation(element, $48df8688b246b15a$var$formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var $48df8688b246b15a$var$onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var $48df8688b246b15a$var$isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return $48df8688b246b15a$var$spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var $48df8688b246b15a$var$shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return ($48df8688b246b15a$var$isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var $48df8688b246b15a$var$formatReactElementNode = function(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? "" : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== "ReactElement") throw new Error('The "formatReactElementNode" function could only format node of type "ReactElement". Given:  '.concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = $48df8688b246b15a$var$createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter($48df8688b246b15a$var$onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = $48df8688b246b15a$var$sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = $48df8688b246b15a$var$formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat($48df8688b246b15a$var$spacer(lvl, tabStop));
    if ($48df8688b246b15a$var$shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += ">";
        if (!inline) {
            out += "\n";
            out += $48df8688b246b15a$var$spacer(newLvl, tabStop);
        }
        out += childrens.reduce($48df8688b246b15a$var$mergeSiblingPlainStringChildrenReducer, []).map($48df8688b246b15a$var$formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat($48df8688b246b15a$var$spacer(newLvl, tabStop)) : "");
        if (!inline) {
            out += "\n";
            out += $48df8688b246b15a$var$spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!$48df8688b246b15a$var$isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += " ";
        out += "/>";
    }
    return out;
};
var $48df8688b246b15a$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = "";
var $48df8688b246b15a$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = "React.Fragment";
var $48df8688b246b15a$var$toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: "ReactElement",
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var $48df8688b246b15a$var$isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var $48df8688b246b15a$var$hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var $48df8688b246b15a$var$formatReactFragmentNode = function(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== "ReactFragment") throw new Error('The "formatReactFragmentNode" function could only format node of type "ReactFragment". Given: '.concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if ($48df8688b246b15a$var$hasNoChildren(node) || $48df8688b246b15a$var$isKeyedFragment(node)) displayName = $48df8688b246b15a$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = $48df8688b246b15a$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = $48df8688b246b15a$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return $48df8688b246b15a$var$formatReactElementNode($48df8688b246b15a$var$toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var $48df8688b246b15a$var$jsxStopChars = [
    "<",
    ">",
    "{",
    "}"
];
var $48df8688b246b15a$var$shouldBeEscaped = function shouldBeEscaped(s) {
    return $48df8688b246b15a$var$jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var $48df8688b246b15a$var$escape = function escape(s) {
    if (!$48df8688b246b15a$var$shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var $48df8688b246b15a$var$preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(" ")) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(" ")) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var $48df8688b246b15a$var$formatTreeNode = function(node, inline, lvl, options) {
    if (node.type === "number") return String(node.value);
    if (node.type === "string") return node.value ? "".concat($48df8688b246b15a$var$preserveTrailingSpace($48df8688b246b15a$var$escape(String(node.value)))) : "";
    if (node.type === "ReactElement") return $48df8688b246b15a$var$formatReactElementNode(node, inline, lvl, options);
    if (node.type === "ReactFragment") return $48df8688b246b15a$var$formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError('Unknow format type "'.concat(node.type, '"'));
};
var $48df8688b246b15a$var$formatTree = function(node, options) {
    return $48df8688b246b15a$var$formatTreeNode(node, false, 0, options);
};
var $48df8688b246b15a$var$reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error("react-element-to-jsx-string: Expected a ReactElement");
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return $48df8688b246b15a$var$formatTree($48df8688b246b15a$var$parseReactElement(element, options), options);
};
$48df8688b246b15a$exports["default"] = $48df8688b246b15a$var$reactElementToJsxString;
$48df8688b246b15a$exports.inlineFunction = $48df8688b246b15a$var$inlineFunction;
$48df8688b246b15a$exports.preserveFunctionLineBreak = $48df8688b246b15a$var$preserveFunctionLineBreak;


var $e851e88da3cfd192$export$71511d61b312f219;
"use strict";
var $334ab200e86084f6$export$71511d61b312f219;
"use strict";


function $334ab200e86084f6$var$_construct(Parent, args, Class) {
    if ($c37185e15892315d$export$71511d61b312f219()) $334ab200e86084f6$export$71511d61b312f219 = $334ab200e86084f6$var$_construct = Reflect.construct;
    else $334ab200e86084f6$export$71511d61b312f219 = $334ab200e86084f6$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $b5ec57665330634d$export$71511d61b312f219(instance, Class.prototype);
        return instance;
    };
    return $334ab200e86084f6$var$_construct.apply(null, arguments);
}
$334ab200e86084f6$export$71511d61b312f219 = $334ab200e86084f6$var$_construct;



var $c86ac613f32a3f1a$export$71511d61b312f219;
"use strict";
function $c86ac613f32a3f1a$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
$c86ac613f32a3f1a$export$71511d61b312f219 = $c86ac613f32a3f1a$var$_is_native_function;



function $e851e88da3cfd192$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e851e88da3cfd192$export$71511d61b312f219 = $e851e88da3cfd192$var$_wrap_native_super = function(Class) {
        if (Class === null || !$c86ac613f32a3f1a$export$71511d61b312f219(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $334ab200e86084f6$export$71511d61b312f219(Class, arguments, $b68705b1e088022e$export$71511d61b312f219(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $b5ec57665330634d$export$71511d61b312f219(Wrapper, Class);
    };
    return $e851e88da3cfd192$var$_wrap_native_super(Class);
}
$e851e88da3cfd192$export$71511d61b312f219 = $e851e88da3cfd192$var$_wrap_native_super;


function $630535246db4a983$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $630535246db4a983$var$$22de11b45b0eeb97$exports = {};
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $630535246db4a983$export$c7e91f8aec23ae14;
});
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $630535246db4a983$export$51ca94569b882c51;
});
class $630535246db4a983$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $630535246db4a983$export$51ca94569b882c51 = ()=>new $630535246db4a983$export$c7e91f8aec23ae14();
var $630535246db4a983$var$$e3640f413e0c36e7$exports = {};
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $630535246db4a983$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
class $630535246db4a983$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $630535246db4a983$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $630535246db4a983$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) queue[queue.length - 1].reject(reason), done = true;
                if (canceler) canceler();
            },
            complete () {
                if (!done) queue[queue.length - 1].resolve(), done = true;
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug);
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error);
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === "function") target.on(name, next).on("error", error);
            else {
                target.addEventListener(name, next);
                target.addEventListener("error", error);
            }
            return ()=>{
                if (typeof target.off === "function") target.off(name, next).off("error", error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener("error", error);
                }
            };
        });
    }
}
var $630535246db4a983$var$$603f33a01a36ab56$exports = {};
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $630535246db4a983$export$d16acf4b6e75743d;
});
function $630535246db4a983$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $630535246db4a983$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $630535246db4a983$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}



var $kAoxL = parcelRequire("kAoxL");

var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");

var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");
if (!(0, $4HBpa.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $kAoxL.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






var $kAoxL = parcelRequire("kAoxL");
function $2eb3b46f3eb8bd9a$export$fb2daceae6f5097a(callback) {
    callback();
}
function $2eb3b46f3eb8bd9a$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $2eb3b46f3eb8bd9a$export$fb2daceae6f5097a;
    (0, $kAoxL.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $2eb3b46f3eb8bd9a$export$13ce1459b9a04b51 = function() {
    return true;
};


var $dec58924b695943e$var$deprecatedMessages = [];
function $dec58924b695943e$export$be38475be17599d(msg) {
    if (!$dec58924b695943e$var$deprecatedMessages.includes(msg)) {
        $dec58924b695943e$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");

var $kAoxL = parcelRequire("kAoxL");
function $a5b06cdb52f58c92$export$ef795f1f307682c7(v) {
    return (0, $kAoxL.getDependencyTree)(v);
}


var $1501ada62eae77a2$var$globalIsUsingStaticRendering = false;
function $1501ada62eae77a2$export$5d52eaa7c0f24c9e(enable) {
    $1501ada62eae77a2$var$globalIsUsingStaticRendering = enable;
}
function $1501ada62eae77a2$export$55979271896d643e() {
    return $1501ada62eae77a2$var$globalIsUsingStaticRendering;
}


var $91ec477941ecfd8c$export$e901ba0ffe10ba41 = 10000;
var $91ec477941ecfd8c$export$1ae22ce5a82f26b6 = 10000;
var $91ec477941ecfd8c$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $91ec477941ecfd8c$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $91ec477941ecfd8c$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $91ec477941ecfd8c$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $91ec477941ecfd8c$export$b7a00d372cedeedd;


var $b98151876264b847$export$10e8a12fbfd8583c = new (0, $91ec477941ecfd8c$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $b9116a30d570126f$exports = {};
"use strict";

$b9116a30d570126f$exports = (parcelRequire("gVIri"));


function $9ae3725284474255$var$createReaction(adm) {
    adm.reaction = new (0, $kAoxL.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $9ae3725284474255$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $1501ada62eae77a2$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $b98151876264b847$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $9ae3725284474255$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $9ae3725284474255$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $b98151876264b847$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useDebugValue(adm.reaction, (0, $a5b06cdb52f58c92$export$ef795f1f307682c7));
    (0, $b9116a30d570126f$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $4HBpa = parcelRequire("4HBpa");


var $3c5190d06f1dcf03$var$_a, $3c5190d06f1dcf03$var$_b;
var $3c5190d06f1dcf03$var$warnObserverOptionsDeprecated = true;
var $3c5190d06f1dcf03$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $3c5190d06f1dcf03$var$isFunctionNameConfigurable = ($3c5190d06f1dcf03$var$_b = ($3c5190d06f1dcf03$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $3c5190d06f1dcf03$var$_a === void 0 ? void 0 : $3c5190d06f1dcf03$var$_a.configurable) !== null && $3c5190d06f1dcf03$var$_b !== void 0 ? $3c5190d06f1dcf03$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $3c5190d06f1dcf03$var$ReactForwardRefSymbol = $3c5190d06f1dcf03$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $4HBpa.forwardRef) === "function" && (0, $4HBpa.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $3c5190d06f1dcf03$var$ReactMemoSymbol = $3c5190d06f1dcf03$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $4HBpa.memo) === "function" && (0, $4HBpa.memo)(function(props) {
    return null;
})["$$typeof"];
function $3c5190d06f1dcf03$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($3c5190d06f1dcf03$var$ReactMemoSymbol && baseComponent["$$typeof"] === $3c5190d06f1dcf03$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $1501ada62eae77a2$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($3c5190d06f1dcf03$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $3c5190d06f1dcf03$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $9ae3725284474255$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($3c5190d06f1dcf03$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $4HBpa.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $4HBpa.memo)(observerComponent);
    $3c5190d06f1dcf03$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $3c5190d06f1dcf03$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $3c5190d06f1dcf03$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$3c5190d06f1dcf03$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $1846936176caa08a$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $9ae3725284474255$export$b9c7ecd090a87b14)(component);
}
$1846936176caa08a$export$c1cbdee04e18ea8b.displayName = "Observer";
function $1846936176caa08a$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");
function $99f6e8081b71e7a6$export$aa207039f277c5f(initializer, annotations) {
    return (0, $4HBpa.useState)(function() {
        return (0, $kAoxL.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");



var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");
function $7323c381ef910725$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $4HBpa.useState)(function() {
        return (0, $kAoxL.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $kAoxL.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $416875d6f23c4aea$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $7323c381ef910725$export$e0ded3646391939c)(current);
    return (0, $4HBpa.useState)(function() {
        return (0, $kAoxL.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $4b02975e2cd02ed1$var$_a;
(0, $2eb3b46f3eb8bd9a$export$294943bbc3c74f4f)((0, $384457d72cc1e1d1$exports.unstable_batchedUpdates));
var $4b02975e2cd02ed1$export$469d51fb8d268227 = ($4b02975e2cd02ed1$var$_a = (0, $b98151876264b847$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $4b02975e2cd02ed1$var$_a !== void 0 ? $4b02975e2cd02ed1$var$_a : function() {};
function $4b02975e2cd02ed1$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $9ae3725284474255$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $4b02975e2cd02ed1$export$7613124ee4202834(enable) {
    (0, $1501ada62eae77a2$export$5d52eaa7c0f24c9e)(enable);
}


function $2bb10cc242f0df2f$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($2bb10cc242f0df2f$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$2bb10cc242f0df2f$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $2bb10cc242f0df2f$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $2bb10cc242f0df2f$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $2bb10cc242f0df2f$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$2bb10cc242f0df2f$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $2bb10cc242f0df2f$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $2bb10cc242f0df2f$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $2bb10cc242f0df2f$var$getMixins(target, methodName) {
    var mixins = target[$2bb10cc242f0df2f$var$mobxMixins] = target[$2bb10cc242f0df2f$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $2bb10cc242f0df2f$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $2bb10cc242f0df2f$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $2bb10cc242f0df2f$var$wrapper.call.apply($2bb10cc242f0df2f$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $2bb10cc242f0df2f$var$patch(target, methodName, mixinMethod) {
    var mixins = $2bb10cc242f0df2f$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$2bb10cc242f0df2f$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $2bb10cc242f0df2f$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $2bb10cc242f0df2f$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $2bb10cc242f0df2f$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$2bb10cc242f0df2f$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $2bb10cc242f0df2f$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $2bb10cc242f0df2f$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $2bb10cc242f0df2f$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $2bb10cc242f0df2f$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $2bb10cc242f0df2f$var$observablePropDescriptors;
function $2bb10cc242f0df2f$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$2bb10cc242f0df2f$var$administrationSymbol]) != null ? _component$administra : component[$2bb10cc242f0df2f$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $2bb10cc242f0df2f$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $2bb10cc242f0df2f$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$2bb10cc242f0df2f$var$isMobXReactObserverSymbol]) {
        var displayName = $2bb10cc242f0df2f$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$2bb10cc242f0df2f$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $4HBpa.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $2bb10cc242f0df2f$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $2bb10cc242f0df2f$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $2bb10cc242f0df2f$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $1501ada62eae77a2$export$55979271896d643e)() ? originalRender : $2bb10cc242f0df2f$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $2bb10cc242f0df2f$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $b98151876264b847$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $2bb10cc242f0df2f$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $1501ada62eae77a2$export$55979271896d643e)()) return;
        var admin = $2bb10cc242f0df2f$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $2bb10cc242f0df2f$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $2bb10cc242f0df2f$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $2bb10cc242f0df2f$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $2bb10cc242f0df2f$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $b98151876264b847$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $kAoxL._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $2bb10cc242f0df2f$var$createReaction(admin) {
    return new (0, $kAoxL.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $2bb10cc242f0df2f$var$observerSCU(nextProps, nextState) {
    if ((0, $1501ada62eae77a2$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$2bb10cc242f0df2f$var$shallowEqual(this.props, nextProps);
}
function $2bb10cc242f0df2f$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $2bb10cc242f0df2f$var$getAdministration(this);
            var derivation = (0, $kAoxL._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error('[mobx-react] Cannot read "' + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $2bb10cc242f0df2f$var$getAdministration(this)[key] = value;
        }
    };
}
function $2bb10cc242f0df2f$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $4HBpa.Component), component) || Object.prototype.isPrototypeOf.call((0, $4HBpa.PureComponent), component)) // Class component
    return $2bb10cc242f0df2f$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $3c5190d06f1dcf03$export$b6ae1bc530f4c149)(component);
}
function $2bb10cc242f0df2f$var$_extends() {
    $2bb10cc242f0df2f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2bb10cc242f0df2f$var$_extends.apply(this, arguments);
}
function $2bb10cc242f0df2f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2bb10cc242f0df2f$var$_excluded = [
    "children"
];
var $2bb10cc242f0df2f$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createContext({});
function $2bb10cc242f0df2f$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $2bb10cc242f0df2f$var$_objectWithoutPropertiesLoose(props, $2bb10cc242f0df2f$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useContext($2bb10cc242f0df2f$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useRef($2bb10cc242f0df2f$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement($2bb10cc242f0df2f$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$2bb10cc242f0df2f$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $2bb10cc242f0df2f$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).forwardRef(function(props, ref) {
        var newProps = $2bb10cc242f0df2f$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useContext($2bb10cc242f0df2f$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $2bb10cc242f0df2f$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $2bb10cc242f0df2f$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $2bb10cc242f0df2f$var$getInjectName(component, injectNames);
    return Injector;
}
function $2bb10cc242f0df2f$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $2bb10cc242f0df2f$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $2bb10cc242f0df2f$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $2bb10cc242f0df2f$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $2bb10cc242f0df2f$var$createStoreInjector($2bb10cc242f0df2f$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $2bb10cc242f0df2f$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).version.split(".")[0]);
var $2bb10cc242f0df2f$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $2bb10cc242f0df2f$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $2bb10cc242f0df2f$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $2bb10cc242f0df2f$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$2bb10cc242f0df2f$var$protoStoreKey] || [], this[$2bb10cc242f0df2f$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $2bb10cc242f0df2f$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $2bb10cc242f0df2f$export$4e749cb731da87a9(target, fn);
    });
    if (!$2bb10cc242f0df2f$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($2bb10cc242f0df2f$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $2bb10cc242f0df2f$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$2bb10cc242f0df2f$var$protoStoreKey] || !!target[$2bb10cc242f0df2f$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$2bb10cc242f0df2f$var$protoStoreKey] || (target[$2bb10cc242f0df2f$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$2bb10cc242f0df2f$var$instStoreKey] || (target[$2bb10cc242f0df2f$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $2bb10cc242f0df2f$var$patch(target, "componentWillUnmount", $2bb10cc242f0df2f$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $2bb10cc242f0df2f$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $kAoxL.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $2bb10cc242f0df2f$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $2bb10cc242f0df2f$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($2bb10cc242f0df2f$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $2bb10cc242f0df2f$var$getPreciseType(propValue) {
    var propType = $2bb10cc242f0df2f$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $2bb10cc242f0df2f$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $kAoxL.untracked)(function() {
            if (allowNativeType) {
                if ($2bb10cc242f0df2f$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $kAoxL.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $kAoxL.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $kAoxL.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $2bb10cc242f0df2f$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $2bb10cc242f0df2f$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $2bb10cc242f0df2f$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $kAoxL.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $2bb10cc242f0df2f$var$observableArray = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(false, "Array");
var $2bb10cc242f0df2f$var$observableArrayOf = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableArrayOfTypeChecker.bind(null, false);
var $2bb10cc242f0df2f$var$observableMap = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(false, "Map");
var $2bb10cc242f0df2f$var$observableObject = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(false, "Object");
var $2bb10cc242f0df2f$var$arrayOrObservableArray = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(true, "Array");
var $2bb10cc242f0df2f$var$arrayOrObservableArrayOf = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableArrayOfTypeChecker.bind(null, true);
var $2bb10cc242f0df2f$var$objectOrObservableObject = /*#__PURE__*/ $2bb10cc242f0df2f$var$createObservableTypeCheckerCreator(true, "Object");
var $2bb10cc242f0df2f$export$e0c95a451cd220b7 = {
    observableArray: $2bb10cc242f0df2f$var$observableArray,
    observableArrayOf: $2bb10cc242f0df2f$var$observableArrayOf,
    observableMap: $2bb10cc242f0df2f$var$observableMap,
    observableObject: $2bb10cc242f0df2f$var$observableObject,
    arrayOrObservableArray: $2bb10cc242f0df2f$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $2bb10cc242f0df2f$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $2bb10cc242f0df2f$var$objectOrObservableObject
};
if (!(0, $4HBpa.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $kAoxL.observable)) throw new Error("mobx-react requires mobx to be available");



var $bcfad0ea6174f23f$export$71511d61b312f219;
"use strict";

$bcfad0ea6174f23f$export$71511d61b312f219 = (parcelRequire("eOEwK")).__generator;




function $e32f060b0f06d5c3$export$da8ca15f4115b46e() {
    if (typeof window !== "undefined") {
        const Component = (parcelRequire("lf9Oh"));
        return Component.default || Component;
    } else {
        const Component = (parcelRequire("8Cjev"));
        return Component.default || Component;
    }
}


var $f4d62e6f87601d7b$exports = {};
"use strict";
var $f4d62e6f87601d7b$var$e = [
    "left",
    "right",
    "center",
    "justify"
], $f4d62e6f87601d7b$var$t = {
    delimiter: function() {
        return "<br/>";
    },
    header: function(e) {
        var t = e.data;
        return "<h" + t.level + ">" + t.text + "</h" + t.level + ">";
    },
    paragraph: function(t) {
        var r = t.data, n = r.alignment || r.align;
        return void 0 !== n && $f4d62e6f87601d7b$var$e.includes(n) ? '<p style="text-align:' + n + ';">' + r.text + "</p>" : "<p>" + r.text + "</p>";
    },
    list: function(e) {
        var t = e.data, r = "unordered" === t.style ? "ul" : "ol", n = function(e, t) {
            var r = e.map(function(e) {
                if (!e.content && !e.items) return "<li>" + e + "</li>";
                var r = "";
                return e.items && (r = n(e.items, t)), e.content ? "<li> " + e.content + " </li>" + r : void 0;
            });
            return "<" + t + ">" + r.join("") + "</" + t + ">";
        };
        return n(t.items, r);
    },
    image: function(e) {
        var t = e.data, r = t.caption ? t.caption : "Image";
        return '<img src="' + (t.file && t.file.url ? t.file.url : t.url) + '" alt="' + r + '" />';
    },
    quote: function(e) {
        var t = e.data;
        return "<blockquote>" + t.text + "</blockquote> - " + t.caption;
    },
    code: function(e) {
        return "<pre><code>" + e.data.code + "</code></pre>";
    },
    embed: function(e) {
        var t = e.data;
        switch(t.service){
            case "vimeo":
                return '<iframe src="' + t.embed + '" height="' + t.height + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
            case "youtube":
                return '<iframe width="' + t.width + '" height="' + t.height + '" src="' + t.embed + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            default:
                throw new Error("Only Youtube and Vime Embeds are supported right now.");
        }
    }
};
function $f4d62e6f87601d7b$var$r(e) {
    return new Error('\x1b[31m The Parser function of type "' + e + '" is not defined. \n\n  Define your custom parser functions as: \x1b[34mhttps://github.com/pavittarx/editorjs-html#extend-for-custom-blocks \x1b[0m');
}
var $f4d62e6f87601d7b$var$n = function(e) {
    void 0 === e && (e = {});
    var i = Object.assign({}, $f4d62e6f87601d7b$var$t, e);
    return {
        parse: function(e) {
            return e.blocks.map(function(e) {
                return i[e.type] ? i[e.type](e) : $f4d62e6f87601d7b$var$r(e.type);
            });
        },
        parseBlock: function(e) {
            return i[e.type] ? i[e.type](e) : $f4d62e6f87601d7b$var$r(e.type);
        },
        parseStrict: function(e) {
            var t = e.blocks, o = $f4d62e6f87601d7b$var$n(i).validate({
                blocks: t
            });
            if (o.length) throw new Error("Parser Functions missing for blocks: " + o.toString());
            for(var a = [], u = 0; u < t.length; u++){
                if (!i[t[u].type]) throw $f4d62e6f87601d7b$var$r(t[u].type);
                a.push(i[t[u].type](t[u]));
            }
            return a;
        },
        validate: function(e) {
            var t = e.blocks.map(function(e) {
                return e.type;
            }).filter(function(e, t, r) {
                return r.indexOf(e) === t;
            }), r = Object.keys(i);
            return t.filter(function(e) {
                return !r.includes(e);
            });
        }
    };
};
$f4d62e6f87601d7b$exports = $f4d62e6f87601d7b$var$n;




var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");

"use client";
const $b605ce7bbfab4197$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $b605ce7bbfab4197$export$ff817e17bad2e091 = "xs";
const $b605ce7bbfab4197$var$ThemeContext = /*#__PURE__*/ $4HBpa.createContext({
    prefixes: {},
    breakpoints: $b605ce7bbfab4197$export$666ad80b5007f835,
    minBreakpoint: $b605ce7bbfab4197$export$ff817e17bad2e091
});
const { Consumer: $b605ce7bbfab4197$export$b631efc24e9d5e2f, Provider: $b605ce7bbfab4197$var$Provider } = $b605ce7bbfab4197$var$ThemeContext;
function $b605ce7bbfab4197$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $b605ce7bbfab4197$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $b605ce7bbfab4197$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $4HBpa.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)($b605ce7bbfab4197$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $b605ce7bbfab4197$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $4HBpa.useContext)($b605ce7bbfab4197$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $b605ce7bbfab4197$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $4HBpa.useContext)($b605ce7bbfab4197$var$ThemeContext);
    return breakpoints;
}
function $b605ce7bbfab4197$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $4HBpa.useContext)($b605ce7bbfab4197$var$ThemeContext);
    return minBreakpoint;
}
function $b605ce7bbfab4197$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $4HBpa.useContext)($b605ce7bbfab4197$var$ThemeContext);
    return dir === "rtl";
}
function $b605ce7bbfab4197$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $4HBpa.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $b605ce7bbfab4197$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $b605ce7bbfab4197$export$2e2bcd8739ae039 = $b605ce7bbfab4197$var$ThemeProvider;



"use client";
const $d24f0e25e592dc71$var$Badge = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, bg: bg = "primary", pill: pill = false, text: text, className: className, as: Component = "span", ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "badge");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$d24f0e25e592dc71$var$Badge.displayName = "Badge";
var $d24f0e25e592dc71$export$2e2bcd8739ae039 = $d24f0e25e592dc71$var$Badge;



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");

const $77c09beb04dc34b0$var$_excluded = [
    "as",
    "disabled"
];
function $77c09beb04dc34b0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $77c09beb04dc34b0$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $77c09beb04dc34b0$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $77c09beb04dc34b0$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $77c09beb04dc34b0$var$Button = /*#__PURE__*/ $4HBpa.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $77c09beb04dc34b0$var$_objectWithoutPropertiesLoose(_ref, $77c09beb04dc34b0$var$_excluded);
    const [buttonProps, { tagName: Component }] = $77c09beb04dc34b0$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$77c09beb04dc34b0$var$Button.displayName = "Button";
var $77c09beb04dc34b0$export$2e2bcd8739ae039 = $77c09beb04dc34b0$var$Button;




"use client";
const $367fe3a5abb69f2e$var$Button = /*#__PURE__*/ $4HBpa.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $77c09beb04dc34b0$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$367fe3a5abb69f2e$var$Button.displayName = "Button";
var $367fe3a5abb69f2e$export$2e2bcd8739ae039 = $367fe3a5abb69f2e$var$Button;



var $4HBpa = parcelRequire("4HBpa");
var $0a134cba80b47542$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $0a134cba80b47542$export$2e2bcd8739ae039(element, selector) {
    return $0a134cba80b47542$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $53e6d5b016eb161e$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $39288ac6dc5c98da$export$63fefd044b2bc624 = false;
var $39288ac6dc5c98da$export$a614c6b395900f69 = false;
try {
    var $39288ac6dc5c98da$var$options = {
        get passive () {
            return $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $39288ac6dc5c98da$export$a614c6b395900f69 = $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $53e6d5b016eb161e$export$2e2bcd8739ae039) {
        window.addEventListener("test", $39288ac6dc5c98da$var$options, $39288ac6dc5c98da$var$options);
        window.removeEventListener("test", $39288ac6dc5c98da$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $39288ac6dc5c98da$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$39288ac6dc5c98da$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$39288ac6dc5c98da$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $39288ac6dc5c98da$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $39288ac6dc5c98da$export$2e2bcd8739ae039 = $39288ac6dc5c98da$var$addEventListener;



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");
function $151cf54a86bb6052$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $151cf54a86bb6052$var$_toPropertyKey(arg) {
    var key = $151cf54a86bb6052$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $151cf54a86bb6052$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $151cf54a86bb6052$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $151cf54a86bb6052$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $4HBpa.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $4HBpa.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $4HBpa.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $151cf54a86bb6052$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $151cf54a86bb6052$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $151cf54a86bb6052$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($151cf54a86bb6052$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $151cf54a86bb6052$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $4HBpa = parcelRequire("4HBpa");
function $f0da90f5f4f7563a$export$2e2bcd8739ae039(value) {
    const ref = (0, $4HBpa.useRef)(null);
    (0, $4HBpa.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $4HBpa = parcelRequire("4HBpa");
function $f28d972037a2e151$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $4HBpa.useReducer)((state)=>!state, false);
    return dispatch;
}



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $c8e821dedca1379f$var$useCommittedRef(value) {
    const ref = (0, $4HBpa.useRef)(value);
    (0, $4HBpa.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $c8e821dedca1379f$export$2e2bcd8739ae039 = $c8e821dedca1379f$var$useCommittedRef;


function $d99c632f2d60c58b$export$2e2bcd8739ae039(fn) {
    const ref = (0, $c8e821dedca1379f$export$2e2bcd8739ae039)(fn);
    return (0, $4HBpa.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $09845d24c20a3b12$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(listener);
    (0, $4HBpa.useEffect)(()=>{
        const target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $4HBpa = parcelRequire("4HBpa");
const $7463d0e7102de2a2$var$DropdownContext = /*#__PURE__*/ $4HBpa.createContext(null);
var $7463d0e7102de2a2$export$2e2bcd8739ae039 = $7463d0e7102de2a2$var$DropdownContext;



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");
function $7c3e42abf881a16e$export$2e2bcd8739ae039() {
    return (0, $4HBpa.useState)(null);
}




var $4HBpa = parcelRequire("4HBpa");
var $4acd931b6f5f6b58$var$has = Object.prototype.hasOwnProperty;
function $4acd931b6f5f6b58$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($4acd931b6f5f6b58$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $4acd931b6f5f6b58$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4acd931b6f5f6b58$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $4acd931b6f5f6b58$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $4acd931b6f5f6b58$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$4acd931b6f5f6b58$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($4acd931b6f5f6b58$var$has.call(foo, ctor) && ++len && !$4acd931b6f5f6b58$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4acd931b6f5f6b58$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");
function $bea9a4f5d8420224$export$2e2bcd8739ae039() {
    const mounted = (0, $4HBpa.useRef)(true);
    const isMounted = (0, $4HBpa.useRef)(()=>mounted.current);
    (0, $4HBpa.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $6a3736a13e7e8d7f$var$useSafeState(state) {
    const isMounted = (0, $bea9a4f5d8420224$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $4HBpa.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $6a3736a13e7e8d7f$export$2e2bcd8739ae039 = $6a3736a13e7e8d7f$var$useSafeState;



function $48bb75d5bf3c287d$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $61b65052593cce67$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $47e2f793e6db6001$export$8960430cfd85939f = Math.max;
var $47e2f793e6db6001$export$96ec731ed4dcb222 = Math.min;
var $47e2f793e6db6001$export$2077e0241d6afd3c = Math.round;



function $8ecbe53684bd7b48$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $eec2a55e9af96354$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $8ecbe53684bd7b48$export$2e2bcd8739ae039)());
}


function $5a3919fd7116f891$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(element) ? (0, $61b65052593cce67$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $eec2a55e9af96354$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0aa5be651923dfbb$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $4c9ec00b782551f7$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $5cab22a6b884c3d9$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}



function $60d1639ab565e3e4$export$2e2bcd8739ae039(element) {
    return (0, $61b65052593cce67$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $368606681b890691$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(element)) >= 0;
}




function $55a71246ec6b8be3$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $375e027f2230e225$export$2e2bcd8739ae039(element) {
    if ((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $717b277afd92e276$var$getTrueOffsetParent(element) {
    if (!(0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $717b277afd92e276$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $8ecbe53684bd7b48$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $8ecbe53684bd7b48$export$2e2bcd8739ae039)());
    if (isIE && (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $375e027f2230e225$export$2e2bcd8739ae039)(element);
    if ((0, $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $717b277afd92e276$export$2e2bcd8739ae039(element) {
    var window = (0, $61b65052593cce67$export$2e2bcd8739ae039)(element);
    var offsetParent = $717b277afd92e276$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $368606681b890691$export$2e2bcd8739ae039)(offsetParent) && (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $717b277afd92e276$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $717b277afd92e276$var$getContainingBlock(element) || window;
}


function $8664aca5c419c963$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $891a462c23ca7b5d$export$f28d906d67a997f3(min, value, max) {
    return (0, $47e2f793e6db6001$export$8960430cfd85939f)(min, (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(value, max));
}
function $891a462c23ca7b5d$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $891a462c23ca7b5d$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $f61daa9e4ec37835$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $5a0e8fa0789ad2aa$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f61daa9e4ec37835$export$2e2bcd8739ae039)(), paddingObject);
}


function $9bd77f53938bd74f$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $ae039e4f0d49d659$export$1e95b668f3b82d = "top";
var $ae039e4f0d49d659$export$40e543e69a8b3fbb = "bottom";
var $ae039e4f0d49d659$export$79ffe56a765070d2 = "right";
var $ae039e4f0d49d659$export$eabcd2c8791e7bf4 = "left";
var $ae039e4f0d49d659$export$dfb5619354ba860 = "auto";
var $ae039e4f0d49d659$export$aec2ce47c367b8c3 = [
    $ae039e4f0d49d659$export$1e95b668f3b82d,
    $ae039e4f0d49d659$export$40e543e69a8b3fbb,
    $ae039e4f0d49d659$export$79ffe56a765070d2,
    $ae039e4f0d49d659$export$eabcd2c8791e7bf4
];
var $ae039e4f0d49d659$export$b3571188c770cc5a = "start";
var $ae039e4f0d49d659$export$bd5df0f255a350f8 = "end";
var $ae039e4f0d49d659$export$390fd549c5303b4d = "clippingParents";
var $ae039e4f0d49d659$export$d7b7311ec04a3e8f = "viewport";
var $ae039e4f0d49d659$export$ae5ab1c730825774 = "popper";
var $ae039e4f0d49d659$export$ca50aac9f3ba507f = "reference";
var $ae039e4f0d49d659$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ae039e4f0d49d659$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ae039e4f0d49d659$export$b3571188c770cc5a,
        placement + "-" + $ae039e4f0d49d659$export$bd5df0f255a350f8
    ]);
}, []);
var $ae039e4f0d49d659$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ae039e4f0d49d659$export$aec2ce47c367b8c3, [
    $ae039e4f0d49d659$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ae039e4f0d49d659$export$b3571188c770cc5a,
        placement + "-" + $ae039e4f0d49d659$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ae039e4f0d49d659$export$421679a7c3d56e = "beforeRead";
var $ae039e4f0d49d659$export$aafa59e2e03f2942 = "read";
var $ae039e4f0d49d659$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $ae039e4f0d49d659$export$c65e99957a05207c = "beforeMain";
var $ae039e4f0d49d659$export$f22da7240b7add18 = "main";
var $ae039e4f0d49d659$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ae039e4f0d49d659$export$8d4d2d70e7d46032 = "beforeWrite";
var $ae039e4f0d49d659$export$68d8715fc104d294 = "write";
var $ae039e4f0d49d659$export$70a6e5159acce2e6 = "afterWrite";
var $ae039e4f0d49d659$export$d087d3878fdf71d5 = [
    $ae039e4f0d49d659$export$421679a7c3d56e,
    $ae039e4f0d49d659$export$aafa59e2e03f2942,
    $ae039e4f0d49d659$export$6964f6c886723980,
    $ae039e4f0d49d659$export$c65e99957a05207c,
    $ae039e4f0d49d659$export$f22da7240b7add18,
    $ae039e4f0d49d659$export$bab79516f2d662fe,
    $ae039e4f0d49d659$export$8d4d2d70e7d46032,
    $ae039e4f0d49d659$export$68d8715fc104d294,
    $ae039e4f0d49d659$export$70a6e5159acce2e6
];


var $c81aadba3facd31a$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5a0e8fa0789ad2aa$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $9bd77f53938bd74f$export$2e2bcd8739ae039)(padding, (0, $ae039e4f0d49d659$export$aec2ce47c367b8c3)));
};
function $c81aadba3facd31a$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8664aca5c419c963$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4),
        (0, $ae039e4f0d49d659$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c81aadba3facd31a$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0aa5be651923dfbb$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $ae039e4f0d49d659$export$1e95b668f3b82d) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $717b277afd92e276$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c81aadba3facd31a$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4c9ec00b782551f7$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c81aadba3facd31a$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $c81aadba3facd31a$var$arrow,
    effect: $c81aadba3facd31a$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $6685b38147ddeec8$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $625bb50c8847a2cc$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $625bb50c8847a2cc$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $625bb50c8847a2cc$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
    var sideY = (0, $ae039e4f0d49d659$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $717b277afd92e276$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $61b65052593cce67$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(popper);
            if ((0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ae039e4f0d49d659$export$1e95b668f3b82d) || (placement === (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4) || placement === (0, $ae039e4f0d49d659$export$79ffe56a765070d2)) && variation === (0, $ae039e4f0d49d659$export$bd5df0f255a350f8)) {
            sideY = (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4) || (placement === (0, $ae039e4f0d49d659$export$1e95b668f3b82d) || placement === (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)) && variation === (0, $ae039e4f0d49d659$export$bd5df0f255a350f8)) {
            sideX = (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $625bb50c8847a2cc$var$unsetSides);
    var _ref4 = roundOffsets === true ? $625bb50c8847a2cc$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $61b65052593cce67$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $625bb50c8847a2cc$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $625bb50c8847a2cc$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $625bb50c8847a2cc$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $625bb50c8847a2cc$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $625bb50c8847a2cc$var$computeStyles,
    data: {}
};



var $543972eb5fd21065$var$passive = {
    passive: true
};
function $543972eb5fd21065$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $61b65052593cce67$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $543972eb5fd21065$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $543972eb5fd21065$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $543972eb5fd21065$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $543972eb5fd21065$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $543972eb5fd21065$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $543972eb5fd21065$var$effect,
    data: {}
};


var $fd277c2f1b2fdd45$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $fd277c2f1b2fdd45$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $fd277c2f1b2fdd45$var$hash[matched];
    });
}



var $feb66e05f65f002d$var$hash = {
    start: "end",
    end: "start"
};
function $feb66e05f65f002d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $feb66e05f65f002d$var$hash[matched];
    });
}








function $f805881890c4a8ae$export$2e2bcd8739ae039(node) {
    var win = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $66cc7bcd3398f9f0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5a3919fd7116f891$export$2e2bcd8739ae039)((0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element)).left + (0, $f805881890c4a8ae$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $3d9f2682e8b46ad0$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $61b65052593cce67$export$2e2bcd8739ae039)(element);
    var html = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $eec2a55e9af96354$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $66cc7bcd3398f9f0$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $c41321b0f5f2650f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $f805881890c4a8ae$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $47e2f793e6db6001$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $47e2f793e6db6001$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $66cc7bcd3398f9f0$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $47e2f793e6db6001$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $62dd7a1e768b8c7b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3dd4d705a60d837f$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(node) && (0, $62dd7a1e768b8c7b$export$2e2bcd8739ae039)(node)) return node;
    return $3dd4d705a60d837f$export$2e2bcd8739ae039((0, $375e027f2230e225$export$2e2bcd8739ae039)(node));
}





function $808134ffcafa23ab$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3dd4d705a60d837f$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $61b65052593cce67$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $62dd7a1e768b8c7b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($808134ffcafa23ab$export$2e2bcd8739ae039((0, $375e027f2230e225$export$2e2bcd8739ae039)(target)));
}










function $ed98f3c8e193990a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $da676012f58a8d10$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $da676012f58a8d10$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ae039e4f0d49d659$export$d7b7311ec04a3e8f) ? (0, $ed98f3c8e193990a$export$2e2bcd8739ae039)((0, $3d9f2682e8b46ad0$export$2e2bcd8739ae039)(element, strategy)) : (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(clippingParent) ? $da676012f58a8d10$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ed98f3c8e193990a$export$2e2bcd8739ae039)((0, $c41321b0f5f2650f$export$2e2bcd8739ae039)((0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $da676012f58a8d10$var$getClippingParents(element) {
    var clippingParents = (0, $808134ffcafa23ab$export$2e2bcd8739ae039)((0, $375e027f2230e225$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element) ? (0, $717b277afd92e276$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4c9ec00b782551f7$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $da676012f58a8d10$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $da676012f58a8d10$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $da676012f58a8d10$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $47e2f793e6db6001$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $47e2f793e6db6001$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $da676012f58a8d10$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $b7686cfa0bad79fe$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ae039e4f0d49d659$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ae039e4f0d49d659$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ae039e4f0d49d659$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8664aca5c419c963$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $ae039e4f0d49d659$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ae039e4f0d49d659$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $b4e02f68dba27cf0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ae039e4f0d49d659$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ae039e4f0d49d659$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ae039e4f0d49d659$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5a0e8fa0789ad2aa$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $9bd77f53938bd74f$export$2e2bcd8739ae039)(padding, (0, $ae039e4f0d49d659$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $ae039e4f0d49d659$export$ae5ab1c730825774) ? (0, $ae039e4f0d49d659$export$ca50aac9f3ba507f) : (0, $ae039e4f0d49d659$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $da676012f58a8d10$export$2e2bcd8739ae039)((0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $b7686cfa0bad79fe$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ed98f3c8e193990a$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ae039e4f0d49d659$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ae039e4f0d49d659$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ae039e4f0d49d659$export$79ffe56a765070d2),
                (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
                (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bee67608fa020610$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ae039e4f0d49d659$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $ae039e4f0d49d659$export$368f9a87e87fa4e1) : (0, $ae039e4f0d49d659$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $ae039e4f0d49d659$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $ef83021c7d12dc40$var$getExpandedFallbackPlacements(placement) {
    if ((0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement) === (0, $ae039e4f0d49d659$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(placement);
    return [
        (0, $feb66e05f65f002d$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $feb66e05f65f002d$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $ef83021c7d12dc40$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $ef83021c7d12dc40$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement) === (0, $ae039e4f0d49d659$export$dfb5619354ba860) ? (0, $bee67608fa020610$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement) === (0, $ae039e4f0d49d659$export$b3571188c770cc5a);
        var isVertical = [
            (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
            (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ae039e4f0d49d659$export$79ffe56a765070d2) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $ef83021c7d12dc40$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $ef83021c7d12dc40$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $3cb23a9df881f494$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3cb23a9df881f494$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
        (0, $ae039e4f0d49d659$export$79ffe56a765070d2),
        (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb),
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3cb23a9df881f494$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3cb23a9df881f494$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3cb23a9df881f494$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3cb23a9df881f494$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3cb23a9df881f494$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3cb23a9df881f494$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $3cb23a9df881f494$var$hide
};




function $17febcad75c34150$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4),
        (0, $ae039e4f0d49d659$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4),
        (0, $ae039e4f0d49d659$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $17febcad75c34150$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ae039e4f0d49d659$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $17febcad75c34150$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $17febcad75c34150$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $17febcad75c34150$var$offset
};



function $838c56d274cf33c2$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b7686cfa0bad79fe$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $838c56d274cf33c2$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $838c56d274cf33c2$var$popperOffsets,
    data: {}
};





function $4ca6267150d720be$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $db925e83491d082b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8664aca5c419c963$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4ca6267150d720be$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $ae039e4f0d49d659$export$1e95b668f3b82d) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ae039e4f0d49d659$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ae039e4f0d49d659$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0aa5be651923dfbb$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f61daa9e4ec37835$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $717b277afd92e276$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(tether ? (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $47e2f793e6db6001$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $ae039e4f0d49d659$export$1e95b668f3b82d) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
            (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $891a462c23ca7b5d$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $db925e83491d082b$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $db925e83491d082b$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};







function $16b4c6f5959333e9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $e54e832a2669b203$export$2e2bcd8739ae039(node) {
    if (node === (0, $61b65052593cce67$export$2e2bcd8739ae039)(node) || !(0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(node)) return (0, $f805881890c4a8ae$export$2e2bcd8739ae039)(node);
    else return (0, $16b4c6f5959333e9$export$2e2bcd8739ae039)(node);
}








function $fecbc57855d29bfb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $fecbc57855d29bfb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(offsetParent) && $fecbc57855d29bfb$var$isElementScaled(offsetParent);
    var documentElement = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $62dd7a1e768b8c7b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $e54e832a2669b203$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $66cc7bcd3398f9f0$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $48549fee1e8e137f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $48549fee1e8e137f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $48549fee1e8e137f$var$order(modifiers); // order based on phase
    return (0, $ae039e4f0d49d659$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9f32f692269a213b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $ef4d0de54045ec9e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $dc3c055f8bfc86cb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $dc3c055f8bfc86cb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $dc3c055f8bfc86cb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $dc3c055f8bfc86cb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $dc3c055f8bfc86cb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(reference) ? (0, $808134ffcafa23ab$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $808134ffcafa23ab$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $808134ffcafa23ab$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $48549fee1e8e137f$export$2e2bcd8739ae039)((0, $ef4d0de54045ec9e$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$dc3c055f8bfc86cb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $fecbc57855d29bfb$export$2e2bcd8739ae039)(reference, (0, $717b277afd92e276$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $0aa5be651923dfbb$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9f32f692269a213b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$dc3c055f8bfc86cb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $dc3c055f8bfc86cb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $dc3c055f8bfc86cb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $2ebd4501d6754532$export$8f7491d57c8f97a9 = (0, $dc3c055f8bfc86cb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $3cb23a9df881f494$export$2e2bcd8739ae039),
        (0, $838c56d274cf33c2$export$2e2bcd8739ae039),
        (0, $625bb50c8847a2cc$export$2e2bcd8739ae039),
        (0, $543972eb5fd21065$export$2e2bcd8739ae039),
        (0, $17febcad75c34150$export$2e2bcd8739ae039),
        (0, $ef83021c7d12dc40$export$2e2bcd8739ae039),
        (0, $db925e83491d082b$export$2e2bcd8739ae039),
        (0, $c81aadba3facd31a$export$2e2bcd8739ae039)
    ]
});


const $abe5087e14854617$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $abe5087e14854617$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $abe5087e14854617$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: ()=>undefined
};
// until docjs supports type exports...
const $abe5087e14854617$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ("removeAttribute" in reference) {
                const ids = (reference.getAttribute("aria-describedby") || "").split(",").filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            const ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $abe5087e14854617$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $abe5087e14854617$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = "bottom", strategy: strategy = "absolute", modifiers: modifiers = $abe5087e14854617$var$EMPTY_MODIFIERS } = _ref, config = $abe5087e14854617$var$_objectWithoutPropertiesLoose(_ref, $abe5087e14854617$var$_excluded);
    const prevModifiers = (0, $4HBpa.useRef)(modifiers);
    const popperInstanceRef = (0, $4HBpa.useRef)();
    const update = (0, $4HBpa.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $4HBpa.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $6a3736a13e7e8d7f$export$2e2bcd8739ae039)((0, $4HBpa.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $4HBpa.useMemo)(()=>({
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $4HBpa.useMemo)(()=>{
        if (!(0, $4acd931b6f5f6b58$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $4HBpa.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $abe5087e14854617$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $4HBpa.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $2ebd4501d6754532$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $abe5087e14854617$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $abe5087e14854617$export$2e2bcd8739ae039 = $abe5087e14854617$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $321b0569c1d3b241$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $bf50d51abf54f84c$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $bf50d51abf54f84c$export$2e2bcd8739ae039 = $bf50d51abf54f84c$var$removeEventListener;


function $c19f71e61aa90e5d$var$listen(node, eventName, handler, options) {
    (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $c19f71e61aa90e5d$export$2e2bcd8739ae039 = $c19f71e61aa90e5d$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $0ddd9f7131150c10$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $4HBpa = parcelRequire("4HBpa");

var $ced47db6f467fbae$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ced47db6f467fbae$var$__DEV__ = false;
var $ced47db6f467fbae$var$warning = function() {};
if ($ced47db6f467fbae$var$__DEV__) {
    var $ced47db6f467fbae$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ced47db6f467fbae$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ced47db6f467fbae$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ced47db6f467fbae$exports = $ced47db6f467fbae$var$warning;


const $b1371a53f6a26973$var$noop = ()=>{};
function $b1371a53f6a26973$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $b1371a53f6a26973$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $b1371a53f6a26973$export$347601c75fcd4732 = (ref)=>ref && ("current" in ref ? ref.current : ref);
const $b1371a53f6a26973$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $b1371a53f6a26973$var$useClickOutside(ref, onClickOutside = $b1371a53f6a26973$var$noop, { disabled: disabled, clickTrigger: clickTrigger = "click" } = {}) {
    const preventMouseClickOutsideRef = (0, $4HBpa.useRef)(false);
    const waitingForTrigger = (0, $4HBpa.useRef)(false);
    const handleMouseCapture = (0, $4HBpa.useCallback)((e)=>{
        const currentTarget = $b1371a53f6a26973$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ced47db6f467fbae$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $b1371a53f6a26973$var$isModifiedEvent(e) || !$b1371a53f6a26973$var$isLeftClickEvent(e) || !!(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $b1371a53f6a26973$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    const handleMouse = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $4HBpa.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)($b1371a53f6a26973$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($b1371a53f6a26973$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, $b1371a53f6a26973$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(el, "mousemove", $b1371a53f6a26973$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $b1371a53f6a26973$export$2e2bcd8739ae039 = $b1371a53f6a26973$var$useClickOutside;


function $1cd9cbd0063f21a8$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $1cd9cbd0063f21a8$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $1cd9cbd0063f21a8$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $1cd9cbd0063f21a8$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $1cd9cbd0063f21a8$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $be1f2490cc143862$var$_excluded = [
    "children",
    "usePopper"
];
function $be1f2490cc143862$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $be1f2490cc143862$var$noop = ()=>{};
function $be1f2490cc143862$export$133c4d08f3775d64(options = {}) {
    const context = (0, $4HBpa.useContext)((0, $7463d0e7102de2a2$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $7c3e42abf881a16e$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $4HBpa.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $abe5087e14854617$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $1cd9cbd0063f21a8$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || "bottom-start",
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $be1f2490cc143862$var$noop,
        "aria-labelledby": toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $b1371a53f6a26973$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $be1f2490cc143862$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $be1f2490cc143862$var$_objectWithoutPropertiesLoose(_ref, $be1f2490cc143862$var$_excluded);
    const [props, meta] = $be1f2490cc143862$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $237889e76c767d38$exports.Fragment), {
        children: children(props, meta)
    });
}
$be1f2490cc143862$var$DropdownMenu.displayName = "DropdownMenu";
var /** @component */ $be1f2490cc143862$export$2e2bcd8739ae039 = $be1f2490cc143862$var$DropdownMenu;



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $a13c8c087c05ce47$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $a13c8c087c05ce47$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createContext($a13c8c087c05ce47$var$$b5e257d569688ac6$var$defaultContext);
const $a13c8c087c05ce47$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createContext(false);
// This is only used in React < 18.
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $4HBpa.useContext)($a13c8c087c05ce47$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useCounter(cur === $a13c8c087c05ce47$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $4HBpa.useState)(true);
    let value = (0, $4HBpa.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $a13c8c087c05ce47$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $4HBpa.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement($a13c8c087c05ce47$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement($a13c8c087c05ce47$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $a13c8c087c05ce47$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $a13c8c087c05ce47$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa)))["useId"] === "function") {
        if (!$a13c8c087c05ce47$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $a13c8c087c05ce47$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement($a13c8c087c05ce47$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $a13c8c087c05ce47$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $a13c8c087c05ce47$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $4HBpa.useContext)($a13c8c087c05ce47$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $4HBpa.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $a13c8c087c05ce47$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $a13c8c087c05ce47$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $a13c8c087c05ce47$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $4HBpa.useContext)($a13c8c087c05ce47$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $a13c8c087c05ce47$var$$b5e257d569688ac6$var$defaultContext && !$a13c8c087c05ce47$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).useId();
    let [didSSR] = (0, $4HBpa.useState)($a13c8c087c05ce47$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$a13c8c087c05ce47$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $a13c8c087c05ce47$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa)))["useId"] === "function" ? $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useModernSSRSafeId : $a13c8c087c05ce47$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $a13c8c087c05ce47$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $a13c8c087c05ce47$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa)))["useSyncExternalStore"]($a13c8c087c05ce47$var$$b5e257d569688ac6$var$subscribe, $a13c8c087c05ce47$var$$b5e257d569688ac6$var$getSnapshot, $a13c8c087c05ce47$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $4HBpa.useContext)($a13c8c087c05ce47$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $1db5a1adaecb1ba5$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute("role")) == null ? void 0 : _el$getAttribute.toLowerCase()) === "menu";
};
const $1db5a1adaecb1ba5$var$noop = ()=>{};
function $1db5a1adaecb1ba5$export$96df6c7c5036b9a2() {
    const id = (0, $a13c8c087c05ce47$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $1db5a1adaecb1ba5$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $4HBpa.useContext)((0, $7463d0e7102de2a2$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $4HBpa.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $1db5a1adaecb1ba5$var$noop,
        onClick: handleClick,
        "aria-expanded": !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $1db5a1adaecb1ba5$export$386b1213cf9779d8(menuElement)) props["aria-haspopup"] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $1db5a1adaecb1ba5$var$DropdownToggle({ children: children }) {
    const [props, meta] = $1db5a1adaecb1ba5$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $237889e76c767d38$exports.Fragment), {
        children: children(props, meta)
    });
}
$1db5a1adaecb1ba5$var$DropdownToggle.displayName = "DropdownToggle";
var /** @component */ $1db5a1adaecb1ba5$export$2e2bcd8739ae039 = $1db5a1adaecb1ba5$var$DropdownToggle;



var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");
const $010ad8e954db9444$var$SelectableContext = /*#__PURE__*/ $4HBpa.createContext(null);
const $010ad8e954db9444$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $010ad8e954db9444$export$2e2bcd8739ae039 = $010ad8e954db9444$var$SelectableContext;



var $4HBpa = parcelRequire("4HBpa");
const $c2a4297bfb6756cd$var$NavContext = /*#__PURE__*/ $4HBpa.createContext(null);
$c2a4297bfb6756cd$var$NavContext.displayName = "NavContext";
var $c2a4297bfb6756cd$export$2e2bcd8739ae039 = $c2a4297bfb6756cd$var$NavContext;



const $89243f679e71db97$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $89243f679e71db97$export$635202801f9383a0 = `rrUi`;
function $89243f679e71db97$export$5cc3b7b83e34ade7(property) {
    return `${$89243f679e71db97$export$fd7bcb7e9bef4e8a}${property}`;
}
function $89243f679e71db97$export$7776c0a7cd2eb3e0(property) {
    return `${$89243f679e71db97$export$635202801f9383a0}${property}`;
}



const $64de3ec9a9fd846a$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $64de3ec9a9fd846a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $64de3ec9a9fd846a$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $4HBpa.useContext)((0, $010ad8e954db9444$export$2e2bcd8739ae039));
    const navContext = (0, $4HBpa.useContext)((0, $c2a4297bfb6756cd$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $010ad8e954db9444$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $010ad8e954db9444$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            "aria-disabled": disabled || undefined,
            "aria-selected": isActive,
            [(0, $89243f679e71db97$export$5cc3b7b83e34ade7)("dropdown-item")]: ""
        },
        {
            isActive: isActive
        }
    ];
}
const $64de3ec9a9fd846a$var$DropdownItem = /*#__PURE__*/ $4HBpa.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $77c09beb04dc34b0$export$2e2bcd8739ae039) } = _ref, props = $64de3ec9a9fd846a$var$_objectWithoutPropertiesLoose(_ref, $64de3ec9a9fd846a$var$_excluded);
    const [dropdownItemProps] = $64de3ec9a9fd846a$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$64de3ec9a9fd846a$var$DropdownItem.displayName = "DropdownItem";
var $64de3ec9a9fd846a$export$2e2bcd8739ae039 = $64de3ec9a9fd846a$var$DropdownItem;





var $4HBpa = parcelRequire("4HBpa");

const $30cae4eefb1ace18$var$Context = /*#__PURE__*/ (0, $4HBpa.createContext)((0, $53e6d5b016eb161e$export$2e2bcd8739ae039) ? window : undefined);
const $30cae4eefb1ace18$export$f7d306aeb1cf5fbc = $30cae4eefb1ace18$var$Context.Provider;
function $30cae4eefb1ace18$export$2e2bcd8739ae039() {
    return (0, $4HBpa.useContext)($30cae4eefb1ace18$var$Context);
}



function $e1f46a806ea9aca0$var$useRefWithUpdate() {
    const forceUpdate = (0, $f28d972037a2e151$export$2e2bcd8739ae039)();
    const ref = (0, $4HBpa.useRef)(null);
    const attachRef = (0, $4HBpa.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $e1f46a806ea9aca0$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $89243f679e71db97$export$5cc3b7b83e34ade7)("dropdown-item")}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = "bottom-start", children: children }) {
    const window = (0, $30cae4eefb1ace18$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $151cf54a86bb6052$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $e1f46a806ea9aca0$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $e1f46a806ea9aca0$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $f0da90f5f4f7563a$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $4HBpa.useRef)(null);
    const focusInDropdown = (0, $4HBpa.useRef)(false);
    const onSelectCtx = (0, $4HBpa.useContext)((0, $010ad8e954db9444$export$2e2bcd8739ae039));
    const toggle = (0, $4HBpa.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, "select");
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $4HBpa.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $1db5a1adaecb1ba5$export$386b1213cf9779d8)(menuRef.current) ? "keyboard" : false;
        if (focusType === false || focusType === "keyboard" && !/^key.+$/.test(type)) return;
        const first = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $4HBpa.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $4HBpa.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $09845d24c20a3b12$export$2e2bcd8739ae039)((0, $4HBpa.useCallback)(()=>window.document, [
        window
    ]), "keydown", (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === " " || key !== "Escape" && fromMenu || key === "Escape" && target.type === "search")) return;
        if (!fromMenu && !fromToggle) return;
        if (key === "Tab" && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case "ArrowUp":
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case "ArrowDown":
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case "Tab":
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(target.ownerDocument, "keyup", (e)=>{
                    var _menuRef$current2;
                    if (e.key === "Tab" && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case "Escape":
                if (key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $010ad8e954db9444$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $7463d0e7102de2a2$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$e1f46a806ea9aca0$var$Dropdown.displayName = "Dropdown";
$e1f46a806ea9aca0$var$Dropdown.Menu = (0, $be1f2490cc143862$export$2e2bcd8739ae039);
$e1f46a806ea9aca0$var$Dropdown.Toggle = (0, $1db5a1adaecb1ba5$export$2e2bcd8739ae039);
$e1f46a806ea9aca0$var$Dropdown.Item = (0, $64de3ec9a9fd846a$export$2e2bcd8739ae039);
var $e1f46a806ea9aca0$export$2e2bcd8739ae039 = $e1f46a806ea9aca0$var$Dropdown;


function $8c55e5e47312da59$export$2e2bcd8739ae039() {
    return $8c55e5e47312da59$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8c55e5e47312da59$export$2e2bcd8739ae039.apply(null, arguments);
}


function $28c18a12d9cdcd60$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $4HBpa = parcelRequire("4HBpa");
var $250d2e1099d426ec$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $250d2e1099d426ec$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$250d2e1099d426ec$exports = $250d2e1099d426ec$var$invariant;


var $7d8ae10a42051d20$var$noop = function noop() {};
function $7d8ae10a42051d20$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $7d8ae10a42051d20$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $7d8ae10a42051d20$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$7d8ae10a42051d20$export$26cbf8c37e721e67(prop)] = $7d8ae10a42051d20$var$noop;
        var handler;
    });
    return propTypes;
}
function $7d8ae10a42051d20$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $7d8ae10a42051d20$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7d8ae10a42051d20$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $e5768bdb302594a0$var$_toPropertyKey(arg) {
    var key = $e5768bdb302594a0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e5768bdb302594a0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e5768bdb302594a0$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $4HBpa.useRef)(propValue !== undefined);
    var _useState = (0, $4HBpa.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $4HBpa.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $e5768bdb302594a0$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$7d8ae10a42051d20$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $28c18a12d9cdcd60$export$2e2bcd8739ae039)(_ref, [
            $7d8ae10a42051d20$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($e5768bdb302594a0$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $e5768bdb302594a0$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $8c55e5e47312da59$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $d0e246bf6b4f256e$export$2e2bcd8739ae039(t, e) {
    return $d0e246bf6b4f256e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d0e246bf6b4f256e$export$2e2bcd8739ae039(t, e);
}


function $60464ca81d254772$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $d0e246bf6b4f256e$export$2e2bcd8739ae039)(t, o);
}



var $4HBpa = parcelRequire("4HBpa");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $e60c074f0cb8bafe$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $e60c074f0cb8bafe$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $e60c074f0cb8bafe$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$e60c074f0cb8bafe$var$componentWillMount.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $e60c074f0cb8bafe$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $e60c074f0cb8bafe$var$componentWillMount;
        prototype.componentWillReceiveProps = $e60c074f0cb8bafe$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $e60c074f0cb8bafe$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $42f118d4b160bde2$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $42f118d4b160bde2$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $7d8ae10a42051d20$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($7d8ae10a42051d20$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $60464ca81d254772$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $8c55e5e47312da59$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$7d8ae10a42051d20$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $8c55e5e47312da59$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$7d8ae10a42051d20$export$12ae2baa35bd9b8b(props, key) && $7d8ae10a42051d20$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$7d8ae10a42051d20$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $28c18a12d9cdcd60$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement(Component, (0, $8c55e5e47312da59$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Component);
    (0, $e60c074f0cb8bafe$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $8c55e5e47312da59$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $7d8ae10a42051d20$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement(UncontrolledComponent, (0, $8c55e5e47312da59$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $42f118d4b160bde2$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $42f118d4b160bde2$export$2e2bcd8739ae039(newComponent, (0, $8c55e5e47312da59$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}






var $4HBpa = parcelRequire("4HBpa");
"use client";
const $986df028171c45b5$var$DropdownContext = /*#__PURE__*/ $4HBpa.createContext({});
$986df028171c45b5$var$DropdownContext.displayName = "DropdownContext";
var $986df028171c45b5$export$2e2bcd8739ae039 = $986df028171c45b5$var$DropdownContext;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $0ba9bd178e1c7b31$var$DropdownDivider = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "hr", role: role = "separator", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown-divider");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$0ba9bd178e1c7b31$var$DropdownDivider.displayName = "DropdownDivider";
var $0ba9bd178e1c7b31$export$2e2bcd8739ae039 = $0ba9bd178e1c7b31$var$DropdownDivider;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $62b032330efa6ba5$var$DropdownHeader = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", role: role = "heading", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown-header");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$62b032330efa6ba5$var$DropdownHeader.displayName = "DropdownHeader";
var $62b032330efa6ba5$export$2e2bcd8739ae039 = $62b032330efa6ba5$var$DropdownHeader;




var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");






var $4HBpa = parcelRequire("4HBpa");
function $ce25eb77ea931c8b$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $4HBpa.useCallback)(()=>document, []);
    return (0, $09845d24c20a3b12$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $4HBpa = parcelRequire("4HBpa");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $02099d2749b9788f$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $c8e821dedca1379f$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $c8e821dedca1379f$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $4HBpa.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $02099d2749b9788f$export$2e2bcd8739ae039 = $02099d2749b9788f$var$useInterval;



var $4HBpa = parcelRequire("4HBpa");

function $5de7fe743d81deb9$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $c8e821dedca1379f$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $c8e821dedca1379f$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $4HBpa.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $5de7fe743d81deb9$export$2e2bcd8739ae039 = $5de7fe743d81deb9$var$useRafInterval;



var $4HBpa = parcelRequire("4HBpa");
function $1bf6c8c658e7198c$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $4HBpa.useState)(initialState);
    const updater = (0, $4HBpa.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === "function") setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $757da29090232814$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $1bf6c8c658e7198c$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $4HBpa = parcelRequire("4HBpa");
function $b1d5ec4fa27d0d39$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $4HBpa.useState)({
        image: null,
        error: null
    });
    (0, $4HBpa.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return ()=>{
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");
const $edeb438989f381d0$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $edeb438989f381d0$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $edeb438989f381d0$export$2e2bcd8739ae039 = $edeb438989f381d0$var$isDOM || $edeb438989f381d0$var$isReactNative ? (0, $4HBpa.useLayoutEffect) : (0, $4HBpa.useEffect);


const $aaec6a5016fbac73$var$targetMap = new WeakMap();
let $aaec6a5016fbac73$var$resizeObserver;
function $aaec6a5016fbac73$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $aaec6a5016fbac73$var$resizeObserver = $aaec6a5016fbac73$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $aaec6a5016fbac73$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $aaec6a5016fbac73$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $4HBpa.useState)(null);
    (0, $edeb438989f381d0$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $aaec6a5016fbac73$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $aaec6a5016fbac73$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $aaec6a5016fbac73$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $29b0ade028b96912$var$_excluded = [
    "onKeyDown"
];
function $29b0ade028b96912$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $29b0ade028b96912$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $29b0ade028b96912$var$Anchor = /*#__PURE__*/ $4HBpa.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $29b0ade028b96912$var$_objectWithoutPropertiesLoose(_ref, $29b0ade028b96912$var$_excluded);
    const [buttonProps] = (0, $77c09beb04dc34b0$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($29b0ade028b96912$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$29b0ade028b96912$var$Anchor.displayName = "Anchor";
var $29b0ade028b96912$export$2e2bcd8739ae039 = $29b0ade028b96912$var$Anchor;




"use client";
const $51190ae7670d83a1$var$DropdownItem = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $29b0ade028b96912$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown-item");
    const [dropdownItemProps, meta] = (0, $64de3ec9a9fd846a$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, meta.isActive && "active", disabled && "disabled")
    });
});
$51190ae7670d83a1$var$DropdownItem.displayName = "DropdownItem";
var $51190ae7670d83a1$export$2e2bcd8739ae039 = $51190ae7670d83a1$var$DropdownItem;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $4ebf766baf12d066$var$DropdownItemText = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown-item-text");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$4ebf766baf12d066$var$DropdownItemText.displayName = "DropdownItemText";
var $4ebf766baf12d066$export$2e2bcd8739ae039 = $4ebf766baf12d066$var$DropdownItemText;




var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");
const $e6d7094585fd795b$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $e6d7094585fd795b$export$c9058316764c140e(refA, refB) {
    const a = $e6d7094585fd795b$var$toFnRef(refA);
    const b = $e6d7094585fd795b$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $e6d7094585fd795b$var$useMergedRefs(refA, refB) {
    return (0, $4HBpa.useMemo)(()=>$e6d7094585fd795b$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $e6d7094585fd795b$export$2e2bcd8739ae039 = $e6d7094585fd795b$var$useMergedRefs;





var $4HBpa = parcelRequire("4HBpa");
"use client";
const $de63f8d2eb920c28$var$context = /*#__PURE__*/ $4HBpa.createContext(null);
$de63f8d2eb920c28$var$context.displayName = "InputGroupContext";
var $de63f8d2eb920c28$export$2e2bcd8739ae039 = $de63f8d2eb920c28$var$context;



var $4HBpa = parcelRequire("4HBpa");
"use client";
// TODO: check
const $dd9b233515888708$var$context = /*#__PURE__*/ $4HBpa.createContext(null);
$dd9b233515888708$var$context.displayName = "NavbarContext";
var $dd9b233515888708$export$2e2bcd8739ae039 = $dd9b233515888708$var$context;




parcelRequire("4HBpa");

function $d39560d8c6caf4d6$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $8babc5298b99e8f5$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? "top-end" : "top-start";
    const topEnd = isRTL ? "top-start" : "top-end";
    const bottomStart = isRTL ? "bottom-end" : "bottom-start";
    const bottomEnd = isRTL ? "bottom-start" : "bottom-end";
    const leftStart = isRTL ? "right-start" : "left-start";
    const leftEnd = isRTL ? "right-end" : "left-end";
    const rightStart = isRTL ? "left-start" : "right-start";
    const rightEnd = isRTL ? "left-end" : "right-end";
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === "up") placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === "end") placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === "start") placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === "down-centered") placement = "bottom";
    else if (dropDirection === "up-centered") placement = "top";
    return placement;
}
const $8babc5298b99e8f5$var$DropdownMenu = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $4HBpa.useContext)((0, $dd9b233515888708$export$2e2bcd8739ae039));
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown-menu");
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $4HBpa.useContext)((0, $986df028171c45b5$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $4HBpa.useContext)((0, $de63f8d2eb920c28$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === "object") {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === "start";
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === "end") alignEnd = true;
    }
    const placement = $8babc5298b99e8f5$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $be1f2490cc143862$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)((0, $d39560d8c6caf4d6$export$2e2bcd8739ae039)(ref, "DropdownMenu"), menuProps.ref);
    (0, $edeb438989f381d0$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== "string") {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props["x-placement"] = popper.placement;
    }
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            "data-bs-popper": "static"
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, show && "show", alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$8babc5298b99e8f5$var$DropdownMenu.displayName = "DropdownMenu";
var $8babc5298b99e8f5$export$2e2bcd8739ae039 = $8babc5298b99e8f5$var$DropdownMenu;







var $4HBpa = parcelRequire("4HBpa");




"use client";
const $9c36ba48b9464bab$var$DropdownToggle = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown-toggle");
    const dropdownContext = (0, $4HBpa.useContext)((0, $7463d0e7102de2a2$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $1db5a1adaecb1ba5$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(toggleProps.ref, (0, $d39560d8c6caf4d6$export$2e2bcd8739ae039)(ref, "DropdownToggle"));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && "show"),
        ...toggleProps,
        ...props
    });
});
$9c36ba48b9464bab$var$DropdownToggle.displayName = "DropdownToggle";
var $9c36ba48b9464bab$export$2e2bcd8739ae039 = $9c36ba48b9464bab$var$DropdownToggle;






"use client";
const $2ac552a1d6e4346b$var$Dropdown = /*#__PURE__*/ $4HBpa.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = "down", show: show, className: className, align: align = "start", onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", navbar: _4, autoClose: autoClose = true, ...props } = (0, $e5768bdb302594a0$export$2e2bcd8739ae039)(pProps, {
        show: "onToggle"
    });
    const isInputGroup = (0, $4HBpa.useContext)((0, $de63f8d2eb920c28$export$2e2bcd8739ae039));
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "dropdown");
    const isRTL = (0, $b605ce7bbfab4197$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === "click";
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === "inside") return source !== "rootClose";
        // autoClose=outside doesn't permit close on select
        if (autoClose === "outside") return source !== "select";
        return true;
    };
    const handleToggle = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains("dropdown-toggle");
        if (isToggleButton && meta.source === "mousedown") return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== "keydown" || meta.originalEvent.key === "Escape")) meta.source = "rootClose";
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === "end";
    const placement = (0, $8babc5298b99e8f5$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $4HBpa.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        "down-centered": `${prefix}-center`,
        up: "dropup",
        "up-centered": "dropup-center dropup",
        end: "dropend",
        start: "dropstart"
    };
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $986df028171c45b5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $e1f46a806ea9aca0$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, show && "show", directionClasses[drop])
            })
        })
    });
});
$2ac552a1d6e4346b$var$Dropdown.displayName = "Dropdown";
var $2ac552a1d6e4346b$export$2e2bcd8739ae039 = Object.assign($2ac552a1d6e4346b$var$Dropdown, {
    Toggle: (0, $9c36ba48b9464bab$export$2e2bcd8739ae039),
    Menu: (0, $8babc5298b99e8f5$export$2e2bcd8739ae039),
    Item: (0, $51190ae7670d83a1$export$2e2bcd8739ae039),
    ItemText: (0, $4ebf766baf12d066$export$2e2bcd8739ae039),
    Divider: (0, $0ba9bd178e1c7b31$export$2e2bcd8739ae039),
    Header: (0, $62b032330efa6ba5$export$2e2bcd8739ae039)
});



var $4HBpa = parcelRequire("4HBpa");
var $a53fecd73fa4e68d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a53fecd73fa4e68d$var$ReactIs, $a53fecd73fa4e68d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$a53fecd73fa4e68d$exports = (parcelRequire("3p0ZA"))();




"use client";
const $9c4c44bc71b8d84b$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool
};
const $9c4c44bc71b8d84b$var$Image = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "img");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("img", {
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$9c4c44bc71b8d84b$var$Image.displayName = "Image";
var $9c4c44bc71b8d84b$export$2e2bcd8739ae039 = $9c4c44bc71b8d84b$var$Image;


var $0f29ead507a12c2a$exports = {};
"use strict";
Object.defineProperty($0f29ead507a12c2a$exports, "__esModule", {
    value: true
});
$0f29ead507a12c2a$exports.default = $0f29ead507a12c2a$var$all;
var $fcedaedbf58a80aa$exports = {};
"use strict";
Object.defineProperty($fcedaedbf58a80aa$exports, "__esModule", {
    value: true
});
$fcedaedbf58a80aa$exports.default = $fcedaedbf58a80aa$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $fcedaedbf58a80aa$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$fcedaedbf58a80aa$exports = $fcedaedbf58a80aa$exports["default"];


var $0f29ead507a12c2a$var$_createChainableTypeChecker2 = $0f29ead507a12c2a$var$_interopRequireDefault($fcedaedbf58a80aa$exports);
function $0f29ead507a12c2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0f29ead507a12c2a$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $0f29ead507a12c2a$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$0f29ead507a12c2a$exports = $0f29ead507a12c2a$exports["default"];



var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");





var $4HBpa = parcelRequire("4HBpa");
const $4df3e8f5f6454f6a$var$TabContext = /*#__PURE__*/ $4HBpa.createContext(null);
var $4df3e8f5f6454f6a$export$2e2bcd8739ae039 = $4df3e8f5f6454f6a$var$TabContext;




var $4HBpa = parcelRequire("4HBpa");







const $98c324b2f1912f21$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $98c324b2f1912f21$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $98c324b2f1912f21$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $4HBpa.useContext)((0, $010ad8e954db9444$export$2e2bcd8739ae039));
    const navContext = (0, $4HBpa.useContext)((0, $c2a4297bfb6756cd$export$2e2bcd8739ae039));
    const tabContext = (0, $4HBpa.useContext)((0, $4df3e8f5f6454f6a$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $89243f679e71db97$export$5cc3b7b83e34ade7)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $98c324b2f1912f21$var$NavItem = /*#__PURE__*/ $4HBpa.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $77c09beb04dc34b0$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $98c324b2f1912f21$var$_objectWithoutPropertiesLoose(_ref, $98c324b2f1912f21$var$_excluded);
    const [props, meta] = $98c324b2f1912f21$export$d7a68693710982a(Object.assign({
        key: (0, $010ad8e954db9444$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $89243f679e71db97$export$5cc3b7b83e34ade7)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$98c324b2f1912f21$var$NavItem.displayName = "NavItem";
var $98c324b2f1912f21$export$2e2bcd8739ae039 = $98c324b2f1912f21$var$NavItem;



const $cdb19ac1a0e4dcf8$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $cdb19ac1a0e4dcf8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $cdb19ac1a0e4dcf8$var$noop = ()=>{};
const $cdb19ac1a0e4dcf8$var$EVENT_KEY_ATTR = (0, $89243f679e71db97$export$5cc3b7b83e34ade7)("event-key");
const $cdb19ac1a0e4dcf8$var$Nav = /*#__PURE__*/ $4HBpa.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $cdb19ac1a0e4dcf8$var$_objectWithoutPropertiesLoose(_ref, $cdb19ac1a0e4dcf8$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $f28d972037a2e151$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $4HBpa.useRef)(false);
    const parentOnSelect = (0, $4HBpa.useContext)((0, $010ad8e954db9444$export$2e2bcd8739ae039));
    const tabContext = (0, $4HBpa.useContext)((0, $4df3e8f5f6454f6a$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $4HBpa.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(currentListNode, `[${$cdb19ac1a0e4dcf8$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $89243f679e71db97$export$7776c0a7cd2eb3e0)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $4HBpa.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$cdb19ac1a0e4dcf8$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $010ad8e954db9444$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $c2a4297bfb6756cd$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $010ad8e954db9444$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $cdb19ac1a0e4dcf8$var$noop,
                getControllerId: getControllerId || $cdb19ac1a0e4dcf8$var$noop
            },
            children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$cdb19ac1a0e4dcf8$var$Nav.displayName = "Nav";
var $cdb19ac1a0e4dcf8$export$2e2bcd8739ae039 = Object.assign($cdb19ac1a0e4dcf8$var$Nav, {
    Item: (0, $98c324b2f1912f21$export$2e2bcd8739ae039)
});





var $4HBpa = parcelRequire("4HBpa");
"use client";
const $a1b53d71fae21ef4$var$context = /*#__PURE__*/ $4HBpa.createContext(null);
$a1b53d71fae21ef4$var$context.displayName = "CardHeaderContext";
var $a1b53d71fae21ef4$export$2e2bcd8739ae039 = $a1b53d71fae21ef4$var$context;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $3baf4609c5feb6f0$var$NavItem = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "nav-item");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$3baf4609c5feb6f0$var$NavItem.displayName = "NavItem";
var $3baf4609c5feb6f0$export$2e2bcd8739ae039 = $3baf4609c5feb6f0$var$NavItem;




var $4HBpa = parcelRequire("4HBpa");





"use client";
const $19eb693361999595$var$NavLink = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $29b0ade028b96912$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "nav-link");
    const [navItemProps, meta] = (0, $98c324b2f1912f21$export$d7a68693710982a)({
        key: (0, $010ad8e954db9444$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    });
});
$19eb693361999595$var$NavLink.displayName = "NavLink";
var $19eb693361999595$export$2e2bcd8739ae039 = $19eb693361999595$var$NavLink;



"use client";
const $1b7a3ff760a21514$var$Nav = /*#__PURE__*/ $4HBpa.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = "div", bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $e5768bdb302594a0$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: "onSelect"
    });
    const bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(initialBsPrefix, "nav");
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $4HBpa.useContext)((0, $dd9b233515888708$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $4HBpa.useContext)((0, $a1b53d71fae21ef4$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $cdb19ac1a0e4dcf8$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$1b7a3ff760a21514$var$Nav.displayName = "Nav";
var $1b7a3ff760a21514$export$2e2bcd8739ae039 = Object.assign($1b7a3ff760a21514$var$Nav, {
    Item: (0, $3baf4609c5feb6f0$export$2e2bcd8739ae039),
    Link: (0, $19eb693361999595$export$2e2bcd8739ae039)
});




var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");
function $4c690575f6c62589$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $4HBpa.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $4HBpa = parcelRequire("4HBpa");
function $e4da7e2c6df0e7a9$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $4c690575f6c62589$export$2e2bcd8739ae039)(fn);
    (0, $4HBpa.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $17c898b2e23d8386$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $17c898b2e23d8386$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $17c898b2e23d8386$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$17c898b2e23d8386$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $17c898b2e23d8386$var$MAX_DELAY_MS);
}
function $17c898b2e23d8386$export$2e2bcd8739ae039() {
    const isMounted = (0, $bea9a4f5d8420224$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $4HBpa.useRef)();
    (0, $e4da7e2c6df0e7a9$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $4HBpa.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $17c898b2e23d8386$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $17c898b2e23d8386$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}






var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");







var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");
function $2cd124cfc4a4b479$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}
function $2cd124cfc4a4b479$export$13e065f3a74cfe36() {
    const parts = $4HBpa.version.split(".");
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}


const $1e4eac455caa9e9e$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $1e4eac455caa9e9e$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $1e4eac455caa9e9e$var$noop;
    (0, $b1371a53f6a26973$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        if ((0, $2cd124cfc4a4b479$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $4HBpa.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)((0, $b1371a53f6a26973$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, "keyup", (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $1e4eac455caa9e9e$export$2e2bcd8739ae039 = $1e4eac455caa9e9e$var$useRootClose;





var $4HBpa = parcelRequire("4HBpa");

const $425d5774df596b6d$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $53e6d5b016eb161e$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $425d5774df596b6d$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $30cae4eefb1ace18$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $4HBpa.useState)(()=>$425d5774df596b6d$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $425d5774df596b6d$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $4HBpa.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $4HBpa.useEffect)(()=>{
        const nextRef = $425d5774df596b6d$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");
function $a24f0e42e9857c91$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $4HBpa.useRef)(null);
    const hasEnteredRef = (0, $4HBpa.useRef)(inProp);
    const handleExited = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(onExited);
    (0, $4HBpa.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $4HBpa.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $a24f0e42e9857c91$export$2e2bcd8739ae039 = $a24f0e42e9857c91$var$NoopTransition;



var $4HBpa = parcelRequire("4HBpa");

var $4HBpa = parcelRequire("4HBpa");


const $171a5747df6dbce2$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $171a5747df6dbce2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $171a5747df6dbce2$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $171a5747df6dbce2$var$_objectWithoutPropertiesLoose(_ref, $171a5747df6dbce2$var$_excluded);
    const { major: major } = (0, $2cd124cfc4a4b479$export$13e065f3a74cfe36)();
    const childRef = major >= 19 ? children.props.ref : children.ref;
    const nodeRef = (0, $4HBpa.useRef)(null);
    const mergedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(nodeRef, typeof children === "function" ? null : childRef);
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $4HBpa.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $4HBpa.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $4HBpa.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $4HBpa.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $4HBpa.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $4HBpa.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $4HBpa.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $4HBpa.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $80b688a7f16f3a41$var$_excluded = [
    "component"
];
function $80b688a7f16f3a41$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $80b688a7f16f3a41$var$RTGTransition = /*#__PURE__*/ $4HBpa.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $80b688a7f16f3a41$var$_objectWithoutPropertiesLoose(_ref, $80b688a7f16f3a41$var$_excluded);
    const transitionProps = (0, $171a5747df6dbce2$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $80b688a7f16f3a41$export$2e2bcd8739ae039 = $80b688a7f16f3a41$var$RTGTransition;



function $070d5ca02dcd24fa$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $4HBpa.useRef)(null);
    const isInitialRef = (0, $4HBpa.useRef)(true);
    const handleTransition = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(onTransition);
    (0, $edeb438989f381d0$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $edeb438989f381d0$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $070d5ca02dcd24fa$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $4HBpa.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $070d5ca02dcd24fa$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $4HBpa.cloneElement)(children, {
        ref: combinedRef
    });
}
function $070d5ca02dcd24fa$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $80b688a7f16f3a41$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)($070d5ca02dcd24fa$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $a24f0e42e9857c91$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $74e35172c8448cc0$var$Overlay = /*#__PURE__*/ $4HBpa.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $7c3e42abf881a16e$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $7c3e42abf881a16e$export$2e2bcd8739ae039)();
    const mergedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $425d5774df596b6d$export$2e2bcd8739ae039)(props.container);
    const target = (0, $425d5774df596b6d$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $4HBpa.useState)(!props.show);
    const popper = (0, $abe5087e14854617$export$2e2bcd8739ae039)(target, rootElement, (0, $1cd9cbd0063f21a8$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $1e4eac455caa9e9e$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $070d5ca02dcd24fa$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).createPortal(child, container) : null;
});
$74e35172c8448cc0$var$Overlay.displayName = "Overlay";
var $74e35172c8448cc0$export$2e2bcd8739ae039 = $74e35172c8448cc0$var$Overlay;






var $4HBpa = parcelRequire("4HBpa");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $720e403436e1555a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");



"use client";
const $f04ec99f25dbaf53$var$PopoverHeader = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "popover-header");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$f04ec99f25dbaf53$var$PopoverHeader.displayName = "PopoverHeader";
var $f04ec99f25dbaf53$export$2e2bcd8739ae039 = $f04ec99f25dbaf53$var$PopoverHeader;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $70a3ded8aa80940c$var$PopoverBody = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "popover-body");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$70a3ded8aa80940c$var$PopoverBody.displayName = "PopoverBody";
var $70a3ded8aa80940c$export$2e2bcd8739ae039 = $70a3ded8aa80940c$var$PopoverBody;



var $4HBpa = parcelRequire("4HBpa");
class $9710ac5ed8118e8c$export$34582a676b91ff07 extends $4HBpa.Component {
}
function $9710ac5ed8118e8c$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === "left") bsDirection = isRTL ? "end" : "start";
    else if (placement === "right") bsDirection = isRTL ? "start" : "end";
    return bsDirection;
}


function $87d80c6b0b14900f$export$2e2bcd8739ae039(position = "absolute") {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
}



"use client";
const $80bafe4d791ef4d4$var$Popover = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "popover");
    const isRTL = (0, $b605ce7bbfab4197$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $9710ac5ed8118e8c$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $87d80c6b0b14900f$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $70a3ded8aa80940c$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
var $80bafe4d791ef4d4$export$2e2bcd8739ae039 = Object.assign($80bafe4d791ef4d4$var$Popover, {
    Header: (0, $f04ec99f25dbaf53$export$2e2bcd8739ae039),
    Body: (0, $70a3ded8aa80940c$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $4HBpa = parcelRequire("4HBpa");




"use client";
const $d4a4bde41225d644$var$Tooltip = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "tooltip");
    const isRTL = (0, $b605ce7bbfab4197$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $9710ac5ed8118e8c$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $87d80c6b0b14900f$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$d4a4bde41225d644$var$Tooltip.displayName = "Tooltip";
var $d4a4bde41225d644$export$2e2bcd8739ae039 = Object.assign($d4a4bde41225d644$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $c88d59dac445f089$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $4HBpa.useRef)(null);
    const popoverClass = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(undefined, "popover");
    const tooltipClass = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(undefined, "tooltip");
    const offset = (0, $4HBpa.useMemo)(()=>({
            name: "offset",
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $720e403436e1555a$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $80bafe4d791ef4d4$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $720e403436e1555a$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $d4a4bde41225d644$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}




var $4HBpa = parcelRequire("4HBpa");




var $4HBpa = parcelRequire("4HBpa");

var $90188f72752a7d62$export$2e2bcd8739ae039 = {
    disabled: false
};




var $4HBpa = parcelRequire("4HBpa");
var $e0ecde808a11b41a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createContext(null);


var $689444de06e24951$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $c10e4d22a343ddd7$export$bb38bb9a1161268 = "unmounted";
var $c10e4d22a343ddd7$export$84cbff306f539230 = "exited";
var $c10e4d22a343ddd7$export$df38205c966be359 = "entering";
var $c10e4d22a343ddd7$export$78e9e6e3e014d60a = "entered";
var $c10e4d22a343ddd7$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $c10e4d22a343ddd7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $60464ca81d254772$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $c10e4d22a343ddd7$export$84cbff306f539230;
                _this.appearStatus = $c10e4d22a343ddd7$export$df38205c966be359;
            } else initialStatus = $c10e4d22a343ddd7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $c10e4d22a343ddd7$export$bb38bb9a1161268;
        else initialStatus = $c10e4d22a343ddd7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $c10e4d22a343ddd7$export$bb38bb9a1161268) return {
            status: $c10e4d22a343ddd7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $c10e4d22a343ddd7$export$df38205c966be359 && status !== $c10e4d22a343ddd7$export$78e9e6e3e014d60a) nextStatus = $c10e4d22a343ddd7$export$df38205c966be359;
            } else if (status === $c10e4d22a343ddd7$export$df38205c966be359 || status === $c10e4d22a343ddd7$export$78e9e6e3e014d60a) nextStatus = $c10e4d22a343ddd7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $c10e4d22a343ddd7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $689444de06e24951$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $c10e4d22a343ddd7$export$84cbff306f539230) this.setState({
            status: $c10e4d22a343ddd7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $90188f72752a7d62$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c10e4d22a343ddd7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $c10e4d22a343ddd7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $c10e4d22a343ddd7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $90188f72752a7d62$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c10e4d22a343ddd7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $c10e4d22a343ddd7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $c10e4d22a343ddd7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $c10e4d22a343ddd7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $28c18a12d9cdcd60$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).createElement((0, $e0ecde808a11b41a$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).Component);
$c10e4d22a343ddd7$var$Transition.contextType = (0, $e0ecde808a11b41a$export$2e2bcd8739ae039);
$c10e4d22a343ddd7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $c10e4d22a343ddd7$var$noop() {}
$c10e4d22a343ddd7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $c10e4d22a343ddd7$var$noop,
    onEntering: $c10e4d22a343ddd7$var$noop,
    onEntered: $c10e4d22a343ddd7$var$noop,
    onExit: $c10e4d22a343ddd7$var$noop,
    onExiting: $c10e4d22a343ddd7$var$noop,
    onExited: $c10e4d22a343ddd7$var$noop
};
$c10e4d22a343ddd7$var$Transition.UNMOUNTED = $c10e4d22a343ddd7$export$bb38bb9a1161268;
$c10e4d22a343ddd7$var$Transition.EXITED = $c10e4d22a343ddd7$export$84cbff306f539230;
$c10e4d22a343ddd7$var$Transition.ENTERING = $c10e4d22a343ddd7$export$df38205c966be359;
$c10e4d22a343ddd7$var$Transition.ENTERED = $c10e4d22a343ddd7$export$78e9e6e3e014d60a;
$c10e4d22a343ddd7$var$Transition.EXITING = $c10e4d22a343ddd7$export$4aacc83d4d59139f;
var $c10e4d22a343ddd7$export$2e2bcd8739ae039 = $c10e4d22a343ddd7$var$Transition;



function $32111235bb00f3df$export$2e2bcd8739ae039(node) {
    var doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $7f1da6e4e2ccffac$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $32111235bb00f3df$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $93dc448587824ba2$var$rUpper = /([A-Z])/g;
function $93dc448587824ba2$export$2e2bcd8739ae039(string) {
    return string.replace($93dc448587824ba2$var$rUpper, "-$1").toLowerCase();
}


var $fc9e0f35a4611ba5$var$msPattern = /^ms-/;
function $fc9e0f35a4611ba5$export$2e2bcd8739ae039(string) {
    return (0, $93dc448587824ba2$export$2e2bcd8739ae039)(string).replace($fc9e0f35a4611ba5$var$msPattern, "-ms-");
}


var $8daf33ed3a5b05b4$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $8daf33ed3a5b05b4$export$2e2bcd8739ae039(value) {
    return !!(value && $8daf33ed3a5b05b4$var$supportedTransforms.test(value));
}


function $6a01e84b1d47be46$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property)) || (0, $7f1da6e4e2ccffac$export$2e2bcd8739ae039)(node).getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key));
        else if ((0, $8daf33ed3a5b05b4$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $6a01e84b1d47be46$export$2e2bcd8739ae039 = $6a01e84b1d47be46$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $3d98db97c6f46e5c$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $8061db448c42d261$var$parseDuration(node) {
    var str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $3d98db97c6f46e5c$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $8061db448c42d261$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $8061db448c42d261$var$parseDuration(element) || 0;
    var removeEmulate = $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $b6f5876741e6a320$var$parseDuration(node, property) {
    const str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $b6f5876741e6a320$export$2e2bcd8739ae039(element, handler) {
    const duration = $b6f5876741e6a320$var$parseDuration(element, "transitionDuration");
    const delay = $b6f5876741e6a320$var$parseDuration(element, "transitionDelay");
    const remove = (0, $8061db448c42d261$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $3c7e9d19e739df43$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $4HBpa = parcelRequire("4HBpa");



function $d6ba2faff4032901$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $377540a345e50bbb$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $4HBpa.useRef)(null);
    const mergedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $d6ba2faff4032901$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $4HBpa.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $4HBpa.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $4HBpa.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $4HBpa.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $4HBpa.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $4HBpa.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $4HBpa.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $c10e4d22a343ddd7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $377540a345e50bbb$export$2e2bcd8739ae039 = $377540a345e50bbb$var$TransitionWrapper;



const $66f8963d44df9ceb$var$fadeStyles = {
    [(0, $c10e4d22a343ddd7$export$df38205c966be359)]: "show",
    [(0, $c10e4d22a343ddd7$export$78e9e6e3e014d60a)]: "show"
};
const $66f8963d44df9ceb$var$Fade = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $4HBpa.useCallback)((node, isAppearing)=>{
        (0, $3c7e9d19e739df43$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $377540a345e50bbb$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $b6f5876741e6a320$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $4HBpa.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("fade", className, children.props.className, $66f8963d44df9ceb$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$66f8963d44df9ceb$var$Fade.displayName = "Fade";
var $66f8963d44df9ceb$export$2e2bcd8739ae039 = $66f8963d44df9ceb$var$Fade;




"use client";
function $84865d06d690cb03$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $d6ba2faff4032901$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $d6ba2faff4032901$export$2e2bcd8739ae039)(r)));
}
const $84865d06d690cb03$var$Overlay = /*#__PURE__*/ $4HBpa.forwardRef(({ children: overlay, transition: transition = (0, $66f8963d44df9ceb$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = "top", show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $4HBpa.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $4HBpa.useState)(null);
    const [ref, modifiers] = (0, $c88d59dac445f089$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $66f8963d44df9ceb$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $edeb438989f381d0$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $4HBpa.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $74e35172c8448cc0$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $84865d06d690cb03$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === "function") return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: "show"
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $4HBpa.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(overlay.props.className, !transition && show && "show"),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$84865d06d690cb03$var$Overlay.displayName = "Overlay";
var $84865d06d690cb03$export$2e2bcd8739ae039 = $84865d06d690cb03$var$Overlay;




"use client";
function $ee913af29239d9e3$var$normalizeDelay(delay) {
    return delay && typeof delay === "object" ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $ee913af29239d9e3$var$handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $ee913af29239d9e3$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).oneOf([
    "click",
    "hover",
    "focus"
]);
const $ee913af29239d9e3$var$OverlayTrigger = ({ trigger: trigger = [
    "hover",
    "focus"
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf("auto") !== -1, ...props })=>{
    const triggerNodeRef = (0, $4HBpa.useRef)(null);
    const mergedRef = (0, $e6d7094585fd795b$export$2e2bcd8739ae039)(triggerNodeRef, children.ref);
    const timeout = (0, $17c898b2e23d8386$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $4HBpa.useRef)("");
    const [show, setShow] = (0, $e5768bdb302594a0$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $ee913af29239d9e3$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== "function" ? $4HBpa.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $d6ba2faff4032901$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $4HBpa.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "show";
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "show") setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $4HBpa.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "hide";
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "hide") setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $4HBpa.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $4HBpa.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $4HBpa.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $4HBpa.useCallback)((...args)=>{
        $ee913af29239d9e3$var$handleMouseOverOut(handleShow, args, "fromElement");
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $4HBpa.useCallback)((...args)=>{
        $ee913af29239d9e3$var$handleMouseOverOut(handleHide, args, "toElement");
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf("click") !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf("focus") !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf("hover") !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsxs)((0, $237889e76c767d38$exports.Fragment), {
        children: [
            typeof children === "function" ? children(triggerProps) : /*#__PURE__*/ (0, $4HBpa.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $84865d06d690cb03$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $ee913af29239d9e3$export$2e2bcd8739ae039 = $ee913af29239d9e3$var$OverlayTrigger;



var $4HBpa = parcelRequire("4HBpa");


"use client";
const $b77909a1b1b04ae6$var$Spinner = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = "border", size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "spinner");
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$b77909a1b1b04ae6$var$Spinner.displayName = "Spinner";
var $b77909a1b1b04ae6$export$2e2bcd8739ae039 = $b77909a1b1b04ae6$var$Spinner;



var $4HBpa = parcelRequire("4HBpa");


"use client";
const $279fc564c3dfbde6$var$Table = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "table");
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === "string" ? `striped-${striped}` : "striped"}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === "string") responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
var $279fc564c3dfbde6$export$2e2bcd8739ae039 = $279fc564c3dfbde6$var$Table;


var $1d49ee2f49ed26bb$exports = {};
var $1d49ee2f49ed26bb$var$e, $1d49ee2f49ed26bb$var$t, $1d49ee2f49ed26bb$var$r, $1d49ee2f49ed26bb$var$n, $1d49ee2f49ed26bb$var$o, $1d49ee2f49ed26bb$var$a, $1d49ee2f49ed26bb$var$i, $1d49ee2f49ed26bb$var$s, $1d49ee2f49ed26bb$var$c;



var $d3a93f3373228101$export$71511d61b312f219;
"use strict";
var $d1f2ec613ab145d0$export$71511d61b312f219;
"use strict";

function $d1f2ec613ab145d0$var$_super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $b68705b1e088022e$export$71511d61b312f219(object);
        if (object === null) break;
    }
    return object;
}
$d1f2ec613ab145d0$export$71511d61b312f219 = $d1f2ec613ab145d0$var$_super_prop_base;


function $d3a93f3373228101$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $d3a93f3373228101$export$71511d61b312f219 = $d3a93f3373228101$var$_get = Reflect.get;
    else $d3a93f3373228101$export$71511d61b312f219 = $d3a93f3373228101$var$_get = function get(target, property, receiver) {
        var base = $d1f2ec613ab145d0$export$71511d61b312f219(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $d3a93f3373228101$var$_get(target, property, receiver || target);
}
$d3a93f3373228101$export$71511d61b312f219 = $d3a93f3373228101$var$_get;




var $f04458dccaf432de$export$71511d61b312f219;
"use strict";
function $f04458dccaf432de$var$_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
$f04458dccaf432de$export$71511d61b312f219 = $f04458dccaf432de$var$_object_destructuring_empty;




var $ddVow = parcelRequire("ddVow");

var $kAoxL = parcelRequire("kAoxL");

var $4HBpa = parcelRequire("4HBpa");
function $1d49ee2f49ed26bb$var$_(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $1d49ee2f49ed26bb$var$g(e, t, r, n) {
    Object.defineProperty(e, t, {
        get: r,
        set: n,
        enumerable: !0,
        configurable: !0
    });
}
var $1d49ee2f49ed26bb$var$j = {};
$1d49ee2f49ed26bb$var$g($1d49ee2f49ed26bb$var$j, "isEqualProps", function() {
    return $1d49ee2f49ed26bb$var$S;
}), $1d49ee2f49ed26bb$var$g($1d49ee2f49ed26bb$var$j, "observePropsState", function() {
    return $1d49ee2f49ed26bb$var$T;
});
var $1d49ee2f49ed26bb$var$P = function(e, t, r, n, o, a) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var s, c = n.kind, u = "getter" === c ? "get" : "setter" === c ? "set" : "value", l = !t && e ? n.static ? e : e.prototype : null, f = t || (l ? Object.getOwnPropertyDescriptor(l, n.name) : {}), p = !1, d = r.length - 1; d >= 0; d--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (p) throw TypeError("Cannot add initializers after decoration has completed");
            a.push(i(e || null));
        };
        var b = (0, r[d])("accessor" === c ? {
            get: f.get,
            set: f.set
        } : f[u], v);
        if ("accessor" === c) {
            if (void 0 === b) continue;
            if (null === b || "object" != typeof b) throw TypeError("Object expected");
            (s = i(b.get)) && (f.get = s), (s = i(b.set)) && (f.set = s), (s = i(b.init)) && o.unshift(s);
        } else (s = i(b)) && ("field" === c ? o.unshift(s) : f[u] = s);
    }
    l && Object.defineProperty(l, n.name, f), p = !0;
}, $1d49ee2f49ed26bb$var$E = function(e, t, r) {
    for(var n = arguments.length > 2, o = 0; o < t.length; o++)r = n ? t[o].call(e, r) : t[o].call(e);
    return n ? r : void 0;
}, $1d49ee2f49ed26bb$var$k = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $1d49ee2f49ed26bb$var$O = function(e, t, r, n, o) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !o) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
}, $1d49ee2f49ed26bb$var$S = function(e, t) {
    return ($ddVow && $ddVow.__esModule ? $ddVow.default : $ddVow)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
};
function $1d49ee2f49ed26bb$var$T(e, t) {
    var r, n, o, a, i, s, c, m, w, _;
    return (0, $f04458dccaf432de$export$71511d61b312f219)(t), s = [], c = [], m = [], r = function(e) {
        (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
        var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
        function r() {
            var e;
            return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
                this
            ].concat(Array.prototype.slice.call(arguments))), n.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), ($1d49ee2f49ed26bb$var$E((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), s), $1d49ee2f49ed26bb$var$E((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), c, e.props))), o.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $1d49ee2f49ed26bb$var$E((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), m, {})), e;
        }
        return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
            {
                key: "observedProps",
                get: function() {
                    return $1d49ee2f49ed26bb$var$k(this, n, "f");
                },
                set: function(e) {
                    $1d49ee2f49ed26bb$var$O(this, n, e, "f");
                }
            },
            {
                key: "observedState",
                get: function() {
                    return $1d49ee2f49ed26bb$var$k(this, o, "f");
                },
                set: function(e) {
                    $1d49ee2f49ed26bb$var$O(this, o, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e;
                    this.observedProps = this.props, this.observedState = this.state, null === (e = (0, $d3a93f3373228101$export$71511d61b312f219)((0, $b68705b1e088022e$export$71511d61b312f219)(r.prototype), "componentDidMount", this)) || void 0 === e || e.call(this);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t, n) {
                    var o;
                    $1d49ee2f49ed26bb$var$S(e, this.props) || (this.observedProps = this.props), $1d49ee2f49ed26bb$var$S(t, this.state) || (this.observedState = this.state), null === (o = (0, $d3a93f3373228101$export$71511d61b312f219)((0, $b68705b1e088022e$export$71511d61b312f219)(r.prototype), "componentDidUpdate", this)) || void 0 === o || o.call(this, e, t, n);
                }
            }
        ]), r;
    }(e), n = new WeakMap, o = new WeakMap, _ = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== (w = e[Symbol.metadata]) && void 0 !== w ? w : null) : void 0, a = [
        $kAoxL.observable
    ], i = [
        $kAoxL.observable
    ], $1d49ee2f49ed26bb$var$P(r, null, a, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedProps" in e;
            },
            get: function(e) {
                return e.observedProps;
            },
            set: function(e, t) {
                e.observedProps = t;
            }
        },
        metadata: _
    }, c, s), $1d49ee2f49ed26bb$var$P(r, null, i, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedState" in e;
            },
            get: function(e) {
                return e.observedState;
            },
            set: function(e, t) {
                e.observedState = t;
            }
        },
        metadata: _
    }, m, s), _ && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: _
    }), r;
}
var $1d49ee2f49ed26bb$var$q = {};
$1d49ee2f49ed26bb$var$g($1d49ee2f49ed26bb$var$q, "FormComponent", function() {
    return $1d49ee2f49ed26bb$var$D;
});
var $1d49ee2f49ed26bb$var$V = function(e, t, r) {
    for(var n = arguments.length > 2, o = 0; o < t.length; o++)r = n ? t[o].call(e, r) : t[o].call(e);
    return n ? r : void 0;
}, $1d49ee2f49ed26bb$var$C = function(e, t, r, n, o, a) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var s, c = n.kind, u = "getter" === c ? "get" : "setter" === c ? "set" : "value", l = !t && e ? n.static ? e : e.prototype : null, f = t || (l ? Object.getOwnPropertyDescriptor(l, n.name) : {}), p = !1, d = r.length - 1; d >= 0; d--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (p) throw TypeError("Cannot add initializers after decoration has completed");
            a.push(i(e || null));
        };
        var b = (0, r[d])("accessor" === c ? {
            get: f.get,
            set: f.set
        } : f[u], v);
        if ("accessor" === c) {
            if (void 0 === b) continue;
            if (null === b || "object" != typeof b) throw TypeError("Object expected");
            (s = i(b.get)) && (f.get = s), (s = i(b.set)) && (f.set = s), (s = i(b.init)) && o.unshift(s);
        } else (s = i(b)) && ("field" === c ? o.unshift(s) : f[u] = s);
    }
    l && Object.defineProperty(l, n.name, f), p = !0;
}, $1d49ee2f49ed26bb$var$M = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $1d49ee2f49ed26bb$var$x = function(e, t, r, n, o) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !o) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
}, $1d49ee2f49ed26bb$var$D = ($1d49ee2f49ed26bb$var$o = $4HBpa.Component, $1d49ee2f49ed26bb$var$a = [], $1d49ee2f49ed26bb$var$i = [], $1d49ee2f49ed26bb$var$e = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(n, e);
    var r = (0, $f44768c4e043f9d2$export$71511d61b312f219)(n);
    function n() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, n), e = r.call.apply(r, [
            this
        ].concat(Array.prototype.slice.call(arguments))), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ($1d49ee2f49ed26bb$var$V((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $1d49ee2f49ed26bb$var$a), (0, $4HBpa.createRef)())
        }), $1d49ee2f49ed26bb$var$t.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $1d49ee2f49ed26bb$var$V((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $1d49ee2f49ed26bb$var$i, e.props.defaultValue)), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "reset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function() {
                var t, r;
                e.innerValue = e.props.defaultValue, null === (r = (t = e.props).onChange) || void 0 === r || r.call(t, e.innerValue);
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(n, [
        {
            key: "innerValue",
            get: function() {
                return $1d49ee2f49ed26bb$var$M(this, $1d49ee2f49ed26bb$var$t, "f");
            },
            set: function(e) {
                $1d49ee2f49ed26bb$var$x(this, $1d49ee2f49ed26bb$var$t, e, "f");
            }
        },
        {
            key: "value",
            get: function() {
                var e;
                return null !== (e = this.observedProps.value) && void 0 !== e ? e : this.innerValue;
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                var e, t;
                null === (t = null === (e = this.ref.current) || void 0 === e ? void 0 : e.form) || void 0 === t || t.addEventListener("reset", this.reset);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                var e, t;
                null === (t = null === (e = this.ref.current) || void 0 === e ? void 0 : e.form) || void 0 === t || t.removeEventListener("reset", this.reset);
            }
        }
    ]), n;
}($1d49ee2f49ed26bb$var$o), $1d49ee2f49ed26bb$var$t = new WeakMap, $1d49ee2f49ed26bb$var$c = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== ($1d49ee2f49ed26bb$var$s = $1d49ee2f49ed26bb$var$o[Symbol.metadata]) && void 0 !== $1d49ee2f49ed26bb$var$s ? $1d49ee2f49ed26bb$var$s : null) : void 0, $1d49ee2f49ed26bb$var$r = [
    $kAoxL.observable
], $1d49ee2f49ed26bb$var$n = [
    $kAoxL.computed
], $1d49ee2f49ed26bb$var$C($1d49ee2f49ed26bb$var$e, null, $1d49ee2f49ed26bb$var$r, {
    kind: "accessor",
    name: "innerValue",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "innerValue" in e;
        },
        get: function(e) {
            return e.innerValue;
        },
        set: function(e, t) {
            e.innerValue = t;
        }
    },
    metadata: $1d49ee2f49ed26bb$var$c
}, $1d49ee2f49ed26bb$var$i, $1d49ee2f49ed26bb$var$a), $1d49ee2f49ed26bb$var$C($1d49ee2f49ed26bb$var$e, null, $1d49ee2f49ed26bb$var$n, {
    kind: "getter",
    name: "value",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "value" in e;
        },
        get: function(e) {
            return e.value;
        }
    },
    metadata: $1d49ee2f49ed26bb$var$c
}, null, $1d49ee2f49ed26bb$var$a), $1d49ee2f49ed26bb$var$c && Object.defineProperty($1d49ee2f49ed26bb$var$e, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $1d49ee2f49ed26bb$var$c
}), $1d49ee2f49ed26bb$var$e);
$1d49ee2f49ed26bb$var$_($1d49ee2f49ed26bb$exports, $1d49ee2f49ed26bb$var$j), $1d49ee2f49ed26bb$var$_($1d49ee2f49ed26bb$exports, $1d49ee2f49ed26bb$var$q);



var $eec13e6b5a0b94b3$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $eec13e6b5a0b94b3$exports = factory();
})($eec13e6b5a0b94b3$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $b2d204ad2c8a6909$var$eZ(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $b2d204ad2c8a6909$var$e$(e, t, r, n) {
    Object.defineProperty(e, t, {
        get: r,
        set: n,
        enumerable: !0,
        configurable: !0
    });
}
function $b2d204ad2c8a6909$var$e0(e) {
    return e && e.__esModule ? e.default : e;
}
var $b2d204ad2c8a6909$var$e1 = {};
function $b2d204ad2c8a6909$var$e2(e) {
    return function(t) {
        return t && new IntersectionObserver(function(t, r) {
            var n, a, i = (0, $88421859e416994d$export$71511d61b312f219)(t, 1)[0], o = i.isIntersecting, c = i.target;
            if (o) {
                var l = [
                    "animate__animated",
                    "animate__".concat(e)
                ];
                (n = c.classList).add.apply(n, (0, $41564e795f0c9d63$export$71511d61b312f219)(l)), c.addEventListener("animationend", function() {
                    return (a = c.classList).remove.apply(a, (0, $41564e795f0c9d63$export$71511d61b312f219)(l));
                }, {
                    once: !0
                }), r.disconnect();
            }
        }).observe(t);
    };
}
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$e1, "animate", function() {
    return $b2d204ad2c8a6909$var$e2;
});
var $b2d204ad2c8a6909$var$e4 = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$e4, "Avatar", function() {
    return $b2d204ad2c8a6909$var$e5;
});
var $b2d204ad2c8a6909$var$e3 = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$e5 = function(e) {
    var t = e.className, r = e.style, n = e.size, a = void 0 === n ? 3 : n, i = $b2d204ad2c8a6909$var$e3(e, [
        "className",
        "style",
        "size"
    ]);
    return (0, $237889e76c767d38$exports.jsx)("img", Object.assign({
        className: $b2d204ad2c8a6909$var$e0($46a03b660b5bd4f2$exports)("object-fit-cover rounded-circle", t),
        style: Object.assign({
            width: "".concat(a, "rem"),
            height: "".concat(a, "rem")
        }, r)
    }, i));
};
$b2d204ad2c8a6909$var$e5.displayName = "Avatar";
var $b2d204ad2c8a6909$var$e7 = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$e7, "ClickBoundary", function() {
    return $b2d204ad2c8a6909$var$e6;
});
var $b2d204ad2c8a6909$var$e8 = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$e6 = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
            this
        ].concat(Array.prototype.slice.call(arguments))), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "root", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $4HBpa.createRef)()
        }), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "switchClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r, n = e.props, a = n.onInnerClick, i = n.onOuterClick;
                (null === (r = e.root.current) || void 0 === r ? void 0 : r.contains(t.target)) ? null == a || a(t) : null == i || i(t);
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
        {
            key: "componentDidMount",
            value: function() {
                window.addEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                window.removeEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.children, r = (e.onInnerClick, e.onOuterClick, $b2d204ad2c8a6909$var$e8(e, [
                    "children",
                    "onInnerClick",
                    "onOuterClick"
                ]));
                return (0, $237889e76c767d38$exports.jsx)("div", Object.assign({
                    ref: this.root
                }, r, {
                    children: t
                }));
            }
        }
    ]), r;
}($4HBpa.PureComponent), $b2d204ad2c8a6909$var$e9 = {};
function $b2d204ad2c8a6909$var$te(e) {
    var t = e.language, r = e.children, n = (0, $37311d2b72b65959$exports.highlight)($b2d204ad2c8a6909$var$e0($48df8688b246b15a$exports)((0, $4HBpa.isValidElement)(r) ? r : (0, $237889e76c767d38$exports.jsx)($237889e76c767d38$exports.Fragment, {
        children: r
    })), $37311d2b72b65959$exports.languages[t], t);
    return (0, $237889e76c767d38$exports.jsx)("pre", {
        children: (0, $237889e76c767d38$exports.jsx)("code", {
            className: "language-".concat(t),
            dangerouslySetInnerHTML: {
                __html: n
            }
        })
    });
}
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$e9, "CodeBlock", function() {
    return $b2d204ad2c8a6909$var$te;
});
var $b2d204ad2c8a6909$var$tt = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tt, "VariantColors", function() {
    return $b2d204ad2c8a6909$var$tr;
}), $b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tt, "text2color", function() {
    return $b2d204ad2c8a6909$var$tn;
});
var $b2d204ad2c8a6909$var$tr = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
    "light"
];
function $b2d204ad2c8a6909$var$tn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = t[0] ? $b2d204ad2c8a6909$var$tr.filter(function(e) {
        return !t.find(function(t) {
            return t === e;
        });
    }) : $b2d204ad2c8a6909$var$tr;
    return r[(0, $41564e795f0c9d63$export$71511d61b312f219)(e).reduce(function(e, t) {
        return e + t.charCodeAt(0);
    }, 0) % r.length];
}
var $b2d204ad2c8a6909$var$ta = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$ta, "DialogClose", function() {
    return $b2d204ad2c8a6909$var$tl;
}), $b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$ta, "Dialog", function() {
    return $b2d204ad2c8a6909$var$ts;
});
var $b2d204ad2c8a6909$var$ti = function(e, t, r) {
    for(var n = arguments.length > 2, a = 0; a < t.length; a++)r = n ? t[a].call(e, r) : t[a].call(e);
    return n ? r : void 0;
}, $b2d204ad2c8a6909$var$to = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $b2d204ad2c8a6909$var$tc = function(e, t, r, n, a) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, $b2d204ad2c8a6909$var$tl = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Dialog closed";
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), t.call(this, e);
    }
    return r;
}((0, $e851e88da3cfd192$export$71511d61b312f219)(Error)), $b2d204ad2c8a6909$var$ts = ($b2d204ad2c8a6909$var$r = [], $b2d204ad2c8a6909$var$n = [], $b2d204ad2c8a6909$var$e = function() {
    function e(a) {
        var i = this;
        (0, $a3e0d6b297546463$export$71511d61b312f219)(this, e), $b2d204ad2c8a6909$var$t.set(this, ($b2d204ad2c8a6909$var$ti(this, $b2d204ad2c8a6909$var$r), $b2d204ad2c8a6909$var$ti(this, $b2d204ad2c8a6909$var$n, void 0))), Object.defineProperty(this, "Component", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.Component = (0, $2bb10cc242f0df2f$export$b6ae1bc530f4c149)(function() {
            return (0, $237889e76c767d38$exports.jsx)(a, {
                defer: i.defer
            });
        }), this.Component.displayName = "DialogComponent";
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(e, [
        {
            key: "defer",
            get: function() {
                return $b2d204ad2c8a6909$var$to(this, $b2d204ad2c8a6909$var$t, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$tc(this, $b2d204ad2c8a6909$var$t, e, "f");
            }
        },
        {
            key: "open",
            value: function() {
                var e = this;
                return this.defer = new $630535246db4a983$export$c7e91f8aec23ae14, this.defer.promise.finally(function() {
                    return e.defer = void 0;
                }), this.defer.promise;
            }
        }
    ]), e;
}(), $b2d204ad2c8a6909$var$t = new WeakMap, $b2d204ad2c8a6909$var$a = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, function(e, t, r, n, a, i) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, l = n.kind, s = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f = !1, p = r.length - 1; p >= 0; p--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            i.push(o(e || null));
        };
        var m = (0, r[p])("accessor" === l ? {
            get: d.get,
            set: d.set
        } : d[s], v);
        if ("accessor" === l) {
            if (void 0 === m) continue;
            if (null === m || "object" != typeof m) throw TypeError("Object expected");
            (c = o(m.get)) && (d.get = c), (c = o(m.set)) && (d.set = c), (c = o(m.init)) && a.unshift(c);
        } else (c = o(m)) && ("field" === l ? a.unshift(c) : d[s] = c);
    }
    u && Object.defineProperty(u, n.name, d), f = !0;
}($b2d204ad2c8a6909$var$e, null, [
    $kAoxL.observable
], {
    kind: "accessor",
    name: "defer",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "defer" in e;
        },
        get: function(e) {
            return e.defer;
        },
        set: function(e, t) {
            e.defer = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$a
}, $b2d204ad2c8a6909$var$n, $b2d204ad2c8a6909$var$r), $b2d204ad2c8a6909$var$a && Object.defineProperty($b2d204ad2c8a6909$var$e, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $b2d204ad2c8a6909$var$a
}), $b2d204ad2c8a6909$var$e), $b2d204ad2c8a6909$var$tu = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tu, "Editor", function() {
    return $b2d204ad2c8a6909$var$ty;
});
var $b2d204ad2c8a6909$var$td = function(e, t, r) {
    for(var n = arguments.length > 2, a = 0; a < t.length; a++)r = n ? t[a].call(e, r) : t[a].call(e);
    return n ? r : void 0;
}, $b2d204ad2c8a6909$var$tf = function(e, t, r, n, a, i) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, l = n.kind, s = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f = !1, p = r.length - 1; p >= 0; p--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            i.push(o(e || null));
        };
        var m = (0, r[p])("accessor" === l ? {
            get: d.get,
            set: d.set
        } : d[s], v);
        if ("accessor" === l) {
            if (void 0 === m) continue;
            if (null === m || "object" != typeof m) throw TypeError("Object expected");
            (c = o(m.get)) && (d.get = c), (c = o(m.set)) && (d.set = c), (c = o(m.init)) && a.unshift(c);
        } else (c = o(m)) && ("field" === l ? a.unshift(c) : d[s] = c);
    }
    u && Object.defineProperty(u, n.name, d), f = !0;
}, $b2d204ad2c8a6909$var$tp = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $b2d204ad2c8a6909$var$tv = function(e, t, r, n, a) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, $b2d204ad2c8a6909$var$th = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$tm = (0, $e32f060b0f06d5c3$export$da8ca15f4115b46e)(), $b2d204ad2c8a6909$var$ty = ($b2d204ad2c8a6909$var$l = [
    $2bb10cc242f0df2f$export$b6ae1bc530f4c149
], $b2d204ad2c8a6909$var$s = [], $b2d204ad2c8a6909$var$u = $4HBpa.PureComponent, $b2d204ad2c8a6909$var$d = [], $b2d204ad2c8a6909$var$f = [], $b2d204ad2c8a6909$var$c = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
            this
        ].concat(Array.prototype.slice.call(arguments))), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "core", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void $b2d204ad2c8a6909$var$td((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$d)
        }), $b2d204ad2c8a6909$var$i.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$td((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$f, e.props.defaultValue)), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "save", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function() {
                var t, r, n, a;
                return t = (0, $0fbfbb0e88863202$export$71511d61b312f219)(e), r = void 0, n = void 0, a = function() {
                    var e, t;
                    return (0, $bcfad0ea6174f23f$export$71511d61b312f219)(this, function(r) {
                        switch(r.label){
                            case 0:
                                if (!(e = this.core)) return [
                                    3,
                                    2
                                ];
                                return t = this, [
                                    4,
                                    this.core.save()
                                ];
                            case 1:
                                e = t.innerValue = r.sent(), r.label = 2;
                            case 2:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                }, new (n || (n = Promise))(function(e, i) {
                    function o(e) {
                        try {
                            l(a.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function c(e) {
                        try {
                            l(a.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function l(t) {
                        var r;
                        t.done ? e(t.value) : ((r = t.value) instanceof n ? r : new n(function(e) {
                            e(r);
                        })).then(o, c);
                    }
                    l((a = a.apply(t, r || [])).next());
                });
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
        {
            key: "innerValue",
            get: function() {
                return $b2d204ad2c8a6909$var$tp(this, $b2d204ad2c8a6909$var$i, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$tv(this, $b2d204ad2c8a6909$var$i, e, "f");
            }
        },
        {
            key: "render",
            value: function() {
                var e = this, t = this.props, r = t.name, n = t.required, a = (t.children, $b2d204ad2c8a6909$var$th(t, [
                    "name",
                    "required",
                    "children"
                ])), i = this.innerValue;
                return (0, $237889e76c767d38$exports.jsxs)("div", {
                    className: "form-control",
                    tabIndex: -1,
                    onBlur: this.save,
                    children: [
                        (0, $237889e76c767d38$exports.jsx)("input", {
                            hidden: !0,
                            name: r,
                            required: n,
                            value: JSON.stringify(i)
                        }),
                        (0, $237889e76c767d38$exports.jsx)($b2d204ad2c8a6909$var$tm, Object.assign({}, a, {
                            onInitialize: function(t) {
                                var r;
                                e.core = t, null === (r = a.onInitialize) || void 0 === r || r.call(a, t);
                            }
                        }))
                    ]
                });
            }
        }
    ]), r;
}($b2d204ad2c8a6909$var$u), $b2d204ad2c8a6909$var$i = new WeakMap, $b2d204ad2c8a6909$var$p = $b2d204ad2c8a6909$var$c, $b2d204ad2c8a6909$var$v = "Editor", "symbol" === (0, $0d42f84d7422b820$export$71511d61b312f219)($b2d204ad2c8a6909$var$v) && ($b2d204ad2c8a6909$var$v = $b2d204ad2c8a6909$var$v.description ? "[".concat($b2d204ad2c8a6909$var$v.description, "]") : ""), Object.defineProperty($b2d204ad2c8a6909$var$p, "name", {
    configurable: !0,
    value: $b2d204ad2c8a6909$var$h ? "".concat($b2d204ad2c8a6909$var$h, " ", $b2d204ad2c8a6909$var$v) : $b2d204ad2c8a6909$var$v
}), $b2d204ad2c8a6909$var$y = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== ($b2d204ad2c8a6909$var$m = $b2d204ad2c8a6909$var$u[Symbol.metadata]) && void 0 !== $b2d204ad2c8a6909$var$m ? $b2d204ad2c8a6909$var$m : null) : void 0, $b2d204ad2c8a6909$var$tf($b2d204ad2c8a6909$var$c, null, [
    $kAoxL.observable
], {
    kind: "accessor",
    name: "innerValue",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "innerValue" in e;
        },
        get: function(e) {
            return e.innerValue;
        },
        set: function(e, t) {
            e.innerValue = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$y
}, $b2d204ad2c8a6909$var$f, $b2d204ad2c8a6909$var$d), $b2d204ad2c8a6909$var$tf(null, $b2d204ad2c8a6909$var$o = {
    value: $b2d204ad2c8a6909$var$c
}, $b2d204ad2c8a6909$var$l, {
    kind: "class",
    name: $b2d204ad2c8a6909$var$c.name,
    metadata: $b2d204ad2c8a6909$var$y
}, null, $b2d204ad2c8a6909$var$s), $b2d204ad2c8a6909$var$c = $b2d204ad2c8a6909$var$o.value, $b2d204ad2c8a6909$var$y && Object.defineProperty($b2d204ad2c8a6909$var$c, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $b2d204ad2c8a6909$var$y
}), Object.defineProperty($b2d204ad2c8a6909$var$c, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "Editor"
}), $b2d204ad2c8a6909$var$td($b2d204ad2c8a6909$var$c, $b2d204ad2c8a6909$var$s), $b2d204ad2c8a6909$var$c), $b2d204ad2c8a6909$var$tb = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tb, "parser", function() {
    return $b2d204ad2c8a6909$var$tg;
}), $b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tb, "EditorHTML", function() {
    return $b2d204ad2c8a6909$var$tw;
});
var $b2d204ad2c8a6909$var$tg = $b2d204ad2c8a6909$var$e0($f4d62e6f87601d7b$exports)({
    link: function(e) {
        var t = e.data.link;
        return '<a href="'.concat(t, '">').concat(t, "</a>");
    }
}), $b2d204ad2c8a6909$var$tw = function(e) {
    var t = e.className, r = e.data, n = $b2d204ad2c8a6909$var$tg.parse(r).join("");
    return (0, $237889e76c767d38$exports.jsx)("article", {
        className: t,
        dangerouslySetInnerHTML: {
            __html: n
        }
    });
};
$b2d204ad2c8a6909$var$tw.displayName = "EditorHTML";
var $b2d204ad2c8a6909$var$tj = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tj, "Icon", function() {
    return $b2d204ad2c8a6909$var$tx;
});
var $b2d204ad2c8a6909$var$tO = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$tx = function(e) {
    var t = e.className, r = e.style, n = e.name, a = e.size, i = $b2d204ad2c8a6909$var$tO(e, [
        "className",
        "style",
        "name",
        "size"
    ]);
    return (0, $237889e76c767d38$exports.jsx)("i", Object.assign({
        className: $b2d204ad2c8a6909$var$e0($46a03b660b5bd4f2$exports)("bi-".concat(n), t),
        style: Object.assign({
            fontSize: a && "".concat(a, "rem")
        }, r)
    }, i));
};
$b2d204ad2c8a6909$var$tx.displayName = "Icon";
var $b2d204ad2c8a6909$var$t_ = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$t_, "Loading", function() {
    return $b2d204ad2c8a6909$var$tP;
});
var $b2d204ad2c8a6909$var$tP = function(e) {
    var t = e.children;
    return (0, $237889e76c767d38$exports.jsxs)("div", {
        className: "fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black",
        children: [
            (0, $237889e76c767d38$exports.jsx)($b77909a1b1b04ae6$export$2e2bcd8739ae039, {
                animation: "border",
                variant: "success"
            }),
            (0, $237889e76c767d38$exports.jsx)("span", {
                className: "ml-3 text-white",
                children: void 0 === t ? "Loading..." : t
            })
        ]
    });
};
$b2d204ad2c8a6909$var$tP.displayName = "Loading";
var $b2d204ad2c8a6909$var$tk = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tk, "MonthCalendar", function() {
    return $b2d204ad2c8a6909$var$tq;
});
var $b2d204ad2c8a6909$var$tT = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tT, "OverlayBox", function() {
    return $b2d204ad2c8a6909$var$tS;
});
var $b2d204ad2c8a6909$var$tE = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$tS = function(e) {
    var t = e.title, r = e.detail, n = e.children, a = $b2d204ad2c8a6909$var$tE(e, [
        "title",
        "detail",
        "children"
    ]);
    return (0, $237889e76c767d38$exports.jsx)($ee913af29239d9e3$export$2e2bcd8739ae039, Object.assign({}, a, {
        overlay: r ? (0, $237889e76c767d38$exports.jsxs)($80bafe4d791ef4d4$export$2e2bcd8739ae039, {
            children: [
                (0, $237889e76c767d38$exports.jsx)($80bafe4d791ef4d4$export$2e2bcd8739ae039.Header, {
                    children: t
                }),
                (0, $237889e76c767d38$exports.jsx)($80bafe4d791ef4d4$export$2e2bcd8739ae039.Body, {
                    children: r
                })
            ]
        }) : (0, $237889e76c767d38$exports.jsx)($d4a4bde41225d644$export$2e2bcd8739ae039, {
            children: t
        }),
        children: n
    }));
};
$b2d204ad2c8a6909$var$tS.displayName = "OverlayBox";
var $b2d204ad2c8a6909$var$tI = function(e, t, r, n, a, i) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, l = n.kind, s = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f = !1, p = r.length - 1; p >= 0; p--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            i.push(o(e || null));
        };
        var m = (0, r[p])("accessor" === l ? {
            get: d.get,
            set: d.set
        } : d[s], v);
        if ("accessor" === l) {
            if (void 0 === m) continue;
            if (null === m || "object" != typeof m) throw TypeError("Object expected");
            (c = o(m.get)) && (d.get = c), (c = o(m.set)) && (d.set = c), (c = o(m.init)) && a.unshift(c);
        } else (c = o(m)) && ("field" === l ? a.unshift(c) : d[s] = c);
    }
    u && Object.defineProperty(u, n.name, d), f = !0;
}, $b2d204ad2c8a6909$var$tN = function(e, t, r) {
    for(var n = arguments.length > 2, a = 0; a < t.length; a++)r = n ? t[a].call(e, r) : t[a].call(e);
    return n ? r : void 0;
}, $b2d204ad2c8a6909$var$tC = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $b2d204ad2c8a6909$var$tD = function(e, t, r, n, a) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, $b2d204ad2c8a6909$var$tM = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$tq = ($b2d204ad2c8a6909$var$_ = [
    $2bb10cc242f0df2f$export$b6ae1bc530f4c149,
    $1d49ee2f49ed26bb$exports.observePropsState
], $b2d204ad2c8a6909$var$P = [], $b2d204ad2c8a6909$var$k = $4HBpa.Component, $b2d204ad2c8a6909$var$T = [], $b2d204ad2c8a6909$var$E = [], $b2d204ad2c8a6909$var$w = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
            this
        ].concat(Array.prototype.slice.call(arguments))), $b2d204ad2c8a6909$var$b.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), ($b2d204ad2c8a6909$var$tN((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$T), $b2d204ad2c8a6909$var$tN((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$E, new Date))), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "renderDate", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r = e.observedProps, n = (r.variant, r.value), a = r.onSelect, i = (0, $a1a155eb9166d0df$export$3ae94a2503e890a1)(t, "YYYY-MM-DD"), o = null == n ? void 0 : n.filter(function(e) {
                    var t = e.date;
                    return (0, $a1a155eb9166d0df$export$3ae94a2503e890a1)(t, "YYYY-MM-DD") === i;
                });
                return (0, $237889e76c767d38$exports.jsxs)("td", {
                    className: $b2d204ad2c8a6909$var$e0($46a03b660b5bd4f2$exports)({
                        "opacity-50": t.getMonth() !== e.currentDate.getMonth(),
                        "fw-bold": i === (0, $a1a155eb9166d0df$export$3ae94a2503e890a1)(new Date, "YYYY-MM-DD")
                    }),
                    children: [
                        (0, $237889e76c767d38$exports.jsx)("time", {
                            className: "d-block",
                            dateTime: t.toJSON(),
                            children: t.getDate()
                        }),
                        null == o ? void 0 : o.map(function(e) {
                            return "object" == typeof e.content ? e.content : (0, $237889e76c767d38$exports.jsx)($b2d204ad2c8a6909$var$tS, {
                                title: e.content,
                                children: (0, $237889e76c767d38$exports.jsx)($d24f0e25e592dc71$export$2e2bcd8739ae039, {
                                    as: "a",
                                    className: "d-inline-block text-decoration-none w-100 text-truncate",
                                    bg: $b2d204ad2c8a6909$var$tn(e.content + "", [
                                        "light"
                                    ]),
                                    href: e.link,
                                    onClick: function() {
                                        return null == a ? void 0 : a(e);
                                    },
                                    children: e.content
                                })
                            }, e.date + "");
                        })
                    ]
                }, t + "");
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
        {
            key: "weekFormatter",
            get: function() {
                var e, t = this.observedProps.locale, r = void 0 === t ? null === (e = globalThis.navigator) || void 0 === e ? void 0 : e.language : t;
                return new Intl.DateTimeFormat(r, {
                    weekday: "long"
                });
            }
        },
        {
            key: "currentDate",
            get: function() {
                return $b2d204ad2c8a6909$var$tC(this, $b2d204ad2c8a6909$var$b, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$tD(this, $b2d204ad2c8a6909$var$b, e, "f");
            }
        },
        {
            key: "dateGrid",
            get: function() {
                var e = new Date(this.currentDate);
                e.setDate(1), e = new Date(+e - e.getDay() * $a1a155eb9166d0df$export$7a9a31a911eb9a20);
                var t = Array.from(Array(42), function(t, r) {
                    return new Date(+e + r * $a1a155eb9166d0df$export$7a9a31a911eb9a20);
                });
                return (0, $a1a155eb9166d0df$export$697c3df919c0e61a)(t, 7);
            }
        },
        {
            key: "changeMonth",
            value: function(e) {
                var t, r;
                this.currentDate = (0, $a1a155eb9166d0df$export$62ad822b3a5fd9a0)(this.currentDate, e), null === (r = (t = this.props).onChange) || void 0 === r || r.call(t, this.currentDate);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this, t = this.weekFormatter, r = this.currentDate, n = this.dateGrid, a = this.observedProps, i = a.style, o = a.variant, c = void 0 === o ? "primary" : o, l = (a.onChange, a.onSelect, $b2d204ad2c8a6909$var$tM(a, [
                    "style",
                    "variant",
                    "onChange",
                    "onSelect"
                ]));
                return (0, $237889e76c767d38$exports.jsxs)($279fc564c3dfbde6$export$2e2bcd8739ae039, Object.assign({}, l, {
                    style: Object.assign({
                        tableLayout: "fixed"
                    }, i),
                    children: [
                        (0, $237889e76c767d38$exports.jsx)("caption", {
                            children: (0, $237889e76c767d38$exports.jsxs)("div", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    (0, $237889e76c767d38$exports.jsx)($367fe3a5abb69f2e$export$2e2bcd8739ae039, {
                                        variant: c,
                                        onClick: function() {
                                            return e.changeMonth(-1);
                                        },
                                        children: "<"
                                    }),
                                    (0, $a1a155eb9166d0df$export$3ae94a2503e890a1)(r, "YYYY-MM"),
                                    (0, $237889e76c767d38$exports.jsx)($367fe3a5abb69f2e$export$2e2bcd8739ae039, {
                                        variant: c,
                                        onClick: function() {
                                            return e.changeMonth(1);
                                        },
                                        children: ">"
                                    })
                                ]
                            })
                        }),
                        (0, $237889e76c767d38$exports.jsx)("thead", {
                            children: (0, $237889e76c767d38$exports.jsx)("tr", {
                                children: n[0].map(function(e, r, n) {
                                    var a = n.length;
                                    return (0, $237889e76c767d38$exports.jsx)("td", {
                                        className: "bg-".concat(c, " text-white"),
                                        style: {
                                            width: "calc(100% / ".concat(a, ")")
                                        },
                                        children: t.format(e)
                                    }, r);
                                })
                            })
                        }),
                        (0, $237889e76c767d38$exports.jsx)("tbody", {
                            children: n.map(function(t) {
                                return (0, $237889e76c767d38$exports.jsx)("tr", {
                                    children: t.map(e.renderDate)
                                }, t[0] + "");
                            })
                        })
                    ]
                }));
            }
        }
    ]), r;
}($b2d204ad2c8a6909$var$k), $b2d204ad2c8a6909$var$b = new WeakMap, $b2d204ad2c8a6909$var$S = $b2d204ad2c8a6909$var$w, $b2d204ad2c8a6909$var$I = "MonthCalendar", "symbol" === (0, $0d42f84d7422b820$export$71511d61b312f219)($b2d204ad2c8a6909$var$I) && ($b2d204ad2c8a6909$var$I = $b2d204ad2c8a6909$var$I.description ? "[".concat($b2d204ad2c8a6909$var$I.description, "]") : ""), Object.defineProperty($b2d204ad2c8a6909$var$S, "name", {
    configurable: !0,
    value: $b2d204ad2c8a6909$var$N ? "".concat($b2d204ad2c8a6909$var$N, " ", $b2d204ad2c8a6909$var$I) : $b2d204ad2c8a6909$var$I
}), $b2d204ad2c8a6909$var$D = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== ($b2d204ad2c8a6909$var$C = $b2d204ad2c8a6909$var$k[Symbol.metadata]) && void 0 !== $b2d204ad2c8a6909$var$C ? $b2d204ad2c8a6909$var$C : null) : void 0, $b2d204ad2c8a6909$var$j = [
    $kAoxL.computed
], $b2d204ad2c8a6909$var$O = [
    $kAoxL.observable
], $b2d204ad2c8a6909$var$x = [
    $kAoxL.computed
], $b2d204ad2c8a6909$var$tI($b2d204ad2c8a6909$var$w, null, $b2d204ad2c8a6909$var$j, {
    kind: "getter",
    name: "weekFormatter",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "weekFormatter" in e;
        },
        get: function(e) {
            return e.weekFormatter;
        }
    },
    metadata: $b2d204ad2c8a6909$var$D
}, null, $b2d204ad2c8a6909$var$T), $b2d204ad2c8a6909$var$tI($b2d204ad2c8a6909$var$w, null, $b2d204ad2c8a6909$var$O, {
    kind: "accessor",
    name: "currentDate",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "currentDate" in e;
        },
        get: function(e) {
            return e.currentDate;
        },
        set: function(e, t) {
            e.currentDate = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$D
}, $b2d204ad2c8a6909$var$E, $b2d204ad2c8a6909$var$T), $b2d204ad2c8a6909$var$tI($b2d204ad2c8a6909$var$w, null, $b2d204ad2c8a6909$var$x, {
    kind: "getter",
    name: "dateGrid",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "dateGrid" in e;
        },
        get: function(e) {
            return e.dateGrid;
        }
    },
    metadata: $b2d204ad2c8a6909$var$D
}, null, $b2d204ad2c8a6909$var$T), $b2d204ad2c8a6909$var$tI(null, $b2d204ad2c8a6909$var$g = {
    value: $b2d204ad2c8a6909$var$w
}, $b2d204ad2c8a6909$var$_, {
    kind: "class",
    name: $b2d204ad2c8a6909$var$w.name,
    metadata: $b2d204ad2c8a6909$var$D
}, null, $b2d204ad2c8a6909$var$P), $b2d204ad2c8a6909$var$w = $b2d204ad2c8a6909$var$g.value, $b2d204ad2c8a6909$var$D && Object.defineProperty($b2d204ad2c8a6909$var$w, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $b2d204ad2c8a6909$var$D
}), Object.defineProperty($b2d204ad2c8a6909$var$w, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "MonthCalendar"
}), $b2d204ad2c8a6909$var$tN($b2d204ad2c8a6909$var$w, $b2d204ad2c8a6909$var$P), $b2d204ad2c8a6909$var$w), $b2d204ad2c8a6909$var$tY = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tY, "Nameplate", function() {
    return $b2d204ad2c8a6909$var$tL;
});
var $b2d204ad2c8a6909$var$tL = function(e) {
    var t = e.avatar, r = e.name;
    return (0, $237889e76c767d38$exports.jsxs)($237889e76c767d38$exports.Fragment, {
        children: [
            (0, $237889e76c767d38$exports.jsx)($b2d204ad2c8a6909$var$e5, {
                size: 2,
                style: {
                    marginRight: "0.5rem"
                },
                src: t
            }),
            (0, $237889e76c767d38$exports.jsx)("span", {
                className: "align-middle",
                children: r
            })
        ]
    });
};
$b2d204ad2c8a6909$var$tL.displayName = "Nameplate";
var $b2d204ad2c8a6909$var$tz = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tz, "PageNav", function() {
    return $b2d204ad2c8a6909$var$tV;
});
var $b2d204ad2c8a6909$var$tA = function(e, t, r, n, a, i) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, l = n.kind, s = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f = !1, p = r.length - 1; p >= 0; p--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            i.push(o(e || null));
        };
        var m = (0, r[p])("accessor" === l ? {
            get: d.get,
            set: d.set
        } : d[s], v);
        if ("accessor" === l) {
            if (void 0 === m) continue;
            if (null === m || "object" != typeof m) throw TypeError("Object expected");
            (c = o(m.get)) && (d.get = c), (c = o(m.set)) && (d.set = c), (c = o(m.init)) && a.unshift(c);
        } else (c = o(m)) && ("field" === l ? a.unshift(c) : d[s] = c);
    }
    u && Object.defineProperty(u, n.name, d), f = !0;
}, $b2d204ad2c8a6909$var$tR = function(e, t, r) {
    for(var n = arguments.length > 2, a = 0; a < t.length; a++)r = n ? t[a].call(e, r) : t[a].call(e);
    return n ? r : void 0;
}, $b2d204ad2c8a6909$var$tU = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $b2d204ad2c8a6909$var$tF = function(e, t, r, n, a) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, $b2d204ad2c8a6909$var$tB = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$tW = Array.from(Array(6), function(e, t) {
    return "h".concat(++t);
}) + "", $b2d204ad2c8a6909$var$tV = ($b2d204ad2c8a6909$var$U = [
    $2bb10cc242f0df2f$export$b6ae1bc530f4c149
], $b2d204ad2c8a6909$var$F = [], $b2d204ad2c8a6909$var$B = $4HBpa.PureComponent, $b2d204ad2c8a6909$var$W = [], $b2d204ad2c8a6909$var$V = [], $b2d204ad2c8a6909$var$H = [], $b2d204ad2c8a6909$var$L = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
            this
        ].concat(Array.prototype.slice.call(arguments))), $b2d204ad2c8a6909$var$M.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), ($b2d204ad2c8a6909$var$tR((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$W), $b2d204ad2c8a6909$var$tR((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$V, []))), $b2d204ad2c8a6909$var$q.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$tR((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$H, 0)), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "updateScrollY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function() {
                return e.scrollY = window.scrollY;
            }
        }), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "scrollTo", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                return function() {
                    var r, n;
                    setTimeout(function() {
                        return (0, $a1a155eb9166d0df$export$3f99968195accfaf)('[id="'.concat(t.id, '"]'));
                    }), null === (n = (r = e.props).onItemClick) || void 0 === n || n.call(r, t);
                };
            }
        }), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "renderLink", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r = t.id, n = t.level, a = t.text, i = t.top, o = (0, $0fbfbb0e88863202$export$71511d61b312f219)(e).currentActiveId, c = e.props.depth;
                return n <= (void 0 === c ? 1 / 0 : c) && (0, $237889e76c767d38$exports.jsx)($1b7a3ff760a21514$export$2e2bcd8739ae039.Item, {
                    style: {
                        textIndent: "".concat(n - 1, "rem")
                    },
                    children: (0, $237889e76c767d38$exports.jsx)($1b7a3ff760a21514$export$2e2bcd8739ae039.Link, {
                        href: "#".concat(r),
                        active: o === r,
                        onClick: e.scrollTo({
                            id: r,
                            level: n,
                            text: a,
                            top: i
                        }),
                        children: a
                    })
                }, r);
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
        {
            key: "list",
            get: function() {
                return $b2d204ad2c8a6909$var$tU(this, $b2d204ad2c8a6909$var$M, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$tF(this, $b2d204ad2c8a6909$var$M, e, "f");
            }
        },
        {
            key: "scrollY",
            get: function() {
                return $b2d204ad2c8a6909$var$tU(this, $b2d204ad2c8a6909$var$q, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$tF(this, $b2d204ad2c8a6909$var$q, e, "f");
            }
        },
        {
            key: "currentActiveId",
            get: function() {
                var e, t = this.list, r = this.scrollY, n = t.findIndex(function(e) {
                    return e.top > r;
                });
                return null === (e = t[n - 1]) || void 0 === e ? void 0 : e.id;
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                globalThis.document && (window.addEventListener("scroll", this.updateScrollY), this.list = Array.from(document.querySelectorAll($b2d204ad2c8a6909$var$tW), function(e) {
                    e.id || (e.id = (0, $a1a155eb9166d0df$export$89912e019eef22aa)());
                    var t = e.id, r = e.tagName, n = e.textContent, a = e.offsetTop;
                    return {
                        id: t,
                        level: +r[1],
                        text: n.trim(),
                        top: a
                    };
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                var e;
                null === (e = globalThis.removeEventListener) || void 0 === e || e.call(globalThis, "scroll", this.updateScrollY);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.list, t = this.props, r = t.style, n = t.variant, a = $b2d204ad2c8a6909$var$tB(t, [
                    "style",
                    "variant"
                ]);
                return (0, $237889e76c767d38$exports.jsx)($1b7a3ff760a21514$export$2e2bcd8739ae039, Object.assign({}, a, {
                    variant: void 0 === n ? "underline" : n,
                    style: Object.assign({
                        flexDirection: "column"
                    }, r),
                    children: e.map(this.renderLink)
                }));
            }
        }
    ]), r;
}($b2d204ad2c8a6909$var$B), $b2d204ad2c8a6909$var$M = new WeakMap, $b2d204ad2c8a6909$var$q = new WeakMap, $b2d204ad2c8a6909$var$G = $b2d204ad2c8a6909$var$L, $b2d204ad2c8a6909$var$J = "PageNav", "symbol" === (0, $0d42f84d7422b820$export$71511d61b312f219)($b2d204ad2c8a6909$var$J) && ($b2d204ad2c8a6909$var$J = $b2d204ad2c8a6909$var$J.description ? "[".concat($b2d204ad2c8a6909$var$J.description, "]") : ""), Object.defineProperty($b2d204ad2c8a6909$var$G, "name", {
    configurable: !0,
    value: $b2d204ad2c8a6909$var$K ? "".concat($b2d204ad2c8a6909$var$K, " ", $b2d204ad2c8a6909$var$J) : $b2d204ad2c8a6909$var$J
}), $b2d204ad2c8a6909$var$X = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== ($b2d204ad2c8a6909$var$Q = $b2d204ad2c8a6909$var$B[Symbol.metadata]) && void 0 !== $b2d204ad2c8a6909$var$Q ? $b2d204ad2c8a6909$var$Q : null) : void 0, $b2d204ad2c8a6909$var$z = [
    $kAoxL.observable
], $b2d204ad2c8a6909$var$A = [
    $kAoxL.observable
], $b2d204ad2c8a6909$var$R = [
    $kAoxL.computed
], $b2d204ad2c8a6909$var$tA($b2d204ad2c8a6909$var$L, null, $b2d204ad2c8a6909$var$z, {
    kind: "accessor",
    name: "list",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "list" in e;
        },
        get: function(e) {
            return e.list;
        },
        set: function(e, t) {
            e.list = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$X
}, $b2d204ad2c8a6909$var$V, $b2d204ad2c8a6909$var$W), $b2d204ad2c8a6909$var$tA($b2d204ad2c8a6909$var$L, null, $b2d204ad2c8a6909$var$A, {
    kind: "accessor",
    name: "scrollY",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "scrollY" in e;
        },
        get: function(e) {
            return e.scrollY;
        },
        set: function(e, t) {
            e.scrollY = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$X
}, $b2d204ad2c8a6909$var$H, $b2d204ad2c8a6909$var$W), $b2d204ad2c8a6909$var$tA($b2d204ad2c8a6909$var$L, null, $b2d204ad2c8a6909$var$R, {
    kind: "getter",
    name: "currentActiveId",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "currentActiveId" in e;
        },
        get: function(e) {
            return e.currentActiveId;
        }
    },
    metadata: $b2d204ad2c8a6909$var$X
}, null, $b2d204ad2c8a6909$var$W), $b2d204ad2c8a6909$var$tA(null, $b2d204ad2c8a6909$var$Y = {
    value: $b2d204ad2c8a6909$var$L
}, $b2d204ad2c8a6909$var$U, {
    kind: "class",
    name: $b2d204ad2c8a6909$var$L.name,
    metadata: $b2d204ad2c8a6909$var$X
}, null, $b2d204ad2c8a6909$var$F), $b2d204ad2c8a6909$var$L = $b2d204ad2c8a6909$var$Y.value, $b2d204ad2c8a6909$var$X && Object.defineProperty($b2d204ad2c8a6909$var$L, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $b2d204ad2c8a6909$var$X
}), Object.defineProperty($b2d204ad2c8a6909$var$L, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "PageNav"
}), $b2d204ad2c8a6909$var$tR($b2d204ad2c8a6909$var$L, $b2d204ad2c8a6909$var$F), $b2d204ad2c8a6909$var$L), $b2d204ad2c8a6909$var$tH = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tH, "Option", function() {
    return $b2d204ad2c8a6909$var$tJ;
}), $b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tH, "Select", function() {
    return $b2d204ad2c8a6909$var$tK;
});
var $b2d204ad2c8a6909$var$tG = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$tJ = function(e) {
    var t = e.value, r = e.children, n = $b2d204ad2c8a6909$var$tG(e, [
        "value",
        "children"
    ]);
    return (0, $237889e76c767d38$exports.jsx)($2ac552a1d6e4346b$export$2e2bcd8739ae039.Item, Object.assign({}, n, {
        "data-value": t,
        children: r
    }));
};
$b2d204ad2c8a6909$var$tJ.displayName = "Option";
var $b2d204ad2c8a6909$var$tK = function(e) {
    var t = e.className, r = e.style, n = e.variant, a = e.menuVariant, i = e.children, o = e.value, c = e.onChange, l = e.valueRender, s = (0, $a1a155eb9166d0df$export$7b85fd78dd236198)(i).flat(1 / 0).find(function(e) {
        return (0, $4HBpa.isValidElement)(e) && e.type === $b2d204ad2c8a6909$var$tJ && e.props.value === o;
    });
    return (0, $237889e76c767d38$exports.jsxs)($2ac552a1d6e4346b$export$2e2bcd8739ae039, {
        onClick: function(e) {
            var t = e.target.closest(".dropdown-item");
            if (t) {
                var r = t.dataset.value;
                null == c || c(r);
            }
        },
        children: [
            (0, $237889e76c767d38$exports.jsx)($2ac552a1d6e4346b$export$2e2bcd8739ae039.Toggle, {
                className: $b2d204ad2c8a6909$var$e0($46a03b660b5bd4f2$exports)("w-100", "d-flex", "justify-content-between", "align-items-center", !n && "bg-white text-dark", t),
                style: r,
                variant: n,
                children: (null == l ? void 0 : l(o)) || (0, $237889e76c767d38$exports.jsx)("div", {
                    className: null == s ? void 0 : s.props.className,
                    children: null == s ? void 0 : s.props.children
                })
            }),
            (0, $237889e76c767d38$exports.jsx)($2ac552a1d6e4346b$export$2e2bcd8739ae039.Menu, {
                variant: a,
                children: i
            })
        ]
    });
};
$b2d204ad2c8a6909$var$tK.displayName = "Select";
var $b2d204ad2c8a6909$var$tQ = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tQ, "elementToImage", function() {
    return $b2d204ad2c8a6909$var$t2;
}), $b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$tQ, "ShareBox", function() {
    return $b2d204ad2c8a6909$var$t4;
});
var $b2d204ad2c8a6909$var$tX = function(e, t, r) {
    for(var n = arguments.length > 2, a = 0; a < t.length; a++)r = n ? t[a].call(e, r) : t[a].call(e);
    return n ? r : void 0;
}, $b2d204ad2c8a6909$var$tZ = function(e, t, r, n, a, i) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, l = n.kind, s = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f = !1, p = r.length - 1; p >= 0; p--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            i.push(o(e || null));
        };
        var m = (0, r[p])("accessor" === l ? {
            get: d.get,
            set: d.set
        } : d[s], v);
        if ("accessor" === l) {
            if (void 0 === m) continue;
            if (null === m || "object" != typeof m) throw TypeError("Object expected");
            (c = o(m.get)) && (d.get = c), (c = o(m.set)) && (d.set = c), (c = o(m.init)) && a.unshift(c);
        } else (c = o(m)) && ("field" === l ? a.unshift(c) : d[s] = c);
    }
    u && Object.defineProperty(u, n.name, d), f = !0;
}, $b2d204ad2c8a6909$var$t$ = function(e, t, r, n) {
    return new (r || (r = Promise))(function(a, i) {
        function o(e) {
            try {
                l(n.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                l(n.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function l(e) {
            var t;
            e.done ? a(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(o, c);
        }
        l((n = n.apply(e, t || [])).next());
    });
}, $b2d204ad2c8a6909$var$t0 = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $b2d204ad2c8a6909$var$t1 = function(e, t, r, n, a) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
};
function $b2d204ad2c8a6909$var$t2(e, t, r) {
    return $b2d204ad2c8a6909$var$t$(this, void 0, void 0, function() {
        var n;
        return (0, $bcfad0ea6174f23f$export$71511d61b312f219)(this, function(a) {
            switch(a.label){
                case 0:
                    return [
                        4,
                        $b2d204ad2c8a6909$var$e0($eec13e6b5a0b94b3$exports)(e, {
                            useCORS: !0
                        })
                    ];
                case 1:
                    return n = a.sent(), [
                        2,
                        new Promise(function(e, a) {
                            return n.toBlob(function(t) {
                                return t ? e(URL.createObjectURL(t)) : a();
                            }, t, r);
                        })
                    ];
            }
        });
    });
}
var $b2d204ad2c8a6909$var$t4 = ($b2d204ad2c8a6909$var$ea = [
    $2bb10cc242f0df2f$export$b6ae1bc530f4c149
], $b2d204ad2c8a6909$var$ei = [], $b2d204ad2c8a6909$var$eo = $4HBpa.PureComponent, $b2d204ad2c8a6909$var$ec = [], $b2d204ad2c8a6909$var$el = [], $b2d204ad2c8a6909$var$es = [], $b2d204ad2c8a6909$var$et = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
            this
        ].concat(Array.prototype.slice.call(arguments))), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "root", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ($b2d204ad2c8a6909$var$tX((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$ec), (0, $4HBpa.createRef)())
        }), $b2d204ad2c8a6909$var$Z.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$tX((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$el, !1)), $b2d204ad2c8a6909$var$$.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$tX((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$es, "")), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "generateImage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function() {
                return $b2d204ad2c8a6909$var$t$((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), void 0, void 0, function() {
                    var e;
                    return (0, $bcfad0ea6174f23f$export$71511d61b312f219)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return this.imageURI && (URL.revokeObjectURL(this.imageURI), this.imageURI = ""), this.loading = !0, e = this, [
                                    4,
                                    $b2d204ad2c8a6909$var$t2(this.root.current)
                                ];
                            case 1:
                                return e.imageURI = t.sent(), this.loading = !1, [
                                    2
                                ];
                        }
                    });
                });
            }
        }), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "share", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                return $b2d204ad2c8a6909$var$t$((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), void 0, void 0, function() {
                    var e, r, n;
                    return (0, $bcfad0ea6174f23f$export$71511d61b312f219)(this, function(a) {
                        switch(a.label){
                            case 0:
                                return t.stopPropagation(), [
                                    4,
                                    (0, $a1a155eb9166d0df$export$fd89523fba250fa4)(this.imageURI)
                                ];
                            case 1:
                                return r = a.sent(), n = new File([
                                    r
                                ], "".concat(this.props.title, ".png"), {
                                    type: r.type
                                }), [
                                    4,
                                    null === (e = navigator.share) || void 0 === e ? void 0 : e.call(navigator, Object.assign({
                                        files: [
                                            n
                                        ]
                                    }, this.props))
                                ];
                            case 2:
                                return a.sent(), [
                                    2
                                ];
                        }
                    });
                });
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
        {
            key: "loading",
            get: function() {
                return $b2d204ad2c8a6909$var$t0(this, $b2d204ad2c8a6909$var$Z, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$t1(this, $b2d204ad2c8a6909$var$Z, e, "f");
            }
        },
        {
            key: "imageURI",
            get: function() {
                return $b2d204ad2c8a6909$var$t0(this, $b2d204ad2c8a6909$var$$, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$t1(this, $b2d204ad2c8a6909$var$$, e, "f");
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                var e;
                null === (e = globalThis.addEventListener) || void 0 === e || e.call(globalThis, "resize", this.generateImage);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                var e;
                null === (e = globalThis.removeEventListener) || void 0 === e || e.call(globalThis, "resize", this.generateImage);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props.children, t = this.loading, r = this.imageURI;
                return (0, $237889e76c767d38$exports.jsxs)($237889e76c767d38$exports.Fragment, {
                    children: [
                        t && (0, $237889e76c767d38$exports.jsx)($b2d204ad2c8a6909$var$tP, {}),
                        (0, $237889e76c767d38$exports.jsxs)("div", {
                            ref: this.root,
                            className: "position-relative",
                            onMouseEnter: r ? void 0 : this.generateImage,
                            onTouchStart: r ? void 0 : this.generateImage,
                            children: [
                                e,
                                r && (0, $237889e76c767d38$exports.jsx)($9c4c44bc71b8d84b$export$2e2bcd8739ae039, {
                                    className: "position-absolute start-0 top-0 w-100 h-100",
                                    fluid: !0,
                                    src: r,
                                    alt: "Share Image",
                                    onClick: this.share
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]), r;
}($b2d204ad2c8a6909$var$eo), $b2d204ad2c8a6909$var$Z = new WeakMap, $b2d204ad2c8a6909$var$$ = new WeakMap, $b2d204ad2c8a6909$var$eu = $b2d204ad2c8a6909$var$et, $b2d204ad2c8a6909$var$ed = "ShareBox", "symbol" === (0, $0d42f84d7422b820$export$71511d61b312f219)($b2d204ad2c8a6909$var$ed) && ($b2d204ad2c8a6909$var$ed = $b2d204ad2c8a6909$var$ed.description ? "[".concat($b2d204ad2c8a6909$var$ed.description, "]") : ""), Object.defineProperty($b2d204ad2c8a6909$var$eu, "name", {
    configurable: !0,
    value: $b2d204ad2c8a6909$var$ef ? "".concat($b2d204ad2c8a6909$var$ef, " ", $b2d204ad2c8a6909$var$ed) : $b2d204ad2c8a6909$var$ed
}), $b2d204ad2c8a6909$var$ev = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== ($b2d204ad2c8a6909$var$ep = $b2d204ad2c8a6909$var$eo[Symbol.metadata]) && void 0 !== $b2d204ad2c8a6909$var$ep ? $b2d204ad2c8a6909$var$ep : null) : void 0, $b2d204ad2c8a6909$var$er = [
    $kAoxL.observable
], $b2d204ad2c8a6909$var$en = [
    $kAoxL.observable
], $b2d204ad2c8a6909$var$tZ($b2d204ad2c8a6909$var$et, null, $b2d204ad2c8a6909$var$er, {
    kind: "accessor",
    name: "loading",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "loading" in e;
        },
        get: function(e) {
            return e.loading;
        },
        set: function(e, t) {
            e.loading = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$ev
}, $b2d204ad2c8a6909$var$el, $b2d204ad2c8a6909$var$ec), $b2d204ad2c8a6909$var$tZ($b2d204ad2c8a6909$var$et, null, $b2d204ad2c8a6909$var$en, {
    kind: "accessor",
    name: "imageURI",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "imageURI" in e;
        },
        get: function(e) {
            return e.imageURI;
        },
        set: function(e, t) {
            e.imageURI = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$ev
}, $b2d204ad2c8a6909$var$es, $b2d204ad2c8a6909$var$ec), $b2d204ad2c8a6909$var$tZ(null, $b2d204ad2c8a6909$var$ee = {
    value: $b2d204ad2c8a6909$var$et
}, $b2d204ad2c8a6909$var$ea, {
    kind: "class",
    name: $b2d204ad2c8a6909$var$et.name,
    metadata: $b2d204ad2c8a6909$var$ev
}, null, $b2d204ad2c8a6909$var$ei), $b2d204ad2c8a6909$var$et = $b2d204ad2c8a6909$var$ee.value, $b2d204ad2c8a6909$var$ev && Object.defineProperty($b2d204ad2c8a6909$var$et, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $b2d204ad2c8a6909$var$ev
}), Object.defineProperty($b2d204ad2c8a6909$var$et, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "ShareBox"
}), $b2d204ad2c8a6909$var$tX($b2d204ad2c8a6909$var$et, $b2d204ad2c8a6909$var$ei), $b2d204ad2c8a6909$var$et), $b2d204ad2c8a6909$var$t3 = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$t3, "SpinnerButton", function() {
    return $b2d204ad2c8a6909$var$t7;
});
var $b2d204ad2c8a6909$var$t5 = function(e, t) {
    var r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)0 > t.indexOf(n[a]) && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
}, $b2d204ad2c8a6909$var$t7 = function(e) {
    var t = e.animation, r = e.loading, n = e.disabled, a = e.children, i = $b2d204ad2c8a6909$var$t5(e, [
        "animation",
        "loading",
        "disabled",
        "children"
    ]);
    return (0, $237889e76c767d38$exports.jsxs)($367fe3a5abb69f2e$export$2e2bcd8739ae039, Object.assign({}, i, {
        disabled: r || n,
        children: [
            r && (0, $237889e76c767d38$exports.jsxs)($237889e76c767d38$exports.Fragment, {
                children: [
                    (0, $237889e76c767d38$exports.jsx)($b77909a1b1b04ae6$export$2e2bcd8739ae039, {
                        as: "span",
                        className: a ? "me-2" : "",
                        size: "sm",
                        animation: t,
                        role: "status",
                        "aria-hidden": "true"
                    }),
                    !a && (0, $237889e76c767d38$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                ]
            }),
            a
        ]
    }));
};
$b2d204ad2c8a6909$var$t7.displayName = "SpinnerButton";
var $b2d204ad2c8a6909$var$t8 = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$t8, "TableSpinner", function() {
    return $b2d204ad2c8a6909$var$t6;
});
var $b2d204ad2c8a6909$var$t6 = function(e) {
    var t = e.colSpan;
    return (0, $237889e76c767d38$exports.jsx)("tr", {
        children: (0, $237889e76c767d38$exports.jsx)("td", {
            className: "text-center p-4",
            colSpan: t,
            children: (0, $237889e76c767d38$exports.jsx)($b77909a1b1b04ae6$export$2e2bcd8739ae039, {
                animation: "border",
                variant: "primary"
            })
        })
    });
};
$b2d204ad2c8a6909$var$t6.displayName = "TableSpinner";
var $b2d204ad2c8a6909$var$t9 = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$t9, "TimeDistance", function() {
    return $b2d204ad2c8a6909$var$rt;
});
var $b2d204ad2c8a6909$var$re = {
    ms: "millisecond(s)",
    s: "second(s)",
    m: "minute(s)",
    H: "hour(s)",
    D: "day(s)",
    W: "week(s)",
    M: "month(s)",
    Y: "year(s)"
}, $b2d204ad2c8a6909$var$rt = function(e) {
    var t = e.className, r = e.date, n = e.unitWords, a = void 0 === n ? $b2d204ad2c8a6909$var$re : n, i = e.beforeWord, o = e.afterWord;
    r = new Date(r);
    var c = (0, $a1a155eb9166d0df$export$506c8e8f8c8edda)(r), l = c.distance, s = c.unit;
    return (0, $237889e76c767d38$exports.jsxs)("time", {
        className: t,
        dateTime: r.toJSON(),
        title: r.toLocaleString(),
        children: [
            Math.abs(l),
            " ",
            a[s],
            l < 0 ? void 0 === i ? " before" : i : void 0 === o ? " after" : o
        ]
    });
};
$b2d204ad2c8a6909$var$rt.displayName = "TimeDistance";
var $b2d204ad2c8a6909$var$rr = {};
$b2d204ad2c8a6909$var$e$($b2d204ad2c8a6909$var$rr, "TypeEcho", function() {
    return $b2d204ad2c8a6909$var$rc;
});
var $b2d204ad2c8a6909$var$rn = function(e, t, r, n, a, i) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, l = n.kind, s = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f = !1, p = r.length - 1; p >= 0; p--){
        var v = {};
        for(var h in n)v[h] = "access" === h ? {} : n[h];
        for(var h in n.access)v.access[h] = n.access[h];
        v.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            i.push(o(e || null));
        };
        var m = (0, r[p])("accessor" === l ? {
            get: d.get,
            set: d.set
        } : d[s], v);
        if ("accessor" === l) {
            if (void 0 === m) continue;
            if (null === m || "object" != typeof m) throw TypeError("Object expected");
            (c = o(m.get)) && (d.get = c), (c = o(m.set)) && (d.set = c), (c = o(m.init)) && a.unshift(c);
        } else (c = o(m)) && ("field" === l ? a.unshift(c) : d[s] = c);
    }
    u && Object.defineProperty(u, n.name, d), f = !0;
}, $b2d204ad2c8a6909$var$ra = function(e, t, r) {
    for(var n = arguments.length > 2, a = 0; a < t.length; a++)r = n ? t[a].call(e, r) : t[a].call(e);
    return n ? r : void 0;
}, $b2d204ad2c8a6909$var$ri = function(e, t, r, n) {
    if ("a" === r && !n) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
}, $b2d204ad2c8a6909$var$ro = function(e, t, r, n, a) {
    if ("m" === n) throw TypeError("Private method is not writable");
    if ("a" === n && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, $b2d204ad2c8a6909$var$rc = ($b2d204ad2c8a6909$var$eb = [
    $2bb10cc242f0df2f$export$b6ae1bc530f4c149
], $b2d204ad2c8a6909$var$eg = [], $b2d204ad2c8a6909$var$ew = $4HBpa.PureComponent, $b2d204ad2c8a6909$var$ej = [], $b2d204ad2c8a6909$var$eO = [], $b2d204ad2c8a6909$var$ey = function(e) {
    (0, $cd0a83c7e6f027c0$export$71511d61b312f219)(r, e);
    var t = (0, $f44768c4e043f9d2$export$71511d61b312f219)(r);
    function r() {
        var e;
        return (0, $a3e0d6b297546463$export$71511d61b312f219)(this, r), e = t.call.apply(t, [
            this
        ].concat(Array.prototype.slice.call(arguments))), $b2d204ad2c8a6909$var$eh.set((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), ($b2d204ad2c8a6909$var$ra((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$ej), $b2d204ad2c8a6909$var$ra((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), $b2d204ad2c8a6909$var$eO, ""))), Object.defineProperty((0, $0fbfbb0e88863202$export$71511d61b312f219)(e), "init", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                return t && new IntersectionObserver(function(t, r) {
                    var n, a, i, o = (0, $88421859e416994d$export$71511d61b312f219)(t, 1)[0].isIntersecting;
                    return n = void 0, a = void 0, i = function() {
                        var e, t, n, a, i, c, l, s, u, d, f;
                        return (0, $bcfad0ea6174f23f$export$71511d61b312f219)(this, function(p) {
                            switch(p.label){
                                case 0:
                                    if (!o) return [
                                        2
                                    ];
                                    r.disconnect(), t = (e = this.props).text, a = void 0 === (n = e.intervals) ? 150 : n, i = !0, c = !1, l = void 0, p.label = 1;
                                case 1:
                                    p.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), s = t[Symbol.iterator](), p.label = 2;
                                case 2:
                                    if (i = (u = s.next()).done) return [
                                        3,
                                        5
                                    ];
                                    return d = u.value, [
                                        4,
                                        (0, $a1a155eb9166d0df$export$e772c8ff12451969)(a / 1e3)
                                    ];
                                case 3:
                                    p.sent(), this.echoed += d, p.label = 4;
                                case 4:
                                    return i = !0, [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return f = p.sent(), c = !0, l = f, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        i || null == s.return || s.return();
                                    } finally{
                                        if (c) throw l;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }, new (a || (a = Promise))(function(t, r) {
                        function o(e) {
                            try {
                                l(i.next(e));
                            } catch (e) {
                                r(e);
                            }
                        }
                        function c(e) {
                            try {
                                l(i.throw(e));
                            } catch (e) {
                                r(e);
                            }
                        }
                        function l(e) {
                            var r;
                            e.done ? t(e.value) : ((r = e.value) instanceof a ? r : new a(function(e) {
                                e(r);
                            })).then(o, c);
                        }
                        l((i = i.apply(e, n || [])).next());
                    });
                }).observe(t);
            }
        }), e;
    }
    return (0, $d828c11bd1c1c0bb$export$71511d61b312f219)(r, [
        {
            key: "echoed",
            get: function() {
                return $b2d204ad2c8a6909$var$ri(this, $b2d204ad2c8a6909$var$eh, "f");
            },
            set: function(e) {
                $b2d204ad2c8a6909$var$ro(this, $b2d204ad2c8a6909$var$eh, e, "f");
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.className, r = e.text, n = this.echoed;
                return (0, $237889e76c767d38$exports.jsx)("pre", {
                    className: $b2d204ad2c8a6909$var$e0($46a03b660b5bd4f2$exports)("text-wrap", t),
                    ref: this.init,
                    children: n + (n === r ? "" : "_")
                });
            }
        }
    ]), r;
}($b2d204ad2c8a6909$var$ew), $b2d204ad2c8a6909$var$eh = new WeakMap, $b2d204ad2c8a6909$var$ex = $b2d204ad2c8a6909$var$ey, $b2d204ad2c8a6909$var$e_ = "TypeEcho", "symbol" === (0, $0d42f84d7422b820$export$71511d61b312f219)($b2d204ad2c8a6909$var$e_) && ($b2d204ad2c8a6909$var$e_ = $b2d204ad2c8a6909$var$e_.description ? "[".concat($b2d204ad2c8a6909$var$e_.description, "]") : ""), Object.defineProperty($b2d204ad2c8a6909$var$ex, "name", {
    configurable: !0,
    value: $b2d204ad2c8a6909$var$eP ? "".concat($b2d204ad2c8a6909$var$eP, " ", $b2d204ad2c8a6909$var$e_) : $b2d204ad2c8a6909$var$e_
}), $b2d204ad2c8a6909$var$eT = "function" == typeof Symbol && Symbol.metadata ? Object.create(null !== ($b2d204ad2c8a6909$var$ek = $b2d204ad2c8a6909$var$ew[Symbol.metadata]) && void 0 !== $b2d204ad2c8a6909$var$ek ? $b2d204ad2c8a6909$var$ek : null) : void 0, $b2d204ad2c8a6909$var$rn($b2d204ad2c8a6909$var$ey, null, [
    $kAoxL.observable
], {
    kind: "accessor",
    name: "echoed",
    static: !1,
    private: !1,
    access: {
        has: function(e) {
            return "echoed" in e;
        },
        get: function(e) {
            return e.echoed;
        },
        set: function(e, t) {
            e.echoed = t;
        }
    },
    metadata: $b2d204ad2c8a6909$var$eT
}, $b2d204ad2c8a6909$var$eO, $b2d204ad2c8a6909$var$ej), $b2d204ad2c8a6909$var$rn(null, $b2d204ad2c8a6909$var$em = {
    value: $b2d204ad2c8a6909$var$ey
}, $b2d204ad2c8a6909$var$eb, {
    kind: "class",
    name: $b2d204ad2c8a6909$var$ey.name,
    metadata: $b2d204ad2c8a6909$var$eT
}, null, $b2d204ad2c8a6909$var$eg), $b2d204ad2c8a6909$var$ey = $b2d204ad2c8a6909$var$em.value, $b2d204ad2c8a6909$var$eT && Object.defineProperty($b2d204ad2c8a6909$var$ey, Symbol.metadata, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $b2d204ad2c8a6909$var$eT
}), Object.defineProperty($b2d204ad2c8a6909$var$ey, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "TypeEcho"
}), $b2d204ad2c8a6909$var$ra($b2d204ad2c8a6909$var$ey, $b2d204ad2c8a6909$var$eg), $b2d204ad2c8a6909$var$ey);
$b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$e1), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$e4), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$e7), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$e9), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tt), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$ta), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tu), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tb), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tj), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$t_), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tk), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tY), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tT), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tz), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tH), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$tQ), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$t3), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$t8), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$t9), $b2d204ad2c8a6909$var$eZ($b2d204ad2c8a6909$exports, $b2d204ad2c8a6909$var$rr);


const $9a1d813924b63f50$export$8cacaad232db56d2 = [
    {
        icon: "twitter-x",
        link: "https://x.com/thezkcross"
    },
    {
        icon: "discord",
        link: "https://discord.com/invite/aJNjfRvgam"
    },
    {
        icon: "telegram",
        link: "https://t.me/ZKCross"
    },
    {
        icon: "medium",
        link: "https://blog.zkcross.org/"
    }
];
const $9a1d813924b63f50$export$a06f1c675e846f6f = ()=>(0, $237889e76c767d38$exports.jsxs)("footer", {
        className: "border-top border-white d-flex align-items-center justify-content-between bg-black-a p-5 flex-column flex-md-row",
        children: [
            (0, $237889e76c767d38$exports.jsxs)("nav", {
                className: "d-flex gap-3 font-poppins align-items-center",
                children: [
                    (0, $237889e76c767d38$exports.jsx)("span", {
                        className: "text-white fs-28 text-capitalize",
                        children: "zkVRF"
                    }),
                    $9a1d813924b63f50$export$8cacaad232db56d2.map(({ icon: icon, link: link })=>(0, $237889e76c767d38$exports.jsx)("a", {
                            className: "text-white fs-18",
                            target: "_blank",
                            href: link,
                            children: (0, $237889e76c767d38$exports.jsx)((0, $b2d204ad2c8a6909$exports.Icon), {
                                name: icon
                            })
                        }, link))
                ]
            }),
            (0, $237889e76c767d38$exports.jsx)("div", {
                className: "font-space text-white",
                children: "Copyright \xa9 2024 ZKVRF | All Rights Reserved by ZKCross |"
            })
        ]
    });






var $4HBpa = parcelRequire("4HBpa");




var $4HBpa = parcelRequire("4HBpa");


"use client";
const $9e3843193ed3d292$var$NavbarBrand = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "navbar-brand");
    const Component = as || (props.href ? "a" : "span");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix)
    });
});
$9e3843193ed3d292$var$NavbarBrand.displayName = "NavbarBrand";
var $9e3843193ed3d292$export$2e2bcd8739ae039 = $9e3843193ed3d292$var$NavbarBrand;



var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $0f6721d485770ab5$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $0f6721d485770ab5$export$2e2bcd8739ae039 = $0f6721d485770ab5$var$createChainedFunction;





const $64a7e2b7c52f2501$var$MARGINS = {
    height: [
        "marginTop",
        "marginBottom"
    ],
    width: [
        "marginLeft",
        "marginRight"
    ]
};
function $64a7e2b7c52f2501$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $64a7e2b7c52f2501$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $64a7e2b7c52f2501$var$collapseStyles = {
    [(0, $c10e4d22a343ddd7$export$84cbff306f539230)]: "collapse",
    [(0, $c10e4d22a343ddd7$export$4aacc83d4d59139f)]: "collapsing",
    [(0, $c10e4d22a343ddd7$export$df38205c966be359)]: "collapsing",
    [(0, $c10e4d22a343ddd7$export$78e9e6e3e014d60a)]: "collapse show"
};
const $64a7e2b7c52f2501$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = "height", in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $64a7e2b7c52f2501$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === "function" ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $4HBpa.useMemo)(()=>(0, $0f6721d485770ab5$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = "0";
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $4HBpa.useMemo)(()=>(0, $0f6721d485770ab5$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $4HBpa.useMemo)(()=>(0, $0f6721d485770ab5$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $4HBpa.useMemo)(()=>(0, $0f6721d485770ab5$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $3c7e9d19e739df43$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $4HBpa.useMemo)(()=>(0, $0f6721d485770ab5$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $377540a345e50bbb$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $b6f5876741e6a320$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4HBpa))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, children.props.className, $64a7e2b7c52f2501$var$collapseStyles[state], computedDimension === "width" && "collapse-horizontal")
            })
    });
});
var // @ts-ignore
$64a7e2b7c52f2501$export$2e2bcd8739ae039 = $64a7e2b7c52f2501$var$Collapse;





"use client";
const $b774dcd20c2dfa4f$var$NavbarCollapse = /*#__PURE__*/ $4HBpa.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "navbar-collapse");
    const context = (0, $4HBpa.useContext)((0, $dd9b233515888708$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $64a7e2b7c52f2501$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$b774dcd20c2dfa4f$var$NavbarCollapse.displayName = "NavbarCollapse";
var $b774dcd20c2dfa4f$export$2e2bcd8739ae039 = $b774dcd20c2dfa4f$var$NavbarCollapse;




var $4HBpa = parcelRequire("4HBpa");




"use client";
const $3577a1f22fb240e4$var$NavbarToggle = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = "Toggle navigation", // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "button", onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "navbar-toggler");
    const { onToggle: onToggle, expanded: expanded } = (0, $4HBpa.useContext)((0, $dd9b233515888708$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === "button") props.type = "button";
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, !expanded && "collapsed"),
        children: children || /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$3577a1f22fb240e4$var$NavbarToggle.displayName = "NavbarToggle";
var $3577a1f22fb240e4$export$2e2bcd8739ae039 = $3577a1f22fb240e4$var$NavbarToggle;



var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");
const $ed75d9b7245d7b39$var$matchersByWindow = new WeakMap();
const $ed75d9b7245d7b39$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $ed75d9b7245d7b39$var$matchersByWindow.get(targetWindow) || new Map();
    $ed75d9b7245d7b39$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $ed75d9b7245d7b39$export$2e2bcd8739ae039(query, targetWindow = typeof window === "undefined" ? undefined : window) {
    const mql = $ed75d9b7245d7b39$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $4HBpa.useState)(()=>mql ? mql.matches : false);
    (0, $edeb438989f381d0$export$2e2bcd8739ae039)(()=>{
        let mql = $ed75d9b7245d7b39$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $ed75d9b7245d7b39$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $4HBpa = parcelRequire("4HBpa");
function $9192735bd6b2045f$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === "number") value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === "number") value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === "object") {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $4HBpa.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === "up" || direction === true) query = and(query, getMinQuery(key));
                if (direction === "down" || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ""), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $ed75d9b7245d7b39$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $9192735bd6b2045f$var$useBreakpoint = $9192735bd6b2045f$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $9192735bd6b2045f$export$2e2bcd8739ae039 = $9192735bd6b2045f$var$useBreakpoint;




var $4HBpa = parcelRequire("4HBpa");

function $6efacf96f2f861d9$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $4HBpa = parcelRequire("4HBpa");







/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $6e46be37d1a82db3$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $c2a67f457f345873$export$1a88c12b8b979fa0 = (0, $89243f679e71db97$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $c2a67f457f345873$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $6e46be37d1a82db3$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($c2a67f457f345873$export$1a88c12b8b979fa0, "");
        (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($c2a67f457f345873$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $c2a67f457f345873$export$2e2bcd8739ae039 = $c2a67f457f345873$var$ModalManager;







const $a3786b3f5609742b$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $a3786b3f5609742b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $a3786b3f5609742b$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $a3786b3f5609742b$var$getManager(window) {
    if (!$a3786b3f5609742b$var$manager) $a3786b3f5609742b$var$manager = new (0, $c2a67f457f345873$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $a3786b3f5609742b$var$manager;
}
function $a3786b3f5609742b$var$useModalManager(provided) {
    const window = (0, $30cae4eefb1ace18$export$2e2bcd8739ae039)();
    const modalManager = provided || $a3786b3f5609742b$var$getManager(window);
    const modal = (0, $4HBpa.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $4HBpa.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $4HBpa.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $a3786b3f5609742b$var$Modal = /*#__PURE__*/ (0, $4HBpa.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $a3786b3f5609742b$var$_objectWithoutPropertiesLoose(_ref, $a3786b3f5609742b$var$_excluded);
    const ownerWindow = (0, $30cae4eefb1ace18$export$2e2bcd8739ae039)();
    const container = (0, $425d5774df596b6d$export$2e2bcd8739ae039)(containerRef);
    const modal = $a3786b3f5609742b$var$useModalManager(providedManager);
    const isMounted = (0, $bea9a4f5d8420224$export$2e2bcd8739ae039)();
    const prevShow = (0, $f0da90f5f4f7563a$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $4HBpa.useState)(!show);
    const lastFocusRef = (0, $4HBpa.useRef)(null);
    (0, $4HBpa.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $53e6d5b016eb161e$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $4HBpa.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $4HBpa.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $e4da7e2c6df0e7a9$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $2cd124cfc4a4b479$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $4HBpa.useRef)();
    const removeKeydownListenerRef = (0, $4HBpa.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $4HBpa.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $070d5ca02dcd24fa$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $070d5ca02dcd24fa$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $237889e76c767d38$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($384457d72cc1e1d1$exports))).createPortal(/*#__PURE__*/ (0, $237889e76c767d38$exports.jsxs)((0, $237889e76c767d38$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$a3786b3f5609742b$var$Modal.displayName = "Modal";
var $a3786b3f5609742b$export$2e2bcd8739ae039 = Object.assign($a3786b3f5609742b$var$Modal, {
    Manager: (0, $c2a67f457f345873$export$2e2bcd8739ae039)
});




var $4HBpa = parcelRequire("4HBpa");



"use client";
const $864427091defeb7a$var$OffcanvasBody = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "offcanvas-body");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$864427091defeb7a$var$OffcanvasBody.displayName = "OffcanvasBody";
var $864427091defeb7a$export$2e2bcd8739ae039 = $864427091defeb7a$var$OffcanvasBody;




var $4HBpa = parcelRequire("4HBpa");





"use client";
const $3930f025445f44c4$var$transitionStyles = {
    [(0, $c10e4d22a343ddd7$export$df38205c966be359)]: "show",
    [(0, $c10e4d22a343ddd7$export$78e9e6e3e014d60a)]: "show"
};
const $3930f025445f44c4$var$OffcanvasToggling = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $377540a345e50bbb$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $b6f5876741e6a320$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $4HBpa.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, children.props.className, (status === (0, $c10e4d22a343ddd7$export$df38205c966be359) || status === (0, $c10e4d22a343ddd7$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $3930f025445f44c4$var$transitionStyles[status])
            })
    });
});
$3930f025445f44c4$var$OffcanvasToggling.displayName = "OffcanvasToggling";
var $3930f025445f44c4$export$2e2bcd8739ae039 = $3930f025445f44c4$var$OffcanvasToggling;



var $4HBpa = parcelRequire("4HBpa");
"use client";
const $7d2ccf7b47ff0fe3$var$ModalContext = /*#__PURE__*/ $4HBpa.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $7d2ccf7b47ff0fe3$export$2e2bcd8739ae039 = $7d2ccf7b47ff0fe3$var$ModalContext;





var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");



var $4HBpa = parcelRequire("4HBpa");


const $ae1082fbb0468689$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).oneOf([
        "white"
    ])
};
const $ae1082fbb0468689$var$CloseButton = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$ae1082fbb0468689$var$CloseButton.displayName = "CloseButton";
$ae1082fbb0468689$var$CloseButton.propTypes = $ae1082fbb0468689$var$propTypes;
var $ae1082fbb0468689$export$2e2bcd8739ae039 = $ae1082fbb0468689$var$CloseButton;




"use client";
const $485062d61da6db7f$var$AbstractModalHeader = /*#__PURE__*/ $4HBpa.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $4HBpa.useContext)((0, $7d2ccf7b47ff0fe3$export$2e2bcd8739ae039));
    const handleClick = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $ae1082fbb0468689$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $485062d61da6db7f$export$2e2bcd8739ae039 = $485062d61da6db7f$var$AbstractModalHeader;



"use client";
const $8668d29b3bd4418d$var$OffcanvasHeader = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "offcanvas-header");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $485062d61da6db7f$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$8668d29b3bd4418d$var$OffcanvasHeader.displayName = "OffcanvasHeader";
var $8668d29b3bd4418d$export$2e2bcd8739ae039 = $8668d29b3bd4418d$var$OffcanvasHeader;



var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");


var $18d3f1485c77f7e3$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $4HBpa.forwardRef((p, ref)=>/*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(p.className, className)
        }));




"use client";
const $c23cd963abacf56f$var$DivStyledAsH5 = (0, $18d3f1485c77f7e3$export$2e2bcd8739ae039)("h5");
const $c23cd963abacf56f$var$OffcanvasTitle = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $c23cd963abacf56f$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "offcanvas-title");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$c23cd963abacf56f$var$OffcanvasTitle.displayName = "OffcanvasTitle";
var $c23cd963abacf56f$export$2e2bcd8739ae039 = $c23cd963abacf56f$var$OffcanvasTitle;




function $abf72811607b651f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $720e403436e1555a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}




function $37a47d2269fc3066$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $37a47d2269fc3066$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $37a47d2269fc3066$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $37a47d2269fc3066$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $fe1cc3839cbe60a2$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $fe1cc3839cbe60a2$var$BootstrapModalManager extends (0, $c2a67f457f345873$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $abf72811607b651f$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $fe1cc3839cbe60a2$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $fe1cc3839cbe60a2$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $fe1cc3839cbe60a2$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $37a47d2269fc3066$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $fe1cc3839cbe60a2$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $fe1cc3839cbe60a2$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $fe1cc3839cbe60a2$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $fe1cc3839cbe60a2$var$sharedManager;
function $fe1cc3839cbe60a2$export$a03641438014b436(options) {
    if (!$fe1cc3839cbe60a2$var$sharedManager) $fe1cc3839cbe60a2$var$sharedManager = new $fe1cc3839cbe60a2$var$BootstrapModalManager(options);
    return $fe1cc3839cbe60a2$var$sharedManager;
}
var $fe1cc3839cbe60a2$export$2e2bcd8739ae039 = $fe1cc3839cbe60a2$var$BootstrapModalManager;



"use client";
function $02f36f6c60ea52b9$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $3930f025445f44c4$export$2e2bcd8739ae039), {
        ...props
    });
}
function $02f36f6c60ea52b9$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $66f8963d44df9ceb$export$2e2bcd8739ae039), {
        ...props
    });
}
const $02f36f6c60ea52b9$var$Offcanvas = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, "aria-labelledby": ariaLabelledby, placement: placement = "start", responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $4HBpa.useRef)();
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    const { onToggle: onToggle } = (0, $4HBpa.useContext)((0, $dd9b233515888708$export$2e2bcd8739ae039)) || {};
    const [showOffcanvas, setShowOffcanvas] = (0, $4HBpa.useState)(false);
    const hideResponsiveOffcanvas = (0, $9192735bd6b2045f$export$2e2bcd8739ae039)(responsive || "xs", "up");
    (0, $4HBpa.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const handleHide = (0, $d99c632f2d60c58b$export$2e2bcd8739ae039)(()=>{
        onToggle == null || onToggle();
        onHide == null || onHide();
    });
    const modalContext = (0, $4HBpa.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $fe1cc3839cbe60a2$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $fe1cc3839cbe60a2$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = "visible";
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = "";
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $4HBpa.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsxs)((0, $237889e76c767d38$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $7d2ccf7b47ff0fe3$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $a3786b3f5609742b$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $02f36f6c60ea52b9$var$DialogTransition,
                    backdropTransition: $02f36f6c60ea52b9$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$02f36f6c60ea52b9$var$Offcanvas.displayName = "Offcanvas";
var $02f36f6c60ea52b9$export$2e2bcd8739ae039 = Object.assign($02f36f6c60ea52b9$var$Offcanvas, {
    Body: (0, $864427091defeb7a$export$2e2bcd8739ae039),
    Header: (0, $8668d29b3bd4418d$export$2e2bcd8739ae039),
    Title: (0, $c23cd963abacf56f$export$2e2bcd8739ae039)
});




"use client";
const $6da3346fe81c8c1b$var$NavbarOffcanvas = /*#__PURE__*/ $4HBpa.forwardRef((props, ref)=>{
    const context = (0, $4HBpa.useContext)((0, $dd9b233515888708$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $02f36f6c60ea52b9$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true
    });
});
$6da3346fe81c8c1b$var$NavbarOffcanvas.displayName = "NavbarOffcanvas";
var $6da3346fe81c8c1b$export$2e2bcd8739ae039 = $6da3346fe81c8c1b$var$NavbarOffcanvas;





var $4HBpa = parcelRequire("4HBpa");



"use client";
const $063cd779095a8db3$var$NavbarText = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "navbar-text");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$063cd779095a8db3$var$NavbarText.displayName = "NavbarText";
var $063cd779095a8db3$export$2e2bcd8739ae039 = $063cd779095a8db3$var$NavbarText;



"use client";
const $b499189a9863b4dc$var$Navbar = /*#__PURE__*/ $4HBpa.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = "light", bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "nav", expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $e5768bdb302594a0$export$2e2bcd8739ae039)(props, {
        expanded: "onToggle"
    });
    const bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(initialBsPrefix, "navbar");
    const handleCollapse = (0, $4HBpa.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== "nav") controlledProps.role = "navigation";
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === "string") expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $4HBpa.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $dd9b233515888708$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $010ad8e954db9444$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$b499189a9863b4dc$var$Navbar.displayName = "Navbar";
var $b499189a9863b4dc$export$2e2bcd8739ae039 = Object.assign($b499189a9863b4dc$var$Navbar, {
    Brand: (0, $9e3843193ed3d292$export$2e2bcd8739ae039),
    Collapse: (0, $b774dcd20c2dfa4f$export$2e2bcd8739ae039),
    Offcanvas: (0, $6da3346fe81c8c1b$export$2e2bcd8739ae039),
    Text: (0, $063cd779095a8db3$export$2e2bcd8739ae039),
    Toggle: (0, $3577a1f22fb240e4$export$2e2bcd8739ae039)
});



var $4HBpa = parcelRequire("4HBpa");

/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $eb367fe6660fdc84$export$83d89fbfd8236492 = "6.13.2";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $2323980ce672c824$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $2323980ce672c824$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $2323980ce672c824$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $2323980ce672c824$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $205dffdfdb79d607$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($205dffdfdb79d607$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $205dffdfdb79d607$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$205dffdfdb79d607$var$stringify(k)}: ${$205dffdfdb79d607$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $205dffdfdb79d607$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $205dffdfdb79d607$export$748c4fa78f31ff35(error) {
    return $205dffdfdb79d607$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $205dffdfdb79d607$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$205dffdfdb79d607$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $205dffdfdb79d607$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $eb367fe6660fdc84$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $2323980ce672c824$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $2323980ce672c824$export$b61bda4fbca264f2)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $205dffdfdb79d607$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $205dffdfdb79d607$export$5a4bb2b1c89bdce7(message, code, info);
}
function $205dffdfdb79d607$export$c3d31707e5030f5e(check, message, name, value) {
    $205dffdfdb79d607$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $205dffdfdb79d607$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $205dffdfdb79d607$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $205dffdfdb79d607$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $205dffdfdb79d607$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $205dffdfdb79d607$export$d993e67fefdfecda(form) {
    $205dffdfdb79d607$export$a7a9523472993e97($205dffdfdb79d607$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $205dffdfdb79d607$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $205dffdfdb79d607$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}


/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $85f03119331e3531$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $85f03119331e3531$export$a3521add2594f3c8(value, name) {
    return $85f03119331e3531$var$_getBytes(value, name, false);
}
function $85f03119331e3531$export$37110e7fee0af4ad(value, name) {
    return $85f03119331e3531$var$_getBytes(value, name, true);
}
function $85f03119331e3531$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $85f03119331e3531$export$9a14abb1a440cd5e(value) {
    return $85f03119331e3531$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $85f03119331e3531$var$HexCharacters = "0123456789abcdef";
function $85f03119331e3531$export$2b0d6b5fbe698c70(data) {
    const bytes = $85f03119331e3531$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $85f03119331e3531$var$HexCharacters[(v & 0xf0) >> 4] + $85f03119331e3531$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $85f03119331e3531$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$85f03119331e3531$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $85f03119331e3531$export$2321cd91b99770ff(data) {
    if ($85f03119331e3531$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $85f03119331e3531$export$a3521add2594f3c8(data).length;
}
function $85f03119331e3531$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $85f03119331e3531$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $85f03119331e3531$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $85f03119331e3531$export$9c854001a22ebaa2(data) {
    let bytes = $85f03119331e3531$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $85f03119331e3531$var$zeroPad(data, length, left) {
    const bytes = $85f03119331e3531$export$a3521add2594f3c8(data);
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $85f03119331e3531$export$2b0d6b5fbe698c70(result);
}
function $85f03119331e3531$export$4473860254365feb(data, length) {
    return $85f03119331e3531$var$zeroPad(data, length, true);
}
function $85f03119331e3531$export$1dc7fbe1b8738fe7(data, length) {
    return $85f03119331e3531$var$zeroPad(data, length, false);
}


/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 

const $7769476213c187e3$var$BN_0 = BigInt(0);
const $7769476213c187e3$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $7769476213c187e3$var$maxValue = 0x1fffffffffffff;
function $7769476213c187e3$export$92182edcfa20e5bc(_value, _width) {
    const value = $7769476213c187e3$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($7769476213c187e3$export$b14f2714108df84(_width, "width"));
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(value >> width === $7769476213c187e3$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $7769476213c187e3$var$BN_1) {
        const mask = ($7769476213c187e3$var$BN_1 << width) - $7769476213c187e3$var$BN_1;
        return -((~value & mask) + $7769476213c187e3$var$BN_1);
    }
    return value;
}
function $7769476213c187e3$export$7101cd4e6275351c(_value, _width) {
    let value = $7769476213c187e3$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($7769476213c187e3$export$b14f2714108df84(_width, "width"));
    const limit = $7769476213c187e3$var$BN_1 << width - $7769476213c187e3$var$BN_1;
    if (value < $7769476213c187e3$var$BN_0) {
        value = -value;
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($7769476213c187e3$var$BN_1 << width) - $7769476213c187e3$var$BN_1;
        return (~value & mask) + $7769476213c187e3$var$BN_1;
    } else (0, $205dffdfdb79d607$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $7769476213c187e3$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $7769476213c187e3$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($7769476213c187e3$export$b14f2714108df84(_bits, "bits"));
    return value & ($7769476213c187e3$var$BN_1 << bits) - $7769476213c187e3$var$BN_1;
}
function $7769476213c187e3$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value >= -$7769476213c187e3$var$maxValue && value <= $7769476213c187e3$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $7769476213c187e3$export$8677d6ca9282a154(value, name) {
    const result = $7769476213c187e3$export$61fe455e2b1e28a4(value, name);
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(result >= $7769476213c187e3$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $7769476213c187e3$var$Nibbles = "0123456789abcdef";
function $7769476213c187e3$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $7769476213c187e3$var$Nibbles[v >> 4];
            result += $7769476213c187e3$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $7769476213c187e3$export$61fe455e2b1e28a4(value);
}
function $7769476213c187e3$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value >= -$7769476213c187e3$var$maxValue && value <= $7769476213c187e3$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value >= -$7769476213c187e3$var$maxValue && value <= $7769476213c187e3$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $7769476213c187e3$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $7769476213c187e3$export$a0a81dc3380ce7d3(value) {
    return $7769476213c187e3$export$b14f2714108df84($7769476213c187e3$export$c221a145703ab783(value));
}
function $7769476213c187e3$export$c6ebe05badb16181(_value, _width) {
    const value = $7769476213c187e3$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $7769476213c187e3$export$b14f2714108df84(_width, "width");
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $7769476213c187e3$export$b627fcfb5ea68cb0(_value) {
    const value = $7769476213c187e3$export$8677d6ca9282a154(_value, "value");
    if (value === $7769476213c187e3$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $7769476213c187e3$export$d9c067986dbc68dd(value) {
    let result = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)((0, $85f03119331e3531$export$9a14abb1a440cd5e)(value) ? value : $7769476213c187e3$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}


const $43101f4b6dfefe01$export$b4b1d1fba463e69c = 32;
const $43101f4b6dfefe01$var$Padding = new Uint8Array($43101f4b6dfefe01$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $43101f4b6dfefe01$var$passProperties = [
    "then"
];
const $43101f4b6dfefe01$var$_guard = {};
const $43101f4b6dfefe01$var$resultNames = new WeakMap();
function $43101f4b6dfefe01$var$getNames(result) {
    return $43101f4b6dfefe01$var$resultNames.get(result);
}
function $43101f4b6dfefe01$var$setNames(result, names) {
    $43101f4b6dfefe01$var$resultNames.set(result, names);
}
function $43101f4b6dfefe01$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
function $43101f4b6dfefe01$var$toObject(names, items, deep) {
    if (names.indexOf(null) >= 0) return items.map((item, index)=>{
        if (item instanceof $43101f4b6dfefe01$export$8fdcabde73f49165) return $43101f4b6dfefe01$var$toObject($43101f4b6dfefe01$var$getNames(item), item, deep);
        return item;
    });
    return names.reduce((accum, name, index)=>{
        let item = items.getValue(name);
        if (!(name in accum)) {
            if (deep && item instanceof $43101f4b6dfefe01$export$8fdcabde73f49165) item = $43101f4b6dfefe01$var$toObject($43101f4b6dfefe01$var$getNames(item), item, deep);
            accum[name] = item;
        }
        return accum;
    }, {});
}
class $43101f4b6dfefe01$export$8fdcabde73f49165 extends Array {
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $43101f4b6dfefe01$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        $43101f4b6dfefe01$var$setNames(this, Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        })));
        // Dummy operations to prevent TypeScript from complaining
        this.#names = [];
        if (this.#names == null) this.#names;
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        const proxy = new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $7769476213c187e3$export$b14f2714108df84)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $43101f4b6dfefe01$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($43101f4b6dfefe01$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
        $43101f4b6dfefe01$var$setNames(proxy, $43101f4b6dfefe01$var$getNames(this));
        return proxy;
    }
    /**
     *  Returns the Result as a normal Array. If %%deep%%, any children
     *  which are Result objects are also converted to a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray(deep) {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $43101f4b6dfefe01$var$throwError(`index ${index}`, item);
            if (deep && item instanceof $43101f4b6dfefe01$export$8fdcabde73f49165) item = item.toArray(deep);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair. If
     *  %%deep%%, any children which are Result objects are also
     *  converted to an Object.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject(deep) {
        const names = $43101f4b6dfefe01$var$getNames(this);
        return names.reduce((accum, name, index)=>{
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            return $43101f4b6dfefe01$var$toObject(names, this, deep);
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const _names = $43101f4b6dfefe01$var$getNames(this);
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(_names[i]);
        }
        return new $43101f4b6dfefe01$export$8fdcabde73f49165($43101f4b6dfefe01$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const _names = $43101f4b6dfefe01$var$getNames(this);
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $43101f4b6dfefe01$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(_names[i]);
            }
        }
        return new $43101f4b6dfefe01$export$8fdcabde73f49165($43101f4b6dfefe01$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $43101f4b6dfefe01$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = $43101f4b6dfefe01$var$getNames(this).indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $43101f4b6dfefe01$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $43101f4b6dfefe01$export$8fdcabde73f49165($43101f4b6dfefe01$var$_guard, items, keys);
    }
}
function $43101f4b6dfefe01$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $43101f4b6dfefe01$var$getValue(value) {
    let bytes = (0, $7769476213c187e3$export$b627fcfb5ea68cb0)(value);
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(bytes.length <= $43101f4b6dfefe01$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $43101f4b6dfefe01$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $43101f4b6dfefe01$export$b4b1d1fba463e69c) bytes = (0, $85f03119331e3531$export$37110e7fee0af4ad)((0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        $43101f4b6dfefe01$var$Padding.slice(bytes.length % $43101f4b6dfefe01$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $43101f4b6dfefe01$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, message, this.localName, value);
    }
}
class $43101f4b6dfefe01$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $85f03119331e3531$export$ee1b3e54f0441b22)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $85f03119331e3531$export$37110e7fee0af4ad)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $85f03119331e3531$export$37110e7fee0af4ad)(value);
        const paddingOffset = bytes.length % $43101f4b6dfefe01$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $85f03119331e3531$export$37110e7fee0af4ad)((0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            bytes,
            $43101f4b6dfefe01$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($43101f4b6dfefe01$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($43101f4b6dfefe01$var$Padding);
        this.#dataLength += $43101f4b6dfefe01$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $43101f4b6dfefe01$var$getValue(value);
        };
    }
}
class $43101f4b6dfefe01$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $85f03119331e3531$export$37110e7fee0af4ad)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $85f03119331e3531$export$37110e7fee0af4ad)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $43101f4b6dfefe01$export$b4b1d1fba463e69c) * $43101f4b6dfefe01$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $85f03119331e3531$export$37110e7fee0af4ad)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $43101f4b6dfefe01$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $7769476213c187e3$export$c221a145703ab783)(this.readBytes($43101f4b6dfefe01$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $7769476213c187e3$export$a0a81dc3380ce7d3)(this.readBytes($43101f4b6dfefe01$export$b4b1d1fba463e69c));
    }
}


/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ var $67a4b6528fd09ee4$exports = {};
"use strict";
Object.defineProperty($67a4b6528fd09ee4$exports, "__esModule", {
    value: true
});
$67a4b6528fd09ee4$exports.hmac = $67a4b6528fd09ee4$exports.HMAC = void 0;
var $8e5b0f1624444b7c$exports = {};
"use strict";
Object.defineProperty($8e5b0f1624444b7c$exports, "__esModule", {
    value: true
});
$8e5b0f1624444b7c$exports.output = $8e5b0f1624444b7c$exports.exists = $8e5b0f1624444b7c$exports.hash = $8e5b0f1624444b7c$exports.bytes = $8e5b0f1624444b7c$exports.bool = $8e5b0f1624444b7c$exports.number = void 0;
function $8e5b0f1624444b7c$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$8e5b0f1624444b7c$exports.number = $8e5b0f1624444b7c$var$number;
function $8e5b0f1624444b7c$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$8e5b0f1624444b7c$exports.bool = $8e5b0f1624444b7c$var$bool;
function $8e5b0f1624444b7c$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$8e5b0f1624444b7c$exports.bytes = $8e5b0f1624444b7c$var$bytes;
function $8e5b0f1624444b7c$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $8e5b0f1624444b7c$var$number(hash.outputLen);
    $8e5b0f1624444b7c$var$number(hash.blockLen);
}
$8e5b0f1624444b7c$exports.hash = $8e5b0f1624444b7c$var$hash;
function $8e5b0f1624444b7c$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$8e5b0f1624444b7c$exports.exists = $8e5b0f1624444b7c$var$exists;
function $8e5b0f1624444b7c$var$output(out, instance) {
    $8e5b0f1624444b7c$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$8e5b0f1624444b7c$exports.output = $8e5b0f1624444b7c$var$output;
const $8e5b0f1624444b7c$var$assert = {
    number: $8e5b0f1624444b7c$var$number,
    bool: $8e5b0f1624444b7c$var$bool,
    bytes: $8e5b0f1624444b7c$var$bytes,
    hash: $8e5b0f1624444b7c$var$hash,
    exists: $8e5b0f1624444b7c$var$exists,
    output: $8e5b0f1624444b7c$var$output
};
$8e5b0f1624444b7c$exports.default = $8e5b0f1624444b7c$var$assert;


var $a0bae7f9e6925ec9$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($a0bae7f9e6925ec9$exports, "__esModule", {
    value: true
});
$a0bae7f9e6925ec9$exports.randomBytes = $a0bae7f9e6925ec9$exports.wrapXOFConstructorWithOpts = $a0bae7f9e6925ec9$exports.wrapConstructorWithOpts = $a0bae7f9e6925ec9$exports.wrapConstructor = $a0bae7f9e6925ec9$exports.checkOpts = $a0bae7f9e6925ec9$exports.Hash = $a0bae7f9e6925ec9$exports.concatBytes = $a0bae7f9e6925ec9$exports.toBytes = $a0bae7f9e6925ec9$exports.utf8ToBytes = $a0bae7f9e6925ec9$exports.asyncLoop = $a0bae7f9e6925ec9$exports.nextTick = $a0bae7f9e6925ec9$exports.hexToBytes = $a0bae7f9e6925ec9$exports.bytesToHex = $a0bae7f9e6925ec9$exports.isLE = $a0bae7f9e6925ec9$exports.rotr = $a0bae7f9e6925ec9$exports.createView = $a0bae7f9e6925ec9$exports.u32 = $a0bae7f9e6925ec9$exports.u8 = void 0;
var $4e808ef9cae618b5$exports = {};
"use strict";
Object.defineProperty($4e808ef9cae618b5$exports, "__esModule", {
    value: true
});
$4e808ef9cae618b5$exports.crypto = void 0;
$4e808ef9cae618b5$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $a0bae7f9e6925ec9$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $a0bae7f9e6925ec9$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$a0bae7f9e6925ec9$exports.u8 = $a0bae7f9e6925ec9$var$u8;
const $a0bae7f9e6925ec9$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$a0bae7f9e6925ec9$exports.u32 = $a0bae7f9e6925ec9$var$u32;
// Cast array to view
const $a0bae7f9e6925ec9$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$a0bae7f9e6925ec9$exports.createView = $a0bae7f9e6925ec9$var$createView;
// The rotate right (circular right shift) operation for uint32
const $a0bae7f9e6925ec9$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$a0bae7f9e6925ec9$exports.rotr = $a0bae7f9e6925ec9$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$a0bae7f9e6925ec9$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$a0bae7f9e6925ec9$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $a0bae7f9e6925ec9$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a0bae7f9e6925ec9$var$bytesToHex(bytes) {
    if (!$a0bae7f9e6925ec9$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a0bae7f9e6925ec9$var$hexes[bytes[i]];
    return hex;
}
$a0bae7f9e6925ec9$exports.bytesToHex = $a0bae7f9e6925ec9$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a0bae7f9e6925ec9$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$a0bae7f9e6925ec9$exports.hexToBytes = $a0bae7f9e6925ec9$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $a0bae7f9e6925ec9$var$nextTick = async ()=>{};
$a0bae7f9e6925ec9$exports.nextTick = $a0bae7f9e6925ec9$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $a0bae7f9e6925ec9$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $a0bae7f9e6925ec9$exports.nextTick)();
        ts += diff;
    }
}
$a0bae7f9e6925ec9$exports.asyncLoop = $a0bae7f9e6925ec9$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a0bae7f9e6925ec9$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$a0bae7f9e6925ec9$exports.utf8ToBytes = $a0bae7f9e6925ec9$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $a0bae7f9e6925ec9$var$toBytes(data) {
    if (typeof data === "string") data = $a0bae7f9e6925ec9$var$utf8ToBytes(data);
    if (!$a0bae7f9e6925ec9$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
$a0bae7f9e6925ec9$exports.toBytes = $a0bae7f9e6925ec9$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a0bae7f9e6925ec9$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a0bae7f9e6925ec9$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$a0bae7f9e6925ec9$exports.concatBytes = $a0bae7f9e6925ec9$var$concatBytes;
// For runtime check if class implements interface
class $a0bae7f9e6925ec9$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$a0bae7f9e6925ec9$exports.Hash = $a0bae7f9e6925ec9$var$Hash;
const $a0bae7f9e6925ec9$var$toStr = {}.toString;
function $a0bae7f9e6925ec9$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $a0bae7f9e6925ec9$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$a0bae7f9e6925ec9$exports.checkOpts = $a0bae7f9e6925ec9$var$checkOpts;
function $a0bae7f9e6925ec9$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($a0bae7f9e6925ec9$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
$a0bae7f9e6925ec9$exports.wrapConstructor = $a0bae7f9e6925ec9$var$wrapConstructor;
function $a0bae7f9e6925ec9$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a0bae7f9e6925ec9$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$a0bae7f9e6925ec9$exports.wrapConstructorWithOpts = $a0bae7f9e6925ec9$var$wrapConstructorWithOpts;
function $a0bae7f9e6925ec9$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a0bae7f9e6925ec9$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$a0bae7f9e6925ec9$exports.wrapXOFConstructorWithOpts = $a0bae7f9e6925ec9$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $a0bae7f9e6925ec9$var$randomBytes(bytesLength = 32) {
    if ($4e808ef9cae618b5$exports.crypto && typeof $4e808ef9cae618b5$exports.crypto.getRandomValues === "function") return $4e808ef9cae618b5$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$a0bae7f9e6925ec9$exports.randomBytes = $a0bae7f9e6925ec9$var$randomBytes;


// HMAC (RFC 2104)
class $67a4b6528fd09ee4$var$HMAC extends $a0bae7f9e6925ec9$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $8e5b0f1624444b7c$exports.hash)(hash);
        const key = (0, $a0bae7f9e6925ec9$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $8e5b0f1624444b7c$exports.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $8e5b0f1624444b7c$exports.exists)(this);
        (0, $8e5b0f1624444b7c$exports.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$67a4b6528fd09ee4$exports.HMAC = $67a4b6528fd09ee4$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $67a4b6528fd09ee4$var$hmac = (hash, key, message)=>new $67a4b6528fd09ee4$var$HMAC(hash, key).update(message).digest();
$67a4b6528fd09ee4$exports.hmac = $67a4b6528fd09ee4$var$hmac;
$67a4b6528fd09ee4$exports.hmac.create = (hash, key)=>new $67a4b6528fd09ee4$var$HMAC(hash, key);


var $161fa9a2266e3e69$exports = {};
"use strict";
Object.defineProperty($161fa9a2266e3e69$exports, "__esModule", {
    value: true
});
$161fa9a2266e3e69$exports.pbkdf2Async = $161fa9a2266e3e69$exports.pbkdf2 = void 0;



// Common prologue and epilogue for sync/async functions
function $161fa9a2266e3e69$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $8e5b0f1624444b7c$exports.hash)(hash);
    const opts = (0, $a0bae7f9e6925ec9$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $8e5b0f1624444b7c$exports.number)(c);
    (0, $8e5b0f1624444b7c$exports.number)(dkLen);
    (0, $8e5b0f1624444b7c$exports.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $a0bae7f9e6925ec9$exports.toBytes)(_password);
    const salt = (0, $a0bae7f9e6925ec9$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $67a4b6528fd09ee4$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $161fa9a2266e3e69$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $161fa9a2266e3e69$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $161fa9a2266e3e69$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $a0bae7f9e6925ec9$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $161fa9a2266e3e69$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$161fa9a2266e3e69$exports.pbkdf2 = $161fa9a2266e3e69$var$pbkdf2;
async function $161fa9a2266e3e69$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $161fa9a2266e3e69$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $a0bae7f9e6925ec9$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $a0bae7f9e6925ec9$exports.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $161fa9a2266e3e69$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$161fa9a2266e3e69$exports.pbkdf2Async = $161fa9a2266e3e69$var$pbkdf2Async;


var $678d7a8026c4ddb5$exports = {};
"use strict";
Object.defineProperty($678d7a8026c4ddb5$exports, "__esModule", {
    value: true
});
$678d7a8026c4ddb5$exports.sha224 = $678d7a8026c4ddb5$exports.sha256 = void 0;
var $d31549e44a3a8dcc$exports = {};
"use strict";
Object.defineProperty($d31549e44a3a8dcc$exports, "__esModule", {
    value: true
});
$d31549e44a3a8dcc$exports.SHA2 = void 0;


// Polyfill for Safari 14
function $d31549e44a3a8dcc$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $d31549e44a3a8dcc$var$SHA2 extends $a0bae7f9e6925ec9$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $a0bae7f9e6925ec9$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $8e5b0f1624444b7c$exports.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $a0bae7f9e6925ec9$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $a0bae7f9e6925ec9$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $8e5b0f1624444b7c$exports.exists)(this);
        (0, $8e5b0f1624444b7c$exports.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $d31549e44a3a8dcc$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $a0bae7f9e6925ec9$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$d31549e44a3a8dcc$exports.SHA2 = $d31549e44a3a8dcc$var$SHA2;



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $678d7a8026c4ddb5$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $678d7a8026c4ddb5$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $678d7a8026c4ddb5$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $678d7a8026c4ddb5$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $678d7a8026c4ddb5$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $678d7a8026c4ddb5$var$SHA256 extends $d31549e44a3a8dcc$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $678d7a8026c4ddb5$var$IV[0] | 0;
        this.B = $678d7a8026c4ddb5$var$IV[1] | 0;
        this.C = $678d7a8026c4ddb5$var$IV[2] | 0;
        this.D = $678d7a8026c4ddb5$var$IV[3] | 0;
        this.E = $678d7a8026c4ddb5$var$IV[4] | 0;
        this.F = $678d7a8026c4ddb5$var$IV[5] | 0;
        this.G = $678d7a8026c4ddb5$var$IV[6] | 0;
        this.H = $678d7a8026c4ddb5$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$678d7a8026c4ddb5$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $678d7a8026c4ddb5$var$SHA256_W[i - 15];
            const W2 = $678d7a8026c4ddb5$var$SHA256_W[i - 2];
            const s0 = (0, $a0bae7f9e6925ec9$exports.rotr)(W15, 7) ^ (0, $a0bae7f9e6925ec9$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $a0bae7f9e6925ec9$exports.rotr)(W2, 17) ^ (0, $a0bae7f9e6925ec9$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $678d7a8026c4ddb5$var$SHA256_W[i] = s1 + $678d7a8026c4ddb5$var$SHA256_W[i - 7] + s0 + $678d7a8026c4ddb5$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $a0bae7f9e6925ec9$exports.rotr)(E, 6) ^ (0, $a0bae7f9e6925ec9$exports.rotr)(E, 11) ^ (0, $a0bae7f9e6925ec9$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $678d7a8026c4ddb5$var$Chi(E, F, G) + $678d7a8026c4ddb5$var$SHA256_K[i] + $678d7a8026c4ddb5$var$SHA256_W[i] | 0;
            const sigma0 = (0, $a0bae7f9e6925ec9$exports.rotr)(A, 2) ^ (0, $a0bae7f9e6925ec9$exports.rotr)(A, 13) ^ (0, $a0bae7f9e6925ec9$exports.rotr)(A, 22);
            const T2 = sigma0 + $678d7a8026c4ddb5$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $678d7a8026c4ddb5$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $678d7a8026c4ddb5$var$SHA224 extends $678d7a8026c4ddb5$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $678d7a8026c4ddb5$exports.sha256 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $678d7a8026c4ddb5$var$SHA256());
$678d7a8026c4ddb5$exports.sha224 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $678d7a8026c4ddb5$var$SHA224());


var $12d72d0a5d9eca1c$exports = {};
"use strict";
Object.defineProperty($12d72d0a5d9eca1c$exports, "__esModule", {
    value: true
});
$12d72d0a5d9eca1c$exports.sha384 = $12d72d0a5d9eca1c$exports.sha512_256 = $12d72d0a5d9eca1c$exports.sha512_224 = $12d72d0a5d9eca1c$exports.sha512 = $12d72d0a5d9eca1c$exports.SHA512 = void 0;

var $91069521f68f723f$exports = {};
"use strict";
Object.defineProperty($91069521f68f723f$exports, "__esModule", {
    value: true
});
$91069521f68f723f$exports.add5L = $91069521f68f723f$exports.add5H = $91069521f68f723f$exports.add4H = $91069521f68f723f$exports.add4L = $91069521f68f723f$exports.add3H = $91069521f68f723f$exports.add3L = $91069521f68f723f$exports.add = $91069521f68f723f$exports.rotlBL = $91069521f68f723f$exports.rotlBH = $91069521f68f723f$exports.rotlSL = $91069521f68f723f$exports.rotlSH = $91069521f68f723f$exports.rotr32L = $91069521f68f723f$exports.rotr32H = $91069521f68f723f$exports.rotrBL = $91069521f68f723f$exports.rotrBH = $91069521f68f723f$exports.rotrSL = $91069521f68f723f$exports.rotrSH = $91069521f68f723f$exports.shrSL = $91069521f68f723f$exports.shrSH = $91069521f68f723f$exports.toBig = $91069521f68f723f$exports.split = $91069521f68f723f$exports.fromBig = void 0;
const $91069521f68f723f$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $91069521f68f723f$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $91069521f68f723f$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $91069521f68f723f$var$U32_MASK64),
        l: Number(n >> $91069521f68f723f$var$_32n & $91069521f68f723f$var$U32_MASK64)
    };
    return {
        h: Number(n >> $91069521f68f723f$var$_32n & $91069521f68f723f$var$U32_MASK64) | 0,
        l: Number(n & $91069521f68f723f$var$U32_MASK64) | 0
    };
}
$91069521f68f723f$exports.fromBig = $91069521f68f723f$var$fromBig;
function $91069521f68f723f$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $91069521f68f723f$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
$91069521f68f723f$exports.split = $91069521f68f723f$var$split;
const $91069521f68f723f$var$toBig = (h, l)=>BigInt(h >>> 0) << $91069521f68f723f$var$_32n | BigInt(l >>> 0);
$91069521f68f723f$exports.toBig = $91069521f68f723f$var$toBig;
// for Shift in [0, 32)
const $91069521f68f723f$var$shrSH = (h, _l, s)=>h >>> s;
$91069521f68f723f$exports.shrSH = $91069521f68f723f$var$shrSH;
const $91069521f68f723f$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$91069521f68f723f$exports.shrSL = $91069521f68f723f$var$shrSL;
// Right rotate for Shift in [1, 32)
const $91069521f68f723f$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$91069521f68f723f$exports.rotrSH = $91069521f68f723f$var$rotrSH;
const $91069521f68f723f$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$91069521f68f723f$exports.rotrSL = $91069521f68f723f$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $91069521f68f723f$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$91069521f68f723f$exports.rotrBH = $91069521f68f723f$var$rotrBH;
const $91069521f68f723f$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$91069521f68f723f$exports.rotrBL = $91069521f68f723f$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $91069521f68f723f$var$rotr32H = (_h, l)=>l;
$91069521f68f723f$exports.rotr32H = $91069521f68f723f$var$rotr32H;
const $91069521f68f723f$var$rotr32L = (h, _l)=>h;
$91069521f68f723f$exports.rotr32L = $91069521f68f723f$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $91069521f68f723f$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$91069521f68f723f$exports.rotlSH = $91069521f68f723f$var$rotlSH;
const $91069521f68f723f$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$91069521f68f723f$exports.rotlSL = $91069521f68f723f$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $91069521f68f723f$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$91069521f68f723f$exports.rotlBH = $91069521f68f723f$var$rotlBH;
const $91069521f68f723f$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$91069521f68f723f$exports.rotlBL = $91069521f68f723f$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $91069521f68f723f$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
$91069521f68f723f$exports.add = $91069521f68f723f$var$add;
// Addition with more than 2 elements
const $91069521f68f723f$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$91069521f68f723f$exports.add3L = $91069521f68f723f$var$add3L;
const $91069521f68f723f$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$91069521f68f723f$exports.add3H = $91069521f68f723f$var$add3H;
const $91069521f68f723f$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$91069521f68f723f$exports.add4L = $91069521f68f723f$var$add4L;
const $91069521f68f723f$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$91069521f68f723f$exports.add4H = $91069521f68f723f$var$add4H;
const $91069521f68f723f$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$91069521f68f723f$exports.add5L = $91069521f68f723f$var$add5L;
const $91069521f68f723f$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$91069521f68f723f$exports.add5H = $91069521f68f723f$var$add5H;
// prettier-ignore
const $91069521f68f723f$var$u64 = {
    fromBig: $91069521f68f723f$var$fromBig,
    split: $91069521f68f723f$var$split,
    toBig: $91069521f68f723f$var$toBig,
    shrSH: $91069521f68f723f$var$shrSH,
    shrSL: $91069521f68f723f$var$shrSL,
    rotrSH: $91069521f68f723f$var$rotrSH,
    rotrSL: $91069521f68f723f$var$rotrSL,
    rotrBH: $91069521f68f723f$var$rotrBH,
    rotrBL: $91069521f68f723f$var$rotrBL,
    rotr32H: $91069521f68f723f$var$rotr32H,
    rotr32L: $91069521f68f723f$var$rotr32L,
    rotlSH: $91069521f68f723f$var$rotlSH,
    rotlSL: $91069521f68f723f$var$rotlSL,
    rotlBH: $91069521f68f723f$var$rotlBH,
    rotlBL: $91069521f68f723f$var$rotlBL,
    add: $91069521f68f723f$var$add,
    add3L: $91069521f68f723f$var$add3L,
    add3H: $91069521f68f723f$var$add3H,
    add4L: $91069521f68f723f$var$add4L,
    add4H: $91069521f68f723f$var$add4H,
    add5H: $91069521f68f723f$var$add5H,
    add5L: $91069521f68f723f$var$add5L
};
$91069521f68f723f$exports.default = $91069521f68f723f$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$12d72d0a5d9eca1c$var$SHA512_Kh, $12d72d0a5d9eca1c$var$SHA512_Kl] = /* @__PURE__ */ (()=>$91069521f68f723f$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $12d72d0a5d9eca1c$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $12d72d0a5d9eca1c$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $12d72d0a5d9eca1c$var$SHA512 extends $d31549e44a3a8dcc$exports.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $12d72d0a5d9eca1c$var$SHA512_W_H[i] = view.getUint32(offset);
            $12d72d0a5d9eca1c$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $12d72d0a5d9eca1c$var$SHA512_W_H[i - 15] | 0;
            const W15l = $12d72d0a5d9eca1c$var$SHA512_W_L[i - 15] | 0;
            const s0h = $91069521f68f723f$exports.default.rotrSH(W15h, W15l, 1) ^ $91069521f68f723f$exports.default.rotrSH(W15h, W15l, 8) ^ $91069521f68f723f$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $91069521f68f723f$exports.default.rotrSL(W15h, W15l, 1) ^ $91069521f68f723f$exports.default.rotrSL(W15h, W15l, 8) ^ $91069521f68f723f$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $12d72d0a5d9eca1c$var$SHA512_W_H[i - 2] | 0;
            const W2l = $12d72d0a5d9eca1c$var$SHA512_W_L[i - 2] | 0;
            const s1h = $91069521f68f723f$exports.default.rotrSH(W2h, W2l, 19) ^ $91069521f68f723f$exports.default.rotrBH(W2h, W2l, 61) ^ $91069521f68f723f$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $91069521f68f723f$exports.default.rotrSL(W2h, W2l, 19) ^ $91069521f68f723f$exports.default.rotrBL(W2h, W2l, 61) ^ $91069521f68f723f$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $91069521f68f723f$exports.default.add4L(s0l, s1l, $12d72d0a5d9eca1c$var$SHA512_W_L[i - 7], $12d72d0a5d9eca1c$var$SHA512_W_L[i - 16]);
            const SUMh = $91069521f68f723f$exports.default.add4H(SUMl, s0h, s1h, $12d72d0a5d9eca1c$var$SHA512_W_H[i - 7], $12d72d0a5d9eca1c$var$SHA512_W_H[i - 16]);
            $12d72d0a5d9eca1c$var$SHA512_W_H[i] = SUMh | 0;
            $12d72d0a5d9eca1c$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $91069521f68f723f$exports.default.rotrSH(Eh, El, 14) ^ $91069521f68f723f$exports.default.rotrSH(Eh, El, 18) ^ $91069521f68f723f$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $91069521f68f723f$exports.default.rotrSL(Eh, El, 14) ^ $91069521f68f723f$exports.default.rotrSL(Eh, El, 18) ^ $91069521f68f723f$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $91069521f68f723f$exports.default.add5L(Hl, sigma1l, CHIl, $12d72d0a5d9eca1c$var$SHA512_Kl[i], $12d72d0a5d9eca1c$var$SHA512_W_L[i]);
            const T1h = $91069521f68f723f$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $12d72d0a5d9eca1c$var$SHA512_Kh[i], $12d72d0a5d9eca1c$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $91069521f68f723f$exports.default.rotrSH(Ah, Al, 28) ^ $91069521f68f723f$exports.default.rotrBH(Ah, Al, 34) ^ $91069521f68f723f$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $91069521f68f723f$exports.default.rotrSL(Ah, Al, 28) ^ $91069521f68f723f$exports.default.rotrBL(Ah, Al, 34) ^ $91069521f68f723f$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $91069521f68f723f$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $91069521f68f723f$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $91069521f68f723f$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $91069521f68f723f$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $91069521f68f723f$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $91069521f68f723f$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $91069521f68f723f$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $91069521f68f723f$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $91069521f68f723f$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $91069521f68f723f$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $91069521f68f723f$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $12d72d0a5d9eca1c$var$SHA512_W_H.fill(0);
        $12d72d0a5d9eca1c$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$12d72d0a5d9eca1c$exports.SHA512 = $12d72d0a5d9eca1c$var$SHA512;
class $12d72d0a5d9eca1c$var$SHA512_224 extends $12d72d0a5d9eca1c$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $12d72d0a5d9eca1c$var$SHA512_256 extends $12d72d0a5d9eca1c$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $12d72d0a5d9eca1c$var$SHA384 extends $12d72d0a5d9eca1c$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$12d72d0a5d9eca1c$exports.sha512 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $12d72d0a5d9eca1c$var$SHA512());
$12d72d0a5d9eca1c$exports.sha512_224 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $12d72d0a5d9eca1c$var$SHA512_224());
$12d72d0a5d9eca1c$exports.sha512_256 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $12d72d0a5d9eca1c$var$SHA512_256());
$12d72d0a5d9eca1c$exports.sha384 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $12d72d0a5d9eca1c$var$SHA384());



function $23b96bcfda0471de$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $23b96bcfda0471de$var$anyGlobal = $23b96bcfda0471de$var$getGlobal();
const $23b96bcfda0471de$var$crypto = $23b96bcfda0471de$var$anyGlobal.crypto || $23b96bcfda0471de$var$anyGlobal.msCrypto;
function $23b96bcfda0471de$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $678d7a8026c4ddb5$exports.sha256).create();
        case "sha512":
            return (0, $12d72d0a5d9eca1c$exports.sha512).create();
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $23b96bcfda0471de$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $678d7a8026c4ddb5$exports.sha256,
        sha512: $12d72d0a5d9eca1c$exports.sha512
    }[_algo];
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $67a4b6528fd09ee4$exports.hmac).create(algo, key);
}
function $23b96bcfda0471de$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $678d7a8026c4ddb5$exports.sha256,
        sha512: $12d72d0a5d9eca1c$exports.sha512
    }[_algo];
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $161fa9a2266e3e69$exports.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $23b96bcfda0471de$export$5f828d93ff035aa8(length) {
    (0, $205dffdfdb79d607$export$a7a9523472993e97)($23b96bcfda0471de$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $23b96bcfda0471de$var$crypto.getRandomValues(result);
    return result;
}



let $f78b538281db0a48$var$locked = false;
const $f78b538281db0a48$var$_computeHmac = function(algorithm, key, data) {
    return (0, $23b96bcfda0471de$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $f78b538281db0a48$var$__computeHmac = $f78b538281db0a48$var$_computeHmac;
function $f78b538281db0a48$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $85f03119331e3531$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($f78b538281db0a48$var$__computeHmac(algorithm, key, data));
}
$f78b538281db0a48$export$967075d2f3b8e7ff._ = $f78b538281db0a48$var$_computeHmac;
$f78b538281db0a48$export$967075d2f3b8e7ff.lock = function() {
    $f78b538281db0a48$var$locked = true;
};
$f78b538281db0a48$export$967075d2f3b8e7ff.register = function(func) {
    if ($f78b538281db0a48$var$locked) throw new Error("computeHmac is locked");
    $f78b538281db0a48$var$__computeHmac = func;
};
Object.freeze($f78b538281db0a48$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ var $20934520b7eddb1e$exports = {};
"use strict";
Object.defineProperty($20934520b7eddb1e$exports, "__esModule", {
    value: true
});
$20934520b7eddb1e$exports.shake256 = $20934520b7eddb1e$exports.shake128 = $20934520b7eddb1e$exports.keccak_512 = $20934520b7eddb1e$exports.keccak_384 = $20934520b7eddb1e$exports.keccak_256 = $20934520b7eddb1e$exports.keccak_224 = $20934520b7eddb1e$exports.sha3_512 = $20934520b7eddb1e$exports.sha3_384 = $20934520b7eddb1e$exports.sha3_256 = $20934520b7eddb1e$exports.sha3_224 = $20934520b7eddb1e$exports.Keccak = $20934520b7eddb1e$exports.keccakP = void 0;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$20934520b7eddb1e$var$SHA3_PI, $20934520b7eddb1e$var$SHA3_ROTL, $20934520b7eddb1e$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $20934520b7eddb1e$var$_0n = /* @__PURE__ */ BigInt(0);
const $20934520b7eddb1e$var$_1n = /* @__PURE__ */ BigInt(1);
const $20934520b7eddb1e$var$_2n = /* @__PURE__ */ BigInt(2);
const $20934520b7eddb1e$var$_7n = /* @__PURE__ */ BigInt(7);
const $20934520b7eddb1e$var$_256n = /* @__PURE__ */ BigInt(256);
const $20934520b7eddb1e$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $20934520b7eddb1e$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $20934520b7eddb1e$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $20934520b7eddb1e$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $20934520b7eddb1e$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $20934520b7eddb1e$var$_1n ^ (R >> $20934520b7eddb1e$var$_7n) * $20934520b7eddb1e$var$_0x71n) % $20934520b7eddb1e$var$_256n;
        if (R & $20934520b7eddb1e$var$_2n) t ^= $20934520b7eddb1e$var$_1n << ($20934520b7eddb1e$var$_1n << /* @__PURE__ */ BigInt(j)) - $20934520b7eddb1e$var$_1n;
    }
    $20934520b7eddb1e$var$_SHA3_IOTA.push(t);
}
const [$20934520b7eddb1e$var$SHA3_IOTA_H, $20934520b7eddb1e$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $91069521f68f723f$exports.split)($20934520b7eddb1e$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $20934520b7eddb1e$var$rotlH = (h, l, s)=>s > 32 ? (0, $91069521f68f723f$exports.rotlBH)(h, l, s) : (0, $91069521f68f723f$exports.rotlSH)(h, l, s);
const $20934520b7eddb1e$var$rotlL = (h, l, s)=>s > 32 ? (0, $91069521f68f723f$exports.rotlBL)(h, l, s) : (0, $91069521f68f723f$exports.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $20934520b7eddb1e$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $20934520b7eddb1e$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $20934520b7eddb1e$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $20934520b7eddb1e$var$SHA3_ROTL[t];
            const Th = $20934520b7eddb1e$var$rotlH(curH, curL, shift);
            const Tl = $20934520b7eddb1e$var$rotlL(curH, curL, shift);
            const PI = $20934520b7eddb1e$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $20934520b7eddb1e$var$SHA3_IOTA_H[round];
        s[1] ^= $20934520b7eddb1e$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$20934520b7eddb1e$exports.keccakP = $20934520b7eddb1e$var$keccakP;
class $20934520b7eddb1e$var$Keccak extends $a0bae7f9e6925ec9$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $8e5b0f1624444b7c$exports.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $a0bae7f9e6925ec9$exports.u32)(this.state);
    }
    keccak() {
        $20934520b7eddb1e$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $8e5b0f1624444b7c$exports.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $a0bae7f9e6925ec9$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $8e5b0f1624444b7c$exports.exists)(this, false);
        (0, $8e5b0f1624444b7c$exports.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $8e5b0f1624444b7c$exports.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $8e5b0f1624444b7c$exports.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $20934520b7eddb1e$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$20934520b7eddb1e$exports.Keccak = $20934520b7eddb1e$var$Keccak;
const $20934520b7eddb1e$var$gen = (suffix, blockLen, outputLen)=>(0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $20934520b7eddb1e$var$Keccak(blockLen, suffix, outputLen));
$20934520b7eddb1e$exports.sha3_224 = $20934520b7eddb1e$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $20934520b7eddb1e$exports.sha3_256 = $20934520b7eddb1e$var$gen(0x06, 136, 32);
$20934520b7eddb1e$exports.sha3_384 = $20934520b7eddb1e$var$gen(0x06, 104, 48);
$20934520b7eddb1e$exports.sha3_512 = $20934520b7eddb1e$var$gen(0x06, 72, 64);
$20934520b7eddb1e$exports.keccak_224 = $20934520b7eddb1e$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $20934520b7eddb1e$exports.keccak_256 = $20934520b7eddb1e$var$gen(0x01, 136, 32);
$20934520b7eddb1e$exports.keccak_384 = $20934520b7eddb1e$var$gen(0x01, 104, 48);
$20934520b7eddb1e$exports.keccak_512 = $20934520b7eddb1e$var$gen(0x01, 72, 64);
const $20934520b7eddb1e$var$genShake = (suffix, blockLen, outputLen)=>(0, $a0bae7f9e6925ec9$exports.wrapXOFConstructorWithOpts)((opts = {})=>new $20934520b7eddb1e$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
$20934520b7eddb1e$exports.shake128 = $20934520b7eddb1e$var$genShake(0x1f, 168, 16);
$20934520b7eddb1e$exports.shake256 = $20934520b7eddb1e$var$genShake(0x1f, 136, 32);



let $39fe7f3d73992d01$var$locked = false;
const $39fe7f3d73992d01$var$_keccak256 = function(data) {
    return (0, $20934520b7eddb1e$exports.keccak_256)(data);
};
let $39fe7f3d73992d01$var$__keccak256 = $39fe7f3d73992d01$var$_keccak256;
function $39fe7f3d73992d01$export$f8151fce47ad1c35(_data) {
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($39fe7f3d73992d01$var$__keccak256(data));
}
$39fe7f3d73992d01$export$f8151fce47ad1c35._ = $39fe7f3d73992d01$var$_keccak256;
$39fe7f3d73992d01$export$f8151fce47ad1c35.lock = function() {
    $39fe7f3d73992d01$var$locked = true;
};
$39fe7f3d73992d01$export$f8151fce47ad1c35.register = function(func) {
    if ($39fe7f3d73992d01$var$locked) throw new TypeError("keccak256 is locked");
    $39fe7f3d73992d01$var$__keccak256 = func;
};
Object.freeze($39fe7f3d73992d01$export$f8151fce47ad1c35);


var $82e8c78ce9c084d2$exports = {};
"use strict";
Object.defineProperty($82e8c78ce9c084d2$exports, "__esModule", {
    value: true
});
$82e8c78ce9c084d2$exports.ripemd160 = $82e8c78ce9c084d2$exports.RIPEMD160 = void 0;


// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $82e8c78ce9c084d2$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $82e8c78ce9c084d2$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $82e8c78ce9c084d2$var$Pi = /* @__PURE__ */ $82e8c78ce9c084d2$var$Id.map((i)=>(9 * i + 5) % 16);
let $82e8c78ce9c084d2$var$idxL = [
    $82e8c78ce9c084d2$var$Id
];
let $82e8c78ce9c084d2$var$idxR = [
    $82e8c78ce9c084d2$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $82e8c78ce9c084d2$var$idxL,
    $82e8c78ce9c084d2$var$idxR
])j.push(j[i].map((k)=>$82e8c78ce9c084d2$var$Rho[k]));
const $82e8c78ce9c084d2$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $82e8c78ce9c084d2$var$shiftsL = /* @__PURE__ */ $82e8c78ce9c084d2$var$idxL.map((idx, i)=>idx.map((j)=>$82e8c78ce9c084d2$var$shifts[i][j]));
const $82e8c78ce9c084d2$var$shiftsR = /* @__PURE__ */ $82e8c78ce9c084d2$var$idxR.map((idx, i)=>idx.map((j)=>$82e8c78ce9c084d2$var$shifts[i][j]));
const $82e8c78ce9c084d2$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $82e8c78ce9c084d2$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $82e8c78ce9c084d2$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $82e8c78ce9c084d2$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $82e8c78ce9c084d2$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $82e8c78ce9c084d2$var$RIPEMD160 extends $d31549e44a3a8dcc$exports.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$82e8c78ce9c084d2$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $82e8c78ce9c084d2$var$Kl[group], hbr = $82e8c78ce9c084d2$var$Kr[group]; // prettier-ignore
            const rl = $82e8c78ce9c084d2$var$idxL[group], rr = $82e8c78ce9c084d2$var$idxR[group]; // prettier-ignore
            const sl = $82e8c78ce9c084d2$var$shiftsL[group], sr = $82e8c78ce9c084d2$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $82e8c78ce9c084d2$var$rotl(al + $82e8c78ce9c084d2$var$f(group, bl, cl, dl) + $82e8c78ce9c084d2$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $82e8c78ce9c084d2$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $82e8c78ce9c084d2$var$rotl(ar + $82e8c78ce9c084d2$var$f(rGroup, br, cr, dr) + $82e8c78ce9c084d2$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $82e8c78ce9c084d2$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $82e8c78ce9c084d2$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
$82e8c78ce9c084d2$exports.RIPEMD160 = $82e8c78ce9c084d2$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $82e8c78ce9c084d2$exports.ripemd160 = (0, $a0bae7f9e6925ec9$exports.wrapConstructor)(()=>new $82e8c78ce9c084d2$var$RIPEMD160());



let $799945d864146a10$var$locked = false;
const $799945d864146a10$var$_ripemd160 = function(data) {
    return (0, $82e8c78ce9c084d2$exports.ripemd160)(data);
};
let $799945d864146a10$var$__ripemd160 = $799945d864146a10$var$_ripemd160;
function $799945d864146a10$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($799945d864146a10$var$__ripemd160(data));
}
$799945d864146a10$export$d1cea0ee4e3f0d3e._ = $799945d864146a10$var$_ripemd160;
$799945d864146a10$export$d1cea0ee4e3f0d3e.lock = function() {
    $799945d864146a10$var$locked = true;
};
$799945d864146a10$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($799945d864146a10$var$locked) throw new TypeError("ripemd160 is locked");
    $799945d864146a10$var$__ripemd160 = func;
};
Object.freeze($799945d864146a10$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $a8288d4c192ce0a6$var$locked = false;
const $a8288d4c192ce0a6$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $23b96bcfda0471de$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $a8288d4c192ce0a6$var$__pbkdf2 = $a8288d4c192ce0a6$var$_pbkdf2;
function $a8288d4c192ce0a6$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $85f03119331e3531$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $85f03119331e3531$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($a8288d4c192ce0a6$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$a8288d4c192ce0a6$export$448fa22aedc9dbca._ = $a8288d4c192ce0a6$var$_pbkdf2;
$a8288d4c192ce0a6$export$448fa22aedc9dbca.lock = function() {
    $a8288d4c192ce0a6$var$locked = true;
};
$a8288d4c192ce0a6$export$448fa22aedc9dbca.register = function(func) {
    if ($a8288d4c192ce0a6$var$locked) throw new Error("pbkdf2 is locked");
    $a8288d4c192ce0a6$var$__pbkdf2 = func;
};
Object.freeze($a8288d4c192ce0a6$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $2c4ecb7a2d76f909$var$locked = false;
const $2c4ecb7a2d76f909$var$_randomBytes = function(length) {
    return new Uint8Array((0, $23b96bcfda0471de$export$5f828d93ff035aa8)(length));
};
let $2c4ecb7a2d76f909$var$__randomBytes = $2c4ecb7a2d76f909$var$_randomBytes;
function $2c4ecb7a2d76f909$export$5f828d93ff035aa8(length) {
    return $2c4ecb7a2d76f909$var$__randomBytes(length);
}
$2c4ecb7a2d76f909$export$5f828d93ff035aa8._ = $2c4ecb7a2d76f909$var$_randomBytes;
$2c4ecb7a2d76f909$export$5f828d93ff035aa8.lock = function() {
    $2c4ecb7a2d76f909$var$locked = true;
};
$2c4ecb7a2d76f909$export$5f828d93ff035aa8.register = function(func) {
    if ($2c4ecb7a2d76f909$var$locked) throw new Error("randomBytes is locked");
    $2c4ecb7a2d76f909$var$__randomBytes = func;
};
Object.freeze($2c4ecb7a2d76f909$export$5f828d93ff035aa8);


var $cdedc7ed54f800be$exports = {};
"use strict";
Object.defineProperty($cdedc7ed54f800be$exports, "__esModule", {
    value: true
});
$cdedc7ed54f800be$exports.scryptAsync = $cdedc7ed54f800be$exports.scrypt = void 0;




// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $cdedc7ed54f800be$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $cdedc7ed54f800be$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $cdedc7ed54f800be$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $cdedc7ed54f800be$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $cdedc7ed54f800be$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $cdedc7ed54f800be$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $cdedc7ed54f800be$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $cdedc7ed54f800be$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $cdedc7ed54f800be$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $cdedc7ed54f800be$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $cdedc7ed54f800be$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $cdedc7ed54f800be$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $cdedc7ed54f800be$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $cdedc7ed54f800be$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $cdedc7ed54f800be$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $cdedc7ed54f800be$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $cdedc7ed54f800be$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $cdedc7ed54f800be$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $cdedc7ed54f800be$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $cdedc7ed54f800be$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $cdedc7ed54f800be$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $cdedc7ed54f800be$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $cdedc7ed54f800be$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $cdedc7ed54f800be$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $cdedc7ed54f800be$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $cdedc7ed54f800be$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $cdedc7ed54f800be$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $cdedc7ed54f800be$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $cdedc7ed54f800be$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $cdedc7ed54f800be$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $cdedc7ed54f800be$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $cdedc7ed54f800be$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $cdedc7ed54f800be$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $cdedc7ed54f800be$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $cdedc7ed54f800be$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $cdedc7ed54f800be$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $cdedc7ed54f800be$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $cdedc7ed54f800be$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $a0bae7f9e6925ec9$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $8e5b0f1624444b7c$exports.number)(N);
    (0, $8e5b0f1624444b7c$exports.number)(r);
    (0, $8e5b0f1624444b7c$exports.number)(p);
    (0, $8e5b0f1624444b7c$exports.number)(dkLen);
    (0, $8e5b0f1624444b7c$exports.number)(asyncTick);
    (0, $8e5b0f1624444b7c$exports.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $161fa9a2266e3e69$exports.pbkdf2)($678d7a8026c4ddb5$exports.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $a0bae7f9e6925ec9$exports.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $a0bae7f9e6925ec9$exports.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $a0bae7f9e6925ec9$exports.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $cdedc7ed54f800be$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $161fa9a2266e3e69$exports.pbkdf2)($678d7a8026c4ddb5$exports.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function $cdedc7ed54f800be$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $cdedc7ed54f800be$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $cdedc7ed54f800be$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $cdedc7ed54f800be$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $cdedc7ed54f800be$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $cdedc7ed54f800be$var$scryptOutput(password, dkLen, B, V, tmp);
}
$cdedc7ed54f800be$exports.scrypt = $cdedc7ed54f800be$var$scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function $cdedc7ed54f800be$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $cdedc7ed54f800be$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $a0bae7f9e6925ec9$exports.asyncLoop)(N - 1, asyncTick, ()=>{
            $cdedc7ed54f800be$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $cdedc7ed54f800be$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $a0bae7f9e6925ec9$exports.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $cdedc7ed54f800be$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $cdedc7ed54f800be$var$scryptOutput(password, dkLen, B, V, tmp);
}
$cdedc7ed54f800be$exports.scryptAsync = $cdedc7ed54f800be$var$scryptAsync;



let $d8bab4d659173428$var$lockedSync = false, $d8bab4d659173428$var$lockedAsync = false;
const $d8bab4d659173428$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $cdedc7ed54f800be$exports.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $d8bab4d659173428$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $cdedc7ed54f800be$exports.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $d8bab4d659173428$var$__scryptAsync = $d8bab4d659173428$var$_scryptAsync;
let $d8bab4d659173428$var$__scryptSync = $d8bab4d659173428$var$_scryptSync;
async function $d8bab4d659173428$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $85f03119331e3531$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $85f03119331e3531$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(await $d8bab4d659173428$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$d8bab4d659173428$export$7cf7c2f1ec457bf3._ = $d8bab4d659173428$var$_scryptAsync;
$d8bab4d659173428$export$7cf7c2f1ec457bf3.lock = function() {
    $d8bab4d659173428$var$lockedAsync = true;
};
$d8bab4d659173428$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($d8bab4d659173428$var$lockedAsync) throw new Error("scrypt is locked");
    $d8bab4d659173428$var$__scryptAsync = func;
};
Object.freeze($d8bab4d659173428$export$7cf7c2f1ec457bf3);
function $d8bab4d659173428$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $85f03119331e3531$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $85f03119331e3531$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($d8bab4d659173428$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$d8bab4d659173428$export$86c79e0734c26a76._ = $d8bab4d659173428$var$_scryptSync;
$d8bab4d659173428$export$86c79e0734c26a76.lock = function() {
    $d8bab4d659173428$var$lockedSync = true;
};
$d8bab4d659173428$export$86c79e0734c26a76.register = function(func) {
    if ($d8bab4d659173428$var$lockedSync) throw new Error("scryptSync is locked");
    $d8bab4d659173428$var$__scryptSync = func;
};
Object.freeze($d8bab4d659173428$export$86c79e0734c26a76);




const $8ffad2f5de44b604$var$_sha256 = function(data) {
    return (0, $23b96bcfda0471de$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $8ffad2f5de44b604$var$_sha512 = function(data) {
    return (0, $23b96bcfda0471de$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $8ffad2f5de44b604$var$__sha256 = $8ffad2f5de44b604$var$_sha256;
let $8ffad2f5de44b604$var$__sha512 = $8ffad2f5de44b604$var$_sha512;
let $8ffad2f5de44b604$var$locked256 = false, $8ffad2f5de44b604$var$locked512 = false;
function $8ffad2f5de44b604$export$bced8d2aada2d1c9(_data) {
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($8ffad2f5de44b604$var$__sha256(data));
}
$8ffad2f5de44b604$export$bced8d2aada2d1c9._ = $8ffad2f5de44b604$var$_sha256;
$8ffad2f5de44b604$export$bced8d2aada2d1c9.lock = function() {
    $8ffad2f5de44b604$var$locked256 = true;
};
$8ffad2f5de44b604$export$bced8d2aada2d1c9.register = function(func) {
    if ($8ffad2f5de44b604$var$locked256) throw new Error("sha256 is locked");
    $8ffad2f5de44b604$var$__sha256 = func;
};
Object.freeze($8ffad2f5de44b604$export$bced8d2aada2d1c9);
function $8ffad2f5de44b604$export$a888d2532e6dc7bb(_data) {
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)($8ffad2f5de44b604$var$__sha512(data));
}
$8ffad2f5de44b604$export$a888d2532e6dc7bb._ = $8ffad2f5de44b604$var$_sha512;
$8ffad2f5de44b604$export$a888d2532e6dc7bb.lock = function() {
    $8ffad2f5de44b604$var$locked512 = true;
};
$8ffad2f5de44b604$export$a888d2532e6dc7bb.register = function(func) {
    if ($8ffad2f5de44b604$var$locked512) throw new Error("sha512 is locked");
    $8ffad2f5de44b604$var$__sha512 = func;
};
Object.freeze($8ffad2f5de44b604$export$bced8d2aada2d1c9);


/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ var $ae4c2da7f42c597b$exports = {};
"use strict";
Object.defineProperty($ae4c2da7f42c597b$exports, "__esModule", {
    value: true
});
$ae4c2da7f42c597b$exports.encodeToCurve = $ae4c2da7f42c597b$exports.hashToCurve = $ae4c2da7f42c597b$exports.schnorr = $ae4c2da7f42c597b$exports.secp256k1 = void 0;



var $7U1b8 = parcelRequire("7U1b8");
var $9fa09d9cbee376a1$exports = {};
"use strict";
Object.defineProperty($9fa09d9cbee376a1$exports, "__esModule", {
    value: true
});
$9fa09d9cbee376a1$exports.mapToCurveSimpleSWU = $9fa09d9cbee376a1$exports.SWUFpSqrtRatio = $9fa09d9cbee376a1$exports.weierstrass = $9fa09d9cbee376a1$exports.weierstrassPoints = $9fa09d9cbee376a1$exports.DER = void 0;

var $7U1b8 = parcelRequire("7U1b8");

var $jnC97 = parcelRequire("jnC97");

var $jnC97 = parcelRequire("jnC97");

var $9zpVk = parcelRequire("9zpVk");
function $9fa09d9cbee376a1$var$validatePointOpts(curve) {
    const opts = (0, $9zpVk.validateBasic)(curve);
    $jnC97.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $9fa09d9cbee376a1$var$b2n, hexToBytes: $9fa09d9cbee376a1$var$h2b } = $jnC97;
$9fa09d9cbee376a1$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $9fa09d9cbee376a1$exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $9fa09d9cbee376a1$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $9fa09d9cbee376a1$exports.DER;
        const data = typeof hex === "string" ? $9fa09d9cbee376a1$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $9fa09d9cbee376a1$exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $9fa09d9cbee376a1$exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $9fa09d9cbee376a1$var$_0n = BigInt(0), $9fa09d9cbee376a1$var$_1n = BigInt(1), $9fa09d9cbee376a1$var$_2n = BigInt(2), $9fa09d9cbee376a1$var$_3n = BigInt(3), $9fa09d9cbee376a1$var$_4n = BigInt(4);
function $9fa09d9cbee376a1$var$weierstrassPoints(opts) {
    const CURVE = $9fa09d9cbee376a1$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $jnC97.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $9fa09d9cbee376a1$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $jnC97.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $jnC97.bytesToNumberBE((0, $jnC97.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $7U1b8.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $jnC97.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $9fa09d9cbee376a1$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $9fa09d9cbee376a1$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $9fa09d9cbee376a1$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $9fa09d9cbee376a1$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $9fa09d9cbee376a1$var$_0n || k2 > $9fa09d9cbee376a1$var$_0n){
                if (k1 & $9fa09d9cbee376a1$var$_1n) k1p = k1p.add(d);
                if (k2 & $9fa09d9cbee376a1$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $9fa09d9cbee376a1$var$_1n;
                k2 >>= $9fa09d9cbee376a1$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $9fa09d9cbee376a1$var$_0n || a === $9fa09d9cbee376a1$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $9fa09d9cbee376a1$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $9fa09d9cbee376a1$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $jnC97.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $9zpVk.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
$9fa09d9cbee376a1$exports.weierstrassPoints = $9fa09d9cbee376a1$var$weierstrassPoints;
function $9fa09d9cbee376a1$var$validateOpts(curve) {
    const opts = (0, $9zpVk.validateBasic)(curve);
    $jnC97.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $9fa09d9cbee376a1$var$weierstrass(curveDef) {
    const CURVE = $9fa09d9cbee376a1$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $9fa09d9cbee376a1$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $7U1b8.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $7U1b8.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $9fa09d9cbee376a1$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $jnC97.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $jnC97.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $9fa09d9cbee376a1$var$_1n) === $9fa09d9cbee376a1$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$jnC97.bytesToHex($jnC97.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $9fa09d9cbee376a1$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$jnC97.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $jnC97.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $9fa09d9cbee376a1$exports.DER.toSig((0, $jnC97.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $jnC97.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $jnC97.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $9fa09d9cbee376a1$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $jnC97.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $7U1b8.getMinHashLength(CURVE.n);
            return $7U1b8.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $jnC97.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $jnC97.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($9fa09d9cbee376a1$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $jnC97.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $jnC97.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $jnC97.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $jnC97.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $jnC97.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $9fa09d9cbee376a1$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $9fa09d9cbee376a1$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $9fa09d9cbee376a1$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $jnC97.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $jnC97.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $jnC97.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $9fa09d9cbee376a1$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
$9fa09d9cbee376a1$exports.weierstrass = $9fa09d9cbee376a1$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $9fa09d9cbee376a1$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $9fa09d9cbee376a1$var$_0n;
    for(let o = q - $9fa09d9cbee376a1$var$_1n; o % $9fa09d9cbee376a1$var$_2n === $9fa09d9cbee376a1$var$_0n; o /= $9fa09d9cbee376a1$var$_2n)l += $9fa09d9cbee376a1$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $9fa09d9cbee376a1$var$_2n << c1 - $9fa09d9cbee376a1$var$_1n - $9fa09d9cbee376a1$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $9fa09d9cbee376a1$var$_2n;
    const c2 = (q - $9fa09d9cbee376a1$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $9fa09d9cbee376a1$var$_1n) / $9fa09d9cbee376a1$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $9fa09d9cbee376a1$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $9fa09d9cbee376a1$var$_1n) / $9fa09d9cbee376a1$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $9fa09d9cbee376a1$var$_1n; i--){
            let tv5 = i - $9fa09d9cbee376a1$var$_2n; // 18.    tv5 = i - 2
            tv5 = $9fa09d9cbee376a1$var$_2n << tv5 - $9fa09d9cbee376a1$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $9fa09d9cbee376a1$var$_4n === $9fa09d9cbee376a1$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $9fa09d9cbee376a1$var$_3n) / $9fa09d9cbee376a1$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
$9fa09d9cbee376a1$exports.SWUFpSqrtRatio = $9fa09d9cbee376a1$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $9fa09d9cbee376a1$var$mapToCurveSimpleSWU(Fp, opts) {
    $7U1b8.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $9fa09d9cbee376a1$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
$9fa09d9cbee376a1$exports.mapToCurveSimpleSWU = $9fa09d9cbee376a1$var$mapToCurveSimpleSWU;



var $jnC97 = parcelRequire("jnC97");
var $6cce4b131a8ed833$exports = {};
"use strict";
Object.defineProperty($6cce4b131a8ed833$exports, "__esModule", {
    value: true
});
$6cce4b131a8ed833$exports.createHasher = $6cce4b131a8ed833$exports.isogenyMap = $6cce4b131a8ed833$exports.hash_to_field = $6cce4b131a8ed833$exports.expand_message_xof = $6cce4b131a8ed833$exports.expand_message_xmd = void 0;

var $7U1b8 = parcelRequire("7U1b8");

var $jnC97 = parcelRequire("jnC97");
function $6cce4b131a8ed833$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $jnC97.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $6cce4b131a8ed833$var$os2ip = $jnC97.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $6cce4b131a8ed833$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $6cce4b131a8ed833$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $6cce4b131a8ed833$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $6cce4b131a8ed833$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $6cce4b131a8ed833$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $6cce4b131a8ed833$var$isBytes(msg);
    $6cce4b131a8ed833$var$isBytes(DST);
    $6cce4b131a8ed833$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $jnC97.concatBytes)((0, $jnC97.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $jnC97.concatBytes)(DST, $6cce4b131a8ed833$var$i2osp(DST.length, 1));
    const Z_pad = $6cce4b131a8ed833$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $6cce4b131a8ed833$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $jnC97.concatBytes)(Z_pad, msg, l_i_b_str, $6cce4b131a8ed833$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $jnC97.concatBytes)(b_0, $6cce4b131a8ed833$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $6cce4b131a8ed833$var$strxor(b_0, b[i - 1]),
            $6cce4b131a8ed833$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $jnC97.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $jnC97.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
$6cce4b131a8ed833$exports.expand_message_xmd = $6cce4b131a8ed833$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $6cce4b131a8ed833$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $6cce4b131a8ed833$var$isBytes(msg);
    $6cce4b131a8ed833$var$isBytes(DST);
    $6cce4b131a8ed833$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $jnC97.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($6cce4b131a8ed833$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($6cce4b131a8ed833$var$i2osp(DST.length, 1)).digest();
}
$6cce4b131a8ed833$exports.expand_message_xof = $6cce4b131a8ed833$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $6cce4b131a8ed833$var$hash_to_field(msg, count, options) {
    (0, $jnC97.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $6cce4b131a8ed833$var$isBytes(msg);
    $6cce4b131a8ed833$var$isNum(count);
    const DST = $6cce4b131a8ed833$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $6cce4b131a8ed833$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $6cce4b131a8ed833$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $7U1b8.mod)($6cce4b131a8ed833$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
$6cce4b131a8ed833$exports.hash_to_field = $6cce4b131a8ed833$var$hash_to_field;
function $6cce4b131a8ed833$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
$6cce4b131a8ed833$exports.isogenyMap = $6cce4b131a8ed833$var$isogenyMap;
function $6cce4b131a8ed833$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $6cce4b131a8ed833$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $6cce4b131a8ed833$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
$6cce4b131a8ed833$exports.createHasher = $6cce4b131a8ed833$var$createHasher;


var $6af1c4cc8c781cd2$exports = {};
"use strict";
Object.defineProperty($6af1c4cc8c781cd2$exports, "__esModule", {
    value: true
});
$6af1c4cc8c781cd2$exports.createCurve = $6af1c4cc8c781cd2$exports.getHash = void 0;



// connects noble-curves to noble-hashes
function $6af1c4cc8c781cd2$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $67a4b6528fd09ee4$exports.hmac)(hash, key, (0, $a0bae7f9e6925ec9$exports.concatBytes)(...msgs)),
        randomBytes: $a0bae7f9e6925ec9$exports.randomBytes
    };
}
$6af1c4cc8c781cd2$exports.getHash = $6af1c4cc8c781cd2$var$getHash;
function $6af1c4cc8c781cd2$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $9fa09d9cbee376a1$exports.weierstrass)({
            ...curveDef,
            ...$6af1c4cc8c781cd2$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
$6af1c4cc8c781cd2$exports.createCurve = $6af1c4cc8c781cd2$var$createCurve;


const $ae4c2da7f42c597b$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $ae4c2da7f42c597b$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $ae4c2da7f42c597b$var$_1n = BigInt(1);
const $ae4c2da7f42c597b$var$_2n = BigInt(2);
const $ae4c2da7f42c597b$var$divNearest = (a, b)=>(a + b / $ae4c2da7f42c597b$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $ae4c2da7f42c597b$var$sqrtMod(y) {
    const P = $ae4c2da7f42c597b$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $7U1b8.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $7U1b8.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $7U1b8.pow2)(b9, $ae4c2da7f42c597b$var$_2n, P) * b2 % P;
    const b22 = (0, $7U1b8.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $7U1b8.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $7U1b8.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $7U1b8.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $7U1b8.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $7U1b8.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $7U1b8.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $7U1b8.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $7U1b8.pow2)(t2, $ae4c2da7f42c597b$var$_2n, P);
    if (!$ae4c2da7f42c597b$var$Fp.eql($ae4c2da7f42c597b$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $ae4c2da7f42c597b$var$Fp = (0, $7U1b8.Field)($ae4c2da7f42c597b$var$secp256k1P, undefined, undefined, {
    sqrt: $ae4c2da7f42c597b$var$sqrtMod
});
$ae4c2da7f42c597b$exports.secp256k1 = (0, $6af1c4cc8c781cd2$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $ae4c2da7f42c597b$var$Fp,
    n: $ae4c2da7f42c597b$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $ae4c2da7f42c597b$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$ae4c2da7f42c597b$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $ae4c2da7f42c597b$var$divNearest(b2 * k, n);
            const c2 = $ae4c2da7f42c597b$var$divNearest(-b1 * k, n);
            let k1 = (0, $7U1b8.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $7U1b8.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $678d7a8026c4ddb5$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $ae4c2da7f42c597b$var$_0n = BigInt(0);
const $ae4c2da7f42c597b$var$fe = (x)=>typeof x === "bigint" && $ae4c2da7f42c597b$var$_0n < x && x < $ae4c2da7f42c597b$var$secp256k1P;
const $ae4c2da7f42c597b$var$ge = (x)=>typeof x === "bigint" && $ae4c2da7f42c597b$var$_0n < x && x < $ae4c2da7f42c597b$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $ae4c2da7f42c597b$var$TAGGED_HASH_PREFIXES = {};
function $ae4c2da7f42c597b$var$taggedHash(tag, ...messages) {
    let tagP = $ae4c2da7f42c597b$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $678d7a8026c4ddb5$exports.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $jnC97.concatBytes)(tagH, tagH);
        $ae4c2da7f42c597b$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $678d7a8026c4ddb5$exports.sha256)((0, $jnC97.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $ae4c2da7f42c597b$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $ae4c2da7f42c597b$var$numTo32b = (n)=>(0, $jnC97.numberToBytesBE)(n, 32);
const $ae4c2da7f42c597b$var$modP = (x)=>(0, $7U1b8.mod)(x, $ae4c2da7f42c597b$var$secp256k1P);
const $ae4c2da7f42c597b$var$modN = (x)=>(0, $7U1b8.mod)(x, $ae4c2da7f42c597b$var$secp256k1N);
const $ae4c2da7f42c597b$var$Point = $ae4c2da7f42c597b$exports.secp256k1.ProjectivePoint;
const $ae4c2da7f42c597b$var$GmulAdd = (Q, a, b)=>$ae4c2da7f42c597b$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $ae4c2da7f42c597b$var$schnorrGetExtPubKey(priv) {
    let d_ = $ae4c2da7f42c597b$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $ae4c2da7f42c597b$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $ae4c2da7f42c597b$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $ae4c2da7f42c597b$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $ae4c2da7f42c597b$var$lift_x(x) {
    if (!$ae4c2da7f42c597b$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $ae4c2da7f42c597b$var$modP(x * x);
    const c = $ae4c2da7f42c597b$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $ae4c2da7f42c597b$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $ae4c2da7f42c597b$var$_2n !== $ae4c2da7f42c597b$var$_0n) y = $ae4c2da7f42c597b$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $ae4c2da7f42c597b$var$Point(x, y, $ae4c2da7f42c597b$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $ae4c2da7f42c597b$var$challenge(...args) {
    return $ae4c2da7f42c597b$var$modN((0, $jnC97.bytesToNumberBE)($ae4c2da7f42c597b$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $ae4c2da7f42c597b$var$schnorrGetPublicKey(privateKey) {
    return $ae4c2da7f42c597b$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $ae4c2da7f42c597b$var$schnorrSign(message, privateKey, auxRand = (0, $a0bae7f9e6925ec9$exports.randomBytes)(32)) {
    const m = (0, $jnC97.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $ae4c2da7f42c597b$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $jnC97.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $ae4c2da7f42c597b$var$numTo32b(d ^ (0, $jnC97.bytesToNumberBE)($ae4c2da7f42c597b$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $ae4c2da7f42c597b$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $ae4c2da7f42c597b$var$modN((0, $jnC97.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $ae4c2da7f42c597b$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $ae4c2da7f42c597b$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $ae4c2da7f42c597b$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($ae4c2da7f42c597b$var$numTo32b($ae4c2da7f42c597b$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$ae4c2da7f42c597b$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $ae4c2da7f42c597b$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $jnC97.ensureBytes)("signature", signature, 64);
    const m = (0, $jnC97.ensureBytes)("message", message);
    const pub = (0, $jnC97.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $ae4c2da7f42c597b$var$lift_x((0, $jnC97.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $jnC97.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$ae4c2da7f42c597b$var$fe(r)) return false;
        const s = (0, $jnC97.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$ae4c2da7f42c597b$var$ge(s)) return false;
        const e = $ae4c2da7f42c597b$var$challenge($ae4c2da7f42c597b$var$numTo32b(r), $ae4c2da7f42c597b$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $ae4c2da7f42c597b$var$GmulAdd(P, s, $ae4c2da7f42c597b$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$ae4c2da7f42c597b$exports.schnorr = (()=>({
        getPublicKey: $ae4c2da7f42c597b$var$schnorrGetPublicKey,
        sign: $ae4c2da7f42c597b$var$schnorrSign,
        verify: $ae4c2da7f42c597b$var$schnorrVerify,
        utils: {
            randomPrivateKey: $ae4c2da7f42c597b$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $ae4c2da7f42c597b$var$lift_x,
            pointToBytes: $ae4c2da7f42c597b$var$pointToBytes,
            numberToBytesBE: $jnC97.numberToBytesBE,
            bytesToNumberBE: $jnC97.bytesToNumberBE,
            taggedHash: $ae4c2da7f42c597b$var$taggedHash,
            mod: $7U1b8.mod
        }
    }))();
const $ae4c2da7f42c597b$var$isoMap = /* @__PURE__ */ (()=>(0, $6cce4b131a8ed833$exports.isogenyMap)($ae4c2da7f42c597b$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $ae4c2da7f42c597b$var$mapSWU = /* @__PURE__ */ (()=>(0, $9fa09d9cbee376a1$exports.mapToCurveSimpleSWU)($ae4c2da7f42c597b$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $ae4c2da7f42c597b$var$Fp.create(BigInt("-11"))
    }))();
const $ae4c2da7f42c597b$var$htf = /* @__PURE__ */ (()=>(0, $6cce4b131a8ed833$exports.createHasher)($ae4c2da7f42c597b$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $ae4c2da7f42c597b$var$mapSWU($ae4c2da7f42c597b$var$Fp.create(scalars[0]));
        return $ae4c2da7f42c597b$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $ae4c2da7f42c597b$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $678d7a8026c4ddb5$exports.sha256
    }))();
$ae4c2da7f42c597b$exports.hashToCurve = (()=>$ae4c2da7f42c597b$var$htf.hashToCurve)();
$ae4c2da7f42c597b$exports.encodeToCurve = (()=>$ae4c2da7f42c597b$var$htf.encodeToCurve)();



/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $20db941dacece1fe$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";



// Constants
const $1ec7d3acfcdcd7a6$var$BN_0 = BigInt(0);
const $1ec7d3acfcdcd7a6$var$BN_1 = BigInt(1);
const $1ec7d3acfcdcd7a6$var$BN_2 = BigInt(2);
const $1ec7d3acfcdcd7a6$var$BN_27 = BigInt(27);
const $1ec7d3acfcdcd7a6$var$BN_28 = BigInt(28);
const $1ec7d3acfcdcd7a6$var$BN_35 = BigInt(35);
const $1ec7d3acfcdcd7a6$var$_guard = {};
function $1ec7d3acfcdcd7a6$var$toUint256(value) {
    return (0, $85f03119331e3531$export$4473860254365feb)((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(value), 32);
}
class $1ec7d3acfcdcd7a6$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$2321cd91b99770ff)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$2321cd91b99770ff)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(_value);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $7769476213c187e3$export$b14f2714108df84)(value, "value");
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $1ec7d3acfcdcd7a6$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $85f03119331e3531$export$a3521add2594f3c8)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $205dffdfdb79d607$export$ac1a938d48ec8c7b)(guard, $1ec7d3acfcdcd7a6$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $1ec7d3acfcdcd7a6$export$848620f5f2f26e86($1ec7d3acfcdcd7a6$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $1ec7d3acfcdcd7a6$var$BN_27 || bv == $1ec7d3acfcdcd7a6$var$BN_28) return $1ec7d3acfcdcd7a6$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(bv >= $1ec7d3acfcdcd7a6$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $1ec7d3acfcdcd7a6$var$BN_35) / $1ec7d3acfcdcd7a6$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(chainId) * $1ec7d3acfcdcd7a6$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(v);
        if (bv === $1ec7d3acfcdcd7a6$var$BN_0 || bv === $1ec7d3acfcdcd7a6$var$BN_27) return 27;
        if (bv === $1ec7d3acfcdcd7a6$var$BN_1 || bv === $1ec7d3acfcdcd7a6$var$BN_28) return 28;
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(bv >= $1ec7d3acfcdcd7a6$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $1ec7d3acfcdcd7a6$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(check, message, "signature", sig);
        }
        if (sig == null) return new $1ec7d3acfcdcd7a6$export$848620f5f2f26e86($1ec7d3acfcdcd7a6$var$_guard, (0, $20db941dacece1fe$export$89c2533b29c23a61), (0, $20db941dacece1fe$export$89c2533b29c23a61), 27);
        if (typeof sig === "string") {
            const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $1ec7d3acfcdcd7a6$export$848620f5f2f26e86($1ec7d3acfcdcd7a6$var$_guard, r, (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $1ec7d3acfcdcd7a6$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $1ec7d3acfcdcd7a6$export$848620f5f2f26e86($1ec7d3acfcdcd7a6$var$_guard, r, (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $1ec7d3acfcdcd7a6$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $1ec7d3acfcdcd7a6$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $1ec7d3acfcdcd7a6$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $85f03119331e3531$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $85f03119331e3531$export$a3521add2594f3c8)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(_v);
                return {
                    networkV: v >= $1ec7d3acfcdcd7a6$var$BN_35 ? v : undefined,
                    v: $1ec7d3acfcdcd7a6$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $85f03119331e3531$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $85f03119331e3531$export$a3521add2594f3c8)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $7769476213c187e3$export$b14f2714108df84)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $1ec7d3acfcdcd7a6$export$848620f5f2f26e86($1ec7d3acfcdcd7a6$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $7769476213c187e3$export$b14f2714108df84)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}


class $da5509008f9e5216$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$2321cd91b99770ff)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $da5509008f9e5216$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $da5509008f9e5216$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $ae4c2da7f42c597b$exports.secp256k1).sign((0, $85f03119331e3531$export$37110e7fee0af4ad)(digest), (0, $85f03119331e3531$export$37110e7fee0af4ad)(this.#privateKey), {
            lowS: true
        });
        return (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from({
            r: (0, $7769476213c187e3$export$c6ebe05badb16181)(sig.r, 32),
            s: (0, $7769476213c187e3$export$c6ebe05badb16181)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $da5509008f9e5216$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)((0, $ae4c2da7f42c597b$exports.secp256k1).getSharedSecret((0, $85f03119331e3531$export$37110e7fee0af4ad)(this.#privateKey), (0, $85f03119331e3531$export$a3521add2594f3c8)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $ae4c2da7f42c597b$exports.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $ae4c2da7f42c597b$exports.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from(signature);
        let secpSig = (0, $ae4c2da7f42c597b$exports.secp256k1).Signature.fromCompact((0, $85f03119331e3531$export$37110e7fee0af4ad)((0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $85f03119331e3531$export$37110e7fee0af4ad)(digest));
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $ae4c2da7f42c597b$exports.secp256k1).ProjectivePoint.fromHex($da5509008f9e5216$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $ae4c2da7f42c597b$exports.secp256k1).ProjectivePoint.fromHex($da5509008f9e5216$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}



/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $6529911ff832702f$export$6a9f04c98a658ecb() {
    (0, $f78b538281db0a48$export$967075d2f3b8e7ff).lock();
    (0, $39fe7f3d73992d01$export$f8151fce47ad1c35).lock();
    (0, $a8288d4c192ce0a6$export$448fa22aedc9dbca).lock();
    (0, $2c4ecb7a2d76f909$export$5f828d93ff035aa8).lock();
    (0, $799945d864146a10$export$d1cea0ee4e3f0d3e).lock();
    (0, $d8bab4d659173428$export$7cf7c2f1ec457bf3).lock();
    (0, $d8bab4d659173428$export$86c79e0734c26a76).lock();
    (0, $8ffad2f5de44b604$export$bced8d2aada2d1c9).lock();
    (0, $8ffad2f5de44b604$export$a888d2532e6dc7bb).lock();
    (0, $2c4ecb7a2d76f909$export$5f828d93ff035aa8).lock();
}



const $0dc837b8e002cdcf$var$BN_0 = BigInt(0);
const $0dc837b8e002cdcf$var$BN_36 = BigInt(36);
function $0dc837b8e002cdcf$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $85f03119331e3531$export$a3521add2594f3c8)((0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $0dc837b8e002cdcf$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$0dc837b8e002cdcf$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$0dc837b8e002cdcf$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $0dc837b8e002cdcf$var$safeDigits = 15;
function $0dc837b8e002cdcf$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $0dc837b8e002cdcf$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $0dc837b8e002cdcf$var$safeDigits){
        let block = expanded.substring(0, $0dc837b8e002cdcf$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $0dc837b8e002cdcf$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $0dc837b8e002cdcf$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $0dc837b8e002cdcf$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $0dc837b8e002cdcf$var$BN_36 + $0dc837b8e002cdcf$var$Base36[value[i]];
    return result;
}
function $0dc837b8e002cdcf$export$88411125f012957a(address) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $0dc837b8e002cdcf$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(address.substring(2, 4) === $0dc837b8e002cdcf$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $0dc837b8e002cdcf$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $0dc837b8e002cdcf$var$getChecksumAddress("0x" + result);
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid address", "address", address);
}
function $0dc837b8e002cdcf$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($0dc837b8e002cdcf$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $0dc837b8e002cdcf$var$ibanChecksum("XE00" + base36) + base36;
}



/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
const $38063da3e67ecce9$var$_gaurd = {};
function $38063da3e67ecce9$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $38063da3e67ecce9$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $38063da3e67ecce9$var$_typedSymbol = Symbol.for("_ethers_typed");
class $38063da3e67ecce9$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $205dffdfdb79d607$export$ac1a938d48ec8c7b)($38063da3e67ecce9$var$_gaurd, gaurd, "Typed");
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            _typedSymbol: $38063da3e67ecce9$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $38063da3e67ecce9$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $38063da3e67ecce9$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $38063da3e67ecce9$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $38063da3e67ecce9$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $38063da3e67ecce9$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $38063da3e67ecce9$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $38063da3e67ecce9$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $38063da3e67ecce9$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $38063da3e67ecce9$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $38063da3e67ecce9$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $38063da3e67ecce9$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $38063da3e67ecce9$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $38063da3e67ecce9$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $38063da3e67ecce9$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $38063da3e67ecce9$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $38063da3e67ecce9$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $38063da3e67ecce9$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $38063da3e67ecce9$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $38063da3e67ecce9$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $38063da3e67ecce9$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $38063da3e67ecce9$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $38063da3e67ecce9$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $38063da3e67ecce9$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $38063da3e67ecce9$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $38063da3e67ecce9$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $38063da3e67ecce9$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $38063da3e67ecce9$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $38063da3e67ecce9$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $38063da3e67ecce9$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $38063da3e67ecce9$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $38063da3e67ecce9$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $38063da3e67ecce9$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $38063da3e67ecce9$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $38063da3e67ecce9$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $38063da3e67ecce9$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $38063da3e67ecce9$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $38063da3e67ecce9$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $38063da3e67ecce9$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $38063da3e67ecce9$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $38063da3e67ecce9$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $38063da3e67ecce9$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $38063da3e67ecce9$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $38063da3e67ecce9$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $38063da3e67ecce9$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $38063da3e67ecce9$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $38063da3e67ecce9$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $38063da3e67ecce9$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $38063da3e67ecce9$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $38063da3e67ecce9$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $38063da3e67ecce9$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $38063da3e67ecce9$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $38063da3e67ecce9$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $38063da3e67ecce9$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $38063da3e67ecce9$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $38063da3e67ecce9$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $38063da3e67ecce9$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $38063da3e67ecce9$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $38063da3e67ecce9$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $38063da3e67ecce9$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $38063da3e67ecce9$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $38063da3e67ecce9$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $38063da3e67ecce9$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $38063da3e67ecce9$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $38063da3e67ecce9$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $38063da3e67ecce9$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $38063da3e67ecce9$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $38063da3e67ecce9$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $38063da3e67ecce9$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $38063da3e67ecce9$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $38063da3e67ecce9$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $38063da3e67ecce9$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $38063da3e67ecce9$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $38063da3e67ecce9$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $38063da3e67ecce9$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $38063da3e67ecce9$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $38063da3e67ecce9$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $38063da3e67ecce9$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $38063da3e67ecce9$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $38063da3e67ecce9$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $38063da3e67ecce9$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $38063da3e67ecce9$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $38063da3e67ecce9$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $38063da3e67ecce9$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $38063da3e67ecce9$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $38063da3e67ecce9$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $38063da3e67ecce9$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $38063da3e67ecce9$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $38063da3e67ecce9$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $38063da3e67ecce9$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $38063da3e67ecce9$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $38063da3e67ecce9$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $38063da3e67ecce9$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $38063da3e67ecce9$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $38063da3e67ecce9$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $38063da3e67ecce9$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $38063da3e67ecce9$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $38063da3e67ecce9$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $38063da3e67ecce9$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $38063da3e67ecce9$export$af51273277efe223($38063da3e67ecce9$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $38063da3e67ecce9$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($38063da3e67ecce9$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}



class $f34ab564bd112356$export$59dbbded7775bfe7 extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, "string");
        try {
            value = (0, $0dc837b8e002cdcf$export$88411125f012957a)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $0dc837b8e002cdcf$export$88411125f012957a)((0, $7769476213c187e3$export$c6ebe05badb16181)(reader.readValue(), 20));
    }
}






class $39676dd2631345ec$export$87c41d1139a03fa2 extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


function $b21e82f9b00a6a1f$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid tuple value", "tuple", values);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $43101f4b6dfefe01$export$d7a960146e1a269e)();
    let dynamicWriter = new (0, $43101f4b6dfefe01$export$d7a960146e1a269e)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $b21e82f9b00a6a1f$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $43101f4b6dfefe01$export$8fdcabde73f49165).fromItems(values, keys);
}
class $b21e82f9b00a6a1f$export$88bc419d2df11f54 extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $205dffdfdb79d607$export$d228410a8a77e4fa)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $b21e82f9b00a6a1f$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(count * (0, $43101f4b6dfefe01$export$b4b1d1fba463e69c) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $43101f4b6dfefe01$export$b4b1d1fba463e69c),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $39676dd2631345ec$export$87c41d1139a03fa2)(this.coder));
        return $b21e82f9b00a6a1f$export$417857010dc9287f(reader, coders);
    }
}




class $a30975de513d657f$export$fe9118d6c093150c extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}




class $973c09a399749cd0$export$db9eadd8df12ad2e extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $85f03119331e3531$export$37110e7fee0af4ad)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $973c09a399749cd0$export$e5823e9574df18d2 extends $973c09a399749cd0$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(super.decode(reader));
    }
}





class $82d324331ea295f4$export$7dec9db68e6bcf5a extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $85f03119331e3531$export$37110e7fee0af4ad)((0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(reader.readBytes(this.size));
    }
}



const $ada2ec50df0a1e6c$var$Empty = new Uint8Array([]);
class $ada2ec50df0a1e6c$export$70982cadf2d6b4ec extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($ada2ec50df0a1e6c$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}





const $050330b30da2c85a$var$BN_0 = BigInt(0);
const $050330b30da2c85a$var$BN_1 = BigInt(1);
const $050330b30da2c85a$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $050330b30da2c85a$export$b934dc8cfe13938c extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)((0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $7769476213c187e3$export$d99f0801a68bbcf1)($050330b30da2c85a$var$BN_MAX_UINT256, (0, $43101f4b6dfefe01$export$b4b1d1fba463e69c) * 8);
        if (this.signed) {
            let bounds = (0, $7769476213c187e3$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $050330b30da2c85a$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $7769476213c187e3$export$7101cd4e6275351c)(value, 8 * (0, $43101f4b6dfefe01$export$b4b1d1fba463e69c));
        } else if (value < $050330b30da2c85a$var$BN_0 || value > (0, $7769476213c187e3$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $7769476213c187e3$export$d99f0801a68bbcf1)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $7769476213c187e3$export$92182edcfa20e5bc)(value, this.size * 8);
        return value;
    }
}


/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $69bdbe979c9bc699$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $69bdbe979c9bc699$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $69bdbe979c9bc699$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $69bdbe979c9bc699$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $69bdbe979c9bc699$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $69bdbe979c9bc699$var$errorFunc,
    ignore: $69bdbe979c9bc699$var$ignoreFunc,
    replace: $69bdbe979c9bc699$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $69bdbe979c9bc699$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $69bdbe979c9bc699$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $69bdbe979c9bc699$export$8feeb310b4b4752f(str, form) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $205dffdfdb79d607$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $69bdbe979c9bc699$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $69bdbe979c9bc699$export$7643a1dc2c38d5eb(bytes, onError) {
    return $69bdbe979c9bc699$var$_toUtf8String($69bdbe979c9bc699$var$getUtf8CodePoints(bytes, onError));
}
function $69bdbe979c9bc699$export$ae470a36a31b28c2(str, form) {
    return $69bdbe979c9bc699$var$getUtf8CodePoints($69bdbe979c9bc699$export$8feeb310b4b4752f(str, form));
}




class $0620d250f7d34dbd$export$2d1b854518731426 extends (0, $973c09a399749cd0$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)((0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $69bdbe979c9bc699$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}






class $da1117cab86dad59$export$e9fceba8f110fea6 extends (0, $43101f4b6dfefe01$export$2c0c39526f8bad46) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $38063da3e67ecce9$export$af51273277efe223).dereference(_value, "tuple");
        return (0, $b21e82f9b00a6a1f$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $b21e82f9b00a6a1f$export$417857010dc9287f)(reader, this.coders);
    }
}


/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 


function $c936c455cfdb29e8$export$d560c7e4a29451c2(value) {
    return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)((0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(value));
}


// [ "a", "b" ] => { "a": 1, "b": 1 }
function $d6845a35e66ab971$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $d6845a35e66ab971$var$_kwVisibDeploy = "external public payable override";
const $d6845a35e66ab971$var$KwVisibDeploy = $d6845a35e66ab971$var$setify($d6845a35e66ab971$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $d6845a35e66ab971$var$_kwVisib = "constant external internal payable private public pure view override";
const $d6845a35e66ab971$var$KwVisib = $d6845a35e66ab971$var$setify($d6845a35e66ab971$var$_kwVisib.split(" "));
const $d6845a35e66ab971$var$_kwTypes = "constructor error event fallback function receive struct";
const $d6845a35e66ab971$var$KwTypes = $d6845a35e66ab971$var$setify($d6845a35e66ab971$var$_kwTypes.split(" "));
const $d6845a35e66ab971$var$_kwModifiers = "calldata memory storage payable indexed";
const $d6845a35e66ab971$var$KwModifiers = $d6845a35e66ab971$var$setify($d6845a35e66ab971$var$_kwModifiers.split(" "));
const $d6845a35e66ab971$var$_kwOther = "tuple returns";
// All Keywords
const $d6845a35e66ab971$var$_keywords = [
    $d6845a35e66ab971$var$_kwTypes,
    $d6845a35e66ab971$var$_kwModifiers,
    $d6845a35e66ab971$var$_kwOther,
    $d6845a35e66ab971$var$_kwVisib
].join(" ");
const $d6845a35e66ab971$var$Keywords = $d6845a35e66ab971$var$setify($d6845a35e66ab971$var$_keywords.split(" "));
// Single character tokens
const $d6845a35e66ab971$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $d6845a35e66ab971$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $d6845a35e66ab971$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $d6845a35e66ab971$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $d6845a35e66ab971$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $d6845a35e66ab971$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $d6845a35e66ab971$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $d6845a35e66ab971$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $d6845a35e66ab971$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $d6845a35e66ab971$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($d6845a35e66ab971$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $d6845a35e66ab971$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $7769476213c187e3$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($d6845a35e66ab971$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($d6845a35e66ab971$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($d6845a35e66ab971$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($d6845a35e66ab971$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $d6845a35e66ab971$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $d6845a35e66ab971$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $d6845a35e66ab971$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($d6845a35e66ab971$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $d6845a35e66ab971$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $d6845a35e66ab971$var$consumeMutability(tokens) {
    let modifiers = $d6845a35e66ab971$var$consumeKeywords(tokens, $d6845a35e66ab971$var$KwVisib);
    // Detect conflicting modifiers
    $d6845a35e66ab971$var$allowSingle(modifiers, $d6845a35e66ab971$var$setify("constant payable nonpayable".split(" ")));
    $d6845a35e66ab971$var$allowSingle(modifiers, $d6845a35e66ab971$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $d6845a35e66ab971$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$d6845a35e66ab971$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $d6845a35e66ab971$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $d6845a35e66ab971$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $d6845a35e66ab971$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $d6845a35e66ab971$var$verifyBasicType(type) {
    const match = type.match($d6845a35e66ab971$var$regexType);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $d6845a35e66ab971$var$_guard = {};
const $d6845a35e66ab971$var$internal = Symbol.for("_ethers_internal");
const $d6845a35e66ab971$var$ParamTypeInternal = "_ParamTypeInternal";
const $d6845a35e66ab971$var$ErrorFragmentInternal = "_ErrorInternal";
const $d6845a35e66ab971$var$EventFragmentInternal = "_EventInternal";
const $d6845a35e66ab971$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $d6845a35e66ab971$var$FallbackFragmentInternal = "_FallbackInternal";
const $d6845a35e66ab971$var$FunctionFragmentInternal = "_FunctionInternal";
const $d6845a35e66ab971$var$StructFragmentInternal = "_StructInternal";
class $d6845a35e66ab971$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $205dffdfdb79d607$export$ac1a938d48ec8c7b)(guard, $d6845a35e66ab971$var$_guard, "ParamType");
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($d6845a35e66ab971$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $d6845a35e66ab971$export$426dc07f493a4c47.from($d6845a35e66ab971$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$d6845a35e66ab971$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $d6845a35e66ab971$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $d6845a35e66ab971$export$426dc07f493a4c47($d6845a35e66ab971$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $d6845a35e66ab971$export$426dc07f493a4c47($d6845a35e66ab971$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($d6845a35e66ab971$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($d6845a35e66ab971$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $d6845a35e66ab971$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $d6845a35e66ab971$export$426dc07f493a4c47($d6845a35e66ab971$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$d6845a35e66ab971$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $d6845a35e66ab971$export$426dc07f493a4c47($d6845a35e66ab971$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $d6845a35e66ab971$var$verifyBasicType(obj.type);
        return new $d6845a35e66ab971$export$426dc07f493a4c47($d6845a35e66ab971$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$ParamTypeInternal;
    }
}
class $d6845a35e66ab971$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $205dffdfdb79d607$export$ac1a938d48ec8c7b)(guard, $d6845a35e66ab971$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $d6845a35e66ab971$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $d6845a35e66ab971$export$ffb0004e005737fa.from($d6845a35e66ab971$var$lex(obj));
        }
        if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($d6845a35e66ab971$var$KwTypes);
            switch(type){
                case "constructor":
                    return $d6845a35e66ab971$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $d6845a35e66ab971$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $d6845a35e66ab971$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $d6845a35e66ab971$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $d6845a35e66ab971$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $d6845a35e66ab971$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $d6845a35e66ab971$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $d6845a35e66ab971$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $d6845a35e66ab971$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $d6845a35e66ab971$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $d6845a35e66ab971$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $d6845a35e66ab971$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $d6845a35e66ab971$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $d6845a35e66ab971$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $d6845a35e66ab971$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $d6845a35e66ab971$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $d6845a35e66ab971$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $d6845a35e66ab971$export$85c6fc53d6299173 extends $d6845a35e66ab971$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof name === "string" && name.match($d6845a35e66ab971$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $d6845a35e66ab971$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $d6845a35e66ab971$export$2c42c6d543aa9b59 extends $d6845a35e66ab971$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $d6845a35e66ab971$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($d6845a35e66ab971$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $d6845a35e66ab971$export$2c42c6d543aa9b59.from($d6845a35e66ab971$var$lex(obj));
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            const name = $d6845a35e66ab971$var$consumeName("error", obj);
            const inputs = $d6845a35e66ab971$var$consumeParams(obj);
            $d6845a35e66ab971$var$consumeEoi(obj);
            return new $d6845a35e66ab971$export$2c42c6d543aa9b59($d6845a35e66ab971$var$_guard, name, inputs);
        }
        return new $d6845a35e66ab971$export$2c42c6d543aa9b59($d6845a35e66ab971$var$_guard, obj.name, obj.inputs ? obj.inputs.map($d6845a35e66ab971$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$ErrorFragmentInternal;
    }
}
class $d6845a35e66ab971$export$958548f08bac2833 extends $d6845a35e66ab971$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$EventFragmentInternal
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $d6845a35e66ab971$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$d6845a35e66ab971$export$426dc07f493a4c47.from(p));
        const fragment = new $d6845a35e66ab971$export$958548f08bac2833($d6845a35e66ab971$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($d6845a35e66ab971$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $d6845a35e66ab971$export$958548f08bac2833.from($d6845a35e66ab971$var$lex(obj));
        } catch (error) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            const name = $d6845a35e66ab971$var$consumeName("event", obj);
            const inputs = $d6845a35e66ab971$var$consumeParams(obj, true);
            const anonymous = !!$d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$setify([
                "anonymous"
            ])).has("anonymous");
            $d6845a35e66ab971$var$consumeEoi(obj);
            return new $d6845a35e66ab971$export$958548f08bac2833($d6845a35e66ab971$var$_guard, name, inputs, anonymous);
        }
        return new $d6845a35e66ab971$export$958548f08bac2833($d6845a35e66ab971$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$d6845a35e66ab971$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$EventFragmentInternal;
    }
}
class $d6845a35e66ab971$export$3ac5c9504f801ea4 extends $d6845a35e66ab971$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$ConstructorFragmentInternal
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$d6845a35e66ab971$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($d6845a35e66ab971$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $d6845a35e66ab971$export$3ac5c9504f801ea4.from($d6845a35e66ab971$var$lex(obj));
        } catch (error) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            $d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$setify([
                "constructor"
            ]));
            const inputs = $d6845a35e66ab971$var$consumeParams(obj);
            const payable = !!$d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$KwVisibDeploy).has("payable");
            const gas = $d6845a35e66ab971$var$consumeGas(obj);
            $d6845a35e66ab971$var$consumeEoi(obj);
            return new $d6845a35e66ab971$export$3ac5c9504f801ea4($d6845a35e66ab971$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $d6845a35e66ab971$export$3ac5c9504f801ea4($d6845a35e66ab971$var$_guard, "constructor", obj.inputs ? obj.inputs.map($d6845a35e66ab971$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$ConstructorFragmentInternal;
    }
}
class $d6845a35e66ab971$export$71b1ea64c89c20fc extends $d6845a35e66ab971$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$FallbackFragmentInternal
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($d6845a35e66ab971$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $d6845a35e66ab971$export$71b1ea64c89c20fc.from($d6845a35e66ab971$var$lex(obj));
        } catch (error) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($d6845a35e66ab971$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($d6845a35e66ab971$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $d6845a35e66ab971$var$consumeParams(obj);
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$setify([
                    "payable"
                ]));
                $d6845a35e66ab971$var$consumeEoi(obj);
                return new $d6845a35e66ab971$export$71b1ea64c89c20fc($d6845a35e66ab971$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $d6845a35e66ab971$var$consumeParams(obj);
            if (inputs.length) (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $d6845a35e66ab971$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $d6845a35e66ab971$var$consumeMutability(obj);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $d6845a35e66ab971$var$consumeParams(obj);
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $d6845a35e66ab971$var$consumeEoi(obj);
            return new $d6845a35e66ab971$export$71b1ea64c89c20fc($d6845a35e66ab971$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $d6845a35e66ab971$export$71b1ea64c89c20fc($d6845a35e66ab971$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $d6845a35e66ab971$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $d6845a35e66ab971$export$71b1ea64c89c20fc($d6845a35e66ab971$var$_guard, inputs, payable);
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$FallbackFragmentInternal;
    }
}
class $d6845a35e66ab971$export$8d576c928b93668f extends $d6845a35e66ab971$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $d6845a35e66ab971$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($d6845a35e66ab971$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$d6845a35e66ab971$export$426dc07f493a4c47.from(p));
        const fragment = new $d6845a35e66ab971$export$8d576c928b93668f($d6845a35e66ab971$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($d6845a35e66ab971$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $d6845a35e66ab971$export$8d576c928b93668f.from($d6845a35e66ab971$var$lex(obj));
        } catch (error) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            const name = $d6845a35e66ab971$var$consumeName("function", obj);
            const inputs = $d6845a35e66ab971$var$consumeParams(obj);
            const mutability = $d6845a35e66ab971$var$consumeMutability(obj);
            let outputs = [];
            if ($d6845a35e66ab971$var$consumeKeywords(obj, $d6845a35e66ab971$var$setify([
                "returns"
            ])).has("returns")) outputs = $d6845a35e66ab971$var$consumeParams(obj);
            const gas = $d6845a35e66ab971$var$consumeGas(obj);
            $d6845a35e66ab971$var$consumeEoi(obj);
            return new $d6845a35e66ab971$export$8d576c928b93668f($d6845a35e66ab971$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $d6845a35e66ab971$export$8d576c928b93668f($d6845a35e66ab971$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($d6845a35e66ab971$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($d6845a35e66ab971$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$FunctionFragmentInternal;
    }
}
class $d6845a35e66ab971$export$9f91ba10bb234ec7 extends $d6845a35e66ab971$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $d6845a35e66ab971$var$internal, {
            value: $d6845a35e66ab971$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $d6845a35e66ab971$export$9f91ba10bb234ec7.from($d6845a35e66ab971$var$lex(obj));
        } catch (error) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $d6845a35e66ab971$var$TokenString) {
            const name = $d6845a35e66ab971$var$consumeName("struct", obj);
            const inputs = $d6845a35e66ab971$var$consumeParams(obj);
            $d6845a35e66ab971$var$consumeEoi(obj);
            return new $d6845a35e66ab971$export$9f91ba10bb234ec7($d6845a35e66ab971$var$_guard, name, inputs);
        }
        return new $d6845a35e66ab971$export$9f91ba10bb234ec7($d6845a35e66ab971$var$_guard, obj.name, obj.inputs ? obj.inputs.map($d6845a35e66ab971$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$d6845a35e66ab971$var$internal] === $d6845a35e66ab971$var$StructFragmentInternal;
    }
}



// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $7c4fa628ce8062db$var$PanicReasons = new Map();
$7c4fa628ce8062db$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$7c4fa628ce8062db$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$7c4fa628ce8062db$var$PanicReasons.set(0x11, "OVERFLOW");
$7c4fa628ce8062db$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$7c4fa628ce8062db$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$7c4fa628ce8062db$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$7c4fa628ce8062db$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$7c4fa628ce8062db$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$7c4fa628ce8062db$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$7c4fa628ce8062db$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $7c4fa628ce8062db$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $7c4fa628ce8062db$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $7c4fa628ce8062db$var$defaultCoder = null;
let $7c4fa628ce8062db$var$defaultMaxInflation = 1024;
function $7c4fa628ce8062db$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(data);
        data = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$7c4fa628ce8062db$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $0dc837b8e002cdcf$export$88411125f012957a)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $0dc837b8e002cdcf$export$88411125f012957a)(tx.from);
    return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $7c4fa628ce8062db$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $b21e82f9b00a6a1f$export$88bc419d2df11f54)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $da1117cab86dad59$export$e9fceba8f110fea6)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $f34ab564bd112356$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $a30975de513d657f$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $0620d250f7d34dbd$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $973c09a399749cd0$export$e5823e9574df18d2)(param.name);
            case "":
                return new (0, $ada2ec50df0a1e6c$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($7c4fa628ce8062db$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $050330b30da2c85a$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($7c4fa628ce8062db$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $82d324331ea295f4$export$7dec9db68e6bcf5a)(size, param.name);
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $d6845a35e66ab971$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $da1117cab86dad59$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $205dffdfdb79d607$export$d228410a8a77e4fa)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $d6845a35e66ab971$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $da1117cab86dad59$export$e9fceba8f110fea6)(coders, "_");
        const writer = new (0, $43101f4b6dfefe01$export$d7a960146e1a269e)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $d6845a35e66ab971$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $da1117cab86dad59$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(new (0, $43101f4b6dfefe01$export$2f7a2f0e90c07dc4)(data, loose, $7c4fa628ce8062db$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $7c4fa628ce8062db$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($7c4fa628ce8062db$var$defaultCoder == null) $7c4fa628ce8062db$var$defaultCoder = new $7c4fa628ce8062db$export$fe041e1a83d3efc6();
        return $7c4fa628ce8062db$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $7c4fa628ce8062db$var$getBuiltinCallException(action, tx, data, $7c4fa628ce8062db$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}




function $468ec04bb3c62bc6$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $468ec04bb3c62bc6$export$977e255126d763d6(value) {
    try {
        (0, $0dc837b8e002cdcf$export$88411125f012957a)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $468ec04bb3c62bc6$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $0dc837b8e002cdcf$export$88411125f012957a)(result);
}
function $468ec04bb3c62bc6$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $0dc837b8e002cdcf$export$88411125f012957a)(target);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $468ec04bb3c62bc6$var$checkAddress(target, resolver.resolveName(target));
    } else if ($468ec04bb3c62bc6$export$6a88e03bca5eb759(target)) return $468ec04bb3c62bc6$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $468ec04bb3c62bc6$var$checkAddress(target, target);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported addressable value", "target", target);
}


//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";




function $5018792530a66b37$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $da5509008f9e5216$export$21643ca94aed3e83).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $0dc837b8e002cdcf$export$88411125f012957a)((0, $39fe7f3d73992d01$export$f8151fce47ad1c35)("0x" + pubkey.substring(4)).substring(26));
}
function $5018792530a66b37$export$23cc18f96d8510e2(digest, signature) {
    return $5018792530a66b37$export$e67e2732ba9803f9((0, $da5509008f9e5216$export$21643ca94aed3e83).recoverPublicKey(digest, signature));
}




const $8326517c6a9958df$var$padding = new Uint8Array(32);
$8326517c6a9958df$var$padding.fill(0);
const $8326517c6a9958df$var$BN__1 = BigInt(-1);
const $8326517c6a9958df$var$BN_0 = BigInt(0);
const $8326517c6a9958df$var$BN_1 = BigInt(1);
const $8326517c6a9958df$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $8326517c6a9958df$var$hexPadRight(value) {
    const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        bytes,
        $8326517c6a9958df$var$padding.slice(padOffset)
    ]);
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes);
}
const $8326517c6a9958df$var$hexTrue = (0, $7769476213c187e3$export$c6ebe05badb16181)($8326517c6a9958df$var$BN_1, 32);
const $8326517c6a9958df$var$hexFalse = (0, $7769476213c187e3$export$c6ebe05badb16181)($8326517c6a9958df$var$BN_0, 32);
const $8326517c6a9958df$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $8326517c6a9958df$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $8326517c6a9958df$var$checkString(key) {
    return function(value) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $8326517c6a9958df$var$domainChecks = {
    name: $8326517c6a9958df$var$checkString("name"),
    version: $8326517c6a9958df$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(_value, "domain.chainId");
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $7769476213c187e3$export$d9c067986dbc68dd)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $0dc837b8e002cdcf$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(value, "domain.salt");
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes);
    }
};
function $8326517c6a9958df$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $7769476213c187e3$export$d99f0801a68bbcf1)($8326517c6a9958df$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $8326517c6a9958df$var$BN_1) * $8326517c6a9958df$var$BN__1 : $8326517c6a9958df$var$BN_0;
            return function(_value) {
                const value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(_value, "value");
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $7769476213c187e3$export$c6ebe05badb16181)(signed ? (0, $7769476213c187e3$export$7101cd4e6275351c)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(value);
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $8326517c6a9958df$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $85f03119331e3531$export$4473860254365feb)((0, $0dc837b8e002cdcf$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $8326517c6a9958df$var$hexFalse : $8326517c6a9958df$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $8326517c6a9958df$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $8326517c6a9958df$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $8326517c6a9958df$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $8326517c6a9958df$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $8326517c6a9958df$var$splitArray(field.type).base;
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $8326517c6a9958df$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $8326517c6a9958df$var$encodeType(name, types[name]) + st.map((t)=>$8326517c6a9958df$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $8326517c6a9958df$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $8326517c6a9958df$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $39fe7f3d73992d01$export$f8151fce47ad1c35));
                return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)((0, $85f03119331e3531$export$ee1b3e54f0441b22)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $85f03119331e3531$export$ee1b3e54f0441b22)(values);
            };
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $8326517c6a9958df$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $8326517c6a9958df$var$splitArray(type).array;
        if (array) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $8326517c6a9958df$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $8326517c6a9958df$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $8326517c6a9958df$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $8326517c6a9958df$var$domainFieldTypes[name];
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $8326517c6a9958df$var$domainFieldNames.indexOf(a.name) - $8326517c6a9958df$var$domainFieldNames.indexOf(b.name);
        });
        return $8326517c6a9958df$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            "0x1901",
            $8326517c6a9958df$export$458ab927ae635c3.hashDomain(domain),
            $8326517c6a9958df$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)($8326517c6a9958df$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $85f03119331e3531$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $8326517c6a9958df$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $85f03119331e3531$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $8326517c6a9958df$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $8326517c6a9958df$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $8326517c6a9958df$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $8326517c6a9958df$var$domainFieldTypes[name]
            });
        });
        const encoder = $8326517c6a9958df$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)((0, $85f03119331e3531$export$a3521add2594f3c8)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $8326517c6a9958df$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $5018792530a66b37$export$23cc18f96d8510e2)($8326517c6a9958df$export$458ab927ae635c3.hash(domain, types, value), signature);
}




function $54c23e469e18e47c$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $0dc837b8e002cdcf$export$88411125f012957a)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $54c23e469e18e47c$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $54c23e469e18e47c$var$accessSetify(set[0], set[1]);
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $54c23e469e18e47c$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $54c23e469e18e47c$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}


/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ // utils/base64-browser

function $409185b5921fc271$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $85f03119331e3531$export$a3521add2594f3c8)(data);
}
function $409185b5921fc271$export$8fb536984ec8b4d7(_data) {
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}







function $82e3aa879e3826dd$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(_signal == null || !_signal.cancelled, "request cancelled before sending", "CANCELLED");
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let error = null;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            error = (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("request timeout", "TIMEOUT");
            controller.abort();
        }, req.timeout);
        if (_signal) _signal.addListener(()=>{
            error = (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("request cancelled", "CANCELLED");
            controller.abort();
        });
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: controller.signal
        };
        let resp;
        try {
            resp = await fetch(req.url, init);
        } catch (_error) {
            clearTimeout(timer);
            if (error) throw error;
            throw _error;
        }
        clearTimeout(timer);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $82e3aa879e3826dd$var$defaultGetUrl = $82e3aa879e3826dd$export$d3950daf7bce5bf5({});
async function $82e3aa879e3826dd$export$94df0e59ebebf4a7(req, _signal) {
    return $82e3aa879e3826dd$var$defaultGetUrl(req, _signal);
}


const $3e6e83ce717e67cd$var$MAX_ATTEMPTS = 12;
const $3e6e83ce717e67cd$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $3e6e83ce717e67cd$var$defaultGetUrlFunc = (0, $82e3aa879e3826dd$export$d3950daf7bce5bf5)();
const $3e6e83ce717e67cd$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $3e6e83ce717e67cd$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $3e6e83ce717e67cd$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $3e6e83ce717e67cd$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($3e6e83ce717e67cd$var$reData);
        if (!match) throw new Error("invalid data");
        return new $3e6e83ce717e67cd$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $409185b5921fc271$export$94fdf11bafc8de6b)(match[3]) : $3e6e83ce717e67cd$var$unpercent(match[3]));
    } catch (error) {
        return new $3e6e83ce717e67cd$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $3e6e83ce717e67cd$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $3e6e83ce717e67cd$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($3e6e83ce717e67cd$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $3e6e83ce717e67cd$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $3e6e83ce717e67cd$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $3e6e83ce717e67cd$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $3e6e83ce717e67cd$var$Gateways = {
    "data": $3e6e83ce717e67cd$var$dataGatewayFunc,
    "ipfs": $3e6e83ce717e67cd$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $3e6e83ce717e67cd$var$fetchSignals = new WeakMap();
class $3e6e83ce717e67cd$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $3e6e83ce717e67cd$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $3e6e83ce717e67cd$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $3e6e83ce717e67cd$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $409185b5921fc271$export$8fb536984ec8b4d7)((0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $3e6e83ce717e67cd$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $3e6e83ce717e67cd$var$SLOT_INTERVAL,
            maxAttempts: $3e6e83ce717e67cd$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($3e6e83ce717e67cd$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $3e6e83ce717e67cd$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $3e6e83ce717e67cd$var$Gateways) {
            const result = await $3e6e83ce717e67cd$var$Gateways[scheme](req.url, $3e6e83ce717e67cd$var$checkSignal(_request.#signal));
            if (result instanceof $3e6e83ce717e67cd$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $3e6e83ce717e67cd$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $3e6e83ce717e67cd$var$checkSignal(_request.#signal));
        let response = new $3e6e83ce717e67cd$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $3e6e83ce717e67cd$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $3e6e83ce717e67cd$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $3e6e83ce717e67cd$var$getTime() + this.timeout, 0, this, new $3e6e83ce717e67cd$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $3e6e83ce717e67cd$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $3e6e83ce717e67cd$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $3e6e83ce717e67cd$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#throttle = Object.assign({}, this.#throttle);
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $3e6e83ce717e67cd$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $3e6e83ce717e67cd$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($3e6e83ce717e67cd$var$locked) throw new Error("gateways locked");
        $3e6e83ce717e67cd$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($3e6e83ce717e67cd$var$locked) throw new Error("gateways locked");
        $3e6e83ce717e67cd$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $82e3aa879e3826dd$export$d3950daf7bce5bf5)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $3e6e83ce717e67cd$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $3e6e83ce717e67cd$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $3e6e83ce717e67cd$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $69bdbe979c9bc699$export$7643a1dc2c38d5eb)(this.#body);
        } catch (error) {
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $3e6e83ce717e67cd$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $69bdbe979c9bc699$export$7643a1dc2c38d5eb)(this.#body);
        } catch (e) {}
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $3e6e83ce717e67cd$var$getTime() {
    return new Date().getTime();
}
function $3e6e83ce717e67cd$var$unpercent(value) {
    return (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $3e6e83ce717e67cd$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}


/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $7675f23517409f7b$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";


/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ 






class $39ad8f5a46e38b19$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $39ad8f5a46e38b19$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $39ad8f5a46e38b19$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $39ad8f5a46e38b19$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $39ad8f5a46e38b19$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $39ad8f5a46e38b19$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $39ad8f5a46e38b19$var$PanicReasons[code.toString()]) reason = $39ad8f5a46e38b19$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $39ad8f5a46e38b19$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $d6845a35e66ab971$export$ffb0004e005737fa).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            deploy: (0, $d6845a35e66ab971$export$3ac5c9504f801ea4).from("constructor()")
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $7c4fa628ce8062db$export$fe041e1a83d3efc6).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $38063da3e67ecce9$export$af51273277efe223).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $38063da3e67ecce9$export$af51273277efe223).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $d6845a35e66ab971$export$8d576c928b93668f).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $38063da3e67ecce9$export$af51273277efe223).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $d6845a35e66ab971$export$958548f08bac2833).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            if ($39ad8f5a46e38b19$var$BuiltinErrors[selector]) return (0, $d6845a35e66ab971$export$2c42c6d543aa9b59).from($39ad8f5a46e38b19$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $d6845a35e66ab971$export$2c42c6d543aa9b59).from("error Error(string)");
                if (key === "Panic") return (0, $d6845a35e66ab971$export$2c42c6d543aa9b59).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $d6845a35e66ab971$export$2c42c6d543aa9b59).from(key).format();
        if (key === "Error(string)") return (0, $d6845a35e66ab971$export$2c42c6d543aa9b59).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $d6845a35e66ab971$export$2c42c6d543aa9b59).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $85f03119331e3531$export$37110e7fee0af4ad)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, message, "BAD_DATA", {
            value: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
        const error = (0, $7c4fa628ce8062db$export$fe041e1a83d3efc6).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)((0, $85f03119331e3531$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $7769476213c187e3$export$c6ebe05badb16181)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $85f03119331e3531$export$1dc7fbe1b8738fe7)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $85f03119331e3531$export$4473860254365feb)((0, $85f03119331e3531$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $c936c455cfdb29e8$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $d6845a35e66ab971$export$426dc07f493a4c47).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $85f03119331e3531$export$ee1b3e54f0441b22)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $39ad8f5a46e38b19$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $39ad8f5a46e38b19$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $43101f4b6dfefe01$export$8fdcabde73f49165).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(tx.data, "tx.data");
        const value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $39ad8f5a46e38b19$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $39ad8f5a46e38b19$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data);
        const fragment = this.getError((0, $85f03119331e3531$export$f6d845ffb449edc9)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $85f03119331e3531$export$f6d845ffb449edc9)(hexData, 4));
        return new $39ad8f5a46e38b19$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $39ad8f5a46e38b19$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $39ad8f5a46e38b19$export$48cefb51a4e315b2(JSON.parse(value));
        // An Interface; possibly from another v6 instance
        if (typeof value.formatJson === "function") return new $39ad8f5a46e38b19$export$48cefb51a4e315b2(value.formatJson());
        // A legacy Interface; from an older version
        if (typeof value.format === "function") return new $39ad8f5a46e38b19$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $39ad8f5a46e38b19$export$48cefb51a4e315b2(value);
    }
}



//import { resolveAddress } from "@ethersproject/address";


const $3d0b5969b3413cac$var$BN_0 = BigInt(0);
// -----------------------
function $3d0b5969b3413cac$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $3d0b5969b3413cac$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $3d0b5969b3413cac$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            gasPrice: $3d0b5969b3413cac$var$getValue(gasPrice),
            maxFeePerGas: $3d0b5969b3413cac$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $3d0b5969b3413cac$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $3d0b5969b3413cac$var$toJson(gasPrice),
            maxFeePerGas: $3d0b5969b3413cac$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $3d0b5969b3413cac$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $3d0b5969b3413cac$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $7769476213c187e3$export$b14f2714108df84)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $54c23e469e18e47c$export$6c8662b1600dce2)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    if ("blobVersionedHashes" in req && req.blobVersionedHashes) result.blobVersionedHashes = req.blobVersionedHashes.slice();
    if ("kzg" in req) result.kzg = req.kzg;
    if ("blobs" in req && req.blobs) result.blobs = req.blobs.map((b)=>{
        if ((0, $85f03119331e3531$export$9a14abb1a440cd5e)(b)) return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(b);
        return Object.assign({}, b);
    });
    return result;
}
class $3d0b5969b3413cac$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */ prevRandao;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $3d0b5969b3413cac$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            provider: provider,
            hash: $3d0b5969b3413cac$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            prevRandao: $3d0b5969b3413cac$var$getValue(block.prevRandao),
            extraData: block.extraData,
            baseFeePerGas: $3d0b5969b3413cac$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, prevRandao: prevRandao, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $3d0b5969b3413cac$var$toJson(baseFeePerGas),
            difficulty: $3d0b5969b3413cac$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $3d0b5969b3413cac$var$toJson(gasLimit),
            gasUsed: $3d0b5969b3413cac$var$toJson(gasUsed),
            blobGasUsed: $3d0b5969b3413cac$var$toJson(this.blobGasUsed),
            excessBlobGas: $3d0b5969b3413cac$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            prevRandao: prevRandao,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $3d0b5969b3413cac$var$createOrphanedBlockFilter(this);
    }
}
class $3d0b5969b3413cac$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $3d0b5969b3413cac$var$createRemovedLogFilter(this);
    }
}
class $3d0b5969b3413cac$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $3d0b5969b3413cac$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $3d0b5969b3413cac$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $3d0b5969b3413cac$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $3d0b5969b3413cac$var$toJson(this.gasPrice),
            blobGasUsed: $3d0b5969b3413cac$var$toJson(this.blobGasUsed),
            blobGasPrice: $3d0b5969b3413cac$var$toJson(this.blobGasPrice),
            gasUsed: $3d0b5969b3413cac$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $3d0b5969b3413cac$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $3d0b5969b3413cac$var$createReorderedTransactionFilter(this, other);
    }
}
class $3d0b5969b3413cac$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $3d0b5969b3413cac$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $3d0b5969b3413cac$var$toJson(this.gasLimit),
            gasPrice: $3d0b5969b3413cac$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $3d0b5969b3413cac$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $3d0b5969b3413cac$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $3d0b5969b3413cac$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $3d0b5969b3413cac$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $3d0b5969b3413cac$var$BN_0) reason = "cancelled";
                        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $3d0b5969b3413cac$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $3d0b5969b3413cac$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $3d0b5969b3413cac$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $3d0b5969b3413cac$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $3d0b5969b3413cac$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $3d0b5969b3413cac$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $3d0b5969b3413cac$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}



// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
class $736380c8f0fd32e2$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}


class $eafe7e37f600d478$export$f8203d08df5cd081 extends (0, $3d0b5969b3413cac$export$ce30dbb46644d06c) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $eafe7e37f600d478$export$53f6e6acc02bf489 extends (0, $3d0b5969b3413cac$export$ce30dbb46644d06c) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            error: error
        });
    }
}
class $eafe7e37f600d478$export$86bdc83e93503686 extends (0, $3d0b5969b3413cac$export$375ffd5683aa5c1c) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $eafe7e37f600d478$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $eafe7e37f600d478$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $eafe7e37f600d478$export$853f7e2df34220ff extends (0, $3d0b5969b3413cac$export$70966cdb3bfc0785) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $eafe7e37f600d478$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $eafe7e37f600d478$export$54be5ec94ad26a69 extends (0, $736380c8f0fd32e2$export$9cec82196983b278) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $eafe7e37f600d478$export$35f9272dc1c07dee extends $eafe7e37f600d478$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $eafe7e37f600d478$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}


const $f72016e2a99839eb$var$BN_0 = BigInt(0);
function $f72016e2a99839eb$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $f72016e2a99839eb$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $f72016e2a99839eb$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $f72016e2a99839eb$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $f72016e2a99839eb$var$getResolver(value) {
    if (value != null) {
        if ($f72016e2a99839eb$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $f72016e2a99839eb$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $f72016e2a99839eb$var$getRunner(contract.runner, "resolveName");
        const resolver = $f72016e2a99839eb$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $468ec04bb3c62bc6$export$687eed6b344123c9)(v, resolver)));
                        return (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $f72016e2a99839eb$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $f72016e2a99839eb$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $f72016e2a99839eb$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $38063da3e67ecce9$export$af51273277efe223).dereference(arg, "overrides");
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $3d0b5969b3413cac$export$607b34cdac162b7f)(_overrides);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $f72016e2a99839eb$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $f72016e2a99839eb$var$getRunner(_runner, "resolveName");
    const resolver = $f72016e2a99839eb$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $38063da3e67ecce9$export$af51273277efe223).dereference(value, type);
            if (type === "address") return (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(value, resolver);
            return value;
        });
    }));
}
function $f72016e2a99839eb$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $f72016e2a99839eb$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(tx.from, $f72016e2a99839eb$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(tx.value || $f72016e2a99839eb$var$BN_0, "overrides.value") === $f72016e2a99839eb$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $f72016e2a99839eb$var$getRunner(contract.runner, "call");
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($f72016e2a99839eb$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $205dffdfdb79d607$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($f72016e2a99839eb$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $f72016e2a99839eb$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $eafe7e37f600d478$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $f72016e2a99839eb$var$getRunner(contract.runner, "estimateGas");
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($f72016e2a99839eb$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $2323980ce672c824$export$b61bda4fbca264f2)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $f72016e2a99839eb$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $f72016e2a99839eb$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(overrides.from, $f72016e2a99839eb$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $f72016e2a99839eb$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $2323980ce672c824$export$d503dd157d963b60)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($f72016e2a99839eb$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $f72016e2a99839eb$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $eafe7e37f600d478$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $f72016e2a99839eb$var$getRunner(contract.runner, "estimateGas");
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($f72016e2a99839eb$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $f72016e2a99839eb$var$getRunner(contract.runner, "call");
        (0, $205dffdfdb79d607$export$a7a9523472993e97)($f72016e2a99839eb$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $205dffdfdb79d607$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $2323980ce672c824$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $f72016e2a99839eb$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $f72016e2a99839eb$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $2323980ce672c824$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $f72016e2a99839eb$var$internal = Symbol.for("_ethersInternal_contract");
const $f72016e2a99839eb$var$internalValues = new WeakMap();
function $f72016e2a99839eb$var$setInternal(contract, values) {
    $f72016e2a99839eb$var$internalValues.set(contract[$f72016e2a99839eb$var$internal], values);
}
function $f72016e2a99839eb$var$getInternal(contract) {
    return $f72016e2a99839eb$var$internalValues.get(contract[$f72016e2a99839eb$var$internal]);
}
function $f72016e2a99839eb$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $f72016e2a99839eb$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($f72016e2a99839eb$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $f72016e2a99839eb$var$hasSub(contract, event) {
    const { subs: subs } = $f72016e2a99839eb$var$getInternal(contract);
    return subs.get((await $f72016e2a99839eb$var$getSubInfo(contract, event)).tag) || null;
}
async function $f72016e2a99839eb$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $f72016e2a99839eb$var$getProvider(contract.runner);
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $f72016e2a99839eb$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $f72016e2a99839eb$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $f72016e2a99839eb$var$emit(contract, event, args, (listener)=>{
                    return new (0, $eafe7e37f600d478$export$35f9272dc1c07dee)(contract, listener, event, _foundFragment, log);
                });
            } else $f72016e2a99839eb$var$emit(contract, event, [], (listener)=>{
                return new (0, $eafe7e37f600d478$export$54be5ec94ad26a69)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $f72016e2a99839eb$var$lastEmit = Promise.resolve();
async function $f72016e2a99839eb$var$_emit(contract, event, args, payloadFunc) {
    await $f72016e2a99839eb$var$lastEmit;
    const sub = await $f72016e2a99839eb$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $f72016e2a99839eb$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $f72016e2a99839eb$var$emit(contract, event, args, payloadFunc) {
    try {
        await $f72016e2a99839eb$var$lastEmit;
    } catch (error) {}
    const resultPromise = $f72016e2a99839eb$var$_emit(contract, event, args, payloadFunc);
    $f72016e2a99839eb$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $f72016e2a99839eb$var$passProperties = [
    "then"
];
class $f72016e2a99839eb$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$f72016e2a99839eb$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof target === "string" || (0, $468ec04bb3c62bc6$export$6a88e03bca5eb759)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $39ad8f5a46e38b19$export$48cefb51a4e315b2).from(abi);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $f72016e2a99839eb$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $f72016e2a99839eb$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $eafe7e37f600d478$export$853f7e2df34220ff)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $f72016e2a99839eb$var$getRunner(runner, "resolveName");
                if (!$f72016e2a99839eb$var$canResolve(resolver)) throw (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $f72016e2a99839eb$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $f72016e2a99839eb$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $f72016e2a99839eb$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $f72016e2a99839eb$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($f72016e2a99839eb$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            filters: filters
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            fallback: iface.receive || iface.fallback ? $f72016e2a99839eb$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $f72016e2a99839eb$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $f72016e2a99839eb$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $f72016e2a99839eb$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $f72016e2a99839eb$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $f72016e2a99839eb$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $f72016e2a99839eb$var$getProvider(this.runner);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $f72016e2a99839eb$var$getProvider(this.runner);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $f72016e2a99839eb$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $f72016e2a99839eb$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $f72016e2a99839eb$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $f72016e2a99839eb$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $f72016e2a99839eb$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $f72016e2a99839eb$var$getProvider(this.runner);
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $eafe7e37f600d478$export$f8203d08df5cd081)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $eafe7e37f600d478$export$53f6e6acc02bf489)(log, error);
            }
            return new (0, $3d0b5969b3413cac$export$ce30dbb46644d06c)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $f72016e2a99839eb$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $f72016e2a99839eb$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $f72016e2a99839eb$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $f72016e2a99839eb$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $f72016e2a99839eb$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $f72016e2a99839eb$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $f72016e2a99839eb$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $f72016e2a99839eb$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $f72016e2a99839eb$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $f72016e2a99839eb$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $f72016e2a99839eb$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $f72016e2a99839eb$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $f72016e2a99839eb$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $f72016e2a99839eb$var$_ContractBase() {
    return $f72016e2a99839eb$export$304faa4fc17528db;
}
class $f72016e2a99839eb$export$8517d80acf00e19a extends $f72016e2a99839eb$var$_ContractBase() {
}




// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $774695fe1b0041a7$var$COMPRESSED$1 = "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";
const $774695fe1b0041a7$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $774695fe1b0041a7$var$NSM_MAX = 4;
function $774695fe1b0041a7$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $774695fe1b0041a7$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $774695fe1b0041a7$var$read_compressed_payload(s) {
    return $774695fe1b0041a7$var$read_payload($774695fe1b0041a7$var$decode_arithmetic($774695fe1b0041a7$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $774695fe1b0041a7$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $774695fe1b0041a7$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $774695fe1b0041a7$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $774695fe1b0041a7$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $774695fe1b0041a7$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $774695fe1b0041a7$var$read_sorted_arrays(next) {
    return $774695fe1b0041a7$var$read_array_while(()=>{
        let v = $774695fe1b0041a7$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $774695fe1b0041a7$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($774695fe1b0041a7$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($774695fe1b0041a7$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $774695fe1b0041a7$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $774695fe1b0041a7$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$774695fe1b0041a7$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $774695fe1b0041a7$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $774695fe1b0041a7$var$read_array_while(next);
    let m = $774695fe1b0041a7$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $774695fe1b0041a7$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $774695fe1b0041a7$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $774695fe1b0041a7$var$read_trie(next) {
    let ret = [];
    let sorted = $774695fe1b0041a7$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $774695fe1b0041a7$var$read_array_while(()=>{
            let cps = $774695fe1b0041a7$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $774695fe1b0041a7$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $774695fe1b0041a7$var$quote_cp(cp) {
    return `{${$774695fe1b0041a7$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $774695fe1b0041a7$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $774695fe1b0041a7$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $774695fe1b0041a7$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $774695fe1b0041a7$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $774695fe1b0041a7$var$S0 = 0xAC00;
const $774695fe1b0041a7$var$L0 = 0x1100;
const $774695fe1b0041a7$var$V0 = 0x1161;
const $774695fe1b0041a7$var$T0 = 0x11A7;
const $774695fe1b0041a7$var$L_COUNT = 19;
const $774695fe1b0041a7$var$V_COUNT = 21;
const $774695fe1b0041a7$var$T_COUNT = 28;
const $774695fe1b0041a7$var$N_COUNT = $774695fe1b0041a7$var$V_COUNT * $774695fe1b0041a7$var$T_COUNT;
const $774695fe1b0041a7$var$S_COUNT = $774695fe1b0041a7$var$L_COUNT * $774695fe1b0041a7$var$N_COUNT;
const $774695fe1b0041a7$var$S1 = $774695fe1b0041a7$var$S0 + $774695fe1b0041a7$var$S_COUNT;
const $774695fe1b0041a7$var$L1 = $774695fe1b0041a7$var$L0 + $774695fe1b0041a7$var$L_COUNT;
const $774695fe1b0041a7$var$V1 = $774695fe1b0041a7$var$V0 + $774695fe1b0041a7$var$V_COUNT;
const $774695fe1b0041a7$var$T1 = $774695fe1b0041a7$var$T0 + $774695fe1b0041a7$var$T_COUNT;
function $774695fe1b0041a7$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $774695fe1b0041a7$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $774695fe1b0041a7$var$SHIFTED_RANK, $774695fe1b0041a7$var$EXCLUSIONS, $774695fe1b0041a7$var$DECOMP, $774695fe1b0041a7$var$RECOMP;
function $774695fe1b0041a7$var$init$1() {
    //console.time('nf');
    let r = $774695fe1b0041a7$var$read_compressed_payload($774695fe1b0041a7$var$COMPRESSED);
    $774695fe1b0041a7$var$SHIFTED_RANK = new Map($774695fe1b0041a7$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $774695fe1b0041a7$var$EXCLUSIONS = new Set($774695fe1b0041a7$var$read_sorted(r));
    $774695fe1b0041a7$var$DECOMP = new Map();
    $774695fe1b0041a7$var$RECOMP = new Map();
    for (let [cp, cps] of $774695fe1b0041a7$var$read_mapped(r)){
        if (!$774695fe1b0041a7$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $774695fe1b0041a7$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $774695fe1b0041a7$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $774695fe1b0041a7$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $774695fe1b0041a7$var$is_hangul(cp) {
    return cp >= $774695fe1b0041a7$var$S0 && cp < $774695fe1b0041a7$var$S1;
}
function $774695fe1b0041a7$var$compose_pair(a, b) {
    if (a >= $774695fe1b0041a7$var$L0 && a < $774695fe1b0041a7$var$L1 && b >= $774695fe1b0041a7$var$V0 && b < $774695fe1b0041a7$var$V1) return $774695fe1b0041a7$var$S0 + (a - $774695fe1b0041a7$var$L0) * $774695fe1b0041a7$var$N_COUNT + (b - $774695fe1b0041a7$var$V0) * $774695fe1b0041a7$var$T_COUNT;
    else if ($774695fe1b0041a7$var$is_hangul(a) && b > $774695fe1b0041a7$var$T0 && b < $774695fe1b0041a7$var$T1 && (a - $774695fe1b0041a7$var$S0) % $774695fe1b0041a7$var$T_COUNT == 0) return a + (b - $774695fe1b0041a7$var$T0);
    else {
        let recomp = $774695fe1b0041a7$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $774695fe1b0041a7$var$decomposed(cps) {
    if (!$774695fe1b0041a7$var$SHIFTED_RANK) $774695fe1b0041a7$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $774695fe1b0041a7$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($774695fe1b0041a7$var$is_hangul(cp)) {
            let s_index = cp - $774695fe1b0041a7$var$S0;
            let l_index = s_index / $774695fe1b0041a7$var$N_COUNT | 0;
            let v_index = s_index % $774695fe1b0041a7$var$N_COUNT / $774695fe1b0041a7$var$T_COUNT | 0;
            let t_index = s_index % $774695fe1b0041a7$var$T_COUNT;
            add($774695fe1b0041a7$var$L0 + l_index);
            add($774695fe1b0041a7$var$V0 + v_index);
            if (t_index > 0) add($774695fe1b0041a7$var$T0 + t_index);
        } else {
            let mapped = $774695fe1b0041a7$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $774695fe1b0041a7$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $774695fe1b0041a7$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $774695fe1b0041a7$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $774695fe1b0041a7$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $774695fe1b0041a7$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $774695fe1b0041a7$var$unpack_cc(packed);
        let cp = $774695fe1b0041a7$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $774695fe1b0041a7$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $774695fe1b0041a7$export$9d0d896b286a3dba(cps) {
    return $774695fe1b0041a7$var$decomposed(cps).map($774695fe1b0041a7$var$unpack_cp);
}
function $774695fe1b0041a7$export$f42252642e08449(cps) {
    return $774695fe1b0041a7$var$composed_from_decomposed($774695fe1b0041a7$var$decomposed(cps));
}
const $774695fe1b0041a7$var$HYPHEN = 0x2D;
const $774695fe1b0041a7$var$STOP = 0x2E;
const $774695fe1b0041a7$var$STOP_CH = ".";
const $774695fe1b0041a7$var$FE0F = 0xFE0F;
const $774695fe1b0041a7$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $774695fe1b0041a7$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $774695fe1b0041a7$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $774695fe1b0041a7$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $774695fe1b0041a7$var$MAPPED, $774695fe1b0041a7$var$IGNORED, $774695fe1b0041a7$var$CM, $774695fe1b0041a7$var$NSM, $774695fe1b0041a7$var$ESCAPE, $774695fe1b0041a7$var$NFC_CHECK, $774695fe1b0041a7$var$GROUPS, $774695fe1b0041a7$var$WHOLE_VALID, $774695fe1b0041a7$var$WHOLE_MAP, $774695fe1b0041a7$var$VALID, $774695fe1b0041a7$var$EMOJI_LIST, $774695fe1b0041a7$var$EMOJI_ROOT;
function $774695fe1b0041a7$var$init() {
    if ($774695fe1b0041a7$var$MAPPED) return;
    let r = $774695fe1b0041a7$var$read_compressed_payload($774695fe1b0041a7$var$COMPRESSED$1);
    const read_sorted_array = ()=>$774695fe1b0041a7$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $774695fe1b0041a7$var$MAPPED = new Map($774695fe1b0041a7$var$read_mapped(r));
    $774695fe1b0041a7$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $774695fe1b0041a7$var$CM = read_sorted_array();
    $774695fe1b0041a7$var$NSM = new Set(read_sorted_array().map((i)=>$774695fe1b0041a7$var$CM[i]));
    $774695fe1b0041a7$var$CM = new Set($774695fe1b0041a7$var$CM);
    $774695fe1b0041a7$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $774695fe1b0041a7$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $774695fe1b0041a7$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $774695fe1b0041a7$var$GROUPS = $774695fe1b0041a7$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $774695fe1b0041a7$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $774695fe1b0041a7$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $774695fe1b0041a7$var$WHOLE_VALID = read_sorted_set();
    $774695fe1b0041a7$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($774695fe1b0041a7$var$Array_from($774695fe1b0041a7$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$774695fe1b0041a7$var$WHOLE_VALID.has(cp)) $774695fe1b0041a7$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($774695fe1b0041a7$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $774695fe1b0041a7$var$GROUPS.filter((g)=>$774695fe1b0041a7$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$774695fe1b0041a7$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $774695fe1b0041a7$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$774695fe1b0041a7$var$VALID.has(cp) ? multi.add(cp) : $774695fe1b0041a7$var$VALID.add(cp);
    for (let g of $774695fe1b0041a7$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $774695fe1b0041a7$var$VALID)if (!$774695fe1b0041a7$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $774695fe1b0041a7$var$WHOLE_MAP.set(cp, $774695fe1b0041a7$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($774695fe1b0041a7$var$VALID, $774695fe1b0041a7$export$9d0d896b286a3dba($774695fe1b0041a7$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $774695fe1b0041a7$var$EMOJI_LIST = $774695fe1b0041a7$var$read_trie(r).map((v)=>$774695fe1b0041a7$var$Emoji.from(v)).sort($774695fe1b0041a7$var$compare_arrays);
    $774695fe1b0041a7$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $774695fe1b0041a7$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $774695fe1b0041a7$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $774695fe1b0041a7$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $774695fe1b0041a7$var$quoted_cp(cp) {
    return ($774695fe1b0041a7$export$4b1c9c18c687e5e9(cp) ? "" : `${$774695fe1b0041a7$var$bidi_qq($774695fe1b0041a7$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $774695fe1b0041a7$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $774695fe1b0041a7$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $774695fe1b0041a7$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $774695fe1b0041a7$var$HYPHEN && cps[3] == $774695fe1b0041a7$var$HYPHEN) throw new Error(`invalid label extension: "${$774695fe1b0041a7$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $774695fe1b0041a7$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $774695fe1b0041a7$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $774695fe1b0041a7$var$FENCED.get(cp);
    if (prev) throw $774695fe1b0041a7$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $774695fe1b0041a7$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $774695fe1b0041a7$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $774695fe1b0041a7$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $774695fe1b0041a7$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $774695fe1b0041a7$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($774695fe1b0041a7$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($774695fe1b0041a7$export$4b1c9c18c687e5e9(cp)) {
            buf.push($774695fe1b0041a7$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($774695fe1b0041a7$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $774695fe1b0041a7$export$e29a9e4d2573411c(cp) {
    $774695fe1b0041a7$var$init();
    return $774695fe1b0041a7$var$CM.has(cp);
}
function $774695fe1b0041a7$export$4b1c9c18c687e5e9(cp) {
    $774695fe1b0041a7$var$init();
    return $774695fe1b0041a7$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $774695fe1b0041a7$export$95d5ea4de7964366() {
    $774695fe1b0041a7$var$init();
    return $774695fe1b0041a7$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $774695fe1b0041a7$export$f4e6b2721065fb3d(frag, decompose) {
    $774695fe1b0041a7$var$init();
    let nf = decompose ? $774695fe1b0041a7$export$9d0d896b286a3dba : $774695fe1b0041a7$export$f42252642e08449;
    return frag.split($774695fe1b0041a7$var$STOP_CH).map((label)=>$774695fe1b0041a7$var$str_from_cps($774695fe1b0041a7$var$tokens_from_str($774695fe1b0041a7$var$explode_cp(label), nf, $774695fe1b0041a7$var$filter_fe0f).flat())).join($774695fe1b0041a7$var$STOP_CH);
}
function $774695fe1b0041a7$export$499f715881831a51(name) {
    return $774695fe1b0041a7$var$flatten($774695fe1b0041a7$var$split(name, $774695fe1b0041a7$export$f42252642e08449, $774695fe1b0041a7$var$filter_fe0f));
}
function $774695fe1b0041a7$export$d2ee080f6ab2341d(name) {
    let labels = $774695fe1b0041a7$var$split(name, $774695fe1b0041a7$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") $774695fe1b0041a7$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $774695fe1b0041a7$var$flatten(labels);
}
function $774695fe1b0041a7$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $774695fe1b0041a7$export$d2ba335951b08421(name, preserve_emoji) {
    return $774695fe1b0041a7$var$split(name, $774695fe1b0041a7$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $774695fe1b0041a7$var$filter_fe0f); // emoji are exposed so copy
}
function $774695fe1b0041a7$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $774695fe1b0041a7$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($774695fe1b0041a7$var$STOP_CH).map((label)=>{
        let input = $774695fe1b0041a7$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $774695fe1b0041a7$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $774695fe1b0041a7$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $774695fe1b0041a7$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($774695fe1b0041a7$var$CM.has(norm[0])) throw $774695fe1b0041a7$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $774695fe1b0041a7$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $774695fe1b0041a7$var$error_placement(`emoji + combining mark: "${$774695fe1b0041a7$var$str_from_cps(tokens[i - 1])} + ${$774695fe1b0041a7$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $774695fe1b0041a7$var$check_fenced(norm);
                    let unique = $774695fe1b0041a7$var$Array_from(new Set(chars));
                    let [g] = $774695fe1b0041a7$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $774695fe1b0041a7$var$check_group(g, chars); // need text in order
                    $774695fe1b0041a7$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $774695fe1b0041a7$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $774695fe1b0041a7$var$WHOLE_MAP.get(cp);
        if (whole === $774695fe1b0041a7$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $774695fe1b0041a7$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$774695fe1b0041a7$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $774695fe1b0041a7$var$determine_group(unique) {
    let groups = $774695fe1b0041a7$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$774695fe1b0041a7$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$774695fe1b0041a7$var$GROUPS.some((g)=>$774695fe1b0041a7$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $774695fe1b0041a7$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $774695fe1b0041a7$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $774695fe1b0041a7$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$774695fe1b0041a7$var$bidi_qq($774695fe1b0041a7$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $774695fe1b0041a7$var$str_from_cps(output);
    }).join($774695fe1b0041a7$var$STOP_CH);
}
function $774695fe1b0041a7$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$774695fe1b0041a7$var$quoted_cp(cp)}`);
}
function $774695fe1b0041a7$var$error_group_member(g, cp) {
    let quoted = $774695fe1b0041a7$var$quoted_cp(cp);
    let gg = $774695fe1b0041a7$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $774695fe1b0041a7$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $774695fe1b0041a7$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$774695fe1b0041a7$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $774695fe1b0041a7$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $774695fe1b0041a7$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($774695fe1b0041a7$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $774695fe1b0041a7$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$774695fe1b0041a7$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $774695fe1b0041a7$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$774695fe1b0041a7$var$bidi_qq($774695fe1b0041a7$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$774695fe1b0041a7$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $774695fe1b0041a7$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $774695fe1b0041a7$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($774695fe1b0041a7$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $774695fe1b0041a7$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$774695fe1b0041a7$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $774695fe1b0041a7$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $774695fe1b0041a7$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $774695fe1b0041a7$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $774695fe1b0041a7$var$consume_emoji_reversed(cps, eaten) {
    let node = $774695fe1b0041a7$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $774695fe1b0041a7$var$TY_VALID = "valid";
const $774695fe1b0041a7$var$TY_MAPPED = "mapped";
const $774695fe1b0041a7$var$TY_IGNORED = "ignored";
const $774695fe1b0041a7$var$TY_DISALLOWED = "disallowed";
const $774695fe1b0041a7$var$TY_EMOJI = "emoji";
const $774695fe1b0041a7$var$TY_NFC = "nfc";
const $774695fe1b0041a7$var$TY_STOP = "stop";
function $774695fe1b0041a7$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $774695fe1b0041a7$var$init();
    let input = $774695fe1b0041a7$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $774695fe1b0041a7$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $774695fe1b0041a7$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $774695fe1b0041a7$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $774695fe1b0041a7$var$STOP) tokens.push({
                type: $774695fe1b0041a7$var$TY_STOP,
                cp: cp
            });
            else if ($774695fe1b0041a7$var$VALID.has(cp)) tokens.push({
                type: $774695fe1b0041a7$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($774695fe1b0041a7$var$IGNORED.has(cp)) tokens.push({
                type: $774695fe1b0041a7$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $774695fe1b0041a7$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $774695fe1b0041a7$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $774695fe1b0041a7$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($774695fe1b0041a7$var$is_valid_or_mapped(token.type)) {
            if ($774695fe1b0041a7$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($774695fe1b0041a7$var$is_valid_or_mapped(type)) {
                        if (!$774695fe1b0041a7$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $774695fe1b0041a7$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$774695fe1b0041a7$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $774695fe1b0041a7$export$f42252642e08449(cps0);
                if ($774695fe1b0041a7$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $774695fe1b0041a7$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $774695fe1b0041a7$var$collapse_valid_tokens(slice),
                        tokens: $774695fe1b0041a7$export$bac129d8210aa825($774695fe1b0041a7$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $774695fe1b0041a7$var$TY_IGNORED) start = -1; // reset
    }
    return $774695fe1b0041a7$var$collapse_valid_tokens(tokens);
}
function $774695fe1b0041a7$var$is_valid_or_mapped(type) {
    return type == $774695fe1b0041a7$var$TY_VALID || type == $774695fe1b0041a7$var$TY_MAPPED;
}
function $774695fe1b0041a7$var$requires_check(cps) {
    return cps.some((cp)=>$774695fe1b0041a7$var$NFC_CHECK.has(cp));
}
function $774695fe1b0041a7$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $774695fe1b0041a7$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $774695fe1b0041a7$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $774695fe1b0041a7$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


const $165031ad81d38919$var$Zeros = new Uint8Array(32);
$165031ad81d38919$var$Zeros.fill(0);
function $165031ad81d38919$var$checkComponent(comp) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $165031ad81d38919$var$ensNameSplit(name) {
    const bytes = (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)($165031ad81d38919$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($165031ad81d38919$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($165031ad81d38919$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $165031ad81d38919$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $774695fe1b0041a7$export$499f715881831a51)(name);
    } catch (error) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $165031ad81d38919$export$cce2300886e7ace6(name) {
    try {
        return $165031ad81d38919$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $165031ad81d38919$export$91d651ee363e1209(name) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $165031ad81d38919$var$Zeros;
    const comps = $165031ad81d38919$var$ensNameSplit(name);
    while(comps.length)result = (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)((0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        result,
        (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(result);
}
function $165031ad81d38919$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)((0, $85f03119331e3531$export$ee1b3e54f0441b22)($165031ad81d38919$var$ensNameSplit(name).map((comp)=>{
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





//See: https://github.com/ethereum/wiki/wiki/RLP


function $245ae2dbf2ee5fb9$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $245ae2dbf2ee5fb9$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $245ae2dbf2ee5fb9$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $245ae2dbf2ee5fb9$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $245ae2dbf2ee5fb9$var$_decode(data, offset) {
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $245ae2dbf2ee5fb9$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $245ae2dbf2ee5fb9$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $245ae2dbf2ee5fb9$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $245ae2dbf2ee5fb9$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $245ae2dbf2ee5fb9$var$hexlifyByte(data[offset])
    };
}
function $245ae2dbf2ee5fb9$export$7dc021e13b2aa20d(_data) {
    const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(_data, "data");
    const decoded = $245ae2dbf2ee5fb9$var$_decode(data, 0);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

//See: https://github.com/ethereum/wiki/wiki/RLP

function $fa78aa2ab526fcce$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $fa78aa2ab526fcce$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($fa78aa2ab526fcce$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $fa78aa2ab526fcce$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $85f03119331e3531$export$a3521add2594f3c8)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $fa78aa2ab526fcce$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $fa78aa2ab526fcce$var$nibbles = "0123456789abcdef";
function $fa78aa2ab526fcce$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $fa78aa2ab526fcce$var$_encode(object)){
        result += $fa78aa2ab526fcce$var$nibbles[v >> 4];
        result += $fa78aa2ab526fcce$var$nibbles[v & 0xf];
    }
    return result;
}




const $1c7938633fcd26f1$var$BN_0 = BigInt(0);
const $1c7938633fcd26f1$var$BN_2 = BigInt(2);
const $1c7938633fcd26f1$var$BN_27 = BigInt(27);
const $1c7938633fcd26f1$var$BN_28 = BigInt(28);
const $1c7938633fcd26f1$var$BN_35 = BigInt(35);
const $1c7938633fcd26f1$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $1c7938633fcd26f1$var$BLOB_SIZE = 131072;
function $1c7938633fcd26f1$var$getVersionedHash(version, hash) {
    let versioned = version.toString(16);
    while(versioned.length < 2)versioned = "0" + versioned;
    versioned += (0, $8ffad2f5de44b604$export$bced8d2aada2d1c9)(hash).substring(4);
    return "0x" + versioned;
}
function $1c7938633fcd26f1$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $0dc837b8e002cdcf$export$88411125f012957a)(value);
}
function $1c7938633fcd26f1$var$handleAccessList(value, param) {
    try {
        return (0, $54c23e469e18e47c$export$6c8662b1600dce2)(value);
    } catch (error) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $1c7938633fcd26f1$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $7769476213c187e3$export$b14f2714108df84)(_value, param);
}
function $1c7938633fcd26f1$var$handleUint(_value, param) {
    if (_value === "0x") return $1c7938633fcd26f1$var$BN_0;
    const value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(_value, param);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(value <= $1c7938633fcd26f1$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $1c7938633fcd26f1$var$formatNumber(_value, name) {
    const value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(_value, "value");
    const result = (0, $7769476213c187e3$export$b627fcfb5ea68cb0)(value);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $1c7938633fcd26f1$var$formatAccessList(value) {
    return (0, $54c23e469e18e47c$export$6c8662b1600dce2)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $1c7938633fcd26f1$var$formatHashes(value, param) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $1c7938633fcd26f1$var$_parseLegacy(data) {
    const fields = (0, $245ae2dbf2ee5fb9$export$7dc021e13b2aa20d)(data);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $1c7938633fcd26f1$var$handleNumber(fields[0], "nonce"),
        gasPrice: $1c7938633fcd26f1$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $1c7938633fcd26f1$var$handleUint(fields[2], "gasLimit"),
        to: $1c7938633fcd26f1$var$handleAddress(fields[3]),
        value: $1c7938633fcd26f1$var$handleUint(fields[4], "value"),
        data: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(fields[5]),
        chainId: $1c7938633fcd26f1$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $1c7938633fcd26f1$var$handleUint(fields[6], "v");
    const r = $1c7938633fcd26f1$var$handleUint(fields[7], "r");
    const s = $1c7938633fcd26f1$var$handleUint(fields[8], "s");
    if (r === $1c7938633fcd26f1$var$BN_0 && s === $1c7938633fcd26f1$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $1c7938633fcd26f1$var$BN_35) / $1c7938633fcd26f1$var$BN_2;
        if (chainId < $1c7938633fcd26f1$var$BN_0) chainId = $1c7938633fcd26f1$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(chainId !== $1c7938633fcd26f1$var$BN_0 || v === $1c7938633fcd26f1$var$BN_27 || v === $1c7938633fcd26f1$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from({
            r: (0, $85f03119331e3531$export$4473860254365feb)(fields[7], 32),
            s: (0, $85f03119331e3531$export$4473860254365feb)(fields[8], 32),
            v: v
        });
    //tx.hash = keccak256(data);
    }
    return tx;
}
function $1c7938633fcd26f1$var$_serializeLegacy(tx, sig) {
    const fields = [
        $1c7938633fcd26f1$var$formatNumber(tx.nonce, "nonce"),
        $1c7938633fcd26f1$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $1c7938633fcd26f1$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $1c7938633fcd26f1$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $1c7938633fcd26f1$var$BN_0;
    if (tx.chainId != $1c7938633fcd26f1$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $1c7938633fcd26f1$var$BN_0) {
            fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $fa78aa2ab526fcce$export$aea7770274d28b7)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $1c7938633fcd26f1$var$BN_0) v = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(v));
    fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.r));
    fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.s));
    return (0, $fa78aa2ab526fcce$export$aea7770274d28b7)(fields);
}
function $1c7938633fcd26f1$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $1c7938633fcd26f1$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $85f03119331e3531$export$4473860254365feb)(fields[1], 32);
    const s = (0, $85f03119331e3531$export$4473860254365feb)(fields[2], 32);
    const signature = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $1c7938633fcd26f1$var$_parseEip1559(data) {
    const fields = (0, $245ae2dbf2ee5fb9$export$7dc021e13b2aa20d)((0, $85f03119331e3531$export$a3521add2594f3c8)(data).slice(1));
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 2,
        chainId: $1c7938633fcd26f1$var$handleUint(fields[0], "chainId"),
        nonce: $1c7938633fcd26f1$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $1c7938633fcd26f1$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $1c7938633fcd26f1$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $1c7938633fcd26f1$var$handleUint(fields[4], "gasLimit"),
        to: $1c7938633fcd26f1$var$handleAddress(fields[5]),
        value: $1c7938633fcd26f1$var$handleUint(fields[6], "value"),
        data: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $1c7938633fcd26f1$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    //tx.hash = keccak256(data);
    $1c7938633fcd26f1$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $1c7938633fcd26f1$var$_serializeEip1559(tx, sig) {
    const fields = [
        $1c7938633fcd26f1$var$formatNumber(tx.chainId, "chainId"),
        $1c7938633fcd26f1$var$formatNumber(tx.nonce, "nonce"),
        $1c7938633fcd26f1$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $1c7938633fcd26f1$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $1c7938633fcd26f1$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $1c7938633fcd26f1$var$formatNumber(tx.value, "value"),
        tx.data,
        $1c7938633fcd26f1$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($1c7938633fcd26f1$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        "0x02",
        (0, $fa78aa2ab526fcce$export$aea7770274d28b7)(fields)
    ]);
}
function $1c7938633fcd26f1$var$_parseEip2930(data) {
    const fields = (0, $245ae2dbf2ee5fb9$export$7dc021e13b2aa20d)((0, $85f03119331e3531$export$a3521add2594f3c8)(data).slice(1));
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 1,
        chainId: $1c7938633fcd26f1$var$handleUint(fields[0], "chainId"),
        nonce: $1c7938633fcd26f1$var$handleNumber(fields[1], "nonce"),
        gasPrice: $1c7938633fcd26f1$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $1c7938633fcd26f1$var$handleUint(fields[3], "gasLimit"),
        to: $1c7938633fcd26f1$var$handleAddress(fields[4]),
        value: $1c7938633fcd26f1$var$handleUint(fields[5], "value"),
        data: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(fields[6]),
        accessList: $1c7938633fcd26f1$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    //tx.hash = keccak256(data);
    $1c7938633fcd26f1$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $1c7938633fcd26f1$var$_serializeEip2930(tx, sig) {
    const fields = [
        $1c7938633fcd26f1$var$formatNumber(tx.chainId, "chainId"),
        $1c7938633fcd26f1$var$formatNumber(tx.nonce, "nonce"),
        $1c7938633fcd26f1$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $1c7938633fcd26f1$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $1c7938633fcd26f1$var$formatNumber(tx.value, "value"),
        tx.data,
        $1c7938633fcd26f1$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($1c7938633fcd26f1$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        "0x01",
        (0, $fa78aa2ab526fcce$export$aea7770274d28b7)(fields)
    ]);
}
function $1c7938633fcd26f1$var$_parseEip4844(data) {
    let fields = (0, $245ae2dbf2ee5fb9$export$7dc021e13b2aa20d)((0, $85f03119331e3531$export$a3521add2594f3c8)(data).slice(1));
    let typeName = "3";
    let blobs = null;
    // Parse the network format
    if (fields.length === 4 && Array.isArray(fields[0])) {
        typeName = "3 (network format)";
        const fBlobs = fields[1], fCommits = fields[2], fProofs = fields[3];
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fBlobs), "invalid network format: blobs not an array", "fields[1]", fBlobs);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fCommits), "invalid network format: commitments not an array", "fields[2]", fCommits);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fProofs), "invalid network format: proofs not an array", "fields[3]", fProofs);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(fBlobs.length === fCommits.length, "invalid network format: blobs/commitments length mismatch", "fields", fields);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(fBlobs.length === fProofs.length, "invalid network format: blobs/proofs length mismatch", "fields", fields);
        blobs = [];
        for(let i = 0; i < fields[1].length; i++)blobs.push({
            data: fBlobs[i],
            commitment: fCommits[i],
            proof: fProofs[i]
        });
        fields = fields[0];
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), `invalid field count for transaction type: ${typeName}`, "data", (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 3,
        chainId: $1c7938633fcd26f1$var$handleUint(fields[0], "chainId"),
        nonce: $1c7938633fcd26f1$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $1c7938633fcd26f1$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $1c7938633fcd26f1$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $1c7938633fcd26f1$var$handleUint(fields[4], "gasLimit"),
        to: $1c7938633fcd26f1$var$handleAddress(fields[5]),
        value: $1c7938633fcd26f1$var$handleUint(fields[6], "value"),
        data: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $1c7938633fcd26f1$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $1c7938633fcd26f1$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    if (blobs) tx.blobs = blobs;
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(tx.to != null, `invalid address for transaction type: ${typeName}`, "data", data);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    // @TODO: Do we need to do this? This is only called internally
    // and used to verify hashes; it might save time to not do this
    //tx.hash = keccak256(concat([ "0x03", encodeRlp(fields) ]));
    $1c7938633fcd26f1$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $1c7938633fcd26f1$var$_serializeEip4844(tx, sig, blobs) {
    const fields = [
        $1c7938633fcd26f1$var$formatNumber(tx.chainId, "chainId"),
        $1c7938633fcd26f1$var$formatNumber(tx.nonce, "nonce"),
        $1c7938633fcd26f1$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $1c7938633fcd26f1$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $1c7938633fcd26f1$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $7675f23517409f7b$export$b7cbe423ba83da17),
        $1c7938633fcd26f1$var$formatNumber(tx.value, "value"),
        tx.data,
        $1c7938633fcd26f1$var$formatAccessList(tx.accessList || []),
        $1c7938633fcd26f1$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $1c7938633fcd26f1$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($1c7938633fcd26f1$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7769476213c187e3$export$b627fcfb5ea68cb0)(sig.s));
        // We have blobs; return the network wrapped format
        if (blobs) return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
            "0x03",
            (0, $fa78aa2ab526fcce$export$aea7770274d28b7)([
                fields,
                blobs.map((b)=>b.data),
                blobs.map((b)=>b.commitment),
                blobs.map((b)=>b.proof)
            ])
        ]);
    }
    return (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        "0x03",
        (0, $fa78aa2ab526fcce$export$aea7770274d28b7)(fields)
    ]);
}
class $1c7938633fcd26f1$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    #kzg;
    #blobs;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $7675f23517409f7b$export$b7cbe423ba83da17;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $0dc837b8e002cdcf$export$88411125f012957a)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $7769476213c187e3$export$b14f2714108df84)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $1c7938633fcd26f1$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $1c7938633fcd26f1$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $1c7938633fcd26f1$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $54c23e469e18e47c$export$6c8662b1600dce2)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $1c7938633fcd26f1$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */ get blobs() {
        if (this.#blobs == null) return null;
        return this.#blobs.map((b)=>Object.assign({}, b));
    }
    set blobs(_blobs) {
        if (_blobs == null) {
            this.#blobs = null;
            return;
        }
        const blobs = [];
        const versionedHashes = [];
        for(let i = 0; i < _blobs.length; i++){
            const blob = _blobs[i];
            if ((0, $85f03119331e3531$export$9a14abb1a440cd5e)(blob)) {
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.#kzg, "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
                    operation: "set blobs()"
                });
                let data = (0, $85f03119331e3531$export$a3521add2594f3c8)(blob);
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(data.length <= $1c7938633fcd26f1$var$BLOB_SIZE, "blob is too large", `blobs[${i}]`, blob);
                // Pad blob if necessary
                if (data.length !== $1c7938633fcd26f1$var$BLOB_SIZE) {
                    const padded = new Uint8Array($1c7938633fcd26f1$var$BLOB_SIZE);
                    padded.set(data);
                    data = padded;
                }
                const commit = this.#kzg.blobToKzgCommitment(data);
                const proof = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(this.#kzg.computeBlobKzgProof(data, commit));
                blobs.push({
                    data: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(data),
                    commitment: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(commit),
                    proof: proof
                });
                versionedHashes.push($1c7938633fcd26f1$var$getVersionedHash(1, commit));
            } else {
                const commit = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(blob.commitment);
                blobs.push({
                    data: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(blob.data),
                    commitment: commit,
                    proof: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(blob.proof)
                });
                versionedHashes.push($1c7938633fcd26f1$var$getVersionedHash(1, commit));
            }
        }
        this.#blobs = blobs;
        this.#blobVersionedHashes = versionedHashes;
    }
    get kzg() {
        return this.#kzg;
    }
    set kzg(kzg) {
        this.#kzg = kzg;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $1c7938633fcd26f1$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $1c7938633fcd26f1$var$BN_0;
        this.#chainId = $1c7938633fcd26f1$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
        this.#blobs = null;
        this.#kzg = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(this.#getSerialized(true, false));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $39fe7f3d73992d01$export$f8151fce47ad1c35)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $5018792530a66b37$export$23cc18f96d8510e2)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $da5509008f9e5216$export$21643ca94aed3e83).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    #getSerialized(signed, sidecar) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!signed || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        const sig = signed ? this.signature : null;
        switch(this.inferType()){
            case 0:
                return $1c7938633fcd26f1$var$_serializeLegacy(this, sig);
            case 1:
                return $1c7938633fcd26f1$var$_serializeEip2930(this, sig);
            case 2:
                return $1c7938633fcd26f1$var$_serializeEip1559(this, sig);
            case 3:
                return $1c7938633fcd26f1$var$_serializeEip4844(this, sig, sidecar ? this.blobs : null);
        }
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        return this.#getSerialized(true, true);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        return this.#getSerialized(false, false);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $1c7938633fcd26f1$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $1c7938633fcd26f1$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $85f03119331e3531$export$a3521add2594f3c8)(tx);
            if (payload[0] >= 0x7f) return $1c7938633fcd26f1$export$febc5573c75cefb0.from($1c7938633fcd26f1$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $1c7938633fcd26f1$export$febc5573c75cefb0.from($1c7938633fcd26f1$var$_parseEip2930(payload));
                case 2:
                    return $1c7938633fcd26f1$export$febc5573c75cefb0.from($1c7938633fcd26f1$var$_parseEip1559(payload));
                case 3:
                    return $1c7938633fcd26f1$export$febc5573c75cefb0.from($1c7938633fcd26f1$var$_parseEip4844(payload));
            }
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $1c7938633fcd26f1$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        // This will get overwritten by blobs, if present
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        // Make sure we assign the kzg before assigning blobs, which
        // require the library in the event raw blob data is provided.
        if (tx.kzg != null) result.kzg = tx.kzg;
        if (tx.blobs != null) result.blobs = tx.blobs;
        if (tx.hash != null) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.hash'", "tx", tx);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.from'", "tx", tx);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}



/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 



/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 


const $84b8a350c01c7978$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $84b8a350c01c7978$var$Lookup = null;
function $84b8a350c01c7978$var$getAlpha(letter) {
    if ($84b8a350c01c7978$var$Lookup == null) {
        $84b8a350c01c7978$var$Lookup = {};
        for(let i = 0; i < $84b8a350c01c7978$var$Alphabet.length; i++)$84b8a350c01c7978$var$Lookup[$84b8a350c01c7978$var$Alphabet[i]] = BigInt(i);
    }
    const result = $84b8a350c01c7978$var$Lookup[letter];
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $84b8a350c01c7978$var$BN_0 = BigInt(0);
const $84b8a350c01c7978$var$BN_58 = BigInt(58);
function $84b8a350c01c7978$export$743e6bddc3282b13(_value) {
    const bytes = (0, $85f03119331e3531$export$a3521add2594f3c8)(_value);
    let value = (0, $7769476213c187e3$export$c221a145703ab783)(bytes);
    let result = "";
    while(value){
        result = $84b8a350c01c7978$var$Alphabet[Number(value % $84b8a350c01c7978$var$BN_58)] + result;
        value /= $84b8a350c01c7978$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $84b8a350c01c7978$var$Alphabet[0] + result;
    }
    return result;
}
function $84b8a350c01c7978$export$63d430871b22e3d9(value) {
    let result = $84b8a350c01c7978$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $84b8a350c01c7978$var$BN_58;
        result += $84b8a350c01c7978$var$getAlpha(value[i]);
    }
    return result;
}


// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $e3bcb0f775b38be9$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $e3bcb0f775b38be9$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $e3bcb0f775b38be9$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $e3bcb0f775b38be9$export$dcf63b2028a708b5 extends $e3bcb0f775b38be9$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($e3bcb0f775b38be9$var$BasicMulticoinPluginId);
    }
}
const $e3bcb0f775b38be9$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $e3bcb0f775b38be9$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $e3bcb0f775b38be9$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $e3bcb0f775b38be9$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $f72016e2a99839eb$export$8517d80acf00e19a)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $165031ad81d38919$export$91d651ee363e1209)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $165031ad81d38919$export$6c0a8cdae51cb512)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $7675f23517409f7b$export$b7cbe423ba83da17)) return null;
            return result;
        } catch (error) {
            if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(data, 20)) return (0, $0dc837b8e002cdcf$export$88411125f012957a)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $e3bcb0f775b38be9$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $84b8a350c01c7978$export$743e6bddc3282b13)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $e3bcb0f775b38be9$var$matchers.length; i++){
                const match = avatar.match($e3bcb0f775b38be9$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $e3bcb0f775b38be9$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $f72016e2a99839eb$export$8517d80acf00e19a)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $7769476213c187e3$export$c6ebe05badb16181)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $e3bcb0f775b38be9$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($e3bcb0f775b38be9$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $e3bcb0f775b38be9$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $e3bcb0f775b38be9$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $f72016e2a99839eb$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $165031ad81d38919$export$91d651ee363e1209)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $7675f23517409f7b$export$b7cbe423ba83da17)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $e3bcb0f775b38be9$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $e3bcb0f775b38be9$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}


/**
 *  @_ignore
 */ 


function $55a9de269d0390c9$export$769b627a7e45189e(tx) {
    const from = (0, $0dc837b8e002cdcf$export$88411125f012957a)(tx.from);
    const nonce = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $0dc837b8e002cdcf$export$88411125f012957a)((0, $85f03119331e3531$export$f6d845ffb449edc9)((0, $39fe7f3d73992d01$export$f8151fce47ad1c35)((0, $fa78aa2ab526fcce$export$aea7770274d28b7)([
        from,
        nonceHex
    ])), 12));
}
function $55a9de269d0390c9$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $0dc837b8e002cdcf$export$88411125f012957a)(_from);
    const salt = (0, $85f03119331e3531$export$a3521add2594f3c8)(_salt, "salt");
    const initCodeHash = (0, $85f03119331e3531$export$a3521add2594f3c8)(_initCodeHash, "initCodeHash");
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $0dc837b8e002cdcf$export$88411125f012957a)((0, $85f03119331e3531$export$f6d845ffb449edc9)((0, $39fe7f3d73992d01$export$f8151fce47ad1c35)((0, $85f03119331e3531$export$ee1b3e54f0441b22)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}





const $8473f4465021e175$var$BN_0 = BigInt(0);
function $8473f4465021e175$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $8473f4465021e175$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $8473f4465021e175$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $8473f4465021e175$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $8473f4465021e175$export$1f26277db27165ba(value) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(value, true), "invalid data", "value", value);
    return value;
}
function $8473f4465021e175$export$bb5bc852e1c64b88(value) {
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)((0, $85f03119331e3531$export$b02a40aff8e4ad18)(value, 32), "invalid hash", "value", value);
    return value;
}
function $8473f4465021e175$export$aff4fda55e7ac0d6(value) {
    if (!(0, $85f03119331e3531$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
    return (0, $85f03119331e3531$export$4473860254365feb)(value, 32);
}
const $8473f4465021e175$var$_formatLog = $8473f4465021e175$export$be5493f9613cbbe({
    address: (0, $0dc837b8e002cdcf$export$88411125f012957a),
    blockHash: $8473f4465021e175$export$bb5bc852e1c64b88,
    blockNumber: (0, $7769476213c187e3$export$b14f2714108df84),
    data: $8473f4465021e175$export$1f26277db27165ba,
    index: (0, $7769476213c187e3$export$b14f2714108df84),
    removed: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$7a3be81718959bda, false),
    topics: $8473f4465021e175$export$e57ff0f701c44363($8473f4465021e175$export$bb5bc852e1c64b88),
    transactionHash: $8473f4465021e175$export$bb5bc852e1c64b88,
    transactionIndex: (0, $7769476213c187e3$export$b14f2714108df84)
}, {
    index: [
        "logIndex"
    ]
});
function $8473f4465021e175$export$fccdbdc2b9d7893(value) {
    return $8473f4465021e175$var$_formatLog(value);
}
const $8473f4465021e175$var$_formatBlock = $8473f4465021e175$export$be5493f9613cbbe({
    hash: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$bb5bc852e1c64b88),
    parentHash: $8473f4465021e175$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$bb5bc852e1c64b88, null),
    number: (0, $7769476213c187e3$export$b14f2714108df84),
    timestamp: (0, $7769476213c187e3$export$b14f2714108df84),
    nonce: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$1f26277db27165ba),
    difficulty: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
    gasLimit: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
    gasUsed: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
    stateRoot: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$bb5bc852e1c64b88, null),
    receiptsRoot: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$bb5bc852e1c64b88, null),
    blobGasUsed: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4), null),
    excessBlobGas: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4), null),
    miner: $8473f4465021e175$export$4b08254e38b74fcd((0, $0dc837b8e002cdcf$export$88411125f012957a)),
    prevRandao: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$bb5bc852e1c64b88, null),
    extraData: $8473f4465021e175$export$1f26277db27165ba,
    baseFeePerGas: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4))
}, {
    prevRandao: [
        "mixHash"
    ]
});
function $8473f4465021e175$export$ba1152bc4017d62a(value) {
    const result = $8473f4465021e175$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $8473f4465021e175$export$fe50e42b325965d(tx);
    });
    return result;
}
const $8473f4465021e175$var$_formatReceiptLog = $8473f4465021e175$export$be5493f9613cbbe({
    transactionIndex: (0, $7769476213c187e3$export$b14f2714108df84),
    blockNumber: (0, $7769476213c187e3$export$b14f2714108df84),
    transactionHash: $8473f4465021e175$export$bb5bc852e1c64b88,
    address: (0, $0dc837b8e002cdcf$export$88411125f012957a),
    topics: $8473f4465021e175$export$e57ff0f701c44363($8473f4465021e175$export$bb5bc852e1c64b88),
    data: $8473f4465021e175$export$1f26277db27165ba,
    index: (0, $7769476213c187e3$export$b14f2714108df84),
    blockHash: $8473f4465021e175$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $8473f4465021e175$export$5ec2fc59e0e92b87(value) {
    return $8473f4465021e175$var$_formatReceiptLog(value);
}
const $8473f4465021e175$var$_formatTransactionReceipt = $8473f4465021e175$export$be5493f9613cbbe({
    to: $8473f4465021e175$export$4b08254e38b74fcd((0, $0dc837b8e002cdcf$export$88411125f012957a), null),
    from: $8473f4465021e175$export$4b08254e38b74fcd((0, $0dc837b8e002cdcf$export$88411125f012957a), null),
    contractAddress: $8473f4465021e175$export$4b08254e38b74fcd((0, $0dc837b8e002cdcf$export$88411125f012957a), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $7769476213c187e3$export$b14f2714108df84),
    root: $8473f4465021e175$export$4b08254e38b74fcd((0, $85f03119331e3531$export$2b0d6b5fbe698c70)),
    gasUsed: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
    blobGasUsed: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4), null),
    logsBloom: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$1f26277db27165ba),
    blockHash: $8473f4465021e175$export$bb5bc852e1c64b88,
    hash: $8473f4465021e175$export$bb5bc852e1c64b88,
    logs: $8473f4465021e175$export$e57ff0f701c44363($8473f4465021e175$export$5ec2fc59e0e92b87),
    blockNumber: (0, $7769476213c187e3$export$b14f2714108df84),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
    effectiveGasPrice: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4)),
    blobGasPrice: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4), null),
    status: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$b14f2714108df84)),
    type: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$b14f2714108df84), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $8473f4465021e175$export$30da670e49d6fc31(value) {
    return $8473f4465021e175$var$_formatTransactionReceipt(value);
}
function $8473f4465021e175$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value.to) === $8473f4465021e175$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $8473f4465021e175$export$be5493f9613cbbe({
        hash: $8473f4465021e175$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$b14f2714108df84), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $7769476213c187e3$export$b14f2714108df84)(value);
        },
        accessList: $8473f4465021e175$export$4b08254e38b74fcd((0, $54c23e469e18e47c$export$6c8662b1600dce2), null),
        blobVersionedHashes: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$e57ff0f701c44363($8473f4465021e175$export$bb5bc852e1c64b88, true), null),
        blockHash: $8473f4465021e175$export$4b08254e38b74fcd($8473f4465021e175$export$bb5bc852e1c64b88, null),
        blockNumber: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$b14f2714108df84), null),
        transactionIndex: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$b14f2714108df84), null),
        from: (0, $0dc837b8e002cdcf$export$88411125f012957a),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4)),
        maxPriorityFeePerGas: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4)),
        maxFeePerGas: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4)),
        maxFeePerBlobGas: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4), null),
        gasLimit: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
        to: $8473f4465021e175$export$4b08254e38b74fcd((0, $0dc837b8e002cdcf$export$88411125f012957a), null),
        value: (0, $7769476213c187e3$export$61fe455e2b1e28a4),
        nonce: (0, $7769476213c187e3$export$b14f2714108df84),
        data: $8473f4465021e175$export$1f26277db27165ba,
        creates: $8473f4465021e175$export$4b08254e38b74fcd((0, $0dc837b8e002cdcf$export$88411125f012957a), null),
        chainId: $8473f4465021e175$export$4b08254e38b74fcd((0, $7769476213c187e3$export$61fe455e2b1e28a4), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $55a9de269d0390c9$export$769b627a7e45189e)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from(value.signature);
    else result.signature = (0, $1ec7d3acfcdcd7a6$export$848620f5f2f26e86).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $7769476213c187e3$export$61fe455e2b1e28a4)(result.blockHash) === $8473f4465021e175$var$BN_0) result.blockHash = null;
    return result;
}


/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 



const $e4aa0ad52dbf41a0$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $e4aa0ad52dbf41a0$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $e4aa0ad52dbf41a0$export$10ae60faeb7e2196(this.name);
    }
}
class $e4aa0ad52dbf41a0$export$f2b0810a2dd50377 extends $e4aa0ad52dbf41a0$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, props);
    }
    clone() {
        return new $e4aa0ad52dbf41a0$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $e4aa0ad52dbf41a0$export$9be0b2c573890879 extends $e4aa0ad52dbf41a0$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            address: address || $e4aa0ad52dbf41a0$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $e4aa0ad52dbf41a0$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $e4aa0ad52dbf41a0$export$dd49482b7e9ea2da extends $e4aa0ad52dbf41a0$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $e4aa0ad52dbf41a0$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $e4aa0ad52dbf41a0$export$3bee30f9880d72e8 extends $e4aa0ad52dbf41a0$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 


/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $62f438f453d8cb95$var$Networks = new Map();
class $62f438f453d8cb95$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $7769476213c187e3$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $7769476213c187e3$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $7769476213c187e3$export$61fe455e2b1e28a4)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $62f438f453d8cb95$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $e4aa0ad52dbf41a0$export$f2b0810a2dd50377)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $54c23e469e18e47c$export$6c8662b1600dce2)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $62f438f453d8cb95$var$injectCommonNetworks();
        // Default network
        if (network == null) return $62f438f453d8cb95$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $62f438f453d8cb95$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $62f438f453d8cb95$export$95be4ae94445245a("unknown", network);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $62f438f453d8cb95$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $e4aa0ad52dbf41a0$export$9be0b2c573890879)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $62f438f453d8cb95$var$Networks.get(nameOrChainId);
        if (existing) (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $62f438f453d8cb95$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $62f438f453d8cb95$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $62f438f453d8cb95$var$getGasStationPlugin(url) {
    return new (0, $e4aa0ad52dbf41a0$export$3bee30f9880d72e8)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $62f438f453d8cb95$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $62f438f453d8cb95$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $62f438f453d8cb95$var$injected = false;
function $62f438f453d8cb95$var$injectCommonNetworks() {
    if ($62f438f453d8cb95$var$injected) return;
    $62f438f453d8cb95$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $62f438f453d8cb95$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $e4aa0ad52dbf41a0$export$9be0b2c573890879)(null, options.ensNetwork));
            network.attachPlugin(new (0, $e4aa0ad52dbf41a0$export$f2b0810a2dd50377)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $62f438f453d8cb95$export$95be4ae94445245a.register(name, func);
        $62f438f453d8cb95$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $62f438f453d8cb95$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("linea-sepolia", 59141, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $62f438f453d8cb95$var$getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-amoy", 80002, {});
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $62f438f453d8cb95$var$getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}




function $9d0c485bde485e7a$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $9d0c485bde485e7a$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $9d0c485bde485e7a$export$aaf796a16ac1a157(provider);
    if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(event, 32)) return new $9d0c485bde485e7a$export$4fe8a9740765f97e(provider, event);
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $9d0c485bde485e7a$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $9d0c485bde485e7a$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $9d0c485bde485e7a$export$63862f83f14090ef extends $9d0c485bde485e7a$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $9d0c485bde485e7a$export$e4ed5c6414dc4e9e extends $9d0c485bde485e7a$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $9d0c485bde485e7a$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $9d0c485bde485e7a$export$4fe8a9740765f97e extends $9d0c485bde485e7a$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $9d0c485bde485e7a$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $9d0c485bde485e7a$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $9d0c485bde485e7a$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}


// Constants
const $65f802bdc11fcb97$var$BN_2 = BigInt(2);
const $65f802bdc11fcb97$var$MAX_CCIP_REDIRECTS = 10;
function $65f802bdc11fcb97$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $65f802bdc11fcb97$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $65f802bdc11fcb97$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $65f802bdc11fcb97$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $65f802bdc11fcb97$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $65f802bdc11fcb97$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $65f802bdc11fcb97$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $65f802bdc11fcb97$var$getTag("orphan", event),
            filter: $65f802bdc11fcb97$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $65f802bdc11fcb97$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $65f802bdc11fcb97$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $65f802bdc11fcb97$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unknown ProviderEvent", "event", _event);
}
function $65f802bdc11fcb97$var$getTime() {
    return new Date().getTime();
}
const $65f802bdc11fcb97$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $65f802bdc11fcb97$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $65f802bdc11fcb97$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $65f802bdc11fcb97$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $3d0b5969b3413cac$export$d96a8827a60d6b69)((0, $8473f4465021e175$export$ba1152bc4017d62a)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $3d0b5969b3413cac$export$ce30dbb46644d06c)((0, $8473f4465021e175$export$fccdbdc2b9d7893)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $3d0b5969b3413cac$export$375ffd5683aa5c1c)((0, $8473f4465021e175$export$30da670e49d6fc31)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $3d0b5969b3413cac$export$70966cdb3bfc0785)((0, $8473f4465021e175$export$fe50e42b325965d)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $7769476213c187e3$export$b14f2714108df84)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(blockTag)) {
            if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(blockTag, 32)) return blockTag;
            return (0, $7769476213c187e3$export$d9c067986dbc68dd)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $7769476213c187e3$export$b14f2714108df84)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $7769476213c187e3$export$d9c067986dbc68dd)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $7769476213c187e3$export$d9c067986dbc68dd)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $7769476213c187e3$export$d9c067986dbc68dd)(b + blockTag));
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $65f802bdc11fcb97$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $3d0b5969b3413cac$export$607b34cdac162b7f)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(request[key], this);
            if ($65f802bdc11fcb97$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($65f802bdc11fcb97$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $65f802bdc11fcb97$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $3d0b5969b3413cac$export$116c49c1e2a96a78)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $3d0b5969b3413cac$export$116c49c1e2a96a78)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($65f802bdc11fcb97$var$isPromise(tx)) tx = await tx;
        return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(attempt < $65f802bdc11fcb97$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $3d0b5969b3413cac$export$607b34cdac162b7f)(tx);
        try {
            return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $205dffdfdb79d607$export$748c4fa78f31ff35)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $85f03119331e3531$export$f6d845ffb449edc9)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $65f802bdc11fcb97$var$parseOffchainLookup((0, $85f03119331e3531$export$f6d845ffb449edc9)(error.data, 4));
                } catch (error) {
                    (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $85f03119331e3531$export$ee1b3e54f0441b22)([
                        ccipArgs.selector,
                        $65f802bdc11fcb97$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $7769476213c187e3$export$61fe455e2b1e28a4)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $7769476213c187e3$export$b14f2714108df84)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(_position, "position");
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $1c7938633fcd26f1$export$febc5573c75cefb0).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $85f03119331e3531$export$b02a40aff8e4ad18)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($65f802bdc11fcb97$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $e3bcb0f775b38be9$export$d04afd034a0a53ae).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $0dc837b8e002cdcf$export$88411125f012957a)(address);
        const node = (0, $165031ad81d38919$export$91d651ee363e1209)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $e3bcb0f775b38be9$export$d04afd034a0a53ae).getEnsAddress(this);
            const ensContract = new (0, $f72016e2a99839eb$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $7675f23517409f7b$export$b7cbe423ba83da17)) return null;
            const resolverContract = new (0, $f72016e2a99839eb$export$8517d80acf00e19a)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $65f802bdc11fcb97$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $65f802bdc11fcb97$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $9d0c485bde485e7a$export$aaf796a16ac1a157)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $9d0c485bde485e7a$export$63862f83f14090ef)(this, sub.type);
            case "event":
                return new (0, $9d0c485bde485e7a$export$bdb759dc2fe68c72)(this, sub.filter);
            case "transaction":
                return new (0, $9d0c485bde485e7a$export$4fe8a9740765f97e)(this, sub.hash);
            case "orphan":
                return new (0, $9d0c485bde485e7a$export$e4ed5c6414dc4e9e)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $65f802bdc11fcb97$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $65f802bdc11fcb97$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $65f802bdc11fcb97$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $736380c8f0fd32e2$export$9cec82196983b278)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $65f802bdc11fcb97$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $65f802bdc11fcb97$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $65f802bdc11fcb97$var$_parseString(result, start) {
    try {
        const bytes = $65f802bdc11fcb97$var$_parseBytes(result, start);
        if (bytes) return (0, $69bdbe979c9bc699$export$7643a1dc2c38d5eb)(bytes);
    } catch (error) {}
    return null;
}
function $65f802bdc11fcb97$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $7769476213c187e3$export$b14f2714108df84)((0, $85f03119331e3531$export$f6d845ffb449edc9)(result, start, start + 32));
        const length = (0, $7769476213c187e3$export$b14f2714108df84)((0, $85f03119331e3531$export$f6d845ffb449edc9)(result, offset, offset + 32));
        return (0, $85f03119331e3531$export$f6d845ffb449edc9)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $65f802bdc11fcb97$var$numPad(value) {
    const result = (0, $7769476213c187e3$export$b627fcfb5ea68cb0)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $65f802bdc11fcb97$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $65f802bdc11fcb97$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $65f802bdc11fcb97$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($65f802bdc11fcb97$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $85f03119331e3531$export$a3521add2594f3c8)(datas[i]);
        // Update the bytes offset
        result[i] = $65f802bdc11fcb97$var$numPad(byteCount);
        // The length and padded value of data
        result.push($65f802bdc11fcb97$var$numPad(data.length));
        result.push($65f802bdc11fcb97$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $85f03119331e3531$export$ee1b3e54f0441b22)(result);
}
const $65f802bdc11fcb97$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $65f802bdc11fcb97$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $205dffdfdb79d607$export$a7a9523472993e97)((0, $85f03119331e3531$export$2321cd91b99770ff)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 0, 32);
    (0, $205dffdfdb79d607$export$a7a9523472993e97)((0, $85f03119331e3531$export$f6d845ffb449edc9)(sender, 0, 12) === (0, $85f03119331e3531$export$f6d845ffb449edc9)($65f802bdc11fcb97$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $85f03119331e3531$export$f6d845ffb449edc9)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $7769476213c187e3$export$b14f2714108df84)((0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 32, 64));
        const urlsLength = (0, $7769476213c187e3$export$b14f2714108df84)((0, $85f03119331e3531$export$f6d845ffb449edc9)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $85f03119331e3531$export$f6d845ffb449edc9)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $65f802bdc11fcb97$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $65f802bdc11fcb97$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $205dffdfdb79d607$export$a7a9523472993e97)((0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 100, 128) === (0, $85f03119331e3531$export$f6d845ffb449edc9)($65f802bdc11fcb97$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $85f03119331e3531$export$f6d845ffb449edc9)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $65f802bdc11fcb97$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}


/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 



function $c4e54636bb22972b$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $c4e54636bb22972b$var$populate(signer, tx) {
    let pop = (0, $3d0b5969b3413cac$export$607b34cdac162b7f)(tx);
    if (pop.to != null) pop.to = (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(from, signer)
        ]).then(([address, from])=>{
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $2323980ce672c824$export$d503dd157d963b60)(pop);
}
class $c4e54636bb22972b$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $c4e54636bb22972b$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $c4e54636bb22972b$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $c4e54636bb22972b$var$checkProvider(this, "populateTransaction");
        const pop = await $c4e54636bb22972b$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $7769476213c187e3$export$61fe455e2b1e28a4)(pop.chainId);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $205dffdfdb79d607$export$a7a9523472993e97)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2 || pop.type === 3) {
                // Explicitly using EIP-1559 or EIP-4844
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $2323980ce672c824$export$d503dd157d963b60)(pop);
    }
    async estimateGas(tx) {
        return $c4e54636bb22972b$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $c4e54636bb22972b$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $c4e54636bb22972b$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $c4e54636bb22972b$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $1c7938633fcd26f1$export$febc5573c75cefb0).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $c4e54636bb22972b$export$7dbc56d9b9612bad extends $c4e54636bb22972b$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $c4e54636bb22972b$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}





function $8241c73f3114811f$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $8241c73f3114811f$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                if (this.#provider.destroyed) return;
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $8241c73f3114811f$export$60f65cdabb3c5771 extends $8241c73f3114811f$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $8241c73f3114811f$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $9d0c485bde485e7a$export$bdb759dc2fe68c72)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $8241c73f3114811f$export$285511066b2a5499 extends $8241c73f3114811f$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}



const $c946edca449b44d0$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $c946edca449b44d0$var$deepCopy(value) {
    if (value == null || $c946edca449b44d0$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($c946edca449b44d0$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $c946edca449b44d0$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $c946edca449b44d0$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $c946edca449b44d0$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $c946edca449b44d0$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $c946edca449b44d0$export$5f7b5fca3508545a extends (0, $c4e54636bb22972b$export$6c02143914c373f1) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $0dc837b8e002cdcf$export$88411125f012957a)(address);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $c946edca449b44d0$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(_from, this.provider);
                (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "CANCELLED") || (0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "BAD_DATA") || (0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $c946edca449b44d0$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(tx.from, this.provider);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $c946edca449b44d0$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $8326517c6a9958df$export$458ab927ae635c3).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $468ec04bb3c62bc6$export$687eed6b344123c9)(value);
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $8326517c6a9958df$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $69bdbe979c9bc699$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(message)
        ]);
    }
}
class $c946edca449b44d0$export$5afe35a44ca7ff9a extends (0, $65f802bdc11fcb97$export$ae9650e85fb229fe) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $c946edca449b44d0$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $7769476213c187e3$export$61fe455e2b1e28a4)(tx.type)) // If there are no EIP-1559 or newer properties, it might be pre-EIP-1559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $62f438f453d8cb95$export$95be4ae94445245a).from((0, $7769476213c187e3$export$61fe455e2b1e28a4)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $62f438f453d8cb95$export$95be4ae94445245a).from((0, $7769476213c187e3$export$61fe455e2b1e28a4)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $c946edca449b44d0$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $8241c73f3114811f$export$285511066b2a5499)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $9d0c485bde485e7a$export$bdb759dc2fe68c72)(this, sub.filter);
            return new (0, $8241c73f3114811f$export$60f65cdabb3c5771)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $65f802bdc11fcb97$export$f255b979f86248fa)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $7769476213c187e3$export$d9c067986dbc68dd)((0, $7769476213c187e3$export$61fe455e2b1e28a4)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $54c23e469e18e47c$export$6c8662b1600dce2)(tx.accessList);
        if (tx.blobVersionedHashes) // @TODO: Remove this <any> case once EIP-4844 added to prepared tx
        result["blobVersionedHashes"] = tx.blobVersionedHashes.map((h)=>h.toLowerCase());
        // @TODO: blobs should probably also be copied over, optionally
        // accounting for the kzg property to backfill blobVersionedHashes
        // using the commitment. Or should that be left as an exercise to
        // the caller?
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $c946edca449b44d0$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $c946edca449b44d0$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $c946edca449b44d0$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $c946edca449b44d0$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($c946edca449b44d0$var$getLowerCase);
                    else req.filter.address = $c946edca449b44d0$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $c946edca449b44d0$var$spelunkData(error);
            const e = (0, $7c4fa628ce8062db$export$fe041e1a83d3efc6).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($c946edca449b44d0$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $c946edca449b44d0$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $0dc837b8e002cdcf$export$88411125f012957a)(address);
        for (const account of accounts){
            if ((0, $0dc837b8e002cdcf$export$88411125f012957a)(account) === address) return new $c946edca449b44d0$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $c946edca449b44d0$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $c946edca449b44d0$export$e16ffa1aa36d1432 extends $c946edca449b44d0$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        let pollingInterval = this._getOption("pollingInterval");
        if (pollingInterval == null) pollingInterval = $c946edca449b44d0$var$defaultOptions.pollingInterval;
        this.#pollingInterval = pollingInterval;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($c946edca449b44d0$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($c946edca449b44d0$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $c946edca449b44d0$export$da28308012bf6748 extends $c946edca449b44d0$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $c946edca449b44d0$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $85f03119331e3531$export$b02a40aff8e4ad18)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $c946edca449b44d0$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $c946edca449b44d0$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $c946edca449b44d0$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$c946edca449b44d0$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $c946edca449b44d0$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $c946edca449b44d0$var$spelunkMessage(value) {
    const result = [];
    $c946edca449b44d0$var$_spelunkMessage(value, result);
    return result;
}


class $0b5eb0c0b0db8127$export$8d50d0931f78dec8 extends (0, $c946edca449b44d0$export$e16ffa1aa36d1432) {
    #request;
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */ constructor(ethereum, network, _options){
        // Copy the options
        const options = Object.assign({}, _options != null ? _options : {}, {
            batchMaxCount: 1
        });
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(ethereum && ethereum.request, "invalid EIP-1193 provider", "ethereum", ethereum);
        super(network, options);
        this.#request = async (method, params)=>{
            const payload = {
                method: method,
                params: params
            };
            this.emit("debug", {
                action: "sendEip1193Request",
                payload: payload
            });
            try {
                const result = await ethereum.request(payload);
                this.emit("debug", {
                    action: "receiveEip1193Result",
                    result: result
                });
                return result;
            } catch (e) {
                const error = new Error(e.message);
                error.code = e.code;
                error.data = e.data;
                error.payload = payload;
                this.emit("debug", {
                    action: "receiveEip1193Error",
                    error: error
                });
                throw error;
            }
        };
    }
    async send(method, params) {
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
        try {
            const result = await this.#request(payload.method, payload.params || []);
            return [
                {
                    id: payload.id,
                    result: result
                }
            ];
        } catch (e) {
            return [
                {
                    id: payload.id,
                    error: {
                        code: e.code,
                        data: e.data,
                        message: e.message
                    }
                }
            ];
        }
    }
    getRpcError(payload, error) {
        error = JSON.parse(JSON.stringify(error));
        // EIP-1193 gives us some machine-readable error codes, so rewrite
        // them into 
        switch(error.error.code || -1){
            case 4001:
                error.error.message = `ethers-user-denied: ${error.error.message}`;
                break;
            case 4200:
                error.error.message = `ethers-unsupported: ${error.error.message}`;
                break;
        }
        return super.getRpcError(payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */ async hasSigner(address) {
        if (address == null) address = 0;
        const accounts = await this.send("eth_accounts", []);
        if (typeof address === "number") return accounts.length > address;
        address = address.toLowerCase();
        return accounts.filter((a)=>a.toLowerCase() === address).length !== 0;
    }
    async getSigner(address) {
        if (address == null) address = 0;
        if (!await this.hasSigner(address)) try {
            //const resp = 
            await this.#request("eth_requestAccounts", []);
        //console.log("RESP", resp);
        } catch (error) {
            const payload = error.payload;
            throw this.getRpcError(payload, {
                id: payload.id,
                error: error
            });
        }
        return await super.getSigner(address);
    }
}


/**
 *  [[link-ankr]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - BNB (``bnb``)
 *  - BNB Testnet (``bnbt``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:Ankr  [providers-ankr]
 */ 
/**
 *  There are many awesome community services that provide Ethereum
 *  nodes both for developers just starting out and for large-scale
 *  communities.
 *
 *  @_section: api/providers/thirdparty: Community Providers  [thirdparty]
 */ // Show the throttle message only once per service
const $36722169de5041ab$var$shown = new Set();
function $36722169de5041ab$export$4c41bd49e82e82ab(service) {
    if ($36722169de5041ab$var$shown.has(service)) return;
    $36722169de5041ab$var$shown.add(service);
    console.log("========= NOTICE =========");
    console.log(`Request-Rate Exceeded for ${service} (this message will not be repeated)`);
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.org/api-keys/");
    console.log("==========================");
}




const $86c088dee19c0086$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $86c088dee19c0086$var$getHost(name) {
    switch(name){
        case "mainnet":
            return "rpc.ankr.com/eth";
        case "goerli":
            return "rpc.ankr.com/eth_goerli";
        case "sepolia":
            return "rpc.ankr.com/eth_sepolia";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum";
        case "base":
            return "rpc.ankr.com/base";
        case "base-goerli":
            return "rpc.ankr.com/base_goerli";
        case "base-sepolia":
            return "rpc.ankr.com/base_sepolia";
        case "bnb":
            return "rpc.ankr.com/bsc";
        case "bnbt":
            return "rpc.ankr.com/bsc_testnet_chapel";
        case "matic":
            return "rpc.ankr.com/polygon";
        case "matic-mumbai":
            return "rpc.ankr.com/polygon_mumbai";
        case "optimism":
            return "rpc.ankr.com/optimism";
        case "optimism-goerli":
            return "rpc.ankr.com/optimism_testnet";
        case "optimism-sepolia":
            return "rpc.ankr.com/optimism_sepolia";
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
class $86c088dee19c0086$export$72783b2aefa72a45 extends (0, $c946edca449b44d0$export$da28308012bf6748) {
    /**
     *  The API key for the Ankr connection.
     */ apiKey;
    /**
     *  Create a new **AnkrProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */ constructor(_network, apiKey){
        if (_network == null) _network = "mainnet";
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        if (apiKey == null) apiKey = $86c088dee19c0086$var$defaultApiKey;
        // Ankr does not support filterId, so we force polling
        const options = {
            polling: true,
            staticNetwork: network
        };
        const request = $86c088dee19c0086$export$72783b2aefa72a45.getRequest(network, apiKey);
        super(request, network, options);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            apiKey: apiKey
        });
    }
    _getProvider(chainId) {
        try {
            return new $86c088dee19c0086$export$72783b2aefa72a45(chainId, this.apiKey);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%apiKey%%.
     */ static getRequest(network, apiKey) {
        if (apiKey == null) apiKey = $86c088dee19c0086$var$defaultApiKey;
        const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(`https:/\/${$86c088dee19c0086$var$getHost(network.name)}/${apiKey}`);
        request.allowGzip = true;
        if (apiKey === $86c088dee19c0086$var$defaultApiKey) request.retryFunc = async (request, response, attempt)=>{
            (0, $36722169de5041ab$export$4c41bd49e82e82ab)("AnkrProvider");
            return true;
        };
        return request;
    }
    getRpcError(payload, error) {
        if (payload.method === "eth_sendRawTransaction") {
            if (error && error.error && error.error.message === "INTERNAL_ERROR: could not replace existing tx") error.error.message = "replacement transaction underpriced";
        }
        return super.getRpcError(payload, error);
    }
    isCommunityResource() {
        return this.apiKey === $86c088dee19c0086$var$defaultApiKey;
    }
}


/**
 *  [[link-alchemy]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Amoy Testnet (``matic-amoy``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:Alchemy  [providers-alchemy]
 */ 



const $1a788c9cf9449553$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
function $1a788c9cf9449553$var$getHost(name) {
    switch(name){
        case "mainnet":
            return "eth-mainnet.alchemyapi.io";
        case "goerli":
            return "eth-goerli.g.alchemy.com";
        case "sepolia":
            return "eth-sepolia.g.alchemy.com";
        case "arbitrum":
            return "arb-mainnet.g.alchemy.com";
        case "arbitrum-goerli":
            return "arb-goerli.g.alchemy.com";
        case "arbitrum-sepolia":
            return "arb-sepolia.g.alchemy.com";
        case "base":
            return "base-mainnet.g.alchemy.com";
        case "base-goerli":
            return "base-goerli.g.alchemy.com";
        case "base-sepolia":
            return "base-sepolia.g.alchemy.com";
        case "matic":
            return "polygon-mainnet.g.alchemy.com";
        case "matic-amoy":
            return "polygon-amoy.g.alchemy.com";
        case "matic-mumbai":
            return "polygon-mumbai.g.alchemy.com";
        case "optimism":
            return "opt-mainnet.g.alchemy.com";
        case "optimism-goerli":
            return "opt-goerli.g.alchemy.com";
        case "optimism-sepolia":
            return "opt-sepolia.g.alchemy.com";
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
class $1a788c9cf9449553$export$999cc40da3fbc6f extends (0, $c946edca449b44d0$export$da28308012bf6748) {
    apiKey;
    constructor(_network, apiKey){
        if (_network == null) _network = "mainnet";
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        if (apiKey == null) apiKey = $1a788c9cf9449553$var$defaultApiKey;
        const request = $1a788c9cf9449553$export$999cc40da3fbc6f.getRequest(network, apiKey);
        super(request, network, {
            staticNetwork: network
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            apiKey: apiKey
        });
    }
    _getProvider(chainId) {
        try {
            return new $1a788c9cf9449553$export$999cc40da3fbc6f(chainId, this.apiKey);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    async _perform(req) {
        // https://docs.alchemy.com/reference/trace-transaction
        if (req.method === "getTransactionResult") {
            const { trace: trace, tx: tx } = await (0, $2323980ce672c824$export$d503dd157d963b60)({
                trace: this.send("trace_transaction", [
                    req.hash
                ]),
                tx: this.getTransaction(req.hash)
            });
            if (trace == null || tx == null) return null;
            let data;
            let error = false;
            try {
                data = trace[0].result.output;
                error = trace[0].error === "Reverted";
            } catch (error) {}
            if (data) {
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(!error, "an error occurred during transaction executions", "CALL_EXCEPTION", {
                    action: "getTransactionResult",
                    data: data,
                    reason: null,
                    transaction: tx,
                    invocation: null,
                    revert: null // @TODO
                });
                return data;
            }
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "could not parse trace result", "BAD_DATA", {
                value: trace
            });
        }
        return await super._perform(req);
    }
    isCommunityResource() {
        return this.apiKey === $1a788c9cf9449553$var$defaultApiKey;
    }
    static getRequest(network, apiKey) {
        if (apiKey == null) apiKey = $1a788c9cf9449553$var$defaultApiKey;
        const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(`https:/\/${$1a788c9cf9449553$var$getHost(network.name)}/v2/${apiKey}`);
        request.allowGzip = true;
        if (apiKey === $1a788c9cf9449553$var$defaultApiKey) request.retryFunc = async (request, response, attempt)=>{
            (0, $36722169de5041ab$export$4c41bd49e82e82ab)("alchemy");
            return true;
        };
        return request;
    }
}


/**
 *  [[link-chainstack]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Arbitrum (``arbitrum``)
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - Polygon (``matic``)
 *
 *  @_subsection: api/providers/thirdparty:Chainstack  [providers-chainstack]
 */ 



function $f155c21e39c5e127$var$getApiKey(name) {
    switch(name){
        case "mainnet":
            return "39f1d67cedf8b7831010a665328c9197";
        case "arbitrum":
            return "0550c209db33c3abf4cc927e1e18cea1";
        case "bnb":
            return "98b5a77e531614387366f6fc5da097f8";
        case "matic":
            return "cd9d4d70377471aa7c142ec4a4205249";
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
function $f155c21e39c5e127$var$getHost(name) {
    switch(name){
        case "mainnet":
            return "ethereum-mainnet.core.chainstack.com";
        case "arbitrum":
            return "arbitrum-mainnet.core.chainstack.com";
        case "bnb":
            return "bsc-mainnet.core.chainstack.com";
        case "matic":
            return "polygon-mainnet.core.chainstack.com";
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
class $f155c21e39c5e127$export$b6f0a46407d1854c extends (0, $c946edca449b44d0$export$da28308012bf6748) {
    /**
     *  The API key for the Chainstack connection.
     */ apiKey;
    /**
     *  Creates a new **ChainstackProvider**.
     */ constructor(_network, apiKey){
        if (_network == null) _network = "mainnet";
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        if (apiKey == null) apiKey = $f155c21e39c5e127$var$getApiKey(network.name);
        const request = $f155c21e39c5e127$export$b6f0a46407d1854c.getRequest(network, apiKey);
        super(request, network, {
            staticNetwork: network
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            apiKey: apiKey
        });
    }
    _getProvider(chainId) {
        try {
            return new $f155c21e39c5e127$export$b6f0a46407d1854c(chainId, this.apiKey);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    isCommunityResource() {
        return this.apiKey === $f155c21e39c5e127$var$getApiKey(this._network.name);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%apiKey%% and %%projectSecret%%.
     */ static getRequest(network, apiKey) {
        if (apiKey == null) apiKey = $f155c21e39c5e127$var$getApiKey(network.name);
        const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(`https:/\/${$f155c21e39c5e127$var$getHost(network.name)}/${apiKey}`);
        request.allowGzip = true;
        if (apiKey === $f155c21e39c5e127$var$getApiKey(network.name)) request.retryFunc = async (request, response, attempt)=>{
            (0, $36722169de5041ab$export$4c41bd49e82e82ab)("ChainstackProvider");
            return true;
        };
        return request;
    }
}


/**
 *  About Cloudflare
 *
 *  @_subsection: api/providers/thirdparty:Cloudflare  [providers-cloudflare]
 */ 


class $77d2c9a753aabf67$export$7113381f8f264fc0 extends (0, $c946edca449b44d0$export$da28308012bf6748) {
    constructor(_network){
        if (_network == null) _network = "mainnet";
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(network.name === "mainnet", "unsupported network", "network", _network);
        super("https://cloudflare-eth.com/", network, {
            staticNetwork: network
        });
    }
}


/**
 *  [[link-etherscan]] provides a third-party service for connecting to
 *  various blockchains over a combination of JSON-RPC and custom API
 *  endpoints.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Holesky Testnet (``holesky``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Base (``base``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - BNB Smart Chain Testnet (``bnbt``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *  - Polygon Amoy Testnet (``matic-amoy``)
 *
 *  @_subsection api/providers/thirdparty:Etherscan  [providers-etherscan]
 */ 







const $7002dd2f4d24da26$var$THROTTLE = 2000;
function $7002dd2f4d24da26$var$isPromise(value) {
    return value && typeof value.then === "function";
}
const $7002dd2f4d24da26$var$EtherscanPluginId = "org.ethers.plugins.provider.Etherscan";
class $7002dd2f4d24da26$export$e16eda821cd9393f extends (0, $e4aa0ad52dbf41a0$export$10ae60faeb7e2196) {
    /**
     *  The Etherscan API base URL.
     */ baseUrl;
    /**
     *  Creates a new **EtherscanProvider** which will use
     *  %%baseUrl%%.
     */ constructor(baseUrl){
        super($7002dd2f4d24da26$var$EtherscanPluginId);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            baseUrl: baseUrl
        });
    }
    clone() {
        return new $7002dd2f4d24da26$export$e16eda821cd9393f(this.baseUrl);
    }
}
const $7002dd2f4d24da26$var$skipKeys = [
    "enableCcipRead"
];
let $7002dd2f4d24da26$var$nextId = 1;
class $7002dd2f4d24da26$export$dd1d942a536c7912 extends (0, $65f802bdc11fcb97$export$ae9650e85fb229fe) {
    /**
     *  The connected network.
     */ network;
    /**
     *  The API key or null if using the community provided bandwidth.
     */ apiKey;
    #plugin;
    /**
     *  Creates a new **EtherscanBaseProvider**.
     */ constructor(_network, _apiKey){
        const apiKey = _apiKey != null ? _apiKey : null;
        super();
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        this.#plugin = network.getPlugin($7002dd2f4d24da26$var$EtherscanPluginId);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            apiKey: apiKey,
            network: network
        });
        // Test that the network is supported by Etherscan
        this.getBaseUrl();
    }
    /**
     *  Returns the base URL.
     *
     *  If an [[EtherscanPlugin]] is configured on the
     *  [[EtherscanBaseProvider_network]], returns the plugin's
     *  baseUrl.
     */ getBaseUrl() {
        if (this.#plugin) return this.#plugin.baseUrl;
        switch(this.network.name){
            case "mainnet":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "holesky":
                return "https://api-holesky.etherscan.io";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "base":
                return "https://api.basescan.org";
            case "base-sepolia":
                return "https://api-sepolia.basescan.org";
            case "bnb":
                return "https://api.bscscan.com";
            case "bnbt":
                return "https://api-testnet.bscscan.com";
            case "matic":
                return "https://api.polygonscan.com";
            case "matic-amoy":
                return "https://api-amoy.polygonscan.com";
            case "matic-mumbai":
                return "https://api-testnet.polygonscan.com";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", this.network);
    }
    /**
     *  Returns the URL for the %%module%% and %%params%%.
     */ getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.getBaseUrl()}/api?module=${module}${query}${apiKey}`;
    }
    /**
     *  Returns the URL for using POST requests.
     */ getPostUrl() {
        return `${this.getBaseUrl()}/api`;
    }
    /**
     *  Returns the parameters for using POST requests.
     */ getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    async detectNetwork() {
        return this.network;
    }
    /**
     *  Resolves to the result of calling %%module%% with %%params%%.
     *
     *  If %%post%%, the request is made as a POST request.
     */ async fetch(module, params, post) {
        const id = $7002dd2f4d24da26$var$nextId++;
        const url = post ? this.getPostUrl() : this.getUrl(module, params);
        const payload = post ? this.getPostData(module, params) : null;
        this.emit("debug", {
            action: "sendRequest",
            id: id,
            url: url,
            payload: payload
        });
        const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(url);
        request.setThrottleParams({
            slotInterval: 1000
        });
        request.retryFunc = (req, resp, attempt)=>{
            if (this.isCommunityResource()) (0, $36722169de5041ab$export$4c41bd49e82e82ab)("Etherscan");
            return Promise.resolve(true);
        };
        request.processFunc = async (request, response)=>{
            const result = response.hasBody() ? JSON.parse((0, $69bdbe979c9bc699$export$7643a1dc2c38d5eb)(response.body)) : {};
            const throttle = (typeof result.result === "string" ? result.result : "").toLowerCase().indexOf("rate limit") >= 0;
            if (module === "proxy") // This JSON response indicates we are being throttled
            {
                if (result && result.status == 0 && result.message == "NOTOK" && throttle) {
                    this.emit("debug", {
                        action: "receiveError",
                        id: id,
                        reason: "proxy-NOTOK",
                        error: result
                    });
                    response.throwThrottleError(result.result, $7002dd2f4d24da26$var$THROTTLE);
                }
            } else if (throttle) {
                this.emit("debug", {
                    action: "receiveError",
                    id: id,
                    reason: "null result",
                    error: result.result
                });
                response.throwThrottleError(result.result, $7002dd2f4d24da26$var$THROTTLE);
            }
            return response;
        };
        if (payload) {
            request.setHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8");
            request.body = Object.keys(payload).map((k)=>`${k}=${payload[k]}`).join("&");
        }
        const response = await request.send();
        try {
            response.assertOk();
        } catch (error) {
            this.emit("debug", {
                action: "receiveError",
                id: id,
                error: error,
                reason: "assertOk"
            });
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "response error", "SERVER_ERROR", {
                request: request,
                response: response
            });
        }
        if (!response.hasBody()) {
            this.emit("debug", {
                action: "receiveError",
                id: id,
                error: "missing body",
                reason: "null body"
            });
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "missing response", "SERVER_ERROR", {
                request: request,
                response: response
            });
        }
        const result = JSON.parse((0, $69bdbe979c9bc699$export$7643a1dc2c38d5eb)(response.body));
        if (module === "proxy") {
            if (result.jsonrpc != "2.0") {
                this.emit("debug", {
                    action: "receiveError",
                    id: id,
                    result: result,
                    reason: "invalid JSON-RPC"
                });
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "invalid JSON-RPC response (missing jsonrpc='2.0')", "SERVER_ERROR", {
                    request: request,
                    response: response,
                    info: {
                        result: result
                    }
                });
            }
            if (result.error) {
                this.emit("debug", {
                    action: "receiveError",
                    id: id,
                    result: result,
                    reason: "JSON-RPC error"
                });
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "error response", "SERVER_ERROR", {
                    request: request,
                    response: response,
                    info: {
                        result: result
                    }
                });
            }
            this.emit("debug", {
                action: "receiveRequest",
                id: id,
                result: result
            });
            return result.result;
        } else {
            // getLogs, getHistory have weird success responses
            if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) {
                this.emit("debug", {
                    action: "receiveRequest",
                    id: id,
                    result: result
                });
                return result.result;
            }
            if (result.status != 1 || typeof result.message === "string" && !result.message.match(/^OK/)) {
                this.emit("debug", {
                    action: "receiveError",
                    id: id,
                    result: result
                });
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "error response", "SERVER_ERROR", {
                    request: request,
                    response: response,
                    info: {
                        result: result
                    }
                });
            }
            this.emit("debug", {
                action: "receiveRequest",
                id: id,
                result: result
            });
            return result.result;
        }
    }
    /**
     *  Returns %%transaction%% normalized for the Etherscan API.
     */ _getTransactionPostData(transaction) {
        const result = {};
        for(let key in transaction){
            if ($7002dd2f4d24da26$var$skipKeys.indexOf(key) >= 0) continue;
            if (transaction[key] == null) continue;
            let value = transaction[key];
            if (key === "type" && value === 0) continue;
            if (key === "blockTag" && value === "latest") continue;
            // Quantity-types require no leading zero, unless 0
            if (({
                type: true,
                gasLimit: true,
                gasPrice: true,
                maxFeePerGs: true,
                maxPriorityFeePerGas: true,
                nonce: true,
                value: true
            })[key]) value = (0, $7769476213c187e3$export$d9c067986dbc68dd)(value);
            else if (key === "accessList") value = "[" + (0, $54c23e469e18e47c$export$6c8662b1600dce2)(value).map((set)=>{
                return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
            }).join(",") + "]";
            else if (key === "blobVersionedHashes") {
                if (value.length === 0) continue;
                // @TODO: update this once the API supports blobs
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "Etherscan API does not support blobVersionedHashes", "UNSUPPORTED_OPERATION", {
                    operation: "_getTransactionPostData",
                    info: {
                        transaction: transaction
                    }
                });
            } else value = (0, $85f03119331e3531$export$2b0d6b5fbe698c70)(value);
            result[key] = value;
        }
        return result;
    }
    /**
     *  Throws the normalized Etherscan error.
     */ _checkError(req, error, transaction) {
        // Pull any message out if, possible
        let message = "";
        if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(error, "SERVER_ERROR")) {
            // Check for an error emitted by a proxy call
            try {
                message = error.info.result.error.message;
            } catch (e) {}
            if (!message) try {
                message = error.info.message;
            } catch (e) {}
        }
        if (req.method === "estimateGas") {
            if (!message.match(/revert/i) && message.match(/insufficient funds/i)) (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: req.transaction
            });
        }
        if (req.method === "call" || req.method === "estimateGas") {
            if (message.match(/execution reverted/i)) {
                let data = "";
                try {
                    data = error.info.result.error.data;
                } catch (error) {}
                const e = (0, $7c4fa628ce8062db$export$fe041e1a83d3efc6).getBuiltinCallException(req.method, req.transaction, data);
                e.info = {
                    request: req,
                    error: error
                };
                throw e;
            }
        }
        if (message) {
            if (req.method === "broadcastTransaction") {
                const transaction = (0, $1c7938633fcd26f1$export$febc5573c75cefb0).from(req.signedTransaction);
                if (message.match(/replacement/i) && message.match(/underpriced/i)) (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                    transaction: transaction
                });
                if (message.match(/insufficient funds/)) (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                    transaction: transaction
                });
                if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "nonce has already been used", "NONCE_EXPIRED", {
                    transaction: transaction
                });
            }
        }
        // Something we could not process
        throw error;
    }
    async _detectNetwork() {
        return this.network;
    }
    async _perform(req) {
        switch(req.method){
            case "chainId":
                return this.network.chainId;
            case "getBlockNumber":
                return this.fetch("proxy", {
                    action: "eth_blockNumber"
                });
            case "getGasPrice":
                return this.fetch("proxy", {
                    action: "eth_gasPrice"
                });
            case "getPriorityFee":
                // This is temporary until Etherscan completes support
                if (this.network.name === "mainnet") return "1000000000";
                else if (this.network.name === "optimism") return "1000000";
                else throw new Error("fallback onto the AbstractProvider default");
            /* Working with Etherscan to get this added:
            try {
                const test = await this.fetch("proxy", {
                    action: "eth_maxPriorityFeePerGas"
                });
                console.log(test);
                return test;
            } catch (e) {
                console.log("DEBUG", e);
                throw e;
            }
            */ /* This might be safe; but due to rounding neither myself
               or Etherscan are necessarily comfortable with this. :)
            try {
                const result = await this.fetch("gastracker", { action: "gasoracle" });
                console.log(result);
                const gasPrice = parseUnits(result.SafeGasPrice, "gwei");
                const baseFee = parseUnits(result.suggestBaseFee, "gwei");
                const priorityFee = gasPrice - baseFee;
                if (priorityFee < 0) { throw new Error("negative priority fee; defer to abstract provider default"); }
                return priorityFee;
            } catch (error) {
                console.log("DEBUG", error);
                throw error;
            }
            */ case "getBalance":
                // Returns base-10 result
                return this.fetch("account", {
                    action: "balance",
                    address: req.address,
                    tag: req.blockTag
                });
            case "getTransactionCount":
                return this.fetch("proxy", {
                    action: "eth_getTransactionCount",
                    address: req.address,
                    tag: req.blockTag
                });
            case "getCode":
                return this.fetch("proxy", {
                    action: "eth_getCode",
                    address: req.address,
                    tag: req.blockTag
                });
            case "getStorage":
                return this.fetch("proxy", {
                    action: "eth_getStorageAt",
                    address: req.address,
                    position: req.position,
                    tag: req.blockTag
                });
            case "broadcastTransaction":
                return this.fetch("proxy", {
                    action: "eth_sendRawTransaction",
                    hex: req.signedTransaction
                }, true).catch((error)=>{
                    return this._checkError(req, error, req.signedTransaction);
                });
            case "getBlock":
                if ("blockTag" in req) return this.fetch("proxy", {
                    action: "eth_getBlockByNumber",
                    tag: req.blockTag,
                    boolean: req.includeTransactions ? "true" : "false"
                });
                (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "getBlock by blockHash not supported by Etherscan", "UNSUPPORTED_OPERATION", {
                    operation: "getBlock(blockHash)"
                });
            case "getTransaction":
                return this.fetch("proxy", {
                    action: "eth_getTransactionByHash",
                    txhash: req.hash
                });
            case "getTransactionReceipt":
                return this.fetch("proxy", {
                    action: "eth_getTransactionReceipt",
                    txhash: req.hash
                });
            case "call":
                {
                    if (req.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                    const postData = this._getTransactionPostData(req.transaction);
                    postData.module = "proxy";
                    postData.action = "eth_call";
                    try {
                        return await this.fetch("proxy", postData, true);
                    } catch (error) {
                        return this._checkError(req, error, req.transaction);
                    }
                }
            case "estimateGas":
                {
                    const postData = this._getTransactionPostData(req.transaction);
                    postData.module = "proxy";
                    postData.action = "eth_estimateGas";
                    try {
                        return await this.fetch("proxy", postData, true);
                    } catch (error) {
                        return this._checkError(req, error, req.transaction);
                    }
                }
            /*
                        case "getLogs": {
                            // Needs to complain if more than one address is passed in
                            const args: Record<string, any> = { action: "getLogs" }
            
                            if (params.filter.fromBlock) {
                                args.fromBlock = checkLogTag(params.filter.fromBlock);
                            }
            
                            if (params.filter.toBlock) {
                                args.toBlock = checkLogTag(params.filter.toBlock);
                            }
            
                            if (params.filter.address) {
                                args.address = params.filter.address;
                            }
            
                            // @TODO: We can handle slightly more complicated logs using the logs API
                            if (params.filter.topics && params.filter.topics.length > 0) {
                                if (params.filter.topics.length > 1) {
                                    logger.throwError("unsupported topic count", Logger.Errors.UNSUPPORTED_OPERATION, { topics: params.filter.topics });
                                }
                                if (params.filter.topics.length === 1) {
                                    const topic0 = params.filter.topics[0];
                                    if (typeof(topic0) !== "string" || topic0.length !== 66) {
                                        logger.throwError("unsupported topic format", Logger.Errors.UNSUPPORTED_OPERATION, { topic0: topic0 });
                                    }
                                    args.topic0 = topic0;
                                }
                            }
            
                            const logs: Array<any> = await this.fetch("logs", args);
            
                            // Cache txHash => blockHash
                            let blocks: { [tag: string]: string } = {};
            
                            // Add any missing blockHash to the logs
                            for (let i = 0; i < logs.length; i++) {
                                const log = logs[i];
                                if (log.blockHash != null) { continue; }
                                if (blocks[log.blockNumber] == null) {
                                    const block = await this.getBlock(log.blockNumber);
                                    if (block) {
                                        blocks[log.blockNumber] = block.hash;
                                    }
                                }
            
                                log.blockHash = blocks[log.blockNumber];
                            }
            
                            return logs;
                        }
            */ default:
                break;
        }
        return super._perform(req);
    }
    async getNetwork() {
        return this.network;
    }
    /**
     *  Resolves to the current price of ether.
     *
     *  This returns ``0`` on any network other than ``mainnet``.
     */ async getEtherPrice() {
        if (this.network.name !== "mainnet") return 0.0;
        return parseFloat((await this.fetch("stats", {
            action: "ethprice"
        })).ethusd);
    }
    /**
     *  Resolves to a [Contract]] for %%address%%, using the
     *  Etherscan API to retreive the Contract ABI.
     */ async getContract(_address) {
        let address = this._getAddress(_address);
        if ($7002dd2f4d24da26$var$isPromise(address)) address = await address;
        try {
            const resp = await this.fetch("contract", {
                action: "getabi",
                address: address
            });
            const abi = JSON.parse(resp);
            return new (0, $f72016e2a99839eb$export$8517d80acf00e19a)(address, abi, this);
        } catch (error) {
            return null;
        }
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}


/**
 *  [[link-infura]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - BNB Smart Chain Testnet (``bnbt``)
 *  - Linea (``linea``)
 *  - Linea Goerli Testnet (``linea-goerli``)
 *  - Linea Sepolia Testnet (``linea-sepolia``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Amoy Testnet (``matic-amoy``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:INFURA  [providers-infura]
 */ 



function $c9d028ca5b60e671$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $c9d028ca5b60e671$export$3909fb301d3dc8c9 = $c9d028ca5b60e671$var$getGlobal().WebSocket;


/**
 *  Generic long-lived socket provider.
 *
 *  Sub-classing notes
 *  - a sub-class MUST call the `_start()` method once connected
 *  - a sub-class MUST override the `_write(string)` method
 *  - a sub-class MUST call `_processMessage(string)` for each message
 *
 *  @_subsection: api/providers/abstract-provider:Socket Providers  [about-socketProvider]
 */ 


class $869c78967e643173$export$93f3aca769b589e9 {
    #provider;
    #filter;
    /**
     *  The filter.
     */ get filter() {
        return JSON.parse(this.#filter);
    }
    #filterId;
    #paused;
    #emitPromise;
    /**
     *  Creates a new **SocketSubscriber** attached to %%provider%% listening
     *  to %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = JSON.stringify(filter);
        this.#filterId = null;
        this.#paused = null;
        this.#emitPromise = null;
    }
    start() {
        this.#filterId = this.#provider.send("eth_subscribe", this.filter).then((filterId)=>{
            this.#provider._register(filterId, this);
            return filterId;
        });
    }
    stop() {
        this.#filterId.then((filterId)=>{
            if (this.#provider.destroyed) return;
            this.#provider.send("eth_unsubscribe", [
                filterId
            ]);
        });
        this.#filterId = null;
    }
    // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
    //        and resume
    pause(dropWhilePaused) {
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(dropWhilePaused, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", {
            operation: "pause(false)"
        });
        this.#paused = !!dropWhilePaused;
    }
    resume() {
        this.#paused = null;
    }
    /**
     *  @_ignore:
     */ _handleMessage(message) {
        if (this.#filterId == null) return;
        if (this.#paused === null) {
            let emitPromise = this.#emitPromise;
            if (emitPromise == null) emitPromise = this._emit(this.#provider, message);
            else emitPromise = emitPromise.then(async ()=>{
                await this._emit(this.#provider, message);
            });
            this.#emitPromise = emitPromise.then(()=>{
                if (this.#emitPromise === emitPromise) this.#emitPromise = null;
            });
        }
    }
    /**
     *  Sub-classes **must** override this to emit the events on the
     *  provider.
     */ async _emit(provider, message) {
        throw new Error("sub-classes must implemente this; _emit");
    }
}
class $869c78967e643173$export$c41c8e39180b7cbc extends $869c78967e643173$export$93f3aca769b589e9 {
    /**
     *  @_ignore:
     */ constructor(provider){
        super(provider, [
            "newHeads"
        ]);
    }
    async _emit(provider, message) {
        provider.emit("block", parseInt(message.number));
    }
}
class $869c78967e643173$export$a974d62bd7e1dc1f extends $869c78967e643173$export$93f3aca769b589e9 {
    /**
     *  @_ignore:
     */ constructor(provider){
        super(provider, [
            "newPendingTransactions"
        ]);
    }
    async _emit(provider, message) {
        provider.emit("pending", message);
    }
}
class $869c78967e643173$export$5b6129c1da6053f0 extends $869c78967e643173$export$93f3aca769b589e9 {
    #logFilter;
    /**
     *  The filter.
     */ get logFilter() {
        return JSON.parse(this.#logFilter);
    }
    /**
     *  @_ignore:
     */ constructor(provider, filter){
        super(provider, [
            "logs",
            filter
        ]);
        this.#logFilter = JSON.stringify(filter);
    }
    async _emit(provider, message) {
        provider.emit(this.logFilter, provider._wrapLog(message, provider._network));
    }
}
class $869c78967e643173$export$783b29abdab77db7 extends (0, $c946edca449b44d0$export$5afe35a44ca7ff9a) {
    #callbacks;
    // Maps each filterId to its subscriber
    #subs;
    // If any events come in before a subscriber has finished
    // registering, queue them
    #pending;
    /**
     *  Creates a new **SocketProvider** connected to %%network%%.
     *
     *  If unspecified, the network will be discovered.
     */ constructor(network, _options){
        // Copy the options
        const options = Object.assign({}, _options != null ? _options : {});
        // Support for batches is generally not supported for
        // connection-base providers; if this changes in the future
        // the _send should be updated to reflect this
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(options.batchMaxCount == null || options.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", _options);
        options.batchMaxCount = 1;
        // Socket-based Providers (generally) cannot change their network,
        // since they have a long-lived connection; but let people override
        // this if they have just cause.
        if (options.staticNetwork == null) options.staticNetwork = true;
        super(network, options);
        this.#callbacks = new Map();
        this.#subs = new Map();
        this.#pending = new Map();
    }
    // This value is only valid after _start has been called
    /*
    get _network(): Network {
        if (this.#network == null) {
            throw new Error("this shouldn't happen");
        }
        return this.#network.clone();
    }
    */ _getSubscriber(sub) {
        switch(sub.type){
            case "close":
                return new (0, $65f802bdc11fcb97$export$f255b979f86248fa)("close");
            case "block":
                return new $869c78967e643173$export$c41c8e39180b7cbc(this);
            case "pending":
                return new $869c78967e643173$export$a974d62bd7e1dc1f(this);
            case "event":
                return new $869c78967e643173$export$5b6129c1da6053f0(this, sub.filter);
            case "orphan":
                // Handled auto-matically within AbstractProvider
                // when the log.removed = true
                if (sub.filter.orphan === "drop-log") return new (0, $65f802bdc11fcb97$export$f255b979f86248fa)("drop-log");
        }
        return super._getSubscriber(sub);
    }
    /**
     *  Register a new subscriber. This is used internalled by Subscribers
     *  and generally is unecessary unless extending capabilities.
     */ _register(filterId, subscriber) {
        this.#subs.set(filterId, subscriber);
        const pending = this.#pending.get(filterId);
        if (pending) {
            for (const message of pending)subscriber._handleMessage(message);
            this.#pending.delete(filterId);
        }
    }
    async _send(payload) {
        // WebSocket provider doesn't accept batches
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(!Array.isArray(payload), "WebSocket does not support batch send", "payload", payload);
        // @TODO: stringify payloads here and store to prevent mutations
        // Prepare a promise to respond to
        const promise = new Promise((resolve, reject)=>{
            this.#callbacks.set(payload.id, {
                payload: payload,
                resolve: resolve,
                reject: reject
            });
        });
        // Wait until the socket is connected before writing to it
        await this._waitUntilReady();
        // Write the request to the socket
        await this._write(JSON.stringify(payload));
        return [
            await promise
        ];
    }
    // Sub-classes must call this once they are connected
    /*
    async _start(): Promise<void> {
        if (this.#ready) { return; }

        for (const { payload } of this.#callbacks.values()) {
            await this._write(JSON.stringify(payload));
        }

        this.#ready = (async function() {
            await super._start();
        })();
    }
    */ /**
     *  Sub-classes **must** call this with messages received over their
     *  transport to be processed and dispatched.
     */ async _processMessage(message) {
        const result = JSON.parse(message);
        if (result && typeof result === "object" && "id" in result) {
            const callback = this.#callbacks.get(result.id);
            if (callback == null) {
                this.emit("error", (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("received result for unknown id", "UNKNOWN_ERROR", {
                    reasonCode: "UNKNOWN_ID",
                    result: result
                }));
                return;
            }
            this.#callbacks.delete(result.id);
            callback.resolve(result);
        } else if (result && result.method === "eth_subscription") {
            const filterId = result.params.subscription;
            const subscriber = this.#subs.get(filterId);
            if (subscriber) subscriber._handleMessage(result.params.result);
            else {
                let pending = this.#pending.get(filterId);
                if (pending == null) {
                    pending = [];
                    this.#pending.set(filterId, pending);
                }
                pending.push(result.params.result);
            }
        } else {
            this.emit("error", (0, $205dffdfdb79d607$export$5a4bb2b1c89bdce7)("received unexpected message", "UNKNOWN_ERROR", {
                reasonCode: "UNEXPECTED_MESSAGE",
                result: result
            }));
            return;
        }
    }
    /**
     *  Sub-classes **must** override this to send %%message%% over their
     *  transport.
     */ async _write(message) {
        throw new Error("sub-classes must override this");
    }
}


class $ed84d4a98aabce64$export$bfafe629242f30bd extends (0, $869c78967e643173$export$783b29abdab77db7) {
    #connect;
    #websocket;
    get websocket() {
        if (this.#websocket == null) throw new Error("websocket closed");
        return this.#websocket;
    }
    constructor(url, network, options){
        super(network, options);
        if (typeof url === "string") {
            this.#connect = ()=>{
                return new (0, $c9d028ca5b60e671$export$3909fb301d3dc8c9)(url);
            };
            this.#websocket = this.#connect();
        } else if (typeof url === "function") {
            this.#connect = url;
            this.#websocket = url();
        } else {
            this.#connect = null;
            this.#websocket = url;
        }
        this.websocket.onopen = async ()=>{
            try {
                await this._start();
                this.resume();
            } catch (error) {
                console.log("failed to start WebsocketProvider", error);
            // @TODO: now what? Attempt reconnect?
            }
        };
        this.websocket.onmessage = (message)=>{
            this._processMessage(message.data);
        };
    /*
                this.websocket.onclose = (event) => {
                    // @TODO: What event.code should we reconnect on?
                    const reconnect = false;
                    if (reconnect) {
                        this.pause(true);
                        if (this.#connect) {
                            this.#websocket = this.#connect();
                            this.#websocket.onopen = ...
                            // @TODO: this requires the super class to rebroadcast; move it there
                        }
                        this._reconnect();
                    }
                };
        */ }
    async _write(message) {
        this.websocket.send(message);
    }
    async destroy() {
        if (this.#websocket != null) {
            this.#websocket.close();
            this.#websocket = null;
        }
        super.destroy();
    }
}


const $172da1fb5735878b$var$defaultProjectId = "84842078b09946638c03157f83405213";
function $172da1fb5735878b$var$getHost(name) {
    switch(name){
        case "mainnet":
            return "mainnet.infura.io";
        case "goerli":
            return "goerli.infura.io";
        case "sepolia":
            return "sepolia.infura.io";
        case "arbitrum":
            return "arbitrum-mainnet.infura.io";
        case "arbitrum-goerli":
            return "arbitrum-goerli.infura.io";
        case "arbitrum-sepolia":
            return "arbitrum-sepolia.infura.io";
        case "base":
            return "base-mainnet.infura.io";
        case "base-goerlia":
            return "base-goerli.infura.io";
        case "base-sepolia":
            return "base-sepolia.infura.io";
        case "bnb":
            return "bnbsmartchain-mainnet.infura.io";
        case "bnbt":
            return "bnbsmartchain-testnet.infura.io";
        case "linea":
            return "linea-mainnet.infura.io";
        case "linea-goerli":
            return "linea-goerli.infura.io";
        case "linea-sepolia":
            return "linea-sepolia.infura.io";
        case "matic":
            return "polygon-mainnet.infura.io";
        case "matic-amoy":
            return "polygon-amoy.infura.io";
        case "matic-mumbai":
            return "polygon-mumbai.infura.io";
        case "optimism":
            return "optimism-mainnet.infura.io";
        case "optimism-goerli":
            return "optimism-goerli.infura.io";
        case "optimism-sepolia":
            return "optimism-sepolia.infura.io";
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
class $172da1fb5735878b$export$dd168a807d60da4f extends (0, $ed84d4a98aabce64$export$bfafe629242f30bd) {
    /**
     *  The Project ID for the INFURA connection.
     */ projectId;
    /**
     *  The Project Secret.
     *
     *  If null, no authenticated requests are made. This should not
     *  be used outside of private contexts.
     */ projectSecret;
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */ constructor(network, projectId){
        const provider = new $172da1fb5735878b$export$60ff1a559b5c6ebd(network, projectId);
        const req = provider._getConnection();
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(!req.credentials, "INFURA WebSocket project secrets unsupported", "UNSUPPORTED_OPERATION", {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = req.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, provider._network);
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            projectId: provider.projectId,
            projectSecret: provider.projectSecret
        });
    }
    isCommunityResource() {
        return this.projectId === $172da1fb5735878b$var$defaultProjectId;
    }
}
class $172da1fb5735878b$export$60ff1a559b5c6ebd extends (0, $c946edca449b44d0$export$da28308012bf6748) {
    /**
     *  The Project ID for the INFURA connection.
     */ projectId;
    /**
     *  The Project Secret.
     *
     *  If null, no authenticated requests are made. This should not
     *  be used outside of private contexts.
     */ projectSecret;
    /**
     *  Creates a new **InfuraProvider**.
     */ constructor(_network, projectId, projectSecret){
        if (_network == null) _network = "mainnet";
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        if (projectId == null) projectId = $172da1fb5735878b$var$defaultProjectId;
        if (projectSecret == null) projectSecret = null;
        const request = $172da1fb5735878b$export$60ff1a559b5c6ebd.getRequest(network, projectId, projectSecret);
        super(request, network, {
            staticNetwork: network
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            projectId: projectId,
            projectSecret: projectSecret
        });
    }
    _getProvider(chainId) {
        try {
            return new $172da1fb5735878b$export$60ff1a559b5c6ebd(chainId, this.projectId, this.projectSecret);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    isCommunityResource() {
        return this.projectId === $172da1fb5735878b$var$defaultProjectId;
    }
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */ static getWebSocketProvider(network, projectId) {
        return new $172da1fb5735878b$export$dd168a807d60da4f(network, projectId);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%projectId%% and %%projectSecret%%.
     */ static getRequest(network, projectId, projectSecret) {
        if (projectId == null) projectId = $172da1fb5735878b$var$defaultProjectId;
        if (projectSecret == null) projectSecret = null;
        const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(`https:/\/${$172da1fb5735878b$var$getHost(network.name)}/v3/${projectId}`);
        request.allowGzip = true;
        if (projectSecret) request.setCredentials("", projectSecret);
        if (projectId === $172da1fb5735878b$var$defaultProjectId) request.retryFunc = async (request, response, attempt)=>{
            (0, $36722169de5041ab$export$4c41bd49e82e82ab)("InfuraProvider");
            return true;
        };
        return request;
    }
}


/**
 *  [[link-quicknode]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Holesky Testnet (``holesky``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base Mainnet (``base``);
 *  - Base Goerli Testnet (``base-goerli``);
 *  - Base Sepolia Testnet (``base-sepolia``);
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - BNB Smart Chain Testnet (``bnbt``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:QuickNode  [providers-quicknode]
 */ 



const $d4ec93def9cdcfec$var$defaultToken = "919b412a057b5e9c9b6dce193c5a60242d6efadb";
function $d4ec93def9cdcfec$var$getHost(name) {
    switch(name){
        case "mainnet":
            return "ethers.quiknode.pro";
        case "goerli":
            return "ethers.ethereum-goerli.quiknode.pro";
        case "sepolia":
            return "ethers.ethereum-sepolia.quiknode.pro";
        case "holesky":
            return "ethers.ethereum-holesky.quiknode.pro";
        case "arbitrum":
            return "ethers.arbitrum-mainnet.quiknode.pro";
        case "arbitrum-goerli":
            return "ethers.arbitrum-goerli.quiknode.pro";
        case "arbitrum-sepolia":
            return "ethers.arbitrum-sepolia.quiknode.pro";
        case "base":
            return "ethers.base-mainnet.quiknode.pro";
        case "base-goerli":
            return "ethers.base-goerli.quiknode.pro";
        case "base-spolia":
            return "ethers.base-sepolia.quiknode.pro";
        case "bnb":
            return "ethers.bsc.quiknode.pro";
        case "bnbt":
            return "ethers.bsc-testnet.quiknode.pro";
        case "matic":
            return "ethers.matic.quiknode.pro";
        case "matic-mumbai":
            return "ethers.matic-testnet.quiknode.pro";
        case "optimism":
            return "ethers.optimism.quiknode.pro";
        case "optimism-goerli":
            return "ethers.optimism-goerli.quiknode.pro";
        case "optimism-sepolia":
            return "ethers.optimism-sepolia.quiknode.pro";
        case "xdai":
            return "ethers.xdai.quiknode.pro";
    }
    (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
class $d4ec93def9cdcfec$export$440e6c150fe0e352 extends (0, $c946edca449b44d0$export$da28308012bf6748) {
    /**
     *  The API token.
     */ token;
    /**
     *  Creates a new **QuickNodeProvider**.
     */ constructor(_network, token){
        if (_network == null) _network = "mainnet";
        const network = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(_network);
        if (token == null) token = $d4ec93def9cdcfec$var$defaultToken;
        const request = $d4ec93def9cdcfec$export$440e6c150fe0e352.getRequest(network, token);
        super(request, network, {
            staticNetwork: network
        });
        (0, $2323980ce672c824$export$b61bda4fbca264f2)(this, {
            token: token
        });
    }
    _getProvider(chainId) {
        try {
            return new $d4ec93def9cdcfec$export$440e6c150fe0e352(chainId, this.token);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    isCommunityResource() {
        return this.token === $d4ec93def9cdcfec$var$defaultToken;
    }
    /**
     *  Returns a new request prepared for %%network%% and the
     *  %%token%%.
     */ static getRequest(network, token) {
        if (token == null) token = $d4ec93def9cdcfec$var$defaultToken;
        const request = new (0, $3e6e83ce717e67cd$export$319b96fe59834522)(`https:/\/${$d4ec93def9cdcfec$var$getHost(network.name)}/${token}`);
        request.allowGzip = true;
        //if (projectSecret) { request.setCredentials("", projectSecret); }
        if (token === $d4ec93def9cdcfec$var$defaultToken) request.retryFunc = async (request, response, attempt)=>{
            (0, $36722169de5041ab$export$4c41bd49e82e82ab)("QuickNodeProvider");
            return true;
        };
        return request;
    }
}


/**
 *  A **FallbackProvider** provides resilience, security and performance
 *  in a way that is customizable and configurable.
 *
 *  @_section: api/providers/fallback-provider:Fallback Provider [about-fallback-provider]
 */ 


const $3d2bbd3e3e226bb5$var$BN_1 = BigInt("1");
const $3d2bbd3e3e226bb5$var$BN_2 = BigInt("2");
function $3d2bbd3e3e226bb5$var$shuffle(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
}
function $3d2bbd3e3e226bb5$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $3d2bbd3e3e226bb5$var$getTime() {
    return new Date().getTime();
}
function $3d2bbd3e3e226bb5$var$stringify(value) {
    return JSON.stringify(value, (key, value)=>{
        if (typeof value === "bigint") return {
            type: "bigint",
            value: value.toString()
        };
        return value;
    });
}
const $3d2bbd3e3e226bb5$var$defaultConfig = {
    stallTimeout: 400,
    priority: 1,
    weight: 1
};
const $3d2bbd3e3e226bb5$var$defaultState = {
    blockNumber: -2,
    requests: 0,
    lateResponses: 0,
    errorResponses: 0,
    outOfSync: -1,
    unsupportedEvents: 0,
    rollingDuration: 0,
    score: 0,
    _network: null,
    _updateNumber: null,
    _totalTime: 0,
    _lastFatalError: null,
    _lastFatalErrorTimestamp: 0
};
async function $3d2bbd3e3e226bb5$var$waitForSync(config, blockNumber) {
    while(config.blockNumber < 0 || config.blockNumber < blockNumber){
        if (!config._updateNumber) config._updateNumber = (async ()=>{
            try {
                const blockNumber = await config.provider.getBlockNumber();
                if (blockNumber > config.blockNumber) config.blockNumber = blockNumber;
            } catch (error) {
                config.blockNumber = -2;
                config._lastFatalError = error;
                config._lastFatalErrorTimestamp = $3d2bbd3e3e226bb5$var$getTime();
            }
            config._updateNumber = null;
        })();
        await config._updateNumber;
        config.outOfSync++;
        if (config._lastFatalError) break;
    }
}
function $3d2bbd3e3e226bb5$var$_normalize(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[" + value.map($3d2bbd3e3e226bb5$var$_normalize).join(",") + "]";
    if (typeof value === "object" && typeof value.toJSON === "function") return $3d2bbd3e3e226bb5$var$_normalize(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
        case "number":
            return BigInt(value).toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{" + keys.map((k)=>`${JSON.stringify(k)}:${$3d2bbd3e3e226bb5$var$_normalize(value[k])}`).join(",") + "}";
            }
    }
    console.log("Could not serialize", value);
    throw new Error("Hmm...");
}
function $3d2bbd3e3e226bb5$var$normalizeResult(value) {
    if ("error" in value) {
        const error = value.error;
        return {
            tag: $3d2bbd3e3e226bb5$var$_normalize(error),
            value: error
        };
    }
    const result = value.result;
    return {
        tag: $3d2bbd3e3e226bb5$var$_normalize(result),
        value: result
    };
}
// This strategy picks the highest weight result, as long as the weight is
// equal to or greater than quorum
function $3d2bbd3e3e226bb5$var$checkQuorum(quorum, results) {
    const tally = new Map();
    for (const { value: value, tag: tag, weight: weight } of results){
        const t = tally.get(tag) || {
            value: value,
            weight: 0
        };
        t.weight += weight;
        tally.set(tag, t);
    }
    let best = null;
    for (const r of tally.values())if (r.weight >= quorum && (!best || r.weight > best.weight)) best = r;
    if (best) return best.value;
    return undefined;
}
function $3d2bbd3e3e226bb5$var$getMedian(quorum, results) {
    let resultWeight = 0;
    const errorMap = new Map();
    let bestError = null;
    const values = [];
    for (const { value: value, tag: tag, weight: weight } of results)if (value instanceof Error) {
        const e = errorMap.get(tag) || {
            value: value,
            weight: 0
        };
        e.weight += weight;
        errorMap.set(tag, e);
        if (bestError == null || e.weight > bestError.weight) bestError = e;
    } else {
        values.push(BigInt(value));
        resultWeight += weight;
    }
    if (resultWeight < quorum) {
        // We have quorum for an error
        if (bestError && bestError.weight >= quorum) return bestError.value;
        // We do not have quorum for a result
        return undefined;
    }
    // Get the sorted values
    values.sort((a, b)=>a < b ? -1 : b > a ? 1 : 0);
    const mid = Math.floor(values.length / 2);
    // Odd-length; take the middle value
    if (values.length % 2) return values[mid];
    // Even length; take the ceiling of the mean of the center two values
    return (values[mid - 1] + values[mid] + $3d2bbd3e3e226bb5$var$BN_1) / $3d2bbd3e3e226bb5$var$BN_2;
}
function $3d2bbd3e3e226bb5$var$getAnyResult(quorum, results) {
    // If any value or error meets quorum, that is our preferred result
    const result = $3d2bbd3e3e226bb5$var$checkQuorum(quorum, results);
    if (result !== undefined) return result;
    // Otherwise, do we have any result?
    for (const r of results){
        if (r.value) return r.value;
    }
    // Nope!
    return undefined;
}
function $3d2bbd3e3e226bb5$var$getFuzzyMode(quorum, results) {
    if (quorum === 1) return (0, $7769476213c187e3$export$b14f2714108df84)($3d2bbd3e3e226bb5$var$getMedian(quorum, results), "%internal");
    const tally = new Map();
    const add = (result, weight)=>{
        const t = tally.get(result) || {
            result: result,
            weight: 0
        };
        t.weight += weight;
        tally.set(result, t);
    };
    for (const { weight: weight, value: value } of results){
        const r = (0, $7769476213c187e3$export$b14f2714108df84)(value);
        add(r - 1, weight);
        add(r, weight);
        add(r + 1, weight);
    }
    let bestWeight = 0;
    let bestResult = undefined;
    for (const { weight: weight, result: result } of tally.values())// Use this result, if this result meets quorum and has either:
    // - a better weight
    // - or equal weight, but the result is larger
    if (weight >= quorum && (weight > bestWeight || bestResult != null && weight === bestWeight && result > bestResult)) {
        bestWeight = weight;
        bestResult = result;
    }
    return bestResult;
}
class $3d2bbd3e3e226bb5$export$cb1d0beacb55feb7 extends (0, $65f802bdc11fcb97$export$ae9650e85fb229fe) {
    /**
     *  The number of backends that must agree on a value before it is
     *  accpeted.
     */ quorum;
    /**
     *  @_ignore:
     */ eventQuorum;
    /**
     *  @_ignore:
     */ eventWorkers;
    #configs;
    #height;
    #initialSyncPromise;
    /**
     *  Creates a new **FallbackProvider** with %%providers%% connected to
     *  %%network%%.
     *
     *  If a [[Provider]] is included in %%providers%%, defaults are used
     *  for the configuration.
     */ constructor(providers, network, options){
        super(network, options);
        this.#configs = providers.map((p)=>{
            if (p instanceof (0, $65f802bdc11fcb97$export$ae9650e85fb229fe)) return Object.assign({
                provider: p
            }, $3d2bbd3e3e226bb5$var$defaultConfig, $3d2bbd3e3e226bb5$var$defaultState);
            else return Object.assign({}, $3d2bbd3e3e226bb5$var$defaultConfig, p, $3d2bbd3e3e226bb5$var$defaultState);
        });
        this.#height = -2;
        this.#initialSyncPromise = null;
        if (options && options.quorum != null) this.quorum = options.quorum;
        else this.quorum = Math.ceil(this.#configs.reduce((accum, config)=>{
            accum += config.weight;
            return accum;
        }, 0) / 2);
        this.eventQuorum = 1;
        this.eventWorkers = 1;
        (0, $205dffdfdb79d607$export$c3d31707e5030f5e)(this.quorum <= this.#configs.reduce((a, c)=>a + c.weight, 0), "quorum exceed provider weight", "quorum", this.quorum);
    }
    get providerConfigs() {
        return this.#configs.map((c)=>{
            const result = Object.assign({}, c);
            for(const key in result)if (key[0] === "_") delete result[key];
            return result;
        });
    }
    async _detectNetwork() {
        return (0, $62f438f453d8cb95$export$95be4ae94445245a).from((0, $7769476213c187e3$export$61fe455e2b1e28a4)(await this._perform({
            method: "chainId"
        })));
    }
    // @TODO: Add support to select providers to be the event subscriber
    //_getSubscriber(sub: Subscription): Subscriber {
    //    throw new Error("@TODO");
    //}
    /**
     *  Transforms a %%req%% into the correct method call on %%provider%%.
     */ async _translatePerform(provider, req) {
        switch(req.method){
            case "broadcastTransaction":
                return await provider.broadcastTransaction(req.signedTransaction);
            case "call":
                return await provider.call(Object.assign({}, req.transaction, {
                    blockTag: req.blockTag
                }));
            case "chainId":
                return (await provider.getNetwork()).chainId;
            case "estimateGas":
                return await provider.estimateGas(req.transaction);
            case "getBalance":
                return await provider.getBalance(req.address, req.blockTag);
            case "getBlock":
                {
                    const block = "blockHash" in req ? req.blockHash : req.blockTag;
                    return await provider.getBlock(block, req.includeTransactions);
                }
            case "getBlockNumber":
                return await provider.getBlockNumber();
            case "getCode":
                return await provider.getCode(req.address, req.blockTag);
            case "getGasPrice":
                return (await provider.getFeeData()).gasPrice;
            case "getPriorityFee":
                return (await provider.getFeeData()).maxPriorityFeePerGas;
            case "getLogs":
                return await provider.getLogs(req.filter);
            case "getStorage":
                return await provider.getStorage(req.address, req.position, req.blockTag);
            case "getTransaction":
                return await provider.getTransaction(req.hash);
            case "getTransactionCount":
                return await provider.getTransactionCount(req.address, req.blockTag);
            case "getTransactionReceipt":
                return await provider.getTransactionReceipt(req.hash);
            case "getTransactionResult":
                return await provider.getTransactionResult(req.hash);
        }
    }
    // Grab the next (random) config that is not already part of
    // the running set
    #getNextConfig(running) {
        // @TODO: Maybe do a check here to favour (heavily) providers that
        //        do not require waitForSync and disfavour providers that
        //        seem down-ish or are behaving slowly
        const configs = Array.from(running).map((r)=>r.config);
        // Shuffle the states, sorted by priority
        const allConfigs = this.#configs.slice();
        $3d2bbd3e3e226bb5$var$shuffle(allConfigs);
        allConfigs.sort((a, b)=>a.priority - b.priority);
        for (const config of allConfigs){
            if (config._lastFatalError) continue;
            if (configs.indexOf(config) === -1) return config;
        }
        return null;
    }
    // Adds a new runner (if available) to running.
    #addRunner(running, req) {
        const config = this.#getNextConfig(running);
        // No runners available
        if (config == null) return null;
        // Create a new runner
        const runner = {
            config: config,
            result: null,
            didBump: false,
            perform: null,
            staller: null
        };
        const now = $3d2bbd3e3e226bb5$var$getTime();
        // Start performing this operation
        runner.perform = (async ()=>{
            try {
                config.requests++;
                const result = await this._translatePerform(config.provider, req);
                runner.result = {
                    result: result
                };
            } catch (error) {
                config.errorResponses++;
                runner.result = {
                    error: error
                };
            }
            const dt = $3d2bbd3e3e226bb5$var$getTime() - now;
            config._totalTime += dt;
            config.rollingDuration = 0.95 * config.rollingDuration + 0.05 * dt;
            runner.perform = null;
        })();
        // Start a staller; when this times out, it's time to force
        // kicking off another runner because we are taking too long
        runner.staller = (async ()=>{
            await $3d2bbd3e3e226bb5$var$stall(config.stallTimeout);
            runner.staller = null;
        })();
        running.add(runner);
        return runner;
    }
    // Initializes the blockNumber and network for each runner and
    // blocks until initialized
    async #initialSync() {
        let initialSync = this.#initialSyncPromise;
        if (!initialSync) {
            const promises = [];
            this.#configs.forEach((config)=>{
                promises.push((async ()=>{
                    await $3d2bbd3e3e226bb5$var$waitForSync(config, 0);
                    if (!config._lastFatalError) config._network = await config.provider.getNetwork();
                })());
            });
            this.#initialSyncPromise = initialSync = (async ()=>{
                // Wait for all providers to have a block number and network
                await Promise.all(promises);
                // Check all the networks match
                let chainId = null;
                for (const config of this.#configs){
                    if (config._lastFatalError) continue;
                    const network = config._network;
                    if (chainId == null) chainId = network.chainId;
                    else if (network.chainId !== chainId) (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
                        operation: "new FallbackProvider"
                    });
                }
            })();
        }
        await initialSync;
    }
    async #checkQuorum(running, req) {
        // Get all the result objects
        const results = [];
        for (const runner of running)if (runner.result != null) {
            const { tag: tag, value: value } = $3d2bbd3e3e226bb5$var$normalizeResult(runner.result);
            results.push({
                tag: tag,
                value: value,
                weight: runner.config.weight
            });
        }
        // Are there enough results to event meet quorum?
        if (results.reduce((a, r)=>a + r.weight, 0) < this.quorum) return undefined;
        switch(req.method){
            case "getBlockNumber":
                {
                    // We need to get the bootstrap block height
                    if (this.#height === -2) this.#height = Math.ceil((0, $7769476213c187e3$export$b14f2714108df84)($3d2bbd3e3e226bb5$var$getMedian(this.quorum, this.#configs.filter((c)=>!c._lastFatalError).map((c)=>({
                            value: c.blockNumber,
                            tag: (0, $7769476213c187e3$export$b14f2714108df84)(c.blockNumber).toString(),
                            weight: c.weight
                        })))));
                    // Find the mode across all the providers, allowing for
                    // a little drift between block heights
                    const mode = $3d2bbd3e3e226bb5$var$getFuzzyMode(this.quorum, results);
                    if (mode === undefined) return undefined;
                    if (mode > this.#height) this.#height = mode;
                    return this.#height;
                }
            case "getGasPrice":
            case "getPriorityFee":
            case "estimateGas":
                return $3d2bbd3e3e226bb5$var$getMedian(this.quorum, results);
            case "getBlock":
                // Pending blocks are in the mempool and already
                // quite untrustworthy; just grab anything
                if ("blockTag" in req && req.blockTag === "pending") return $3d2bbd3e3e226bb5$var$getAnyResult(this.quorum, results);
                return $3d2bbd3e3e226bb5$var$checkQuorum(this.quorum, results);
            case "call":
            case "chainId":
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
            case "getStorage":
            case "getTransaction":
            case "getTransactionReceipt":
            case "getLogs":
                return $3d2bbd3e3e226bb5$var$checkQuorum(this.quorum, results);
            case "broadcastTransaction":
                return $3d2bbd3e3e226bb5$var$getAnyResult(this.quorum, results);
        }
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(false, "unsupported method", "UNSUPPORTED_OPERATION", {
            operation: `_perform(${$3d2bbd3e3e226bb5$var$stringify(req.method)})`
        });
    }
    async #waitForQuorum(running, req) {
        if (running.size === 0) throw new Error("no runners?!");
        // Any promises that are interesting to watch for; an expired stall
        // or a successful perform
        const interesting = [];
        let newRunners = 0;
        for (const runner of running){
            // No responses, yet; keep an eye on it
            if (runner.perform) interesting.push(runner.perform);
            // Still stalling...
            if (runner.staller) {
                interesting.push(runner.staller);
                continue;
            }
            // This runner has already triggered another runner
            if (runner.didBump) continue;
            // Got a response (result or error) or stalled; kick off another runner
            runner.didBump = true;
            newRunners++;
        }
        // Check if we have reached quorum on a result (or error)
        const value = await this.#checkQuorum(running, req);
        if (value !== undefined) {
            if (value instanceof Error) throw value;
            return value;
        }
        // Add any new runners, because a staller timed out or a result
        // or error response came in.
        for(let i = 0; i < newRunners; i++)this.#addRunner(running, req);
        // All providers have returned, and we have no result
        (0, $205dffdfdb79d607$export$a7a9523472993e97)(interesting.length > 0, "quorum not met", "SERVER_ERROR", {
            request: "%sub-requests",
            info: {
                request: req,
                results: Array.from(running).map((r)=>$3d2bbd3e3e226bb5$var$stringify(r.result))
            }
        });
        // Wait for someone to either complete its perform or stall out
        await Promise.race(interesting);
        // This is recursive, but at worst case the depth is 2x the
        // number of providers (each has a perform and a staller)
        return await this.#waitForQuorum(running, req);
    }
    async _perform(req) {
        // Broadcasting a transaction is rare (ish) and already incurs
        // a cost on the user, so spamming is safe-ish. Just send it to
        // every backend.
        if (req.method === "broadcastTransaction") {
            // Once any broadcast provides a positive result, use it. No
            // need to wait for anyone else
            const results = this.#configs.map((c)=>null);
            const broadcasts = this.#configs.map(async ({ provider: provider, weight: weight }, index)=>{
                try {
                    const result = await provider._perform(req);
                    results[index] = Object.assign($3d2bbd3e3e226bb5$var$normalizeResult({
                        result: result
                    }), {
                        weight: weight
                    });
                } catch (error) {
                    results[index] = Object.assign($3d2bbd3e3e226bb5$var$normalizeResult({
                        error: error
                    }), {
                        weight: weight
                    });
                }
            });
            // As each promise finishes...
            while(true){
                // Check for a valid broadcast result
                const done = results.filter((r)=>r != null);
                for (const { value: value } of done){
                    if (!(value instanceof Error)) return value;
                }
                // Check for a legit broadcast error (one which we cannot
                // recover from; some nodes may return the following red
                // herring events:
                // - alredy seend (UNKNOWN_ERROR)
                // - NONCE_EXPIRED
                // - REPLACEMENT_UNDERPRICED
                const result = $3d2bbd3e3e226bb5$var$checkQuorum(this.quorum, results.filter((r)=>r != null));
                if ((0, $205dffdfdb79d607$export$e6127cc7fe7395c3)(result, "INSUFFICIENT_FUNDS")) throw result;
                // Kick off the next provider (if any)
                const waiting = broadcasts.filter((b, i)=>results[i] == null);
                if (waiting.length === 0) break;
                await Promise.race(waiting);
            }
            // Use standard quorum results; any result was returned above,
            // so this will find any error that met quorum if any
            const result = $3d2bbd3e3e226bb5$var$getAnyResult(this.quorum, results);
            (0, $205dffdfdb79d607$export$a7a9523472993e97)(result !== undefined, "problem multi-broadcasting", "SERVER_ERROR", {
                request: "%sub-requests",
                info: {
                    request: req,
                    results: results.map($3d2bbd3e3e226bb5$var$stringify)
                }
            });
            if (result instanceof Error) throw result;
            return result;
        }
        await this.#initialSync();
        // Bootstrap enough runners to meet quorum
        const running = new Set();
        let inflightQuorum = 0;
        while(true){
            const runner = this.#addRunner(running, req);
            if (runner == null) break;
            inflightQuorum += runner.config.weight;
            if (inflightQuorum >= this.quorum) break;
        }
        const result = await this.#waitForQuorum(running, req);
        // Track requests sent to a provider that are still
        // outstanding after quorum has been otherwise found
        for (const runner of running)if (runner.perform && runner.result == null) runner.config.lateResponses++;
        return result;
    }
    async destroy() {
        for (const { provider: provider } of this.#configs)provider.destroy();
        super.destroy();
    }
}





function $fac209858859fbd7$var$isWebSocketLike(value) {
    return value && typeof value.send === "function" && typeof value.close === "function";
}
const $fac209858859fbd7$var$Testnets = "goerli kovan sepolia classicKotti optimism-goerli arbitrum-goerli matic-mumbai bnbt".split(" ");
function $fac209858859fbd7$export$4f77a1d3c1ac6642(network, options) {
    if (options == null) options = {};
    const allowService = (name)=>{
        if (options[name] === "-") return false;
        if (typeof options.exclusive === "string") return name === options.exclusive;
        if (Array.isArray(options.exclusive)) return options.exclusive.indexOf(name) !== -1;
        return true;
    };
    if (typeof network === "string" && network.match(/^https?:/)) return new (0, $c946edca449b44d0$export$da28308012bf6748)(network);
    if (typeof network === "string" && network.match(/^wss?:/) || $fac209858859fbd7$var$isWebSocketLike(network)) return new (0, $ed84d4a98aabce64$export$bfafe629242f30bd)(network);
    // Get the network and name, if possible
    let staticNetwork = null;
    try {
        staticNetwork = (0, $62f438f453d8cb95$export$95be4ae94445245a).from(network);
    } catch (error) {}
    const providers = [];
    if (allowService("publicPolygon") && staticNetwork) {
        if (staticNetwork.name === "matic") providers.push(new (0, $c946edca449b44d0$export$da28308012bf6748)("https://polygon-rpc.com/", staticNetwork, {
            staticNetwork: staticNetwork
        }));
        else if (staticNetwork.name === "matic-amoy") providers.push(new (0, $c946edca449b44d0$export$da28308012bf6748)("https://rpc-amoy.polygon.technology/", staticNetwork, {
            staticNetwork: staticNetwork
        }));
    }
    if (allowService("alchemy")) try {
        providers.push(new (0, $1a788c9cf9449553$export$999cc40da3fbc6f)(network, options.alchemy));
    } catch (error) {}
    if (allowService("ankr") && options.ankr != null) try {
        providers.push(new (0, $86c088dee19c0086$export$72783b2aefa72a45)(network, options.ankr));
    } catch (error) {}
    if (allowService("chainstack")) try {
        providers.push(new (0, $f155c21e39c5e127$export$b6f0a46407d1854c)(network, options.chainstack));
    } catch (error) {}
    if (allowService("cloudflare")) try {
        providers.push(new (0, $77d2c9a753aabf67$export$7113381f8f264fc0)(network));
    } catch (error) {}
    if (allowService("etherscan")) try {
        providers.push(new (0, $7002dd2f4d24da26$export$dd1d942a536c7912)(network, options.etherscan));
    } catch (error) {}
    if (allowService("infura")) try {
        let projectId = options.infura;
        let projectSecret = undefined;
        if (typeof projectId === "object") {
            projectSecret = projectId.projectSecret;
            projectId = projectId.projectId;
        }
        providers.push(new (0, $172da1fb5735878b$export$60ff1a559b5c6ebd)(network, projectId, projectSecret));
    } catch (error) {}
    /*
        if (options.pocket !== "-") {
            try {
                let appId = options.pocket;
                let secretKey: undefined | string = undefined;
                let loadBalancer: undefined | boolean = undefined;
                if (typeof(appId) === "object") {
                    loadBalancer = !!appId.loadBalancer;
                    secretKey = appId.secretKey;
                    appId = appId.appId;
                }
                providers.push(new PocketProvider(network, appId, secretKey, loadBalancer));
            } catch (error) { console.log(error); }
        }
    */ if (allowService("quicknode")) try {
        let token = options.quicknode;
        providers.push(new (0, $d4ec93def9cdcfec$export$440e6c150fe0e352)(network, token));
    } catch (error) {}
    (0, $205dffdfdb79d607$export$a7a9523472993e97)(providers.length, "unsupported default network", "UNSUPPORTED_OPERATION", {
        operation: "getDefaultProvider"
    });
    // No need for a FallbackProvider
    if (providers.length === 1) return providers[0];
    // We use the floor because public third-party providers can be unreliable,
    // so a low number of providers with a large quorum will fail too often
    let quorum = Math.floor(providers.length / 2);
    if (quorum > 2) quorum = 2;
    // Testnets don't need as strong a security gaurantee and speed is
    // more useful during testing
    if (staticNetwork && $fac209858859fbd7$var$Testnets.indexOf(staticNetwork.name) !== -1) quorum = 1;
    // Provided override qorum takes priority
    if (options && options.quorum) quorum = options.quorum;
    return new (0, $3d2bbd3e3e226bb5$export$cb1d0beacb55feb7)(providers, undefined, {
        quorum: quorum
    });
}



var $kAoxL = parcelRequire("kAoxL");

var $kAoxL = parcelRequire("kAoxL");

var $366a29267488e9ac$exports = {};

$parcel$export($366a29267488e9ac$exports, "promisifyRequest", function () { return $366a29267488e9ac$export$b327150396135fe7; });
$parcel$export($366a29267488e9ac$exports, "createStore", function () { return $366a29267488e9ac$export$f51a9068ac82ea43; });
$parcel$export($366a29267488e9ac$exports, "get", function () { return $366a29267488e9ac$export$3988ae62b71be9a3; });
$parcel$export($366a29267488e9ac$exports, "set", function () { return $366a29267488e9ac$export$adaa4cf7ef1b65be; });
$parcel$export($366a29267488e9ac$exports, "setMany", function () { return $366a29267488e9ac$export$daa0a5170277c7a8; });
$parcel$export($366a29267488e9ac$exports, "getMany", function () { return $366a29267488e9ac$export$5df405cccea42673; });
$parcel$export($366a29267488e9ac$exports, "update", function () { return $366a29267488e9ac$export$722fbec263ad908a; });
$parcel$export($366a29267488e9ac$exports, "del", function () { return $366a29267488e9ac$export$1d2f21e549771e67; });
$parcel$export($366a29267488e9ac$exports, "delMany", function () { return $366a29267488e9ac$export$c8aa84257229cac8; });
$parcel$export($366a29267488e9ac$exports, "clear", function () { return $366a29267488e9ac$export$42ffd38884aecdac; });
$parcel$export($366a29267488e9ac$exports, "keys", function () { return $366a29267488e9ac$export$ed97f33186d4b816; });
$parcel$export($366a29267488e9ac$exports, "values", function () { return $366a29267488e9ac$export$68c286be0e7e55b7; });
$parcel$export($366a29267488e9ac$exports, "entries", function () { return $366a29267488e9ac$export$3e9f948b41964866; });
function $366a29267488e9ac$var$_slicedToArray(arr, i) {
    return $366a29267488e9ac$var$_arrayWithHoles(arr) || $366a29267488e9ac$var$_iterableToArrayLimit(arr, i) || $366a29267488e9ac$var$_unsupportedIterableToArray(arr, i) || $366a29267488e9ac$var$_nonIterableRest();
}
function $366a29267488e9ac$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $366a29267488e9ac$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $366a29267488e9ac$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $366a29267488e9ac$var$_arrayLikeToArray(o, minLen);
}
function $366a29267488e9ac$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $366a29267488e9ac$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $366a29267488e9ac$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $366a29267488e9ac$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $366a29267488e9ac$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $366a29267488e9ac$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $366a29267488e9ac$var$defaultGetStoreFunc;
function $366a29267488e9ac$var$defaultGetStore() {
    if (!$366a29267488e9ac$var$defaultGetStoreFunc) $366a29267488e9ac$var$defaultGetStoreFunc = $366a29267488e9ac$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $366a29267488e9ac$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $366a29267488e9ac$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $366a29267488e9ac$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $366a29267488e9ac$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $366a29267488e9ac$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($366a29267488e9ac$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $366a29267488e9ac$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $366a29267488e9ac$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $366a29267488e9ac$export$b327150396135fe7(store.transaction);
    });
}
function $366a29267488e9ac$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $366a29267488e9ac$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $366a29267488e9ac$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $366a29267488e9ac$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $366a29267488e9ac$export$b327150396135fe7(store.getAll());
        var items = [];
        return $366a29267488e9ac$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $366a29267488e9ac$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $366a29267488e9ac$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $366a29267488e9ac$export$b327150396135fe7(store.getAllKeys()),
            $366a29267488e9ac$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $366a29267488e9ac$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $366a29267488e9ac$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}




function $89e48cd0768a697f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $89e48cd0768a697f$var$$eef213ff4197108b$exports = {};
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$eef213ff4197108b$exports, "Stack", function() {
    return $89e48cd0768a697f$export$694e0d28c7ffc90c;
});
const { push: $89e48cd0768a697f$var$$eef213ff4197108b$var$push } = Array.prototype;
class $89e48cd0768a697f$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $89e48cd0768a697f$var$$eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $89e48cd0768a697f$var$$0fe1f1400993ba8a$exports = {};
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $89e48cd0768a697f$export$4125cfe7e08e2040;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $89e48cd0768a697f$export$aa9d629c530f62a7;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "headerParser", function() {
    return $89e48cd0768a697f$export$b725a69477e4d33f;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $89e48cd0768a697f$export$eea2c1c5e1a37e50;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "parseBody", function() {
    return $89e48cd0768a697f$export$3b629cd0ff482602;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $89e48cd0768a697f$export$4f2a8c8c11a6373a;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $89e48cd0768a697f$export$bda27a3e49197b9;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$0fe1f1400993ba8a$exports, "request", function() {
    return $89e48cd0768a697f$export$b5fe3f66a567bec0;
});
var $89e48cd0768a697f$var$$22de11b45b0eeb97$exports = {};
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$22de11b45b0eeb97$exports, "parseDocument", function() {
    return $89e48cd0768a697f$export$b6a9369736b19f4d;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$22de11b45b0eeb97$exports, "makeFormData", function() {
    return $89e48cd0768a697f$export$2c28ab2e118e73f1;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$22de11b45b0eeb97$exports, "serializeNode", function() {
    return $89e48cd0768a697f$export$a0beee2e55fb5dd1;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$22de11b45b0eeb97$exports, "serialize", function() {
    return $89e48cd0768a697f$export$dfdc1655ccc5b9cb;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$22de11b45b0eeb97$exports, "readAs", function() {
    return $89e48cd0768a697f$export$e209cbb66c5b18c;
});
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $89e48cd0768a697f$export$8fb536984ec8b4d7;
});
/**
 * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/70}
 */ AbortSignal.prototype.throwIfAborted ||= function() {
    const { aborted: aborted, reason: reason = "Aborted" } = this;
    if (!aborted) return;
    throw reason instanceof DOMException ? reason : new DOMException(reason instanceof Error ? reason.message : reason + "", "AbortError");
};
/**
 * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/73#issuecomment-2085543258}
 */ AbortSignal.any ||= (iterable)=>{
    const controller = new AbortController();
    function abort() {
        controller.abort(this.reason);
        clean();
    }
    function clean() {
        for (const signal of iterable)signal.removeEventListener("abort", abort);
    }
    for (const signal of iterable)if (signal.aborted) {
        controller.abort(signal.reason);
        break;
    } else signal.addEventListener("abort", abort);
    return controller.signal;
};
async function $89e48cd0768a697f$export$b6a9369736b19f4d(text, contentType = "") {
    const [type] = contentType?.split(";") || [];
    return new DOMParser().parseFromString(text, type || "text/html");
}
function $89e48cd0768a697f$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== "string" && (0, $a1a155eb9166d0df$export$b5a4d6f439a5044d)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === "object") formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $89e48cd0768a697f$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? "image/svg" : root instanceof HTMLDocument || root instanceof HTMLElement ? "text/html" : "application/xml",
        data: (0, $a1a155eb9166d0df$export$b0709844452f8b6b)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: "multipart/form-data",
        data: new FormData(root)
    };
    const data = (0, $a1a155eb9166d0df$export$86d7c59254d6a2c9)(root);
    switch(contentType = root.enctype){
        case "text/plain":
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join("\n")
            };
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data) + ""
            };
        default:
            return {
                contentType: "application/json",
                data: JSON.stringify(data)
            };
    }
}
function $89e48cd0768a697f$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(";") || [];
    switch(type){
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case "multipart/form-data":
            return {
                data: $89e48cd0768a697f$export$2c28ab2e118e73f1(data)
            };
        case "application/json":
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case "text/html":
        case "application/xml":
        case "image/svg":
            return {
                contentType: contentType,
                data: (0, $a1a155eb9166d0df$export$b0709844452f8b6b)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: "application/x-www-form-urlencoded",
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $89e48cd0768a697f$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $a1a155eb9166d0df$export$b119cc7e1840e59c)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: "application/octet-stream",
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: "application/json",
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error("Unserialized Object needs a specific Content-Type");
}
var $89e48cd0768a697f$var$$22de11b45b0eeb97$var$FileMethod;
(function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
})($89e48cd0768a697f$var$$22de11b45b0eeb97$var$FileMethod || ($89e48cd0768a697f$var$$22de11b45b0eeb97$var$FileMethod = {}));
function $89e48cd0768a697f$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    return {
        progress: (0, $630535246db4a983$export$77cea355fa80b5f4).fromEvent(reader, "progress"),
        result: new Promise((resolve, reject)=>{
            reader.onerror = reject;
            reader.onload = ()=>resolve(reader.result);
            reader[$89e48cd0768a697f$var$$22de11b45b0eeb97$var$FileMethod[method]](file, encoding);
        })
    };
}
const $89e48cd0768a697f$var$$22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
const $89e48cd0768a697f$export$8fb536984ec8b4d7 = async (raw)=>raw instanceof Blob ? ($89e48cd0768a697f$var$$22de11b45b0eeb97$var$DataURI.exec(await $89e48cd0768a697f$export$e209cbb66c5b18c(raw, "text").result) || "")[4] : btoa(encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+("0x" + p1))));
var $89e48cd0768a697f$export$4125cfe7e08e2040;
(function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
})($89e48cd0768a697f$export$4125cfe7e08e2040 || ($89e48cd0768a697f$export$4125cfe7e08e2040 = {}));
class $89e48cd0768a697f$export$aa9d629c530f62a7 extends URIError {
    constructor(message, response){
        super(message);
        Object.assign(this, response);
    }
}
const $89e48cd0768a697f$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $89e48cd0768a697f$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $89e48cd0768a697f$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $89e48cd0768a697f$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes("text")) return raw;
    if (contentType.includes("json")) return (0, $a1a155eb9166d0df$export$27924e57e9afff7f)(raw);
    if (contentType.match(/html|xml/)) try {
        return $89e48cd0768a697f$export$b6a9369736b19f4d(raw, contentType);
    } catch  {}
    return new TextEncoder().encode(raw).buffer;
}
function $89e48cd0768a697f$export$4f2a8c8c11a6373a({ method: method = "GET", path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest(), header_list = headers instanceof Array ? headers : headers?.[Symbol.iterator] instanceof Function ? [
        ...headers
    ] : Object.entries(headers);
    const abort = ()=>request.abort();
    signal?.addEventListener("abort", abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            if (request.readyState !== 4) return;
            if (!request.status && !signal?.aborted) return;
            resolve({
                status: request.status,
                statusText: request.statusText,
                headers: $89e48cd0768a697f$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: request.response || request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        request.open(method, path + "");
        for (const [key, value] of header_list)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        request.send(body);
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader("Content-Type") || "";
        if (typeof body === "string" && !contentType.includes("text")) body = $89e48cd0768a697f$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener("abort", abort));
    return {
        response: response,
        upload: (0, $630535246db4a983$export$77cea355fa80b5f4).fromEvent(request.upload, "progress"),
        download: (0, $630535246db4a983$export$77cea355fa80b5f4).fromEvent(request, "progress")
    };
}
async function $89e48cd0768a697f$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === "text" ? {
        ...headers,
        Accept: "text/plain"
    } : responseType === "json" ? {
        ...headers,
        Accept: "application/json"
    } : responseType === "document" ? {
        ...headers,
        Accept: "text/html, application/xhtml+xml, application/xml"
    } : responseType === "arraybuffer" || responseType === "blob" ? {
        ...headers,
        Accept: "application/octet-stream"
    } : headers;
    const response = await fetch(path + "", {
        method: method,
        headers: headers,
        credentials: withCredentials ? "include" : "omit",
        body: body,
        signal: signals[0] && AbortSignal.any(signals)
    });
    const header = $89e48cd0768a697f$export$eea2c1c5e1a37e50([
        ...response.headers
    ].map(([key, value])=>`${key}: ${value}`).join("\n"));
    if (response.status !== 204) try {
        var contentType = response.headers.get("Content-Type") || "", backup = response.clone();
        var data = await (responseType === "text" ? response.text() : responseType === "document" ? $89e48cd0768a697f$export$b6a9369736b19f4d(await response.text(), contentType) : responseType === "json" ? response.json() : responseType === "arraybuffer" ? response.arrayBuffer() : response.blob());
    } catch  {
        const text = await backup.text();
        var data = $89e48cd0768a697f$export$3b629cd0ff482602(text, contentType);
    }
    return {
        status: response.status,
        statusText: response.statusText,
        headers: header,
        body: data
    };
}
function $89e48cd0768a697f$export$b5fe3f66a567bec0(options) {
    return typeof globalThis.XMLHttpRequest === "function" ? $89e48cd0768a697f$export$4f2a8c8c11a6373a(options) : {
        response: $89e48cd0768a697f$export$bda27a3e49197b9(options)
    };
}
var $89e48cd0768a697f$var$$cbd22d3323bef9ca$exports = {};
$89e48cd0768a697f$var$$parcel$export($89e48cd0768a697f$var$$cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $89e48cd0768a697f$export$45cf759b359d3d24;
});
const { splice: $89e48cd0768a697f$var$$cbd22d3323bef9ca$var$splice } = Array.prototype;
class $89e48cd0768a697f$export$45cf759b359d3d24 extends $89e48cd0768a697f$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, ...options } = {}){
        super();
        this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = "GET", headers: headers = {}, body: body } = request;
            if (method in $89e48cd0768a697f$export$4125cfe7e08e2040 && body && typeof body === "object") {
                const { contentType: contentType, data: data } = $89e48cd0768a697f$export$dfdc1655ccc5b9cb(body, headers["Content-Type"]);
                if (contentType) headers["Content-Type"] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $89e48cd0768a697f$export$aa9d629c530f62a7(response.statusText, response);
        };
        this.baseURI = baseURI, this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + "", this.baseURI) + "";
            Object.assign(response, await $89e48cd0768a697f$export$b5fe3f66a567bec0({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $89e48cd0768a697f$var$$cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: "HEAD",
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: "GET",
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: "POST",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: "PUT",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: "PATCH",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: "DELETE",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { "Content-Length": length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { "Content-Range": range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split("/").pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}


var $82111daab1cb7b2d$exports = {};

$parcel$export($82111daab1cb7b2d$exports, "FileSystemDirectoryHandle", function () { return (parcelRequire("7LdLi")).default; });
$parcel$export($82111daab1cb7b2d$exports, "FileSystemFileHandle", function () { return (parcelRequire("dPisW")).default; });
$parcel$export($82111daab1cb7b2d$exports, "FileSystemHandle", function () { return (parcelRequire("9QfhF")).default; });
$parcel$export($82111daab1cb7b2d$exports, "FileSystemWritableFileStream", function () { return (parcelRequire("1A4EY")).default; });
$parcel$export($82111daab1cb7b2d$exports, "getOriginPrivateDirectory", function () { return $20ac7021bfef7fb4$export$2e2bcd8739ae039; });
$parcel$export($82111daab1cb7b2d$exports, "showDirectoryPicker", function () { return $c433495088966cc5$export$2e2bcd8739ae039; });
$parcel$export($82111daab1cb7b2d$exports, "showOpenFilePicker", function () { return $1f9e46a93385cc2a$export$2e2bcd8739ae039; });
$parcel$export($82111daab1cb7b2d$exports, "showSaveFilePicker", function () { return $4ed3d0d95c8af78b$export$2e2bcd8739ae039; });
/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ const $c433495088966cc5$var$native = globalThis.showDirectoryPicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemDirectoryHandle>}
 */ async function $c433495088966cc5$export$6030ffa7b5d2eb28(options = {}) {
    if ($c433495088966cc5$var$native && !options._preferPolyfill) return $c433495088966cc5$var$native(options);
    const input = document.createElement("input");
    input.type = "file";
    input.webkitdirectory = true;
    // Fallback to multiple files input for iOS Safari
    input.multiple = true;
    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
    input.style.position = "fixed";
    input.style.top = "-100000px";
    input.style.left = "-100000px";
    document.body.appendChild(input);
    // Lazy load while the user is choosing the directory
    const p = Promise.resolve((parcelRequire("cFLn4")));
    await new Promise((resolve)=>{
        input.addEventListener("change", resolve);
        input.click();
    });
    return p.then((mod)=>mod.getDirHandlesFromInput(input));
}
var $c433495088966cc5$export$2e2bcd8739ae039 = $c433495088966cc5$export$6030ffa7b5d2eb28;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ const $1f9e46a93385cc2a$var$def = {
    accepts: []
};
const $1f9e46a93385cc2a$var$native = globalThis.showOpenFilePicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options.multiple] If you want to allow more than one file
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.accepts] Files you want to accept
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemFileHandle[]>}
 */ async function $1f9e46a93385cc2a$export$9a17f2258b27c445(options = {}) {
    const opts = {
        ...$1f9e46a93385cc2a$var$def,
        ...options
    };
    if ($1f9e46a93385cc2a$var$native && !options._preferPolyfill) return $1f9e46a93385cc2a$var$native(opts);
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = opts.multiple;
    input.accept = (opts.accepts || []).map((e)=>[
            ...(e.extensions || []).map((e)=>"." + e),
            ...e.mimeTypes || []
        ]).flat().join(",");
    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
    Object.assign(input.style, {
        position: "fixed",
        top: "-100000px",
        left: "-100000px"
    });
    document.body.appendChild(input);
    // Lazy load while the user is choosing the directory
    const p = Promise.resolve((parcelRequire("cFLn4")));
    await new Promise((resolve)=>{
        input.addEventListener("change", resolve, {
            once: true
        });
        input.click();
    });
    input.remove();
    return p.then((m)=>m.getFileHandlesFromInput(input));
}
var $1f9e46a93385cc2a$export$2e2bcd8739ae039 = $1f9e46a93385cc2a$export$9a17f2258b27c445;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ const $4ed3d0d95c8af78b$var$native = globalThis.showSaveFilePicker;


/**
 * @param {Object} [options]
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.types] Files you want to accept
 * @param {string} [options.suggestedName] the name to fall back to when using polyfill
 * @param {string} [options._name] the name to fall back to when using polyfill
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @return {Promise<FileSystemFileHandle>}
 */ async function $4ed3d0d95c8af78b$export$f8b17fb0c2d91989(options = {}) {
    if ($4ed3d0d95c8af78b$var$native && !options._preferPolyfill) return $4ed3d0d95c8af78b$var$native(options);
    if (options._name) {
        console.warn("deprecated _name, spec now have `suggestedName`");
        options.suggestedName = options._name;
    }
    const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
    const { FileHandle: FileHandle } = await (parcelRequire("h6VsE"));
    return new FileSystemFileHandle(new FileHandle(options.suggestedName));
}
var $4ed3d0d95c8af78b$export$2e2bcd8739ae039 = $4ed3d0d95c8af78b$export$f8b17fb0c2d91989;


/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ 


if (globalThis.DataTransferItem && !DataTransferItem.prototype.getAsFileSystemHandle) DataTransferItem.prototype.getAsFileSystemHandle = async function() {
    const entry = this.webkitGetAsEntry();
    const [{ FileHandle: FileHandle, FolderHandle: FolderHandle }, { FileSystemDirectoryHandle: FileSystemDirectoryHandle }, { FileSystemFileHandle: FileSystemFileHandle }] = await Promise.all([
        (parcelRequire("ljuBJ")),
        Promise.resolve((parcelRequire("7LdLi"))),
        Promise.resolve((parcelRequire("dPisW")))
    ]);
    return entry.isFile ? new FileSystemFileHandle(new FileHandle(entry, false)) : new FileSystemDirectoryHandle(new FolderHandle(entry, false));
};

/**
 * @param {object=} driver
 * @return {Promise<FileSystemDirectoryHandle>}
 */ async function $20ac7021bfef7fb4$var$getOriginPrivateDirectory(driver, options = {}) {
    if (!driver) return globalThis.navigator?.storage?.getDirectory() || globalThis.getOriginPrivateDirectory();
    const { FileSystemDirectoryHandle: FileSystemDirectoryHandle } = await Promise.resolve((parcelRequire("7LdLi")));
    const module = await driver;
    const sandbox = await (module.default ? module.default(options) : module(options));
    return new FileSystemDirectoryHandle(sandbox);
}
var $20ac7021bfef7fb4$export$2e2bcd8739ae039 = $20ac7021bfef7fb4$var$getOriginPrivateDirectory;



var $1A4EY = parcelRequire("1A4EY");

var $7LdLi = parcelRequire("7LdLi");

var $dPisW = parcelRequire("dPisW");

var $9QfhF = parcelRequire("9QfhF");


var $46f52113003b1da0$exports = {};

$parcel$export($46f52113003b1da0$exports, "ReadableStreamDefaultReader", function () { return $46f52113003b1da0$export$a890bf36e2af9168; });
$parcel$export($46f52113003b1da0$exports, "ReadableStreamBYOBRequest", function () { return $46f52113003b1da0$export$fbcf11583158d2c; });
$parcel$export($46f52113003b1da0$exports, "ReadableByteStreamController", function () { return $46f52113003b1da0$export$2047cf34091e94ac; });
$parcel$export($46f52113003b1da0$exports, "ReadableStreamBYOBReader", function () { return $46f52113003b1da0$export$20068a30393fcc28; });
$parcel$export($46f52113003b1da0$exports, "WritableStream", function () { return $46f52113003b1da0$export$826849241f7970f8; });
$parcel$export($46f52113003b1da0$exports, "WritableStreamDefaultController", function () { return $46f52113003b1da0$export$9e6890cb9a51c7c2; });
$parcel$export($46f52113003b1da0$exports, "WritableStreamDefaultWriter", function () { return $46f52113003b1da0$export$9295348f005d6054; });
$parcel$export($46f52113003b1da0$exports, "ReadableStreamDefaultController", function () { return $46f52113003b1da0$export$b0bb6d0989d67700; });
$parcel$export($46f52113003b1da0$exports, "ReadableStream", function () { return $46f52113003b1da0$export$5d3e1e5268af5f76; });
$parcel$export($46f52113003b1da0$exports, "ByteLengthQueuingStrategy", function () { return $46f52113003b1da0$export$d386b5f37d154119; });
$parcel$export($46f52113003b1da0$exports, "CountQueuingStrategy", function () { return $46f52113003b1da0$export$9ebfec18c2dfc625; });
$parcel$export($46f52113003b1da0$exports, "TransformStream", function () { return $46f52113003b1da0$export$d102341634899398; });
$parcel$export($46f52113003b1da0$exports, "TransformStreamDefaultController", function () { return $46f52113003b1da0$export$a55559184460222; });
/**
 * @license
 * web-streams-polyfill v4.0.0
 * Copyright 2024 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $46f52113003b1da0$var$e() {}
function $46f52113003b1da0$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $46f52113003b1da0$var$r = $46f52113003b1da0$var$e;
function $46f52113003b1da0$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $46f52113003b1da0$var$n = Promise, $46f52113003b1da0$var$a = Promise.resolve.bind($46f52113003b1da0$var$n), $46f52113003b1da0$var$i = Promise.prototype.then, $46f52113003b1da0$var$l = Promise.reject.bind($46f52113003b1da0$var$n), $46f52113003b1da0$var$s = $46f52113003b1da0$var$a;
function $46f52113003b1da0$var$u(e) {
    return new $46f52113003b1da0$var$n(e);
}
function $46f52113003b1da0$var$c(e) {
    return $46f52113003b1da0$var$u((t)=>t(e));
}
function $46f52113003b1da0$var$d(e) {
    return $46f52113003b1da0$var$l(e);
}
function $46f52113003b1da0$var$f(e, t, r) {
    return $46f52113003b1da0$var$i.call(e, t, r);
}
function $46f52113003b1da0$var$b(e, t, o) {
    $46f52113003b1da0$var$f($46f52113003b1da0$var$f(e, t, o), void 0, $46f52113003b1da0$var$r);
}
function $46f52113003b1da0$var$h(e, t) {
    $46f52113003b1da0$var$b(e, t);
}
function $46f52113003b1da0$var$m(e, t) {
    $46f52113003b1da0$var$b(e, void 0, t);
}
function $46f52113003b1da0$var$_(e, t, r) {
    return $46f52113003b1da0$var$f(e, t, r);
}
function $46f52113003b1da0$var$p(e) {
    $46f52113003b1da0$var$f(e, void 0, $46f52113003b1da0$var$r);
}
let $46f52113003b1da0$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $46f52113003b1da0$var$y = queueMicrotask;
    else {
        const e = $46f52113003b1da0$var$c(void 0);
        $46f52113003b1da0$var$y = (t)=>$46f52113003b1da0$var$f(e, t);
    }
    return $46f52113003b1da0$var$y(e);
};
function $46f52113003b1da0$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $46f52113003b1da0$var$g(e, t, r) {
    try {
        return $46f52113003b1da0$var$c($46f52113003b1da0$var$S(e, t, r));
    } catch (e) {
        return $46f52113003b1da0$var$d(e);
    }
}
class $46f52113003b1da0$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, a = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, a;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $46f52113003b1da0$var$w = Symbol("[[AbortSteps]]"), $46f52113003b1da0$var$R = Symbol("[[ErrorSteps]]"), $46f52113003b1da0$var$T = Symbol("[[CancelSteps]]"), $46f52113003b1da0$var$C = Symbol("[[PullSteps]]"), $46f52113003b1da0$var$P = Symbol("[[ReleaseSteps]]");
function $46f52113003b1da0$var$q(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $46f52113003b1da0$var$B(e) : "closed" === t._state ? function(e) {
        $46f52113003b1da0$var$B(e), $46f52113003b1da0$var$A(e);
    }(e) : $46f52113003b1da0$var$k(e, t._storedError);
}
function $46f52113003b1da0$var$E(e, t) {
    return $46f52113003b1da0$var$Or(e._ownerReadableStream, t);
}
function $46f52113003b1da0$var$W(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $46f52113003b1da0$var$j(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $46f52113003b1da0$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$46f52113003b1da0$var$P](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $46f52113003b1da0$var$O(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $46f52113003b1da0$var$B(e) {
    e._closedPromise = $46f52113003b1da0$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $46f52113003b1da0$var$k(e, t) {
    $46f52113003b1da0$var$B(e), $46f52113003b1da0$var$j(e, t);
}
function $46f52113003b1da0$var$j(e, t) {
    void 0 !== e._closedPromise_reject && ($46f52113003b1da0$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $46f52113003b1da0$var$A(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $46f52113003b1da0$var$z = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $46f52113003b1da0$var$D = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $46f52113003b1da0$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $46f52113003b1da0$var$F(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $46f52113003b1da0$var$I(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $46f52113003b1da0$var$$(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $46f52113003b1da0$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $46f52113003b1da0$var$Y(e) {
    return Number(e);
}
function $46f52113003b1da0$var$x(e) {
    return 0 === e ? 0 : e;
}
function $46f52113003b1da0$var$Q(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $46f52113003b1da0$var$x(o), !$46f52113003b1da0$var$z(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $46f52113003b1da0$var$x($46f52113003b1da0$var$D(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $46f52113003b1da0$var$z(o) && 0 !== o ? o : 0;
}
function $46f52113003b1da0$var$N(e, t) {
    if (!$46f52113003b1da0$var$Er(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $46f52113003b1da0$var$H(e) {
    return new $46f52113003b1da0$export$a890bf36e2af9168(e);
}
function $46f52113003b1da0$var$V(e, t) {
    e._reader._readRequests.push(t);
}
function $46f52113003b1da0$var$U(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $46f52113003b1da0$var$G(e) {
    return e._reader._readRequests.length;
}
function $46f52113003b1da0$var$X(e) {
    const t = e._reader;
    return void 0 !== t && !!$46f52113003b1da0$var$J(t);
}
class $46f52113003b1da0$export$a890bf36e2af9168 {
    constructor(e){
        if ($46f52113003b1da0$var$$(e, 1, "ReadableStreamDefaultReader"), $46f52113003b1da0$var$N(e, "First parameter"), $46f52113003b1da0$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $46f52113003b1da0$var$q(this, e), this._readRequests = new $46f52113003b1da0$var$v;
    }
    get closed() {
        return $46f52113003b1da0$var$J(this) ? this._closedPromise : $46f52113003b1da0$var$d($46f52113003b1da0$var$ee("closed"));
    }
    cancel(e) {
        return $46f52113003b1da0$var$J(this) ? void 0 === this._ownerReadableStream ? $46f52113003b1da0$var$d($46f52113003b1da0$var$O("cancel")) : $46f52113003b1da0$var$E(this, e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$ee("cancel"));
    }
    read() {
        if (!$46f52113003b1da0$var$J(this)) return $46f52113003b1da0$var$d($46f52113003b1da0$var$ee("read"));
        if (void 0 === this._ownerReadableStream) return $46f52113003b1da0$var$d($46f52113003b1da0$var$O("read from"));
        let e, t;
        const r = $46f52113003b1da0$var$u((r, o)=>{
            e = r, t = o;
        });
        return $46f52113003b1da0$var$K(this, {
            _chunkSteps: (t)=>e({
                    value: t,
                    done: !1
                }),
            _closeSteps: ()=>e({
                    value: void 0,
                    done: !0
                }),
            _errorSteps: (e)=>t(e)
        }), r;
    }
    releaseLock() {
        if (!$46f52113003b1da0$var$J(this)) throw $46f52113003b1da0$var$ee("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $46f52113003b1da0$var$W(e);
            const t = new TypeError("Reader was released");
            $46f52113003b1da0$var$Z(e, t);
        }(this);
    }
}
function $46f52113003b1da0$var$J(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $46f52113003b1da0$export$a890bf36e2af9168;
}
function $46f52113003b1da0$var$K(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$46f52113003b1da0$var$C](t);
}
function $46f52113003b1da0$var$Z(e, t) {
    const r = e._readRequests;
    e._readRequests = new $46f52113003b1da0$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $46f52113003b1da0$var$ee(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $46f52113003b1da0$var$te, $46f52113003b1da0$var$re, $46f52113003b1da0$var$oe;
function $46f52113003b1da0$var$ne(e) {
    return e.slice();
}
function $46f52113003b1da0$var$ae(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
Object.defineProperties($46f52113003b1da0$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$a890bf36e2af9168.prototype.cancel, "cancel"), $46f52113003b1da0$var$o($46f52113003b1da0$export$a890bf36e2af9168.prototype.read, "read"), $46f52113003b1da0$var$o($46f52113003b1da0$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
let $46f52113003b1da0$var$ie = (e)=>($46f52113003b1da0$var$ie = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $46f52113003b1da0$var$ie(e)), $46f52113003b1da0$var$le = (e)=>($46f52113003b1da0$var$le = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $46f52113003b1da0$var$le(e));
function $46f52113003b1da0$var$se(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $46f52113003b1da0$var$ae(n, 0, e, t, o), n;
}
function $46f52113003b1da0$var$ue(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $46f52113003b1da0$var$ce(e) {
    try {
        const t = e.done, r = e.value;
        return $46f52113003b1da0$var$f($46f52113003b1da0$var$s(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $46f52113003b1da0$var$d(e);
    }
}
const $46f52113003b1da0$var$de = null !== ($46f52113003b1da0$var$oe = null !== ($46f52113003b1da0$var$te = Symbol.asyncIterator) && void 0 !== $46f52113003b1da0$var$te ? $46f52113003b1da0$var$te : null === ($46f52113003b1da0$var$re = Symbol.for) || void 0 === $46f52113003b1da0$var$re ? void 0 : $46f52113003b1da0$var$re.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $46f52113003b1da0$var$oe ? $46f52113003b1da0$var$oe : "@@asyncIterator";
function $46f52113003b1da0$var$fe(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $46f52113003b1da0$var$ue(e, $46f52113003b1da0$var$de))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $46f52113003b1da0$var$be(e);
                        } catch (e) {
                            return $46f52113003b1da0$var$d(e);
                        }
                        return $46f52113003b1da0$var$ce(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $46f52113003b1da0$var$ue(e.iterator, "return");
                            if (void 0 === t) return $46f52113003b1da0$var$c({
                                done: !0,
                                value: r
                            });
                            o = $46f52113003b1da0$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $46f52113003b1da0$var$d(e);
                        }
                        return $46f52113003b1da0$var$t(o) ? $46f52113003b1da0$var$ce(o) : $46f52113003b1da0$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($46f52113003b1da0$var$fe(e, "sync", $46f52113003b1da0$var$ue(e, Symbol.iterator)));
        } else o = $46f52113003b1da0$var$ue(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $46f52113003b1da0$var$S(o, e, []);
    if (!$46f52113003b1da0$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $46f52113003b1da0$var$be(e) {
    const r = $46f52113003b1da0$var$S(e.nextMethod, e.iterator, []);
    if (!$46f52113003b1da0$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $46f52113003b1da0$var$he {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $46f52113003b1da0$var$_(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise ? $46f52113003b1da0$var$_(this._ongoingPromise, t, t) : t();
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader;
        let t, r;
        const o = $46f52113003b1da0$var$u((e, o)=>{
            t = e, r = o;
        });
        return $46f52113003b1da0$var$K(e, {
            _chunkSteps: (e)=>{
                this._ongoingPromise = void 0, $46f52113003b1da0$var$y(()=>t({
                        value: e,
                        done: !1
                    }));
            },
            _closeSteps: ()=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $46f52113003b1da0$var$W(e), t({
                    value: void 0,
                    done: !0
                });
            },
            _errorSteps: (t)=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $46f52113003b1da0$var$W(e), r(t);
            }
        }), o;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $46f52113003b1da0$var$E(t, e);
            return $46f52113003b1da0$var$W(t), $46f52113003b1da0$var$_(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $46f52113003b1da0$var$W(t), $46f52113003b1da0$var$c({
            value: e,
            done: !0
        });
    }
}
const $46f52113003b1da0$var$me = {
    next () {
        return $46f52113003b1da0$var$_e(this) ? this._asyncIteratorImpl.next() : $46f52113003b1da0$var$d($46f52113003b1da0$var$pe("next"));
    },
    return (e) {
        return $46f52113003b1da0$var$_e(this) ? this._asyncIteratorImpl.return(e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$pe("return"));
    },
    [$46f52113003b1da0$var$de] () {
        return this;
    }
};
function $46f52113003b1da0$var$_e(e) {
    if (!$46f52113003b1da0$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $46f52113003b1da0$var$he;
    } catch (e) {
        return !1;
    }
}
function $46f52113003b1da0$var$pe(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($46f52113003b1da0$var$me, $46f52113003b1da0$var$de, {
    enumerable: !1
});
const $46f52113003b1da0$var$ye = Number.isNaN || function(e) {
    return e != e;
};
function $46f52113003b1da0$var$Se(e) {
    const t = $46f52113003b1da0$var$se(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $46f52113003b1da0$var$ge(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $46f52113003b1da0$var$ve(e, t, r) {
    if ("number" != typeof (o = r) || $46f52113003b1da0$var$ye(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $46f52113003b1da0$var$we(e) {
    e._queue = new $46f52113003b1da0$var$v, e._queueTotalSize = 0;
}
function $46f52113003b1da0$var$Re(e) {
    return e === DataView;
}
class $46f52113003b1da0$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$46f52113003b1da0$var$Ce(this)) throw $46f52113003b1da0$var$Je("view");
        return this._view;
    }
    respond(e) {
        if (!$46f52113003b1da0$var$Ce(this)) throw $46f52113003b1da0$var$Je("respond");
        if ($46f52113003b1da0$var$$(e, 1, "respond"), e = $46f52113003b1da0$var$Q(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($46f52113003b1da0$var$le(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $46f52113003b1da0$var$Ue(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$46f52113003b1da0$var$Ce(this)) throw $46f52113003b1da0$var$Je("respondWithNewView");
        if ($46f52113003b1da0$var$$(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($46f52113003b1da0$var$le(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $46f52113003b1da0$var$Ge(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($46f52113003b1da0$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$fbcf11583158d2c.prototype.respond, "respond"), $46f52113003b1da0$var$o($46f52113003b1da0$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $46f52113003b1da0$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$46f52113003b1da0$var$Te(this)) throw $46f52113003b1da0$var$Ke("byobRequest");
        return $46f52113003b1da0$var$He(this);
    }
    get desiredSize() {
        if (!$46f52113003b1da0$var$Te(this)) throw $46f52113003b1da0$var$Ke("desiredSize");
        return $46f52113003b1da0$var$Ve(this);
    }
    close() {
        if (!$46f52113003b1da0$var$Te(this)) throw $46f52113003b1da0$var$Ke("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $46f52113003b1da0$var$Ye(this);
    }
    enqueue(e) {
        if (!$46f52113003b1da0$var$Te(this)) throw $46f52113003b1da0$var$Ke("enqueue");
        if ($46f52113003b1da0$var$$(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $46f52113003b1da0$var$xe(this, e);
    }
    error(e) {
        if (!$46f52113003b1da0$var$Te(this)) throw $46f52113003b1da0$var$Ke("error");
        $46f52113003b1da0$var$Qe(this, e);
    }
    [$46f52113003b1da0$var$T](e) {
        $46f52113003b1da0$var$qe(this), $46f52113003b1da0$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $46f52113003b1da0$var$Me(this), t;
    }
    [$46f52113003b1da0$var$C](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $46f52113003b1da0$var$Ne(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $46f52113003b1da0$var$V(t, e), $46f52113003b1da0$var$Pe(this);
    }
    [$46f52113003b1da0$var$P]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $46f52113003b1da0$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $46f52113003b1da0$var$Te(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $46f52113003b1da0$export$2047cf34091e94ac;
}
function $46f52113003b1da0$var$Ce(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $46f52113003b1da0$export$fbcf11583158d2c;
}
function $46f52113003b1da0$var$Pe(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($46f52113003b1da0$var$X(t) && $46f52113003b1da0$var$G(t) > 0) return !0;
        if ($46f52113003b1da0$var$ot(t) && $46f52113003b1da0$var$rt(t) > 0) return !0;
        const r = $46f52113003b1da0$var$Ve(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $46f52113003b1da0$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $46f52113003b1da0$var$Pe(e)), null), (t)=>($46f52113003b1da0$var$Qe(e, t), null));
}
function $46f52113003b1da0$var$qe(e) {
    $46f52113003b1da0$var$De(e), e._pendingPullIntos = new $46f52113003b1da0$var$v;
}
function $46f52113003b1da0$var$Ee(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $46f52113003b1da0$var$We(t);
    "default" === t.readerType ? $46f52113003b1da0$var$U(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $46f52113003b1da0$var$We(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $46f52113003b1da0$var$Oe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $46f52113003b1da0$var$Be(e, t, r, o) {
    let n;
    try {
        n = $46f52113003b1da0$var$se(t, r, r + o);
    } catch (t) {
        throw $46f52113003b1da0$var$Qe(e, t), t;
    }
    $46f52113003b1da0$var$Oe(e, n, 0, o);
}
function $46f52113003b1da0$var$ke(e, t) {
    t.bytesFilled > 0 && $46f52113003b1da0$var$Be(e, t.buffer, t.byteOffset, t.bytesFilled), $46f52113003b1da0$var$$e(e);
}
function $46f52113003b1da0$var$je(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, a = !1;
    const i = o - o % t.elementSize;
    i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
    const l = e._queue;
    for(; n > 0;){
        const r = l.peek(), o = Math.min(n, r.byteLength), a = t.byteOffset + t.bytesFilled;
        $46f52113003b1da0$var$ae(t.buffer, a, r.buffer, r.byteOffset, o), r.byteLength === o ? l.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $46f52113003b1da0$var$Ae(e, o, t), n -= o;
    }
    return a;
}
function $46f52113003b1da0$var$Ae(e, t, r) {
    r.bytesFilled += t;
}
function $46f52113003b1da0$var$ze(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($46f52113003b1da0$var$Me(e), $46f52113003b1da0$var$Br(e._controlledReadableByteStream)) : $46f52113003b1da0$var$Pe(e);
}
function $46f52113003b1da0$var$De(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $46f52113003b1da0$var$Le(e) {
    for(; e._pendingPullIntos.length > 0;){
        if (0 === e._queueTotalSize) return;
        const t = e._pendingPullIntos.peek();
        $46f52113003b1da0$var$je(e, t) && ($46f52113003b1da0$var$$e(e), $46f52113003b1da0$var$Ee(e._controlledReadableByteStream, t));
    }
}
function $46f52113003b1da0$var$Fe(e, t, r, o) {
    const n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
        return $46f52113003b1da0$var$Re(e) ? 1 : e.BYTES_PER_ELEMENT;
    }(a), { byteOffset: l, byteLength: s } = t, u = r * i;
    let c;
    try {
        c = $46f52113003b1da0$var$ie(t.buffer);
    } catch (e) {
        return void o._errorSteps(e);
    }
    const d = {
        buffer: c,
        bufferByteLength: c.byteLength,
        byteOffset: l,
        byteLength: s,
        bytesFilled: 0,
        minimumFill: u,
        elementSize: i,
        viewConstructor: a,
        readerType: "byob"
    };
    if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $46f52113003b1da0$var$tt(n, o);
    if ("closed" !== n._state) {
        if (e._queueTotalSize > 0) {
            if ($46f52113003b1da0$var$je(e, d)) {
                const t = $46f52113003b1da0$var$We(d);
                return $46f52113003b1da0$var$ze(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $46f52113003b1da0$var$Qe(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), $46f52113003b1da0$var$tt(n, o), $46f52113003b1da0$var$Pe(e);
    } else {
        const e = new a(d.buffer, d.byteOffset, 0);
        o._closeSteps(e);
    }
}
function $46f52113003b1da0$var$Ie(e, t) {
    const r = e._pendingPullIntos.peek();
    $46f52113003b1da0$var$De(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $46f52113003b1da0$var$$e(e);
        const r = e._controlledReadableByteStream;
        if ($46f52113003b1da0$var$ot(r)) for(; $46f52113003b1da0$var$rt(r) > 0;)$46f52113003b1da0$var$Ee(r, $46f52113003b1da0$var$$e(e));
    }(e, r) : function(e, t, r) {
        if ($46f52113003b1da0$var$Ae(0, t, r), "none" === r.readerType) return $46f52113003b1da0$var$ke(e, r), void $46f52113003b1da0$var$Le(e);
        if (r.bytesFilled < r.minimumFill) return;
        $46f52113003b1da0$var$$e(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $46f52113003b1da0$var$Be(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o, $46f52113003b1da0$var$Ee(e._controlledReadableByteStream, r), $46f52113003b1da0$var$Le(e);
    }(e, t, r), $46f52113003b1da0$var$Pe(e);
}
function $46f52113003b1da0$var$$e(e) {
    return e._pendingPullIntos.shift();
}
function $46f52113003b1da0$var$Me(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $46f52113003b1da0$var$Ye(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize != 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $46f52113003b1da0$var$Qe(e, t), t;
                }
            }
            $46f52113003b1da0$var$Me(e), $46f52113003b1da0$var$Br(t);
        }
    }
}
function $46f52113003b1da0$var$xe(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: a } = t;
    if ($46f52113003b1da0$var$le(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const i = $46f52113003b1da0$var$ie(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($46f52113003b1da0$var$le(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $46f52113003b1da0$var$De(e), t.buffer = $46f52113003b1da0$var$ie(t.buffer), "none" === t.readerType && $46f52113003b1da0$var$ke(e, t);
    }
    if ($46f52113003b1da0$var$X(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $46f52113003b1da0$var$Ne(e, t._readRequests.shift());
            }
        }(e), 0 === $46f52113003b1da0$var$G(r)) $46f52113003b1da0$var$Oe(e, i, n, a);
        else {
            e._pendingPullIntos.length > 0 && $46f52113003b1da0$var$$e(e);
            $46f52113003b1da0$var$U(r, new Uint8Array(i, n, a), !1);
        }
    } else $46f52113003b1da0$var$ot(r) ? ($46f52113003b1da0$var$Oe(e, i, n, a), $46f52113003b1da0$var$Le(e)) : $46f52113003b1da0$var$Oe(e, i, n, a);
    $46f52113003b1da0$var$Pe(e);
}
function $46f52113003b1da0$var$Qe(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($46f52113003b1da0$var$qe(e), $46f52113003b1da0$var$we(e), $46f52113003b1da0$var$Me(e), $46f52113003b1da0$var$kr(r, t));
}
function $46f52113003b1da0$var$Ne(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $46f52113003b1da0$var$ze(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $46f52113003b1da0$var$He(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($46f52113003b1da0$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $46f52113003b1da0$var$Ve(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $46f52113003b1da0$var$Ue(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $46f52113003b1da0$var$ie(r.buffer), $46f52113003b1da0$var$Ie(e, t);
}
function $46f52113003b1da0$var$Ge(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $46f52113003b1da0$var$ie(t.buffer), $46f52113003b1da0$var$Ie(e, o);
}
function $46f52113003b1da0$var$Xe(e, t, r, o, n, a, i) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $46f52113003b1da0$var$we(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new $46f52113003b1da0$var$v, e._readableStreamController = t;
    $46f52113003b1da0$var$b($46f52113003b1da0$var$c(r()), ()=>(t._started = !0, $46f52113003b1da0$var$Pe(t), null), (e)=>($46f52113003b1da0$var$Qe(t, e), null));
}
function $46f52113003b1da0$var$Je(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $46f52113003b1da0$var$Ke(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $46f52113003b1da0$var$Ze(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $46f52113003b1da0$var$et(e) {
    return new $46f52113003b1da0$export$20068a30393fcc28(e);
}
function $46f52113003b1da0$var$tt(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $46f52113003b1da0$var$rt(e) {
    return e._reader._readIntoRequests.length;
}
function $46f52113003b1da0$var$ot(e) {
    const t = e._reader;
    return void 0 !== t && !!$46f52113003b1da0$var$nt(t);
}
Object.defineProperties($46f52113003b1da0$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$2047cf34091e94ac.prototype.close, "close"), $46f52113003b1da0$var$o($46f52113003b1da0$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $46f52113003b1da0$var$o($46f52113003b1da0$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $46f52113003b1da0$export$20068a30393fcc28 {
    constructor(e){
        if ($46f52113003b1da0$var$$(e, 1, "ReadableStreamBYOBReader"), $46f52113003b1da0$var$N(e, "First parameter"), $46f52113003b1da0$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$46f52113003b1da0$var$Te(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $46f52113003b1da0$var$q(this, e), this._readIntoRequests = new $46f52113003b1da0$var$v;
    }
    get closed() {
        return $46f52113003b1da0$var$nt(this) ? this._closedPromise : $46f52113003b1da0$var$d($46f52113003b1da0$var$lt("closed"));
    }
    cancel(e) {
        return $46f52113003b1da0$var$nt(this) ? void 0 === this._ownerReadableStream ? $46f52113003b1da0$var$d($46f52113003b1da0$var$O("cancel")) : $46f52113003b1da0$var$E(this, e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$lt("cancel"));
    }
    read(e, t = {}) {
        if (!$46f52113003b1da0$var$nt(this)) return $46f52113003b1da0$var$d($46f52113003b1da0$var$lt("read"));
        if (!ArrayBuffer.isView(e)) return $46f52113003b1da0$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $46f52113003b1da0$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $46f52113003b1da0$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($46f52113003b1da0$var$le(e.buffer)) return $46f52113003b1da0$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $46f52113003b1da0$var$L(e, t), {
                    min: $46f52113003b1da0$var$Q(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $46f52113003b1da0$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $46f52113003b1da0$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $46f52113003b1da0$var$Re(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $46f52113003b1da0$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $46f52113003b1da0$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $46f52113003b1da0$var$d($46f52113003b1da0$var$O("read from"));
        let n, a;
        const i = $46f52113003b1da0$var$u((e, t)=>{
            n = e, a = t;
        });
        return $46f52113003b1da0$var$at(this, e, o, {
            _chunkSteps: (e)=>n({
                    value: e,
                    done: !1
                }),
            _closeSteps: (e)=>n({
                    value: e,
                    done: !0
                }),
            _errorSteps: (e)=>a(e)
        }), i;
    }
    releaseLock() {
        if (!$46f52113003b1da0$var$nt(this)) throw $46f52113003b1da0$var$lt("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $46f52113003b1da0$var$W(e);
            const t = new TypeError("Reader was released");
            $46f52113003b1da0$var$it(e, t);
        }(this);
    }
}
function $46f52113003b1da0$var$nt(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $46f52113003b1da0$export$20068a30393fcc28;
}
function $46f52113003b1da0$var$at(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $46f52113003b1da0$var$Fe(n._readableStreamController, t, r, o);
}
function $46f52113003b1da0$var$it(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $46f52113003b1da0$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $46f52113003b1da0$var$lt(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $46f52113003b1da0$var$st(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($46f52113003b1da0$var$ye(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $46f52113003b1da0$var$ut(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $46f52113003b1da0$var$ct(e, t) {
    $46f52113003b1da0$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $46f52113003b1da0$var$Y(r),
        size: void 0 === o ? void 0 : $46f52113003b1da0$var$dt(o, `${t} has member 'size' that`)
    };
}
function $46f52113003b1da0$var$dt(e, t) {
    return $46f52113003b1da0$var$F(e, t), (t)=>$46f52113003b1da0$var$Y(e(t));
}
function $46f52113003b1da0$var$ft(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$g(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$bt(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), ()=>$46f52113003b1da0$var$g(e, t, []);
}
function $46f52113003b1da0$var$ht(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$S(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$mt(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r, o)=>$46f52113003b1da0$var$g(e, t, [
            r,
            o
        ]);
}
function $46f52113003b1da0$var$_t(e, t) {
    if (!$46f52113003b1da0$var$gt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
Object.defineProperties($46f52113003b1da0$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$20068a30393fcc28.prototype.cancel, "cancel"), $46f52113003b1da0$var$o($46f52113003b1da0$export$20068a30393fcc28.prototype.read, "read"), $46f52113003b1da0$var$o($46f52113003b1da0$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
const $46f52113003b1da0$var$pt = "function" == typeof AbortController;
class $46f52113003b1da0$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $46f52113003b1da0$var$I(e, "First parameter");
        const r = $46f52113003b1da0$var$ct(t, "Second parameter"), o = function(e, t) {
            $46f52113003b1da0$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $46f52113003b1da0$var$ft(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $46f52113003b1da0$var$bt(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $46f52113003b1da0$var$ht(n, e, `${t} has member 'start' that`),
                write: void 0 === i ? void 0 : $46f52113003b1da0$var$mt(i, e, `${t} has member 'write' that`),
                type: a
            };
        }(e, "First parameter");
        $46f52113003b1da0$var$St(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $46f52113003b1da0$var$ut(r);
        !function(e, t, r, o) {
            const n = Object.create($46f52113003b1da0$export$9e6890cb9a51c7c2.prototype);
            let a, i, l, s;
            a = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            i = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$46f52113003b1da0$var$c(void 0);
            l = void 0 !== t.close ? ()=>t.close() : ()=>$46f52113003b1da0$var$c(void 0);
            s = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$46f52113003b1da0$var$c(void 0);
            $46f52113003b1da0$var$Ft(e, n, a, i, l, s, r, o);
        }(this, o, $46f52113003b1da0$var$st(r, 1), n);
    }
    get locked() {
        if (!$46f52113003b1da0$var$gt(this)) throw $46f52113003b1da0$var$Nt("locked");
        return $46f52113003b1da0$var$vt(this);
    }
    abort(e) {
        return $46f52113003b1da0$var$gt(this) ? $46f52113003b1da0$var$vt(this) ? $46f52113003b1da0$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $46f52113003b1da0$var$wt(this, e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$Nt("abort"));
    }
    close() {
        return $46f52113003b1da0$var$gt(this) ? $46f52113003b1da0$var$vt(this) ? $46f52113003b1da0$var$d(new TypeError("Cannot close a stream that already has a writer")) : $46f52113003b1da0$var$qt(this) ? $46f52113003b1da0$var$d(new TypeError("Cannot close an already-closing stream")) : $46f52113003b1da0$var$Rt(this) : $46f52113003b1da0$var$d($46f52113003b1da0$var$Nt("close"));
    }
    getWriter() {
        if (!$46f52113003b1da0$var$gt(this)) throw $46f52113003b1da0$var$Nt("getWriter");
        return $46f52113003b1da0$var$yt(this);
    }
}
function $46f52113003b1da0$var$yt(e) {
    return new $46f52113003b1da0$export$9295348f005d6054(e);
}
function $46f52113003b1da0$var$St(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $46f52113003b1da0$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $46f52113003b1da0$var$gt(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $46f52113003b1da0$export$826849241f7970f8;
}
function $46f52113003b1da0$var$vt(e) {
    return void 0 !== e._writer;
}
function $46f52113003b1da0$var$wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $46f52113003b1da0$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $46f52113003b1da0$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const a = $46f52113003b1da0$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = a, n || $46f52113003b1da0$var$Ct(e, t), a;
}
function $46f52113003b1da0$var$Rt(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $46f52113003b1da0$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $46f52113003b1da0$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $46f52113003b1da0$var$or(o), $46f52113003b1da0$var$ve(n = e._writableStreamController, $46f52113003b1da0$var$Dt, 0), $46f52113003b1da0$var$Mt(n), r;
}
function $46f52113003b1da0$var$Tt(e, t) {
    "writable" !== e._state ? $46f52113003b1da0$var$Pt(e) : $46f52113003b1da0$var$Ct(e, t);
}
function $46f52113003b1da0$var$Ct(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $46f52113003b1da0$var$jt(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $46f52113003b1da0$var$Pt(e);
}
function $46f52113003b1da0$var$Pt(e) {
    e._state = "errored", e._writableStreamController[$46f52113003b1da0$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $46f52113003b1da0$var$v, void 0 === e._pendingAbortRequest) return void $46f52113003b1da0$var$Et(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $46f52113003b1da0$var$Et(e);
    $46f52113003b1da0$var$b(e._writableStreamController[$46f52113003b1da0$var$w](r._reason), ()=>(r._resolve(), $46f52113003b1da0$var$Et(e), null), (t)=>(r._reject(t), $46f52113003b1da0$var$Et(e), null));
}
function $46f52113003b1da0$var$qt(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $46f52113003b1da0$var$Et(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $46f52113003b1da0$var$Jt(t, e._storedError);
}
function $46f52113003b1da0$var$Wt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $46f52113003b1da0$var$Zt(e);
    }(r) : $46f52113003b1da0$var$or(r)), e._backpressure = t;
}
Object.defineProperties($46f52113003b1da0$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$826849241f7970f8.prototype.abort, "abort"), $46f52113003b1da0$var$o($46f52113003b1da0$export$826849241f7970f8.prototype.close, "close"), $46f52113003b1da0$var$o($46f52113003b1da0$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $46f52113003b1da0$export$9295348f005d6054 {
    constructor(e){
        if ($46f52113003b1da0$var$$(e, 1, "WritableStreamDefaultWriter"), $46f52113003b1da0$var$_t(e, "First parameter"), $46f52113003b1da0$var$vt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$46f52113003b1da0$var$qt(e) && e._backpressure ? $46f52113003b1da0$var$Zt(this) : $46f52113003b1da0$var$tr(this), $46f52113003b1da0$var$Gt(this);
        else if ("erroring" === t) $46f52113003b1da0$var$er(this, e._storedError), $46f52113003b1da0$var$Gt(this);
        else if ("closed" === t) $46f52113003b1da0$var$tr(this), $46f52113003b1da0$var$Gt(r = this), $46f52113003b1da0$var$Kt(r);
        else {
            const t = e._storedError;
            $46f52113003b1da0$var$er(this, t), $46f52113003b1da0$var$Xt(this, t);
        }
        var r;
    }
    get closed() {
        return $46f52113003b1da0$var$Ot(this) ? this._closedPromise : $46f52113003b1da0$var$d($46f52113003b1da0$var$Vt("closed"));
    }
    get desiredSize() {
        if (!$46f52113003b1da0$var$Ot(this)) throw $46f52113003b1da0$var$Vt("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $46f52113003b1da0$var$Ut("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $46f52113003b1da0$var$$t(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $46f52113003b1da0$var$Ot(this) ? this._readyPromise : $46f52113003b1da0$var$d($46f52113003b1da0$var$Vt("ready"));
    }
    abort(e) {
        return $46f52113003b1da0$var$Ot(this) ? void 0 === this._ownerWritableStream ? $46f52113003b1da0$var$d($46f52113003b1da0$var$Ut("abort")) : function(e, t) {
            return $46f52113003b1da0$var$wt(e._ownerWritableStream, t);
        }(this, e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$Vt("abort"));
    }
    close() {
        if (!$46f52113003b1da0$var$Ot(this)) return $46f52113003b1da0$var$d($46f52113003b1da0$var$Vt("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $46f52113003b1da0$var$d($46f52113003b1da0$var$Ut("close")) : $46f52113003b1da0$var$qt(e) ? $46f52113003b1da0$var$d(new TypeError("Cannot close an already-closing stream")) : $46f52113003b1da0$var$Bt(this);
    }
    releaseLock() {
        if (!$46f52113003b1da0$var$Ot(this)) throw $46f52113003b1da0$var$Vt("releaseLock");
        void 0 !== this._ownerWritableStream && $46f52113003b1da0$var$At(this);
    }
    write(e) {
        return $46f52113003b1da0$var$Ot(this) ? void 0 === this._ownerWritableStream ? $46f52113003b1da0$var$d($46f52113003b1da0$var$Ut("write to")) : $46f52113003b1da0$var$zt(this, e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$Vt("write"));
    }
}
function $46f52113003b1da0$var$Ot(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $46f52113003b1da0$export$9295348f005d6054;
}
function $46f52113003b1da0$var$Bt(e) {
    return $46f52113003b1da0$var$Rt(e._ownerWritableStream);
}
function $46f52113003b1da0$var$kt(e, t) {
    "pending" === e._closedPromiseState ? $46f52113003b1da0$var$Jt(e, t) : function(e, t) {
        $46f52113003b1da0$var$Xt(e, t);
    }(e, t);
}
function $46f52113003b1da0$var$jt(e, t) {
    "pending" === e._readyPromiseState ? $46f52113003b1da0$var$rr(e, t) : function(e, t) {
        $46f52113003b1da0$var$er(e, t);
    }(e, t);
}
function $46f52113003b1da0$var$At(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $46f52113003b1da0$var$jt(e, r), $46f52113003b1da0$var$kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $46f52113003b1da0$var$zt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $46f52113003b1da0$var$Yt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $46f52113003b1da0$var$d($46f52113003b1da0$var$Ut("write to"));
    const a = r._state;
    if ("errored" === a) return $46f52113003b1da0$var$d(r._storedError);
    if ($46f52113003b1da0$var$qt(r) || "closed" === a) return $46f52113003b1da0$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === a) return $46f52113003b1da0$var$d(r._storedError);
    const i = function(e) {
        return $46f52113003b1da0$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $46f52113003b1da0$var$ve(e, t, r);
        } catch (t) {
            return void $46f52113003b1da0$var$Yt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$46f52113003b1da0$var$qt(o) && "writable" === o._state) $46f52113003b1da0$var$Wt(o, $46f52113003b1da0$var$xt(e));
        $46f52113003b1da0$var$Mt(e);
    }(o, t, n), i;
}
Object.defineProperties($46f52113003b1da0$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$9295348f005d6054.prototype.abort, "abort"), $46f52113003b1da0$var$o($46f52113003b1da0$export$9295348f005d6054.prototype.close, "close"), $46f52113003b1da0$var$o($46f52113003b1da0$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $46f52113003b1da0$var$o($46f52113003b1da0$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $46f52113003b1da0$var$Dt = {};
class $46f52113003b1da0$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$46f52113003b1da0$var$Lt(this)) throw $46f52113003b1da0$var$Ht("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$46f52113003b1da0$var$Lt(this)) throw $46f52113003b1da0$var$Ht("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$46f52113003b1da0$var$Lt(this)) throw $46f52113003b1da0$var$Ht("error");
        "writable" === this._controlledWritableStream._state && $46f52113003b1da0$var$Qt(this, e);
    }
    [$46f52113003b1da0$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $46f52113003b1da0$var$It(this), t;
    }
    [$46f52113003b1da0$var$R]() {
        $46f52113003b1da0$var$we(this);
    }
}
function $46f52113003b1da0$var$Lt(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $46f52113003b1da0$export$9e6890cb9a51c7c2;
}
function $46f52113003b1da0$var$Ft(e, t, r, o, n, a, i, l) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $46f52113003b1da0$var$we(t), t._abortReason = void 0, t._abortController = function() {
        if ($46f52113003b1da0$var$pt) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
    const s = $46f52113003b1da0$var$xt(t);
    $46f52113003b1da0$var$Wt(e, s);
    $46f52113003b1da0$var$b($46f52113003b1da0$var$c(r()), ()=>(t._started = !0, $46f52113003b1da0$var$Mt(t), null), (r)=>(t._started = !0, $46f52113003b1da0$var$Tt(e, r), null));
}
function $46f52113003b1da0$var$It(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $46f52113003b1da0$var$$t(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $46f52113003b1da0$var$Mt(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $46f52113003b1da0$var$Pt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $46f52113003b1da0$var$Dt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $46f52113003b1da0$var$ge(e);
        const r = e._closeAlgorithm();
        $46f52113003b1da0$var$It(e), $46f52113003b1da0$var$b(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $46f52113003b1da0$var$Kt(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $46f52113003b1da0$var$Tt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $46f52113003b1da0$var$b(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($46f52113003b1da0$var$ge(e), !$46f52113003b1da0$var$qt(r) && "writable" === t) {
                const t = $46f52113003b1da0$var$xt(e);
                $46f52113003b1da0$var$Wt(r, t);
            }
            return $46f52113003b1da0$var$Mt(e), null;
        }, (t)=>("writable" === r._state && $46f52113003b1da0$var$It(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $46f52113003b1da0$var$Tt(e, t);
            }(r, t), null));
    }(e, r);
}
function $46f52113003b1da0$var$Yt(e, t) {
    "writable" === e._controlledWritableStream._state && $46f52113003b1da0$var$Qt(e, t);
}
function $46f52113003b1da0$var$xt(e) {
    return $46f52113003b1da0$var$$t(e) <= 0;
}
function $46f52113003b1da0$var$Qt(e, t) {
    const r = e._controlledWritableStream;
    $46f52113003b1da0$var$It(e), $46f52113003b1da0$var$Ct(r, t);
}
function $46f52113003b1da0$var$Nt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $46f52113003b1da0$var$Ht(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $46f52113003b1da0$var$Vt(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $46f52113003b1da0$var$Ut(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $46f52113003b1da0$var$Gt(e) {
    e._closedPromise = $46f52113003b1da0$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $46f52113003b1da0$var$Xt(e, t) {
    $46f52113003b1da0$var$Gt(e), $46f52113003b1da0$var$Jt(e, t);
}
function $46f52113003b1da0$var$Jt(e, t) {
    void 0 !== e._closedPromise_reject && ($46f52113003b1da0$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $46f52113003b1da0$var$Kt(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $46f52113003b1da0$var$Zt(e) {
    e._readyPromise = $46f52113003b1da0$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $46f52113003b1da0$var$er(e, t) {
    $46f52113003b1da0$var$Zt(e), $46f52113003b1da0$var$rr(e, t);
}
function $46f52113003b1da0$var$tr(e) {
    $46f52113003b1da0$var$Zt(e), $46f52113003b1da0$var$or(e);
}
function $46f52113003b1da0$var$rr(e, t) {
    void 0 !== e._readyPromise_reject && ($46f52113003b1da0$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $46f52113003b1da0$var$or(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($46f52113003b1da0$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $46f52113003b1da0$var$nr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $46f52113003b1da0$var$ar = function() {
    const e = null == $46f52113003b1da0$var$nr ? void 0 : $46f52113003b1da0$var$nr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $46f52113003b1da0$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $46f52113003b1da0$var$ir(t, r, o, n, a, i) {
    const l = $46f52113003b1da0$var$H(t), s = $46f52113003b1da0$var$yt(r);
    t._disturbed = !0;
    let _ = !1, y = $46f52113003b1da0$var$c(void 0);
    return $46f52113003b1da0$var$u((S, g)=>{
        let v;
        if (void 0 !== i) {
            if (v = ()=>{
                const e = void 0 !== i.reason ? i.reason : new $46f52113003b1da0$var$ar("Aborted", "AbortError"), o = [];
                n || o.push(()=>"writable" === r._state ? $46f52113003b1da0$var$wt(r, e) : $46f52113003b1da0$var$c(void 0)), a || o.push(()=>"readable" === t._state ? $46f52113003b1da0$var$Or(t, e) : $46f52113003b1da0$var$c(void 0)), q(()=>Promise.all(o.map((e)=>e())), !0, e);
            }, i.aborted) return void v();
            i.addEventListener("abort", v);
        }
        var w, R, T;
        if (P(t, l._closedPromise, (e)=>(n ? E(!0, e) : q(()=>$46f52113003b1da0$var$wt(r, e), !0, e), null)), P(r, s._closedPromise, (e)=>(a ? E(!0, e) : q(()=>$46f52113003b1da0$var$Or(t, e), !0, e), null)), w = t, R = l._closedPromise, T = ()=>(o ? E() : q(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $46f52113003b1da0$var$qt(t) || "closed" === r ? $46f52113003b1da0$var$c(void 0) : "errored" === r ? $46f52113003b1da0$var$d(t._storedError) : $46f52113003b1da0$var$Bt(e);
                })(s)), null), "closed" === w._state ? T() : $46f52113003b1da0$var$h(R, T), $46f52113003b1da0$var$qt(r) || "closed" === r._state) {
            const e = new TypeError("the destination writable stream closed before all data could be piped to it");
            a ? E(!0, e) : q(()=>$46f52113003b1da0$var$Or(t, e), !0, e);
        }
        function C() {
            const e = y;
            return $46f52113003b1da0$var$f(y, ()=>e !== y ? C() : void 0);
        }
        function P(e, t, r) {
            "errored" === e._state ? r(e._storedError) : $46f52113003b1da0$var$m(t, r);
        }
        function q(e, t, o) {
            function n() {
                return $46f52113003b1da0$var$b(e(), ()=>O(t, o), (e)=>O(!0, e)), null;
            }
            _ || (_ = !0, "writable" !== r._state || $46f52113003b1da0$var$qt(r) ? n() : $46f52113003b1da0$var$h(C(), n));
        }
        function E(e, t) {
            _ || (_ = !0, "writable" !== r._state || $46f52113003b1da0$var$qt(r) ? O(e, t) : $46f52113003b1da0$var$h(C(), ()=>O(e, t)));
        }
        function O(e, t) {
            return $46f52113003b1da0$var$At(s), $46f52113003b1da0$var$W(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
        }
        $46f52113003b1da0$var$p($46f52113003b1da0$var$u((t, r)=>{
            !function o(n) {
                n ? t() : $46f52113003b1da0$var$f(_ ? $46f52113003b1da0$var$c(!0) : $46f52113003b1da0$var$f(s._readyPromise, ()=>$46f52113003b1da0$var$u((t, r)=>{
                        $46f52113003b1da0$var$K(l, {
                            _chunkSteps: (r)=>{
                                y = $46f52113003b1da0$var$f($46f52113003b1da0$var$zt(s, r), void 0, $46f52113003b1da0$var$e), t(!1);
                            },
                            _closeSteps: ()=>t(!0),
                            _errorSteps: r
                        });
                    })), o, r);
            }(!1);
        }));
    });
}
class $46f52113003b1da0$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$46f52113003b1da0$var$lr(this)) throw $46f52113003b1da0$var$pr("desiredSize");
        return $46f52113003b1da0$var$hr(this);
    }
    close() {
        if (!$46f52113003b1da0$var$lr(this)) throw $46f52113003b1da0$var$pr("close");
        if (!$46f52113003b1da0$var$mr(this)) throw new TypeError("The stream is not in a state that permits close");
        $46f52113003b1da0$var$dr(this);
    }
    enqueue(e) {
        if (!$46f52113003b1da0$var$lr(this)) throw $46f52113003b1da0$var$pr("enqueue");
        if (!$46f52113003b1da0$var$mr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $46f52113003b1da0$var$fr(this, e);
    }
    error(e) {
        if (!$46f52113003b1da0$var$lr(this)) throw $46f52113003b1da0$var$pr("error");
        $46f52113003b1da0$var$br(this, e);
    }
    [$46f52113003b1da0$var$T](e) {
        $46f52113003b1da0$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $46f52113003b1da0$var$cr(this), t;
    }
    [$46f52113003b1da0$var$C](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $46f52113003b1da0$var$ge(this);
            this._closeRequested && 0 === this._queue.length ? ($46f52113003b1da0$var$cr(this), $46f52113003b1da0$var$Br(t)) : $46f52113003b1da0$var$sr(this), e._chunkSteps(r);
        } else $46f52113003b1da0$var$V(t, e), $46f52113003b1da0$var$sr(this);
    }
    [$46f52113003b1da0$var$P]() {}
}
function $46f52113003b1da0$var$lr(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $46f52113003b1da0$export$b0bb6d0989d67700;
}
function $46f52113003b1da0$var$sr(e) {
    if (!$46f52113003b1da0$var$ur(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $46f52113003b1da0$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $46f52113003b1da0$var$sr(e)), null), (t)=>($46f52113003b1da0$var$br(e, t), null));
}
function $46f52113003b1da0$var$ur(e) {
    const t = e._controlledReadableStream;
    if (!$46f52113003b1da0$var$mr(e)) return !1;
    if (!e._started) return !1;
    if ($46f52113003b1da0$var$Wr(t) && $46f52113003b1da0$var$G(t) > 0) return !0;
    return $46f52113003b1da0$var$hr(e) > 0;
}
function $46f52113003b1da0$var$cr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $46f52113003b1da0$var$dr(e) {
    if (!$46f52113003b1da0$var$mr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($46f52113003b1da0$var$cr(e), $46f52113003b1da0$var$Br(t));
}
function $46f52113003b1da0$var$fr(e, t) {
    if (!$46f52113003b1da0$var$mr(e)) return;
    const r = e._controlledReadableStream;
    if ($46f52113003b1da0$var$Wr(r) && $46f52113003b1da0$var$G(r) > 0) $46f52113003b1da0$var$U(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $46f52113003b1da0$var$br(e, t), t;
        }
        try {
            $46f52113003b1da0$var$ve(e, t, r);
        } catch (t) {
            throw $46f52113003b1da0$var$br(e, t), t;
        }
    }
    $46f52113003b1da0$var$sr(e);
}
function $46f52113003b1da0$var$br(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($46f52113003b1da0$var$we(e), $46f52113003b1da0$var$cr(e), $46f52113003b1da0$var$kr(r, t));
}
function $46f52113003b1da0$var$hr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $46f52113003b1da0$var$mr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $46f52113003b1da0$var$_r(e, t, r, o, n, a, i) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $46f52113003b1da0$var$we(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $46f52113003b1da0$var$b($46f52113003b1da0$var$c(r()), ()=>(t._started = !0, $46f52113003b1da0$var$sr(t), null), (e)=>($46f52113003b1da0$var$br(t, e), null));
}
function $46f52113003b1da0$var$pr(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $46f52113003b1da0$var$yr(e, t) {
    return $46f52113003b1da0$var$Te(e._readableStreamController) ? function(e) {
        let t, r, o, n, a, i = $46f52113003b1da0$var$H(e), l = !1, s = !1, d = !1, f = !1, b = !1;
        const h = $46f52113003b1da0$var$u((e)=>{
            a = e;
        });
        function _(e) {
            $46f52113003b1da0$var$m(e._closedPromise, (t)=>(e !== i || ($46f52113003b1da0$var$Qe(o._readableStreamController, t), $46f52113003b1da0$var$Qe(n._readableStreamController, t), f && b || a(void 0)), null));
        }
        function p() {
            $46f52113003b1da0$var$nt(i) && ($46f52113003b1da0$var$W(i), i = $46f52113003b1da0$var$H(e), _(i));
            $46f52113003b1da0$var$K(i, {
                _chunkSteps: (t)=>{
                    $46f52113003b1da0$var$y(()=>{
                        s = !1, d = !1;
                        const r = t;
                        let i = t;
                        if (!f && !b) try {
                            i = $46f52113003b1da0$var$Se(t);
                        } catch (t) {
                            return $46f52113003b1da0$var$Qe(o._readableStreamController, t), $46f52113003b1da0$var$Qe(n._readableStreamController, t), void a($46f52113003b1da0$var$Or(e, t));
                        }
                        f || $46f52113003b1da0$var$xe(o._readableStreamController, r), b || $46f52113003b1da0$var$xe(n._readableStreamController, i), l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    l = !1, f || $46f52113003b1da0$var$Ye(o._readableStreamController), b || $46f52113003b1da0$var$Ye(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $46f52113003b1da0$var$Ue(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $46f52113003b1da0$var$Ue(n._readableStreamController, 0), f && b || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function S(t, r) {
            $46f52113003b1da0$var$J(i) && ($46f52113003b1da0$var$W(i), i = $46f52113003b1da0$var$et(e), _(i));
            const u = r ? n : o, c = r ? o : n;
            $46f52113003b1da0$var$at(i, t, 1, {
                _chunkSteps: (t)=>{
                    $46f52113003b1da0$var$y(()=>{
                        s = !1, d = !1;
                        const o = r ? b : f;
                        if (r ? f : b) o || $46f52113003b1da0$var$Ge(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $46f52113003b1da0$var$Se(t);
                            } catch (t) {
                                return $46f52113003b1da0$var$Qe(u._readableStreamController, t), $46f52113003b1da0$var$Qe(c._readableStreamController, t), void a($46f52113003b1da0$var$Or(e, t));
                            }
                            o || $46f52113003b1da0$var$Ge(u._readableStreamController, t), $46f52113003b1da0$var$xe(c._readableStreamController, r);
                        }
                        l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    l = !1;
                    const t = r ? b : f, o = r ? f : b;
                    t || $46f52113003b1da0$var$Ye(u._readableStreamController), o || $46f52113003b1da0$var$Ye(c._readableStreamController), void 0 !== e && (t || $46f52113003b1da0$var$Ge(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $46f52113003b1da0$var$Ue(c._readableStreamController, 0)), t && o || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function g() {
            if (l) return s = !0, $46f52113003b1da0$var$c(void 0);
            l = !0;
            const e = $46f52113003b1da0$var$He(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $46f52113003b1da0$var$c(void 0);
        }
        function v() {
            if (l) return d = !0, $46f52113003b1da0$var$c(void 0);
            l = !0;
            const e = $46f52113003b1da0$var$He(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $46f52113003b1da0$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, b) {
                const o = $46f52113003b1da0$var$ne([
                    t,
                    r
                ]), n = $46f52113003b1da0$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function R(o) {
            if (b = !0, r = o, f) {
                const o = $46f52113003b1da0$var$ne([
                    t,
                    r
                ]), n = $46f52113003b1da0$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function T() {}
        return o = $46f52113003b1da0$var$Pr(T, g, w), n = $46f52113003b1da0$var$Pr(T, v, R), _(i), [
            o,
            n
        ];
    }(e) : function(e, t) {
        const r = $46f52113003b1da0$var$H(e);
        let o, n, a, i, l, s = !1, d = !1, f = !1, b = !1;
        const h = $46f52113003b1da0$var$u((e)=>{
            l = e;
        });
        function _() {
            if (s) return d = !0, $46f52113003b1da0$var$c(void 0);
            s = !0;
            return $46f52113003b1da0$var$K(r, {
                _chunkSteps: (e)=>{
                    $46f52113003b1da0$var$y(()=>{
                        d = !1;
                        const t = e, r = e;
                        f || $46f52113003b1da0$var$fr(a._readableStreamController, t), b || $46f52113003b1da0$var$fr(i._readableStreamController, r), s = !1, d && _();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, f || $46f52113003b1da0$var$dr(a._readableStreamController), b || $46f52113003b1da0$var$dr(i._readableStreamController), f && b || l(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            }), $46f52113003b1da0$var$c(void 0);
        }
        function p(t) {
            if (f = !0, o = t, b) {
                const t = $46f52113003b1da0$var$ne([
                    o,
                    n
                ]), r = $46f52113003b1da0$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function S(t) {
            if (b = !0, n = t, f) {
                const t = $46f52113003b1da0$var$ne([
                    o,
                    n
                ]), r = $46f52113003b1da0$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function g() {}
        return a = $46f52113003b1da0$var$Cr(g, _, p), i = $46f52113003b1da0$var$Cr(g, _, S), $46f52113003b1da0$var$m(r._closedPromise, (e)=>($46f52113003b1da0$var$br(a._readableStreamController, e), $46f52113003b1da0$var$br(i._readableStreamController, e), f && b || l(void 0), null)), [
            a,
            i
        ];
    }(e);
}
function $46f52113003b1da0$var$Sr(r) {
    var o;
    return $46f52113003b1da0$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $46f52113003b1da0$var$d(e);
            }
            return $46f52113003b1da0$var$_(e, (e)=>{
                if (!$46f52113003b1da0$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $46f52113003b1da0$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $46f52113003b1da0$var$fr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            try {
                return $46f52113003b1da0$var$c(r.cancel(e));
            } catch (e) {
                return $46f52113003b1da0$var$d(e);
            }
        }
        return o = $46f52113003b1da0$var$Cr($46f52113003b1da0$var$e, n, a, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $46f52113003b1da0$var$fe(r, "async");
        function a() {
            let e;
            try {
                e = $46f52113003b1da0$var$be(n);
            } catch (e) {
                return $46f52113003b1da0$var$d(e);
            }
            return $46f52113003b1da0$var$_($46f52113003b1da0$var$c(e), (e)=>{
                if (!$46f52113003b1da0$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $46f52113003b1da0$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $46f52113003b1da0$var$fr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            const r = n.iterator;
            let o;
            try {
                o = $46f52113003b1da0$var$ue(r, "return");
            } catch (e) {
                return $46f52113003b1da0$var$d(e);
            }
            if (void 0 === o) return $46f52113003b1da0$var$c(void 0);
            return $46f52113003b1da0$var$_($46f52113003b1da0$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$46f52113003b1da0$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $46f52113003b1da0$var$Cr($46f52113003b1da0$var$e, a, i, 0), o;
    }(r);
}
function $46f52113003b1da0$var$gr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$g(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$vr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$g(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$wr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$S(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$Rr(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $46f52113003b1da0$var$Tr(e, t) {
    $46f52113003b1da0$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
    return void 0 !== a && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(a, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: a
    };
}
Object.defineProperties($46f52113003b1da0$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$b0bb6d0989d67700.prototype.close, "close"), $46f52113003b1da0$var$o($46f52113003b1da0$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $46f52113003b1da0$var$o($46f52113003b1da0$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $46f52113003b1da0$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $46f52113003b1da0$var$I(e, "First parameter");
        const r = $46f52113003b1da0$var$ct(t, "Second parameter"), o = function(e, t) {
            $46f52113003b1da0$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $46f52113003b1da0$var$Q(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $46f52113003b1da0$var$gr(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === a ? void 0 : $46f52113003b1da0$var$vr(a, r, `${t} has member 'pull' that`),
                start: void 0 === i ? void 0 : $46f52113003b1da0$var$wr(i, r, `${t} has member 'start' that`),
                type: void 0 === l ? void 0 : $46f52113003b1da0$var$Rr(l, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($46f52113003b1da0$var$qr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($46f52113003b1da0$export$2047cf34091e94ac.prototype);
                let n, a, i;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$46f52113003b1da0$var$c(void 0), i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$46f52113003b1da0$var$c(void 0);
                const l = t.autoAllocateChunkSize;
                if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $46f52113003b1da0$var$Xe(e, o, n, a, i, r, l);
            }(this, o, $46f52113003b1da0$var$st(r, 0));
        } else {
            const e = $46f52113003b1da0$var$ut(r);
            !function(e, t, r, o) {
                const n = Object.create($46f52113003b1da0$export$b0bb6d0989d67700.prototype);
                let a, i, l;
                a = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$46f52113003b1da0$var$c(void 0), l = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$46f52113003b1da0$var$c(void 0), $46f52113003b1da0$var$_r(e, n, a, i, l, r, o);
            }(this, o, $46f52113003b1da0$var$st(r, 1), e);
        }
    }
    get locked() {
        if (!$46f52113003b1da0$var$Er(this)) throw $46f52113003b1da0$var$jr("locked");
        return $46f52113003b1da0$var$Wr(this);
    }
    cancel(e) {
        return $46f52113003b1da0$var$Er(this) ? $46f52113003b1da0$var$Wr(this) ? $46f52113003b1da0$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $46f52113003b1da0$var$Or(this, e) : $46f52113003b1da0$var$d($46f52113003b1da0$var$jr("cancel"));
    }
    getReader(e) {
        if (!$46f52113003b1da0$var$Er(this)) throw $46f52113003b1da0$var$jr("getReader");
        return void 0 === function(e, t) {
            $46f52113003b1da0$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $46f52113003b1da0$var$Ze(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $46f52113003b1da0$var$H(this) : $46f52113003b1da0$var$et(this);
    }
    pipeThrough(e, t = {}) {
        if (!$46f52113003b1da0$var$Er(this)) throw $46f52113003b1da0$var$jr("pipeThrough");
        $46f52113003b1da0$var$$(e, 1, "pipeThrough");
        const r = function(e, t) {
            $46f52113003b1da0$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $46f52113003b1da0$var$M(r, "readable", "ReadableWritablePair"), $46f52113003b1da0$var$N(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $46f52113003b1da0$var$M(o, "writable", "ReadableWritablePair"), $46f52113003b1da0$var$_t(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $46f52113003b1da0$var$Tr(t, "Second parameter");
        if ($46f52113003b1da0$var$Wr(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($46f52113003b1da0$var$vt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $46f52113003b1da0$var$p($46f52113003b1da0$var$ir(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$46f52113003b1da0$var$Er(this)) return $46f52113003b1da0$var$d($46f52113003b1da0$var$jr("pipeTo"));
        if (void 0 === e) return $46f52113003b1da0$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$46f52113003b1da0$var$gt(e)) return $46f52113003b1da0$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $46f52113003b1da0$var$Tr(t, "Second parameter");
        } catch (e) {
            return $46f52113003b1da0$var$d(e);
        }
        return $46f52113003b1da0$var$Wr(this) ? $46f52113003b1da0$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $46f52113003b1da0$var$vt(e) ? $46f52113003b1da0$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $46f52113003b1da0$var$ir(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$46f52113003b1da0$var$Er(this)) throw $46f52113003b1da0$var$jr("tee");
        return $46f52113003b1da0$var$ne($46f52113003b1da0$var$yr(this));
    }
    values(e) {
        if (!$46f52113003b1da0$var$Er(this)) throw $46f52113003b1da0$var$jr("values");
        return function(e, t) {
            const r = $46f52113003b1da0$var$H(e), o = new $46f52113003b1da0$var$he(r, t), n = Object.create($46f52113003b1da0$var$me);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $46f52113003b1da0$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$46f52113003b1da0$var$de](e) {
        return this.values(e);
    }
    static from(e) {
        return $46f52113003b1da0$var$Sr(e);
    }
}
function $46f52113003b1da0$var$Cr(e, t, r, o = 1, n = ()=>1) {
    const a = Object.create($46f52113003b1da0$export$5d3e1e5268af5f76.prototype);
    $46f52113003b1da0$var$qr(a);
    return $46f52113003b1da0$var$_r(a, Object.create($46f52113003b1da0$export$b0bb6d0989d67700.prototype), e, t, r, o, n), a;
}
function $46f52113003b1da0$var$Pr(e, t, r) {
    const o = Object.create($46f52113003b1da0$export$5d3e1e5268af5f76.prototype);
    $46f52113003b1da0$var$qr(o);
    return $46f52113003b1da0$var$Xe(o, Object.create($46f52113003b1da0$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $46f52113003b1da0$var$qr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $46f52113003b1da0$var$Er(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $46f52113003b1da0$export$5d3e1e5268af5f76;
}
function $46f52113003b1da0$var$Wr(e) {
    return void 0 !== e._reader;
}
function $46f52113003b1da0$var$Or(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $46f52113003b1da0$var$c(void 0);
    if ("errored" === t._state) return $46f52113003b1da0$var$d(t._storedError);
    $46f52113003b1da0$var$Br(t);
    const o = t._reader;
    if (void 0 !== o && $46f52113003b1da0$var$nt(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $46f52113003b1da0$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $46f52113003b1da0$var$_(t._readableStreamController[$46f52113003b1da0$var$T](r), $46f52113003b1da0$var$e);
}
function $46f52113003b1da0$var$Br(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($46f52113003b1da0$var$A(t), $46f52113003b1da0$var$J(t))) {
        const e = t._readRequests;
        t._readRequests = new $46f52113003b1da0$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $46f52113003b1da0$var$kr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($46f52113003b1da0$var$j(r, t), $46f52113003b1da0$var$J(r) ? $46f52113003b1da0$var$Z(r, t) : $46f52113003b1da0$var$it(r, t));
}
function $46f52113003b1da0$var$jr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $46f52113003b1da0$var$Ar(e, t) {
    $46f52113003b1da0$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $46f52113003b1da0$var$M(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $46f52113003b1da0$var$Y(r)
    };
}
Object.defineProperties($46f52113003b1da0$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($46f52113003b1da0$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.from, "from"), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.prototype.tee, "tee"), $46f52113003b1da0$var$o($46f52113003b1da0$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($46f52113003b1da0$export$5d3e1e5268af5f76.prototype, $46f52113003b1da0$var$de, {
    value: $46f52113003b1da0$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $46f52113003b1da0$var$zr = (e)=>e.byteLength;
$46f52113003b1da0$var$o($46f52113003b1da0$var$zr, "size");
class $46f52113003b1da0$export$d386b5f37d154119 {
    constructor(e){
        $46f52113003b1da0$var$$(e, 1, "ByteLengthQueuingStrategy"), e = $46f52113003b1da0$var$Ar(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$46f52113003b1da0$var$Lr(this)) throw $46f52113003b1da0$var$Dr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$46f52113003b1da0$var$Lr(this)) throw $46f52113003b1da0$var$Dr("size");
        return $46f52113003b1da0$var$zr;
    }
}
function $46f52113003b1da0$var$Dr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $46f52113003b1da0$var$Lr(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $46f52113003b1da0$export$d386b5f37d154119;
}
Object.defineProperties($46f52113003b1da0$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $46f52113003b1da0$var$Fr = ()=>1;
$46f52113003b1da0$var$o($46f52113003b1da0$var$Fr, "size");
class $46f52113003b1da0$export$9ebfec18c2dfc625 {
    constructor(e){
        $46f52113003b1da0$var$$(e, 1, "CountQueuingStrategy"), e = $46f52113003b1da0$var$Ar(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$46f52113003b1da0$var$$r(this)) throw $46f52113003b1da0$var$Ir("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$46f52113003b1da0$var$$r(this)) throw $46f52113003b1da0$var$Ir("size");
        return $46f52113003b1da0$var$Fr;
    }
}
function $46f52113003b1da0$var$Ir(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $46f52113003b1da0$var$$r(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $46f52113003b1da0$export$9ebfec18c2dfc625;
}
function $46f52113003b1da0$var$Mr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$g(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$Yr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$S(e, t, [
            r
        ]);
}
function $46f52113003b1da0$var$xr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r, o)=>$46f52113003b1da0$var$g(e, t, [
            r,
            o
        ]);
}
function $46f52113003b1da0$var$Qr(e, t, r) {
    return $46f52113003b1da0$var$F(e, r), (r)=>$46f52113003b1da0$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($46f52113003b1da0$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $46f52113003b1da0$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $46f52113003b1da0$var$ct(t, "Second parameter"), n = $46f52113003b1da0$var$ct(r, "Third parameter"), a = function(e, t) {
            $46f52113003b1da0$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $46f52113003b1da0$var$Qr(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $46f52113003b1da0$var$Mr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === a ? void 0 : $46f52113003b1da0$var$Yr(a, e, `${t} has member 'start' that`),
                transform: void 0 === i ? void 0 : $46f52113003b1da0$var$xr(i, e, `${t} has member 'transform' that`),
                writableType: l
            };
        }(e, "First parameter");
        if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
        const i = $46f52113003b1da0$var$st(n, 0), l = $46f52113003b1da0$var$ut(n), s = $46f52113003b1da0$var$st(o, 1), f = $46f52113003b1da0$var$ut(o);
        let h;
        !function(e, t, r, o, n, a) {
            function i() {
                return t;
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $46f52113003b1da0$var$_(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $46f52113003b1da0$var$Zr(r, t);
                    });
                    return $46f52113003b1da0$var$Zr(r, t);
                }(e, t);
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $46f52113003b1da0$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $46f52113003b1da0$var$Jr(r), $46f52113003b1da0$var$b(n, ()=>("errored" === o._state ? $46f52113003b1da0$var$ro(r, o._storedError) : ($46f52113003b1da0$var$br(o._readableStreamController, t), $46f52113003b1da0$var$to(r)), null), (e)=>($46f52113003b1da0$var$br(o._readableStreamController, e), $46f52113003b1da0$var$ro(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $46f52113003b1da0$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $46f52113003b1da0$var$Jr(t), $46f52113003b1da0$var$b(o, ()=>("errored" === r._state ? $46f52113003b1da0$var$ro(t, r._storedError) : ($46f52113003b1da0$var$dr(r._readableStreamController), $46f52113003b1da0$var$to(t)), null), (e)=>($46f52113003b1da0$var$br(r._readableStreamController, e), $46f52113003b1da0$var$ro(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $46f52113003b1da0$var$Gr(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $46f52113003b1da0$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $46f52113003b1da0$var$Jr(r), $46f52113003b1da0$var$b(n, ()=>("errored" === o._state ? $46f52113003b1da0$var$ro(r, o._storedError) : ($46f52113003b1da0$var$Yt(o._writableStreamController, t), $46f52113003b1da0$var$Ur(e), $46f52113003b1da0$var$to(r)), null), (t)=>($46f52113003b1da0$var$Yt(o._writableStreamController, t), $46f52113003b1da0$var$Ur(e), $46f52113003b1da0$var$ro(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, a = ()=>1) {
                const i = Object.create($46f52113003b1da0$export$826849241f7970f8.prototype);
                return $46f52113003b1da0$var$St(i), $46f52113003b1da0$var$Ft(i, Object.create($46f52113003b1da0$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, a), i;
            }(i, l, c, s, r, o), e._readable = $46f52113003b1da0$var$Cr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $46f52113003b1da0$var$Gr(e, !0), e._transformStreamController = void 0;
        }(this, $46f52113003b1da0$var$u((e)=>{
            h = e;
        }), s, f, i, l), function(e, t) {
            const r = Object.create($46f52113003b1da0$export$a55559184460222.prototype);
            let o, n, a;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $46f52113003b1da0$var$Kr(r, e), $46f52113003b1da0$var$c(void 0);
                } catch (e) {
                    return $46f52113003b1da0$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$46f52113003b1da0$var$c(void 0);
            a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$46f52113003b1da0$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, a);
        }(this, a), void 0 !== a.start ? h(a.start(this._transformStreamController)) : h(void 0);
    }
    get readable() {
        if (!$46f52113003b1da0$var$Nr(this)) throw $46f52113003b1da0$var$oo("readable");
        return this._readable;
    }
    get writable() {
        if (!$46f52113003b1da0$var$Nr(this)) throw $46f52113003b1da0$var$oo("writable");
        return this._writable;
    }
}
function $46f52113003b1da0$var$Nr(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $46f52113003b1da0$export$d102341634899398;
}
function $46f52113003b1da0$var$Hr(e, t) {
    $46f52113003b1da0$var$br(e._readable._readableStreamController, t), $46f52113003b1da0$var$Vr(e, t);
}
function $46f52113003b1da0$var$Vr(e, t) {
    $46f52113003b1da0$var$Jr(e._transformStreamController), $46f52113003b1da0$var$Yt(e._writable._writableStreamController, t), $46f52113003b1da0$var$Ur(e);
}
function $46f52113003b1da0$var$Ur(e) {
    e._backpressure && $46f52113003b1da0$var$Gr(e, !1);
}
function $46f52113003b1da0$var$Gr(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $46f52113003b1da0$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($46f52113003b1da0$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $46f52113003b1da0$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$46f52113003b1da0$var$Xr(this)) throw $46f52113003b1da0$var$eo("desiredSize");
        return $46f52113003b1da0$var$hr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$46f52113003b1da0$var$Xr(this)) throw $46f52113003b1da0$var$eo("enqueue");
        $46f52113003b1da0$var$Kr(this, e);
    }
    error(e) {
        if (!$46f52113003b1da0$var$Xr(this)) throw $46f52113003b1da0$var$eo("error");
        var t;
        t = e, $46f52113003b1da0$var$Hr(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$46f52113003b1da0$var$Xr(this)) throw $46f52113003b1da0$var$eo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $46f52113003b1da0$var$dr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $46f52113003b1da0$var$Vr(t, r);
        }(this);
    }
}
function $46f52113003b1da0$var$Xr(e) {
    return !!$46f52113003b1da0$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $46f52113003b1da0$export$a55559184460222;
}
function $46f52113003b1da0$var$Jr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $46f52113003b1da0$var$Kr(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$46f52113003b1da0$var$mr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $46f52113003b1da0$var$fr(o, t);
    } catch (e) {
        throw $46f52113003b1da0$var$Vr(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$46f52113003b1da0$var$ur(e);
    }(o);
    n !== r._backpressure && $46f52113003b1da0$var$Gr(r, !0);
}
function $46f52113003b1da0$var$Zr(e, t) {
    return $46f52113003b1da0$var$_(e._transformAlgorithm(t), void 0, (t)=>{
        throw $46f52113003b1da0$var$Hr(e._controlledTransformStream, t), t;
    });
}
function $46f52113003b1da0$var$eo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $46f52113003b1da0$var$to(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $46f52113003b1da0$var$ro(e, t) {
    void 0 !== e._finishPromise_reject && ($46f52113003b1da0$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $46f52113003b1da0$var$oo(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($46f52113003b1da0$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $46f52113003b1da0$var$o($46f52113003b1da0$export$a55559184460222.prototype.enqueue, "enqueue"), $46f52113003b1da0$var$o($46f52113003b1da0$export$a55559184460222.prototype.error, "error"), $46f52113003b1da0$var$o($46f52113003b1da0$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($46f52113003b1da0$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});


function $9c65e1276bf6a281$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $9c65e1276bf6a281$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $9c65e1276bf6a281$var$$082ef78710a13331$exports = {};
var $9c65e1276bf6a281$var$$80184bab4212ab17$exports = {};
var $9c65e1276bf6a281$var$$400caf514fe4dd82$exports = {};
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $9c65e1276bf6a281$export$e03c1c3201ee8bb7;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $9c65e1276bf6a281$export$6287f85d0f6a9342;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$400caf514fe4dd82$exports, "persist", function() {
    return $9c65e1276bf6a281$export$9a6132153fba2e0;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$400caf514fe4dd82$exports, "restore", function() {
    return $9c65e1276bf6a281$export$db239ef39aadc7fe;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $9c65e1276bf6a281$export$b1fb4cac938035f7;
});
var $9c65e1276bf6a281$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $9c65e1276bf6a281$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $9c65e1276bf6a281$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === "number" ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === "number" ? --value : false);
                }
            });
        };
}
function $9c65e1276bf6a281$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $9c65e1276bf6a281$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === "granted") return new Notification(typeof message === "function" ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
const $9c65e1276bf6a281$var$$400caf514fe4dd82$var$PersistKeys = new WeakMap();
function $9c65e1276bf6a281$export$9a6132153fba2e0(patcher = {}) {
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $9c65e1276bf6a281$var$$400caf514fe4dd82$var$PersistKeys.get(this) || [];
            list.push(Object.assign(Object.assign({}, patcher), {
                key: name.toString()
            }));
            $9c65e1276bf6a281$var$$400caf514fe4dd82$var$PersistKeys.set(this, list);
        });
    };
}
function $9c65e1276bf6a281$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $9c65e1276bf6a281$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        var _a;
        const { get: load, set: save } = yield $366a29267488e9ac$exports, list = $9c65e1276bf6a281$var$$400caf514fe4dd82$var$PersistKeys.get(classInstance) || [], restoredData = {};
        for (const { key: key, get: get, set: set } of list){
            const itemKey = `${storeKey}-${key}`;
            const value = yield load(itemKey);
            const patchedValue = (_a = get === null || get === void 0 ? void 0 : get(value)) !== null && _a !== void 0 ? _a : value;
            if (patchedValue != null) {
                Reflect.set(classInstance, key, patchedValue);
                restoredData[key] = patchedValue;
            }
            (0, $kAoxL.reaction)(()=>classInstance[key], (value)=>{
                const patchedValue = set === null || set === void 0 ? void 0 : set(value);
                return save(itemKey, patchedValue !== null && patchedValue !== void 0 ? patchedValue : (0, $kAoxL.toJS)(value));
            });
        }
        if ((0, $a1a155eb9166d0df$export$dd1bc94b04021eeb)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $9c65e1276bf6a281$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $9c65e1276bf6a281$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const { del: del } = yield $366a29267488e9ac$exports, list = $9c65e1276bf6a281$var$$400caf514fe4dd82$var$PersistKeys.get(classInstance) || [];
        for (const { key: key } of list){
            const itemKey = `${storeKey}-${key}`;
            yield del(itemKey);
        }
    });
}
$9c65e1276bf6a281$var$$parcel$exportWildcard($9c65e1276bf6a281$var$$082ef78710a13331$exports, $9c65e1276bf6a281$var$$80184bab4212ab17$exports);
$9c65e1276bf6a281$var$$parcel$exportWildcard($9c65e1276bf6a281$var$$082ef78710a13331$exports, $9c65e1276bf6a281$var$$400caf514fe4dd82$exports);
var $9c65e1276bf6a281$var$$16892940cfb7bd51$exports = {};
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $9c65e1276bf6a281$export$d12e20a4eec10acf;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $9c65e1276bf6a281$export$673dbc4a8d0cb20a;
});
var $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $9c65e1276bf6a281$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $kAoxL.observable)
        ];
        _uploading_decorators = [
            (0, $kAoxL.observable)
        ];
        _clear_decorators = [
            (0, $kAoxL.action)
        ];
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $9c65e1276bf6a281$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $9c65e1276bf6a281$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + "");
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), "id")
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $kAoxL.observable)
        ];
        _clearCurrent_decorators = [
            (0, $kAoxL.action)
        ];
        _updateOne_decorators = [
            $9c65e1276bf6a281$export$e03c1c3201ee8bb7("uploading")
        ];
        _getOne_decorators = [
            $9c65e1276bf6a281$export$e03c1c3201ee8bb7("downloading")
        ];
        _deleteOne_decorators = [
            $9c65e1276bf6a281$export$e03c1c3201ee8bb7("uploading")
        ];
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $9c65e1276bf6a281$var$$5766c49bacaeb5b8$exports = {};
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $9c65e1276bf6a281$export$36e5777a1ba4b7c3;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $9c65e1276bf6a281$export$a143d493d941bafc;
});
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $9c65e1276bf6a281$export$6a4eb2e7fc9e8903;
});
var $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $9c65e1276bf6a281$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage;
    let _classSuper = $9c65e1276bf6a281$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        get pageIndex() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $kAoxL.toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $a1a155eb9166d0df$export$697c3df919c0e61a)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $a1a155eb9166d0df$export$697c3df919c0e61a)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAll() {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageSize = this.pageSize) {
                while(!this.noMore)yield this.getList(filter, undefined, pageSize);
                return this.allItems;
            });
        }
        countAll(keys_1) {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $a1a155eb9166d0df$export$1d012a0dff3dab06)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers);
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _pageIndex_decorators = [
            (0, $kAoxL.observable)
        ];
        _pageSize_decorators = [
            (0, $kAoxL.observable)
        ];
        _filter_decorators = [
            (0, $kAoxL.observable)
        ];
        _totalCount_decorators = [
            (0, $kAoxL.observable)
        ];
        _pageList_decorators = [
            (0, $kAoxL.observable)
        ];
        _get_currentPage_decorators = [
            (0, $kAoxL.computed)
        ];
        _get_pageCount_decorators = [
            (0, $kAoxL.computed)
        ];
        _get_allItems_decorators = [
            (0, $kAoxL.computed)
        ];
        _get_noMore_decorators = [
            (0, $kAoxL.computed)
        ];
        _statistic_decorators = [
            (0, $kAoxL.observable)
        ];
        _clearList_decorators = [
            (0, $kAoxL.action)
        ];
        _restoreList_decorators = [
            (0, $kAoxL.action)
        ];
        _turnTo_decorators = [
            (0, $kAoxL.action)
        ];
        _getList_decorators = [
            $9c65e1276bf6a281$export$e03c1c3201ee8bb7("downloading")
        ];
        _deleteOne_decorators = [
            $9c65e1276bf6a281$export$e03c1c3201ee8bb7("uploading")
        ];
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $9c65e1276bf6a281$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $kAoxL.action),
                $9c65e1276bf6a281$export$e03c1c3201ee8bb7("downloading")
            ];
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $9c65e1276bf6a281$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $a1a155eb9166d0df$export$697c3df919c0e61a)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $9c65e1276bf6a281$export$e03c1c3201ee8bb7("downloading")
            ];
            $9c65e1276bf6a281$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}
var $9c65e1276bf6a281$var$$5bda69183db6db33$exports = {};
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$5bda69183db6db33$exports, "Downloader", function() {
    return $9c65e1276bf6a281$export$ef06e7620d37c296;
});
var $9c65e1276bf6a281$var$$71107f2a0d00cd1d$exports = {};
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$71107f2a0d00cd1d$exports, "HTTPDownloadTask", function() {
    return $9c65e1276bf6a281$export$54a5aef4e85ae85;
});
var $9c65e1276bf6a281$var$$d278b456907e9c31$exports = {};
$9c65e1276bf6a281$var$$parcel$export($9c65e1276bf6a281$var$$d278b456907e9c31$exports, "DownloadTask", function() {
    return $9c65e1276bf6a281$export$e9ba70c733fe1cb8;
});
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9c65e1276bf6a281$var$$d278b456907e9c31$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
let $9c65e1276bf6a281$export$e9ba70c733fe1cb8 = (()=>{
    var _a, _DownloadTask_id_accessor_storage, _DownloadTask_name_accessor_storage, _DownloadTask_path_accessor_storage, _DownloadTask_fsHandle_accessor_storage, _DownloadTask_total_accessor_storage, _DownloadTask_loaded_accessor_storage, _DownloadTask_percent_accessor_storage, _DownloadTask_executing_accessor_storage, _DownloadTask_options_accessor_storage;
    var _b;
    let _instanceExtraInitializers = [];
    let _id_decorators;
    let _id_initializers = [];
    let _id_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _fsHandle_decorators;
    let _fsHandle_initializers = [];
    let _fsHandle_extraInitializers = [];
    let _total_decorators;
    let _total_initializers = [];
    let _total_extraInitializers = [];
    let _loaded_decorators;
    let _loaded_initializers = [];
    let _loaded_extraInitializers = [];
    let _percent_decorators;
    let _percent_initializers = [];
    let _percent_extraInitializers = [];
    let _executing_decorators;
    let _executing_initializers = [];
    let _executing_extraInitializers = [];
    let _options_decorators;
    let _options_initializers = [];
    let _options_extraInitializers = [];
    let _get_totalSize_decorators;
    let _get_loadedSize_decorators;
    return _a = class DownloadTask {
        get id() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_id_accessor_storage, "f");
        }
        set id(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_id_accessor_storage, value, "f");
        }
        get name() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_name_accessor_storage, "f");
        }
        set name(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_name_accessor_storage, value, "f");
        }
        get path() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_path_accessor_storage, "f");
        }
        set path(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_path_accessor_storage, value, "f");
        }
        get fsHandle() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_fsHandle_accessor_storage, "f");
        }
        set fsHandle(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_fsHandle_accessor_storage, value, "f");
        }
        get total() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_total_accessor_storage, "f");
        }
        set total(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_total_accessor_storage, value, "f");
        }
        get loaded() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_loaded_accessor_storage, "f");
        }
        set loaded(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_loaded_accessor_storage, value, "f");
        }
        get percent() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_percent_accessor_storage, "f");
        }
        set percent(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_percent_accessor_storage, value, "f");
        }
        get executing() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_executing_accessor_storage, "f");
        }
        set executing(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_executing_accessor_storage, value, "f");
        }
        get options() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_options_accessor_storage, "f");
        }
        set options(value) {
            $9c65e1276bf6a281$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_options_accessor_storage, value, "f");
        }
        get totalSize() {
            return new (0, $a1a155eb9166d0df$export$271f7c16f175f804)(this.total);
        }
        get loadedSize() {
            return new (0, $a1a155eb9166d0df$export$271f7c16f175f804)(this.loaded);
        }
        static nameOf(URI) {
            return decodeURI(new URL(URI).pathname.split("/").filter(Boolean).at(-1));
        }
        constructor(path, name = _a.nameOf(path)){
            _DownloadTask_id_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _instanceExtraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _id_initializers, "")));
            _DownloadTask_name_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _id_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _name_initializers, "")));
            _DownloadTask_path_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _name_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _path_initializers, "")));
            _DownloadTask_fsHandle_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _path_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _fsHandle_initializers, void 0)));
            _DownloadTask_total_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _fsHandle_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _total_initializers, 0)));
            _DownloadTask_loaded_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _total_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _loaded_initializers, 0)));
            _DownloadTask_percent_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _loaded_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _percent_initializers, 0)));
            _DownloadTask_executing_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _percent_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _executing_initializers, false)));
            _DownloadTask_options_accessor_storage.set(this, ($9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _executing_extraInitializers), $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _options_initializers, void 0)));
            Object.defineProperty(this, "stream", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $9c65e1276bf6a281$var$$d278b456907e9c31$var$__runInitializers(this, _options_extraInitializers)
            });
            this.path = path;
            this.name = name;
        }
        toJSON() {
            const { id: id, name: name, path: path, fsHandle: fsHandle, total: total, loaded: loaded, percent: percent, options: options } = this;
            return Object.assign({
                id: id,
                name: name,
                path: path,
                fsHandle: fsHandle,
                options: options
            }, {
                total: total,
                loaded: loaded,
                percent: percent
            });
        }
        saveMeta(data = {}) {
            const { buffer: buffer } = data, progress = $9c65e1276bf6a281$var$$d278b456907e9c31$var$__rest(data, [
                "buffer"
            ]);
            Object.assign(this, progress);
            return data;
        }
        start() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__awaiter(this, arguments, void 0, function*(options = this.options) {
                this.options = options;
                const started = Promise.withResolvers();
                const [innerStream, outerStream] = (yield $46f52113003b1da0$exports).ReadableStream.from(this.loadStream(options)).tee();
                (()=>$9c65e1276bf6a281$var$$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                        var _b, e_1, _c, _d;
                        try {
                            try {
                                for(var _e = true, innerStream_1 = $9c65e1276bf6a281$var$$d278b456907e9c31$var$__asyncValues(innerStream), innerStream_1_1; innerStream_1_1 = yield innerStream_1.next(), _b = innerStream_1_1.done, !_b; _e = true){
                                    _d = innerStream_1_1.value;
                                    _e = false;
                                    const chunk = _d;
                                    started.resolve();
                                    console.table(chunk);
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (!_e && !_b && (_c = innerStream_1.return)) yield _c.call(innerStream_1);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                        } catch (error) {
                            started.reject(error);
                        }
                    }))();
                yield started.promise;
                return this.stream = outerStream;
            });
        }
        pause() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                this.executing = false;
            });
        }
        destroy() {
            return $9c65e1276bf6a281$var$$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pause();
                return $9c65e1276bf6a281$export$b1fb4cac938035f7(this, this.id);
            });
        }
    }, _DownloadTask_id_accessor_storage = new WeakMap(), _DownloadTask_name_accessor_storage = new WeakMap(), _DownloadTask_path_accessor_storage = new WeakMap(), _DownloadTask_fsHandle_accessor_storage = new WeakMap(), _DownloadTask_total_accessor_storage = new WeakMap(), _DownloadTask_loaded_accessor_storage = new WeakMap(), _DownloadTask_percent_accessor_storage = new WeakMap(), _DownloadTask_executing_accessor_storage = new WeakMap(), _DownloadTask_options_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _name_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _path_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _fsHandle_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (_b = (0, $kAoxL.observable)).ref.bind(_b)
        ];
        _total_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _loaded_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _percent_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _executing_decorators = [
            (0, $kAoxL.observable)
        ];
        _options_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0(),
            (0, $kAoxL.observable)
        ];
        _get_totalSize_decorators = [
            (0, $kAoxL.computed)
        ];
        _get_loadedSize_decorators = [
            (0, $kAoxL.computed)
        ];
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: (obj)=>"id" in obj,
                get: (obj)=>obj.id,
                set: (obj, value)=>{
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"name" in obj,
                get: (obj)=>obj.name,
                set: (obj, value)=>{
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _fsHandle_decorators, {
            kind: "accessor",
            name: "fsHandle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fsHandle" in obj,
                get: (obj)=>obj.fsHandle,
                set: (obj, value)=>{
                    obj.fsHandle = value;
                }
            },
            metadata: _metadata
        }, _fsHandle_initializers, _fsHandle_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _total_decorators, {
            kind: "accessor",
            name: "total",
            static: false,
            private: false,
            access: {
                has: (obj)=>"total" in obj,
                get: (obj)=>obj.total,
                set: (obj, value)=>{
                    obj.total = value;
                }
            },
            metadata: _metadata
        }, _total_initializers, _total_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _loaded_decorators, {
            kind: "accessor",
            name: "loaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loaded" in obj,
                get: (obj)=>obj.loaded,
                set: (obj, value)=>{
                    obj.loaded = value;
                }
            },
            metadata: _metadata
        }, _loaded_initializers, _loaded_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _percent_decorators, {
            kind: "accessor",
            name: "percent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"percent" in obj,
                get: (obj)=>obj.percent,
                set: (obj, value)=>{
                    obj.percent = value;
                }
            },
            metadata: _metadata
        }, _percent_initializers, _percent_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _executing_decorators, {
            kind: "accessor",
            name: "executing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executing" in obj,
                get: (obj)=>obj.executing,
                set: (obj, value)=>{
                    obj.executing = value;
                }
            },
            metadata: _metadata
        }, _executing_initializers, _executing_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _options_decorators, {
            kind: "accessor",
            name: "options",
            static: false,
            private: false,
            access: {
                has: (obj)=>"options" in obj,
                get: (obj)=>obj.options,
                set: (obj, value)=>{
                    obj.options = value;
                }
            },
            metadata: _metadata
        }, _options_initializers, _options_extraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _get_totalSize_decorators, {
            kind: "getter",
            name: "totalSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalSize" in obj,
                get: (obj)=>obj.totalSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$d278b456907e9c31$var$__esDecorate(_a, null, _get_loadedSize_decorators, {
            kind: "getter",
            name: "loadedSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadedSize" in obj,
                get: (obj)=>obj.loadedSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await = function(v) {
    return this instanceof $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await ? (this.v = v, this) : new $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(v);
};
var $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $9c65e1276bf6a281$export$54a5aef4e85ae85 extends $9c65e1276bf6a281$export$e9ba70c733fe1cb8 {
    constructor(path, name){
        super(path, name);
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, $89e48cd0768a697f$export$45cf759b359d3d24)({
                responseType: "arraybuffer"
            })
        });
        this.id = `http-download-task-${this.name}`;
        $9c65e1276bf6a281$export$db239ef39aadc7fe(this, this.id);
    }
    loadStream(options) {
        return $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__asyncGenerator(this, arguments, function* loadStream_1() {
            var _a, e_1, _b, _c;
            const { path: path } = this;
            const suggestedName = $9c65e1276bf6a281$export$e9ba70c733fe1cb8.nameOf(path);
            this.fsHandle || (this.fsHandle = yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await((yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await($82111daab1cb7b2d$exports)).showSaveFilePicker({
                suggestedName: suggestedName
            })));
            const writer = yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(this.fsHandle.createWritable({
                keepExistingData: true
            })), stream = this.client.download(path, Object.assign({
                range: [
                    this.loaded
                ]
            }, options));
            try {
                this.executing = true;
                try {
                    for(var _d = true, stream_1 = $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(stream_1.next()), _a = stream_1_1.done, !_a; _d = true){
                        _c = stream_1_1.value;
                        _d = false;
                        const chunk = _c;
                        yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(writer.write({
                            type: "write",
                            position: this.loaded,
                            data: chunk.buffer
                        }));
                        yield yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(this.saveMeta(chunk));
                        if (!this.executing) break;
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = stream_1.return)) yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(_b.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            } finally{
                yield $9c65e1276bf6a281$var$$71107f2a0d00cd1d$var$__await(writer.close());
                this.executing = false;
            }
        });
    }
}
var $9c65e1276bf6a281$var$$5bda69183db6db33$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9c65e1276bf6a281$var$$5bda69183db6db33$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9c65e1276bf6a281$var$$5bda69183db6db33$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9c65e1276bf6a281$var$$5bda69183db6db33$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9c65e1276bf6a281$var$$5bda69183db6db33$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $9c65e1276bf6a281$export$ef06e7620d37c296 = (()=>{
    var _a, _Downloader_tasks_accessor_storage;
    let _instanceExtraInitializers = [];
    let _tasks_decorators;
    let _tasks_initializers = [];
    let _tasks_extraInitializers = [];
    let _get_unfinishedCount_decorators;
    let _get_executingCount_decorators;
    return _a = class Downloader {
        static createTask(path, name) {
            const [protocol] = path.split(":");
            const ProtocolTask = _a.protocolMap[protocol];
            if (!ProtocolTask) throw new URIError(`Protocol "${protocol} has not been registered"`);
            return new ProtocolTask(path, name);
        }
        constructor(){
            _Downloader_tasks_accessor_storage.set(this, ($9c65e1276bf6a281$var$$5bda69183db6db33$var$__runInitializers(this, _instanceExtraInitializers), $9c65e1276bf6a281$var$$5bda69183db6db33$var$__runInitializers(this, _tasks_initializers, [])));
            $9c65e1276bf6a281$var$$5bda69183db6db33$var$__runInitializers(this, _tasks_extraInitializers);
            $9c65e1276bf6a281$export$db239ef39aadc7fe(this, "downloader");
        }
        get tasks() {
            return $9c65e1276bf6a281$var$$5bda69183db6db33$var$__classPrivateFieldGet(this, _Downloader_tasks_accessor_storage, "f");
        }
        set tasks(value) {
            $9c65e1276bf6a281$var$$5bda69183db6db33$var$__classPrivateFieldSet(this, _Downloader_tasks_accessor_storage, value, "f");
        }
        get unfinishedCount() {
            return this.tasks.filter(({ percent: percent })=>percent < 100).length;
        }
        get executingCount() {
            return this.tasks.filter(({ executing: executing })=>executing).length;
        }
        createTask(path, name) {
            const { tasks: tasks } = this;
            const sameTask = tasks.find((task)=>task.path === path);
            if (sameTask) return sameTask;
            const task = _a.createTask(path, name);
            this.tasks = [
                ...tasks,
                task
            ];
            return task;
        }
        destroyTask(name) {
            return $9c65e1276bf6a281$var$$5bda69183db6db33$var$__awaiter(this, void 0, void 0, function*() {
                const { tasks: tasks } = this;
                const index = tasks.findIndex(({ name: N })=>N === name);
                if (index < 0) throw new ReferenceError(`${name} isn't found`);
                yield tasks[index].destroy();
                this.tasks = [
                    ...tasks.slice(0, index),
                    ...tasks.slice(index + 1)
                ];
            });
        }
    }, _Downloader_tasks_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tasks_decorators = [
            $9c65e1276bf6a281$export$9a6132153fba2e0({
                set: (tasks)=>tasks.map(({ name: name, path: path })=>({
                            name: name,
                            path: path
                        })),
                get: (list)=>list === null || list === void 0 ? void 0 : list.map(({ name: name, path: path })=>$9c65e1276bf6a281$export$ef06e7620d37c296.createTask(path, name))
            }),
            (0, $kAoxL.observable)
        ];
        _get_unfinishedCount_decorators = [
            (0, $kAoxL.computed)
        ];
        _get_executingCount_decorators = [
            (0, $kAoxL.computed)
        ];
        $9c65e1276bf6a281$var$$5bda69183db6db33$var$__esDecorate(_a, null, _tasks_decorators, {
            kind: "accessor",
            name: "tasks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tasks" in obj,
                get: (obj)=>obj.tasks,
                set: (obj, value)=>{
                    obj.tasks = value;
                }
            },
            metadata: _metadata
        }, _tasks_initializers, _tasks_extraInitializers);
        $9c65e1276bf6a281$var$$5bda69183db6db33$var$__esDecorate(_a, null, _get_unfinishedCount_decorators, {
            kind: "getter",
            name: "unfinishedCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"unfinishedCount" in obj,
                get: (obj)=>obj.unfinishedCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9c65e1276bf6a281$var$$5bda69183db6db33$var$__esDecorate(_a, null, _get_executingCount_decorators, {
            kind: "getter",
            name: "executingCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executingCount" in obj,
                get: (obj)=>obj.executingCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), Object.defineProperty(_a, "protocolMap", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            http: $9c65e1276bf6a281$export$54a5aef4e85ae85,
            https: $9c65e1276bf6a281$export$54a5aef4e85ae85
        }
    }), _a;
})();
$9c65e1276bf6a281$var$$parcel$exportWildcard($9c65e1276bf6a281$var$$5bda69183db6db33$exports, $9c65e1276bf6a281$var$$71107f2a0d00cd1d$exports);
$9c65e1276bf6a281$var$$parcel$exportWildcard($9c65e1276bf6a281$var$$5bda69183db6db33$exports, $9c65e1276bf6a281$var$$d278b456907e9c31$exports);


var $0dbd2646a343d857$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $0dbd2646a343d857$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $0dbd2646a343d857$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0dbd2646a343d857$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $0dbd2646a343d857$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $0dbd2646a343d857$export$efa691df22055b3e = (()=>{
    var _a, _EthersModel_provider_accessor_storage, _EthersModel_signer_accessor_storage, _EthersModel_address_accessor_storage;
    let _classSuper = (0, $9c65e1276bf6a281$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _provider_decorators;
    let _provider_initializers = [];
    let _provider_extraInitializers = [];
    let _signer_decorators;
    let _signer_initializers = [];
    let _signer_extraInitializers = [];
    let _address_decorators;
    let _address_initializers = [];
    let _address_extraInitializers = [];
    let _signMessage_decorators;
    let _getAddress_decorators;
    return _a = class EthersModel extends _classSuper {
        get provider() {
            return $0dbd2646a343d857$var$__classPrivateFieldGet(this, _EthersModel_provider_accessor_storage, "f");
        }
        set provider(value) {
            $0dbd2646a343d857$var$__classPrivateFieldSet(this, _EthersModel_provider_accessor_storage, value, "f");
        }
        get signer() {
            return $0dbd2646a343d857$var$__classPrivateFieldGet(this, _EthersModel_signer_accessor_storage, "f");
        }
        set signer(value) {
            $0dbd2646a343d857$var$__classPrivateFieldSet(this, _EthersModel_signer_accessor_storage, value, "f");
        }
        get address() {
            return $0dbd2646a343d857$var$__classPrivateFieldGet(this, _EthersModel_address_accessor_storage, "f");
        }
        set address(value) {
            $0dbd2646a343d857$var$__classPrivateFieldSet(this, _EthersModel_address_accessor_storage, value, "f");
        }
        init() {
            return $0dbd2646a343d857$var$__awaiter(this, void 0, void 0, function*() {
                if (!window.ethereum) return console.error("MetaMask not install");
                this.provider = new (0, $0b5eb0c0b0db8127$export$8d50d0931f78dec8)(window.ethereum);
                this.signer = yield this.provider.getSigner();
            });
        }
        signMessage(message) {
            return this.signer.signMessage(message);
        }
        getAddress() {
            return $0dbd2646a343d857$var$__awaiter(this, void 0, void 0, function*() {
                const eth_address = yield this.signer.getAddress();
                return this.address = localStorage.eth_address = eth_address;
            });
        }
        constructor(){
            super(...arguments);
            _EthersModel_provider_accessor_storage.set(this, ($0dbd2646a343d857$var$__runInitializers(this, _instanceExtraInitializers), $0dbd2646a343d857$var$__runInitializers(this, _provider_initializers, (0, $fac209858859fbd7$export$4f77a1d3c1ac6642)())));
            _EthersModel_signer_accessor_storage.set(this, ($0dbd2646a343d857$var$__runInitializers(this, _provider_extraInitializers), $0dbd2646a343d857$var$__runInitializers(this, _signer_initializers, void 0)));
            _EthersModel_address_accessor_storage.set(this, ($0dbd2646a343d857$var$__runInitializers(this, _signer_extraInitializers), $0dbd2646a343d857$var$__runInitializers(this, _address_initializers, localStorage.eth_address)));
            $0dbd2646a343d857$var$__runInitializers(this, _address_extraInitializers);
        }
    }, _EthersModel_provider_accessor_storage = new WeakMap(), _EthersModel_signer_accessor_storage = new WeakMap(), _EthersModel_address_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _provider_decorators = [
            (0, $kAoxL.observable)
        ];
        _signer_decorators = [
            (0, $kAoxL.observable)
        ];
        _address_decorators = [
            (0, $kAoxL.observable)
        ];
        _signMessage_decorators = [
            (0, $9c65e1276bf6a281$export$e03c1c3201ee8bb7)("uploading")
        ];
        _getAddress_decorators = [
            (0, $kAoxL.action),
            (0, $9c65e1276bf6a281$export$e03c1c3201ee8bb7)("downloading")
        ];
        $0dbd2646a343d857$var$__esDecorate(_a, null, _provider_decorators, {
            kind: "accessor",
            name: "provider",
            static: false,
            private: false,
            access: {
                has: (obj)=>"provider" in obj,
                get: (obj)=>obj.provider,
                set: (obj, value)=>{
                    obj.provider = value;
                }
            },
            metadata: _metadata
        }, _provider_initializers, _provider_extraInitializers);
        $0dbd2646a343d857$var$__esDecorate(_a, null, _signer_decorators, {
            kind: "accessor",
            name: "signer",
            static: false,
            private: false,
            access: {
                has: (obj)=>"signer" in obj,
                get: (obj)=>obj.signer,
                set: (obj, value)=>{
                    obj.signer = value;
                }
            },
            metadata: _metadata
        }, _signer_initializers, _signer_extraInitializers);
        $0dbd2646a343d857$var$__esDecorate(_a, null, _address_decorators, {
            kind: "accessor",
            name: "address",
            static: false,
            private: false,
            access: {
                has: (obj)=>"address" in obj,
                get: (obj)=>obj.address,
                set: (obj, value)=>{
                    obj.address = value;
                }
            },
            metadata: _metadata
        }, _address_initializers, _address_extraInitializers);
        $0dbd2646a343d857$var$__esDecorate(_a, null, _signMessage_decorators, {
            kind: "method",
            name: "signMessage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"signMessage" in obj,
                get: (obj)=>obj.signMessage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $0dbd2646a343d857$var$__esDecorate(_a, null, _getAddress_decorators, {
            kind: "method",
            name: "getAddress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getAddress" in obj,
                get: (obj)=>obj.getAddress
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $0dbd2646a343d857$export$2e2bcd8739ae039 = new $0dbd2646a343d857$export$efa691df22055b3e();






var $kAoxL = parcelRequire("kAoxL");

parcelRequire("4HBpa");

const $f6965111910e6c5c$export$b0ab8a875b84a64a = (0, $kAoxL.observable)(new Map());
const $f6965111910e6c5c$export$2808da24ccf8bc0b = ()=>(0, $4b02975e2cd02ed1$export$b9c7ecd090a87b14)(()=>{
        const list = [
            ...$f6965111910e6c5c$export$b0ab8a875b84a64a.values()
        ];
        return /*#__PURE__*/ (0, $384457d72cc1e1d1$exports.createPortal)(list.length ? (0, $237889e76c767d38$exports.jsx)("div", {
            className: "global-toast-layer",
            children: list.map(({ key: key, content: content, error: error, className: className })=>(0, $237889e76c767d38$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("global-toast-item d-flex align-items-center", className, error && "global-toast-item-error"),
                    children: [
                        (0, $237889e76c767d38$exports.jsx)((0, $b2d204ad2c8a6909$exports.Icon), {
                            name: error ? "exclamation-octagon" : "info-circle",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("me-3", error ? "global-toast-item-error" : "text-white")
                        }),
                        content
                    ]
                }, key))
        }) : null, document.body);
    });
function $f6965111910e6c5c$export$b410431fab84fa58(config) {
    const conf = Object.assign(Object.assign({}, config), {
        key: new Date().toJSON(),
        duration: config.duration || 3000
    });
    $f6965111910e6c5c$export$b0ab8a875b84a64a.set(conf.key, conf);
    const remove = ()=>{
        $f6965111910e6c5c$export$b0ab8a875b84a64a.delete(conf.key);
    };
    if (conf.duration) setTimeout(remove, conf.duration);
    return remove;
}
function $f6965111910e6c5c$export$26ae4b6927d0e993(err, config) {
    const message = !err ? "unknown error" : (err === null || err === void 0 ? void 0 : err.message) ? err.message : typeof err === "string" ? err : JSON.stringify(err);
    return $f6965111910e6c5c$export$b410431fab84fa58(Object.assign(Object.assign({}, config), {
        content: message,
        error: true
    }));
}


var $f75a252a80b327d5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f75a252a80b327d5$export$9ab766ce7f4c1f3c = (addr)=>{
    const upperAfterLastTwo = addr.slice(0, 2) + addr.slice(2);
    return `${upperAfterLastTwo.substring(0, 5)}...${upperAfterLastTwo.substring(39)}`;
};
const $f75a252a80b327d5$export$784d13d8ee351f07 = (value, tips)=>$f75a252a80b327d5$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            yield navigator.clipboard.writeText(value);
            (0, $f6965111910e6c5c$export$b410431fab84fa58)({
                content: tips
            });
        } catch (error) {
            console.log(error);
        }
    });






var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");



"use client";
const $bc3b27084a3fd43e$var$CardBody = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-body");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$bc3b27084a3fd43e$var$CardBody.displayName = "CardBody";
var $bc3b27084a3fd43e$export$2e2bcd8739ae039 = $bc3b27084a3fd43e$var$CardBody;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $aa0e1c924b7d9f52$var$CardFooter = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-footer");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$aa0e1c924b7d9f52$var$CardFooter.displayName = "CardFooter";
var $aa0e1c924b7d9f52$export$2e2bcd8739ae039 = $aa0e1c924b7d9f52$var$CardFooter;




var $4HBpa = parcelRequire("4HBpa");



"use client";
const $5a83b6d7ba56d7d9$var$CardHeader = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-header");
    const contextValue = (0, $4HBpa.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $a1b53d71fae21ef4$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix)
        })
    });
});
$5a83b6d7ba56d7d9$var$CardHeader.displayName = "CardHeader";
var $5a83b6d7ba56d7d9$export$2e2bcd8739ae039 = $5a83b6d7ba56d7d9$var$CardHeader;




var $4HBpa = parcelRequire("4HBpa");


"use client";
const $b95a72064bcbfa52$var$CardImg = /*#__PURE__*/ $4HBpa.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = "img", ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$b95a72064bcbfa52$var$CardImg.displayName = "CardImg";
var $b95a72064bcbfa52$export$2e2bcd8739ae039 = $b95a72064bcbfa52$var$CardImg;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $ad749c32005f2197$var$CardImgOverlay = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-img-overlay");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$ad749c32005f2197$var$CardImgOverlay.displayName = "CardImgOverlay";
var $ad749c32005f2197$export$2e2bcd8739ae039 = $ad749c32005f2197$var$CardImgOverlay;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $0546ab35ba41a900$var$CardLink = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "a", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-link");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$0546ab35ba41a900$var$CardLink.displayName = "CardLink";
var $0546ab35ba41a900$export$2e2bcd8739ae039 = $0546ab35ba41a900$var$CardLink;



var $4HBpa = parcelRequire("4HBpa");




"use client";
const $96bbc377a2c709b7$var$DivStyledAsH6 = (0, $18d3f1485c77f7e3$export$2e2bcd8739ae039)("h6");
const $96bbc377a2c709b7$var$CardSubtitle = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $96bbc377a2c709b7$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-subtitle");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$96bbc377a2c709b7$var$CardSubtitle.displayName = "CardSubtitle";
var $96bbc377a2c709b7$export$2e2bcd8739ae039 = $96bbc377a2c709b7$var$CardSubtitle;



var $4HBpa = parcelRequire("4HBpa");



"use client";
const $66e7a392b1c3cafe$var$CardText = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "p", ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-text");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$66e7a392b1c3cafe$var$CardText.displayName = "CardText";
var $66e7a392b1c3cafe$export$2e2bcd8739ae039 = $66e7a392b1c3cafe$var$CardText;



var $4HBpa = parcelRequire("4HBpa");




"use client";
const $5084da34be4e7094$var$DivStyledAsH5 = (0, $18d3f1485c77f7e3$export$2e2bcd8739ae039)("h5");
const $5084da34be4e7094$var$CardTitle = /*#__PURE__*/ $4HBpa.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $5084da34be4e7094$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card-title");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$5084da34be4e7094$var$CardTitle.displayName = "CardTitle";
var $5084da34be4e7094$export$2e2bcd8739ae039 = $5084da34be4e7094$var$CardTitle;



"use client";
const $8bb8dca1621633cc$var$Card = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)((0, $bc3b27084a3fd43e$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$8bb8dca1621633cc$var$Card.displayName = "Card";
var $8bb8dca1621633cc$export$2e2bcd8739ae039 = Object.assign($8bb8dca1621633cc$var$Card, {
    Img: (0, $b95a72064bcbfa52$export$2e2bcd8739ae039),
    Title: (0, $5084da34be4e7094$export$2e2bcd8739ae039),
    Subtitle: (0, $96bbc377a2c709b7$export$2e2bcd8739ae039),
    Body: (0, $bc3b27084a3fd43e$export$2e2bcd8739ae039),
    Link: (0, $0546ab35ba41a900$export$2e2bcd8739ae039),
    Text: (0, $66e7a392b1c3cafe$export$2e2bcd8739ae039),
    Header: (0, $5a83b6d7ba56d7d9$export$2e2bcd8739ae039),
    Footer: (0, $aa0e1c924b7d9f52$export$2e2bcd8739ae039),
    ImgOverlay: (0, $ad749c32005f2197$export$2e2bcd8739ae039)
});


var $1f394ef4af1d5209$export$97deab5b3db3fb02;
var $1f394ef4af1d5209$export$b8d163bdabdd123c;
var $1f394ef4af1d5209$export$37f32d010033786;
var $1f394ef4af1d5209$export$164efbb43b17b663;
var $1f394ef4af1d5209$export$d7f2d4602509652c;
var $1f394ef4af1d5209$export$83e5bc49e0b19252;
var $1f394ef4af1d5209$export$e9578944e98044e0;
var $1f394ef4af1d5209$export$f37c50809ac2905a;
$1f394ef4af1d5209$export$97deab5b3db3fb02 = `uU8Nkq_dd-body`;
$1f394ef4af1d5209$export$b8d163bdabdd123c = `uU8Nkq_dt-title`;
$1f394ef4af1d5209$export$37f32d010033786 = `uU8Nkq_gradient-data`;
$1f394ef4af1d5209$export$164efbb43b17b663 = `uU8Nkq_overview-body`;
$1f394ef4af1d5209$export$d7f2d4602509652c = `uU8Nkq_overview-card`;
$1f394ef4af1d5209$export$83e5bc49e0b19252 = `uU8Nkq_overview-title`;
$1f394ef4af1d5209$export$e9578944e98044e0 = `uU8Nkq_section-body`;
$1f394ef4af1d5209$export$f37c50809ac2905a = `uU8Nkq_section-title`;


const $ba4bd77a230f3938$export$ed635c390d770d4b = ({ title: title, data: data })=>(0, $237889e76c767d38$exports.jsxs)("li", {
        className: "list-unstyled d-flex flex-column gap-3 align-items-center justify-content-center p-3",
        children: [
            (0, $237889e76c767d38$exports.jsx)("em", {
                className: `p-3 ${$1f394ef4af1d5209$export$37f32d010033786}`,
                children: data
            }),
            (0, $237889e76c767d38$exports.jsx)("span", {
                className: "text-white",
                children: title
            })
        ]
    });
const $ba4bd77a230f3938$export$714a708ea6288321 = ({ title: title, children: children })=>(0, $237889e76c767d38$exports.jsxs)((0, $8bb8dca1621633cc$export$2e2bcd8739ae039), {
        as: "li",
        className: `p-4 d-flex flex-column gap-2 font-poppins ${$1f394ef4af1d5209$export$d7f2d4602509652c}`,
        children: [
            (0, $237889e76c767d38$exports.jsx)((0, $8bb8dca1621633cc$export$2e2bcd8739ae039).Title, {
                as: "h4",
                className: `${$1f394ef4af1d5209$export$83e5bc49e0b19252} fs-18 text-capitalize fw-500`,
                children: title
            }),
            (0, $237889e76c767d38$exports.jsx)((0, $8bb8dca1621633cc$export$2e2bcd8739ae039).Text, {
                className: `fs-14 fw-500 ${$1f394ef4af1d5209$export$164efbb43b17b663}`,
                children: children
            })
        ]
    });
const $ba4bd77a230f3938$export$69ed894a7932b604 = ({ icon: icon, title: title, children: children })=>(0, $237889e76c767d38$exports.jsxs)((0, $8bb8dca1621633cc$export$2e2bcd8739ae039), {
        as: "li",
        className: "d-flex flex-column gap-4 align-items-start text-black px-3 py-0 border border-top-0 mb-0",
        children: [
            (0, $237889e76c767d38$exports.jsxs)((0, $8bb8dca1621633cc$export$2e2bcd8739ae039).Title, {
                className: `${$1f394ef4af1d5209$export$f37c50809ac2905a} pt-4 m-0`,
                children: [
                    (0, $237889e76c767d38$exports.jsx)((0, $b2d204ad2c8a6909$exports.Icon), {
                        name: icon,
                        className: "fs-23"
                    }),
                    (0, $237889e76c767d38$exports.jsx)("h4", {
                        className: "fs-23 font-poppins fw-500 text-capitalize mb-0 text-break",
                        children: title
                    })
                ]
            }),
            (0, $237889e76c767d38$exports.jsx)((0, $8bb8dca1621633cc$export$2e2bcd8739ae039).Text, {
                className: `font-space pb-5 ${$1f394ef4af1d5209$export$e9578944e98044e0}`,
                children: children
            })
        ]
    });
const $ba4bd77a230f3938$export$f240a6b5c2f72910 = ({ title: title, children: children })=>(0, $237889e76c767d38$exports.jsxs)((0, $237889e76c767d38$exports.Fragment), {
        children: [
            (0, $237889e76c767d38$exports.jsx)("dt", {
                className: `${$1f394ef4af1d5209$export$b8d163bdabdd123c} px-3 fs-18 text-capitalize fw-500 text-capitalize`,
                children: title
            }),
            (0, $237889e76c767d38$exports.jsx)("dd", {
                className: `px-3 ${$1f394ef4af1d5209$export$97deab5b3db3fb02} pb-5`,
                children: children
            })
        ]
    });


var $7eb6f6c751b65708$export$9a0a7fd1093241e8;
var $7eb6f6c751b65708$export$1a914bd4d9665f42;
$7eb6f6c751b65708$export$9a0a7fd1093241e8 = `MgokeW_navbar-bg`;
$7eb6f6c751b65708$export$1a914bd4d9665f42 = `MgokeW_user-info`;



var $5c7d45190b2b9254$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5c7d45190b2b9254$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5c7d45190b2b9254$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5c7d45190b2b9254$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $5c7d45190b2b9254$export$8b543871300e74c2 = (()=>{
    let _classDecorators = [
        (0, $2bb10cc242f0df2f$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $4HBpa.Component);
    var MainNavigator = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "handleConnect", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>$5c7d45190b2b9254$var$__awaiter(this, void 0, void 0, function*() {
                        try {
                            yield (0, $0dbd2646a343d857$export$2e2bcd8739ae039).init();
                        } catch (_a) {
                            return (0, $f6965111910e6c5c$export$b410431fab84fa58)({
                                error: true,
                                content: "User reject the operation!"
                            });
                        }
                        (0, $0dbd2646a343d857$export$2e2bcd8739ae039).getAddress();
                    })
            });
        }
        renderUserInfo() {
            return (0, $237889e76c767d38$exports.jsxs)("div", {
                className: "bg-black-a p-4 position-absolute top-100 end-0 d-none rounded-3",
                children: [
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Joined Group",
                        data: "3"
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Signed Times",
                        data: "3"
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Minted Points",
                        data: "2"
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Shared Fees",
                        data: "3"
                    })
                ]
            });
        }
        render() {
            const { address: address } = (0, $0dbd2646a343d857$export$2e2bcd8739ae039);
            return (0, $237889e76c767d38$exports.jsxs)((0, $b499189a9863b4dc$export$2e2bcd8739ae039), {
                style: {
                    zIndex: 1030
                },
                className: `position-absolute mt-5 py-2 ps-5 pe-2 d-flex flex-unwrap align-items-center justify-content-between ${$7eb6f6c751b65708$export$9a0a7fd1093241e8}`,
                expand: "lg",
                variant: "dark",
                collapseOnSelect: true,
                children: [
                    (0, $237889e76c767d38$exports.jsxs)((0, $1b7a3ff760a21514$export$2e2bcd8739ae039), {
                        className: "d-flex gap-4 flex-row align-items-center text-grey-a",
                        children: [
                            (0, $237889e76c767d38$exports.jsx)((0, $1b7a3ff760a21514$export$2e2bcd8739ae039).Link, {
                                children: "APP"
                            }),
                            (0, $237889e76c767d38$exports.jsx)((0, $1b7a3ff760a21514$export$2e2bcd8739ae039).Link, {
                                href: "https://docs.zkcross.org/developer-guide/zkvrf-integration-guide",
                                target: "_blank",
                                children: "Docs"
                            })
                        ]
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $b499189a9863b4dc$export$2e2bcd8739ae039).Brand, {
                        className: "px-5 fs-28 text-center",
                        href: ".",
                        children: "zkVRF"
                    }),
                    address ? (0, $237889e76c767d38$exports.jsxs)("div", {
                        className: `position-relative ${$7eb6f6c751b65708$export$1a914bd4d9665f42}`,
                        children: [
                            (0, $237889e76c767d38$exports.jsxs)((0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), {
                                className: "px-3 bg-gradient-a border border-grey-b",
                                variant: "dark",
                                children: [
                                    (0, $f75a252a80b327d5$export$9ab766ce7f4c1f3c)(address),
                                    (0, $237889e76c767d38$exports.jsx)((0, $b2d204ad2c8a6909$exports.Icon), {
                                        className: "ps-3",
                                        name: "chevron-down"
                                    })
                                ]
                            }),
                            this.renderUserInfo()
                        ]
                    }) : (0, $237889e76c767d38$exports.jsx)((0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), {
                        className: "px-3 bg-gradient-a border border-grey-b",
                        variant: "dark",
                        onClick: this.handleConnect,
                        children: "Connect+"
                    })
                ]
            });
        }
    };
    $5c7d45190b2b9254$var$__setFunctionName(_classThis, "MainNavigator");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $5c7d45190b2b9254$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        MainNavigator = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5c7d45190b2b9254$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return MainNavigator = _classThis;
})();






var $4HBpa = parcelRequire("4HBpa");


var $4HBpa = parcelRequire("4HBpa");


"use client";
function $a0e96830dba06dc3$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $b605ce7bbfab4197$export$8970c8db816a5863)();
    const minBreakpoint = (0, $b605ce7bbfab4197$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $a0e96830dba06dc3$var$Col = /*#__PURE__*/ $4HBpa.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $a0e96830dba06dc3$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, !spans.length && bsPrefix)
    });
});
$a0e96830dba06dc3$var$Col.displayName = "Col";
var $a0e96830dba06dc3$export$2e2bcd8739ae039 = $a0e96830dba06dc3$var$Col;



var $4HBpa = parcelRequire("4HBpa");


"use client";
const $e63aec4a7c8dff57$var$Row = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "row");
    const breakpoints = (0, $b605ce7bbfab4197$export$8970c8db816a5863)();
    const minBreakpoint = (0, $b605ce7bbfab4197$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$e63aec4a7c8dff57$var$Row.displayName = "Row";
var $e63aec4a7c8dff57$export$2e2bcd8739ae039 = $e63aec4a7c8dff57$var$Row;



var $ed907a2f2ea36274$export$f66f4aae7f9c10d3;
var $ed907a2f2ea36274$export$b2095415316b9427;
$ed907a2f2ea36274$export$f66f4aae7f9c10d3 = `UwycbG_ellipse-1`;
$ed907a2f2ea36274$export$b2095415316b9427 = `UwycbG_main-title`;


var $7bd5386193bdc9be$exports = {};
$7bd5386193bdc9be$exports = new URL("bar-chart.e74215ec.jpg", import.meta.url).toString();


const $2225a23d985d86b7$export$919c1a77577cd02 = new URL($7bd5386193bdc9be$exports) + "";
class $2225a23d985d86b7$export$b44d9d0ae74f1ed3 extends (0, $4HBpa.Component) {
    renderCards() {
        return (0, $237889e76c767d38$exports.jsxs)((0, $e63aec4a7c8dff57$export$2e2bcd8739ae039), {
            className: "border-start border-dark pt-4 font-poppins d-flex align-items-center flex-wrap m-0",
            md: 1,
            lg: 2,
            children: [
                (0, $237889e76c767d38$exports.jsxs)((0, $a0e96830dba06dc3$export$2e2bcd8739ae039), {
                    as: "dl",
                    className: "m-0 p-0",
                    children: [
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$f240a6b5c2f72910), {
                            title: "Signer",
                            children: "Signing nodes participate in the network to sign the seed numbers registered by users."
                        }),
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$f240a6b5c2f72910), {
                            title: "Groups",
                            children: "Groups participating in the network coordinate a certain number of signing nodes to provide seed signatures and maintain the group's liveness."
                        }),
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$f240a6b5c2f72910), {
                            title: "Random number provider",
                            children: "The provider is a blockchain contract offering an API for users to register their seed and supply random numbers with zero-knowledge proof."
                        })
                    ]
                }),
                (0, $237889e76c767d38$exports.jsx)((0, $a0e96830dba06dc3$export$2e2bcd8739ae039), {
                    as: "img",
                    className: "object-fit m-0 p-0",
                    src: $2225a23d985d86b7$export$919c1a77577cd02
                })
            ]
        });
    }
    render() {
        return (0, $237889e76c767d38$exports.jsxs)("div", {
            className: "d-flex flex-column align-items-start bg-black-a px-sm-10",
            children: [
                (0, $237889e76c767d38$exports.jsx)("h3", {
                    className: `ps-3 font-monument text-uppercase text-start border-bottom border-start border-dark mb-0 ${$ed907a2f2ea36274$export$b2095415316b9427}`,
                    children: "Highly effective solutions"
                }),
                this.renderCards()
            ]
        });
    }
}





var $4HBpa = parcelRequire("4HBpa");



var $kAoxL = parcelRequire("kAoxL");


var $b16be82c38219c2b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b16be82c38219c2b$export$f661b071ed616d85 = new (0, $89e48cd0768a697f$export$45cf759b359d3d24)({
    baseURI: "https://rpc.zkvrf.xyz/",
    responseType: "json"
}).use((_a, next_1)=>$b16be82c38219c2b$var$__awaiter(void 0, [
        _a,
        next_1
    ], void 0, function*({ request: request }, next) {
        request.headers = Object.assign({
            ["Authorization"]: `Bearer ${localStorage.access_token}`
        }, request.headers);
        return next();
    }));
class $b16be82c38219c2b$export$4c1294091808e167 extends (0, $9c65e1276bf6a281$export$d12e20a4eec10acf) {
    constructor(){
        super();
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $b16be82c38219c2b$export$f661b071ed616d85
        });
        this.getToken();
    }
    getToken() {
        return $b16be82c38219c2b$var$__awaiter(this, arguments, void 0, function*(client_id = "user1", client_secret = "password1") {
            if (localStorage.access_token) return localStorage.access_token;
            const { body: { access_token: access_token } } = yield this.client.post("authorize", {
                client_id: client_id,
                client_secret: client_secret
            });
            return localStorage.access_token = access_token;
        });
    }
}



var $35c4b581312abe4b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $35c4b581312abe4b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $35c4b581312abe4b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $35c4b581312abe4b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $35c4b581312abe4b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $35c4b581312abe4b$export$bb00b15286f30eee = (()=>{
    var _a, _GroupModel_pageList_accessor_storage, _GroupModel_currentOne_accessor_storage;
    let _classSuper = (0, $b16be82c38219c2b$export$4c1294091808e167);
    let _instanceExtraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _get_totalCount_decorators;
    let _getList_decorators;
    let _join_decorators;
    let _getOne_decorators;
    return _a = class GroupModel extends _classSuper {
        get pageList() {
            return $35c4b581312abe4b$var$__classPrivateFieldGet(this, _GroupModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $35c4b581312abe4b$var$__classPrivateFieldSet(this, _GroupModel_pageList_accessor_storage, value, "f");
        }
        get currentOne() {
            return $35c4b581312abe4b$var$__classPrivateFieldGet(this, _GroupModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $35c4b581312abe4b$var$__classPrivateFieldSet(this, _GroupModel_currentOne_accessor_storage, value, "f");
        }
        get totalCount() {
            return this.pageList.length;
        }
        getList() {
            return $35c4b581312abe4b$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get("allgroups");
                this.pageList = body.data;
            });
        }
        join(grouphash, nodehash) {
            return this.client.post("joingroup", {
                grouphash: grouphash,
                nodehash: nodehash
            });
        }
        getOne(grouphash) {
            return $35c4b581312abe4b$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.post("getgroup", {
                    grouphash: grouphash
                });
                return this.currentOne = body;
            });
        }
        constructor(){
            super(...arguments);
            _GroupModel_pageList_accessor_storage.set(this, ($35c4b581312abe4b$var$__runInitializers(this, _instanceExtraInitializers), $35c4b581312abe4b$var$__runInitializers(this, _pageList_initializers, [])));
            _GroupModel_currentOne_accessor_storage.set(this, ($35c4b581312abe4b$var$__runInitializers(this, _pageList_extraInitializers), $35c4b581312abe4b$var$__runInitializers(this, _currentOne_initializers, void 0)));
            $35c4b581312abe4b$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _GroupModel_pageList_accessor_storage = new WeakMap(), _GroupModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _pageList_decorators = [
            (0, $kAoxL.observable)
        ];
        _currentOne_decorators = [
            (0, $kAoxL.observable)
        ];
        _get_totalCount_decorators = [
            (0, $kAoxL.computed)
        ];
        _getList_decorators = [
            (0, $kAoxL.action),
            (0, $9c65e1276bf6a281$export$e03c1c3201ee8bb7)("downloading")
        ];
        _join_decorators = [
            (0, $9c65e1276bf6a281$export$e03c1c3201ee8bb7)("uploading")
        ];
        _getOne_decorators = [
            (0, $kAoxL.action)
        ];
        $35c4b581312abe4b$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $35c4b581312abe4b$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $35c4b581312abe4b$var$__esDecorate(_a, null, _get_totalCount_decorators, {
            kind: "getter",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $35c4b581312abe4b$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $35c4b581312abe4b$var$__esDecorate(_a, null, _join_decorators, {
            kind: "method",
            name: "join",
            static: false,
            private: false,
            access: {
                has: (obj)=>"join" in obj,
                get: (obj)=>obj.join
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $35c4b581312abe4b$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $35c4b581312abe4b$export$2e2bcd8739ae039 = new $35c4b581312abe4b$export$bb00b15286f30eee();





var $f3666b0834219890$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f3666b0834219890$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f3666b0834219890$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $f3666b0834219890$export$47f84c71c51506f8 = (()=>{
    let _classDecorators = [
        (0, $2bb10cc242f0df2f$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $4HBpa.Component);
    var SectionOne = _classThis = class extends _classSuper {
        componentDidMount() {
            (0, $35c4b581312abe4b$export$2e2bcd8739ae039).getList();
        }
        renderStatistical(totalCount) {
            return (0, $237889e76c767d38$exports.jsxs)("ul", {
                className: "gradient-list d-flex flex-wrap gap-4 justify-content-center align-items-center",
                children: [
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Total Requests +",
                        data: "106758443"
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Pending Request +",
                        data: "106758443"
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Signing Groups +",
                        data: totalCount + ""
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$ed635c390d770d4b), {
                        title: "Signing Nodes + ",
                        data: "106758443"
                    })
                ]
            });
        }
        renderColumns({ grouphash: grouphash, groupid: groupid }) {
            return (0, $237889e76c767d38$exports.jsxs)("li", {
                className: "d-flex gap-1 align-items-center",
                children: [
                    (0, $237889e76c767d38$exports.jsx)((0, $ee913af29239d9e3$export$2e2bcd8739ae039), {
                        trigger: "click",
                        placement: "bottom-end",
                        rootClose: true,
                        overlay: (0, $237889e76c767d38$exports.jsxs)("dl", {
                            className: "d-flex flex-column p-3 gap-3 bg-gradient-c rounded-3 shadow-a blur-1",
                            children: [
                                (0, $237889e76c767d38$exports.jsx)("dt", {
                                    className: "text-white",
                                    children: "groupid"
                                }),
                                (0, $237889e76c767d38$exports.jsx)("dd", {
                                    className: "bg-grey-d p-2 text-grey-e rounded-1",
                                    children: groupid
                                }),
                                (0, $237889e76c767d38$exports.jsxs)("dt", {
                                    className: "text-white",
                                    children: [
                                        "grouphash",
                                        (0, $237889e76c767d38$exports.jsx)((0, $b2d204ad2c8a6909$exports.Icon), {
                                            size: 0.6,
                                            name: "copy",
                                            className: "ps-2",
                                            onClick: ()=>(0, $f75a252a80b327d5$export$784d13d8ee351f07)(grouphash, "Copied!")
                                        })
                                    ]
                                }),
                                (0, $237889e76c767d38$exports.jsx)("dd", {
                                    className: "bg-grey-d p-2 text-grey-e rounded-1",
                                    children: grouphash
                                })
                            ]
                        }),
                        children: (0, $237889e76c767d38$exports.jsx)((0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), {
                            variant: "dark",
                            className: "bg-gradient-b border border-grey-c rounded-1 px-3 col-8 text-grey-f font-poppins",
                            children: grouphash.substring(0, 15)
                        })
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), {
                        variant: "dark",
                        className: "bg-gradient-b border border-grey-c rounded-1 px-3 col-2 text-grey-f font-poppins",
                        children: "531"
                    }),
                    (0, $237889e76c767d38$exports.jsx)((0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), {
                        variant: "dark",
                        className: "bg-gradient-b border border-grey-c rounded-1 px-3 col-2 text-grey-f font-poppins",
                        children: "1"
                    })
                ]
            }, grouphash);
        }
        render() {
            const { totalCount: totalCount, pageList: pageList } = (0, $35c4b581312abe4b$export$2e2bcd8739ae039);
            return (0, $237889e76c767d38$exports.jsxs)("div", {
                className: "d-flex flex-column align-items-center gap-5 bg-black-a pt-5 px-5 py-4",
                children: [
                    (0, $237889e76c767d38$exports.jsx)("h3", {
                        className: `font-monument text-uppercase mb-4 text-center ${$ed907a2f2ea36274$export$b2095415316b9427}`,
                        children: "zkVRF network live data"
                    }),
                    this.renderStatistical(totalCount),
                    (0, $237889e76c767d38$exports.jsx)("h4", {
                        className: "text-center text-white mb-3",
                        children: "Group Details"
                    }),
                    " ",
                    (0, $237889e76c767d38$exports.jsxs)("ul", {
                        className: "list-unstyled d-flex flex-column gap-3 w-75",
                        children: [
                            (0, $237889e76c767d38$exports.jsxs)("li", {
                                className: "d-flex gap-1 align-items-center w-100",
                                children: [
                                    " ",
                                    (0, $237889e76c767d38$exports.jsx)("span", {
                                        className: "col-8 text-center text-white",
                                        children: "Groups (Click to display grouphash)"
                                    }),
                                    (0, $237889e76c767d38$exports.jsx)("span", {
                                        className: "col-2 text-center text-white",
                                        children: "Group signing times"
                                    }),
                                    (0, $237889e76c767d38$exports.jsx)("span", {
                                        className: "col-2 text-center text-white",
                                        children: "Group signing nodes"
                                    })
                                ]
                            }),
                            pageList.map(this.renderColumns)
                        ]
                    })
                ]
            });
        }
    };
    $f3666b0834219890$var$__setFunctionName(_classThis, "SectionOne");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $f3666b0834219890$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        SectionOne = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $f3666b0834219890$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return SectionOne = _classThis;
})();




var $4HBpa = parcelRequire("4HBpa");

var $c9e3f8ed52f0d5da$export$5e34e4aea79c8793;
var $c9e3f8ed52f0d5da$export$a9c683973f6e854a;
var $c9e3f8ed52f0d5da$export$bc626fab76ccb093;
$c9e3f8ed52f0d5da$export$5e34e4aea79c8793 = `KBO8SG_list-box`;
$c9e3f8ed52f0d5da$export$a9c683973f6e854a = `KBO8SG_rounded-box`;
$c9e3f8ed52f0d5da$export$bc626fab76ccb093 = `KBO8SG_section-header`;


class $56648c1c1f1c2708$export$446efc711814a202 extends (0, $4HBpa.Component) {
    renderCards() {
        return (0, $237889e76c767d38$exports.jsxs)("ul", {
            className: `list-unstyled d-flex mb-0 ${$c9e3f8ed52f0d5da$export$5e34e4aea79c8793}`,
            children: [
                (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$69ed894a7932b604), {
                    icon: "graph-up-arrow",
                    title: "Validator selection",
                    children: "Used to select validators or committees in PoS systems to ensure fair and secure elections."
                }),
                (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$69ed894a7932b604), {
                    icon: "controller",
                    title: "On-chain game",
                    children: "Ensures the fairness and verifiability of random outcomes in decentralized applications."
                }),
                (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$69ed894a7932b604), {
                    icon: "pie-chart",
                    title: "Random Beacons",
                    children: "Used to select validators or committees in PoS systems to ensure fair and secure elections."
                }),
                (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$69ed894a7932b604), {
                    icon: "bag",
                    title: "Commitment Schemes",
                    children: "Ensures the fairness and verifiability of random outcomes in decentralized applications."
                })
            ]
        });
    }
    render() {
        return (0, $237889e76c767d38$exports.jsx)("div", {
            className: "bg-black-a py-5",
            children: (0, $237889e76c767d38$exports.jsxs)("div", {
                className: `${$c9e3f8ed52f0d5da$export$a9c683973f6e854a} pt-5 d-flex flex-column align-items-end gap-0`,
                children: [
                    (0, $237889e76c767d38$exports.jsx)("h3", {
                        className: `${$c9e3f8ed52f0d5da$export$bc626fab76ccb093} font-monument fw-400 align-self-start w-100 mb-0`,
                        children: "use cases"
                    }),
                    this.renderCards()
                ]
            })
        });
    }
}




var $4HBpa = parcelRequire("4HBpa");


class $bbe06b908f1df23b$export$5150f8f3c0a7f52 extends (0, $4HBpa.Component) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "renderCards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ()=>(0, $237889e76c767d38$exports.jsxs)("div", {
                    className: "d-flex flex-sm-row flex-column flex-wrap align-items-center justify-content-center gap-4",
                    children: [
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$714a708ea6288321), {
                            title: "High Performance",
                            children: "The use of WASM enhances the execution speed, ensuring that the randomness generation is swift even with multiple participants."
                        }),
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$714a708ea6288321), {
                            title: "Resistance to Manipulation ",
                            children: "The use of WASM enhances the execution speed, ensuring that the randomness generation is swift even with multiple participants."
                        }),
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$714a708ea6288321), {
                            title: "Scalability",
                            children: "The use of WASM enhances the execution speed, ensuring that the randomness generation is swift even with multiple participants."
                        }),
                        (0, $237889e76c767d38$exports.jsx)((0, $ba4bd77a230f3938$export$714a708ea6288321), {
                            title: "Verifiable Proofs",
                            children: "The use of WASM enhances the execution speed, ensuring that the randomness generation is swift even with multiple participants."
                        })
                    ]
                })
        });
    }
    render() {
        return (0, $237889e76c767d38$exports.jsxs)("div", {
            className: "d-flex flex-column align-items-center gap-5 bg-black-a p-5",
            children: [
                (0, $237889e76c767d38$exports.jsx)("h3", {
                    className: `font-monument text-uppercase mb-4 text-center ${$ed907a2f2ea36274$export$b2095415316b9427}`,
                    children: "Advantages of zkVRF to other service"
                }),
                this.renderCards()
            ]
        });
    }
}






var $4HBpa = parcelRequire("4HBpa");


"use client";
const $cc15a08b4fdc16df$var$Container = /*#__PURE__*/ $4HBpa.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    const prefix = (0, $b605ce7bbfab4197$export$7f387860ebffb32c)(bsPrefix, "container");
    const suffix = typeof fluid === "string" ? `-${fluid}` : "-fluid";
    return /*#__PURE__*/ (0, $237889e76c767d38$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$cc15a08b4fdc16df$var$Container.displayName = "Container";
var $cc15a08b4fdc16df$export$2e2bcd8739ae039 = $cc15a08b4fdc16df$var$Container;


var $e4744544ea384c67$export$9b0df3745aedae7b;
$e4744544ea384c67$export$9b0df3745aedae7b = `GVqZ8W_zkvrf-header`;


const $177c43623ffd1366$export$36258d134f135954 = ()=>(0, $237889e76c767d38$exports.jsxs)((0, $cc15a08b4fdc16df$export$2e2bcd8739ae039), {
        className: "vh-100 d-flex flex-column gap-5 align-items-center justify-content-center",
        children: [
            (0, $237889e76c767d38$exports.jsx)("h2", {
                className: `${$e4744544ea384c67$export$9b0df3745aedae7b} font-monument fw-400 text-uppercase text-center text-break`,
                children: "verifiable random number generated with zkp"
            }),
            (0, $237889e76c767d38$exports.jsxs)((0, $367fe3a5abb69f2e$export$2e2bcd8739ae039), {
                className: "px-3 bg-gradient-a border border-grey-b font-poppins",
                variant: "dark",
                children: [
                    "Get started ",
                    (0, $237889e76c767d38$exports.jsx)((0, $b2d204ad2c8a6909$exports.Icon), {
                        name: "arrow-right"
                    })
                ]
            })
        ]
    });


var $6d3964f81f7bb7c5$export$3fd24a4346d52118;
var $6d3964f81f7bb7c5$export$5c0e458f405f45dd;
var $6d3964f81f7bb7c5$export$b47cd7389989b9cb;
$6d3964f81f7bb7c5$export$3fd24a4346d52118 = `_6YvFKG_full-scroll`;
$6d3964f81f7bb7c5$export$5c0e458f405f45dd = `_6YvFKG_full-video`;
$6d3964f81f7bb7c5$export$b47cd7389989b9cb = `_6YvFKG_video-mask`;


var $71fecb4fc9a39371$exports = {};
$71fecb4fc9a39371$exports = new URL("zkvrf.a56213d8.mp4", import.meta.url).toString();


const $2296d3e31d6332cb$export$d72766bc9a177951 = new URL($71fecb4fc9a39371$exports) + "";
const $2296d3e31d6332cb$export$36d69433c4f81145 = ()=>(0, $237889e76c767d38$exports.jsxs)((0, $237889e76c767d38$exports.Fragment), {
        children: [
            (0, $237889e76c767d38$exports.jsx)("video", {
                className: `vw-100 vh-100  ${$6d3964f81f7bb7c5$export$5c0e458f405f45dd}`,
                src: $2296d3e31d6332cb$export$d72766bc9a177951,
                autoPlay: true,
                muted: true,
                loop: true
            }),
            (0, $237889e76c767d38$exports.jsx)("div", {
                className: `${$6d3964f81f7bb7c5$export$b47cd7389989b9cb}`
            }),
            (0, $237889e76c767d38$exports.jsxs)("div", {
                className: `m-0 p-0 ${$6d3964f81f7bb7c5$export$3fd24a4346d52118}`,
                children: [
                    (0, $237889e76c767d38$exports.jsx)((0, $177c43623ffd1366$export$36258d134f135954), {}),
                    (0, $237889e76c767d38$exports.jsx)((0, $f3666b0834219890$export$47f84c71c51506f8), {}),
                    (0, $237889e76c767d38$exports.jsx)((0, $bbe06b908f1df23b$export$5150f8f3c0a7f52), {}),
                    (0, $237889e76c767d38$exports.jsx)((0, $56648c1c1f1c2708$export$446efc711814a202), {}),
                    (0, $237889e76c767d38$exports.jsx)((0, $2225a23d985d86b7$export$b44d9d0ae74f1ed3), {})
                ]
            })
        ]
    });


const $325af5f10b3faac7$export$953c2efc134d7f79 = ()=>(0, $237889e76c767d38$exports.jsxs)((0, $237889e76c767d38$exports.Fragment), {
        children: [
            (0, $237889e76c767d38$exports.jsx)((0, $5c7d45190b2b9254$export$8b543871300e74c2), {}),
            (0, $237889e76c767d38$exports.jsx)((0, $13f7c841fa583706$export$7221d69dcfc8e36b), {
                children: (0, $237889e76c767d38$exports.jsx)((0, $c03a1ed858071efe$export$3565eb3d00ca5a74), {
                    children: (0, $237889e76c767d38$exports.jsx)((0, $c03a1ed858071efe$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: (0, $237889e76c767d38$exports.jsx)((0, $2296d3e31d6332cb$export$36d69433c4f81145), {})
                    })
                })
            }),
            (0, $237889e76c767d38$exports.jsx)((0, $f6965111910e6c5c$export$2808da24ccf8bc0b), {}),
            (0, $237889e76c767d38$exports.jsx)((0, $9a1d813924b63f50$export$a06f1c675e846f6f), {})
        ]
    });


(0, $de9addb89ca41b61$export$dfb5619354ba860)();
(0, $kAoxL.configure)({
    enforceActions: "never"
});
self.addEventListener("unhandledrejection", ({ reason: reason })=>{
    const { message: message } = reason;
    if (message) self.alert(message);
});
const { serviceWorker: $b1b793d8911e6aa6$var$serviceWorker } = window.navigator, $b1b793d8911e6aa6$var$NODE_ENV = "production";
if ($b1b793d8911e6aa6$var$NODE_ENV !== "development") $b1b793d8911e6aa6$var$serviceWorker === null || $b1b793d8911e6aa6$var$serviceWorker === void 0 || $b1b793d8911e6aa6$var$serviceWorker.register("sw.js").then((0, $a1a155eb9166d0df$export$d635d04af3887bbe)).then((worker)=>{
    if (window.confirm("New version of this Web App detected, update now?")) worker.postMessage({
        type: "SKIP_WAITING"
    });
});
$b1b793d8911e6aa6$var$serviceWorker === null || $b1b793d8911e6aa6$var$serviceWorker === void 0 || $b1b793d8911e6aa6$var$serviceWorker.addEventListener("controllerchange", ()=>window.location.reload());
const $b1b793d8911e6aa6$var$container = document.getElementById("app"), $b1b793d8911e6aa6$var$root = (0, $1235ee506af21140$export$882461b6382ed46c)($b1b793d8911e6aa6$var$container);
$b1b793d8911e6aa6$var$root.render((0, $237889e76c767d38$exports.jsx)((0, $325af5f10b3faac7$export$953c2efc134d7f79), {}));


//# sourceMappingURL=index.25980825.js.map
